import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  float8: { input: any; output: any; }
  json: { input: any; output: any; }
  smallint: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

export type AdEventsByIntervalOutput = {
  __typename?: 'AdEventsByIntervalOutput';
  adEventsByInterval: Array<Maybe<AdEventsByIntervalRecord>>;
};

export type AdEventsByIntervalRecord = {
  __typename?: 'AdEventsByIntervalRecord';
  ad_campaign_id: Scalars['bigint']['output'];
  ad_campaign_name: Scalars['String']['output'];
  ad_campaign_short_name: Scalars['String']['output'];
  ad_id: Scalars['bigint']['output'];
  ad_name: Scalars['String']['output'];
  ad_short_name: Scalars['String']['output'];
  ad_variant_id: Scalars['bigint']['output'];
  ad_variant_name: Scalars['String']['output'];
  ad_variant_short_name: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  day: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AdPick = {
  __typename?: 'AdPick';
  blur_hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  media_cdn_url: Scalars['String']['output'];
  url: Scalars['String']['output'];
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
};

export type AdsConfig = {
  __typename?: 'AdsConfig';
  pick?: Maybe<AdPick>;
  preloadUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AdsConfigItem = {
  __typename?: 'AdsConfigItem';
  overrides?: Maybe<ConfigOverrides>;
  value?: Maybe<AdsConfig>;
};

export type AuthConfig = {
  __typename?: 'AuthConfig';
  forceLogOut?: Maybe<ForceLogOutConfig>;
};

export type AuthConfigItem = {
  __typename?: 'AuthConfigItem';
  overrides?: Maybe<ConfigOverrides>;
  value?: Maybe<AuthConfig>;
};

export type AuthProvider = {
  authenticated: Scalars['Boolean']['input'];
  credential: Scalars['String']['input'];
  identityId?: InputMaybe<Scalars['Int']['input']>;
  lastUsed: Scalars['Float']['input'];
  provider: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockUserOutput = {
  __typename?: 'BlockUserOutput';
  blocked: Scalars['Boolean']['output'];
};

export type BooleanConfigitem = {
  __typename?: 'BooleanConfigitem';
  overrides?: Maybe<ConfigOverrides>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CancelParkableTransactionOutput = {
  __typename?: 'CancelParkableTransactionOutput';
  parkableTransaction?: Maybe<Parkable_Transactions>;
  parkableTransactionId: Scalars['bigint']['output'];
};

export type ChangePhoneNumberOutput = {
  __typename?: 'ChangePhoneNumberOutput';
  accountsDeleted?: Maybe<Array<Scalars['bigint']['output']>>;
  keptAccount: Scalars['bigint']['output'];
};

export type ClientDevice = {
  app_version_android_version_code?: InputMaybe<Scalars['String']['input']>;
  app_version_eas_update_datetime?: InputMaybe<Scalars['String']['input']>;
  app_version_eas_update_id?: InputMaybe<Scalars['String']['input']>;
  app_version_human_readable?: InputMaybe<Scalars['String']['input']>;
  app_version_ios_build_number?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['String']['input']>;
  expo_push_token?: InputMaybe<Scalars['String']['input']>;
  is_rooted?: InputMaybe<Scalars['Boolean']['input']>;
  is_side_loading_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_os_permission_status?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_memory?: InputMaybe<Scalars['Float']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications_app_permission_request_status?: InputMaybe<Scalars['String']['input']>;
  notifications_os_permission_status?: InputMaybe<Scalars['String']['input']>;
  os_build_fingerprint?: InputMaybe<Scalars['String']['input']>;
  os_build_id?: InputMaybe<Scalars['String']['input']>;
  os_internal_build_id?: InputMaybe<Scalars['String']['input']>;
  os_name?: InputMaybe<Scalars['String']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  platform_api_level?: InputMaybe<Scalars['String']['input']>;
  platform_features?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supported_cpu_architectures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  time_discrepancy?: InputMaybe<Scalars['Int']['input']>;
  total_memory?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uptime?: InputMaybe<Scalars['Float']['input']>;
  year_class?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigDebug = {
  __typename?: 'ConfigDebug';
  context?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ErrorOutput>>;
};

export type ConfigOutput = {
  __typename?: 'ConfigOutput';
  ads: AdsConfig;
  customerFeedback: CustomerFeedbackConfig;
  devToolsEnabled: Scalars['Boolean']['output'];
  latestReleases?: Maybe<ReleasesConfig>;
  providers?: Maybe<ProvidersConfig>;
  serverNow: Scalars['String']['output'];
};

export type ConfigOverrides = {
  __typename?: 'ConfigOverrides';
  fromCache?: Maybe<Scalars['Boolean']['output']>;
  ids?: Maybe<Array<Scalars['bigint']['output']>>;
};

export type ConfigV2 = {
  __typename?: 'ConfigV2';
  ads?: Maybe<AdsConfigItem>;
  auth?: Maybe<AuthConfigItem>;
  betaFeaturesEnabled?: Maybe<BooleanConfigitem>;
  customerFeedback?: Maybe<CustomerFeedbackConfigItem>;
  debugErrorsEnabled?: Maybe<BooleanConfigitem>;
  devToolsEnabled?: Maybe<BooleanConfigitem>;
  providers?: Maybe<ProvidersConfigItem>;
  releases?: Maybe<LatestReleasesConfigItem>;
  serverNow?: Maybe<ServerNowConfigItem>;
};

export type ConfigV2Output = {
  __typename?: 'ConfigV2Output';
  config?: Maybe<ConfigV2>;
  debug?: Maybe<ConfigDebug>;
};

export type CreateAccountingReportOutput = {
  __typename?: 'CreateAccountingReportOutput';
  id: Scalars['bigint']['output'];
  report?: Maybe<Reports>;
};

export type CreateEscrowReportOutput = {
  __typename?: 'CreateEscrowReportOutput';
  id: Scalars['bigint']['output'];
  report?: Maybe<Reports>;
};

export type CreateMxmCustomerOutput = {
  __typename?: 'CreateMxmCustomerOutput';
  user?: Maybe<Users>;
  userId: Scalars['bigint']['output'];
};

export type CreateParkableTransactionOutput = {
  __typename?: 'CreateParkableTransactionOutput';
  parkableTransaction?: Maybe<Parkable_Transactions>;
  parkableTransactionId: Scalars['bigint']['output'];
};

export type CreateSupportTicketGuestOutput = {
  __typename?: 'CreateSupportTicketGuestOutput';
  id: Scalars['bigint']['output'];
};

export type CreateSupportTicketOutput = {
  __typename?: 'CreateSupportTicketOutput';
  id: Scalars['bigint']['output'];
  supportTicket?: Maybe<Support_Tickets>;
};

export type CreateTransfersReportOutput = {
  __typename?: 'CreateTransfersReportOutput';
  id: Scalars['bigint']['output'];
  report?: Maybe<Reports>;
};

export type CustomerFeedbackConfig = {
  __typename?: 'CustomerFeedbackConfig';
  initial: CustomerFeedbackInitialConfig;
  ongoing?: Maybe<CustomerFeedbackOngoingConfig>;
};

export type CustomerFeedbackConfigItem = {
  __typename?: 'CustomerFeedbackConfigItem';
  overrides?: Maybe<ConfigOverrides>;
  value?: Maybe<CustomerFeedbackConfig>;
};

export type CustomerFeedbackInitialConfig = {
  __typename?: 'CustomerFeedbackInitialConfig';
  enabled: Scalars['Boolean']['output'];
  promptCacheKey: Scalars['String']['output'];
  promptCooldownSeconds: Scalars['Int']['output'];
  prompts: Array<CustomerFeedbackInitialPromptConfig>;
  surveyUrl: CustomerFeedbackInitialSurveyUrlConfig;
};

export type CustomerFeedbackInitialPromptConfig = {
  __typename?: 'CustomerFeedbackInitialPromptConfig';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  promptAt: Scalars['String']['output'];
};

export type CustomerFeedbackInitialSurveyUrlConfig = {
  __typename?: 'CustomerFeedbackInitialSurveyUrlConfig';
  baseUrl: Scalars['String']['output'];
  emailParam: Scalars['String']['output'];
  idParam: Scalars['String']['output'];
  phoneNumberParam: Scalars['String']['output'];
};

export type CustomerFeedbackOngoingConfig = {
  __typename?: 'CustomerFeedbackOngoingConfig';
  enabled: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type DeletePaymentMethodOutput = {
  __typename?: 'DeletePaymentMethodOutput';
  deletedPaymentMethodId: Scalars['bigint']['output'];
};

export type DeleteVehicleOutput = {
  __typename?: 'DeleteVehicleOutput';
  deletedVehicleId: Scalars['bigint']['output'];
  vehicle?: Maybe<Vehicles>;
};

export type ErrorOutput = {
  __typename?: 'ErrorOutput';
  code?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
};

export type EtlLog = {
  __typename?: 'EtlLog';
  context?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  category: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  occurredAt: Scalars['Float']['input'];
  subCategory?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type EventsBatch = {
  batchId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  events: Array<Event>;
  lastAttempt?: InputMaybe<Scalars['Float']['input']>;
  numAttempts: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type EventsBatchResult = {
  __typename?: 'EventsBatchResult';
  batchId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExportParkableTransactionHistoryOutput = {
  __typename?: 'ExportParkableTransactionHistoryOutput';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  generatedSuccess: Scalars['Boolean']['output'];
  savedSuccess: Scalars['Boolean']['output'];
  sentSuccess: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type ExtendTimeOutput = {
  __typename?: 'ExtendTimeOutput';
  parkableTransaction?: Maybe<Parkable_Transactions>;
  parkableTransactionId: Scalars['bigint']['output'];
};

export type ForceLogOutConfig = {
  __typename?: 'ForceLogOutConfig';
  reasons: ForceLogOutReasonConfigs;
};

export type ForceLogOutReasonConfig = {
  __typename?: 'ForceLogOutReasonConfig';
  enabled: Scalars['Boolean']['output'];
};

export type ForceLogOutReasonConfigs = {
  __typename?: 'ForceLogOutReasonConfigs';
  CREDENTIAL_MISMATCH: ForceLogOutReasonConfig;
  IDENTITY_MISSING: ForceLogOutReasonConfig;
  USER_DELETED: ForceLogOutReasonConfig;
  USER_FRAUDULENT: ForceLogOutReasonConfig;
  USER_LOCKED: ForceLogOutReasonConfig;
  USER_MISSING: ForceLogOutReasonConfig;
  USER_PENDING_DELETION: ForceLogOutReasonConfig;
};

export type FoundAccount = {
  __typename?: 'FoundAccount';
  created_at: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  legacy: Scalars['Boolean']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LatestReleasesConfigItem = {
  __typename?: 'LatestReleasesConfigItem';
  overrides?: Maybe<ConfigOverrides>;
  value?: Maybe<ReleasesConfig>;
};

export type ParkTask = {
  __typename?: 'ParkTask';
  _parkableTransactionId: Scalars['bigint']['output'];
  _taskClassShortName: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  abortedAt?: Maybe<Scalars['String']['output']>;
  checkAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  events: Array<ParkTaskEvent>;
  failedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastCycleAt?: Maybe<Scalars['String']['output']>;
  lastErrorAt?: Maybe<Scalars['String']['output']>;
  lastLife?: Maybe<Scalars['Int']['output']>;
  loadedLife?: Maybe<Scalars['Int']['output']>;
  lockExpiresAt?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['String']['output']>;
  processingAt?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ParkTaskState>;
  status: Scalars['String']['output'];
  try?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ParkTaskDetailsOutput = {
  __typename?: 'ParkTaskDetailsOutput';
  task?: Maybe<ParkTask>;
};

export type ParkTaskEvent = {
  __typename?: 'ParkTaskEvent';
  _eventClassShortName?: Maybe<Scalars['String']['output']>;
  _isSettled: Scalars['Boolean']['output'];
  abortedAt?: Maybe<Scalars['String']['output']>;
  actionable?: Maybe<Scalars['Boolean']['output']>;
  autoReloadWallet?: Maybe<Scalars['Boolean']['output']>;
  backoffMultiplier?: Maybe<Scalars['Int']['output']>;
  cardAuthPayment?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotentKey?: Maybe<Scalars['String']['output']>;
  interfaceId?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['bigint']['output']>;
  lastFailedTryAt?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  life?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  parkableId?: Maybe<Scalars['bigint']['output']>;
  parkableTransactionId?: Maybe<Scalars['bigint']['output']>;
  paymentMethodId?: Maybe<Scalars['bigint']['output']>;
  processedAt?: Maybe<Scalars['String']['output']>;
  processingAt?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  selfEmitted?: Maybe<Scalars['Boolean']['output']>;
  snapshot?: Maybe<ParkableTransactionSnapshot>;
  status: Scalars['String']['output'];
  storedAt?: Maybe<Scalars['String']['output']>;
  taskId: Scalars['String']['output'];
  time?: Maybe<Scalars['Int']['output']>;
  transactions?: Maybe<Scalars['String']['output']>;
  transferBillId?: Maybe<Scalars['bigint']['output']>;
  try?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
  vehicleId?: Maybe<Scalars['bigint']['output']>;
  waitingAt?: Maybe<Scalars['String']['output']>;
};

export type ParkTaskState = {
  __typename?: 'ParkTaskState';
  parkableTransactionId?: Maybe<Scalars['bigint']['output']>;
};

export type ParkableTransactionSnapshot = {
  __typename?: 'ParkableTransactionSnapshot';
  fee?: Maybe<Scalars['Int']['output']>;
  parkablePrice?: Maybe<Scalars['Int']['output']>;
  parkablePriceInterval?: Maybe<Scalars['Int']['output']>;
  parkablePriceIntervalUnit?: Maybe<Scalars['String']['output']>;
  parkableTimeLimit?: Maybe<Scalars['Int']['output']>;
  parkableTimeLimitUnit?: Maybe<Scalars['String']['output']>;
  priceIntervalInSeconds?: Maybe<Scalars['Int']['output']>;
};

export type ParkableTransactionsByDayRecord = {
  __typename?: 'ParkableTransactionsByDayRecord';
  count: Scalars['Int']['output'];
  day: Scalars['String']['output'];
  dow: Scalars['Int']['output'];
  is_v2: Scalars['Boolean']['output'];
};

export type PreAuthenticationCheckOutput = {
  __typename?: 'PreAuthenticationCheckOutput';
  success: Scalars['Boolean']['output'];
  user_message?: Maybe<Scalars['String']['output']>;
};

export type Promo = {
  __typename?: 'Promo';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  promo_state?: Maybe<Scalars['String']['output']>;
  promo_state_id: Scalars['bigint']['output'];
  redeemed_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PromosOutput = {
  __typename?: 'PromosOutput';
  promos?: Maybe<Array<Promo>>;
};

export type ProviderConfig = {
  __typename?: 'ProviderConfig';
  enabled: Scalars['Boolean']['output'];
};

export type ProvidersConfig = {
  __typename?: 'ProvidersConfig';
  apple: ProviderConfig;
  email: ProviderConfig;
  google: ProviderConfig;
  phone_number: ProviderConfig;
};

export type ProvidersConfigItem = {
  __typename?: 'ProvidersConfigItem';
  overrides?: Maybe<ConfigOverrides>;
  value?: Maybe<ProvidersConfig>;
};

export type QrAssignParkablesOutput = {
  __typename?: 'QrAssignParkablesOutput';
  success: Scalars['Boolean']['output'];
};

export type RefreshEtlOutput = {
  __typename?: 'RefreshEtlOutput';
  logs?: Maybe<EtlLog>;
  processed: Scalars['Boolean']['output'];
};

export type ReleaseConfig = {
  __typename?: 'ReleaseConfig';
  full_availability_datetime?: Maybe<Scalars['String']['output']>;
  human_readable_version: Scalars['String']['output'];
  nag_start_datetime?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  update_required_datetime?: Maybe<Scalars['String']['output']>;
  visible_start_datetime?: Maybe<Scalars['String']['output']>;
};

export type ReleasesConfig = {
  __typename?: 'ReleasesConfig';
  android?: Maybe<ReleaseConfig>;
  ios?: Maybe<ReleaseConfig>;
};

export type ReloadWalletOutput = {
  __typename?: 'ReloadWalletOutput';
  finalBalance: Scalars['Int']['output'];
  invoice?: Maybe<Invoices>;
  invoiceId: Scalars['bigint']['output'];
  previousBalance: Scalars['Int']['output'];
  wallet?: Maybe<Wallets>;
  walletId: Scalars['bigint']['output'];
  walletTransaction?: Maybe<Wallet_Transactions>;
  walletTransactionId: Scalars['bigint']['output'];
};

export type RequestLegacyMigrationOutput = {
  __typename?: 'RequestLegacyMigrationOutput';
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

export type RequestPaymentLimitedUseTokenOutput = {
  __typename?: 'RequestPaymentLimitedUseTokenOutput';
  token: Scalars['String']['output'];
};

export type ResetAccountSetupOutput = {
  __typename?: 'ResetAccountSetupOutput';
  success: Scalars['Boolean']['output'];
};

export type SaveDeviceOutput = {
  __typename?: 'SaveDeviceOutput';
  device?: Maybe<Devices>;
  id: Scalars['bigint']['output'];
};

export type SearchAccountsOutput = {
  __typename?: 'SearchAccountsOutput';
  foundAccounts: Array<FoundAccount>;
};

export type SearchCredential = {
  final?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ServerNowConfigItem = {
  __typename?: 'ServerNowConfigItem';
  overrides?: Maybe<ConfigOverrides>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StoreVaultedCardAccountOutput = {
  __typename?: 'StoreVaultedCardAccountOutput';
  alreadyExists: Scalars['Boolean']['output'];
  paymentMethod?: Maybe<Payment_Methods>;
  paymentMethodId: Scalars['bigint']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitEventsOutput = {
  __typename?: 'SubmitEventsOutput';
  result: Array<EventsBatchResult>;
};

export type SurveyDataMeterProperties = {
  attnPrice: Scalars['Boolean']['input'];
  defaced: Scalars['Boolean']['input'];
  extra?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  needsSticker: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
};

export type SystemOverview = {
  __typename?: 'SystemOverview';
  sessions: SystemOverviewSessions;
};

export type SystemOverviewOutput = {
  __typename?: 'SystemOverviewOutput';
  systemOverview?: Maybe<SystemOverview>;
};

export type SystemOverviewSessions = {
  __typename?: 'SystemOverviewSessions';
  by_day?: Maybe<SystemOverviewSessionsByDay>;
  debug?: Maybe<Scalars['String']['output']>;
  lifetime?: Maybe<SystemOverviewSessionsLifetime>;
  today?: Maybe<SystemOverviewSessionsToday>;
};

export type SystemOverviewSessionsByDay = {
  __typename?: 'SystemOverviewSessionsByDay';
  debug?: Maybe<Scalars['String']['output']>;
  prev_days?: Maybe<Array<ParkableTransactionsByDayRecord>>;
  today?: Maybe<Array<ParkableTransactionsByDayRecord>>;
};

export type SystemOverviewSessionsLifetime = {
  __typename?: 'SystemOverviewSessionsLifetime';
  debug?: Maybe<Scalars['String']['output']>;
  from_cache: Scalars['Boolean']['output'];
  last_refreshed_at: Scalars['String']['output'];
  result?: Maybe<Scalars['Int']['output']>;
};

export type SystemOverviewSessionsToday = {
  __typename?: 'SystemOverviewSessionsToday';
  debug?: Maybe<Scalars['String']['output']>;
  from_cache: Scalars['Boolean']['output'];
  last_refreshed_at: Scalars['String']['output'];
  result?: Maybe<Scalars['Int']['output']>;
};

export type SystemStatusEtlCounts = {
  __typename?: 'SystemStatusEtlCounts';
  failed_etl: Scalars['bigint']['output'];
  failing_etl: Scalars['bigint']['output'];
  no_etl: Scalars['bigint']['output'];
  stale_etl: Scalars['bigint']['output'];
};

export type SystemStatusOutput = {
  __typename?: 'SystemStatusOutput';
  etl__legacy_parkable_transactions: SystemStatusEtlCounts;
  etl__legacy_payments: SystemStatusEtlCounts;
  etl__legacy_wallet_transactions: SystemStatusEtlCounts;
  etl__parkable_transactions: SystemStatusEtlCounts;
  etl__parking_authorities: SystemStatusEtlCounts;
  etl__payment_batches: SystemStatusEtlCounts;
  etl__payments: SystemStatusEtlCounts;
  etl__transfer_batches: SystemStatusEtlCounts;
  etl__users: SystemStatusEtlCounts;
  legacy_migration__completed_count: Scalars['bigint']['output'];
  legacy_migration__started_count: Scalars['bigint']['output'];
  legacy_migration__synced_count: Scalars['bigint']['output'];
  legacy_migration__with_active_parkable_transaction_count: Scalars['bigint']['output'];
  legacy_migration__with_errors_count: Scalars['bigint']['output'];
  legacy_sync__parkable_transactions__count: Scalars['bigint']['output'];
  legacy_sync__parkable_transactions__max_id: Scalars['bigint']['output'];
  legacy_sync__parkable_transactions__min_id: Scalars['bigint']['output'];
  legacy_sync__parkable_transactions__synced_count: Scalars['bigint']['output'];
  legacy_sync__parkable_transactions__synced_max_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__parkable_transactions__synced_min_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__payments__count: Scalars['bigint']['output'];
  legacy_sync__payments__max_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__payments__min_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__payments__synced_count: Scalars['bigint']['output'];
  legacy_sync__payments__synced_max_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__payments__synced_min_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__users__count: Scalars['bigint']['output'];
  legacy_sync__users__max_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__users__min_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__users__synced_count: Scalars['bigint']['output'];
  legacy_sync__users__synced_max_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__users__synced_min_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__wallet_transactions__count: Scalars['bigint']['output'];
  legacy_sync__wallet_transactions__max_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__wallet_transactions__min_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__wallet_transactions__synced_count: Scalars['bigint']['output'];
  legacy_sync__wallet_transactions__synced_max_id?: Maybe<Scalars['bigint']['output']>;
  legacy_sync__wallet_transactions__synced_min_id?: Maybe<Scalars['bigint']['output']>;
};

export type TestOutput = {
  __typename?: 'TestOutput';
  test: Scalars['String']['output'];
  userId?: Maybe<Scalars['bigint']['output']>;
};

export type TransferBatchStatusTotal = {
  __typename?: 'TransferBatchStatusTotal';
  count: Scalars['Int']['output'];
  net_total?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

export type TransfersOverview = {
  __typename?: 'TransfersOverview';
  min_pending_payment_created_at?: Maybe<Scalars['String']['output']>;
  pending_payments_transferable_line_item_count: Scalars['Int']['output'];
  pending_payments_transferable_total?: Maybe<Scalars['Int']['output']>;
  totals_by_batch_status?: Maybe<Array<TransferBatchStatusTotal>>;
};

export type TransfersOverviewOutput = {
  __typename?: 'TransfersOverviewOutput';
  transfersOverview?: Maybe<TransfersOverview>;
};

export type UnauthenticatedCredentials = {
  knownProviders?: InputMaybe<Array<AuthProvider>>;
};

export type UpdateUserSettingOutput = {
  __typename?: 'UpdateUserSettingOutput';
  updatedUserSettings: Array<Maybe<UpdatedUserSetting>>;
};

export type UpdatedUserSetting = {
  __typename?: 'UpdatedUserSetting';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type UserSetting = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User = {
  __typename?: 'ad_campaign_admin_user';
  /** An object relationship */
  ad_campaign: Ad_Campaigns;
  ad_campaign_id: Scalars['bigint']['output'];
  /** An object relationship */
  admin_user: Admin_Users;
  admin_user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Aggregate = {
  __typename?: 'ad_campaign_admin_user_aggregate';
  aggregate?: Maybe<Ad_Campaign_Admin_User_Aggregate_Fields>;
  nodes: Array<Ad_Campaign_Admin_User>;
};

export type Ad_Campaign_Admin_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ad_Campaign_Admin_User_Aggregate_Bool_Exp_Count>;
};

export type Ad_Campaign_Admin_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ad_Campaign_Admin_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Aggregate_Fields = {
  __typename?: 'ad_campaign_admin_user_aggregate_fields';
  avg?: Maybe<Ad_Campaign_Admin_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Campaign_Admin_User_Max_Fields>;
  min?: Maybe<Ad_Campaign_Admin_User_Min_Fields>;
  stddev?: Maybe<Ad_Campaign_Admin_User_Stddev_Fields>;
  stddev_pop?: Maybe<Ad_Campaign_Admin_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ad_Campaign_Admin_User_Stddev_Samp_Fields>;
  sum?: Maybe<Ad_Campaign_Admin_User_Sum_Fields>;
  var_pop?: Maybe<Ad_Campaign_Admin_User_Var_Pop_Fields>;
  var_samp?: Maybe<Ad_Campaign_Admin_User_Var_Samp_Fields>;
  variance?: Maybe<Ad_Campaign_Admin_User_Variance_Fields>;
};


/** aggregate fields of "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Campaign_Admin_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Aggregate_Order_By = {
  avg?: InputMaybe<Ad_Campaign_Admin_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ad_Campaign_Admin_User_Max_Order_By>;
  min?: InputMaybe<Ad_Campaign_Admin_User_Min_Order_By>;
  stddev?: InputMaybe<Ad_Campaign_Admin_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ad_Campaign_Admin_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ad_Campaign_Admin_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ad_Campaign_Admin_User_Sum_Order_By>;
  var_pop?: InputMaybe<Ad_Campaign_Admin_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ad_Campaign_Admin_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Ad_Campaign_Admin_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Arr_Rel_Insert_Input = {
  data: Array<Ad_Campaign_Admin_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Campaign_Admin_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Ad_Campaign_Admin_User_Avg_Fields = {
  __typename?: 'ad_campaign_admin_user_avg_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  admin_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Avg_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ad_campaign_admin_user". All fields are combined with a logical 'AND'. */
export type Ad_Campaign_Admin_User_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Campaign_Admin_User_Bool_Exp>>;
  _not?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Campaign_Admin_User_Bool_Exp>>;
  ad_campaign?: InputMaybe<Ad_Campaigns_Bool_Exp>;
  ad_campaign_id?: InputMaybe<Bigint_Comparison_Exp>;
  admin_user?: InputMaybe<Admin_Users_Bool_Exp>;
  admin_user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad_campaign_admin_user" */
export enum Ad_Campaign_Admin_User_Constraint {
  /** unique or primary key constraint on columns "ad_campaign_id", "admin_user_id" */
  AdCampaignAdminUserAdCampaignIdAdminUserIdUnique = 'ad_campaign_admin_user_ad_campaign_id_admin_user_id_unique'
}

/** input type for incrementing numeric columns in table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Inc_Input = {
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Insert_Input = {
  ad_campaign?: InputMaybe<Ad_Campaigns_Obj_Rel_Insert_Input>;
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  admin_user?: InputMaybe<Admin_Users_Obj_Rel_Insert_Input>;
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Ad_Campaign_Admin_User_Max_Fields = {
  __typename?: 'ad_campaign_admin_user_max_fields';
  ad_campaign_id?: Maybe<Scalars['bigint']['output']>;
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Max_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ad_Campaign_Admin_User_Min_Fields = {
  __typename?: 'ad_campaign_admin_user_min_fields';
  ad_campaign_id?: Maybe<Scalars['bigint']['output']>;
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Min_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Mutation_Response = {
  __typename?: 'ad_campaign_admin_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Campaign_Admin_User>;
};

/** on_conflict condition type for table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_On_Conflict = {
  constraint: Ad_Campaign_Admin_User_Constraint;
  update_columns?: Array<Ad_Campaign_Admin_User_Update_Column>;
  where?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
};

/** Ordering options when selecting data from "ad_campaign_admin_user". */
export type Ad_Campaign_Admin_User_Order_By = {
  ad_campaign?: InputMaybe<Ad_Campaigns_Order_By>;
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user?: InputMaybe<Admin_Users_Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** select columns of table "ad_campaign_admin_user" */
export enum Ad_Campaign_Admin_User_Select_Column {
  /** column name */
  AdCampaignId = 'ad_campaign_id',
  /** column name */
  AdminUserId = 'admin_user_id'
}

/** input type for updating data in table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Set_Input = {
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Ad_Campaign_Admin_User_Stddev_Fields = {
  __typename?: 'ad_campaign_admin_user_stddev_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  admin_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Stddev_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ad_Campaign_Admin_User_Stddev_Pop_Fields = {
  __typename?: 'ad_campaign_admin_user_stddev_pop_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  admin_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Stddev_Pop_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ad_Campaign_Admin_User_Stddev_Samp_Fields = {
  __typename?: 'ad_campaign_admin_user_stddev_samp_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  admin_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Stddev_Samp_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Campaign_Admin_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Campaign_Admin_User_Stream_Cursor_Value_Input = {
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Ad_Campaign_Admin_User_Sum_Fields = {
  __typename?: 'ad_campaign_admin_user_sum_fields';
  ad_campaign_id?: Maybe<Scalars['bigint']['output']>;
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Sum_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** update columns of table "ad_campaign_admin_user" */
export enum Ad_Campaign_Admin_User_Update_Column {
  /** column name */
  AdCampaignId = 'ad_campaign_id',
  /** column name */
  AdminUserId = 'admin_user_id'
}

export type Ad_Campaign_Admin_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ad_Campaign_Admin_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Campaign_Admin_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Campaign_Admin_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ad_Campaign_Admin_User_Var_Pop_Fields = {
  __typename?: 'ad_campaign_admin_user_var_pop_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  admin_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Var_Pop_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ad_Campaign_Admin_User_Var_Samp_Fields = {
  __typename?: 'ad_campaign_admin_user_var_samp_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  admin_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Var_Samp_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ad_Campaign_Admin_User_Variance_Fields = {
  __typename?: 'ad_campaign_admin_user_variance_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  admin_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ad_campaign_admin_user" */
export type Ad_Campaign_Admin_User_Variance_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority = {
  __typename?: 'ad_campaign_parking_authority';
  /** An object relationship */
  ad_campaign: Ad_Campaigns;
  ad_campaign_id: Scalars['bigint']['output'];
  /** An object relationship */
  parking_authority: Parking_Authorities;
  parking_authority_id: Scalars['bigint']['output'];
};

/** aggregated selection of "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Aggregate = {
  __typename?: 'ad_campaign_parking_authority_aggregate';
  aggregate?: Maybe<Ad_Campaign_Parking_Authority_Aggregate_Fields>;
  nodes: Array<Ad_Campaign_Parking_Authority>;
};

export type Ad_Campaign_Parking_Authority_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ad_Campaign_Parking_Authority_Aggregate_Bool_Exp_Count>;
};

export type Ad_Campaign_Parking_Authority_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Aggregate_Fields = {
  __typename?: 'ad_campaign_parking_authority_aggregate_fields';
  avg?: Maybe<Ad_Campaign_Parking_Authority_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Campaign_Parking_Authority_Max_Fields>;
  min?: Maybe<Ad_Campaign_Parking_Authority_Min_Fields>;
  stddev?: Maybe<Ad_Campaign_Parking_Authority_Stddev_Fields>;
  stddev_pop?: Maybe<Ad_Campaign_Parking_Authority_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ad_Campaign_Parking_Authority_Stddev_Samp_Fields>;
  sum?: Maybe<Ad_Campaign_Parking_Authority_Sum_Fields>;
  var_pop?: Maybe<Ad_Campaign_Parking_Authority_Var_Pop_Fields>;
  var_samp?: Maybe<Ad_Campaign_Parking_Authority_Var_Samp_Fields>;
  variance?: Maybe<Ad_Campaign_Parking_Authority_Variance_Fields>;
};


/** aggregate fields of "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Aggregate_Order_By = {
  avg?: InputMaybe<Ad_Campaign_Parking_Authority_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ad_Campaign_Parking_Authority_Max_Order_By>;
  min?: InputMaybe<Ad_Campaign_Parking_Authority_Min_Order_By>;
  stddev?: InputMaybe<Ad_Campaign_Parking_Authority_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ad_Campaign_Parking_Authority_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ad_Campaign_Parking_Authority_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ad_Campaign_Parking_Authority_Sum_Order_By>;
  var_pop?: InputMaybe<Ad_Campaign_Parking_Authority_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ad_Campaign_Parking_Authority_Var_Samp_Order_By>;
  variance?: InputMaybe<Ad_Campaign_Parking_Authority_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Arr_Rel_Insert_Input = {
  data: Array<Ad_Campaign_Parking_Authority_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Campaign_Parking_Authority_On_Conflict>;
};

/** aggregate avg on columns */
export type Ad_Campaign_Parking_Authority_Avg_Fields = {
  __typename?: 'ad_campaign_parking_authority_avg_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Avg_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ad_campaign_parking_authority". All fields are combined with a logical 'AND'. */
export type Ad_Campaign_Parking_Authority_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Bool_Exp>>;
  _not?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Bool_Exp>>;
  ad_campaign?: InputMaybe<Ad_Campaigns_Bool_Exp>;
  ad_campaign_id?: InputMaybe<Bigint_Comparison_Exp>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad_campaign_parking_authority" */
export enum Ad_Campaign_Parking_Authority_Constraint {
  /** unique or primary key constraint on columns "parking_authority_id", "ad_campaign_id" */
  AdCampaignParkingAuthorityAdCampaignIdParkingAuthority = 'ad_campaign_parking_authority_ad_campaign_id_parking_authority_'
}

/** input type for incrementing numeric columns in table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Inc_Input = {
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Insert_Input = {
  ad_campaign?: InputMaybe<Ad_Campaigns_Obj_Rel_Insert_Input>;
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Ad_Campaign_Parking_Authority_Max_Fields = {
  __typename?: 'ad_campaign_parking_authority_max_fields';
  ad_campaign_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Max_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ad_Campaign_Parking_Authority_Min_Fields = {
  __typename?: 'ad_campaign_parking_authority_min_fields';
  ad_campaign_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Min_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Mutation_Response = {
  __typename?: 'ad_campaign_parking_authority_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Campaign_Parking_Authority>;
};

/** on_conflict condition type for table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_On_Conflict = {
  constraint: Ad_Campaign_Parking_Authority_Constraint;
  update_columns?: Array<Ad_Campaign_Parking_Authority_Update_Column>;
  where?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
};

/** Ordering options when selecting data from "ad_campaign_parking_authority". */
export type Ad_Campaign_Parking_Authority_Order_By = {
  ad_campaign?: InputMaybe<Ad_Campaigns_Order_By>;
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** select columns of table "ad_campaign_parking_authority" */
export enum Ad_Campaign_Parking_Authority_Select_Column {
  /** column name */
  AdCampaignId = 'ad_campaign_id',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id'
}

/** input type for updating data in table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Set_Input = {
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Ad_Campaign_Parking_Authority_Stddev_Fields = {
  __typename?: 'ad_campaign_parking_authority_stddev_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Stddev_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ad_Campaign_Parking_Authority_Stddev_Pop_Fields = {
  __typename?: 'ad_campaign_parking_authority_stddev_pop_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Stddev_Pop_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ad_Campaign_Parking_Authority_Stddev_Samp_Fields = {
  __typename?: 'ad_campaign_parking_authority_stddev_samp_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Stddev_Samp_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Campaign_Parking_Authority_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Campaign_Parking_Authority_Stream_Cursor_Value_Input = {
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Ad_Campaign_Parking_Authority_Sum_Fields = {
  __typename?: 'ad_campaign_parking_authority_sum_fields';
  ad_campaign_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Sum_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** update columns of table "ad_campaign_parking_authority" */
export enum Ad_Campaign_Parking_Authority_Update_Column {
  /** column name */
  AdCampaignId = 'ad_campaign_id',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id'
}

export type Ad_Campaign_Parking_Authority_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ad_Campaign_Parking_Authority_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Campaign_Parking_Authority_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Campaign_Parking_Authority_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ad_Campaign_Parking_Authority_Var_Pop_Fields = {
  __typename?: 'ad_campaign_parking_authority_var_pop_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Var_Pop_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ad_Campaign_Parking_Authority_Var_Samp_Fields = {
  __typename?: 'ad_campaign_parking_authority_var_samp_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Var_Samp_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ad_Campaign_Parking_Authority_Variance_Fields = {
  __typename?: 'ad_campaign_parking_authority_variance_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ad_campaign_parking_authority" */
export type Ad_Campaign_Parking_Authority_Variance_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ad_campaigns" */
export type Ad_Campaigns = {
  __typename?: 'ad_campaigns';
  /** An array relationship */
  ad_campaign_admin_users: Array<Ad_Campaign_Admin_User>;
  /** An aggregate relationship */
  ad_campaign_admin_users_aggregate: Ad_Campaign_Admin_User_Aggregate;
  /** An array relationship */
  ad_campaign_parking_authorities: Array<Ad_Campaign_Parking_Authority>;
  /** An aggregate relationship */
  ad_campaign_parking_authorities_aggregate: Ad_Campaign_Parking_Authority_Aggregate;
  /** An array relationship */
  ads: Array<Ads>;
  /** An aggregate relationship */
  ads_aggregate: Ads_Aggregate;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['bigint']['output'];
  idempotent_key: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  short_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "ad_campaigns" */
export type Ad_CampaignsAd_Campaign_Admin_UsersArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Admin_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Admin_User_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
};


/** columns and relationships of "ad_campaigns" */
export type Ad_CampaignsAd_Campaign_Admin_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Admin_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Admin_User_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
};


/** columns and relationships of "ad_campaigns" */
export type Ad_CampaignsAd_Campaign_Parking_AuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
};


/** columns and relationships of "ad_campaigns" */
export type Ad_CampaignsAd_Campaign_Parking_Authorities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
};


/** columns and relationships of "ad_campaigns" */
export type Ad_CampaignsAdsArgs = {
  distinct_on?: InputMaybe<Array<Ads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ads_Order_By>>;
  where?: InputMaybe<Ads_Bool_Exp>;
};


/** columns and relationships of "ad_campaigns" */
export type Ad_CampaignsAds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ads_Order_By>>;
  where?: InputMaybe<Ads_Bool_Exp>;
};

/** aggregated selection of "ad_campaigns" */
export type Ad_Campaigns_Aggregate = {
  __typename?: 'ad_campaigns_aggregate';
  aggregate?: Maybe<Ad_Campaigns_Aggregate_Fields>;
  nodes: Array<Ad_Campaigns>;
};

/** aggregate fields of "ad_campaigns" */
export type Ad_Campaigns_Aggregate_Fields = {
  __typename?: 'ad_campaigns_aggregate_fields';
  avg?: Maybe<Ad_Campaigns_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Campaigns_Max_Fields>;
  min?: Maybe<Ad_Campaigns_Min_Fields>;
  stddev?: Maybe<Ad_Campaigns_Stddev_Fields>;
  stddev_pop?: Maybe<Ad_Campaigns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ad_Campaigns_Stddev_Samp_Fields>;
  sum?: Maybe<Ad_Campaigns_Sum_Fields>;
  var_pop?: Maybe<Ad_Campaigns_Var_Pop_Fields>;
  var_samp?: Maybe<Ad_Campaigns_Var_Samp_Fields>;
  variance?: Maybe<Ad_Campaigns_Variance_Fields>;
};


/** aggregate fields of "ad_campaigns" */
export type Ad_Campaigns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Campaigns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ad_Campaigns_Avg_Fields = {
  __typename?: 'ad_campaigns_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "ad_campaigns". All fields are combined with a logical 'AND'. */
export type Ad_Campaigns_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Campaigns_Bool_Exp>>;
  _not?: InputMaybe<Ad_Campaigns_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Campaigns_Bool_Exp>>;
  ad_campaign_admin_users?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
  ad_campaign_admin_users_aggregate?: InputMaybe<Ad_Campaign_Admin_User_Aggregate_Bool_Exp>;
  ad_campaign_parking_authorities?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
  ad_campaign_parking_authorities_aggregate?: InputMaybe<Ad_Campaign_Parking_Authority_Aggregate_Bool_Exp>;
  ads?: InputMaybe<Ads_Bool_Exp>;
  ads_aggregate?: InputMaybe<Ads_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad_campaigns" */
export enum Ad_Campaigns_Constraint {
  /** unique or primary key constraint on columns "idempotent_key" */
  AdCampaignsIdempotentKeyUnique = 'ad_campaigns_idempotent_key_unique',
  /** unique or primary key constraint on columns "id" */
  AdCampaignsPkey = 'ad_campaigns_pkey'
}

/** input type for incrementing numeric columns in table "ad_campaigns" */
export type Ad_Campaigns_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "ad_campaigns" */
export type Ad_Campaigns_Insert_Input = {
  ad_campaign_admin_users?: InputMaybe<Ad_Campaign_Admin_User_Arr_Rel_Insert_Input>;
  ad_campaign_parking_authorities?: InputMaybe<Ad_Campaign_Parking_Authority_Arr_Rel_Insert_Input>;
  ads?: InputMaybe<Ads_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Ad_Campaigns_Max_Fields = {
  __typename?: 'ad_campaigns_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Ad_Campaigns_Min_Fields = {
  __typename?: 'ad_campaigns_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "ad_campaigns" */
export type Ad_Campaigns_Mutation_Response = {
  __typename?: 'ad_campaigns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Campaigns>;
};

/** input type for inserting object relation for remote table "ad_campaigns" */
export type Ad_Campaigns_Obj_Rel_Insert_Input = {
  data: Ad_Campaigns_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Campaigns_On_Conflict>;
};

/** on_conflict condition type for table "ad_campaigns" */
export type Ad_Campaigns_On_Conflict = {
  constraint: Ad_Campaigns_Constraint;
  update_columns?: Array<Ad_Campaigns_Update_Column>;
  where?: InputMaybe<Ad_Campaigns_Bool_Exp>;
};

/** Ordering options when selecting data from "ad_campaigns". */
export type Ad_Campaigns_Order_By = {
  ad_campaign_admin_users_aggregate?: InputMaybe<Ad_Campaign_Admin_User_Aggregate_Order_By>;
  ad_campaign_parking_authorities_aggregate?: InputMaybe<Ad_Campaign_Parking_Authority_Aggregate_Order_By>;
  ads_aggregate?: InputMaybe<Ads_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad_campaigns */
export type Ad_Campaigns_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "ad_campaigns" */
export enum Ad_Campaigns_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ad_campaigns" */
export type Ad_Campaigns_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Ad_Campaigns_Stddev_Fields = {
  __typename?: 'ad_campaigns_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ad_Campaigns_Stddev_Pop_Fields = {
  __typename?: 'ad_campaigns_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ad_Campaigns_Stddev_Samp_Fields = {
  __typename?: 'ad_campaigns_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "ad_campaigns" */
export type Ad_Campaigns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Campaigns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Campaigns_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Ad_Campaigns_Sum_Fields = {
  __typename?: 'ad_campaigns_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "ad_campaigns" */
export enum Ad_Campaigns_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ad_Campaigns_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ad_Campaigns_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Campaigns_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Campaigns_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ad_Campaigns_Var_Pop_Fields = {
  __typename?: 'ad_campaigns_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ad_Campaigns_Var_Samp_Fields = {
  __typename?: 'ad_campaigns_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ad_Campaigns_Variance_Fields = {
  __typename?: 'ad_campaigns_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "ad_events" */
export type Ad_Events = {
  __typename?: 'ad_events';
  /** An object relationship */
  ad_variant?: Maybe<Ad_Variants>;
  ad_variant_id?: Maybe<Scalars['bigint']['output']>;
  batch_id: Scalars['uuid']['output'];
  context?: Maybe<Scalars['json']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  event_id: Scalars['uuid']['output'];
  id: Scalars['bigint']['output'];
  occurred_at: Scalars['timestamp']['output'];
  spot: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "ad_events" */
export type Ad_EventsContextArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "ad_events" */
export type Ad_Events_Aggregate = {
  __typename?: 'ad_events_aggregate';
  aggregate?: Maybe<Ad_Events_Aggregate_Fields>;
  nodes: Array<Ad_Events>;
};

export type Ad_Events_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ad_Events_Aggregate_Bool_Exp_Count>;
};

export type Ad_Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ad_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ad_events" */
export type Ad_Events_Aggregate_Fields = {
  __typename?: 'ad_events_aggregate_fields';
  avg?: Maybe<Ad_Events_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Events_Max_Fields>;
  min?: Maybe<Ad_Events_Min_Fields>;
  stddev?: Maybe<Ad_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Ad_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ad_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Ad_Events_Sum_Fields>;
  var_pop?: Maybe<Ad_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Ad_Events_Var_Samp_Fields>;
  variance?: Maybe<Ad_Events_Variance_Fields>;
};


/** aggregate fields of "ad_events" */
export type Ad_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ad_events" */
export type Ad_Events_Aggregate_Order_By = {
  avg?: InputMaybe<Ad_Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ad_Events_Max_Order_By>;
  min?: InputMaybe<Ad_Events_Min_Order_By>;
  stddev?: InputMaybe<Ad_Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ad_Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ad_Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ad_Events_Sum_Order_By>;
  var_pop?: InputMaybe<Ad_Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ad_Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Ad_Events_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ad_events" */
export type Ad_Events_Arr_Rel_Insert_Input = {
  data: Array<Ad_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Ad_Events_Avg_Fields = {
  __typename?: 'ad_events_avg_fields';
  ad_variant_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ad_events" */
export type Ad_Events_Avg_Order_By = {
  ad_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ad_events". All fields are combined with a logical 'AND'. */
export type Ad_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Events_Bool_Exp>>;
  _not?: InputMaybe<Ad_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Events_Bool_Exp>>;
  ad_variant?: InputMaybe<Ad_Variants_Bool_Exp>;
  ad_variant_id?: InputMaybe<Bigint_Comparison_Exp>;
  batch_id?: InputMaybe<Uuid_Comparison_Exp>;
  context?: InputMaybe<Json_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  occurred_at?: InputMaybe<Timestamp_Comparison_Exp>;
  spot?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad_events" */
export enum Ad_Events_Constraint {
  /** unique or primary key constraint on columns "event_id" */
  AdEventsEventIdUnique = 'ad_events_event_id_unique',
  /** unique or primary key constraint on columns "id" */
  AdEventsPkey = 'ad_events_pkey'
}

/** input type for incrementing numeric columns in table "ad_events" */
export type Ad_Events_Inc_Input = {
  ad_variant_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "ad_events" */
export type Ad_Events_Insert_Input = {
  ad_variant?: InputMaybe<Ad_Variants_Obj_Rel_Insert_Input>;
  ad_variant_id?: InputMaybe<Scalars['bigint']['input']>;
  batch_id?: InputMaybe<Scalars['uuid']['input']>;
  context?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  event_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  occurred_at?: InputMaybe<Scalars['timestamp']['input']>;
  spot?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Ad_Events_Max_Fields = {
  __typename?: 'ad_events_max_fields';
  ad_variant_id?: Maybe<Scalars['bigint']['output']>;
  batch_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  event_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  occurred_at?: Maybe<Scalars['timestamp']['output']>;
  spot?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "ad_events" */
export type Ad_Events_Max_Order_By = {
  ad_variant_id?: InputMaybe<Order_By>;
  batch_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  occurred_at?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ad_Events_Min_Fields = {
  __typename?: 'ad_events_min_fields';
  ad_variant_id?: Maybe<Scalars['bigint']['output']>;
  batch_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  event_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  occurred_at?: Maybe<Scalars['timestamp']['output']>;
  spot?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "ad_events" */
export type Ad_Events_Min_Order_By = {
  ad_variant_id?: InputMaybe<Order_By>;
  batch_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  occurred_at?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ad_events" */
export type Ad_Events_Mutation_Response = {
  __typename?: 'ad_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Events>;
};

/** on_conflict condition type for table "ad_events" */
export type Ad_Events_On_Conflict = {
  constraint: Ad_Events_Constraint;
  update_columns?: Array<Ad_Events_Update_Column>;
  where?: InputMaybe<Ad_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "ad_events". */
export type Ad_Events_Order_By = {
  ad_variant?: InputMaybe<Ad_Variants_Order_By>;
  ad_variant_id?: InputMaybe<Order_By>;
  batch_id?: InputMaybe<Order_By>;
  context?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  occurred_at?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad_events */
export type Ad_Events_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "ad_events" */
export enum Ad_Events_Select_Column {
  /** column name */
  AdVariantId = 'ad_variant_id',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Context = 'context',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  OccurredAt = 'occurred_at',
  /** column name */
  Spot = 'spot',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "ad_events" */
export type Ad_Events_Set_Input = {
  ad_variant_id?: InputMaybe<Scalars['bigint']['input']>;
  batch_id?: InputMaybe<Scalars['uuid']['input']>;
  context?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  event_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  occurred_at?: InputMaybe<Scalars['timestamp']['input']>;
  spot?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Ad_Events_Stddev_Fields = {
  __typename?: 'ad_events_stddev_fields';
  ad_variant_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ad_events" */
export type Ad_Events_Stddev_Order_By = {
  ad_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ad_Events_Stddev_Pop_Fields = {
  __typename?: 'ad_events_stddev_pop_fields';
  ad_variant_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ad_events" */
export type Ad_Events_Stddev_Pop_Order_By = {
  ad_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ad_Events_Stddev_Samp_Fields = {
  __typename?: 'ad_events_stddev_samp_fields';
  ad_variant_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ad_events" */
export type Ad_Events_Stddev_Samp_Order_By = {
  ad_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ad_events" */
export type Ad_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Events_Stream_Cursor_Value_Input = {
  ad_variant_id?: InputMaybe<Scalars['bigint']['input']>;
  batch_id?: InputMaybe<Scalars['uuid']['input']>;
  context?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  event_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  occurred_at?: InputMaybe<Scalars['timestamp']['input']>;
  spot?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Ad_Events_Sum_Fields = {
  __typename?: 'ad_events_sum_fields';
  ad_variant_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "ad_events" */
export type Ad_Events_Sum_Order_By = {
  ad_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "ad_events" */
export enum Ad_Events_Update_Column {
  /** column name */
  AdVariantId = 'ad_variant_id',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Context = 'context',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  OccurredAt = 'occurred_at',
  /** column name */
  Spot = 'spot',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Ad_Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ad_Events_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ad_Events_Var_Pop_Fields = {
  __typename?: 'ad_events_var_pop_fields';
  ad_variant_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ad_events" */
export type Ad_Events_Var_Pop_Order_By = {
  ad_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ad_Events_Var_Samp_Fields = {
  __typename?: 'ad_events_var_samp_fields';
  ad_variant_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ad_events" */
export type Ad_Events_Var_Samp_Order_By = {
  ad_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ad_Events_Variance_Fields = {
  __typename?: 'ad_events_variance_fields';
  ad_variant_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ad_events" */
export type Ad_Events_Variance_Order_By = {
  ad_variant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ad_variants" */
export type Ad_Variants = {
  __typename?: 'ad_variants';
  /** An object relationship */
  ad?: Maybe<Ads>;
  /** An array relationship */
  ad_events: Array<Ad_Events>;
  /** An aggregate relationship */
  ad_events_aggregate: Ad_Events_Aggregate;
  ad_id?: Maybe<Scalars['bigint']['output']>;
  blur_hash?: Maybe<Scalars['String']['output']>;
  clicks: Scalars['float8']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  distribution: Scalars['float8']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['bigint']['output'];
  idempotent_key: Scalars['uuid']['output'];
  impressions_goal: Scalars['float8']['output'];
  impressions_last_updated_at?: Maybe<Scalars['timestamp']['output']>;
  impressions_served: Scalars['float8']['output'];
  impressions_served_prev_days: Scalars['float8']['output'];
  impressions_served_prev_hours: Scalars['float8']['output'];
  media_cdn_url?: Maybe<Scalars['String']['output']>;
  media_file_pathname?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  short_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "ad_variants" */
export type Ad_VariantsAd_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Events_Order_By>>;
  where?: InputMaybe<Ad_Events_Bool_Exp>;
};


/** columns and relationships of "ad_variants" */
export type Ad_VariantsAd_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Events_Order_By>>;
  where?: InputMaybe<Ad_Events_Bool_Exp>;
};

/** aggregated selection of "ad_variants" */
export type Ad_Variants_Aggregate = {
  __typename?: 'ad_variants_aggregate';
  aggregate?: Maybe<Ad_Variants_Aggregate_Fields>;
  nodes: Array<Ad_Variants>;
};

export type Ad_Variants_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp_Var_Samp>;
};

export type Ad_Variants_Aggregate_Bool_Exp_Avg = {
  arguments: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Variants_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ad_Variants_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ad_Variants_Aggregate_Bool_Exp_Corr = {
  arguments: Ad_Variants_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Variants_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Ad_Variants_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ad_Variants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Ad_Variants_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Ad_Variants_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Variants_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Ad_Variants_Aggregate_Bool_Exp_Max = {
  arguments: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Variants_Aggregate_Bool_Exp_Min = {
  arguments: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Variants_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Variants_Aggregate_Bool_Exp_Sum = {
  arguments: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ad_Variants_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ad_Variants_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "ad_variants" */
export type Ad_Variants_Aggregate_Fields = {
  __typename?: 'ad_variants_aggregate_fields';
  avg?: Maybe<Ad_Variants_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ad_Variants_Max_Fields>;
  min?: Maybe<Ad_Variants_Min_Fields>;
  stddev?: Maybe<Ad_Variants_Stddev_Fields>;
  stddev_pop?: Maybe<Ad_Variants_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ad_Variants_Stddev_Samp_Fields>;
  sum?: Maybe<Ad_Variants_Sum_Fields>;
  var_pop?: Maybe<Ad_Variants_Var_Pop_Fields>;
  var_samp?: Maybe<Ad_Variants_Var_Samp_Fields>;
  variance?: Maybe<Ad_Variants_Variance_Fields>;
};


/** aggregate fields of "ad_variants" */
export type Ad_Variants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Variants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ad_variants" */
export type Ad_Variants_Aggregate_Order_By = {
  avg?: InputMaybe<Ad_Variants_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ad_Variants_Max_Order_By>;
  min?: InputMaybe<Ad_Variants_Min_Order_By>;
  stddev?: InputMaybe<Ad_Variants_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ad_Variants_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ad_Variants_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ad_Variants_Sum_Order_By>;
  var_pop?: InputMaybe<Ad_Variants_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ad_Variants_Var_Samp_Order_By>;
  variance?: InputMaybe<Ad_Variants_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ad_variants" */
export type Ad_Variants_Arr_Rel_Insert_Input = {
  data: Array<Ad_Variants_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Variants_On_Conflict>;
};

/** aggregate avg on columns */
export type Ad_Variants_Avg_Fields = {
  __typename?: 'ad_variants_avg_fields';
  ad_id?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_days?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ad_variants" */
export type Ad_Variants_Avg_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ad_variants". All fields are combined with a logical 'AND'. */
export type Ad_Variants_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Variants_Bool_Exp>>;
  _not?: InputMaybe<Ad_Variants_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Variants_Bool_Exp>>;
  ad?: InputMaybe<Ads_Bool_Exp>;
  ad_events?: InputMaybe<Ad_Events_Bool_Exp>;
  ad_events_aggregate?: InputMaybe<Ad_Events_Aggregate_Bool_Exp>;
  ad_id?: InputMaybe<Bigint_Comparison_Exp>;
  blur_hash?: InputMaybe<String_Comparison_Exp>;
  clicks?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  distribution?: InputMaybe<Float8_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  impressions_goal?: InputMaybe<Float8_Comparison_Exp>;
  impressions_last_updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  impressions_served?: InputMaybe<Float8_Comparison_Exp>;
  impressions_served_prev_days?: InputMaybe<Float8_Comparison_Exp>;
  impressions_served_prev_hours?: InputMaybe<Float8_Comparison_Exp>;
  media_cdn_url?: InputMaybe<String_Comparison_Exp>;
  media_file_pathname?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  utm_campaign?: InputMaybe<String_Comparison_Exp>;
  utm_content?: InputMaybe<String_Comparison_Exp>;
  utm_medium?: InputMaybe<String_Comparison_Exp>;
  utm_source?: InputMaybe<String_Comparison_Exp>;
  utm_term?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad_variants" */
export enum Ad_Variants_Constraint {
  /** unique or primary key constraint on columns "idempotent_key" */
  AdVariantsIdempotentKeyUnique = 'ad_variants_idempotent_key_unique',
  /** unique or primary key constraint on columns "id" */
  AdVariantsPkey = 'ad_variants_pkey'
}

/** input type for incrementing numeric columns in table "ad_variants" */
export type Ad_Variants_Inc_Input = {
  ad_id?: InputMaybe<Scalars['bigint']['input']>;
  clicks?: InputMaybe<Scalars['float8']['input']>;
  distribution?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  impressions_goal?: InputMaybe<Scalars['float8']['input']>;
  impressions_served?: InputMaybe<Scalars['float8']['input']>;
  impressions_served_prev_days?: InputMaybe<Scalars['float8']['input']>;
  impressions_served_prev_hours?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "ad_variants" */
export type Ad_Variants_Insert_Input = {
  ad?: InputMaybe<Ads_Obj_Rel_Insert_Input>;
  ad_events?: InputMaybe<Ad_Events_Arr_Rel_Insert_Input>;
  ad_id?: InputMaybe<Scalars['bigint']['input']>;
  blur_hash?: InputMaybe<Scalars['String']['input']>;
  clicks?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  distribution?: InputMaybe<Scalars['float8']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  impressions_goal?: InputMaybe<Scalars['float8']['input']>;
  impressions_last_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  impressions_served?: InputMaybe<Scalars['float8']['input']>;
  impressions_served_prev_days?: InputMaybe<Scalars['float8']['input']>;
  impressions_served_prev_hours?: InputMaybe<Scalars['float8']['input']>;
  media_cdn_url?: InputMaybe<Scalars['String']['input']>;
  media_file_pathname?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ad_Variants_Max_Fields = {
  __typename?: 'ad_variants_max_fields';
  ad_id?: Maybe<Scalars['bigint']['output']>;
  blur_hash?: Maybe<Scalars['String']['output']>;
  clicks?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  distribution?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  impressions_goal?: Maybe<Scalars['float8']['output']>;
  impressions_last_updated_at?: Maybe<Scalars['timestamp']['output']>;
  impressions_served?: Maybe<Scalars['float8']['output']>;
  impressions_served_prev_days?: Maybe<Scalars['float8']['output']>;
  impressions_served_prev_hours?: Maybe<Scalars['float8']['output']>;
  media_cdn_url?: Maybe<Scalars['String']['output']>;
  media_file_pathname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "ad_variants" */
export type Ad_Variants_Max_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  blur_hash?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_last_updated_at?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
  media_cdn_url?: InputMaybe<Order_By>;
  media_file_pathname?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_content?: InputMaybe<Order_By>;
  utm_medium?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  utm_term?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ad_Variants_Min_Fields = {
  __typename?: 'ad_variants_min_fields';
  ad_id?: Maybe<Scalars['bigint']['output']>;
  blur_hash?: Maybe<Scalars['String']['output']>;
  clicks?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  distribution?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  impressions_goal?: Maybe<Scalars['float8']['output']>;
  impressions_last_updated_at?: Maybe<Scalars['timestamp']['output']>;
  impressions_served?: Maybe<Scalars['float8']['output']>;
  impressions_served_prev_days?: Maybe<Scalars['float8']['output']>;
  impressions_served_prev_hours?: Maybe<Scalars['float8']['output']>;
  media_cdn_url?: Maybe<Scalars['String']['output']>;
  media_file_pathname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "ad_variants" */
export type Ad_Variants_Min_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  blur_hash?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_last_updated_at?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
  media_cdn_url?: InputMaybe<Order_By>;
  media_file_pathname?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_content?: InputMaybe<Order_By>;
  utm_medium?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  utm_term?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ad_variants" */
export type Ad_Variants_Mutation_Response = {
  __typename?: 'ad_variants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Variants>;
};

/** input type for inserting object relation for remote table "ad_variants" */
export type Ad_Variants_Obj_Rel_Insert_Input = {
  data: Ad_Variants_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Variants_On_Conflict>;
};

/** on_conflict condition type for table "ad_variants" */
export type Ad_Variants_On_Conflict = {
  constraint: Ad_Variants_Constraint;
  update_columns?: Array<Ad_Variants_Update_Column>;
  where?: InputMaybe<Ad_Variants_Bool_Exp>;
};

/** Ordering options when selecting data from "ad_variants". */
export type Ad_Variants_Order_By = {
  ad?: InputMaybe<Ads_Order_By>;
  ad_events_aggregate?: InputMaybe<Ad_Events_Aggregate_Order_By>;
  ad_id?: InputMaybe<Order_By>;
  blur_hash?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_last_updated_at?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
  media_cdn_url?: InputMaybe<Order_By>;
  media_file_pathname?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_content?: InputMaybe<Order_By>;
  utm_medium?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  utm_term?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad_variants */
export type Ad_Variants_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "ad_variants" */
export enum Ad_Variants_Select_Column {
  /** column name */
  AdId = 'ad_id',
  /** column name */
  BlurHash = 'blur_hash',
  /** column name */
  Clicks = 'clicks',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Distribution = 'distribution',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsLastUpdatedAt = 'impressions_last_updated_at',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  ImpressionsServedPrevDays = 'impressions_served_prev_days',
  /** column name */
  ImpressionsServedPrevHours = 'impressions_served_prev_hours',
  /** column name */
  MediaCdnUrl = 'media_cdn_url',
  /** column name */
  MediaFilePathname = 'media_file_pathname',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UtmCampaign = 'utm_campaign',
  /** column name */
  UtmContent = 'utm_content',
  /** column name */
  UtmMedium = 'utm_medium',
  /** column name */
  UtmSource = 'utm_source',
  /** column name */
  UtmTerm = 'utm_term'
}

/** select "ad_variants_aggregate_bool_exp_avg_arguments_columns" columns of table "ad_variants" */
export enum Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Distribution = 'distribution',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  ImpressionsServedPrevDays = 'impressions_served_prev_days',
  /** column name */
  ImpressionsServedPrevHours = 'impressions_served_prev_hours'
}

/** select "ad_variants_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ad_variants" */
export enum Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Enabled = 'enabled'
}

/** select "ad_variants_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ad_variants" */
export enum Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Enabled = 'enabled'
}

/** select "ad_variants_aggregate_bool_exp_corr_arguments_columns" columns of table "ad_variants" */
export enum Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Distribution = 'distribution',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  ImpressionsServedPrevDays = 'impressions_served_prev_days',
  /** column name */
  ImpressionsServedPrevHours = 'impressions_served_prev_hours'
}

/** select "ad_variants_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "ad_variants" */
export enum Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Distribution = 'distribution',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  ImpressionsServedPrevDays = 'impressions_served_prev_days',
  /** column name */
  ImpressionsServedPrevHours = 'impressions_served_prev_hours'
}

/** select "ad_variants_aggregate_bool_exp_max_arguments_columns" columns of table "ad_variants" */
export enum Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Distribution = 'distribution',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  ImpressionsServedPrevDays = 'impressions_served_prev_days',
  /** column name */
  ImpressionsServedPrevHours = 'impressions_served_prev_hours'
}

/** select "ad_variants_aggregate_bool_exp_min_arguments_columns" columns of table "ad_variants" */
export enum Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Distribution = 'distribution',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  ImpressionsServedPrevDays = 'impressions_served_prev_days',
  /** column name */
  ImpressionsServedPrevHours = 'impressions_served_prev_hours'
}

/** select "ad_variants_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "ad_variants" */
export enum Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Distribution = 'distribution',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  ImpressionsServedPrevDays = 'impressions_served_prev_days',
  /** column name */
  ImpressionsServedPrevHours = 'impressions_served_prev_hours'
}

/** select "ad_variants_aggregate_bool_exp_sum_arguments_columns" columns of table "ad_variants" */
export enum Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Distribution = 'distribution',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  ImpressionsServedPrevDays = 'impressions_served_prev_days',
  /** column name */
  ImpressionsServedPrevHours = 'impressions_served_prev_hours'
}

/** select "ad_variants_aggregate_bool_exp_var_samp_arguments_columns" columns of table "ad_variants" */
export enum Ad_Variants_Select_Column_Ad_Variants_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Distribution = 'distribution',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  ImpressionsServedPrevDays = 'impressions_served_prev_days',
  /** column name */
  ImpressionsServedPrevHours = 'impressions_served_prev_hours'
}

/** input type for updating data in table "ad_variants" */
export type Ad_Variants_Set_Input = {
  ad_id?: InputMaybe<Scalars['bigint']['input']>;
  blur_hash?: InputMaybe<Scalars['String']['input']>;
  clicks?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  distribution?: InputMaybe<Scalars['float8']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  impressions_goal?: InputMaybe<Scalars['float8']['input']>;
  impressions_last_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  impressions_served?: InputMaybe<Scalars['float8']['input']>;
  impressions_served_prev_days?: InputMaybe<Scalars['float8']['input']>;
  impressions_served_prev_hours?: InputMaybe<Scalars['float8']['input']>;
  media_cdn_url?: InputMaybe<Scalars['String']['input']>;
  media_file_pathname?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Ad_Variants_Stddev_Fields = {
  __typename?: 'ad_variants_stddev_fields';
  ad_id?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_days?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ad_variants" */
export type Ad_Variants_Stddev_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ad_Variants_Stddev_Pop_Fields = {
  __typename?: 'ad_variants_stddev_pop_fields';
  ad_id?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_days?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ad_variants" */
export type Ad_Variants_Stddev_Pop_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ad_Variants_Stddev_Samp_Fields = {
  __typename?: 'ad_variants_stddev_samp_fields';
  ad_id?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_days?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ad_variants" */
export type Ad_Variants_Stddev_Samp_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ad_variants" */
export type Ad_Variants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Variants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Variants_Stream_Cursor_Value_Input = {
  ad_id?: InputMaybe<Scalars['bigint']['input']>;
  blur_hash?: InputMaybe<Scalars['String']['input']>;
  clicks?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  distribution?: InputMaybe<Scalars['float8']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  impressions_goal?: InputMaybe<Scalars['float8']['input']>;
  impressions_last_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  impressions_served?: InputMaybe<Scalars['float8']['input']>;
  impressions_served_prev_days?: InputMaybe<Scalars['float8']['input']>;
  impressions_served_prev_hours?: InputMaybe<Scalars['float8']['input']>;
  media_cdn_url?: InputMaybe<Scalars['String']['input']>;
  media_file_pathname?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Ad_Variants_Sum_Fields = {
  __typename?: 'ad_variants_sum_fields';
  ad_id?: Maybe<Scalars['bigint']['output']>;
  clicks?: Maybe<Scalars['float8']['output']>;
  distribution?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  impressions_goal?: Maybe<Scalars['float8']['output']>;
  impressions_served?: Maybe<Scalars['float8']['output']>;
  impressions_served_prev_days?: Maybe<Scalars['float8']['output']>;
  impressions_served_prev_hours?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "ad_variants" */
export type Ad_Variants_Sum_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
};

/** update columns of table "ad_variants" */
export enum Ad_Variants_Update_Column {
  /** column name */
  AdId = 'ad_id',
  /** column name */
  BlurHash = 'blur_hash',
  /** column name */
  Clicks = 'clicks',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Distribution = 'distribution',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsLastUpdatedAt = 'impressions_last_updated_at',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  ImpressionsServedPrevDays = 'impressions_served_prev_days',
  /** column name */
  ImpressionsServedPrevHours = 'impressions_served_prev_hours',
  /** column name */
  MediaCdnUrl = 'media_cdn_url',
  /** column name */
  MediaFilePathname = 'media_file_pathname',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UtmCampaign = 'utm_campaign',
  /** column name */
  UtmContent = 'utm_content',
  /** column name */
  UtmMedium = 'utm_medium',
  /** column name */
  UtmSource = 'utm_source',
  /** column name */
  UtmTerm = 'utm_term'
}

export type Ad_Variants_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ad_Variants_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Variants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Variants_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ad_Variants_Var_Pop_Fields = {
  __typename?: 'ad_variants_var_pop_fields';
  ad_id?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_days?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ad_variants" */
export type Ad_Variants_Var_Pop_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ad_Variants_Var_Samp_Fields = {
  __typename?: 'ad_variants_var_samp_fields';
  ad_id?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_days?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ad_variants" */
export type Ad_Variants_Var_Samp_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ad_Variants_Variance_Fields = {
  __typename?: 'ad_variants_variance_fields';
  ad_id?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_days?: Maybe<Scalars['Float']['output']>;
  impressions_served_prev_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ad_variants" */
export type Ad_Variants_Variance_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  impressions_served_prev_days?: InputMaybe<Order_By>;
  impressions_served_prev_hours?: InputMaybe<Order_By>;
};

/** columns and relationships of "admin_user_parking_authority" */
export type Admin_User_Parking_Authority = {
  __typename?: 'admin_user_parking_authority';
  /** An object relationship */
  admin_user: Admin_Users;
  admin_user_id: Scalars['bigint']['output'];
  /** An object relationship */
  parking_authority: Parking_Authorities;
  parking_authority_id: Scalars['bigint']['output'];
};

/** aggregated selection of "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Aggregate = {
  __typename?: 'admin_user_parking_authority_aggregate';
  aggregate?: Maybe<Admin_User_Parking_Authority_Aggregate_Fields>;
  nodes: Array<Admin_User_Parking_Authority>;
};

export type Admin_User_Parking_Authority_Aggregate_Bool_Exp = {
  count?: InputMaybe<Admin_User_Parking_Authority_Aggregate_Bool_Exp_Count>;
};

export type Admin_User_Parking_Authority_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Admin_User_Parking_Authority_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Aggregate_Fields = {
  __typename?: 'admin_user_parking_authority_aggregate_fields';
  avg?: Maybe<Admin_User_Parking_Authority_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_User_Parking_Authority_Max_Fields>;
  min?: Maybe<Admin_User_Parking_Authority_Min_Fields>;
  stddev?: Maybe<Admin_User_Parking_Authority_Stddev_Fields>;
  stddev_pop?: Maybe<Admin_User_Parking_Authority_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Admin_User_Parking_Authority_Stddev_Samp_Fields>;
  sum?: Maybe<Admin_User_Parking_Authority_Sum_Fields>;
  var_pop?: Maybe<Admin_User_Parking_Authority_Var_Pop_Fields>;
  var_samp?: Maybe<Admin_User_Parking_Authority_Var_Samp_Fields>;
  variance?: Maybe<Admin_User_Parking_Authority_Variance_Fields>;
};


/** aggregate fields of "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_User_Parking_Authority_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Aggregate_Order_By = {
  avg?: InputMaybe<Admin_User_Parking_Authority_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Admin_User_Parking_Authority_Max_Order_By>;
  min?: InputMaybe<Admin_User_Parking_Authority_Min_Order_By>;
  stddev?: InputMaybe<Admin_User_Parking_Authority_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Admin_User_Parking_Authority_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Admin_User_Parking_Authority_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Admin_User_Parking_Authority_Sum_Order_By>;
  var_pop?: InputMaybe<Admin_User_Parking_Authority_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Admin_User_Parking_Authority_Var_Samp_Order_By>;
  variance?: InputMaybe<Admin_User_Parking_Authority_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Arr_Rel_Insert_Input = {
  data: Array<Admin_User_Parking_Authority_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Admin_User_Parking_Authority_On_Conflict>;
};

/** aggregate avg on columns */
export type Admin_User_Parking_Authority_Avg_Fields = {
  __typename?: 'admin_user_parking_authority_avg_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Avg_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "admin_user_parking_authority". All fields are combined with a logical 'AND'. */
export type Admin_User_Parking_Authority_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_User_Parking_Authority_Bool_Exp>>;
  _not?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_User_Parking_Authority_Bool_Exp>>;
  admin_user?: InputMaybe<Admin_Users_Bool_Exp>;
  admin_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin_user_parking_authority" */
export enum Admin_User_Parking_Authority_Constraint {
  /** unique or primary key constraint on columns "parking_authority_id", "admin_user_id" */
  AdminUserParkingAuthorityAdminUserIdParkingAuthorityId = 'admin_user_parking_authority_admin_user_id_parking_authority_id'
}

/** input type for incrementing numeric columns in table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Inc_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Insert_Input = {
  admin_user?: InputMaybe<Admin_Users_Obj_Rel_Insert_Input>;
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Admin_User_Parking_Authority_Max_Fields = {
  __typename?: 'admin_user_parking_authority_max_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Max_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Admin_User_Parking_Authority_Min_Fields = {
  __typename?: 'admin_user_parking_authority_min_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Min_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Mutation_Response = {
  __typename?: 'admin_user_parking_authority_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_User_Parking_Authority>;
};

/** on_conflict condition type for table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_On_Conflict = {
  constraint: Admin_User_Parking_Authority_Constraint;
  update_columns?: Array<Admin_User_Parking_Authority_Update_Column>;
  where?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
};

/** Ordering options when selecting data from "admin_user_parking_authority". */
export type Admin_User_Parking_Authority_Order_By = {
  admin_user?: InputMaybe<Admin_Users_Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** select columns of table "admin_user_parking_authority" */
export enum Admin_User_Parking_Authority_Select_Column {
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id'
}

/** input type for updating data in table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Set_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Admin_User_Parking_Authority_Stddev_Fields = {
  __typename?: 'admin_user_parking_authority_stddev_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Stddev_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Admin_User_Parking_Authority_Stddev_Pop_Fields = {
  __typename?: 'admin_user_parking_authority_stddev_pop_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Stddev_Pop_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Admin_User_Parking_Authority_Stddev_Samp_Fields = {
  __typename?: 'admin_user_parking_authority_stddev_samp_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Stddev_Samp_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_User_Parking_Authority_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_User_Parking_Authority_Stream_Cursor_Value_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Admin_User_Parking_Authority_Sum_Fields = {
  __typename?: 'admin_user_parking_authority_sum_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Sum_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** update columns of table "admin_user_parking_authority" */
export enum Admin_User_Parking_Authority_Update_Column {
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id'
}

export type Admin_User_Parking_Authority_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Admin_User_Parking_Authority_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_User_Parking_Authority_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_User_Parking_Authority_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Admin_User_Parking_Authority_Var_Pop_Fields = {
  __typename?: 'admin_user_parking_authority_var_pop_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Var_Pop_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Admin_User_Parking_Authority_Var_Samp_Fields = {
  __typename?: 'admin_user_parking_authority_var_samp_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Var_Samp_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Admin_User_Parking_Authority_Variance_Fields = {
  __typename?: 'admin_user_parking_authority_variance_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "admin_user_parking_authority" */
export type Admin_User_Parking_Authority_Variance_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "admin_users" */
export type Admin_Users = {
  __typename?: 'admin_users';
  /** An array relationship */
  admin_user_parking_authorities: Array<Admin_User_Parking_Authority>;
  /** An aggregate relationship */
  admin_user_parking_authorities_aggregate: Admin_User_Parking_Authority_Aggregate;
  auth0_username?: Maybe<Scalars['String']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  identities: Array<Identities>;
  /** An aggregate relationship */
  identities_aggregate: Identities_Aggregate;
  is_admin: Scalars['Boolean']['output'];
  is_approved: Scalars['Boolean']['output'];
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  pending_deletion_at?: Maybe<Scalars['timestamp']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  reports: Array<Reports>;
  /** An aggregate relationship */
  reports_aggregate: Reports_Aggregate;
  terms_of_service_last_accepted?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "admin_users" */
export type Admin_UsersAdmin_User_Parking_AuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<Admin_User_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_User_Parking_Authority_Order_By>>;
  where?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
};


/** columns and relationships of "admin_users" */
export type Admin_UsersAdmin_User_Parking_Authorities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_User_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_User_Parking_Authority_Order_By>>;
  where?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
};


/** columns and relationships of "admin_users" */
export type Admin_UsersIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


/** columns and relationships of "admin_users" */
export type Admin_UsersIdentities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


/** columns and relationships of "admin_users" */
export type Admin_UsersReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** columns and relationships of "admin_users" */
export type Admin_UsersReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};

/** aggregated selection of "admin_users" */
export type Admin_Users_Aggregate = {
  __typename?: 'admin_users_aggregate';
  aggregate?: Maybe<Admin_Users_Aggregate_Fields>;
  nodes: Array<Admin_Users>;
};

/** aggregate fields of "admin_users" */
export type Admin_Users_Aggregate_Fields = {
  __typename?: 'admin_users_aggregate_fields';
  avg?: Maybe<Admin_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_Users_Max_Fields>;
  min?: Maybe<Admin_Users_Min_Fields>;
  stddev?: Maybe<Admin_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Admin_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Admin_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Admin_Users_Sum_Fields>;
  var_pop?: Maybe<Admin_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Admin_Users_Var_Samp_Fields>;
  variance?: Maybe<Admin_Users_Variance_Fields>;
};


/** aggregate fields of "admin_users" */
export type Admin_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Admin_Users_Avg_Fields = {
  __typename?: 'admin_users_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "admin_users". All fields are combined with a logical 'AND'. */
export type Admin_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Users_Bool_Exp>>;
  _not?: InputMaybe<Admin_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Users_Bool_Exp>>;
  admin_user_parking_authorities?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
  admin_user_parking_authorities_aggregate?: InputMaybe<Admin_User_Parking_Authority_Aggregate_Bool_Exp>;
  auth0_username?: InputMaybe<String_Comparison_Exp>;
  cognito_identity_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  identities?: InputMaybe<Identities_Bool_Exp>;
  identities_aggregate?: InputMaybe<Identities_Aggregate_Bool_Exp>;
  is_admin?: InputMaybe<Boolean_Comparison_Exp>;
  is_approved?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_login_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  num_etl_failures?: InputMaybe<Smallint_Comparison_Exp>;
  num_etls?: InputMaybe<Bigint_Comparison_Exp>;
  pending_deletion_at?: InputMaybe<Timestamp_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  reports?: InputMaybe<Reports_Bool_Exp>;
  reports_aggregate?: InputMaybe<Reports_Aggregate_Bool_Exp>;
  terms_of_service_last_accepted?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin_users" */
export enum Admin_Users_Constraint {
  /** unique or primary key constraint on columns "auth0_username" */
  AdminUsersAuth0UsernameUnique = 'admin_users_auth0_username_unique',
  /** unique or primary key constraint on columns "cognito_identity_id" */
  AdminUsersCognitoIdentityIdUnique = 'admin_users_cognito_identity_id_unique',
  /** unique or primary key constraint on columns "email" */
  AdminUsersEmailUnique = 'admin_users_email_unique',
  /** unique or primary key constraint on columns "phone_number" */
  AdminUsersPhoneNumberUnique = 'admin_users_phone_number_unique',
  /** unique or primary key constraint on columns "id" */
  AdminUsersPkey = 'admin_users_pkey'
}

/** input type for incrementing numeric columns in table "admin_users" */
export type Admin_Users_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "admin_users" */
export type Admin_Users_Insert_Input = {
  admin_user_parking_authorities?: InputMaybe<Admin_User_Parking_Authority_Arr_Rel_Insert_Input>;
  auth0_username?: InputMaybe<Scalars['String']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  identities?: InputMaybe<Identities_Arr_Rel_Insert_Input>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  pending_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  reports?: InputMaybe<Reports_Arr_Rel_Insert_Input>;
  terms_of_service_last_accepted?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Admin_Users_Max_Fields = {
  __typename?: 'admin_users_max_fields';
  auth0_username?: Maybe<Scalars['String']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  pending_deletion_at?: Maybe<Scalars['timestamp']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  terms_of_service_last_accepted?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Admin_Users_Min_Fields = {
  __typename?: 'admin_users_min_fields';
  auth0_username?: Maybe<Scalars['String']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  pending_deletion_at?: Maybe<Scalars['timestamp']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  terms_of_service_last_accepted?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "admin_users" */
export type Admin_Users_Mutation_Response = {
  __typename?: 'admin_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Users>;
};

/** input type for inserting object relation for remote table "admin_users" */
export type Admin_Users_Obj_Rel_Insert_Input = {
  data: Admin_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Admin_Users_On_Conflict>;
};

/** on_conflict condition type for table "admin_users" */
export type Admin_Users_On_Conflict = {
  constraint: Admin_Users_Constraint;
  update_columns?: Array<Admin_Users_Update_Column>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "admin_users". */
export type Admin_Users_Order_By = {
  admin_user_parking_authorities_aggregate?: InputMaybe<Admin_User_Parking_Authority_Aggregate_Order_By>;
  auth0_username?: InputMaybe<Order_By>;
  cognito_identity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identities_aggregate?: InputMaybe<Identities_Aggregate_Order_By>;
  is_admin?: InputMaybe<Order_By>;
  is_approved?: InputMaybe<Order_By>;
  last_active_at?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_login_at?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  pending_deletion_at?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  reports_aggregate?: InputMaybe<Reports_Aggregate_Order_By>;
  terms_of_service_last_accepted?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin_users */
export type Admin_Users_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "admin_users" */
export enum Admin_Users_Select_Column {
  /** column name */
  Auth0Username = 'auth0_username',
  /** column name */
  CognitoIdentityId = 'cognito_identity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastLoginAt = 'last_login_at',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  PendingDeletionAt = 'pending_deletion_at',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TermsOfServiceLastAccepted = 'terms_of_service_last_accepted',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "admin_users" */
export type Admin_Users_Set_Input = {
  auth0_username?: InputMaybe<Scalars['String']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  pending_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  terms_of_service_last_accepted?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Admin_Users_Stddev_Fields = {
  __typename?: 'admin_users_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Admin_Users_Stddev_Pop_Fields = {
  __typename?: 'admin_users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Admin_Users_Stddev_Samp_Fields = {
  __typename?: 'admin_users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "admin_users" */
export type Admin_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Users_Stream_Cursor_Value_Input = {
  auth0_username?: InputMaybe<Scalars['String']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  pending_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  terms_of_service_last_accepted?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Admin_Users_Sum_Fields = {
  __typename?: 'admin_users_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "admin_users" */
export enum Admin_Users_Update_Column {
  /** column name */
  Auth0Username = 'auth0_username',
  /** column name */
  CognitoIdentityId = 'cognito_identity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastLoginAt = 'last_login_at',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  PendingDeletionAt = 'pending_deletion_at',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TermsOfServiceLastAccepted = 'terms_of_service_last_accepted',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Admin_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Admin_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Admin_Users_Var_Pop_Fields = {
  __typename?: 'admin_users_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Admin_Users_Var_Samp_Fields = {
  __typename?: 'admin_users_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Admin_Users_Variance_Fields = {
  __typename?: 'admin_users_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "ads" */
export type Ads = {
  __typename?: 'ads';
  /** An object relationship */
  ad_campaign?: Maybe<Ad_Campaigns>;
  ad_campaign_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  ad_variants: Array<Ad_Variants>;
  /** An aggregate relationship */
  ad_variants_aggregate: Ad_Variants_Aggregate;
  budget: Scalars['Int']['output'];
  budget_interval?: Maybe<Scalars['String']['output']>;
  clicks: Scalars['float8']['output'];
  cpm: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day_overburn_rate: Scalars['float8']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  enabled: Scalars['Boolean']['output'];
  end_date?: Maybe<Scalars['timestamp']['output']>;
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  fallback_distribution: Scalars['float8']['output'];
  hour_overburn_rate: Scalars['float8']['output'];
  id: Scalars['bigint']['output'];
  idempotent_key: Scalars['uuid']['output'];
  impressions_goal: Scalars['float8']['output'];
  impressions_served: Scalars['float8']['output'];
  is_fallback: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  short_name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
  timezone: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "ads" */
export type AdsAd_VariantsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Variants_Order_By>>;
  where?: InputMaybe<Ad_Variants_Bool_Exp>;
};


/** columns and relationships of "ads" */
export type AdsAd_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Variants_Order_By>>;
  where?: InputMaybe<Ad_Variants_Bool_Exp>;
};

/** aggregated selection of "ads" */
export type Ads_Aggregate = {
  __typename?: 'ads_aggregate';
  aggregate?: Maybe<Ads_Aggregate_Fields>;
  nodes: Array<Ads>;
};

export type Ads_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Ads_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Ads_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ads_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Ads_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Ads_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Ads_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Ads_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Ads_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Ads_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Ads_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Ads_Aggregate_Bool_Exp_Var_Samp>;
};

export type Ads_Aggregate_Bool_Exp_Avg = {
  arguments: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ads_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ads_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ads_Aggregate_Bool_Exp_Corr = {
  arguments: Ads_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ads_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Ads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Ads_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Ads_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ads_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Ads_Aggregate_Bool_Exp_Max = {
  arguments: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ads_Aggregate_Bool_Exp_Min = {
  arguments: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ads_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ads_Aggregate_Bool_Exp_Sum = {
  arguments: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Ads_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Ads_Select_Column_Ads_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "ads" */
export type Ads_Aggregate_Fields = {
  __typename?: 'ads_aggregate_fields';
  avg?: Maybe<Ads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ads_Max_Fields>;
  min?: Maybe<Ads_Min_Fields>;
  stddev?: Maybe<Ads_Stddev_Fields>;
  stddev_pop?: Maybe<Ads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ads_Stddev_Samp_Fields>;
  sum?: Maybe<Ads_Sum_Fields>;
  var_pop?: Maybe<Ads_Var_Pop_Fields>;
  var_samp?: Maybe<Ads_Var_Samp_Fields>;
  variance?: Maybe<Ads_Variance_Fields>;
};


/** aggregate fields of "ads" */
export type Ads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ads" */
export type Ads_Aggregate_Order_By = {
  avg?: InputMaybe<Ads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ads_Max_Order_By>;
  min?: InputMaybe<Ads_Min_Order_By>;
  stddev?: InputMaybe<Ads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ads_Sum_Order_By>;
  var_pop?: InputMaybe<Ads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ads_Var_Samp_Order_By>;
  variance?: InputMaybe<Ads_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ads" */
export type Ads_Arr_Rel_Insert_Input = {
  data: Array<Ads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ads_On_Conflict>;
};

/** aggregate avg on columns */
export type Ads_Avg_Fields = {
  __typename?: 'ads_avg_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  cpm?: Maybe<Scalars['Float']['output']>;
  day_overburn_rate?: Maybe<Scalars['Float']['output']>;
  fallback_distribution?: Maybe<Scalars['Float']['output']>;
  hour_overburn_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ads" */
export type Ads_Avg_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ads". All fields are combined with a logical 'AND'. */
export type Ads_Bool_Exp = {
  _and?: InputMaybe<Array<Ads_Bool_Exp>>;
  _not?: InputMaybe<Ads_Bool_Exp>;
  _or?: InputMaybe<Array<Ads_Bool_Exp>>;
  ad_campaign?: InputMaybe<Ad_Campaigns_Bool_Exp>;
  ad_campaign_id?: InputMaybe<Bigint_Comparison_Exp>;
  ad_variants?: InputMaybe<Ad_Variants_Bool_Exp>;
  ad_variants_aggregate?: InputMaybe<Ad_Variants_Aggregate_Bool_Exp>;
  budget?: InputMaybe<Int_Comparison_Exp>;
  budget_interval?: InputMaybe<String_Comparison_Exp>;
  clicks?: InputMaybe<Float8_Comparison_Exp>;
  cpm?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  day_overburn_rate?: InputMaybe<Float8_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  end_date?: InputMaybe<Timestamp_Comparison_Exp>;
  ended_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fallback_distribution?: InputMaybe<Float8_Comparison_Exp>;
  hour_overburn_rate?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  impressions_goal?: InputMaybe<Float8_Comparison_Exp>;
  impressions_served?: InputMaybe<Float8_Comparison_Exp>;
  is_fallback?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Timestamp_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "ads" */
export enum Ads_Constraint {
  /** unique or primary key constraint on columns "idempotent_key" */
  AdsIdempotentKeyUnique = 'ads_idempotent_key_unique',
  /** unique or primary key constraint on columns "id" */
  AdsPkey = 'ads_pkey'
}

/** input type for incrementing numeric columns in table "ads" */
export type Ads_Inc_Input = {
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  clicks?: InputMaybe<Scalars['float8']['input']>;
  cpm?: InputMaybe<Scalars['Int']['input']>;
  day_overburn_rate?: InputMaybe<Scalars['float8']['input']>;
  fallback_distribution?: InputMaybe<Scalars['float8']['input']>;
  hour_overburn_rate?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  impressions_goal?: InputMaybe<Scalars['float8']['input']>;
  impressions_served?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "ads" */
export type Ads_Insert_Input = {
  ad_campaign?: InputMaybe<Ad_Campaigns_Obj_Rel_Insert_Input>;
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  ad_variants?: InputMaybe<Ad_Variants_Arr_Rel_Insert_Input>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_interval?: InputMaybe<Scalars['String']['input']>;
  clicks?: InputMaybe<Scalars['float8']['input']>;
  cpm?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day_overburn_rate?: InputMaybe<Scalars['float8']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  fallback_distribution?: InputMaybe<Scalars['float8']['input']>;
  hour_overburn_rate?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  impressions_goal?: InputMaybe<Scalars['float8']['input']>;
  impressions_served?: InputMaybe<Scalars['float8']['input']>;
  is_fallback?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Ads_Max_Fields = {
  __typename?: 'ads_max_fields';
  ad_campaign_id?: Maybe<Scalars['bigint']['output']>;
  budget?: Maybe<Scalars['Int']['output']>;
  budget_interval?: Maybe<Scalars['String']['output']>;
  clicks?: Maybe<Scalars['float8']['output']>;
  cpm?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day_overburn_rate?: Maybe<Scalars['float8']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  end_date?: Maybe<Scalars['timestamp']['output']>;
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  fallback_distribution?: Maybe<Scalars['float8']['output']>;
  hour_overburn_rate?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  impressions_goal?: Maybe<Scalars['float8']['output']>;
  impressions_served?: Maybe<Scalars['float8']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "ads" */
export type Ads_Max_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  budget_interval?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ads_Min_Fields = {
  __typename?: 'ads_min_fields';
  ad_campaign_id?: Maybe<Scalars['bigint']['output']>;
  budget?: Maybe<Scalars['Int']['output']>;
  budget_interval?: Maybe<Scalars['String']['output']>;
  clicks?: Maybe<Scalars['float8']['output']>;
  cpm?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day_overburn_rate?: Maybe<Scalars['float8']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  end_date?: Maybe<Scalars['timestamp']['output']>;
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  fallback_distribution?: Maybe<Scalars['float8']['output']>;
  hour_overburn_rate?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  impressions_goal?: Maybe<Scalars['float8']['output']>;
  impressions_served?: Maybe<Scalars['float8']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "ads" */
export type Ads_Min_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  budget_interval?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ads" */
export type Ads_Mutation_Response = {
  __typename?: 'ads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ads>;
};

/** input type for inserting object relation for remote table "ads" */
export type Ads_Obj_Rel_Insert_Input = {
  data: Ads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ads_On_Conflict>;
};

/** on_conflict condition type for table "ads" */
export type Ads_On_Conflict = {
  constraint: Ads_Constraint;
  update_columns?: Array<Ads_Update_Column>;
  where?: InputMaybe<Ads_Bool_Exp>;
};

/** Ordering options when selecting data from "ads". */
export type Ads_Order_By = {
  ad_campaign?: InputMaybe<Ad_Campaigns_Order_By>;
  ad_campaign_id?: InputMaybe<Order_By>;
  ad_variants_aggregate?: InputMaybe<Ad_Variants_Aggregate_Order_By>;
  budget?: InputMaybe<Order_By>;
  budget_interval?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
  is_fallback?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ads */
export type Ads_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "ads" */
export enum Ads_Select_Column {
  /** column name */
  AdCampaignId = 'ad_campaign_id',
  /** column name */
  Budget = 'budget',
  /** column name */
  BudgetInterval = 'budget_interval',
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Cpm = 'cpm',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayOverburnRate = 'day_overburn_rate',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  FallbackDistribution = 'fallback_distribution',
  /** column name */
  HourOverburnRate = 'hour_overburn_rate',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  IsFallback = 'is_fallback',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "ads_aggregate_bool_exp_avg_arguments_columns" columns of table "ads" */
export enum Ads_Select_Column_Ads_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  DayOverburnRate = 'day_overburn_rate',
  /** column name */
  FallbackDistribution = 'fallback_distribution',
  /** column name */
  HourOverburnRate = 'hour_overburn_rate',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served'
}

/** select "ads_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ads" */
export enum Ads_Select_Column_Ads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsFallback = 'is_fallback'
}

/** select "ads_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ads" */
export enum Ads_Select_Column_Ads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  IsFallback = 'is_fallback'
}

/** select "ads_aggregate_bool_exp_corr_arguments_columns" columns of table "ads" */
export enum Ads_Select_Column_Ads_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  DayOverburnRate = 'day_overburn_rate',
  /** column name */
  FallbackDistribution = 'fallback_distribution',
  /** column name */
  HourOverburnRate = 'hour_overburn_rate',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served'
}

/** select "ads_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "ads" */
export enum Ads_Select_Column_Ads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  DayOverburnRate = 'day_overburn_rate',
  /** column name */
  FallbackDistribution = 'fallback_distribution',
  /** column name */
  HourOverburnRate = 'hour_overburn_rate',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served'
}

/** select "ads_aggregate_bool_exp_max_arguments_columns" columns of table "ads" */
export enum Ads_Select_Column_Ads_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  DayOverburnRate = 'day_overburn_rate',
  /** column name */
  FallbackDistribution = 'fallback_distribution',
  /** column name */
  HourOverburnRate = 'hour_overburn_rate',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served'
}

/** select "ads_aggregate_bool_exp_min_arguments_columns" columns of table "ads" */
export enum Ads_Select_Column_Ads_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  DayOverburnRate = 'day_overburn_rate',
  /** column name */
  FallbackDistribution = 'fallback_distribution',
  /** column name */
  HourOverburnRate = 'hour_overburn_rate',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served'
}

/** select "ads_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "ads" */
export enum Ads_Select_Column_Ads_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  DayOverburnRate = 'day_overburn_rate',
  /** column name */
  FallbackDistribution = 'fallback_distribution',
  /** column name */
  HourOverburnRate = 'hour_overburn_rate',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served'
}

/** select "ads_aggregate_bool_exp_sum_arguments_columns" columns of table "ads" */
export enum Ads_Select_Column_Ads_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  DayOverburnRate = 'day_overburn_rate',
  /** column name */
  FallbackDistribution = 'fallback_distribution',
  /** column name */
  HourOverburnRate = 'hour_overburn_rate',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served'
}

/** select "ads_aggregate_bool_exp_var_samp_arguments_columns" columns of table "ads" */
export enum Ads_Select_Column_Ads_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Clicks = 'clicks',
  /** column name */
  DayOverburnRate = 'day_overburn_rate',
  /** column name */
  FallbackDistribution = 'fallback_distribution',
  /** column name */
  HourOverburnRate = 'hour_overburn_rate',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served'
}

/** input type for updating data in table "ads" */
export type Ads_Set_Input = {
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_interval?: InputMaybe<Scalars['String']['input']>;
  clicks?: InputMaybe<Scalars['float8']['input']>;
  cpm?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day_overburn_rate?: InputMaybe<Scalars['float8']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  fallback_distribution?: InputMaybe<Scalars['float8']['input']>;
  hour_overburn_rate?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  impressions_goal?: InputMaybe<Scalars['float8']['input']>;
  impressions_served?: InputMaybe<Scalars['float8']['input']>;
  is_fallback?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Ads_Stddev_Fields = {
  __typename?: 'ads_stddev_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  cpm?: Maybe<Scalars['Float']['output']>;
  day_overburn_rate?: Maybe<Scalars['Float']['output']>;
  fallback_distribution?: Maybe<Scalars['Float']['output']>;
  hour_overburn_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ads" */
export type Ads_Stddev_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ads_Stddev_Pop_Fields = {
  __typename?: 'ads_stddev_pop_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  cpm?: Maybe<Scalars['Float']['output']>;
  day_overburn_rate?: Maybe<Scalars['Float']['output']>;
  fallback_distribution?: Maybe<Scalars['Float']['output']>;
  hour_overburn_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ads" */
export type Ads_Stddev_Pop_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ads_Stddev_Samp_Fields = {
  __typename?: 'ads_stddev_samp_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  cpm?: Maybe<Scalars['Float']['output']>;
  day_overburn_rate?: Maybe<Scalars['Float']['output']>;
  fallback_distribution?: Maybe<Scalars['Float']['output']>;
  hour_overburn_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ads" */
export type Ads_Stddev_Samp_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ads" */
export type Ads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ads_Stream_Cursor_Value_Input = {
  ad_campaign_id?: InputMaybe<Scalars['bigint']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_interval?: InputMaybe<Scalars['String']['input']>;
  clicks?: InputMaybe<Scalars['float8']['input']>;
  cpm?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day_overburn_rate?: InputMaybe<Scalars['float8']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  fallback_distribution?: InputMaybe<Scalars['float8']['input']>;
  hour_overburn_rate?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  impressions_goal?: InputMaybe<Scalars['float8']['input']>;
  impressions_served?: InputMaybe<Scalars['float8']['input']>;
  is_fallback?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Ads_Sum_Fields = {
  __typename?: 'ads_sum_fields';
  ad_campaign_id?: Maybe<Scalars['bigint']['output']>;
  budget?: Maybe<Scalars['Int']['output']>;
  clicks?: Maybe<Scalars['float8']['output']>;
  cpm?: Maybe<Scalars['Int']['output']>;
  day_overburn_rate?: Maybe<Scalars['float8']['output']>;
  fallback_distribution?: Maybe<Scalars['float8']['output']>;
  hour_overburn_rate?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  impressions_goal?: Maybe<Scalars['float8']['output']>;
  impressions_served?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "ads" */
export type Ads_Sum_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
};

/** update columns of table "ads" */
export enum Ads_Update_Column {
  /** column name */
  AdCampaignId = 'ad_campaign_id',
  /** column name */
  Budget = 'budget',
  /** column name */
  BudgetInterval = 'budget_interval',
  /** column name */
  Clicks = 'clicks',
  /** column name */
  Cpm = 'cpm',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayOverburnRate = 'day_overburn_rate',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  FallbackDistribution = 'fallback_distribution',
  /** column name */
  HourOverburnRate = 'hour_overburn_rate',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  ImpressionsGoal = 'impressions_goal',
  /** column name */
  ImpressionsServed = 'impressions_served',
  /** column name */
  IsFallback = 'is_fallback',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ads_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ads_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ads_Var_Pop_Fields = {
  __typename?: 'ads_var_pop_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  cpm?: Maybe<Scalars['Float']['output']>;
  day_overburn_rate?: Maybe<Scalars['Float']['output']>;
  fallback_distribution?: Maybe<Scalars['Float']['output']>;
  hour_overburn_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ads" */
export type Ads_Var_Pop_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ads_Var_Samp_Fields = {
  __typename?: 'ads_var_samp_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  cpm?: Maybe<Scalars['Float']['output']>;
  day_overburn_rate?: Maybe<Scalars['Float']['output']>;
  fallback_distribution?: Maybe<Scalars['Float']['output']>;
  hour_overburn_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ads" */
export type Ads_Var_Samp_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ads_Variance_Fields = {
  __typename?: 'ads_variance_fields';
  ad_campaign_id?: Maybe<Scalars['Float']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  cpm?: Maybe<Scalars['Float']['output']>;
  day_overburn_rate?: Maybe<Scalars['Float']['output']>;
  fallback_distribution?: Maybe<Scalars['Float']['output']>;
  hour_overburn_rate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  impressions_goal?: Maybe<Scalars['Float']['output']>;
  impressions_served?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ads" */
export type Ads_Variance_Order_By = {
  ad_campaign_id?: InputMaybe<Order_By>;
  budget?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  day_overburn_rate?: InputMaybe<Order_By>;
  fallback_distribution?: InputMaybe<Order_By>;
  hour_overburn_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impressions_goal?: InputMaybe<Order_By>;
  impressions_served?: InputMaybe<Order_By>;
};

/** columns and relationships of "batch_sets" */
export type Batch_Sets = {
  __typename?: 'batch_sets';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  payment_batches: Array<Payment_Batches>;
  /** An aggregate relationship */
  payment_batches_aggregate: Payment_Batches_Aggregate;
  /** An object relationship */
  rPaymentBatches?: Maybe<R_Payment_Batches>;
  /** An object relationship */
  rTransferBatches?: Maybe<R_Transfer_Batches>;
  status: Scalars['String']['output'];
  /** An array relationship */
  transfer_batches: Array<Transfer_Batches>;
  /** An aggregate relationship */
  transfer_batches_aggregate: Transfer_Batches_Aggregate;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "batch_sets" */
export type Batch_SetsPayment_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


/** columns and relationships of "batch_sets" */
export type Batch_SetsPayment_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


/** columns and relationships of "batch_sets" */
export type Batch_SetsTransfer_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transfer_Batches_Order_By>>;
  where?: InputMaybe<Transfer_Batches_Bool_Exp>;
};


/** columns and relationships of "batch_sets" */
export type Batch_SetsTransfer_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transfer_Batches_Order_By>>;
  where?: InputMaybe<Transfer_Batches_Bool_Exp>;
};

/** aggregated selection of "batch_sets" */
export type Batch_Sets_Aggregate = {
  __typename?: 'batch_sets_aggregate';
  aggregate?: Maybe<Batch_Sets_Aggregate_Fields>;
  nodes: Array<Batch_Sets>;
};

/** aggregate fields of "batch_sets" */
export type Batch_Sets_Aggregate_Fields = {
  __typename?: 'batch_sets_aggregate_fields';
  avg?: Maybe<Batch_Sets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Batch_Sets_Max_Fields>;
  min?: Maybe<Batch_Sets_Min_Fields>;
  stddev?: Maybe<Batch_Sets_Stddev_Fields>;
  stddev_pop?: Maybe<Batch_Sets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Batch_Sets_Stddev_Samp_Fields>;
  sum?: Maybe<Batch_Sets_Sum_Fields>;
  var_pop?: Maybe<Batch_Sets_Var_Pop_Fields>;
  var_samp?: Maybe<Batch_Sets_Var_Samp_Fields>;
  variance?: Maybe<Batch_Sets_Variance_Fields>;
};


/** aggregate fields of "batch_sets" */
export type Batch_Sets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Batch_Sets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Batch_Sets_Avg_Fields = {
  __typename?: 'batch_sets_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "batch_sets". All fields are combined with a logical 'AND'. */
export type Batch_Sets_Bool_Exp = {
  _and?: InputMaybe<Array<Batch_Sets_Bool_Exp>>;
  _not?: InputMaybe<Batch_Sets_Bool_Exp>;
  _or?: InputMaybe<Array<Batch_Sets_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_batches?: InputMaybe<Payment_Batches_Bool_Exp>;
  payment_batches_aggregate?: InputMaybe<Payment_Batches_Aggregate_Bool_Exp>;
  rPaymentBatches?: InputMaybe<R_Payment_Batches_Bool_Exp>;
  rTransferBatches?: InputMaybe<R_Transfer_Batches_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  transfer_batches?: InputMaybe<Transfer_Batches_Bool_Exp>;
  transfer_batches_aggregate?: InputMaybe<Transfer_Batches_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "batch_sets" */
export enum Batch_Sets_Constraint {
  /** unique or primary key constraint on columns "id" */
  BatchSetsPkey = 'batch_sets_pkey'
}

/** input type for incrementing numeric columns in table "batch_sets" */
export type Batch_Sets_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "batch_sets" */
export type Batch_Sets_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batches?: InputMaybe<Payment_Batches_Arr_Rel_Insert_Input>;
  rPaymentBatches?: InputMaybe<R_Payment_Batches_Obj_Rel_Insert_Input>;
  rTransferBatches?: InputMaybe<R_Transfer_Batches_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_batches?: InputMaybe<Transfer_Batches_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Batch_Sets_Max_Fields = {
  __typename?: 'batch_sets_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Batch_Sets_Min_Fields = {
  __typename?: 'batch_sets_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "batch_sets" */
export type Batch_Sets_Mutation_Response = {
  __typename?: 'batch_sets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Batch_Sets>;
};

/** input type for inserting object relation for remote table "batch_sets" */
export type Batch_Sets_Obj_Rel_Insert_Input = {
  data: Batch_Sets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Batch_Sets_On_Conflict>;
};

/** on_conflict condition type for table "batch_sets" */
export type Batch_Sets_On_Conflict = {
  constraint: Batch_Sets_Constraint;
  update_columns?: Array<Batch_Sets_Update_Column>;
  where?: InputMaybe<Batch_Sets_Bool_Exp>;
};

/** Ordering options when selecting data from "batch_sets". */
export type Batch_Sets_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_batches_aggregate?: InputMaybe<Payment_Batches_Aggregate_Order_By>;
  rPaymentBatches?: InputMaybe<R_Payment_Batches_Order_By>;
  rTransferBatches?: InputMaybe<R_Transfer_Batches_Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_batches_aggregate?: InputMaybe<Transfer_Batches_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: batch_sets */
export type Batch_Sets_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "batch_sets" */
export enum Batch_Sets_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "batch_sets" */
export type Batch_Sets_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Batch_Sets_Stddev_Fields = {
  __typename?: 'batch_sets_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Batch_Sets_Stddev_Pop_Fields = {
  __typename?: 'batch_sets_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Batch_Sets_Stddev_Samp_Fields = {
  __typename?: 'batch_sets_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "batch_sets" */
export type Batch_Sets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Batch_Sets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Batch_Sets_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Batch_Sets_Sum_Fields = {
  __typename?: 'batch_sets_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "batch_sets" */
export enum Batch_Sets_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Batch_Sets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Batch_Sets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Batch_Sets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Batch_Sets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Batch_Sets_Var_Pop_Fields = {
  __typename?: 'batch_sets_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Batch_Sets_Var_Samp_Fields = {
  __typename?: 'batch_sets_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Batch_Sets_Variance_Fields = {
  __typename?: 'batch_sets_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "blacklisted_credentials" */
export type Blacklisted_Credentials = {
  __typename?: 'blacklisted_credentials';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  credential: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "blacklisted_credentials" */
export type Blacklisted_Credentials_Aggregate = {
  __typename?: 'blacklisted_credentials_aggregate';
  aggregate?: Maybe<Blacklisted_Credentials_Aggregate_Fields>;
  nodes: Array<Blacklisted_Credentials>;
};

export type Blacklisted_Credentials_Aggregate_Bool_Exp = {
  count?: InputMaybe<Blacklisted_Credentials_Aggregate_Bool_Exp_Count>;
};

export type Blacklisted_Credentials_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Blacklisted_Credentials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "blacklisted_credentials" */
export type Blacklisted_Credentials_Aggregate_Fields = {
  __typename?: 'blacklisted_credentials_aggregate_fields';
  avg?: Maybe<Blacklisted_Credentials_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Blacklisted_Credentials_Max_Fields>;
  min?: Maybe<Blacklisted_Credentials_Min_Fields>;
  stddev?: Maybe<Blacklisted_Credentials_Stddev_Fields>;
  stddev_pop?: Maybe<Blacklisted_Credentials_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Blacklisted_Credentials_Stddev_Samp_Fields>;
  sum?: Maybe<Blacklisted_Credentials_Sum_Fields>;
  var_pop?: Maybe<Blacklisted_Credentials_Var_Pop_Fields>;
  var_samp?: Maybe<Blacklisted_Credentials_Var_Samp_Fields>;
  variance?: Maybe<Blacklisted_Credentials_Variance_Fields>;
};


/** aggregate fields of "blacklisted_credentials" */
export type Blacklisted_Credentials_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Blacklisted_Credentials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Aggregate_Order_By = {
  avg?: InputMaybe<Blacklisted_Credentials_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Blacklisted_Credentials_Max_Order_By>;
  min?: InputMaybe<Blacklisted_Credentials_Min_Order_By>;
  stddev?: InputMaybe<Blacklisted_Credentials_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Blacklisted_Credentials_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Blacklisted_Credentials_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Blacklisted_Credentials_Sum_Order_By>;
  var_pop?: InputMaybe<Blacklisted_Credentials_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Blacklisted_Credentials_Var_Samp_Order_By>;
  variance?: InputMaybe<Blacklisted_Credentials_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "blacklisted_credentials" */
export type Blacklisted_Credentials_Arr_Rel_Insert_Input = {
  data: Array<Blacklisted_Credentials_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Blacklisted_Credentials_On_Conflict>;
};

/** aggregate avg on columns */
export type Blacklisted_Credentials_Avg_Fields = {
  __typename?: 'blacklisted_credentials_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "blacklisted_credentials". All fields are combined with a logical 'AND'. */
export type Blacklisted_Credentials_Bool_Exp = {
  _and?: InputMaybe<Array<Blacklisted_Credentials_Bool_Exp>>;
  _not?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
  _or?: InputMaybe<Array<Blacklisted_Credentials_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  credential?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "blacklisted_credentials" */
export enum Blacklisted_Credentials_Constraint {
  /** unique or primary key constraint on columns "id" */
  BlacklistedCredentialsPkey = 'blacklisted_credentials_pkey'
}

/** input type for incrementing numeric columns in table "blacklisted_credentials" */
export type Blacklisted_Credentials_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "blacklisted_credentials" */
export type Blacklisted_Credentials_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  credential?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Blacklisted_Credentials_Max_Fields = {
  __typename?: 'blacklisted_credentials_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credential?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Blacklisted_Credentials_Min_Fields = {
  __typename?: 'blacklisted_credentials_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credential?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "blacklisted_credentials" */
export type Blacklisted_Credentials_Mutation_Response = {
  __typename?: 'blacklisted_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Blacklisted_Credentials>;
};

/** on_conflict condition type for table "blacklisted_credentials" */
export type Blacklisted_Credentials_On_Conflict = {
  constraint: Blacklisted_Credentials_Constraint;
  update_columns?: Array<Blacklisted_Credentials_Update_Column>;
  where?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
};

/** Ordering options when selecting data from "blacklisted_credentials". */
export type Blacklisted_Credentials_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credential?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: blacklisted_credentials */
export type Blacklisted_Credentials_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "blacklisted_credentials" */
export enum Blacklisted_Credentials_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credential = 'credential',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "blacklisted_credentials" */
export type Blacklisted_Credentials_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  credential?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Blacklisted_Credentials_Stddev_Fields = {
  __typename?: 'blacklisted_credentials_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Blacklisted_Credentials_Stddev_Pop_Fields = {
  __typename?: 'blacklisted_credentials_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Blacklisted_Credentials_Stddev_Samp_Fields = {
  __typename?: 'blacklisted_credentials_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "blacklisted_credentials" */
export type Blacklisted_Credentials_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Blacklisted_Credentials_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Blacklisted_Credentials_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  credential?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Blacklisted_Credentials_Sum_Fields = {
  __typename?: 'blacklisted_credentials_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "blacklisted_credentials" */
export enum Blacklisted_Credentials_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credential = 'credential',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Blacklisted_Credentials_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Blacklisted_Credentials_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Blacklisted_Credentials_Set_Input>;
  /** filter the rows which have to be updated */
  where: Blacklisted_Credentials_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Blacklisted_Credentials_Var_Pop_Fields = {
  __typename?: 'blacklisted_credentials_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Blacklisted_Credentials_Var_Samp_Fields = {
  __typename?: 'blacklisted_credentials_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Blacklisted_Credentials_Variance_Fields = {
  __typename?: 'blacklisted_credentials_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "blacklisted_credentials" */
export type Blacklisted_Credentials_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "device_user" */
export type Device_User = {
  __typename?: 'device_user';
  /** An object relationship */
  device: Devices;
  device_id: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "device_user" */
export type Device_User_Aggregate = {
  __typename?: 'device_user_aggregate';
  aggregate?: Maybe<Device_User_Aggregate_Fields>;
  nodes: Array<Device_User>;
};

export type Device_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Device_User_Aggregate_Bool_Exp_Count>;
};

export type Device_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Device_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Device_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "device_user" */
export type Device_User_Aggregate_Fields = {
  __typename?: 'device_user_aggregate_fields';
  avg?: Maybe<Device_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Device_User_Max_Fields>;
  min?: Maybe<Device_User_Min_Fields>;
  stddev?: Maybe<Device_User_Stddev_Fields>;
  stddev_pop?: Maybe<Device_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Device_User_Stddev_Samp_Fields>;
  sum?: Maybe<Device_User_Sum_Fields>;
  var_pop?: Maybe<Device_User_Var_Pop_Fields>;
  var_samp?: Maybe<Device_User_Var_Samp_Fields>;
  variance?: Maybe<Device_User_Variance_Fields>;
};


/** aggregate fields of "device_user" */
export type Device_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Device_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "device_user" */
export type Device_User_Aggregate_Order_By = {
  avg?: InputMaybe<Device_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Device_User_Max_Order_By>;
  min?: InputMaybe<Device_User_Min_Order_By>;
  stddev?: InputMaybe<Device_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Device_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Device_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Device_User_Sum_Order_By>;
  var_pop?: InputMaybe<Device_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Device_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Device_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "device_user" */
export type Device_User_Arr_Rel_Insert_Input = {
  data: Array<Device_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Device_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Device_User_Avg_Fields = {
  __typename?: 'device_user_avg_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "device_user" */
export type Device_User_Avg_Order_By = {
  device_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "device_user". All fields are combined with a logical 'AND'. */
export type Device_User_Bool_Exp = {
  _and?: InputMaybe<Array<Device_User_Bool_Exp>>;
  _not?: InputMaybe<Device_User_Bool_Exp>;
  _or?: InputMaybe<Array<Device_User_Bool_Exp>>;
  device?: InputMaybe<Devices_Bool_Exp>;
  device_id?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "device_user" */
export enum Device_User_Constraint {
  /** unique or primary key constraint on columns "user_id", "device_id" */
  DeviceUserPkey = 'device_user_pkey'
}

/** input type for incrementing numeric columns in table "device_user" */
export type Device_User_Inc_Input = {
  device_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "device_user" */
export type Device_User_Insert_Input = {
  device?: InputMaybe<Devices_Obj_Rel_Insert_Input>;
  device_id?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Device_User_Max_Fields = {
  __typename?: 'device_user_max_fields';
  device_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "device_user" */
export type Device_User_Max_Order_By = {
  device_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Device_User_Min_Fields = {
  __typename?: 'device_user_min_fields';
  device_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "device_user" */
export type Device_User_Min_Order_By = {
  device_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "device_user" */
export type Device_User_Mutation_Response = {
  __typename?: 'device_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Device_User>;
};

/** on_conflict condition type for table "device_user" */
export type Device_User_On_Conflict = {
  constraint: Device_User_Constraint;
  update_columns?: Array<Device_User_Update_Column>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};

/** Ordering options when selecting data from "device_user". */
export type Device_User_Order_By = {
  device?: InputMaybe<Devices_Order_By>;
  device_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: device_user */
export type Device_User_Pk_Columns_Input = {
  device_id: Scalars['bigint']['input'];
  user_id: Scalars['bigint']['input'];
};

/** select columns of table "device_user" */
export enum Device_User_Select_Column {
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "device_user" */
export type Device_User_Set_Input = {
  device_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Device_User_Stddev_Fields = {
  __typename?: 'device_user_stddev_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "device_user" */
export type Device_User_Stddev_Order_By = {
  device_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Device_User_Stddev_Pop_Fields = {
  __typename?: 'device_user_stddev_pop_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "device_user" */
export type Device_User_Stddev_Pop_Order_By = {
  device_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Device_User_Stddev_Samp_Fields = {
  __typename?: 'device_user_stddev_samp_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "device_user" */
export type Device_User_Stddev_Samp_Order_By = {
  device_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "device_user" */
export type Device_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Device_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Device_User_Stream_Cursor_Value_Input = {
  device_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Device_User_Sum_Fields = {
  __typename?: 'device_user_sum_fields';
  device_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "device_user" */
export type Device_User_Sum_Order_By = {
  device_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "device_user" */
export enum Device_User_Update_Column {
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  UserId = 'user_id'
}

export type Device_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Device_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Device_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Device_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Device_User_Var_Pop_Fields = {
  __typename?: 'device_user_var_pop_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "device_user" */
export type Device_User_Var_Pop_Order_By = {
  device_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Device_User_Var_Samp_Fields = {
  __typename?: 'device_user_var_samp_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "device_user" */
export type Device_User_Var_Samp_Order_By = {
  device_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Device_User_Variance_Fields = {
  __typename?: 'device_user_variance_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "device_user" */
export type Device_User_Variance_Order_By = {
  device_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "devices" */
export type Devices = {
  __typename?: 'devices';
  app_version_android_version_code?: Maybe<Scalars['String']['output']>;
  app_version_eas_update_datetime?: Maybe<Scalars['timestamp']['output']>;
  app_version_eas_update_id?: Maybe<Scalars['String']['output']>;
  app_version_human_readable?: Maybe<Scalars['String']['output']>;
  app_version_ios_build_number?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  client_id: Scalars['uuid']['output'];
  config?: Maybe<Scalars['json']['output']>;
  created_at: Scalars['timestamp']['output'];
  /** An array relationship */
  device_users: Array<Device_User>;
  /** An aggregate relationship */
  device_users_aggregate: Device_User_Aggregate;
  expo_push_token?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  ip_data?: Maybe<Scalars['json']['output']>;
  is_rooted?: Maybe<Scalars['Boolean']['output']>;
  is_side_loading_enabled?: Maybe<Scalars['Boolean']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  location_enabled?: Maybe<Scalars['Boolean']['output']>;
  location_os_permission_status?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_memory?: Maybe<Scalars['float8']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  model_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notifications_app_permission_request_status?: Maybe<Scalars['String']['output']>;
  notifications_os_permission_status?: Maybe<Scalars['String']['output']>;
  os_build_fingerprint?: Maybe<Scalars['String']['output']>;
  os_build_id?: Maybe<Scalars['String']['output']>;
  os_internal_build_id?: Maybe<Scalars['String']['output']>;
  os_name?: Maybe<Scalars['String']['output']>;
  os_version?: Maybe<Scalars['String']['output']>;
  platform_api_level?: Maybe<Scalars['String']['output']>;
  platform_features?: Maybe<Scalars['json']['output']>;
  supported_cpu_architectures?: Maybe<Scalars['json']['output']>;
  time_discrepancy?: Maybe<Scalars['Int']['output']>;
  total_memory?: Maybe<Scalars['float8']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  uptime?: Maybe<Scalars['float8']['output']>;
  year_class?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "devices" */
export type DevicesConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "devices" */
export type DevicesDevice_UsersArgs = {
  distinct_on?: InputMaybe<Array<Device_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_User_Order_By>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


/** columns and relationships of "devices" */
export type DevicesDevice_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_User_Order_By>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


/** columns and relationships of "devices" */
export type DevicesIp_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "devices" */
export type DevicesPlatform_FeaturesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "devices" */
export type DevicesSupported_Cpu_ArchitecturesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "devices" */
export type Devices_Aggregate = {
  __typename?: 'devices_aggregate';
  aggregate?: Maybe<Devices_Aggregate_Fields>;
  nodes: Array<Devices>;
};

/** aggregate fields of "devices" */
export type Devices_Aggregate_Fields = {
  __typename?: 'devices_aggregate_fields';
  avg?: Maybe<Devices_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Devices_Max_Fields>;
  min?: Maybe<Devices_Min_Fields>;
  stddev?: Maybe<Devices_Stddev_Fields>;
  stddev_pop?: Maybe<Devices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Devices_Stddev_Samp_Fields>;
  sum?: Maybe<Devices_Sum_Fields>;
  var_pop?: Maybe<Devices_Var_Pop_Fields>;
  var_samp?: Maybe<Devices_Var_Samp_Fields>;
  variance?: Maybe<Devices_Variance_Fields>;
};


/** aggregate fields of "devices" */
export type Devices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Devices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Devices_Avg_Fields = {
  __typename?: 'devices_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_memory?: Maybe<Scalars['Float']['output']>;
  time_discrepancy?: Maybe<Scalars['Float']['output']>;
  total_memory?: Maybe<Scalars['Float']['output']>;
  uptime?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "devices". All fields are combined with a logical 'AND'. */
export type Devices_Bool_Exp = {
  _and?: InputMaybe<Array<Devices_Bool_Exp>>;
  _not?: InputMaybe<Devices_Bool_Exp>;
  _or?: InputMaybe<Array<Devices_Bool_Exp>>;
  app_version_android_version_code?: InputMaybe<String_Comparison_Exp>;
  app_version_eas_update_datetime?: InputMaybe<Timestamp_Comparison_Exp>;
  app_version_eas_update_id?: InputMaybe<String_Comparison_Exp>;
  app_version_human_readable?: InputMaybe<String_Comparison_Exp>;
  app_version_ios_build_number?: InputMaybe<String_Comparison_Exp>;
  brand?: InputMaybe<String_Comparison_Exp>;
  client_id?: InputMaybe<Uuid_Comparison_Exp>;
  config?: InputMaybe<Json_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  device_users?: InputMaybe<Device_User_Bool_Exp>;
  device_users_aggregate?: InputMaybe<Device_User_Aggregate_Bool_Exp>;
  expo_push_token?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  ip_data?: InputMaybe<Json_Comparison_Exp>;
  is_rooted?: InputMaybe<Boolean_Comparison_Exp>;
  is_side_loading_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_at?: InputMaybe<Timestamp_Comparison_Exp>;
  location_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  location_os_permission_status?: InputMaybe<String_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  max_memory?: InputMaybe<Float8_Comparison_Exp>;
  model_id?: InputMaybe<String_Comparison_Exp>;
  model_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notifications_app_permission_request_status?: InputMaybe<String_Comparison_Exp>;
  notifications_os_permission_status?: InputMaybe<String_Comparison_Exp>;
  os_build_fingerprint?: InputMaybe<String_Comparison_Exp>;
  os_build_id?: InputMaybe<String_Comparison_Exp>;
  os_internal_build_id?: InputMaybe<String_Comparison_Exp>;
  os_name?: InputMaybe<String_Comparison_Exp>;
  os_version?: InputMaybe<String_Comparison_Exp>;
  platform_api_level?: InputMaybe<String_Comparison_Exp>;
  platform_features?: InputMaybe<Json_Comparison_Exp>;
  supported_cpu_architectures?: InputMaybe<Json_Comparison_Exp>;
  time_discrepancy?: InputMaybe<Int_Comparison_Exp>;
  total_memory?: InputMaybe<Float8_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  uptime?: InputMaybe<Float8_Comparison_Exp>;
  year_class?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "devices" */
export enum Devices_Constraint {
  /** unique or primary key constraint on columns "id" */
  DevicesPkey = 'devices_pkey'
}

/** input type for incrementing numeric columns in table "devices" */
export type Devices_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  max_memory?: InputMaybe<Scalars['float8']['input']>;
  time_discrepancy?: InputMaybe<Scalars['Int']['input']>;
  total_memory?: InputMaybe<Scalars['float8']['input']>;
  uptime?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "devices" */
export type Devices_Insert_Input = {
  app_version_android_version_code?: InputMaybe<Scalars['String']['input']>;
  app_version_eas_update_datetime?: InputMaybe<Scalars['timestamp']['input']>;
  app_version_eas_update_id?: InputMaybe<Scalars['String']['input']>;
  app_version_human_readable?: InputMaybe<Scalars['String']['input']>;
  app_version_ios_build_number?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  config?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_users?: InputMaybe<Device_User_Arr_Rel_Insert_Input>;
  expo_push_token?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ip_data?: InputMaybe<Scalars['json']['input']>;
  is_rooted?: InputMaybe<Scalars['Boolean']['input']>;
  is_side_loading_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  location_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_os_permission_status?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_memory?: InputMaybe<Scalars['float8']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications_app_permission_request_status?: InputMaybe<Scalars['String']['input']>;
  notifications_os_permission_status?: InputMaybe<Scalars['String']['input']>;
  os_build_fingerprint?: InputMaybe<Scalars['String']['input']>;
  os_build_id?: InputMaybe<Scalars['String']['input']>;
  os_internal_build_id?: InputMaybe<Scalars['String']['input']>;
  os_name?: InputMaybe<Scalars['String']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  platform_api_level?: InputMaybe<Scalars['String']['input']>;
  platform_features?: InputMaybe<Scalars['json']['input']>;
  supported_cpu_architectures?: InputMaybe<Scalars['json']['input']>;
  time_discrepancy?: InputMaybe<Scalars['Int']['input']>;
  total_memory?: InputMaybe<Scalars['float8']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uptime?: InputMaybe<Scalars['float8']['input']>;
  year_class?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Devices_Max_Fields = {
  __typename?: 'devices_max_fields';
  app_version_android_version_code?: Maybe<Scalars['String']['output']>;
  app_version_eas_update_datetime?: Maybe<Scalars['timestamp']['output']>;
  app_version_eas_update_id?: Maybe<Scalars['String']['output']>;
  app_version_human_readable?: Maybe<Scalars['String']['output']>;
  app_version_ios_build_number?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expo_push_token?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  location_os_permission_status?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_memory?: Maybe<Scalars['float8']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  model_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notifications_app_permission_request_status?: Maybe<Scalars['String']['output']>;
  notifications_os_permission_status?: Maybe<Scalars['String']['output']>;
  os_build_fingerprint?: Maybe<Scalars['String']['output']>;
  os_build_id?: Maybe<Scalars['String']['output']>;
  os_internal_build_id?: Maybe<Scalars['String']['output']>;
  os_name?: Maybe<Scalars['String']['output']>;
  os_version?: Maybe<Scalars['String']['output']>;
  platform_api_level?: Maybe<Scalars['String']['output']>;
  time_discrepancy?: Maybe<Scalars['Int']['output']>;
  total_memory?: Maybe<Scalars['float8']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  uptime?: Maybe<Scalars['float8']['output']>;
  year_class?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Devices_Min_Fields = {
  __typename?: 'devices_min_fields';
  app_version_android_version_code?: Maybe<Scalars['String']['output']>;
  app_version_eas_update_datetime?: Maybe<Scalars['timestamp']['output']>;
  app_version_eas_update_id?: Maybe<Scalars['String']['output']>;
  app_version_human_readable?: Maybe<Scalars['String']['output']>;
  app_version_ios_build_number?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expo_push_token?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  location_os_permission_status?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  max_memory?: Maybe<Scalars['float8']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  model_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notifications_app_permission_request_status?: Maybe<Scalars['String']['output']>;
  notifications_os_permission_status?: Maybe<Scalars['String']['output']>;
  os_build_fingerprint?: Maybe<Scalars['String']['output']>;
  os_build_id?: Maybe<Scalars['String']['output']>;
  os_internal_build_id?: Maybe<Scalars['String']['output']>;
  os_name?: Maybe<Scalars['String']['output']>;
  os_version?: Maybe<Scalars['String']['output']>;
  platform_api_level?: Maybe<Scalars['String']['output']>;
  time_discrepancy?: Maybe<Scalars['Int']['output']>;
  total_memory?: Maybe<Scalars['float8']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  uptime?: Maybe<Scalars['float8']['output']>;
  year_class?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "devices" */
export type Devices_Mutation_Response = {
  __typename?: 'devices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Devices>;
};

/** input type for inserting object relation for remote table "devices" */
export type Devices_Obj_Rel_Insert_Input = {
  data: Devices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Devices_On_Conflict>;
};

/** on_conflict condition type for table "devices" */
export type Devices_On_Conflict = {
  constraint: Devices_Constraint;
  update_columns?: Array<Devices_Update_Column>;
  where?: InputMaybe<Devices_Bool_Exp>;
};

/** Ordering options when selecting data from "devices". */
export type Devices_Order_By = {
  app_version_android_version_code?: InputMaybe<Order_By>;
  app_version_eas_update_datetime?: InputMaybe<Order_By>;
  app_version_eas_update_id?: InputMaybe<Order_By>;
  app_version_human_readable?: InputMaybe<Order_By>;
  app_version_ios_build_number?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_users_aggregate?: InputMaybe<Device_User_Aggregate_Order_By>;
  expo_push_token?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_data?: InputMaybe<Order_By>;
  is_rooted?: InputMaybe<Order_By>;
  is_side_loading_enabled?: InputMaybe<Order_By>;
  last_active_at?: InputMaybe<Order_By>;
  location_enabled?: InputMaybe<Order_By>;
  location_os_permission_status?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  max_memory?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  model_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notifications_app_permission_request_status?: InputMaybe<Order_By>;
  notifications_os_permission_status?: InputMaybe<Order_By>;
  os_build_fingerprint?: InputMaybe<Order_By>;
  os_build_id?: InputMaybe<Order_By>;
  os_internal_build_id?: InputMaybe<Order_By>;
  os_name?: InputMaybe<Order_By>;
  os_version?: InputMaybe<Order_By>;
  platform_api_level?: InputMaybe<Order_By>;
  platform_features?: InputMaybe<Order_By>;
  supported_cpu_architectures?: InputMaybe<Order_By>;
  time_discrepancy?: InputMaybe<Order_By>;
  total_memory?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uptime?: InputMaybe<Order_By>;
  year_class?: InputMaybe<Order_By>;
};

/** primary key columns input for table: devices */
export type Devices_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "devices" */
export enum Devices_Select_Column {
  /** column name */
  AppVersionAndroidVersionCode = 'app_version_android_version_code',
  /** column name */
  AppVersionEasUpdateDatetime = 'app_version_eas_update_datetime',
  /** column name */
  AppVersionEasUpdateId = 'app_version_eas_update_id',
  /** column name */
  AppVersionHumanReadable = 'app_version_human_readable',
  /** column name */
  AppVersionIosBuildNumber = 'app_version_ios_build_number',
  /** column name */
  Brand = 'brand',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpoPushToken = 'expo_push_token',
  /** column name */
  Id = 'id',
  /** column name */
  IpData = 'ip_data',
  /** column name */
  IsRooted = 'is_rooted',
  /** column name */
  IsSideLoadingEnabled = 'is_side_loading_enabled',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LocationEnabled = 'location_enabled',
  /** column name */
  LocationOsPermissionStatus = 'location_os_permission_status',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxMemory = 'max_memory',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  ModelName = 'model_name',
  /** column name */
  Name = 'name',
  /** column name */
  NotificationsAppPermissionRequestStatus = 'notifications_app_permission_request_status',
  /** column name */
  NotificationsOsPermissionStatus = 'notifications_os_permission_status',
  /** column name */
  OsBuildFingerprint = 'os_build_fingerprint',
  /** column name */
  OsBuildId = 'os_build_id',
  /** column name */
  OsInternalBuildId = 'os_internal_build_id',
  /** column name */
  OsName = 'os_name',
  /** column name */
  OsVersion = 'os_version',
  /** column name */
  PlatformApiLevel = 'platform_api_level',
  /** column name */
  PlatformFeatures = 'platform_features',
  /** column name */
  SupportedCpuArchitectures = 'supported_cpu_architectures',
  /** column name */
  TimeDiscrepancy = 'time_discrepancy',
  /** column name */
  TotalMemory = 'total_memory',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uptime = 'uptime',
  /** column name */
  YearClass = 'year_class'
}

/** input type for updating data in table "devices" */
export type Devices_Set_Input = {
  app_version_android_version_code?: InputMaybe<Scalars['String']['input']>;
  app_version_eas_update_datetime?: InputMaybe<Scalars['timestamp']['input']>;
  app_version_eas_update_id?: InputMaybe<Scalars['String']['input']>;
  app_version_human_readable?: InputMaybe<Scalars['String']['input']>;
  app_version_ios_build_number?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  config?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expo_push_token?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ip_data?: InputMaybe<Scalars['json']['input']>;
  is_rooted?: InputMaybe<Scalars['Boolean']['input']>;
  is_side_loading_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  location_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_os_permission_status?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_memory?: InputMaybe<Scalars['float8']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications_app_permission_request_status?: InputMaybe<Scalars['String']['input']>;
  notifications_os_permission_status?: InputMaybe<Scalars['String']['input']>;
  os_build_fingerprint?: InputMaybe<Scalars['String']['input']>;
  os_build_id?: InputMaybe<Scalars['String']['input']>;
  os_internal_build_id?: InputMaybe<Scalars['String']['input']>;
  os_name?: InputMaybe<Scalars['String']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  platform_api_level?: InputMaybe<Scalars['String']['input']>;
  platform_features?: InputMaybe<Scalars['json']['input']>;
  supported_cpu_architectures?: InputMaybe<Scalars['json']['input']>;
  time_discrepancy?: InputMaybe<Scalars['Int']['input']>;
  total_memory?: InputMaybe<Scalars['float8']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uptime?: InputMaybe<Scalars['float8']['input']>;
  year_class?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Devices_Stddev_Fields = {
  __typename?: 'devices_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_memory?: Maybe<Scalars['Float']['output']>;
  time_discrepancy?: Maybe<Scalars['Float']['output']>;
  total_memory?: Maybe<Scalars['Float']['output']>;
  uptime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Devices_Stddev_Pop_Fields = {
  __typename?: 'devices_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_memory?: Maybe<Scalars['Float']['output']>;
  time_discrepancy?: Maybe<Scalars['Float']['output']>;
  total_memory?: Maybe<Scalars['Float']['output']>;
  uptime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Devices_Stddev_Samp_Fields = {
  __typename?: 'devices_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_memory?: Maybe<Scalars['Float']['output']>;
  time_discrepancy?: Maybe<Scalars['Float']['output']>;
  total_memory?: Maybe<Scalars['Float']['output']>;
  uptime?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "devices" */
export type Devices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Devices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Devices_Stream_Cursor_Value_Input = {
  app_version_android_version_code?: InputMaybe<Scalars['String']['input']>;
  app_version_eas_update_datetime?: InputMaybe<Scalars['timestamp']['input']>;
  app_version_eas_update_id?: InputMaybe<Scalars['String']['input']>;
  app_version_human_readable?: InputMaybe<Scalars['String']['input']>;
  app_version_ios_build_number?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  config?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expo_push_token?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ip_data?: InputMaybe<Scalars['json']['input']>;
  is_rooted?: InputMaybe<Scalars['Boolean']['input']>;
  is_side_loading_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  location_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  location_os_permission_status?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  max_memory?: InputMaybe<Scalars['float8']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications_app_permission_request_status?: InputMaybe<Scalars['String']['input']>;
  notifications_os_permission_status?: InputMaybe<Scalars['String']['input']>;
  os_build_fingerprint?: InputMaybe<Scalars['String']['input']>;
  os_build_id?: InputMaybe<Scalars['String']['input']>;
  os_internal_build_id?: InputMaybe<Scalars['String']['input']>;
  os_name?: InputMaybe<Scalars['String']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  platform_api_level?: InputMaybe<Scalars['String']['input']>;
  platform_features?: InputMaybe<Scalars['json']['input']>;
  supported_cpu_architectures?: InputMaybe<Scalars['json']['input']>;
  time_discrepancy?: InputMaybe<Scalars['Int']['input']>;
  total_memory?: InputMaybe<Scalars['float8']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uptime?: InputMaybe<Scalars['float8']['input']>;
  year_class?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Devices_Sum_Fields = {
  __typename?: 'devices_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  max_memory?: Maybe<Scalars['float8']['output']>;
  time_discrepancy?: Maybe<Scalars['Int']['output']>;
  total_memory?: Maybe<Scalars['float8']['output']>;
  uptime?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "devices" */
export enum Devices_Update_Column {
  /** column name */
  AppVersionAndroidVersionCode = 'app_version_android_version_code',
  /** column name */
  AppVersionEasUpdateDatetime = 'app_version_eas_update_datetime',
  /** column name */
  AppVersionEasUpdateId = 'app_version_eas_update_id',
  /** column name */
  AppVersionHumanReadable = 'app_version_human_readable',
  /** column name */
  AppVersionIosBuildNumber = 'app_version_ios_build_number',
  /** column name */
  Brand = 'brand',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpoPushToken = 'expo_push_token',
  /** column name */
  Id = 'id',
  /** column name */
  IpData = 'ip_data',
  /** column name */
  IsRooted = 'is_rooted',
  /** column name */
  IsSideLoadingEnabled = 'is_side_loading_enabled',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LocationEnabled = 'location_enabled',
  /** column name */
  LocationOsPermissionStatus = 'location_os_permission_status',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MaxMemory = 'max_memory',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  ModelName = 'model_name',
  /** column name */
  Name = 'name',
  /** column name */
  NotificationsAppPermissionRequestStatus = 'notifications_app_permission_request_status',
  /** column name */
  NotificationsOsPermissionStatus = 'notifications_os_permission_status',
  /** column name */
  OsBuildFingerprint = 'os_build_fingerprint',
  /** column name */
  OsBuildId = 'os_build_id',
  /** column name */
  OsInternalBuildId = 'os_internal_build_id',
  /** column name */
  OsName = 'os_name',
  /** column name */
  OsVersion = 'os_version',
  /** column name */
  PlatformApiLevel = 'platform_api_level',
  /** column name */
  PlatformFeatures = 'platform_features',
  /** column name */
  SupportedCpuArchitectures = 'supported_cpu_architectures',
  /** column name */
  TimeDiscrepancy = 'time_discrepancy',
  /** column name */
  TotalMemory = 'total_memory',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uptime = 'uptime',
  /** column name */
  YearClass = 'year_class'
}

export type Devices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Devices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Devices_Set_Input>;
  /** filter the rows which have to be updated */
  where: Devices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Devices_Var_Pop_Fields = {
  __typename?: 'devices_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_memory?: Maybe<Scalars['Float']['output']>;
  time_discrepancy?: Maybe<Scalars['Float']['output']>;
  total_memory?: Maybe<Scalars['Float']['output']>;
  uptime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Devices_Var_Samp_Fields = {
  __typename?: 'devices_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_memory?: Maybe<Scalars['Float']['output']>;
  time_discrepancy?: Maybe<Scalars['Float']['output']>;
  total_memory?: Maybe<Scalars['Float']['output']>;
  uptime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Devices_Variance_Fields = {
  __typename?: 'devices_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_memory?: Maybe<Scalars['Float']['output']>;
  time_discrepancy?: Maybe<Scalars['Float']['output']>;
  total_memory?: Maybe<Scalars['Float']['output']>;
  uptime?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'events';
  /** An object relationship */
  adminUser?: Maybe<Admin_Users>;
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  app_version?: Maybe<Scalars['String']['output']>;
  batch_id: Scalars['String']['output'];
  category: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['json']['output']>;
  device?: Maybe<Scalars['json']['output']>;
  device_client_id?: Maybe<Scalars['String']['output']>;
  event_id: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  link_data?: Maybe<Scalars['json']['output']>;
  next_link_attempt_at?: Maybe<Scalars['timestamp']['output']>;
  num_link_attempts?: Maybe<Scalars['smallint']['output']>;
  occurred_at: Scalars['timestamp']['output'];
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "events" */
export type EventsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "events" */
export type EventsDeviceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "events" */
export type EventsLink_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "events" */
export type Events_Aggregate = {
  __typename?: 'events_aggregate';
  aggregate?: Maybe<Events_Aggregate_Fields>;
  nodes: Array<Events>;
};

/** aggregate fields of "events" */
export type Events_Aggregate_Fields = {
  __typename?: 'events_aggregate_fields';
  avg?: Maybe<Events_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Max_Fields>;
  min?: Maybe<Events_Min_Fields>;
  stddev?: Maybe<Events_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Sum_Fields>;
  var_pop?: Maybe<Events_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Var_Samp_Fields>;
  variance?: Maybe<Events_Variance_Fields>;
};


/** aggregate fields of "events" */
export type Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Avg_Fields = {
  __typename?: 'events_avg_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_link_attempts?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Bool_Exp>>;
  _not?: InputMaybe<Events_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Bool_Exp>>;
  adminUser?: InputMaybe<Admin_Users_Bool_Exp>;
  admin_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  batch_id?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  device?: InputMaybe<Json_Comparison_Exp>;
  device_client_id?: InputMaybe<String_Comparison_Exp>;
  event_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  link_data?: InputMaybe<Json_Comparison_Exp>;
  next_link_attempt_at?: InputMaybe<Timestamp_Comparison_Exp>;
  num_link_attempts?: InputMaybe<Smallint_Comparison_Exp>;
  occurred_at?: InputMaybe<Timestamp_Comparison_Exp>;
  os?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  sub_category?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "events" */
export enum Events_Constraint {
  /** unique or primary key constraint on columns "event_id" */
  EventsEventIdUnique = 'events_event_id_unique',
  /** unique or primary key constraint on columns "id" */
  EventsPkey = 'events_pkey'
}

/** input type for incrementing numeric columns in table "events" */
export type Events_Inc_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  num_link_attempts?: InputMaybe<Scalars['smallint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "events" */
export type Events_Insert_Input = {
  adminUser?: InputMaybe<Admin_Users_Obj_Rel_Insert_Input>;
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  batch_id?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  device?: InputMaybe<Scalars['json']['input']>;
  device_client_id?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  link_data?: InputMaybe<Scalars['json']['input']>;
  next_link_attempt_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_link_attempts?: InputMaybe<Scalars['smallint']['input']>;
  occurred_at?: InputMaybe<Scalars['timestamp']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Events_Max_Fields = {
  __typename?: 'events_max_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  app_version?: Maybe<Scalars['String']['output']>;
  batch_id?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_client_id?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  next_link_attempt_at?: Maybe<Scalars['timestamp']['output']>;
  num_link_attempts?: Maybe<Scalars['smallint']['output']>;
  occurred_at?: Maybe<Scalars['timestamp']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Events_Min_Fields = {
  __typename?: 'events_min_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  app_version?: Maybe<Scalars['String']['output']>;
  batch_id?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_client_id?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  next_link_attempt_at?: Maybe<Scalars['timestamp']['output']>;
  num_link_attempts?: Maybe<Scalars['smallint']['output']>;
  occurred_at?: Maybe<Scalars['timestamp']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "events" */
export type Events_Mutation_Response = {
  __typename?: 'events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Events>;
};

/** on_conflict condition type for table "events" */
export type Events_On_Conflict = {
  constraint: Events_Constraint;
  update_columns?: Array<Events_Update_Column>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** Ordering options when selecting data from "events". */
export type Events_Order_By = {
  adminUser?: InputMaybe<Admin_Users_Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
  app_version?: InputMaybe<Order_By>;
  batch_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  device?: InputMaybe<Order_By>;
  device_client_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link_data?: InputMaybe<Order_By>;
  next_link_attempt_at?: InputMaybe<Order_By>;
  num_link_attempts?: InputMaybe<Order_By>;
  occurred_at?: InputMaybe<Order_By>;
  os?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  sub_category?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: events */
export type Events_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "events" */
export enum Events_Select_Column {
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Device = 'device',
  /** column name */
  DeviceClientId = 'device_client_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  LinkData = 'link_data',
  /** column name */
  NextLinkAttemptAt = 'next_link_attempt_at',
  /** column name */
  NumLinkAttempts = 'num_link_attempts',
  /** column name */
  OccurredAt = 'occurred_at',
  /** column name */
  Os = 'os',
  /** column name */
  Platform = 'platform',
  /** column name */
  Source = 'source',
  /** column name */
  SubCategory = 'sub_category',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "events" */
export type Events_Set_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  batch_id?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  device?: InputMaybe<Scalars['json']['input']>;
  device_client_id?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  link_data?: InputMaybe<Scalars['json']['input']>;
  next_link_attempt_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_link_attempts?: InputMaybe<Scalars['smallint']['input']>;
  occurred_at?: InputMaybe<Scalars['timestamp']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Events_Stddev_Fields = {
  __typename?: 'events_stddev_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_link_attempts?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Stddev_Pop_Fields = {
  __typename?: 'events_stddev_pop_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_link_attempts?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Stddev_Samp_Fields = {
  __typename?: 'events_stddev_samp_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_link_attempts?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events" */
export type Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Stream_Cursor_Value_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  batch_id?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  device?: InputMaybe<Scalars['json']['input']>;
  device_client_id?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  link_data?: InputMaybe<Scalars['json']['input']>;
  next_link_attempt_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_link_attempts?: InputMaybe<Scalars['smallint']['input']>;
  occurred_at?: InputMaybe<Scalars['timestamp']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Events_Sum_Fields = {
  __typename?: 'events_sum_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  num_link_attempts?: Maybe<Scalars['smallint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "events" */
export enum Events_Update_Column {
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Device = 'device',
  /** column name */
  DeviceClientId = 'device_client_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  LinkData = 'link_data',
  /** column name */
  NextLinkAttemptAt = 'next_link_attempt_at',
  /** column name */
  NumLinkAttempts = 'num_link_attempts',
  /** column name */
  OccurredAt = 'occurred_at',
  /** column name */
  Os = 'os',
  /** column name */
  Platform = 'platform',
  /** column name */
  Source = 'source',
  /** column name */
  SubCategory = 'sub_category',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Events_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Events_Var_Pop_Fields = {
  __typename?: 'events_var_pop_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_link_attempts?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Var_Samp_Fields = {
  __typename?: 'events_var_samp_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_link_attempts?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Variance_Fields = {
  __typename?: 'events_variance_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_link_attempts?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "failed_jobs" */
export type Failed_Jobs = {
  __typename?: 'failed_jobs';
  connection: Scalars['String']['output'];
  exception: Scalars['String']['output'];
  failed_at: Scalars['timestamp']['output'];
  id: Scalars['bigint']['output'];
  payload: Scalars['String']['output'];
  queue: Scalars['String']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "failed_jobs" */
export type Failed_Jobs_Aggregate = {
  __typename?: 'failed_jobs_aggregate';
  aggregate?: Maybe<Failed_Jobs_Aggregate_Fields>;
  nodes: Array<Failed_Jobs>;
};

/** aggregate fields of "failed_jobs" */
export type Failed_Jobs_Aggregate_Fields = {
  __typename?: 'failed_jobs_aggregate_fields';
  avg?: Maybe<Failed_Jobs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Failed_Jobs_Max_Fields>;
  min?: Maybe<Failed_Jobs_Min_Fields>;
  stddev?: Maybe<Failed_Jobs_Stddev_Fields>;
  stddev_pop?: Maybe<Failed_Jobs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Failed_Jobs_Stddev_Samp_Fields>;
  sum?: Maybe<Failed_Jobs_Sum_Fields>;
  var_pop?: Maybe<Failed_Jobs_Var_Pop_Fields>;
  var_samp?: Maybe<Failed_Jobs_Var_Samp_Fields>;
  variance?: Maybe<Failed_Jobs_Variance_Fields>;
};


/** aggregate fields of "failed_jobs" */
export type Failed_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Failed_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Failed_Jobs_Avg_Fields = {
  __typename?: 'failed_jobs_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "failed_jobs". All fields are combined with a logical 'AND'. */
export type Failed_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Failed_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Failed_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Failed_Jobs_Bool_Exp>>;
  connection?: InputMaybe<String_Comparison_Exp>;
  exception?: InputMaybe<String_Comparison_Exp>;
  failed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  payload?: InputMaybe<String_Comparison_Exp>;
  queue?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "failed_jobs" */
export enum Failed_Jobs_Constraint {
  /** unique or primary key constraint on columns "id" */
  FailedJobsPkey = 'failed_jobs_pkey',
  /** unique or primary key constraint on columns "uuid" */
  FailedJobsUuidUnique = 'failed_jobs_uuid_unique'
}

/** input type for incrementing numeric columns in table "failed_jobs" */
export type Failed_Jobs_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "failed_jobs" */
export type Failed_Jobs_Insert_Input = {
  connection?: InputMaybe<Scalars['String']['input']>;
  exception?: InputMaybe<Scalars['String']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Failed_Jobs_Max_Fields = {
  __typename?: 'failed_jobs_max_fields';
  connection?: Maybe<Scalars['String']['output']>;
  exception?: Maybe<Scalars['String']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Failed_Jobs_Min_Fields = {
  __typename?: 'failed_jobs_min_fields';
  connection?: Maybe<Scalars['String']['output']>;
  exception?: Maybe<Scalars['String']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "failed_jobs" */
export type Failed_Jobs_Mutation_Response = {
  __typename?: 'failed_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Failed_Jobs>;
};

/** on_conflict condition type for table "failed_jobs" */
export type Failed_Jobs_On_Conflict = {
  constraint: Failed_Jobs_Constraint;
  update_columns?: Array<Failed_Jobs_Update_Column>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "failed_jobs". */
export type Failed_Jobs_Order_By = {
  connection?: InputMaybe<Order_By>;
  exception?: InputMaybe<Order_By>;
  failed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  queue?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: failed_jobs */
export type Failed_Jobs_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "failed_jobs" */
export enum Failed_Jobs_Select_Column {
  /** column name */
  Connection = 'connection',
  /** column name */
  Exception = 'exception',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Queue = 'queue',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "failed_jobs" */
export type Failed_Jobs_Set_Input = {
  connection?: InputMaybe<Scalars['String']['input']>;
  exception?: InputMaybe<Scalars['String']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Failed_Jobs_Stddev_Fields = {
  __typename?: 'failed_jobs_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Failed_Jobs_Stddev_Pop_Fields = {
  __typename?: 'failed_jobs_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Failed_Jobs_Stddev_Samp_Fields = {
  __typename?: 'failed_jobs_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "failed_jobs" */
export type Failed_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Failed_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Failed_Jobs_Stream_Cursor_Value_Input = {
  connection?: InputMaybe<Scalars['String']['input']>;
  exception?: InputMaybe<Scalars['String']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Failed_Jobs_Sum_Fields = {
  __typename?: 'failed_jobs_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "failed_jobs" */
export enum Failed_Jobs_Update_Column {
  /** column name */
  Connection = 'connection',
  /** column name */
  Exception = 'exception',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Queue = 'queue',
  /** column name */
  Uuid = 'uuid'
}

export type Failed_Jobs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Failed_Jobs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Failed_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Failed_Jobs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Failed_Jobs_Var_Pop_Fields = {
  __typename?: 'failed_jobs_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Failed_Jobs_Var_Samp_Fields = {
  __typename?: 'failed_jobs_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Failed_Jobs_Variance_Fields = {
  __typename?: 'failed_jobs_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "failed_sentry_messages" */
export type Failed_Sentry_Messages = {
  __typename?: 'failed_sentry_messages';
  body: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  error_stack_trace?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  message_id: Scalars['String']['output'];
  tries: Scalars['smallint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "failed_sentry_messages" */
export type Failed_Sentry_Messages_Aggregate = {
  __typename?: 'failed_sentry_messages_aggregate';
  aggregate?: Maybe<Failed_Sentry_Messages_Aggregate_Fields>;
  nodes: Array<Failed_Sentry_Messages>;
};

/** aggregate fields of "failed_sentry_messages" */
export type Failed_Sentry_Messages_Aggregate_Fields = {
  __typename?: 'failed_sentry_messages_aggregate_fields';
  avg?: Maybe<Failed_Sentry_Messages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Failed_Sentry_Messages_Max_Fields>;
  min?: Maybe<Failed_Sentry_Messages_Min_Fields>;
  stddev?: Maybe<Failed_Sentry_Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Failed_Sentry_Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Failed_Sentry_Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Failed_Sentry_Messages_Sum_Fields>;
  var_pop?: Maybe<Failed_Sentry_Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Failed_Sentry_Messages_Var_Samp_Fields>;
  variance?: Maybe<Failed_Sentry_Messages_Variance_Fields>;
};


/** aggregate fields of "failed_sentry_messages" */
export type Failed_Sentry_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Failed_Sentry_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Failed_Sentry_Messages_Avg_Fields = {
  __typename?: 'failed_sentry_messages_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tries?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "failed_sentry_messages". All fields are combined with a logical 'AND'. */
export type Failed_Sentry_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Failed_Sentry_Messages_Bool_Exp>>;
  _not?: InputMaybe<Failed_Sentry_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Failed_Sentry_Messages_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  error_stack_trace?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  message_id?: InputMaybe<String_Comparison_Exp>;
  tries?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "failed_sentry_messages" */
export enum Failed_Sentry_Messages_Constraint {
  /** unique or primary key constraint on columns "message_id" */
  FailedSentryMessagesMessageIdUnique = 'failed_sentry_messages_message_id_unique',
  /** unique or primary key constraint on columns "id" */
  FailedSentryMessagesPkey = 'failed_sentry_messages_pkey'
}

/** input type for incrementing numeric columns in table "failed_sentry_messages" */
export type Failed_Sentry_Messages_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  tries?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "failed_sentry_messages" */
export type Failed_Sentry_Messages_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  error_stack_trace?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  tries?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Failed_Sentry_Messages_Max_Fields = {
  __typename?: 'failed_sentry_messages_max_fields';
  body?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  error_stack_trace?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  tries?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Failed_Sentry_Messages_Min_Fields = {
  __typename?: 'failed_sentry_messages_min_fields';
  body?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  error_stack_trace?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  tries?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "failed_sentry_messages" */
export type Failed_Sentry_Messages_Mutation_Response = {
  __typename?: 'failed_sentry_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Failed_Sentry_Messages>;
};

/** on_conflict condition type for table "failed_sentry_messages" */
export type Failed_Sentry_Messages_On_Conflict = {
  constraint: Failed_Sentry_Messages_Constraint;
  update_columns?: Array<Failed_Sentry_Messages_Update_Column>;
  where?: InputMaybe<Failed_Sentry_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "failed_sentry_messages". */
export type Failed_Sentry_Messages_Order_By = {
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  error_stack_trace?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  tries?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: failed_sentry_messages */
export type Failed_Sentry_Messages_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "failed_sentry_messages" */
export enum Failed_Sentry_Messages_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  ErrorStackTrace = 'error_stack_trace',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Tries = 'tries',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "failed_sentry_messages" */
export type Failed_Sentry_Messages_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  error_stack_trace?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  tries?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Failed_Sentry_Messages_Stddev_Fields = {
  __typename?: 'failed_sentry_messages_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tries?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Failed_Sentry_Messages_Stddev_Pop_Fields = {
  __typename?: 'failed_sentry_messages_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tries?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Failed_Sentry_Messages_Stddev_Samp_Fields = {
  __typename?: 'failed_sentry_messages_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tries?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "failed_sentry_messages" */
export type Failed_Sentry_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Failed_Sentry_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Failed_Sentry_Messages_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  error_stack_trace?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  tries?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Failed_Sentry_Messages_Sum_Fields = {
  __typename?: 'failed_sentry_messages_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  tries?: Maybe<Scalars['smallint']['output']>;
};

/** update columns of table "failed_sentry_messages" */
export enum Failed_Sentry_Messages_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  ErrorStackTrace = 'error_stack_trace',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Tries = 'tries',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Failed_Sentry_Messages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Failed_Sentry_Messages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Failed_Sentry_Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Failed_Sentry_Messages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Failed_Sentry_Messages_Var_Pop_Fields = {
  __typename?: 'failed_sentry_messages_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tries?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Failed_Sentry_Messages_Var_Samp_Fields = {
  __typename?: 'failed_sentry_messages_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tries?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Failed_Sentry_Messages_Variance_Fields = {
  __typename?: 'failed_sentry_messages_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tries?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "identities" */
export type Identities = {
  __typename?: 'identities';
  /** An object relationship */
  admin_user?: Maybe<Admin_Users>;
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['json']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_token?: Maybe<Scalars['String']['output']>;
  id_token_expires_at?: Maybe<Scalars['timestamp']['output']>;
  identity_pool: Scalars['String']['output'];
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  locked_at?: Maybe<Scalars['timestamp']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  phone_number_verified: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
  provider_id: Scalars['String']['output'];
  refresh_token?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  support_tickets: Array<Support_Tickets>;
  /** An aggregate relationship */
  support_tickets_aggregate: Support_Tickets_Aggregate;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "identities" */
export type IdentitiesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "identities" */
export type IdentitiesSupport_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


/** columns and relationships of "identities" */
export type IdentitiesSupport_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};

/** aggregated selection of "identities" */
export type Identities_Aggregate = {
  __typename?: 'identities_aggregate';
  aggregate?: Maybe<Identities_Aggregate_Fields>;
  nodes: Array<Identities>;
};

export type Identities_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Identities_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Identities_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Identities_Aggregate_Bool_Exp_Count>;
};

export type Identities_Aggregate_Bool_Exp_Bool_And = {
  arguments: Identities_Select_Column_Identities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Identities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Identities_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Identities_Select_Column_Identities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Identities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Identities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Identities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Identities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "identities" */
export type Identities_Aggregate_Fields = {
  __typename?: 'identities_aggregate_fields';
  avg?: Maybe<Identities_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Identities_Max_Fields>;
  min?: Maybe<Identities_Min_Fields>;
  stddev?: Maybe<Identities_Stddev_Fields>;
  stddev_pop?: Maybe<Identities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Identities_Stddev_Samp_Fields>;
  sum?: Maybe<Identities_Sum_Fields>;
  var_pop?: Maybe<Identities_Var_Pop_Fields>;
  var_samp?: Maybe<Identities_Var_Samp_Fields>;
  variance?: Maybe<Identities_Variance_Fields>;
};


/** aggregate fields of "identities" */
export type Identities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Identities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "identities" */
export type Identities_Aggregate_Order_By = {
  avg?: InputMaybe<Identities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Identities_Max_Order_By>;
  min?: InputMaybe<Identities_Min_Order_By>;
  stddev?: InputMaybe<Identities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Identities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Identities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Identities_Sum_Order_By>;
  var_pop?: InputMaybe<Identities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Identities_Var_Samp_Order_By>;
  variance?: InputMaybe<Identities_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "identities" */
export type Identities_Arr_Rel_Insert_Input = {
  data: Array<Identities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Identities_On_Conflict>;
};

/** aggregate avg on columns */
export type Identities_Avg_Fields = {
  __typename?: 'identities_avg_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "identities" */
export type Identities_Avg_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "identities". All fields are combined with a logical 'AND'. */
export type Identities_Bool_Exp = {
  _and?: InputMaybe<Array<Identities_Bool_Exp>>;
  _not?: InputMaybe<Identities_Bool_Exp>;
  _or?: InputMaybe<Array<Identities_Bool_Exp>>;
  admin_user?: InputMaybe<Admin_Users_Bool_Exp>;
  admin_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  email_verified?: InputMaybe<Boolean_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_token?: InputMaybe<String_Comparison_Exp>;
  id_token_expires_at?: InputMaybe<Timestamp_Comparison_Exp>;
  identity_pool?: InputMaybe<String_Comparison_Exp>;
  last_active_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_login_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  locked_at?: InputMaybe<Timestamp_Comparison_Exp>;
  nickname?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  phone_number_verified?: InputMaybe<Boolean_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
  refresh_token?: InputMaybe<String_Comparison_Exp>;
  support_tickets?: InputMaybe<Support_Tickets_Bool_Exp>;
  support_tickets_aggregate?: InputMaybe<Support_Tickets_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "identities" */
export enum Identities_Constraint {
  /** unique or primary key constraint on columns "id" */
  IdentitiesPkey = 'identities_pkey',
  /** unique or primary key constraint on columns "provider", "identity_pool", "provider_id" */
  IdentitiesProviderProviderIdIdentityPoolUnique = 'identities_provider_provider_id_identity_pool_unique'
}

/** input type for incrementing numeric columns in table "identities" */
export type Identities_Inc_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "identities" */
export type Identities_Insert_Input = {
  admin_user?: InputMaybe<Admin_Users_Obj_Rel_Insert_Input>;
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_token?: InputMaybe<Scalars['String']['input']>;
  id_token_expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  identity_pool?: InputMaybe<Scalars['String']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  locked_at?: InputMaybe<Scalars['timestamp']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  support_tickets?: InputMaybe<Support_Tickets_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Identities_Max_Fields = {
  __typename?: 'identities_max_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_token?: Maybe<Scalars['String']['output']>;
  id_token_expires_at?: Maybe<Scalars['timestamp']['output']>;
  identity_pool?: Maybe<Scalars['String']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  locked_at?: Maybe<Scalars['timestamp']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "identities" */
export type Identities_Max_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  avatar?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_token?: InputMaybe<Order_By>;
  id_token_expires_at?: InputMaybe<Order_By>;
  identity_pool?: InputMaybe<Order_By>;
  last_active_at?: InputMaybe<Order_By>;
  last_login_at?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  locked_at?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Identities_Min_Fields = {
  __typename?: 'identities_min_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_token?: Maybe<Scalars['String']['output']>;
  id_token_expires_at?: Maybe<Scalars['timestamp']['output']>;
  identity_pool?: Maybe<Scalars['String']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  locked_at?: Maybe<Scalars['timestamp']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "identities" */
export type Identities_Min_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  avatar?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_token?: InputMaybe<Order_By>;
  id_token_expires_at?: InputMaybe<Order_By>;
  identity_pool?: InputMaybe<Order_By>;
  last_active_at?: InputMaybe<Order_By>;
  last_login_at?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  locked_at?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "identities" */
export type Identities_Mutation_Response = {
  __typename?: 'identities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Identities>;
};

/** input type for inserting object relation for remote table "identities" */
export type Identities_Obj_Rel_Insert_Input = {
  data: Identities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Identities_On_Conflict>;
};

/** on_conflict condition type for table "identities" */
export type Identities_On_Conflict = {
  constraint: Identities_Constraint;
  update_columns?: Array<Identities_Update_Column>;
  where?: InputMaybe<Identities_Bool_Exp>;
};

/** Ordering options when selecting data from "identities". */
export type Identities_Order_By = {
  admin_user?: InputMaybe<Admin_Users_Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
  avatar?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_verified?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_token?: InputMaybe<Order_By>;
  id_token_expires_at?: InputMaybe<Order_By>;
  identity_pool?: InputMaybe<Order_By>;
  last_active_at?: InputMaybe<Order_By>;
  last_login_at?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  locked_at?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  phone_number_verified?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  support_tickets_aggregate?: InputMaybe<Support_Tickets_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: identities */
export type Identities_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "identities" */
export enum Identities_Select_Column {
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  IdToken = 'id_token',
  /** column name */
  IdTokenExpiresAt = 'id_token_expires_at',
  /** column name */
  IdentityPool = 'identity_pool',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LastLoginAt = 'last_login_at',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LockedAt = 'locked_at',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PhoneNumberVerified = 'phone_number_verified',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "identities_aggregate_bool_exp_bool_and_arguments_columns" columns of table "identities" */
export enum Identities_Select_Column_Identities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  PhoneNumberVerified = 'phone_number_verified'
}

/** select "identities_aggregate_bool_exp_bool_or_arguments_columns" columns of table "identities" */
export enum Identities_Select_Column_Identities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  PhoneNumberVerified = 'phone_number_verified'
}

/** input type for updating data in table "identities" */
export type Identities_Set_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_token?: InputMaybe<Scalars['String']['input']>;
  id_token_expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  identity_pool?: InputMaybe<Scalars['String']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  locked_at?: InputMaybe<Scalars['timestamp']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Identities_Stddev_Fields = {
  __typename?: 'identities_stddev_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "identities" */
export type Identities_Stddev_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Identities_Stddev_Pop_Fields = {
  __typename?: 'identities_stddev_pop_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "identities" */
export type Identities_Stddev_Pop_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Identities_Stddev_Samp_Fields = {
  __typename?: 'identities_stddev_samp_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "identities" */
export type Identities_Stddev_Samp_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "identities" */
export type Identities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Identities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Identities_Stream_Cursor_Value_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_token?: InputMaybe<Scalars['String']['input']>;
  id_token_expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  identity_pool?: InputMaybe<Scalars['String']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  locked_at?: InputMaybe<Scalars['timestamp']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Identities_Sum_Fields = {
  __typename?: 'identities_sum_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "identities" */
export type Identities_Sum_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "identities" */
export enum Identities_Update_Column {
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  IdToken = 'id_token',
  /** column name */
  IdTokenExpiresAt = 'id_token_expires_at',
  /** column name */
  IdentityPool = 'identity_pool',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LastLoginAt = 'last_login_at',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LockedAt = 'locked_at',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PhoneNumberVerified = 'phone_number_verified',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Identities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Identities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Identities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Identities_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Identities_Var_Pop_Fields = {
  __typename?: 'identities_var_pop_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "identities" */
export type Identities_Var_Pop_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Identities_Var_Samp_Fields = {
  __typename?: 'identities_var_samp_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "identities" */
export type Identities_Var_Samp_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Identities_Variance_Fields = {
  __typename?: 'identities_variance_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "identities" */
export type Identities_Variance_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction = {
  __typename?: 'invoice_parkable_transaction';
  /** An object relationship */
  invoice: Invoices;
  invoice_id: Scalars['bigint']['output'];
  /** An object relationship */
  parkable_transaction: Parkable_Transactions;
  parkable_transaction_id: Scalars['bigint']['output'];
  /** An object relationship */
  rParkableTransaction?: Maybe<R_Parkable_Transactions>;
};

/** aggregated selection of "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Aggregate = {
  __typename?: 'invoice_parkable_transaction_aggregate';
  aggregate?: Maybe<Invoice_Parkable_Transaction_Aggregate_Fields>;
  nodes: Array<Invoice_Parkable_Transaction>;
};

export type Invoice_Parkable_Transaction_Aggregate_Bool_Exp = {
  count?: InputMaybe<Invoice_Parkable_Transaction_Aggregate_Bool_Exp_Count>;
};

export type Invoice_Parkable_Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Aggregate_Fields = {
  __typename?: 'invoice_parkable_transaction_aggregate_fields';
  avg?: Maybe<Invoice_Parkable_Transaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Invoice_Parkable_Transaction_Max_Fields>;
  min?: Maybe<Invoice_Parkable_Transaction_Min_Fields>;
  stddev?: Maybe<Invoice_Parkable_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Parkable_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Parkable_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Parkable_Transaction_Sum_Fields>;
  var_pop?: Maybe<Invoice_Parkable_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Parkable_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Parkable_Transaction_Variance_Fields>;
};


/** aggregate fields of "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Invoice_Parkable_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoice_Parkable_Transaction_Max_Order_By>;
  min?: InputMaybe<Invoice_Parkable_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Invoice_Parkable_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoice_Parkable_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoice_Parkable_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoice_Parkable_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Invoice_Parkable_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoice_Parkable_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoice_Parkable_Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Invoice_Parkable_Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoice_Parkable_Transaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoice_Parkable_Transaction_Avg_Fields = {
  __typename?: 'invoice_parkable_transaction_avg_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Avg_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoice_parkable_transaction". All fields are combined with a logical 'AND'. */
export type Invoice_Parkable_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Parkable_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Parkable_Transaction_Bool_Exp>>;
  invoice?: InputMaybe<Invoices_Bool_Exp>;
  invoice_id?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  rParkableTransaction?: InputMaybe<R_Parkable_Transactions_Bool_Exp>;
};

/** unique or primary key constraints on table "invoice_parkable_transaction" */
export enum Invoice_Parkable_Transaction_Constraint {
  /** unique or primary key constraint on columns "parkable_transaction_id", "invoice_id" */
  InvoiceParkableTransactionPkey = 'invoice_parkable_transaction_pkey'
}

/** input type for incrementing numeric columns in table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Inc_Input = {
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Insert_Input = {
  invoice?: InputMaybe<Invoices_Obj_Rel_Insert_Input>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Obj_Rel_Insert_Input>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  rParkableTransaction?: InputMaybe<R_Parkable_Transactions_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Invoice_Parkable_Transaction_Max_Fields = {
  __typename?: 'invoice_parkable_transaction_max_fields';
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Max_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoice_Parkable_Transaction_Min_Fields = {
  __typename?: 'invoice_parkable_transaction_min_fields';
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Min_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Mutation_Response = {
  __typename?: 'invoice_parkable_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice_Parkable_Transaction>;
};

/** on_conflict condition type for table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_On_Conflict = {
  constraint: Invoice_Parkable_Transaction_Constraint;
  update_columns?: Array<Invoice_Parkable_Transaction_Update_Column>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "invoice_parkable_transaction". */
export type Invoice_Parkable_Transaction_Order_By = {
  invoice?: InputMaybe<Invoices_Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
  rParkableTransaction?: InputMaybe<R_Parkable_Transactions_Order_By>;
};

/** primary key columns input for table: invoice_parkable_transaction */
export type Invoice_Parkable_Transaction_Pk_Columns_Input = {
  invoice_id: Scalars['bigint']['input'];
  parkable_transaction_id: Scalars['bigint']['input'];
};

/** select columns of table "invoice_parkable_transaction" */
export enum Invoice_Parkable_Transaction_Select_Column {
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id'
}

/** input type for updating data in table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Set_Input = {
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Invoice_Parkable_Transaction_Stddev_Fields = {
  __typename?: 'invoice_parkable_transaction_stddev_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Stddev_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Parkable_Transaction_Stddev_Pop_Fields = {
  __typename?: 'invoice_parkable_transaction_stddev_pop_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Stddev_Pop_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Parkable_Transaction_Stddev_Samp_Fields = {
  __typename?: 'invoice_parkable_transaction_stddev_samp_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Stddev_Samp_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Parkable_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Parkable_Transaction_Stream_Cursor_Value_Input = {
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Invoice_Parkable_Transaction_Sum_Fields = {
  __typename?: 'invoice_parkable_transaction_sum_fields';
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Sum_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "invoice_parkable_transaction" */
export enum Invoice_Parkable_Transaction_Update_Column {
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id'
}

export type Invoice_Parkable_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoice_Parkable_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Parkable_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Parkable_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoice_Parkable_Transaction_Var_Pop_Fields = {
  __typename?: 'invoice_parkable_transaction_var_pop_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Var_Pop_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoice_Parkable_Transaction_Var_Samp_Fields = {
  __typename?: 'invoice_parkable_transaction_var_samp_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Var_Samp_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoice_Parkable_Transaction_Variance_Fields = {
  __typename?: 'invoice_parkable_transaction_variance_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "invoice_parkable_transaction" */
export type Invoice_Parkable_Transaction_Variance_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction = {
  __typename?: 'invoice_wallet_transaction';
  /** An object relationship */
  invoice: Invoices;
  invoice_id: Scalars['bigint']['output'];
  /** An object relationship */
  wallet_transaction: Wallet_Transactions;
  wallet_transaction_id: Scalars['bigint']['output'];
};

/** aggregated selection of "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Aggregate = {
  __typename?: 'invoice_wallet_transaction_aggregate';
  aggregate?: Maybe<Invoice_Wallet_Transaction_Aggregate_Fields>;
  nodes: Array<Invoice_Wallet_Transaction>;
};

export type Invoice_Wallet_Transaction_Aggregate_Bool_Exp = {
  count?: InputMaybe<Invoice_Wallet_Transaction_Aggregate_Bool_Exp_Count>;
};

export type Invoice_Wallet_Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoice_Wallet_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Aggregate_Fields = {
  __typename?: 'invoice_wallet_transaction_aggregate_fields';
  avg?: Maybe<Invoice_Wallet_Transaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Invoice_Wallet_Transaction_Max_Fields>;
  min?: Maybe<Invoice_Wallet_Transaction_Min_Fields>;
  stddev?: Maybe<Invoice_Wallet_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Wallet_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Wallet_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Wallet_Transaction_Sum_Fields>;
  var_pop?: Maybe<Invoice_Wallet_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Wallet_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Wallet_Transaction_Variance_Fields>;
};


/** aggregate fields of "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Wallet_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Invoice_Wallet_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoice_Wallet_Transaction_Max_Order_By>;
  min?: InputMaybe<Invoice_Wallet_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Invoice_Wallet_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoice_Wallet_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoice_Wallet_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoice_Wallet_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Invoice_Wallet_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoice_Wallet_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoice_Wallet_Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Invoice_Wallet_Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoice_Wallet_Transaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoice_Wallet_Transaction_Avg_Fields = {
  __typename?: 'invoice_wallet_transaction_avg_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Avg_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoice_wallet_transaction". All fields are combined with a logical 'AND'. */
export type Invoice_Wallet_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Wallet_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Wallet_Transaction_Bool_Exp>>;
  invoice?: InputMaybe<Invoices_Bool_Exp>;
  invoice_id?: InputMaybe<Bigint_Comparison_Exp>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "invoice_wallet_transaction" */
export enum Invoice_Wallet_Transaction_Constraint {
  /** unique or primary key constraint on columns "wallet_transaction_id", "invoice_id" */
  InvoiceWalletTransactionPkey = 'invoice_wallet_transaction_pkey'
}

/** input type for incrementing numeric columns in table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Inc_Input = {
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Insert_Input = {
  invoice?: InputMaybe<Invoices_Obj_Rel_Insert_Input>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Obj_Rel_Insert_Input>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Invoice_Wallet_Transaction_Max_Fields = {
  __typename?: 'invoice_wallet_transaction_max_fields';
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Max_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoice_Wallet_Transaction_Min_Fields = {
  __typename?: 'invoice_wallet_transaction_min_fields';
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Min_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Mutation_Response = {
  __typename?: 'invoice_wallet_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice_Wallet_Transaction>;
};

/** on_conflict condition type for table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_On_Conflict = {
  constraint: Invoice_Wallet_Transaction_Constraint;
  update_columns?: Array<Invoice_Wallet_Transaction_Update_Column>;
  where?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "invoice_wallet_transaction". */
export type Invoice_Wallet_Transaction_Order_By = {
  invoice?: InputMaybe<Invoices_Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoice_wallet_transaction */
export type Invoice_Wallet_Transaction_Pk_Columns_Input = {
  invoice_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};

/** select columns of table "invoice_wallet_transaction" */
export enum Invoice_Wallet_Transaction_Select_Column {
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

/** input type for updating data in table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Set_Input = {
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Invoice_Wallet_Transaction_Stddev_Fields = {
  __typename?: 'invoice_wallet_transaction_stddev_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Stddev_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Wallet_Transaction_Stddev_Pop_Fields = {
  __typename?: 'invoice_wallet_transaction_stddev_pop_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Stddev_Pop_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Wallet_Transaction_Stddev_Samp_Fields = {
  __typename?: 'invoice_wallet_transaction_stddev_samp_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Stddev_Samp_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Wallet_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Wallet_Transaction_Stream_Cursor_Value_Input = {
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Invoice_Wallet_Transaction_Sum_Fields = {
  __typename?: 'invoice_wallet_transaction_sum_fields';
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Sum_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "invoice_wallet_transaction" */
export enum Invoice_Wallet_Transaction_Update_Column {
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

export type Invoice_Wallet_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoice_Wallet_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Wallet_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Wallet_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoice_Wallet_Transaction_Var_Pop_Fields = {
  __typename?: 'invoice_wallet_transaction_var_pop_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Var_Pop_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoice_Wallet_Transaction_Var_Samp_Fields = {
  __typename?: 'invoice_wallet_transaction_var_samp_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Var_Samp_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoice_Wallet_Transaction_Variance_Fields = {
  __typename?: 'invoice_wallet_transaction_variance_fields';
  invoice_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "invoice_wallet_transaction" */
export type Invoice_Wallet_Transaction_Variance_Order_By = {
  invoice_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "invoices" */
export type Invoices = {
  __typename?: 'invoices';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  invoice_parkable_transactions: Array<Invoice_Parkable_Transaction>;
  /** An aggregate relationship */
  invoice_parkable_transactions_aggregate: Invoice_Parkable_Transaction_Aggregate;
  /** An array relationship */
  invoice_wallet_transactions: Array<Invoice_Wallet_Transaction>;
  /** An aggregate relationship */
  invoice_wallet_transactions_aggregate: Invoice_Wallet_Transaction_Aggregate;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  line_items: Array<Line_Items>;
  /** An aggregate relationship */
  line_items_aggregate: Line_Items_Aggregate;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  processing_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  rUser?: Maybe<R_Users>;
  status: Scalars['String']['output'];
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferable_subtotal?: Maybe<Scalars['Int']['output']>;
  transferable_tax?: Maybe<Scalars['Int']['output']>;
  transferable_total?: Maybe<Scalars['Int']['output']>;
  try: Scalars['smallint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "invoices" */
export type InvoicesInvoice_Parkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoice_Parkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoice_Wallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoice_Wallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "invoices" */
export type InvoicesLine_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Items_Order_By>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};


/** columns and relationships of "invoices" */
export type InvoicesLine_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Items_Order_By>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};


/** columns and relationships of "invoices" */
export type InvoicesPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "invoices" */
export type InvoicesPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** aggregated selection of "invoices" */
export type Invoices_Aggregate = {
  __typename?: 'invoices_aggregate';
  aggregate?: Maybe<Invoices_Aggregate_Fields>;
  nodes: Array<Invoices>;
};

export type Invoices_Aggregate_Bool_Exp = {
  count?: InputMaybe<Invoices_Aggregate_Bool_Exp_Count>;
};

export type Invoices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoices" */
export type Invoices_Aggregate_Fields = {
  __typename?: 'invoices_aggregate_fields';
  avg?: Maybe<Invoices_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Invoices_Max_Fields>;
  min?: Maybe<Invoices_Min_Fields>;
  stddev?: Maybe<Invoices_Stddev_Fields>;
  stddev_pop?: Maybe<Invoices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoices_Stddev_Samp_Fields>;
  sum?: Maybe<Invoices_Sum_Fields>;
  var_pop?: Maybe<Invoices_Var_Pop_Fields>;
  var_samp?: Maybe<Invoices_Var_Samp_Fields>;
  variance?: Maybe<Invoices_Variance_Fields>;
};


/** aggregate fields of "invoices" */
export type Invoices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "invoices" */
export type Invoices_Aggregate_Order_By = {
  avg?: InputMaybe<Invoices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoices_Max_Order_By>;
  min?: InputMaybe<Invoices_Min_Order_By>;
  stddev?: InputMaybe<Invoices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoices_Sum_Order_By>;
  var_pop?: InputMaybe<Invoices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoices_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "invoices" */
export type Invoices_Arr_Rel_Insert_Input = {
  data: Array<Invoices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoices_Avg_Fields = {
  __typename?: 'invoices_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_tax?: Maybe<Scalars['Float']['output']>;
  transferable_total?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "invoices" */
export type Invoices_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoices". All fields are combined with a logical 'AND'. */
export type Invoices_Bool_Exp = {
  _and?: InputMaybe<Array<Invoices_Bool_Exp>>;
  _not?: InputMaybe<Invoices_Bool_Exp>;
  _or?: InputMaybe<Array<Invoices_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_parkable_transactions?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
  invoice_parkable_transactions_aggregate?: InputMaybe<Invoice_Parkable_Transaction_Aggregate_Bool_Exp>;
  invoice_wallet_transactions?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
  invoice_wallet_transactions_aggregate?: InputMaybe<Invoice_Wallet_Transaction_Aggregate_Bool_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  line_items?: InputMaybe<Line_Items_Bool_Exp>;
  line_items_aggregate?: InputMaybe<Line_Items_Aggregate_Bool_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  processed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  processing_at?: InputMaybe<Timestamp_Comparison_Exp>;
  rUser?: InputMaybe<R_Users_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subtotal?: InputMaybe<Int_Comparison_Exp>;
  tax?: InputMaybe<Int_Comparison_Exp>;
  total?: InputMaybe<Int_Comparison_Exp>;
  total_paid?: InputMaybe<Int_Comparison_Exp>;
  total_unpaid?: InputMaybe<Int_Comparison_Exp>;
  transferable_subtotal?: InputMaybe<Int_Comparison_Exp>;
  transferable_tax?: InputMaybe<Int_Comparison_Exp>;
  transferable_total?: InputMaybe<Int_Comparison_Exp>;
  try?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "invoices" */
export enum Invoices_Constraint {
  /** unique or primary key constraint on columns "id" */
  InvoicesPkey = 'invoices_pkey'
}

/** input type for incrementing numeric columns in table "invoices" */
export type Invoices_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferable_subtotal?: InputMaybe<Scalars['Int']['input']>;
  transferable_tax?: InputMaybe<Scalars['Int']['input']>;
  transferable_total?: InputMaybe<Scalars['Int']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "invoices" */
export type Invoices_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  invoice_parkable_transactions?: InputMaybe<Invoice_Parkable_Transaction_Arr_Rel_Insert_Input>;
  invoice_wallet_transactions?: InputMaybe<Invoice_Wallet_Transaction_Arr_Rel_Insert_Input>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  line_items?: InputMaybe<Line_Items_Arr_Rel_Insert_Input>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  rUser?: InputMaybe<R_Users_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferable_subtotal?: InputMaybe<Scalars['Int']['input']>;
  transferable_tax?: InputMaybe<Scalars['Int']['input']>;
  transferable_total?: InputMaybe<Scalars['Int']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Invoices_Max_Fields = {
  __typename?: 'invoices_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  processing_at?: Maybe<Scalars['timestamp']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferable_subtotal?: Maybe<Scalars['Int']['output']>;
  transferable_tax?: Maybe<Scalars['Int']['output']>;
  transferable_total?: Maybe<Scalars['Int']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "invoices" */
export type Invoices_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  processing_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoices_Min_Fields = {
  __typename?: 'invoices_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  processing_at?: Maybe<Scalars['timestamp']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferable_subtotal?: Maybe<Scalars['Int']['output']>;
  transferable_tax?: Maybe<Scalars['Int']['output']>;
  transferable_total?: Maybe<Scalars['Int']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "invoices" */
export type Invoices_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  processing_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoices" */
export type Invoices_Mutation_Response = {
  __typename?: 'invoices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoices>;
};

/** input type for inserting object relation for remote table "invoices" */
export type Invoices_Obj_Rel_Insert_Input = {
  data: Invoices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};

/** on_conflict condition type for table "invoices" */
export type Invoices_On_Conflict = {
  constraint: Invoices_Constraint;
  update_columns?: Array<Invoices_Update_Column>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};

/** Ordering options when selecting data from "invoices". */
export type Invoices_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  invoice_parkable_transactions_aggregate?: InputMaybe<Invoice_Parkable_Transaction_Aggregate_Order_By>;
  invoice_wallet_transactions_aggregate?: InputMaybe<Invoice_Wallet_Transaction_Aggregate_Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  line_items_aggregate?: InputMaybe<Line_Items_Aggregate_Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  processed_at?: InputMaybe<Order_By>;
  processing_at?: InputMaybe<Order_By>;
  rUser?: InputMaybe<R_Users_Order_By>;
  status?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoices */
export type Invoices_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "invoices" */
export enum Invoices_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ProcessingAt = 'processing_at',
  /** column name */
  Status = 'status',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  Total = 'total',
  /** column name */
  TotalPaid = 'total_paid',
  /** column name */
  TotalUnpaid = 'total_unpaid',
  /** column name */
  TransferableSubtotal = 'transferable_subtotal',
  /** column name */
  TransferableTax = 'transferable_tax',
  /** column name */
  TransferableTotal = 'transferable_total',
  /** column name */
  Try = 'try',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "invoices" */
export type Invoices_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferable_subtotal?: InputMaybe<Scalars['Int']['input']>;
  transferable_tax?: InputMaybe<Scalars['Int']['input']>;
  transferable_total?: InputMaybe<Scalars['Int']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Invoices_Stddev_Fields = {
  __typename?: 'invoices_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_tax?: Maybe<Scalars['Float']['output']>;
  transferable_total?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "invoices" */
export type Invoices_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoices_Stddev_Pop_Fields = {
  __typename?: 'invoices_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_tax?: Maybe<Scalars['Float']['output']>;
  transferable_total?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "invoices" */
export type Invoices_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoices_Stddev_Samp_Fields = {
  __typename?: 'invoices_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_tax?: Maybe<Scalars['Float']['output']>;
  transferable_total?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "invoices" */
export type Invoices_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoices" */
export type Invoices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoices_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferable_subtotal?: InputMaybe<Scalars['Int']['input']>;
  transferable_tax?: InputMaybe<Scalars['Int']['input']>;
  transferable_total?: InputMaybe<Scalars['Int']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Invoices_Sum_Fields = {
  __typename?: 'invoices_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferable_subtotal?: Maybe<Scalars['Int']['output']>;
  transferable_tax?: Maybe<Scalars['Int']['output']>;
  transferable_total?: Maybe<Scalars['Int']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "invoices" */
export type Invoices_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "invoices" */
export enum Invoices_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ProcessingAt = 'processing_at',
  /** column name */
  Status = 'status',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  Total = 'total',
  /** column name */
  TotalPaid = 'total_paid',
  /** column name */
  TotalUnpaid = 'total_unpaid',
  /** column name */
  TransferableSubtotal = 'transferable_subtotal',
  /** column name */
  TransferableTax = 'transferable_tax',
  /** column name */
  TransferableTotal = 'transferable_total',
  /** column name */
  Try = 'try',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Invoices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoices_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoices_Var_Pop_Fields = {
  __typename?: 'invoices_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_tax?: Maybe<Scalars['Float']['output']>;
  transferable_total?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "invoices" */
export type Invoices_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoices_Var_Samp_Fields = {
  __typename?: 'invoices_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_tax?: Maybe<Scalars['Float']['output']>;
  transferable_total?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "invoices" */
export type Invoices_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoices_Variance_Fields = {
  __typename?: 'invoices_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_tax?: Maybe<Scalars['Float']['output']>;
  transferable_total?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "invoices" */
export type Invoices_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_tax?: InputMaybe<Order_By>;
  transferable_total?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "jobs" */
export type Jobs = {
  __typename?: 'jobs';
  attempts: Scalars['smallint']['output'];
  available_at: Scalars['Int']['output'];
  created_at: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  payload: Scalars['String']['output'];
  queue: Scalars['String']['output'];
  reserved_at?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "jobs" */
export type Jobs_Aggregate = {
  __typename?: 'jobs_aggregate';
  aggregate?: Maybe<Jobs_Aggregate_Fields>;
  nodes: Array<Jobs>;
};

/** aggregate fields of "jobs" */
export type Jobs_Aggregate_Fields = {
  __typename?: 'jobs_aggregate_fields';
  avg?: Maybe<Jobs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Jobs_Max_Fields>;
  min?: Maybe<Jobs_Min_Fields>;
  stddev?: Maybe<Jobs_Stddev_Fields>;
  stddev_pop?: Maybe<Jobs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Jobs_Stddev_Samp_Fields>;
  sum?: Maybe<Jobs_Sum_Fields>;
  var_pop?: Maybe<Jobs_Var_Pop_Fields>;
  var_samp?: Maybe<Jobs_Var_Samp_Fields>;
  variance?: Maybe<Jobs_Variance_Fields>;
};


/** aggregate fields of "jobs" */
export type Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Jobs_Avg_Fields = {
  __typename?: 'jobs_avg_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
  available_at?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reserved_at?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "jobs". All fields are combined with a logical 'AND'. */
export type Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Jobs_Bool_Exp>>;
  _not?: InputMaybe<Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Jobs_Bool_Exp>>;
  attempts?: InputMaybe<Smallint_Comparison_Exp>;
  available_at?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  payload?: InputMaybe<String_Comparison_Exp>;
  queue?: InputMaybe<String_Comparison_Exp>;
  reserved_at?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "jobs" */
export enum Jobs_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobsPkey = 'jobs_pkey'
}

/** input type for incrementing numeric columns in table "jobs" */
export type Jobs_Inc_Input = {
  attempts?: InputMaybe<Scalars['smallint']['input']>;
  available_at?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  reserved_at?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "jobs" */
export type Jobs_Insert_Input = {
  attempts?: InputMaybe<Scalars['smallint']['input']>;
  available_at?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  reserved_at?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Jobs_Max_Fields = {
  __typename?: 'jobs_max_fields';
  attempts?: Maybe<Scalars['smallint']['output']>;
  available_at?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  reserved_at?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Jobs_Min_Fields = {
  __typename?: 'jobs_min_fields';
  attempts?: Maybe<Scalars['smallint']['output']>;
  available_at?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  reserved_at?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "jobs" */
export type Jobs_Mutation_Response = {
  __typename?: 'jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Jobs>;
};

/** on_conflict condition type for table "jobs" */
export type Jobs_On_Conflict = {
  constraint: Jobs_Constraint;
  update_columns?: Array<Jobs_Update_Column>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "jobs". */
export type Jobs_Order_By = {
  attempts?: InputMaybe<Order_By>;
  available_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  queue?: InputMaybe<Order_By>;
  reserved_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: jobs */
export type Jobs_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "jobs" */
export enum Jobs_Select_Column {
  /** column name */
  Attempts = 'attempts',
  /** column name */
  AvailableAt = 'available_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Queue = 'queue',
  /** column name */
  ReservedAt = 'reserved_at'
}

/** input type for updating data in table "jobs" */
export type Jobs_Set_Input = {
  attempts?: InputMaybe<Scalars['smallint']['input']>;
  available_at?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  reserved_at?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Jobs_Stddev_Fields = {
  __typename?: 'jobs_stddev_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
  available_at?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reserved_at?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Jobs_Stddev_Pop_Fields = {
  __typename?: 'jobs_stddev_pop_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
  available_at?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reserved_at?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Jobs_Stddev_Samp_Fields = {
  __typename?: 'jobs_stddev_samp_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
  available_at?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reserved_at?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "jobs" */
export type Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Jobs_Stream_Cursor_Value_Input = {
  attempts?: InputMaybe<Scalars['smallint']['input']>;
  available_at?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  reserved_at?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Jobs_Sum_Fields = {
  __typename?: 'jobs_sum_fields';
  attempts?: Maybe<Scalars['smallint']['output']>;
  available_at?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  reserved_at?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "jobs" */
export enum Jobs_Update_Column {
  /** column name */
  Attempts = 'attempts',
  /** column name */
  AvailableAt = 'available_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Queue = 'queue',
  /** column name */
  ReservedAt = 'reserved_at'
}

export type Jobs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Jobs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Jobs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Jobs_Var_Pop_Fields = {
  __typename?: 'jobs_var_pop_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
  available_at?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reserved_at?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Jobs_Var_Samp_Fields = {
  __typename?: 'jobs_var_samp_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
  available_at?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reserved_at?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Jobs_Variance_Fields = {
  __typename?: 'jobs_variance_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
  available_at?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  reserved_at?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

/** columns and relationships of "legacy_migrations" */
export type Legacy_Migrations = {
  __typename?: 'legacy_migrations';
  active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  completed_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  last_active_parkable_transaction_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_active_parkable_transaction_sync_error?: Maybe<Scalars['String']['output']>;
  last_active_parkable_transaction_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_general_error?: Maybe<Scalars['String']['output']>;
  last_general_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_payment_methods_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_payment_methods_sync_error?: Maybe<Scalars['String']['output']>;
  last_payment_methods_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_user_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_user_sync_error?: Maybe<Scalars['String']['output']>;
  last_user_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_vehicles_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_vehicles_sync_error?: Maybe<Scalars['String']['output']>;
  last_vehicles_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_wallet_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_wallet_sync_error?: Maybe<Scalars['String']['output']>;
  last_wallet_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  started_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "legacy_migrations" */
export type Legacy_Migrations_Aggregate = {
  __typename?: 'legacy_migrations_aggregate';
  aggregate?: Maybe<Legacy_Migrations_Aggregate_Fields>;
  nodes: Array<Legacy_Migrations>;
};

export type Legacy_Migrations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Legacy_Migrations_Aggregate_Bool_Exp_Count>;
};

export type Legacy_Migrations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Legacy_Migrations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Legacy_Migrations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "legacy_migrations" */
export type Legacy_Migrations_Aggregate_Fields = {
  __typename?: 'legacy_migrations_aggregate_fields';
  avg?: Maybe<Legacy_Migrations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Legacy_Migrations_Max_Fields>;
  min?: Maybe<Legacy_Migrations_Min_Fields>;
  stddev?: Maybe<Legacy_Migrations_Stddev_Fields>;
  stddev_pop?: Maybe<Legacy_Migrations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Legacy_Migrations_Stddev_Samp_Fields>;
  sum?: Maybe<Legacy_Migrations_Sum_Fields>;
  var_pop?: Maybe<Legacy_Migrations_Var_Pop_Fields>;
  var_samp?: Maybe<Legacy_Migrations_Var_Samp_Fields>;
  variance?: Maybe<Legacy_Migrations_Variance_Fields>;
};


/** aggregate fields of "legacy_migrations" */
export type Legacy_Migrations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legacy_Migrations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "legacy_migrations" */
export type Legacy_Migrations_Aggregate_Order_By = {
  avg?: InputMaybe<Legacy_Migrations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Legacy_Migrations_Max_Order_By>;
  min?: InputMaybe<Legacy_Migrations_Min_Order_By>;
  stddev?: InputMaybe<Legacy_Migrations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Legacy_Migrations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Legacy_Migrations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Legacy_Migrations_Sum_Order_By>;
  var_pop?: InputMaybe<Legacy_Migrations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Legacy_Migrations_Var_Samp_Order_By>;
  variance?: InputMaybe<Legacy_Migrations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "legacy_migrations" */
export type Legacy_Migrations_Arr_Rel_Insert_Input = {
  data: Array<Legacy_Migrations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Legacy_Migrations_On_Conflict>;
};

/** aggregate avg on columns */
export type Legacy_Migrations_Avg_Fields = {
  __typename?: 'legacy_migrations_avg_fields';
  active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "legacy_migrations" */
export type Legacy_Migrations_Avg_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "legacy_migrations". All fields are combined with a logical 'AND'. */
export type Legacy_Migrations_Bool_Exp = {
  _and?: InputMaybe<Array<Legacy_Migrations_Bool_Exp>>;
  _not?: InputMaybe<Legacy_Migrations_Bool_Exp>;
  _or?: InputMaybe<Array<Legacy_Migrations_Bool_Exp>>;
  active_parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_active_parkable_transaction_sync_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_active_parkable_transaction_sync_error?: InputMaybe<String_Comparison_Exp>;
  last_active_parkable_transaction_sync_error_sentry_event_id?: InputMaybe<String_Comparison_Exp>;
  last_general_error?: InputMaybe<String_Comparison_Exp>;
  last_general_error_sentry_event_id?: InputMaybe<String_Comparison_Exp>;
  last_payment_methods_sync_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_payment_methods_sync_error?: InputMaybe<String_Comparison_Exp>;
  last_payment_methods_sync_error_sentry_event_id?: InputMaybe<String_Comparison_Exp>;
  last_user_sync_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_user_sync_error?: InputMaybe<String_Comparison_Exp>;
  last_user_sync_error_sentry_event_id?: InputMaybe<String_Comparison_Exp>;
  last_vehicles_sync_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_vehicles_sync_error?: InputMaybe<String_Comparison_Exp>;
  last_vehicles_sync_error_sentry_event_id?: InputMaybe<String_Comparison_Exp>;
  last_wallet_sync_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_wallet_sync_error?: InputMaybe<String_Comparison_Exp>;
  last_wallet_sync_error_sentry_event_id?: InputMaybe<String_Comparison_Exp>;
  legacy_active_parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  started_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "legacy_migrations" */
export enum Legacy_Migrations_Constraint {
  /** unique or primary key constraint on columns "id" */
  LegacyMigrationsPkey = 'legacy_migrations_pkey',
  /** unique or primary key constraint on columns "user_id" */
  LegacyMigrationsUserIdUnique = 'legacy_migrations_user_id_unique'
}

/** input type for incrementing numeric columns in table "legacy_migrations" */
export type Legacy_Migrations_Inc_Input = {
  active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "legacy_migrations" */
export type Legacy_Migrations_Insert_Input = {
  active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  completed_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_active_parkable_transaction_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_active_parkable_transaction_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_active_parkable_transaction_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_general_error?: InputMaybe<Scalars['String']['input']>;
  last_general_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_payment_methods_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_payment_methods_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_payment_methods_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_user_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_user_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_user_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_vehicles_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_vehicles_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_vehicles_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_wallet_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_wallet_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_wallet_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  legacy_active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Legacy_Migrations_Max_Fields = {
  __typename?: 'legacy_migrations_max_fields';
  active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  completed_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_active_parkable_transaction_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_active_parkable_transaction_sync_error?: Maybe<Scalars['String']['output']>;
  last_active_parkable_transaction_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_general_error?: Maybe<Scalars['String']['output']>;
  last_general_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_payment_methods_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_payment_methods_sync_error?: Maybe<Scalars['String']['output']>;
  last_payment_methods_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_user_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_user_sync_error?: Maybe<Scalars['String']['output']>;
  last_user_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_vehicles_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_vehicles_sync_error?: Maybe<Scalars['String']['output']>;
  last_vehicles_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_wallet_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_wallet_sync_error?: Maybe<Scalars['String']['output']>;
  last_wallet_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  started_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "legacy_migrations" */
export type Legacy_Migrations_Max_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active_parkable_transaction_sync_at?: InputMaybe<Order_By>;
  last_active_parkable_transaction_sync_error?: InputMaybe<Order_By>;
  last_active_parkable_transaction_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_general_error?: InputMaybe<Order_By>;
  last_general_error_sentry_event_id?: InputMaybe<Order_By>;
  last_payment_methods_sync_at?: InputMaybe<Order_By>;
  last_payment_methods_sync_error?: InputMaybe<Order_By>;
  last_payment_methods_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_user_sync_at?: InputMaybe<Order_By>;
  last_user_sync_error?: InputMaybe<Order_By>;
  last_user_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_vehicles_sync_at?: InputMaybe<Order_By>;
  last_vehicles_sync_error?: InputMaybe<Order_By>;
  last_vehicles_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_wallet_sync_at?: InputMaybe<Order_By>;
  last_wallet_sync_error?: InputMaybe<Order_By>;
  last_wallet_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Legacy_Migrations_Min_Fields = {
  __typename?: 'legacy_migrations_min_fields';
  active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  completed_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_active_parkable_transaction_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_active_parkable_transaction_sync_error?: Maybe<Scalars['String']['output']>;
  last_active_parkable_transaction_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_general_error?: Maybe<Scalars['String']['output']>;
  last_general_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_payment_methods_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_payment_methods_sync_error?: Maybe<Scalars['String']['output']>;
  last_payment_methods_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_user_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_user_sync_error?: Maybe<Scalars['String']['output']>;
  last_user_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_vehicles_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_vehicles_sync_error?: Maybe<Scalars['String']['output']>;
  last_vehicles_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  last_wallet_sync_at?: Maybe<Scalars['timestamp']['output']>;
  last_wallet_sync_error?: Maybe<Scalars['String']['output']>;
  last_wallet_sync_error_sentry_event_id?: Maybe<Scalars['String']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  started_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "legacy_migrations" */
export type Legacy_Migrations_Min_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active_parkable_transaction_sync_at?: InputMaybe<Order_By>;
  last_active_parkable_transaction_sync_error?: InputMaybe<Order_By>;
  last_active_parkable_transaction_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_general_error?: InputMaybe<Order_By>;
  last_general_error_sentry_event_id?: InputMaybe<Order_By>;
  last_payment_methods_sync_at?: InputMaybe<Order_By>;
  last_payment_methods_sync_error?: InputMaybe<Order_By>;
  last_payment_methods_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_user_sync_at?: InputMaybe<Order_By>;
  last_user_sync_error?: InputMaybe<Order_By>;
  last_user_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_vehicles_sync_at?: InputMaybe<Order_By>;
  last_vehicles_sync_error?: InputMaybe<Order_By>;
  last_vehicles_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_wallet_sync_at?: InputMaybe<Order_By>;
  last_wallet_sync_error?: InputMaybe<Order_By>;
  last_wallet_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "legacy_migrations" */
export type Legacy_Migrations_Mutation_Response = {
  __typename?: 'legacy_migrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Legacy_Migrations>;
};

/** input type for inserting object relation for remote table "legacy_migrations" */
export type Legacy_Migrations_Obj_Rel_Insert_Input = {
  data: Legacy_Migrations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Legacy_Migrations_On_Conflict>;
};

/** on_conflict condition type for table "legacy_migrations" */
export type Legacy_Migrations_On_Conflict = {
  constraint: Legacy_Migrations_Constraint;
  update_columns?: Array<Legacy_Migrations_Update_Column>;
  where?: InputMaybe<Legacy_Migrations_Bool_Exp>;
};

/** Ordering options when selecting data from "legacy_migrations". */
export type Legacy_Migrations_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active_parkable_transaction_sync_at?: InputMaybe<Order_By>;
  last_active_parkable_transaction_sync_error?: InputMaybe<Order_By>;
  last_active_parkable_transaction_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_general_error?: InputMaybe<Order_By>;
  last_general_error_sentry_event_id?: InputMaybe<Order_By>;
  last_payment_methods_sync_at?: InputMaybe<Order_By>;
  last_payment_methods_sync_error?: InputMaybe<Order_By>;
  last_payment_methods_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_user_sync_at?: InputMaybe<Order_By>;
  last_user_sync_error?: InputMaybe<Order_By>;
  last_user_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_vehicles_sync_at?: InputMaybe<Order_By>;
  last_vehicles_sync_error?: InputMaybe<Order_By>;
  last_vehicles_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  last_wallet_sync_at?: InputMaybe<Order_By>;
  last_wallet_sync_error?: InputMaybe<Order_By>;
  last_wallet_sync_error_sentry_event_id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: legacy_migrations */
export type Legacy_Migrations_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "legacy_migrations" */
export enum Legacy_Migrations_Select_Column {
  /** column name */
  ActiveParkableTransactionId = 'active_parkable_transaction_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastActiveParkableTransactionSyncAt = 'last_active_parkable_transaction_sync_at',
  /** column name */
  LastActiveParkableTransactionSyncError = 'last_active_parkable_transaction_sync_error',
  /** column name */
  LastActiveParkableTransactionSyncErrorSentryEventId = 'last_active_parkable_transaction_sync_error_sentry_event_id',
  /** column name */
  LastGeneralError = 'last_general_error',
  /** column name */
  LastGeneralErrorSentryEventId = 'last_general_error_sentry_event_id',
  /** column name */
  LastPaymentMethodsSyncAt = 'last_payment_methods_sync_at',
  /** column name */
  LastPaymentMethodsSyncError = 'last_payment_methods_sync_error',
  /** column name */
  LastPaymentMethodsSyncErrorSentryEventId = 'last_payment_methods_sync_error_sentry_event_id',
  /** column name */
  LastUserSyncAt = 'last_user_sync_at',
  /** column name */
  LastUserSyncError = 'last_user_sync_error',
  /** column name */
  LastUserSyncErrorSentryEventId = 'last_user_sync_error_sentry_event_id',
  /** column name */
  LastVehiclesSyncAt = 'last_vehicles_sync_at',
  /** column name */
  LastVehiclesSyncError = 'last_vehicles_sync_error',
  /** column name */
  LastVehiclesSyncErrorSentryEventId = 'last_vehicles_sync_error_sentry_event_id',
  /** column name */
  LastWalletSyncAt = 'last_wallet_sync_at',
  /** column name */
  LastWalletSyncError = 'last_wallet_sync_error',
  /** column name */
  LastWalletSyncErrorSentryEventId = 'last_wallet_sync_error_sentry_event_id',
  /** column name */
  LegacyActiveParkableTransactionId = 'legacy_active_parkable_transaction_id',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "legacy_migrations" */
export type Legacy_Migrations_Set_Input = {
  active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  completed_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_active_parkable_transaction_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_active_parkable_transaction_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_active_parkable_transaction_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_general_error?: InputMaybe<Scalars['String']['input']>;
  last_general_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_payment_methods_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_payment_methods_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_payment_methods_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_user_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_user_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_user_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_vehicles_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_vehicles_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_vehicles_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_wallet_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_wallet_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_wallet_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  legacy_active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Legacy_Migrations_Stddev_Fields = {
  __typename?: 'legacy_migrations_stddev_fields';
  active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "legacy_migrations" */
export type Legacy_Migrations_Stddev_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Legacy_Migrations_Stddev_Pop_Fields = {
  __typename?: 'legacy_migrations_stddev_pop_fields';
  active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "legacy_migrations" */
export type Legacy_Migrations_Stddev_Pop_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Legacy_Migrations_Stddev_Samp_Fields = {
  __typename?: 'legacy_migrations_stddev_samp_fields';
  active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "legacy_migrations" */
export type Legacy_Migrations_Stddev_Samp_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "legacy_migrations" */
export type Legacy_Migrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legacy_Migrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legacy_Migrations_Stream_Cursor_Value_Input = {
  active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  completed_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_active_parkable_transaction_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_active_parkable_transaction_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_active_parkable_transaction_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_general_error?: InputMaybe<Scalars['String']['input']>;
  last_general_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_payment_methods_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_payment_methods_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_payment_methods_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_user_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_user_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_user_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_vehicles_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_vehicles_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_vehicles_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  last_wallet_sync_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_wallet_sync_error?: InputMaybe<Scalars['String']['input']>;
  last_wallet_sync_error_sentry_event_id?: InputMaybe<Scalars['String']['input']>;
  legacy_active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Legacy_Migrations_Sum_Fields = {
  __typename?: 'legacy_migrations_sum_fields';
  active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "legacy_migrations" */
export type Legacy_Migrations_Sum_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "legacy_migrations" */
export enum Legacy_Migrations_Update_Column {
  /** column name */
  ActiveParkableTransactionId = 'active_parkable_transaction_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastActiveParkableTransactionSyncAt = 'last_active_parkable_transaction_sync_at',
  /** column name */
  LastActiveParkableTransactionSyncError = 'last_active_parkable_transaction_sync_error',
  /** column name */
  LastActiveParkableTransactionSyncErrorSentryEventId = 'last_active_parkable_transaction_sync_error_sentry_event_id',
  /** column name */
  LastGeneralError = 'last_general_error',
  /** column name */
  LastGeneralErrorSentryEventId = 'last_general_error_sentry_event_id',
  /** column name */
  LastPaymentMethodsSyncAt = 'last_payment_methods_sync_at',
  /** column name */
  LastPaymentMethodsSyncError = 'last_payment_methods_sync_error',
  /** column name */
  LastPaymentMethodsSyncErrorSentryEventId = 'last_payment_methods_sync_error_sentry_event_id',
  /** column name */
  LastUserSyncAt = 'last_user_sync_at',
  /** column name */
  LastUserSyncError = 'last_user_sync_error',
  /** column name */
  LastUserSyncErrorSentryEventId = 'last_user_sync_error_sentry_event_id',
  /** column name */
  LastVehiclesSyncAt = 'last_vehicles_sync_at',
  /** column name */
  LastVehiclesSyncError = 'last_vehicles_sync_error',
  /** column name */
  LastVehiclesSyncErrorSentryEventId = 'last_vehicles_sync_error_sentry_event_id',
  /** column name */
  LastWalletSyncAt = 'last_wallet_sync_at',
  /** column name */
  LastWalletSyncError = 'last_wallet_sync_error',
  /** column name */
  LastWalletSyncErrorSentryEventId = 'last_wallet_sync_error_sentry_event_id',
  /** column name */
  LegacyActiveParkableTransactionId = 'legacy_active_parkable_transaction_id',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Legacy_Migrations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Legacy_Migrations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legacy_Migrations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legacy_Migrations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Legacy_Migrations_Var_Pop_Fields = {
  __typename?: 'legacy_migrations_var_pop_fields';
  active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "legacy_migrations" */
export type Legacy_Migrations_Var_Pop_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Legacy_Migrations_Var_Samp_Fields = {
  __typename?: 'legacy_migrations_var_samp_fields';
  active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "legacy_migrations" */
export type Legacy_Migrations_Var_Samp_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Legacy_Migrations_Variance_Fields = {
  __typename?: 'legacy_migrations_variance_fields';
  active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "legacy_migrations" */
export type Legacy_Migrations_Variance_Order_By = {
  active_parkable_transaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions = {
  __typename?: 'legacy_parkable_transactions';
  cancelled_at?: Maybe<Scalars['timestamp']['output']>;
  created_at: Scalars['timestamp']['output'];
  id: Scalars['bigint']['output'];
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parkable_area_name?: Maybe<Scalars['String']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  parkable_identifier?: Maybe<Scalars['Int']['output']>;
  parkable_type?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_license_plate?: Maybe<Scalars['String']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_unit?: Maybe<Scalars['String']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_unit?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions_Aggregate = {
  __typename?: 'legacy_parkable_transactions_aggregate';
  aggregate?: Maybe<Legacy_Parkable_Transactions_Aggregate_Fields>;
  nodes: Array<Legacy_Parkable_Transactions>;
};

/** aggregate fields of "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions_Aggregate_Fields = {
  __typename?: 'legacy_parkable_transactions_aggregate_fields';
  avg?: Maybe<Legacy_Parkable_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Legacy_Parkable_Transactions_Max_Fields>;
  min?: Maybe<Legacy_Parkable_Transactions_Min_Fields>;
  stddev?: Maybe<Legacy_Parkable_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Legacy_Parkable_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Legacy_Parkable_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Legacy_Parkable_Transactions_Sum_Fields>;
  var_pop?: Maybe<Legacy_Parkable_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Legacy_Parkable_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Legacy_Parkable_Transactions_Variance_Fields>;
};


/** aggregate fields of "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legacy_Parkable_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Legacy_Parkable_Transactions_Avg_Fields = {
  __typename?: 'legacy_parkable_transactions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "legacy_parkable_transactions". All fields are combined with a logical 'AND'. */
export type Legacy_Parkable_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Legacy_Parkable_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Legacy_Parkable_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Legacy_Parkable_Transactions_Bool_Exp>>;
  cancelled_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  num_etl_failures?: InputMaybe<Smallint_Comparison_Exp>;
  num_etls?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_area_name?: InputMaybe<String_Comparison_Exp>;
  parkable_id?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_identifier?: InputMaybe<Int_Comparison_Exp>;
  parkable_type?: InputMaybe<String_Comparison_Exp>;
  payment_method_id?: InputMaybe<Bigint_Comparison_Exp>;
  processed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  snapshot_fee?: InputMaybe<Int_Comparison_Exp>;
  snapshot_license_plate?: InputMaybe<String_Comparison_Exp>;
  snapshot_price?: InputMaybe<Int_Comparison_Exp>;
  snapshot_price_interval?: InputMaybe<Int_Comparison_Exp>;
  snapshot_price_interval_unit?: InputMaybe<String_Comparison_Exp>;
  snapshot_time_limit?: InputMaybe<Int_Comparison_Exp>;
  snapshot_time_limit_unit?: InputMaybe<String_Comparison_Exp>;
  time?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  vehicle_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "legacy_parkable_transactions" */
export enum Legacy_Parkable_Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  LegacyParkableTransactionsIdUnique = 'legacy_parkable_transactions_id_unique'
}

/** input type for incrementing numeric columns in table "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_identifier?: InputMaybe<Scalars['Int']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions_Insert_Input = {
  cancelled_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parkable_area_name?: InputMaybe<Scalars['String']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_identifier?: InputMaybe<Scalars['Int']['input']>;
  parkable_type?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_license_plate?: InputMaybe<Scalars['String']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Legacy_Parkable_Transactions_Max_Fields = {
  __typename?: 'legacy_parkable_transactions_max_fields';
  cancelled_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parkable_area_name?: Maybe<Scalars['String']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  parkable_identifier?: Maybe<Scalars['Int']['output']>;
  parkable_type?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_license_plate?: Maybe<Scalars['String']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_unit?: Maybe<Scalars['String']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_unit?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Legacy_Parkable_Transactions_Min_Fields = {
  __typename?: 'legacy_parkable_transactions_min_fields';
  cancelled_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parkable_area_name?: Maybe<Scalars['String']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  parkable_identifier?: Maybe<Scalars['Int']['output']>;
  parkable_type?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_license_plate?: Maybe<Scalars['String']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_unit?: Maybe<Scalars['String']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_unit?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions_Mutation_Response = {
  __typename?: 'legacy_parkable_transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Legacy_Parkable_Transactions>;
};

/** input type for inserting object relation for remote table "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions_Obj_Rel_Insert_Input = {
  data: Legacy_Parkable_Transactions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Legacy_Parkable_Transactions_On_Conflict>;
};

/** on_conflict condition type for table "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions_On_Conflict = {
  constraint: Legacy_Parkable_Transactions_Constraint;
  update_columns?: Array<Legacy_Parkable_Transactions_Update_Column>;
  where?: InputMaybe<Legacy_Parkable_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "legacy_parkable_transactions". */
export type Legacy_Parkable_Transactions_Order_By = {
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parkable_area_name?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  parkable_identifier?: InputMaybe<Order_By>;
  parkable_type?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_license_plate?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_price_interval_unit?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  snapshot_time_limit_unit?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** select columns of table "legacy_parkable_transactions" */
export enum Legacy_Parkable_Transactions_Select_Column {
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  ParkableAreaName = 'parkable_area_name',
  /** column name */
  ParkableId = 'parkable_id',
  /** column name */
  ParkableIdentifier = 'parkable_identifier',
  /** column name */
  ParkableType = 'parkable_type',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  SnapshotFee = 'snapshot_fee',
  /** column name */
  SnapshotLicensePlate = 'snapshot_license_plate',
  /** column name */
  SnapshotPrice = 'snapshot_price',
  /** column name */
  SnapshotPriceInterval = 'snapshot_price_interval',
  /** column name */
  SnapshotPriceIntervalUnit = 'snapshot_price_interval_unit',
  /** column name */
  SnapshotTimeLimit = 'snapshot_time_limit',
  /** column name */
  SnapshotTimeLimitUnit = 'snapshot_time_limit_unit',
  /** column name */
  Time = 'time',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** input type for updating data in table "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions_Set_Input = {
  cancelled_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parkable_area_name?: InputMaybe<Scalars['String']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_identifier?: InputMaybe<Scalars['Int']['input']>;
  parkable_type?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_license_plate?: InputMaybe<Scalars['String']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Legacy_Parkable_Transactions_Stddev_Fields = {
  __typename?: 'legacy_parkable_transactions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Legacy_Parkable_Transactions_Stddev_Pop_Fields = {
  __typename?: 'legacy_parkable_transactions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Legacy_Parkable_Transactions_Stddev_Samp_Fields = {
  __typename?: 'legacy_parkable_transactions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "legacy_parkable_transactions" */
export type Legacy_Parkable_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legacy_Parkable_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legacy_Parkable_Transactions_Stream_Cursor_Value_Input = {
  cancelled_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parkable_area_name?: InputMaybe<Scalars['String']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_identifier?: InputMaybe<Scalars['Int']['input']>;
  parkable_type?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_license_plate?: InputMaybe<Scalars['String']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Legacy_Parkable_Transactions_Sum_Fields = {
  __typename?: 'legacy_parkable_transactions_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  parkable_identifier?: Maybe<Scalars['Int']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "legacy_parkable_transactions" */
export enum Legacy_Parkable_Transactions_Update_Column {
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  ParkableAreaName = 'parkable_area_name',
  /** column name */
  ParkableId = 'parkable_id',
  /** column name */
  ParkableIdentifier = 'parkable_identifier',
  /** column name */
  ParkableType = 'parkable_type',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  SnapshotFee = 'snapshot_fee',
  /** column name */
  SnapshotLicensePlate = 'snapshot_license_plate',
  /** column name */
  SnapshotPrice = 'snapshot_price',
  /** column name */
  SnapshotPriceInterval = 'snapshot_price_interval',
  /** column name */
  SnapshotPriceIntervalUnit = 'snapshot_price_interval_unit',
  /** column name */
  SnapshotTimeLimit = 'snapshot_time_limit',
  /** column name */
  SnapshotTimeLimitUnit = 'snapshot_time_limit_unit',
  /** column name */
  Time = 'time',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Legacy_Parkable_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Legacy_Parkable_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legacy_Parkable_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legacy_Parkable_Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Legacy_Parkable_Transactions_Var_Pop_Fields = {
  __typename?: 'legacy_parkable_transactions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Legacy_Parkable_Transactions_Var_Samp_Fields = {
  __typename?: 'legacy_parkable_transactions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Legacy_Parkable_Transactions_Variance_Fields = {
  __typename?: 'legacy_parkable_transactions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "legacy_payments" */
export type Legacy_Payments = {
  __typename?: 'legacy_payments';
  amount: Scalars['Int']['output'];
  committed_at?: Maybe<Scalars['timestamp']['output']>;
  created_at: Scalars['timestamp']['output'];
  fee_amount: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  is_parking_authority_funds_transfer: Scalars['Boolean']['output'];
  is_prefund: Scalars['Boolean']['output'];
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  meta_reference?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_amount: Scalars['Int']['output'];
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  wallet_top_up_amount: Scalars['Int']['output'];
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "legacy_payments" */
export type Legacy_Payments_Aggregate = {
  __typename?: 'legacy_payments_aggregate';
  aggregate?: Maybe<Legacy_Payments_Aggregate_Fields>;
  nodes: Array<Legacy_Payments>;
};

/** aggregate fields of "legacy_payments" */
export type Legacy_Payments_Aggregate_Fields = {
  __typename?: 'legacy_payments_aggregate_fields';
  avg?: Maybe<Legacy_Payments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Legacy_Payments_Max_Fields>;
  min?: Maybe<Legacy_Payments_Min_Fields>;
  stddev?: Maybe<Legacy_Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Legacy_Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Legacy_Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Legacy_Payments_Sum_Fields>;
  var_pop?: Maybe<Legacy_Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Legacy_Payments_Var_Samp_Fields>;
  variance?: Maybe<Legacy_Payments_Variance_Fields>;
};


/** aggregate fields of "legacy_payments" */
export type Legacy_Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legacy_Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Legacy_Payments_Avg_Fields = {
  __typename?: 'legacy_payments_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  fee_amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_top_up_amount?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "legacy_payments". All fields are combined with a logical 'AND'. */
export type Legacy_Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Legacy_Payments_Bool_Exp>>;
  _not?: InputMaybe<Legacy_Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Legacy_Payments_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  committed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fee_amount?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  invoice_id?: InputMaybe<Bigint_Comparison_Exp>;
  is_parking_authority_funds_transfer?: InputMaybe<Boolean_Comparison_Exp>;
  is_prefund?: InputMaybe<Boolean_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  meta_id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_reference?: InputMaybe<String_Comparison_Exp>;
  num_etl_failures?: InputMaybe<Smallint_Comparison_Exp>;
  num_etls?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_transaction_amount?: InputMaybe<Int_Comparison_Exp>;
  parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_method_id?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  transfer_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  wallet_top_up_amount?: InputMaybe<Int_Comparison_Exp>;
  wallet_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "legacy_payments" */
export enum Legacy_Payments_Constraint {
  /** unique or primary key constraint on columns "id" */
  LegacyPaymentsIdUnique = 'legacy_payments_id_unique'
}

/** input type for incrementing numeric columns in table "legacy_payments" */
export type Legacy_Payments_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  fee_amount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_amount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_top_up_amount?: InputMaybe<Scalars['Int']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "legacy_payments" */
export type Legacy_Payments_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  committed_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fee_amount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  is_parking_authority_funds_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  is_prefund?: InputMaybe<Scalars['Boolean']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_reference?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_amount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_top_up_amount?: InputMaybe<Scalars['Int']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Legacy_Payments_Max_Fields = {
  __typename?: 'legacy_payments_max_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  committed_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  fee_amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  meta_reference?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_amount?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  wallet_top_up_amount?: Maybe<Scalars['Int']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Legacy_Payments_Min_Fields = {
  __typename?: 'legacy_payments_min_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  committed_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  fee_amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  meta_reference?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_amount?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  wallet_top_up_amount?: Maybe<Scalars['Int']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "legacy_payments" */
export type Legacy_Payments_Mutation_Response = {
  __typename?: 'legacy_payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Legacy_Payments>;
};

/** on_conflict condition type for table "legacy_payments" */
export type Legacy_Payments_On_Conflict = {
  constraint: Legacy_Payments_Constraint;
  update_columns?: Array<Legacy_Payments_Update_Column>;
  where?: InputMaybe<Legacy_Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "legacy_payments". */
export type Legacy_Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  committed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fee_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  is_parking_authority_funds_transfer?: InputMaybe<Order_By>;
  is_prefund?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_reference?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parkable_transaction_amount?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wallet_top_up_amount?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** select columns of table "legacy_payments" */
export enum Legacy_Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CommittedAt = 'committed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeeAmount = 'fee_amount',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsParkingAuthorityFundsTransfer = 'is_parking_authority_funds_transfer',
  /** column name */
  IsPrefund = 'is_prefund',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  MetaId = 'meta_id',
  /** column name */
  MetaReference = 'meta_reference',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  ParkableTransactionAmount = 'parkable_transaction_amount',
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id',
  /** column name */
  PaymentBatchId = 'payment_batch_id',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  Status = 'status',
  /** column name */
  TransferBatchId = 'transfer_batch_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WalletTopUpAmount = 'wallet_top_up_amount',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

/** input type for updating data in table "legacy_payments" */
export type Legacy_Payments_Set_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  committed_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fee_amount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  is_parking_authority_funds_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  is_prefund?: InputMaybe<Scalars['Boolean']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_reference?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_amount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_top_up_amount?: InputMaybe<Scalars['Int']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Legacy_Payments_Stddev_Fields = {
  __typename?: 'legacy_payments_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  fee_amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_top_up_amount?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Legacy_Payments_Stddev_Pop_Fields = {
  __typename?: 'legacy_payments_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  fee_amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_top_up_amount?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Legacy_Payments_Stddev_Samp_Fields = {
  __typename?: 'legacy_payments_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  fee_amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_top_up_amount?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "legacy_payments" */
export type Legacy_Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legacy_Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legacy_Payments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  committed_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fee_amount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  is_parking_authority_funds_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  is_prefund?: InputMaybe<Scalars['Boolean']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_reference?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_amount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_top_up_amount?: InputMaybe<Scalars['Int']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Legacy_Payments_Sum_Fields = {
  __typename?: 'legacy_payments_sum_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  fee_amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_amount?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  wallet_top_up_amount?: Maybe<Scalars['Int']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "legacy_payments" */
export enum Legacy_Payments_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CommittedAt = 'committed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeeAmount = 'fee_amount',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsParkingAuthorityFundsTransfer = 'is_parking_authority_funds_transfer',
  /** column name */
  IsPrefund = 'is_prefund',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  MetaId = 'meta_id',
  /** column name */
  MetaReference = 'meta_reference',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  ParkableTransactionAmount = 'parkable_transaction_amount',
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id',
  /** column name */
  PaymentBatchId = 'payment_batch_id',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  Status = 'status',
  /** column name */
  TransferBatchId = 'transfer_batch_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WalletTopUpAmount = 'wallet_top_up_amount',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

export type Legacy_Payments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Legacy_Payments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legacy_Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legacy_Payments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Legacy_Payments_Var_Pop_Fields = {
  __typename?: 'legacy_payments_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  fee_amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_top_up_amount?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Legacy_Payments_Var_Samp_Fields = {
  __typename?: 'legacy_payments_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  fee_amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_top_up_amount?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Legacy_Payments_Variance_Fields = {
  __typename?: 'legacy_payments_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  fee_amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_top_up_amount?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "legacy_wallet_transactions" */
export type Legacy_Wallet_Transactions = {
  __typename?: 'legacy_wallet_transactions';
  balance_type_promo: Scalars['Int']['output'];
  balance_type_real: Scalars['Int']['output'];
  billable_id?: Maybe<Scalars['bigint']['output']>;
  created_at: Scalars['timestamp']['output'];
  id: Scalars['bigint']['output'];
  is_bulk_sync: Scalars['Boolean']['output'];
  is_transferable?: Maybe<Scalars['Boolean']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_id: Scalars['bigint']['output'];
};

/** aggregated selection of "legacy_wallet_transactions" */
export type Legacy_Wallet_Transactions_Aggregate = {
  __typename?: 'legacy_wallet_transactions_aggregate';
  aggregate?: Maybe<Legacy_Wallet_Transactions_Aggregate_Fields>;
  nodes: Array<Legacy_Wallet_Transactions>;
};

/** aggregate fields of "legacy_wallet_transactions" */
export type Legacy_Wallet_Transactions_Aggregate_Fields = {
  __typename?: 'legacy_wallet_transactions_aggregate_fields';
  avg?: Maybe<Legacy_Wallet_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Legacy_Wallet_Transactions_Max_Fields>;
  min?: Maybe<Legacy_Wallet_Transactions_Min_Fields>;
  stddev?: Maybe<Legacy_Wallet_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Legacy_Wallet_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Legacy_Wallet_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Legacy_Wallet_Transactions_Sum_Fields>;
  var_pop?: Maybe<Legacy_Wallet_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Legacy_Wallet_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Legacy_Wallet_Transactions_Variance_Fields>;
};


/** aggregate fields of "legacy_wallet_transactions" */
export type Legacy_Wallet_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legacy_Wallet_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Legacy_Wallet_Transactions_Avg_Fields = {
  __typename?: 'legacy_wallet_transactions_avg_fields';
  balance_type_promo?: Maybe<Scalars['Float']['output']>;
  balance_type_real?: Maybe<Scalars['Float']['output']>;
  billable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "legacy_wallet_transactions". All fields are combined with a logical 'AND'. */
export type Legacy_Wallet_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Legacy_Wallet_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Legacy_Wallet_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Legacy_Wallet_Transactions_Bool_Exp>>;
  balance_type_promo?: InputMaybe<Int_Comparison_Exp>;
  balance_type_real?: InputMaybe<Int_Comparison_Exp>;
  billable_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_bulk_sync?: InputMaybe<Boolean_Comparison_Exp>;
  is_transferable?: InputMaybe<Boolean_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  memo?: InputMaybe<String_Comparison_Exp>;
  num_etl_failures?: InputMaybe<Smallint_Comparison_Exp>;
  num_etls?: InputMaybe<Bigint_Comparison_Exp>;
  transfer_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  wallet_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "legacy_wallet_transactions" */
export enum Legacy_Wallet_Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  LegacyWalletTransactionsIdUnique = 'legacy_wallet_transactions_id_unique'
}

/** input type for incrementing numeric columns in table "legacy_wallet_transactions" */
export type Legacy_Wallet_Transactions_Inc_Input = {
  balance_type_promo?: InputMaybe<Scalars['Int']['input']>;
  balance_type_real?: InputMaybe<Scalars['Int']['input']>;
  billable_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "legacy_wallet_transactions" */
export type Legacy_Wallet_Transactions_Insert_Input = {
  balance_type_promo?: InputMaybe<Scalars['Int']['input']>;
  balance_type_real?: InputMaybe<Scalars['Int']['input']>;
  billable_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_bulk_sync?: InputMaybe<Scalars['Boolean']['input']>;
  is_transferable?: InputMaybe<Scalars['Boolean']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Legacy_Wallet_Transactions_Max_Fields = {
  __typename?: 'legacy_wallet_transactions_max_fields';
  balance_type_promo?: Maybe<Scalars['Int']['output']>;
  balance_type_real?: Maybe<Scalars['Int']['output']>;
  billable_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Legacy_Wallet_Transactions_Min_Fields = {
  __typename?: 'legacy_wallet_transactions_min_fields';
  balance_type_promo?: Maybe<Scalars['Int']['output']>;
  balance_type_real?: Maybe<Scalars['Int']['output']>;
  billable_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "legacy_wallet_transactions" */
export type Legacy_Wallet_Transactions_Mutation_Response = {
  __typename?: 'legacy_wallet_transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Legacy_Wallet_Transactions>;
};

/** on_conflict condition type for table "legacy_wallet_transactions" */
export type Legacy_Wallet_Transactions_On_Conflict = {
  constraint: Legacy_Wallet_Transactions_Constraint;
  update_columns?: Array<Legacy_Wallet_Transactions_Update_Column>;
  where?: InputMaybe<Legacy_Wallet_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "legacy_wallet_transactions". */
export type Legacy_Wallet_Transactions_Order_By = {
  balance_type_promo?: InputMaybe<Order_By>;
  balance_type_real?: InputMaybe<Order_By>;
  billable_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_bulk_sync?: InputMaybe<Order_By>;
  is_transferable?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** select columns of table "legacy_wallet_transactions" */
export enum Legacy_Wallet_Transactions_Select_Column {
  /** column name */
  BalanceTypePromo = 'balance_type_promo',
  /** column name */
  BalanceTypeReal = 'balance_type_real',
  /** column name */
  BillableId = 'billable_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsBulkSync = 'is_bulk_sync',
  /** column name */
  IsTransferable = 'is_transferable',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  Memo = 'memo',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  TransferBatchId = 'transfer_batch_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WalletId = 'wallet_id'
}

/** input type for updating data in table "legacy_wallet_transactions" */
export type Legacy_Wallet_Transactions_Set_Input = {
  balance_type_promo?: InputMaybe<Scalars['Int']['input']>;
  balance_type_real?: InputMaybe<Scalars['Int']['input']>;
  billable_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_bulk_sync?: InputMaybe<Scalars['Boolean']['input']>;
  is_transferable?: InputMaybe<Scalars['Boolean']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Legacy_Wallet_Transactions_Stddev_Fields = {
  __typename?: 'legacy_wallet_transactions_stddev_fields';
  balance_type_promo?: Maybe<Scalars['Float']['output']>;
  balance_type_real?: Maybe<Scalars['Float']['output']>;
  billable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Legacy_Wallet_Transactions_Stddev_Pop_Fields = {
  __typename?: 'legacy_wallet_transactions_stddev_pop_fields';
  balance_type_promo?: Maybe<Scalars['Float']['output']>;
  balance_type_real?: Maybe<Scalars['Float']['output']>;
  billable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Legacy_Wallet_Transactions_Stddev_Samp_Fields = {
  __typename?: 'legacy_wallet_transactions_stddev_samp_fields';
  balance_type_promo?: Maybe<Scalars['Float']['output']>;
  balance_type_real?: Maybe<Scalars['Float']['output']>;
  billable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "legacy_wallet_transactions" */
export type Legacy_Wallet_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legacy_Wallet_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legacy_Wallet_Transactions_Stream_Cursor_Value_Input = {
  balance_type_promo?: InputMaybe<Scalars['Int']['input']>;
  balance_type_real?: InputMaybe<Scalars['Int']['input']>;
  billable_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_bulk_sync?: InputMaybe<Scalars['Boolean']['input']>;
  is_transferable?: InputMaybe<Scalars['Boolean']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Legacy_Wallet_Transactions_Sum_Fields = {
  __typename?: 'legacy_wallet_transactions_sum_fields';
  balance_type_promo?: Maybe<Scalars['Int']['output']>;
  balance_type_real?: Maybe<Scalars['Int']['output']>;
  billable_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  wallet_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "legacy_wallet_transactions" */
export enum Legacy_Wallet_Transactions_Update_Column {
  /** column name */
  BalanceTypePromo = 'balance_type_promo',
  /** column name */
  BalanceTypeReal = 'balance_type_real',
  /** column name */
  BillableId = 'billable_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsBulkSync = 'is_bulk_sync',
  /** column name */
  IsTransferable = 'is_transferable',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  Memo = 'memo',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  TransferBatchId = 'transfer_batch_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WalletId = 'wallet_id'
}

export type Legacy_Wallet_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Legacy_Wallet_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legacy_Wallet_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legacy_Wallet_Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Legacy_Wallet_Transactions_Var_Pop_Fields = {
  __typename?: 'legacy_wallet_transactions_var_pop_fields';
  balance_type_promo?: Maybe<Scalars['Float']['output']>;
  balance_type_real?: Maybe<Scalars['Float']['output']>;
  billable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Legacy_Wallet_Transactions_Var_Samp_Fields = {
  __typename?: 'legacy_wallet_transactions_var_samp_fields';
  balance_type_promo?: Maybe<Scalars['Float']['output']>;
  balance_type_real?: Maybe<Scalars['Float']['output']>;
  billable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Legacy_Wallet_Transactions_Variance_Fields = {
  __typename?: 'legacy_wallet_transactions_variance_fields';
  balance_type_promo?: Maybe<Scalars['Float']['output']>;
  balance_type_real?: Maybe<Scalars['Float']['output']>;
  billable_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction = {
  __typename?: 'line_item_parkable_transaction';
  /** An object relationship */
  line_item: Line_Items;
  line_item_id: Scalars['bigint']['output'];
  /** An object relationship */
  parkable_transaction: Parkable_Transactions;
  parkable_transaction_id: Scalars['bigint']['output'];
};

/** aggregated selection of "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Aggregate = {
  __typename?: 'line_item_parkable_transaction_aggregate';
  aggregate?: Maybe<Line_Item_Parkable_Transaction_Aggregate_Fields>;
  nodes: Array<Line_Item_Parkable_Transaction>;
};

export type Line_Item_Parkable_Transaction_Aggregate_Bool_Exp = {
  count?: InputMaybe<Line_Item_Parkable_Transaction_Aggregate_Bool_Exp_Count>;
};

export type Line_Item_Parkable_Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Line_Item_Parkable_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Aggregate_Fields = {
  __typename?: 'line_item_parkable_transaction_aggregate_fields';
  avg?: Maybe<Line_Item_Parkable_Transaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Line_Item_Parkable_Transaction_Max_Fields>;
  min?: Maybe<Line_Item_Parkable_Transaction_Min_Fields>;
  stddev?: Maybe<Line_Item_Parkable_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Line_Item_Parkable_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Line_Item_Parkable_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Line_Item_Parkable_Transaction_Sum_Fields>;
  var_pop?: Maybe<Line_Item_Parkable_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Line_Item_Parkable_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Line_Item_Parkable_Transaction_Variance_Fields>;
};


/** aggregate fields of "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Line_Item_Parkable_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Line_Item_Parkable_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Line_Item_Parkable_Transaction_Max_Order_By>;
  min?: InputMaybe<Line_Item_Parkable_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Line_Item_Parkable_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Line_Item_Parkable_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Line_Item_Parkable_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Line_Item_Parkable_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Line_Item_Parkable_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Line_Item_Parkable_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Line_Item_Parkable_Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Line_Item_Parkable_Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Line_Item_Parkable_Transaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Line_Item_Parkable_Transaction_Avg_Fields = {
  __typename?: 'line_item_parkable_transaction_avg_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Avg_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "line_item_parkable_transaction". All fields are combined with a logical 'AND'. */
export type Line_Item_Parkable_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Line_Item_Parkable_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Line_Item_Parkable_Transaction_Bool_Exp>>;
  line_item?: InputMaybe<Line_Items_Bool_Exp>;
  line_item_id?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "line_item_parkable_transaction" */
export enum Line_Item_Parkable_Transaction_Constraint {
  /** unique or primary key constraint on columns "parkable_transaction_id", "line_item_id" */
  LineItemParkableTransactionLineItemIdParkableTransactio = 'line_item_parkable_transaction_line_item_id_parkable_transactio'
}

/** input type for incrementing numeric columns in table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Inc_Input = {
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Insert_Input = {
  line_item?: InputMaybe<Line_Items_Obj_Rel_Insert_Input>;
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Obj_Rel_Insert_Input>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Line_Item_Parkable_Transaction_Max_Fields = {
  __typename?: 'line_item_parkable_transaction_max_fields';
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Max_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Line_Item_Parkable_Transaction_Min_Fields = {
  __typename?: 'line_item_parkable_transaction_min_fields';
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Min_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Mutation_Response = {
  __typename?: 'line_item_parkable_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Line_Item_Parkable_Transaction>;
};

/** on_conflict condition type for table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_On_Conflict = {
  constraint: Line_Item_Parkable_Transaction_Constraint;
  update_columns?: Array<Line_Item_Parkable_Transaction_Update_Column>;
  where?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "line_item_parkable_transaction". */
export type Line_Item_Parkable_Transaction_Order_By = {
  line_item?: InputMaybe<Line_Items_Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** select columns of table "line_item_parkable_transaction" */
export enum Line_Item_Parkable_Transaction_Select_Column {
  /** column name */
  LineItemId = 'line_item_id',
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id'
}

/** input type for updating data in table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Set_Input = {
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Line_Item_Parkable_Transaction_Stddev_Fields = {
  __typename?: 'line_item_parkable_transaction_stddev_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Stddev_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Line_Item_Parkable_Transaction_Stddev_Pop_Fields = {
  __typename?: 'line_item_parkable_transaction_stddev_pop_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Stddev_Pop_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Line_Item_Parkable_Transaction_Stddev_Samp_Fields = {
  __typename?: 'line_item_parkable_transaction_stddev_samp_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Stddev_Samp_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Line_Item_Parkable_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Line_Item_Parkable_Transaction_Stream_Cursor_Value_Input = {
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Line_Item_Parkable_Transaction_Sum_Fields = {
  __typename?: 'line_item_parkable_transaction_sum_fields';
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Sum_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "line_item_parkable_transaction" */
export enum Line_Item_Parkable_Transaction_Update_Column {
  /** column name */
  LineItemId = 'line_item_id',
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id'
}

export type Line_Item_Parkable_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Line_Item_Parkable_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Line_Item_Parkable_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Line_Item_Parkable_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Line_Item_Parkable_Transaction_Var_Pop_Fields = {
  __typename?: 'line_item_parkable_transaction_var_pop_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Var_Pop_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Line_Item_Parkable_Transaction_Var_Samp_Fields = {
  __typename?: 'line_item_parkable_transaction_var_samp_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Var_Samp_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Line_Item_Parkable_Transaction_Variance_Fields = {
  __typename?: 'line_item_parkable_transaction_variance_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "line_item_parkable_transaction" */
export type Line_Item_Parkable_Transaction_Variance_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "line_item_payment" */
export type Line_Item_Payment = {
  __typename?: 'line_item_payment';
  amount: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  line_item: Line_Items;
  line_item_id: Scalars['bigint']['output'];
  /** An object relationship */
  payment: Payments;
  payment_id: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "line_item_payment" */
export type Line_Item_Payment_Aggregate = {
  __typename?: 'line_item_payment_aggregate';
  aggregate?: Maybe<Line_Item_Payment_Aggregate_Fields>;
  nodes: Array<Line_Item_Payment>;
};

export type Line_Item_Payment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Line_Item_Payment_Aggregate_Bool_Exp_Count>;
};

export type Line_Item_Payment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Line_Item_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Item_Payment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "line_item_payment" */
export type Line_Item_Payment_Aggregate_Fields = {
  __typename?: 'line_item_payment_aggregate_fields';
  avg?: Maybe<Line_Item_Payment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Line_Item_Payment_Max_Fields>;
  min?: Maybe<Line_Item_Payment_Min_Fields>;
  stddev?: Maybe<Line_Item_Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Line_Item_Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Line_Item_Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Line_Item_Payment_Sum_Fields>;
  var_pop?: Maybe<Line_Item_Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Line_Item_Payment_Var_Samp_Fields>;
  variance?: Maybe<Line_Item_Payment_Variance_Fields>;
};


/** aggregate fields of "line_item_payment" */
export type Line_Item_Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Line_Item_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "line_item_payment" */
export type Line_Item_Payment_Aggregate_Order_By = {
  avg?: InputMaybe<Line_Item_Payment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Line_Item_Payment_Max_Order_By>;
  min?: InputMaybe<Line_Item_Payment_Min_Order_By>;
  stddev?: InputMaybe<Line_Item_Payment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Line_Item_Payment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Line_Item_Payment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Line_Item_Payment_Sum_Order_By>;
  var_pop?: InputMaybe<Line_Item_Payment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Line_Item_Payment_Var_Samp_Order_By>;
  variance?: InputMaybe<Line_Item_Payment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "line_item_payment" */
export type Line_Item_Payment_Arr_Rel_Insert_Input = {
  data: Array<Line_Item_Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Line_Item_Payment_On_Conflict>;
};

/** aggregate avg on columns */
export type Line_Item_Payment_Avg_Fields = {
  __typename?: 'line_item_payment_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "line_item_payment" */
export type Line_Item_Payment_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "line_item_payment". All fields are combined with a logical 'AND'. */
export type Line_Item_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Line_Item_Payment_Bool_Exp>>;
  _not?: InputMaybe<Line_Item_Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Line_Item_Payment_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  line_item?: InputMaybe<Line_Items_Bool_Exp>;
  line_item_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment?: InputMaybe<Payments_Bool_Exp>;
  payment_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "line_item_payment" */
export enum Line_Item_Payment_Constraint {
  /** unique or primary key constraint on columns "payment_id", "line_item_id" */
  LineItemPaymentLineItemIdPaymentIdUnique = 'line_item_payment_line_item_id_payment_id_unique',
  /** unique or primary key constraint on columns "id" */
  LineItemPaymentPkey = 'line_item_payment_pkey'
}

/** input type for incrementing numeric columns in table "line_item_payment" */
export type Line_Item_Payment_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "line_item_payment" */
export type Line_Item_Payment_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  line_item?: InputMaybe<Line_Items_Obj_Rel_Insert_Input>;
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  payment?: InputMaybe<Payments_Obj_Rel_Insert_Input>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Line_Item_Payment_Max_Fields = {
  __typename?: 'line_item_payment_max_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  payment_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "line_item_payment" */
export type Line_Item_Payment_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Line_Item_Payment_Min_Fields = {
  __typename?: 'line_item_payment_min_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  payment_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "line_item_payment" */
export type Line_Item_Payment_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "line_item_payment" */
export type Line_Item_Payment_Mutation_Response = {
  __typename?: 'line_item_payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Line_Item_Payment>;
};

/** on_conflict condition type for table "line_item_payment" */
export type Line_Item_Payment_On_Conflict = {
  constraint: Line_Item_Payment_Constraint;
  update_columns?: Array<Line_Item_Payment_Update_Column>;
  where?: InputMaybe<Line_Item_Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "line_item_payment". */
export type Line_Item_Payment_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item?: InputMaybe<Line_Items_Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment?: InputMaybe<Payments_Order_By>;
  payment_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: line_item_payment */
export type Line_Item_Payment_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "line_item_payment" */
export enum Line_Item_Payment_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LineItemId = 'line_item_id',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "line_item_payment" */
export type Line_Item_Payment_Set_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Line_Item_Payment_Stddev_Fields = {
  __typename?: 'line_item_payment_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "line_item_payment" */
export type Line_Item_Payment_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Line_Item_Payment_Stddev_Pop_Fields = {
  __typename?: 'line_item_payment_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "line_item_payment" */
export type Line_Item_Payment_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Line_Item_Payment_Stddev_Samp_Fields = {
  __typename?: 'line_item_payment_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "line_item_payment" */
export type Line_Item_Payment_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "line_item_payment" */
export type Line_Item_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Line_Item_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Line_Item_Payment_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Line_Item_Payment_Sum_Fields = {
  __typename?: 'line_item_payment_sum_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  payment_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "line_item_payment" */
export type Line_Item_Payment_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** update columns of table "line_item_payment" */
export enum Line_Item_Payment_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LineItemId = 'line_item_id',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Line_Item_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Line_Item_Payment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Line_Item_Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Line_Item_Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Line_Item_Payment_Var_Pop_Fields = {
  __typename?: 'line_item_payment_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "line_item_payment" */
export type Line_Item_Payment_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Line_Item_Payment_Var_Samp_Fields = {
  __typename?: 'line_item_payment_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "line_item_payment" */
export type Line_Item_Payment_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Line_Item_Payment_Variance_Fields = {
  __typename?: 'line_item_payment_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "line_item_payment" */
export type Line_Item_Payment_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction = {
  __typename?: 'line_item_wallet_transaction';
  /** An object relationship */
  line_item: Line_Items;
  line_item_id: Scalars['bigint']['output'];
  /** An object relationship */
  wallet_transaction: Wallet_Transactions;
  wallet_transaction_id: Scalars['bigint']['output'];
};

/** aggregated selection of "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Aggregate = {
  __typename?: 'line_item_wallet_transaction_aggregate';
  aggregate?: Maybe<Line_Item_Wallet_Transaction_Aggregate_Fields>;
  nodes: Array<Line_Item_Wallet_Transaction>;
};

export type Line_Item_Wallet_Transaction_Aggregate_Bool_Exp = {
  count?: InputMaybe<Line_Item_Wallet_Transaction_Aggregate_Bool_Exp_Count>;
};

export type Line_Item_Wallet_Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Line_Item_Wallet_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Aggregate_Fields = {
  __typename?: 'line_item_wallet_transaction_aggregate_fields';
  avg?: Maybe<Line_Item_Wallet_Transaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Line_Item_Wallet_Transaction_Max_Fields>;
  min?: Maybe<Line_Item_Wallet_Transaction_Min_Fields>;
  stddev?: Maybe<Line_Item_Wallet_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Line_Item_Wallet_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Line_Item_Wallet_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Line_Item_Wallet_Transaction_Sum_Fields>;
  var_pop?: Maybe<Line_Item_Wallet_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Line_Item_Wallet_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Line_Item_Wallet_Transaction_Variance_Fields>;
};


/** aggregate fields of "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Line_Item_Wallet_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Line_Item_Wallet_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Line_Item_Wallet_Transaction_Max_Order_By>;
  min?: InputMaybe<Line_Item_Wallet_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Line_Item_Wallet_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Line_Item_Wallet_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Line_Item_Wallet_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Line_Item_Wallet_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Line_Item_Wallet_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Line_Item_Wallet_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Line_Item_Wallet_Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Line_Item_Wallet_Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Line_Item_Wallet_Transaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Line_Item_Wallet_Transaction_Avg_Fields = {
  __typename?: 'line_item_wallet_transaction_avg_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Avg_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "line_item_wallet_transaction". All fields are combined with a logical 'AND'. */
export type Line_Item_Wallet_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Line_Item_Wallet_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Line_Item_Wallet_Transaction_Bool_Exp>>;
  line_item?: InputMaybe<Line_Items_Bool_Exp>;
  line_item_id?: InputMaybe<Bigint_Comparison_Exp>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "line_item_wallet_transaction" */
export enum Line_Item_Wallet_Transaction_Constraint {
  /** unique or primary key constraint on columns "wallet_transaction_id", "line_item_id" */
  LineItemWalletTransactionPkey = 'line_item_wallet_transaction_pkey'
}

/** input type for incrementing numeric columns in table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Inc_Input = {
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Insert_Input = {
  line_item?: InputMaybe<Line_Items_Obj_Rel_Insert_Input>;
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Obj_Rel_Insert_Input>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Line_Item_Wallet_Transaction_Max_Fields = {
  __typename?: 'line_item_wallet_transaction_max_fields';
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Max_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Line_Item_Wallet_Transaction_Min_Fields = {
  __typename?: 'line_item_wallet_transaction_min_fields';
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Min_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Mutation_Response = {
  __typename?: 'line_item_wallet_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Line_Item_Wallet_Transaction>;
};

/** on_conflict condition type for table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_On_Conflict = {
  constraint: Line_Item_Wallet_Transaction_Constraint;
  update_columns?: Array<Line_Item_Wallet_Transaction_Update_Column>;
  where?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "line_item_wallet_transaction". */
export type Line_Item_Wallet_Transaction_Order_By = {
  line_item?: InputMaybe<Line_Items_Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: line_item_wallet_transaction */
export type Line_Item_Wallet_Transaction_Pk_Columns_Input = {
  line_item_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};

/** select columns of table "line_item_wallet_transaction" */
export enum Line_Item_Wallet_Transaction_Select_Column {
  /** column name */
  LineItemId = 'line_item_id',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

/** input type for updating data in table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Set_Input = {
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Line_Item_Wallet_Transaction_Stddev_Fields = {
  __typename?: 'line_item_wallet_transaction_stddev_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Stddev_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Line_Item_Wallet_Transaction_Stddev_Pop_Fields = {
  __typename?: 'line_item_wallet_transaction_stddev_pop_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Stddev_Pop_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Line_Item_Wallet_Transaction_Stddev_Samp_Fields = {
  __typename?: 'line_item_wallet_transaction_stddev_samp_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Stddev_Samp_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Line_Item_Wallet_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Line_Item_Wallet_Transaction_Stream_Cursor_Value_Input = {
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Line_Item_Wallet_Transaction_Sum_Fields = {
  __typename?: 'line_item_wallet_transaction_sum_fields';
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Sum_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "line_item_wallet_transaction" */
export enum Line_Item_Wallet_Transaction_Update_Column {
  /** column name */
  LineItemId = 'line_item_id',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

export type Line_Item_Wallet_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Line_Item_Wallet_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Line_Item_Wallet_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Line_Item_Wallet_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Line_Item_Wallet_Transaction_Var_Pop_Fields = {
  __typename?: 'line_item_wallet_transaction_var_pop_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Var_Pop_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Line_Item_Wallet_Transaction_Var_Samp_Fields = {
  __typename?: 'line_item_wallet_transaction_var_samp_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Var_Samp_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Line_Item_Wallet_Transaction_Variance_Fields = {
  __typename?: 'line_item_wallet_transaction_variance_fields';
  line_item_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "line_item_wallet_transaction" */
export type Line_Item_Wallet_Transaction_Variance_Order_By = {
  line_item_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "line_items" */
export type Line_Items = {
  __typename?: 'line_items';
  amount: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  invoice: Invoices;
  invoice_id: Scalars['bigint']['output'];
  /** An object relationship */
  line_item?: Maybe<Line_Items>;
  /** An array relationship */
  line_item_parkable_transactions: Array<Line_Item_Parkable_Transaction>;
  /** An aggregate relationship */
  line_item_parkable_transactions_aggregate: Line_Item_Parkable_Transaction_Aggregate;
  /** An array relationship */
  line_item_payments: Array<Line_Item_Payment>;
  /** An aggregate relationship */
  line_item_payments_aggregate: Line_Item_Payment_Aggregate;
  /** An array relationship */
  line_item_wallet_transactions: Array<Line_Item_Wallet_Transaction>;
  /** An aggregate relationship */
  line_item_wallet_transactions_aggregate: Line_Item_Wallet_Transaction_Aggregate;
  /** An array relationship */
  line_items: Array<Line_Items>;
  /** An aggregate relationship */
  line_items_aggregate: Line_Items_Aggregate;
  parent_line_item_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  parking_authority?: Maybe<Parking_Authorities>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  taxable: Scalars['Boolean']['output'];
  transferable: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "line_items" */
export type Line_ItemsLine_Item_Parkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
};


/** columns and relationships of "line_items" */
export type Line_ItemsLine_Item_Parkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
};


/** columns and relationships of "line_items" */
export type Line_ItemsLine_Item_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Payment_Order_By>>;
  where?: InputMaybe<Line_Item_Payment_Bool_Exp>;
};


/** columns and relationships of "line_items" */
export type Line_ItemsLine_Item_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Payment_Order_By>>;
  where?: InputMaybe<Line_Item_Payment_Bool_Exp>;
};


/** columns and relationships of "line_items" */
export type Line_ItemsLine_Item_Wallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "line_items" */
export type Line_ItemsLine_Item_Wallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "line_items" */
export type Line_ItemsLine_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Items_Order_By>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};


/** columns and relationships of "line_items" */
export type Line_ItemsLine_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Items_Order_By>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};

/** aggregated selection of "line_items" */
export type Line_Items_Aggregate = {
  __typename?: 'line_items_aggregate';
  aggregate?: Maybe<Line_Items_Aggregate_Fields>;
  nodes: Array<Line_Items>;
};

export type Line_Items_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Line_Items_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Line_Items_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Line_Items_Aggregate_Bool_Exp_Count>;
};

export type Line_Items_Aggregate_Bool_Exp_Bool_And = {
  arguments: Line_Items_Select_Column_Line_Items_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Items_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Line_Items_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Line_Items_Select_Column_Line_Items_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Items_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Line_Items_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Line_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Items_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "line_items" */
export type Line_Items_Aggregate_Fields = {
  __typename?: 'line_items_aggregate_fields';
  avg?: Maybe<Line_Items_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Line_Items_Max_Fields>;
  min?: Maybe<Line_Items_Min_Fields>;
  stddev?: Maybe<Line_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Line_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Line_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Line_Items_Sum_Fields>;
  var_pop?: Maybe<Line_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Line_Items_Var_Samp_Fields>;
  variance?: Maybe<Line_Items_Variance_Fields>;
};


/** aggregate fields of "line_items" */
export type Line_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Line_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "line_items" */
export type Line_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Line_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Line_Items_Max_Order_By>;
  min?: InputMaybe<Line_Items_Min_Order_By>;
  stddev?: InputMaybe<Line_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Line_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Line_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Line_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Line_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Line_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Line_Items_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "line_items" */
export type Line_Items_Arr_Rel_Insert_Input = {
  data: Array<Line_Items_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Line_Items_On_Conflict>;
};

/** aggregate avg on columns */
export type Line_Items_Avg_Fields = {
  __typename?: 'line_items_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parent_line_item_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "line_items" */
export type Line_Items_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "line_items". All fields are combined with a logical 'AND'. */
export type Line_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Line_Items_Bool_Exp>>;
  _not?: InputMaybe<Line_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Line_Items_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  invoice?: InputMaybe<Invoices_Bool_Exp>;
  invoice_id?: InputMaybe<Bigint_Comparison_Exp>;
  line_item?: InputMaybe<Line_Items_Bool_Exp>;
  line_item_parkable_transactions?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
  line_item_parkable_transactions_aggregate?: InputMaybe<Line_Item_Parkable_Transaction_Aggregate_Bool_Exp>;
  line_item_payments?: InputMaybe<Line_Item_Payment_Bool_Exp>;
  line_item_payments_aggregate?: InputMaybe<Line_Item_Payment_Aggregate_Bool_Exp>;
  line_item_wallet_transactions?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
  line_item_wallet_transactions_aggregate?: InputMaybe<Line_Item_Wallet_Transaction_Aggregate_Bool_Exp>;
  line_items?: InputMaybe<Line_Items_Bool_Exp>;
  line_items_aggregate?: InputMaybe<Line_Items_Aggregate_Bool_Exp>;
  parent_line_item_id?: InputMaybe<Bigint_Comparison_Exp>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  taxable?: InputMaybe<Boolean_Comparison_Exp>;
  transferable?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "line_items" */
export enum Line_Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  LineItemsPkey = 'line_items_pkey'
}

/** input type for incrementing numeric columns in table "line_items" */
export type Line_Items_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  parent_line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "line_items" */
export type Line_Items_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  invoice?: InputMaybe<Invoices_Obj_Rel_Insert_Input>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item?: InputMaybe<Line_Items_Obj_Rel_Insert_Input>;
  line_item_parkable_transactions?: InputMaybe<Line_Item_Parkable_Transaction_Arr_Rel_Insert_Input>;
  line_item_payments?: InputMaybe<Line_Item_Payment_Arr_Rel_Insert_Input>;
  line_item_wallet_transactions?: InputMaybe<Line_Item_Wallet_Transaction_Arr_Rel_Insert_Input>;
  line_items?: InputMaybe<Line_Items_Arr_Rel_Insert_Input>;
  parent_line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  transferable?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Line_Items_Max_Fields = {
  __typename?: 'line_items_max_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  parent_line_item_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "line_items" */
export type Line_Items_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Line_Items_Min_Fields = {
  __typename?: 'line_items_min_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  parent_line_item_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "line_items" */
export type Line_Items_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "line_items" */
export type Line_Items_Mutation_Response = {
  __typename?: 'line_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Line_Items>;
};

/** input type for inserting object relation for remote table "line_items" */
export type Line_Items_Obj_Rel_Insert_Input = {
  data: Line_Items_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Line_Items_On_Conflict>;
};

/** on_conflict condition type for table "line_items" */
export type Line_Items_On_Conflict = {
  constraint: Line_Items_Constraint;
  update_columns?: Array<Line_Items_Update_Column>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "line_items". */
export type Line_Items_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoices_Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  line_item?: InputMaybe<Line_Items_Order_By>;
  line_item_parkable_transactions_aggregate?: InputMaybe<Line_Item_Parkable_Transaction_Aggregate_Order_By>;
  line_item_payments_aggregate?: InputMaybe<Line_Item_Payment_Aggregate_Order_By>;
  line_item_wallet_transactions_aggregate?: InputMaybe<Line_Item_Wallet_Transaction_Aggregate_Order_By>;
  line_items_aggregate?: InputMaybe<Line_Items_Aggregate_Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  taxable?: InputMaybe<Order_By>;
  transferable?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: line_items */
export type Line_Items_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "line_items" */
export enum Line_Items_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  ParentLineItemId = 'parent_line_item_id',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  Taxable = 'taxable',
  /** column name */
  Transferable = 'transferable',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "line_items_aggregate_bool_exp_bool_and_arguments_columns" columns of table "line_items" */
export enum Line_Items_Select_Column_Line_Items_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Taxable = 'taxable',
  /** column name */
  Transferable = 'transferable'
}

/** select "line_items_aggregate_bool_exp_bool_or_arguments_columns" columns of table "line_items" */
export enum Line_Items_Select_Column_Line_Items_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Taxable = 'taxable',
  /** column name */
  Transferable = 'transferable'
}

/** input type for updating data in table "line_items" */
export type Line_Items_Set_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  parent_line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  transferable?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Line_Items_Stddev_Fields = {
  __typename?: 'line_items_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parent_line_item_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "line_items" */
export type Line_Items_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Line_Items_Stddev_Pop_Fields = {
  __typename?: 'line_items_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parent_line_item_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "line_items" */
export type Line_Items_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Line_Items_Stddev_Samp_Fields = {
  __typename?: 'line_items_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parent_line_item_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "line_items" */
export type Line_Items_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "line_items" */
export type Line_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Line_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Line_Items_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  parent_line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  transferable?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Line_Items_Sum_Fields = {
  __typename?: 'line_items_sum_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  parent_line_item_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "line_items" */
export type Line_Items_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** update columns of table "line_items" */
export enum Line_Items_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  ParentLineItemId = 'parent_line_item_id',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  Taxable = 'taxable',
  /** column name */
  Transferable = 'transferable',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Line_Items_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Line_Items_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Line_Items_Set_Input>;
  /** filter the rows which have to be updated */
  where: Line_Items_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Line_Items_Var_Pop_Fields = {
  __typename?: 'line_items_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parent_line_item_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "line_items" */
export type Line_Items_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Line_Items_Var_Samp_Fields = {
  __typename?: 'line_items_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parent_line_item_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "line_items" */
export type Line_Items_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Line_Items_Variance_Fields = {
  __typename?: 'line_items_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  parent_line_item_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "line_items" */
export type Line_Items_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_line_item_id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "login_codes" */
export type Login_Codes = {
  __typename?: 'login_codes';
  code: Scalars['smallint']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  credential: Scalars['String']['output'];
  device_data?: Maybe<Scalars['json']['output']>;
  device_manufacturer?: Maybe<Scalars['String']['output']>;
  first_send_at?: Maybe<Scalars['timestamp']['output']>;
  first_verification_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  identity_pool: Scalars['String']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  last_send_at?: Maybe<Scalars['timestamp']['output']>;
  last_verification_at?: Maybe<Scalars['timestamp']['output']>;
  num_sends: Scalars['smallint']['output'];
  num_verifications: Scalars['smallint']['output'];
  provider: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "login_codes" */
export type Login_CodesDevice_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "login_codes" */
export type Login_Codes_Aggregate = {
  __typename?: 'login_codes_aggregate';
  aggregate?: Maybe<Login_Codes_Aggregate_Fields>;
  nodes: Array<Login_Codes>;
};

/** aggregate fields of "login_codes" */
export type Login_Codes_Aggregate_Fields = {
  __typename?: 'login_codes_aggregate_fields';
  avg?: Maybe<Login_Codes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Login_Codes_Max_Fields>;
  min?: Maybe<Login_Codes_Min_Fields>;
  stddev?: Maybe<Login_Codes_Stddev_Fields>;
  stddev_pop?: Maybe<Login_Codes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Login_Codes_Stddev_Samp_Fields>;
  sum?: Maybe<Login_Codes_Sum_Fields>;
  var_pop?: Maybe<Login_Codes_Var_Pop_Fields>;
  var_samp?: Maybe<Login_Codes_Var_Samp_Fields>;
  variance?: Maybe<Login_Codes_Variance_Fields>;
};


/** aggregate fields of "login_codes" */
export type Login_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Login_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Login_Codes_Avg_Fields = {
  __typename?: 'login_codes_avg_fields';
  code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_sends?: Maybe<Scalars['Float']['output']>;
  num_verifications?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "login_codes". All fields are combined with a logical 'AND'. */
export type Login_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Login_Codes_Bool_Exp>>;
  _not?: InputMaybe<Login_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Login_Codes_Bool_Exp>>;
  code?: InputMaybe<Smallint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  credential?: InputMaybe<String_Comparison_Exp>;
  device_data?: InputMaybe<Json_Comparison_Exp>;
  device_manufacturer?: InputMaybe<String_Comparison_Exp>;
  first_send_at?: InputMaybe<Timestamp_Comparison_Exp>;
  first_verification_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  identity_pool?: InputMaybe<String_Comparison_Exp>;
  ip_address?: InputMaybe<String_Comparison_Exp>;
  last_send_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_verification_at?: InputMaybe<Timestamp_Comparison_Exp>;
  num_sends?: InputMaybe<Smallint_Comparison_Exp>;
  num_verifications?: InputMaybe<Smallint_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_agent?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "login_codes" */
export enum Login_Codes_Constraint {
  /** unique or primary key constraint on columns "id" */
  LoginCodesPkey = 'login_codes_pkey'
}

/** input type for incrementing numeric columns in table "login_codes" */
export type Login_Codes_Inc_Input = {
  code?: InputMaybe<Scalars['smallint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  num_sends?: InputMaybe<Scalars['smallint']['input']>;
  num_verifications?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "login_codes" */
export type Login_Codes_Insert_Input = {
  code?: InputMaybe<Scalars['smallint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  credential?: InputMaybe<Scalars['String']['input']>;
  device_data?: InputMaybe<Scalars['json']['input']>;
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  first_send_at?: InputMaybe<Scalars['timestamp']['input']>;
  first_verification_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  identity_pool?: InputMaybe<Scalars['String']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  last_send_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_verification_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_sends?: InputMaybe<Scalars['smallint']['input']>;
  num_verifications?: InputMaybe<Scalars['smallint']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Login_Codes_Max_Fields = {
  __typename?: 'login_codes_max_fields';
  code?: Maybe<Scalars['smallint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  device_manufacturer?: Maybe<Scalars['String']['output']>;
  first_send_at?: Maybe<Scalars['timestamp']['output']>;
  first_verification_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  identity_pool?: Maybe<Scalars['String']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  last_send_at?: Maybe<Scalars['timestamp']['output']>;
  last_verification_at?: Maybe<Scalars['timestamp']['output']>;
  num_sends?: Maybe<Scalars['smallint']['output']>;
  num_verifications?: Maybe<Scalars['smallint']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Login_Codes_Min_Fields = {
  __typename?: 'login_codes_min_fields';
  code?: Maybe<Scalars['smallint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  device_manufacturer?: Maybe<Scalars['String']['output']>;
  first_send_at?: Maybe<Scalars['timestamp']['output']>;
  first_verification_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  identity_pool?: Maybe<Scalars['String']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  last_send_at?: Maybe<Scalars['timestamp']['output']>;
  last_verification_at?: Maybe<Scalars['timestamp']['output']>;
  num_sends?: Maybe<Scalars['smallint']['output']>;
  num_verifications?: Maybe<Scalars['smallint']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "login_codes" */
export type Login_Codes_Mutation_Response = {
  __typename?: 'login_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Login_Codes>;
};

/** on_conflict condition type for table "login_codes" */
export type Login_Codes_On_Conflict = {
  constraint: Login_Codes_Constraint;
  update_columns?: Array<Login_Codes_Update_Column>;
  where?: InputMaybe<Login_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "login_codes". */
export type Login_Codes_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credential?: InputMaybe<Order_By>;
  device_data?: InputMaybe<Order_By>;
  device_manufacturer?: InputMaybe<Order_By>;
  first_send_at?: InputMaybe<Order_By>;
  first_verification_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_pool?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  last_send_at?: InputMaybe<Order_By>;
  last_verification_at?: InputMaybe<Order_By>;
  num_sends?: InputMaybe<Order_By>;
  num_verifications?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
};

/** primary key columns input for table: login_codes */
export type Login_Codes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "login_codes" */
export enum Login_Codes_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credential = 'credential',
  /** column name */
  DeviceData = 'device_data',
  /** column name */
  DeviceManufacturer = 'device_manufacturer',
  /** column name */
  FirstSendAt = 'first_send_at',
  /** column name */
  FirstVerificationAt = 'first_verification_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityPool = 'identity_pool',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  LastSendAt = 'last_send_at',
  /** column name */
  LastVerificationAt = 'last_verification_at',
  /** column name */
  NumSends = 'num_sends',
  /** column name */
  NumVerifications = 'num_verifications',
  /** column name */
  Provider = 'provider',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAgent = 'user_agent'
}

/** input type for updating data in table "login_codes" */
export type Login_Codes_Set_Input = {
  code?: InputMaybe<Scalars['smallint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  credential?: InputMaybe<Scalars['String']['input']>;
  device_data?: InputMaybe<Scalars['json']['input']>;
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  first_send_at?: InputMaybe<Scalars['timestamp']['input']>;
  first_verification_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  identity_pool?: InputMaybe<Scalars['String']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  last_send_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_verification_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_sends?: InputMaybe<Scalars['smallint']['input']>;
  num_verifications?: InputMaybe<Scalars['smallint']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Login_Codes_Stddev_Fields = {
  __typename?: 'login_codes_stddev_fields';
  code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_sends?: Maybe<Scalars['Float']['output']>;
  num_verifications?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Login_Codes_Stddev_Pop_Fields = {
  __typename?: 'login_codes_stddev_pop_fields';
  code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_sends?: Maybe<Scalars['Float']['output']>;
  num_verifications?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Login_Codes_Stddev_Samp_Fields = {
  __typename?: 'login_codes_stddev_samp_fields';
  code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_sends?: Maybe<Scalars['Float']['output']>;
  num_verifications?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "login_codes" */
export type Login_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Login_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Login_Codes_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['smallint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  credential?: InputMaybe<Scalars['String']['input']>;
  device_data?: InputMaybe<Scalars['json']['input']>;
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  first_send_at?: InputMaybe<Scalars['timestamp']['input']>;
  first_verification_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  identity_pool?: InputMaybe<Scalars['String']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  last_send_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_verification_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_sends?: InputMaybe<Scalars['smallint']['input']>;
  num_verifications?: InputMaybe<Scalars['smallint']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Login_Codes_Sum_Fields = {
  __typename?: 'login_codes_sum_fields';
  code?: Maybe<Scalars['smallint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  num_sends?: Maybe<Scalars['smallint']['output']>;
  num_verifications?: Maybe<Scalars['smallint']['output']>;
};

/** update columns of table "login_codes" */
export enum Login_Codes_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credential = 'credential',
  /** column name */
  DeviceData = 'device_data',
  /** column name */
  DeviceManufacturer = 'device_manufacturer',
  /** column name */
  FirstSendAt = 'first_send_at',
  /** column name */
  FirstVerificationAt = 'first_verification_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityPool = 'identity_pool',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  LastSendAt = 'last_send_at',
  /** column name */
  LastVerificationAt = 'last_verification_at',
  /** column name */
  NumSends = 'num_sends',
  /** column name */
  NumVerifications = 'num_verifications',
  /** column name */
  Provider = 'provider',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserAgent = 'user_agent'
}

export type Login_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Login_Codes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Login_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Login_Codes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Login_Codes_Var_Pop_Fields = {
  __typename?: 'login_codes_var_pop_fields';
  code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_sends?: Maybe<Scalars['Float']['output']>;
  num_verifications?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Login_Codes_Var_Samp_Fields = {
  __typename?: 'login_codes_var_samp_fields';
  code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_sends?: Maybe<Scalars['Float']['output']>;
  num_verifications?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Login_Codes_Variance_Fields = {
  __typename?: 'login_codes_variance_fields';
  code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_sends?: Maybe<Scalars['Float']['output']>;
  num_verifications?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "migrations" */
export type Migrations = {
  __typename?: 'migrations';
  batch: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  migration: Scalars['String']['output'];
};

/** aggregated selection of "migrations" */
export type Migrations_Aggregate = {
  __typename?: 'migrations_aggregate';
  aggregate?: Maybe<Migrations_Aggregate_Fields>;
  nodes: Array<Migrations>;
};

/** aggregate fields of "migrations" */
export type Migrations_Aggregate_Fields = {
  __typename?: 'migrations_aggregate_fields';
  avg?: Maybe<Migrations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Migrations_Max_Fields>;
  min?: Maybe<Migrations_Min_Fields>;
  stddev?: Maybe<Migrations_Stddev_Fields>;
  stddev_pop?: Maybe<Migrations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Migrations_Stddev_Samp_Fields>;
  sum?: Maybe<Migrations_Sum_Fields>;
  var_pop?: Maybe<Migrations_Var_Pop_Fields>;
  var_samp?: Maybe<Migrations_Var_Samp_Fields>;
  variance?: Maybe<Migrations_Variance_Fields>;
};


/** aggregate fields of "migrations" */
export type Migrations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Migrations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Migrations_Avg_Fields = {
  __typename?: 'migrations_avg_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "migrations". All fields are combined with a logical 'AND'. */
export type Migrations_Bool_Exp = {
  _and?: InputMaybe<Array<Migrations_Bool_Exp>>;
  _not?: InputMaybe<Migrations_Bool_Exp>;
  _or?: InputMaybe<Array<Migrations_Bool_Exp>>;
  batch?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  migration?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "migrations" */
export enum Migrations_Constraint {
  /** unique or primary key constraint on columns "id" */
  MigrationsPkey = 'migrations_pkey'
}

/** input type for incrementing numeric columns in table "migrations" */
export type Migrations_Inc_Input = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "migrations" */
export type Migrations_Insert_Input = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  migration?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Migrations_Max_Fields = {
  __typename?: 'migrations_max_fields';
  batch?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  migration?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Migrations_Min_Fields = {
  __typename?: 'migrations_min_fields';
  batch?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  migration?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "migrations" */
export type Migrations_Mutation_Response = {
  __typename?: 'migrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Migrations>;
};

/** on_conflict condition type for table "migrations" */
export type Migrations_On_Conflict = {
  constraint: Migrations_Constraint;
  update_columns?: Array<Migrations_Update_Column>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};

/** Ordering options when selecting data from "migrations". */
export type Migrations_Order_By = {
  batch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  migration?: InputMaybe<Order_By>;
};

/** primary key columns input for table: migrations */
export type Migrations_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "migrations" */
export enum Migrations_Select_Column {
  /** column name */
  Batch = 'batch',
  /** column name */
  Id = 'id',
  /** column name */
  Migration = 'migration'
}

/** input type for updating data in table "migrations" */
export type Migrations_Set_Input = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  migration?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Migrations_Stddev_Fields = {
  __typename?: 'migrations_stddev_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Migrations_Stddev_Pop_Fields = {
  __typename?: 'migrations_stddev_pop_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Migrations_Stddev_Samp_Fields = {
  __typename?: 'migrations_stddev_samp_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "migrations" */
export type Migrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Migrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Migrations_Stream_Cursor_Value_Input = {
  batch?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  migration?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Migrations_Sum_Fields = {
  __typename?: 'migrations_sum_fields';
  batch?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "migrations" */
export enum Migrations_Update_Column {
  /** column name */
  Batch = 'batch',
  /** column name */
  Id = 'id',
  /** column name */
  Migration = 'migration'
}

export type Migrations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Migrations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Migrations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Migrations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Migrations_Var_Pop_Fields = {
  __typename?: 'migrations_var_pop_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Migrations_Var_Samp_Fields = {
  __typename?: 'migrations_var_samp_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Migrations_Variance_Fields = {
  __typename?: 'migrations_variance_fields';
  batch?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  blockUser: BlockUserOutput;
  /** Cancel Parking Session */
  cancelParkableTransaction?: Maybe<CancelParkableTransactionOutput>;
  changePhoneNumber: ChangePhoneNumberOutput;
  createAccountingReport?: Maybe<CreateAccountingReportOutput>;
  createEscrowReport?: Maybe<CreateEscrowReportOutput>;
  /** Creates an MXM customer for the user if it doesn't already exist */
  createMxmCustomer?: Maybe<CreateMxmCustomerOutput>;
  /** createParkableTransaction */
  createParkableTransaction?: Maybe<CreateParkableTransactionOutput>;
  createSupportTicket?: Maybe<CreateSupportTicketOutput>;
  createSupportTicketGuest?: Maybe<CreateSupportTicketGuestOutput>;
  createTransfersReport?: Maybe<CreateTransfersReportOutput>;
  /** Delete a payment method and the vaulted card account */
  deletePaymentMethod?: Maybe<DeletePaymentMethodOutput>;
  /** [Soft] Delete a Vehicle */
  deleteVehicle?: Maybe<DeleteVehicleOutput>;
  /** delete data from the table: "ad_campaign_admin_user" */
  delete_ad_campaign_admin_user?: Maybe<Ad_Campaign_Admin_User_Mutation_Response>;
  /** delete data from the table: "ad_campaign_parking_authority" */
  delete_ad_campaign_parking_authority?: Maybe<Ad_Campaign_Parking_Authority_Mutation_Response>;
  /** delete data from the table: "ad_campaigns" */
  delete_ad_campaigns?: Maybe<Ad_Campaigns_Mutation_Response>;
  /** delete single row from the table: "ad_campaigns" */
  delete_ad_campaigns_by_pk?: Maybe<Ad_Campaigns>;
  /** delete data from the table: "ad_events" */
  delete_ad_events?: Maybe<Ad_Events_Mutation_Response>;
  /** delete single row from the table: "ad_events" */
  delete_ad_events_by_pk?: Maybe<Ad_Events>;
  /** delete data from the table: "ad_variants" */
  delete_ad_variants?: Maybe<Ad_Variants_Mutation_Response>;
  /** delete single row from the table: "ad_variants" */
  delete_ad_variants_by_pk?: Maybe<Ad_Variants>;
  /** delete data from the table: "admin_user_parking_authority" */
  delete_admin_user_parking_authority?: Maybe<Admin_User_Parking_Authority_Mutation_Response>;
  /** delete data from the table: "admin_users" */
  delete_admin_users?: Maybe<Admin_Users_Mutation_Response>;
  /** delete single row from the table: "admin_users" */
  delete_admin_users_by_pk?: Maybe<Admin_Users>;
  /** delete data from the table: "ads" */
  delete_ads?: Maybe<Ads_Mutation_Response>;
  /** delete single row from the table: "ads" */
  delete_ads_by_pk?: Maybe<Ads>;
  /** delete data from the table: "batch_sets" */
  delete_batch_sets?: Maybe<Batch_Sets_Mutation_Response>;
  /** delete single row from the table: "batch_sets" */
  delete_batch_sets_by_pk?: Maybe<Batch_Sets>;
  /** delete data from the table: "blacklisted_credentials" */
  delete_blacklisted_credentials?: Maybe<Blacklisted_Credentials_Mutation_Response>;
  /** delete single row from the table: "blacklisted_credentials" */
  delete_blacklisted_credentials_by_pk?: Maybe<Blacklisted_Credentials>;
  /** delete data from the table: "device_user" */
  delete_device_user?: Maybe<Device_User_Mutation_Response>;
  /** delete single row from the table: "device_user" */
  delete_device_user_by_pk?: Maybe<Device_User>;
  /** delete data from the table: "devices" */
  delete_devices?: Maybe<Devices_Mutation_Response>;
  /** delete single row from the table: "devices" */
  delete_devices_by_pk?: Maybe<Devices>;
  /** delete data from the table: "events" */
  delete_events?: Maybe<Events_Mutation_Response>;
  /** delete single row from the table: "events" */
  delete_events_by_pk?: Maybe<Events>;
  /** delete data from the table: "failed_jobs" */
  delete_failed_jobs?: Maybe<Failed_Jobs_Mutation_Response>;
  /** delete single row from the table: "failed_jobs" */
  delete_failed_jobs_by_pk?: Maybe<Failed_Jobs>;
  /** delete data from the table: "failed_sentry_messages" */
  delete_failed_sentry_messages?: Maybe<Failed_Sentry_Messages_Mutation_Response>;
  /** delete single row from the table: "failed_sentry_messages" */
  delete_failed_sentry_messages_by_pk?: Maybe<Failed_Sentry_Messages>;
  /** delete data from the table: "identities" */
  delete_identities?: Maybe<Identities_Mutation_Response>;
  /** delete single row from the table: "identities" */
  delete_identities_by_pk?: Maybe<Identities>;
  /** delete data from the table: "invoice_parkable_transaction" */
  delete_invoice_parkable_transaction?: Maybe<Invoice_Parkable_Transaction_Mutation_Response>;
  /** delete single row from the table: "invoice_parkable_transaction" */
  delete_invoice_parkable_transaction_by_pk?: Maybe<Invoice_Parkable_Transaction>;
  /** delete data from the table: "invoice_wallet_transaction" */
  delete_invoice_wallet_transaction?: Maybe<Invoice_Wallet_Transaction_Mutation_Response>;
  /** delete single row from the table: "invoice_wallet_transaction" */
  delete_invoice_wallet_transaction_by_pk?: Maybe<Invoice_Wallet_Transaction>;
  /** delete data from the table: "invoices" */
  delete_invoices?: Maybe<Invoices_Mutation_Response>;
  /** delete single row from the table: "invoices" */
  delete_invoices_by_pk?: Maybe<Invoices>;
  /** delete data from the table: "jobs" */
  delete_jobs?: Maybe<Jobs_Mutation_Response>;
  /** delete single row from the table: "jobs" */
  delete_jobs_by_pk?: Maybe<Jobs>;
  /** delete data from the table: "legacy_migrations" */
  delete_legacy_migrations?: Maybe<Legacy_Migrations_Mutation_Response>;
  /** delete single row from the table: "legacy_migrations" */
  delete_legacy_migrations_by_pk?: Maybe<Legacy_Migrations>;
  /** delete data from the table: "legacy_parkable_transactions" */
  delete_legacy_parkable_transactions?: Maybe<Legacy_Parkable_Transactions_Mutation_Response>;
  /** delete data from the table: "legacy_payments" */
  delete_legacy_payments?: Maybe<Legacy_Payments_Mutation_Response>;
  /** delete data from the table: "legacy_wallet_transactions" */
  delete_legacy_wallet_transactions?: Maybe<Legacy_Wallet_Transactions_Mutation_Response>;
  /** delete data from the table: "line_item_parkable_transaction" */
  delete_line_item_parkable_transaction?: Maybe<Line_Item_Parkable_Transaction_Mutation_Response>;
  /** delete data from the table: "line_item_payment" */
  delete_line_item_payment?: Maybe<Line_Item_Payment_Mutation_Response>;
  /** delete single row from the table: "line_item_payment" */
  delete_line_item_payment_by_pk?: Maybe<Line_Item_Payment>;
  /** delete data from the table: "line_item_wallet_transaction" */
  delete_line_item_wallet_transaction?: Maybe<Line_Item_Wallet_Transaction_Mutation_Response>;
  /** delete single row from the table: "line_item_wallet_transaction" */
  delete_line_item_wallet_transaction_by_pk?: Maybe<Line_Item_Wallet_Transaction>;
  /** delete data from the table: "line_items" */
  delete_line_items?: Maybe<Line_Items_Mutation_Response>;
  /** delete single row from the table: "line_items" */
  delete_line_items_by_pk?: Maybe<Line_Items>;
  /** delete data from the table: "login_codes" */
  delete_login_codes?: Maybe<Login_Codes_Mutation_Response>;
  /** delete single row from the table: "login_codes" */
  delete_login_codes_by_pk?: Maybe<Login_Codes>;
  /** delete data from the table: "migrations" */
  delete_migrations?: Maybe<Migrations_Mutation_Response>;
  /** delete single row from the table: "migrations" */
  delete_migrations_by_pk?: Maybe<Migrations>;
  /** delete data from the table: "mx_merchant_pa_bank_account_metas" */
  delete_mx_merchant_pa_bank_account_metas?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Mutation_Response>;
  /** delete single row from the table: "mx_merchant_pa_bank_account_metas" */
  delete_mx_merchant_pa_bank_account_metas_by_pk?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas>;
  /** delete data from the table: "mx_merchant_payment_batch_metas" */
  delete_mx_merchant_payment_batch_metas?: Maybe<Mx_Merchant_Payment_Batch_Metas_Mutation_Response>;
  /** delete single row from the table: "mx_merchant_payment_batch_metas" */
  delete_mx_merchant_payment_batch_metas_by_pk?: Maybe<Mx_Merchant_Payment_Batch_Metas>;
  /** delete data from the table: "mx_merchant_payment_metas" */
  delete_mx_merchant_payment_metas?: Maybe<Mx_Merchant_Payment_Metas_Mutation_Response>;
  /** delete single row from the table: "mx_merchant_payment_metas" */
  delete_mx_merchant_payment_metas_by_pk?: Maybe<Mx_Merchant_Payment_Metas>;
  /** delete data from the table: "mx_merchant_payment_method_metas" */
  delete_mx_merchant_payment_method_metas?: Maybe<Mx_Merchant_Payment_Method_Metas_Mutation_Response>;
  /** delete single row from the table: "mx_merchant_payment_method_metas" */
  delete_mx_merchant_payment_method_metas_by_pk?: Maybe<Mx_Merchant_Payment_Method_Metas>;
  /** delete data from the table: "parkable_group_parkable_schedule" */
  delete_parkable_group_parkable_schedule?: Maybe<Parkable_Group_Parkable_Schedule_Mutation_Response>;
  /** delete single row from the table: "parkable_group_parkable_schedule" */
  delete_parkable_group_parkable_schedule_by_pk?: Maybe<Parkable_Group_Parkable_Schedule>;
  /** delete data from the table: "parkable_groups" */
  delete_parkable_groups?: Maybe<Parkable_Groups_Mutation_Response>;
  /** delete single row from the table: "parkable_groups" */
  delete_parkable_groups_by_pk?: Maybe<Parkable_Groups>;
  /** delete data from the table: "parkable_parkable_group" */
  delete_parkable_parkable_group?: Maybe<Parkable_Parkable_Group_Mutation_Response>;
  /** delete single row from the table: "parkable_parkable_group" */
  delete_parkable_parkable_group_by_pk?: Maybe<Parkable_Parkable_Group>;
  /** delete data from the table: "parkable_qr_code" */
  delete_parkable_qr_code?: Maybe<Parkable_Qr_Code_Mutation_Response>;
  /** delete data from the table: "parkable_schedules" */
  delete_parkable_schedules?: Maybe<Parkable_Schedules_Mutation_Response>;
  /** delete single row from the table: "parkable_schedules" */
  delete_parkable_schedules_by_pk?: Maybe<Parkable_Schedules>;
  /** delete data from the table: "parkable_transaction_task" */
  delete_parkable_transaction_task?: Maybe<Parkable_Transaction_Task_Mutation_Response>;
  /** delete single row from the table: "parkable_transaction_task" */
  delete_parkable_transaction_task_by_pk?: Maybe<Parkable_Transaction_Task>;
  /** delete data from the table: "parkable_transaction_wallet_transaction" */
  delete_parkable_transaction_wallet_transaction?: Maybe<Parkable_Transaction_Wallet_Transaction_Mutation_Response>;
  /** delete single row from the table: "parkable_transaction_wallet_transaction" */
  delete_parkable_transaction_wallet_transaction_by_pk?: Maybe<Parkable_Transaction_Wallet_Transaction>;
  /** delete data from the table: "parkable_transactions" */
  delete_parkable_transactions?: Maybe<Parkable_Transactions_Mutation_Response>;
  /** delete single row from the table: "parkable_transactions" */
  delete_parkable_transactions_by_pk?: Maybe<Parkable_Transactions>;
  /** delete data from the table: "parkables" */
  delete_parkables?: Maybe<Parkables_Mutation_Response>;
  /** delete single row from the table: "parkables" */
  delete_parkables_by_pk?: Maybe<Parkables>;
  /** delete data from the table: "parking_authorities" */
  delete_parking_authorities?: Maybe<Parking_Authorities_Mutation_Response>;
  /** delete single row from the table: "parking_authorities" */
  delete_parking_authorities_by_pk?: Maybe<Parking_Authorities>;
  /** delete data from the table: "parking_authority_bank_accounts" */
  delete_parking_authority_bank_accounts?: Maybe<Parking_Authority_Bank_Accounts_Mutation_Response>;
  /** delete single row from the table: "parking_authority_bank_accounts" */
  delete_parking_authority_bank_accounts_by_pk?: Maybe<Parking_Authority_Bank_Accounts>;
  /** delete data from the table: "parking_authority_settings" */
  delete_parking_authority_settings?: Maybe<Parking_Authority_Settings_Mutation_Response>;
  /** delete single row from the table: "parking_authority_settings" */
  delete_parking_authority_settings_by_pk?: Maybe<Parking_Authority_Settings>;
  /** delete data from the table: "parking_authority_user" */
  delete_parking_authority_user?: Maybe<Parking_Authority_User_Mutation_Response>;
  /** delete single row from the table: "parking_authority_user" */
  delete_parking_authority_user_by_pk?: Maybe<Parking_Authority_User>;
  /** delete data from the table: "payment_batches" */
  delete_payment_batches?: Maybe<Payment_Batches_Mutation_Response>;
  /** delete single row from the table: "payment_batches" */
  delete_payment_batches_by_pk?: Maybe<Payment_Batches>;
  /** delete data from the table: "payment_methods" */
  delete_payment_methods?: Maybe<Payment_Methods_Mutation_Response>;
  /** delete single row from the table: "payment_methods" */
  delete_payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** delete data from the table: "payment_wallet_transaction" */
  delete_payment_wallet_transaction?: Maybe<Payment_Wallet_Transaction_Mutation_Response>;
  /** delete single row from the table: "payment_wallet_transaction" */
  delete_payment_wallet_transaction_by_pk?: Maybe<Payment_Wallet_Transaction>;
  /** delete data from the table: "payments" */
  delete_payments?: Maybe<Payments_Mutation_Response>;
  /** delete single row from the table: "payments" */
  delete_payments_by_pk?: Maybe<Payments>;
  /** delete data from the table: "pending_users" */
  delete_pending_users?: Maybe<Pending_Users_Mutation_Response>;
  /** delete single row from the table: "pending_users" */
  delete_pending_users_by_pk?: Maybe<Pending_Users>;
  /** delete data from the table: "personal_access_tokens" */
  delete_personal_access_tokens?: Maybe<Personal_Access_Tokens_Mutation_Response>;
  /** delete single row from the table: "personal_access_tokens" */
  delete_personal_access_tokens_by_pk?: Maybe<Personal_Access_Tokens>;
  /** delete data from the table: "public_keys" */
  delete_public_keys?: Maybe<Public_Keys_Mutation_Response>;
  /** delete data from the table: "qr_codes" */
  delete_qr_codes?: Maybe<Qr_Codes_Mutation_Response>;
  /** delete single row from the table: "qr_codes" */
  delete_qr_codes_by_pk?: Maybe<Qr_Codes>;
  /** delete data from the table: "r_line_item_payments" */
  delete_r_line_item_payments?: Maybe<R_Line_Item_Payments_Mutation_Response>;
  /** delete single row from the table: "r_line_item_payments" */
  delete_r_line_item_payments_by_pk?: Maybe<R_Line_Item_Payments>;
  /** delete data from the table: "r_parkable_transactions" */
  delete_r_parkable_transactions?: Maybe<R_Parkable_Transactions_Mutation_Response>;
  /** delete single row from the table: "r_parkable_transactions" */
  delete_r_parkable_transactions_by_pk?: Maybe<R_Parkable_Transactions>;
  /** delete data from the table: "r_parking_authorities" */
  delete_r_parking_authorities?: Maybe<R_Parking_Authorities_Mutation_Response>;
  /** delete single row from the table: "r_parking_authorities" */
  delete_r_parking_authorities_by_pk?: Maybe<R_Parking_Authorities>;
  /** delete data from the table: "r_payment_batches" */
  delete_r_payment_batches?: Maybe<R_Payment_Batches_Mutation_Response>;
  /** delete single row from the table: "r_payment_batches" */
  delete_r_payment_batches_by_pk?: Maybe<R_Payment_Batches>;
  /** delete data from the table: "r_transfer_batches" */
  delete_r_transfer_batches?: Maybe<R_Transfer_Batches_Mutation_Response>;
  /** delete single row from the table: "r_transfer_batches" */
  delete_r_transfer_batches_by_pk?: Maybe<R_Transfer_Batches>;
  /** delete data from the table: "r_users" */
  delete_r_users?: Maybe<R_Users_Mutation_Response>;
  /** delete single row from the table: "r_users" */
  delete_r_users_by_pk?: Maybe<R_Users>;
  /** delete data from the table: "reports" */
  delete_reports?: Maybe<Reports_Mutation_Response>;
  /** delete single row from the table: "reports" */
  delete_reports_by_pk?: Maybe<Reports>;
  /** delete data from the table: "session_overlap_results" */
  delete_session_overlap_results?: Maybe<Session_Overlap_Results_Mutation_Response>;
  /** delete single row from the table: "session_overlap_results" */
  delete_session_overlap_results_by_pk?: Maybe<Session_Overlap_Results>;
  /** delete data from the table: "support_tickets" */
  delete_support_tickets?: Maybe<Support_Tickets_Mutation_Response>;
  /** delete single row from the table: "support_tickets" */
  delete_support_tickets_by_pk?: Maybe<Support_Tickets>;
  /** delete data from the table: "task_events" */
  delete_task_events?: Maybe<Task_Events_Mutation_Response>;
  /** delete single row from the table: "task_events" */
  delete_task_events_by_pk?: Maybe<Task_Events>;
  /** delete data from the table: "task_states" */
  delete_task_states?: Maybe<Task_States_Mutation_Response>;
  /** delete single row from the table: "task_states" */
  delete_task_states_by_pk?: Maybe<Task_States>;
  /** delete data from the table: "task_user" */
  delete_task_user?: Maybe<Task_User_Mutation_Response>;
  /** delete single row from the table: "task_user" */
  delete_task_user_by_pk?: Maybe<Task_User>;
  /** delete data from the table: "tasks" */
  delete_tasks?: Maybe<Tasks_Mutation_Response>;
  /** delete single row from the table: "tasks" */
  delete_tasks_by_pk?: Maybe<Tasks>;
  /** delete data from the table: "transfer_batches" */
  delete_transfer_batches?: Maybe<Transfer_Batches_Mutation_Response>;
  /** delete single row from the table: "transfer_batches" */
  delete_transfer_batches_by_pk?: Maybe<Transfer_Batches>;
  /** delete data from the table: "user_activities" */
  delete_user_activities?: Maybe<User_Activities_Mutation_Response>;
  /** delete single row from the table: "user_activities" */
  delete_user_activities_by_pk?: Maybe<User_Activities>;
  /** delete data from the table: "user_lists" */
  delete_user_lists?: Maybe<User_Lists_Mutation_Response>;
  /** delete single row from the table: "user_lists" */
  delete_user_lists_by_pk?: Maybe<User_Lists>;
  /** delete data from the table: "user_settings" */
  delete_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** delete data from the table: "user_settings_all" */
  delete_user_settings_all?: Maybe<User_Settings_All_Mutation_Response>;
  /** delete single row from the table: "user_settings" */
  delete_user_settings_by_pk?: Maybe<User_Settings>;
  /** delete data from the table: "user_user_list" */
  delete_user_user_list?: Maybe<User_User_List_Mutation_Response>;
  /** delete single row from the table: "user_user_list" */
  delete_user_user_list_by_pk?: Maybe<User_User_List>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "vehicles" */
  delete_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** delete single row from the table: "vehicles" */
  delete_vehicles_by_pk?: Maybe<Vehicles>;
  /** delete data from the table: "wallet_transactions" */
  delete_wallet_transactions?: Maybe<Wallet_Transactions_Mutation_Response>;
  /** delete single row from the table: "wallet_transactions" */
  delete_wallet_transactions_by_pk?: Maybe<Wallet_Transactions>;
  /** delete data from the table: "wallets" */
  delete_wallets?: Maybe<Wallets_Mutation_Response>;
  /** delete single row from the table: "wallets" */
  delete_wallets_by_pk?: Maybe<Wallets>;
  /** Send parking history to email */
  exportParkableTransactionHistory?: Maybe<ExportParkableTransactionHistoryOutput>;
  /** Extend Parking Session Time */
  extendTime?: Maybe<ExtendTimeOutput>;
  /** insert data into the table: "ad_campaign_admin_user" */
  insert_ad_campaign_admin_user?: Maybe<Ad_Campaign_Admin_User_Mutation_Response>;
  /** insert a single row into the table: "ad_campaign_admin_user" */
  insert_ad_campaign_admin_user_one?: Maybe<Ad_Campaign_Admin_User>;
  /** insert data into the table: "ad_campaign_parking_authority" */
  insert_ad_campaign_parking_authority?: Maybe<Ad_Campaign_Parking_Authority_Mutation_Response>;
  /** insert a single row into the table: "ad_campaign_parking_authority" */
  insert_ad_campaign_parking_authority_one?: Maybe<Ad_Campaign_Parking_Authority>;
  /** insert data into the table: "ad_campaigns" */
  insert_ad_campaigns?: Maybe<Ad_Campaigns_Mutation_Response>;
  /** insert a single row into the table: "ad_campaigns" */
  insert_ad_campaigns_one?: Maybe<Ad_Campaigns>;
  /** insert data into the table: "ad_events" */
  insert_ad_events?: Maybe<Ad_Events_Mutation_Response>;
  /** insert a single row into the table: "ad_events" */
  insert_ad_events_one?: Maybe<Ad_Events>;
  /** insert data into the table: "ad_variants" */
  insert_ad_variants?: Maybe<Ad_Variants_Mutation_Response>;
  /** insert a single row into the table: "ad_variants" */
  insert_ad_variants_one?: Maybe<Ad_Variants>;
  /** insert data into the table: "admin_user_parking_authority" */
  insert_admin_user_parking_authority?: Maybe<Admin_User_Parking_Authority_Mutation_Response>;
  /** insert a single row into the table: "admin_user_parking_authority" */
  insert_admin_user_parking_authority_one?: Maybe<Admin_User_Parking_Authority>;
  /** insert data into the table: "admin_users" */
  insert_admin_users?: Maybe<Admin_Users_Mutation_Response>;
  /** insert a single row into the table: "admin_users" */
  insert_admin_users_one?: Maybe<Admin_Users>;
  /** insert data into the table: "ads" */
  insert_ads?: Maybe<Ads_Mutation_Response>;
  /** insert a single row into the table: "ads" */
  insert_ads_one?: Maybe<Ads>;
  /** insert data into the table: "batch_sets" */
  insert_batch_sets?: Maybe<Batch_Sets_Mutation_Response>;
  /** insert a single row into the table: "batch_sets" */
  insert_batch_sets_one?: Maybe<Batch_Sets>;
  /** insert data into the table: "blacklisted_credentials" */
  insert_blacklisted_credentials?: Maybe<Blacklisted_Credentials_Mutation_Response>;
  /** insert a single row into the table: "blacklisted_credentials" */
  insert_blacklisted_credentials_one?: Maybe<Blacklisted_Credentials>;
  /** insert data into the table: "device_user" */
  insert_device_user?: Maybe<Device_User_Mutation_Response>;
  /** insert a single row into the table: "device_user" */
  insert_device_user_one?: Maybe<Device_User>;
  /** insert data into the table: "devices" */
  insert_devices?: Maybe<Devices_Mutation_Response>;
  /** insert a single row into the table: "devices" */
  insert_devices_one?: Maybe<Devices>;
  /** insert data into the table: "events" */
  insert_events?: Maybe<Events_Mutation_Response>;
  /** insert a single row into the table: "events" */
  insert_events_one?: Maybe<Events>;
  /** insert data into the table: "failed_jobs" */
  insert_failed_jobs?: Maybe<Failed_Jobs_Mutation_Response>;
  /** insert a single row into the table: "failed_jobs" */
  insert_failed_jobs_one?: Maybe<Failed_Jobs>;
  /** insert data into the table: "failed_sentry_messages" */
  insert_failed_sentry_messages?: Maybe<Failed_Sentry_Messages_Mutation_Response>;
  /** insert a single row into the table: "failed_sentry_messages" */
  insert_failed_sentry_messages_one?: Maybe<Failed_Sentry_Messages>;
  /** insert data into the table: "identities" */
  insert_identities?: Maybe<Identities_Mutation_Response>;
  /** insert a single row into the table: "identities" */
  insert_identities_one?: Maybe<Identities>;
  /** insert data into the table: "invoice_parkable_transaction" */
  insert_invoice_parkable_transaction?: Maybe<Invoice_Parkable_Transaction_Mutation_Response>;
  /** insert a single row into the table: "invoice_parkable_transaction" */
  insert_invoice_parkable_transaction_one?: Maybe<Invoice_Parkable_Transaction>;
  /** insert data into the table: "invoice_wallet_transaction" */
  insert_invoice_wallet_transaction?: Maybe<Invoice_Wallet_Transaction_Mutation_Response>;
  /** insert a single row into the table: "invoice_wallet_transaction" */
  insert_invoice_wallet_transaction_one?: Maybe<Invoice_Wallet_Transaction>;
  /** insert data into the table: "invoices" */
  insert_invoices?: Maybe<Invoices_Mutation_Response>;
  /** insert a single row into the table: "invoices" */
  insert_invoices_one?: Maybe<Invoices>;
  /** insert data into the table: "jobs" */
  insert_jobs?: Maybe<Jobs_Mutation_Response>;
  /** insert a single row into the table: "jobs" */
  insert_jobs_one?: Maybe<Jobs>;
  /** insert data into the table: "legacy_migrations" */
  insert_legacy_migrations?: Maybe<Legacy_Migrations_Mutation_Response>;
  /** insert a single row into the table: "legacy_migrations" */
  insert_legacy_migrations_one?: Maybe<Legacy_Migrations>;
  /** insert data into the table: "legacy_parkable_transactions" */
  insert_legacy_parkable_transactions?: Maybe<Legacy_Parkable_Transactions_Mutation_Response>;
  /** insert a single row into the table: "legacy_parkable_transactions" */
  insert_legacy_parkable_transactions_one?: Maybe<Legacy_Parkable_Transactions>;
  /** insert data into the table: "legacy_payments" */
  insert_legacy_payments?: Maybe<Legacy_Payments_Mutation_Response>;
  /** insert a single row into the table: "legacy_payments" */
  insert_legacy_payments_one?: Maybe<Legacy_Payments>;
  /** insert data into the table: "legacy_wallet_transactions" */
  insert_legacy_wallet_transactions?: Maybe<Legacy_Wallet_Transactions_Mutation_Response>;
  /** insert a single row into the table: "legacy_wallet_transactions" */
  insert_legacy_wallet_transactions_one?: Maybe<Legacy_Wallet_Transactions>;
  /** insert data into the table: "line_item_parkable_transaction" */
  insert_line_item_parkable_transaction?: Maybe<Line_Item_Parkable_Transaction_Mutation_Response>;
  /** insert a single row into the table: "line_item_parkable_transaction" */
  insert_line_item_parkable_transaction_one?: Maybe<Line_Item_Parkable_Transaction>;
  /** insert data into the table: "line_item_payment" */
  insert_line_item_payment?: Maybe<Line_Item_Payment_Mutation_Response>;
  /** insert a single row into the table: "line_item_payment" */
  insert_line_item_payment_one?: Maybe<Line_Item_Payment>;
  /** insert data into the table: "line_item_wallet_transaction" */
  insert_line_item_wallet_transaction?: Maybe<Line_Item_Wallet_Transaction_Mutation_Response>;
  /** insert a single row into the table: "line_item_wallet_transaction" */
  insert_line_item_wallet_transaction_one?: Maybe<Line_Item_Wallet_Transaction>;
  /** insert data into the table: "line_items" */
  insert_line_items?: Maybe<Line_Items_Mutation_Response>;
  /** insert a single row into the table: "line_items" */
  insert_line_items_one?: Maybe<Line_Items>;
  /** insert data into the table: "login_codes" */
  insert_login_codes?: Maybe<Login_Codes_Mutation_Response>;
  /** insert a single row into the table: "login_codes" */
  insert_login_codes_one?: Maybe<Login_Codes>;
  /** insert data into the table: "migrations" */
  insert_migrations?: Maybe<Migrations_Mutation_Response>;
  /** insert a single row into the table: "migrations" */
  insert_migrations_one?: Maybe<Migrations>;
  /** insert data into the table: "mx_merchant_pa_bank_account_metas" */
  insert_mx_merchant_pa_bank_account_metas?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Mutation_Response>;
  /** insert a single row into the table: "mx_merchant_pa_bank_account_metas" */
  insert_mx_merchant_pa_bank_account_metas_one?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas>;
  /** insert data into the table: "mx_merchant_payment_batch_metas" */
  insert_mx_merchant_payment_batch_metas?: Maybe<Mx_Merchant_Payment_Batch_Metas_Mutation_Response>;
  /** insert a single row into the table: "mx_merchant_payment_batch_metas" */
  insert_mx_merchant_payment_batch_metas_one?: Maybe<Mx_Merchant_Payment_Batch_Metas>;
  /** insert data into the table: "mx_merchant_payment_metas" */
  insert_mx_merchant_payment_metas?: Maybe<Mx_Merchant_Payment_Metas_Mutation_Response>;
  /** insert a single row into the table: "mx_merchant_payment_metas" */
  insert_mx_merchant_payment_metas_one?: Maybe<Mx_Merchant_Payment_Metas>;
  /** insert data into the table: "mx_merchant_payment_method_metas" */
  insert_mx_merchant_payment_method_metas?: Maybe<Mx_Merchant_Payment_Method_Metas_Mutation_Response>;
  /** insert a single row into the table: "mx_merchant_payment_method_metas" */
  insert_mx_merchant_payment_method_metas_one?: Maybe<Mx_Merchant_Payment_Method_Metas>;
  /** insert data into the table: "parkable_group_parkable_schedule" */
  insert_parkable_group_parkable_schedule?: Maybe<Parkable_Group_Parkable_Schedule_Mutation_Response>;
  /** insert a single row into the table: "parkable_group_parkable_schedule" */
  insert_parkable_group_parkable_schedule_one?: Maybe<Parkable_Group_Parkable_Schedule>;
  /** insert data into the table: "parkable_groups" */
  insert_parkable_groups?: Maybe<Parkable_Groups_Mutation_Response>;
  /** insert a single row into the table: "parkable_groups" */
  insert_parkable_groups_one?: Maybe<Parkable_Groups>;
  /** insert data into the table: "parkable_parkable_group" */
  insert_parkable_parkable_group?: Maybe<Parkable_Parkable_Group_Mutation_Response>;
  /** insert a single row into the table: "parkable_parkable_group" */
  insert_parkable_parkable_group_one?: Maybe<Parkable_Parkable_Group>;
  /** insert data into the table: "parkable_qr_code" */
  insert_parkable_qr_code?: Maybe<Parkable_Qr_Code_Mutation_Response>;
  /** insert a single row into the table: "parkable_qr_code" */
  insert_parkable_qr_code_one?: Maybe<Parkable_Qr_Code>;
  /** insert data into the table: "parkable_schedules" */
  insert_parkable_schedules?: Maybe<Parkable_Schedules_Mutation_Response>;
  /** insert a single row into the table: "parkable_schedules" */
  insert_parkable_schedules_one?: Maybe<Parkable_Schedules>;
  /** insert data into the table: "parkable_transaction_task" */
  insert_parkable_transaction_task?: Maybe<Parkable_Transaction_Task_Mutation_Response>;
  /** insert a single row into the table: "parkable_transaction_task" */
  insert_parkable_transaction_task_one?: Maybe<Parkable_Transaction_Task>;
  /** insert data into the table: "parkable_transaction_wallet_transaction" */
  insert_parkable_transaction_wallet_transaction?: Maybe<Parkable_Transaction_Wallet_Transaction_Mutation_Response>;
  /** insert a single row into the table: "parkable_transaction_wallet_transaction" */
  insert_parkable_transaction_wallet_transaction_one?: Maybe<Parkable_Transaction_Wallet_Transaction>;
  /** insert data into the table: "parkable_transactions" */
  insert_parkable_transactions?: Maybe<Parkable_Transactions_Mutation_Response>;
  /** insert a single row into the table: "parkable_transactions" */
  insert_parkable_transactions_one?: Maybe<Parkable_Transactions>;
  /** insert data into the table: "parkables" */
  insert_parkables?: Maybe<Parkables_Mutation_Response>;
  /** insert a single row into the table: "parkables" */
  insert_parkables_one?: Maybe<Parkables>;
  /** insert data into the table: "parking_authorities" */
  insert_parking_authorities?: Maybe<Parking_Authorities_Mutation_Response>;
  /** insert a single row into the table: "parking_authorities" */
  insert_parking_authorities_one?: Maybe<Parking_Authorities>;
  /** insert data into the table: "parking_authority_bank_accounts" */
  insert_parking_authority_bank_accounts?: Maybe<Parking_Authority_Bank_Accounts_Mutation_Response>;
  /** insert a single row into the table: "parking_authority_bank_accounts" */
  insert_parking_authority_bank_accounts_one?: Maybe<Parking_Authority_Bank_Accounts>;
  /** insert data into the table: "parking_authority_settings" */
  insert_parking_authority_settings?: Maybe<Parking_Authority_Settings_Mutation_Response>;
  /** insert a single row into the table: "parking_authority_settings" */
  insert_parking_authority_settings_one?: Maybe<Parking_Authority_Settings>;
  /** insert data into the table: "parking_authority_user" */
  insert_parking_authority_user?: Maybe<Parking_Authority_User_Mutation_Response>;
  /** insert a single row into the table: "parking_authority_user" */
  insert_parking_authority_user_one?: Maybe<Parking_Authority_User>;
  /** insert data into the table: "payment_batches" */
  insert_payment_batches?: Maybe<Payment_Batches_Mutation_Response>;
  /** insert a single row into the table: "payment_batches" */
  insert_payment_batches_one?: Maybe<Payment_Batches>;
  /** insert data into the table: "payment_methods" */
  insert_payment_methods?: Maybe<Payment_Methods_Mutation_Response>;
  /** insert a single row into the table: "payment_methods" */
  insert_payment_methods_one?: Maybe<Payment_Methods>;
  /** insert data into the table: "payment_wallet_transaction" */
  insert_payment_wallet_transaction?: Maybe<Payment_Wallet_Transaction_Mutation_Response>;
  /** insert a single row into the table: "payment_wallet_transaction" */
  insert_payment_wallet_transaction_one?: Maybe<Payment_Wallet_Transaction>;
  /** insert data into the table: "payments" */
  insert_payments?: Maybe<Payments_Mutation_Response>;
  /** insert a single row into the table: "payments" */
  insert_payments_one?: Maybe<Payments>;
  /** insert data into the table: "pending_users" */
  insert_pending_users?: Maybe<Pending_Users_Mutation_Response>;
  /** insert a single row into the table: "pending_users" */
  insert_pending_users_one?: Maybe<Pending_Users>;
  /** insert data into the table: "personal_access_tokens" */
  insert_personal_access_tokens?: Maybe<Personal_Access_Tokens_Mutation_Response>;
  /** insert a single row into the table: "personal_access_tokens" */
  insert_personal_access_tokens_one?: Maybe<Personal_Access_Tokens>;
  /** insert data into the table: "public_keys" */
  insert_public_keys?: Maybe<Public_Keys_Mutation_Response>;
  /** insert a single row into the table: "public_keys" */
  insert_public_keys_one?: Maybe<Public_Keys>;
  /** insert data into the table: "qr_codes" */
  insert_qr_codes?: Maybe<Qr_Codes_Mutation_Response>;
  /** insert a single row into the table: "qr_codes" */
  insert_qr_codes_one?: Maybe<Qr_Codes>;
  /** insert data into the table: "r_line_item_payments" */
  insert_r_line_item_payments?: Maybe<R_Line_Item_Payments_Mutation_Response>;
  /** insert a single row into the table: "r_line_item_payments" */
  insert_r_line_item_payments_one?: Maybe<R_Line_Item_Payments>;
  /** insert data into the table: "r_parkable_transactions" */
  insert_r_parkable_transactions?: Maybe<R_Parkable_Transactions_Mutation_Response>;
  /** insert a single row into the table: "r_parkable_transactions" */
  insert_r_parkable_transactions_one?: Maybe<R_Parkable_Transactions>;
  /** insert data into the table: "r_parking_authorities" */
  insert_r_parking_authorities?: Maybe<R_Parking_Authorities_Mutation_Response>;
  /** insert a single row into the table: "r_parking_authorities" */
  insert_r_parking_authorities_one?: Maybe<R_Parking_Authorities>;
  /** insert data into the table: "r_payment_batches" */
  insert_r_payment_batches?: Maybe<R_Payment_Batches_Mutation_Response>;
  /** insert a single row into the table: "r_payment_batches" */
  insert_r_payment_batches_one?: Maybe<R_Payment_Batches>;
  /** insert data into the table: "r_transfer_batches" */
  insert_r_transfer_batches?: Maybe<R_Transfer_Batches_Mutation_Response>;
  /** insert a single row into the table: "r_transfer_batches" */
  insert_r_transfer_batches_one?: Maybe<R_Transfer_Batches>;
  /** insert data into the table: "r_users" */
  insert_r_users?: Maybe<R_Users_Mutation_Response>;
  /** insert a single row into the table: "r_users" */
  insert_r_users_one?: Maybe<R_Users>;
  /** insert data into the table: "reports" */
  insert_reports?: Maybe<Reports_Mutation_Response>;
  /** insert a single row into the table: "reports" */
  insert_reports_one?: Maybe<Reports>;
  /** insert data into the table: "session_overlap_results" */
  insert_session_overlap_results?: Maybe<Session_Overlap_Results_Mutation_Response>;
  /** insert a single row into the table: "session_overlap_results" */
  insert_session_overlap_results_one?: Maybe<Session_Overlap_Results>;
  /** insert data into the table: "support_tickets" */
  insert_support_tickets?: Maybe<Support_Tickets_Mutation_Response>;
  /** insert a single row into the table: "support_tickets" */
  insert_support_tickets_one?: Maybe<Support_Tickets>;
  /** insert data into the table: "task_events" */
  insert_task_events?: Maybe<Task_Events_Mutation_Response>;
  /** insert a single row into the table: "task_events" */
  insert_task_events_one?: Maybe<Task_Events>;
  /** insert data into the table: "task_states" */
  insert_task_states?: Maybe<Task_States_Mutation_Response>;
  /** insert a single row into the table: "task_states" */
  insert_task_states_one?: Maybe<Task_States>;
  /** insert data into the table: "task_user" */
  insert_task_user?: Maybe<Task_User_Mutation_Response>;
  /** insert a single row into the table: "task_user" */
  insert_task_user_one?: Maybe<Task_User>;
  /** insert data into the table: "tasks" */
  insert_tasks?: Maybe<Tasks_Mutation_Response>;
  /** insert a single row into the table: "tasks" */
  insert_tasks_one?: Maybe<Tasks>;
  /** insert data into the table: "transfer_batches" */
  insert_transfer_batches?: Maybe<Transfer_Batches_Mutation_Response>;
  /** insert a single row into the table: "transfer_batches" */
  insert_transfer_batches_one?: Maybe<Transfer_Batches>;
  /** insert data into the table: "user_activities" */
  insert_user_activities?: Maybe<User_Activities_Mutation_Response>;
  /** insert a single row into the table: "user_activities" */
  insert_user_activities_one?: Maybe<User_Activities>;
  /** insert data into the table: "user_lists" */
  insert_user_lists?: Maybe<User_Lists_Mutation_Response>;
  /** insert a single row into the table: "user_lists" */
  insert_user_lists_one?: Maybe<User_Lists>;
  /** insert data into the table: "user_settings" */
  insert_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** insert data into the table: "user_settings_all" */
  insert_user_settings_all?: Maybe<User_Settings_All_Mutation_Response>;
  /** insert a single row into the table: "user_settings_all" */
  insert_user_settings_all_one?: Maybe<User_Settings_All>;
  /** insert a single row into the table: "user_settings" */
  insert_user_settings_one?: Maybe<User_Settings>;
  /** insert data into the table: "user_user_list" */
  insert_user_user_list?: Maybe<User_User_List_Mutation_Response>;
  /** insert a single row into the table: "user_user_list" */
  insert_user_user_list_one?: Maybe<User_User_List>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "vehicles" */
  insert_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** insert a single row into the table: "vehicles" */
  insert_vehicles_one?: Maybe<Vehicles>;
  /** insert data into the table: "wallet_transactions" */
  insert_wallet_transactions?: Maybe<Wallet_Transactions_Mutation_Response>;
  /** insert a single row into the table: "wallet_transactions" */
  insert_wallet_transactions_one?: Maybe<Wallet_Transactions>;
  /** insert data into the table: "wallets" */
  insert_wallets?: Maybe<Wallets_Mutation_Response>;
  /** insert a single row into the table: "wallets" */
  insert_wallets_one?: Maybe<Wallets>;
  qrAssignParkables?: Maybe<QrAssignParkablesOutput>;
  refreshParkableTransactionEtl: RefreshEtlOutput;
  refreshPaymentBatchEtl: RefreshEtlOutput;
  refreshTransferBatchEtl: RefreshEtlOutput;
  refreshUserEtl: RefreshEtlOutput;
  /** Reload a User's EZwallet */
  reloadWallet?: Maybe<ReloadWalletOutput>;
  requestLegacyMigration?: Maybe<RequestLegacyMigrationOutput>;
  requestPaymentLimitedUseToken: RequestPaymentLimitedUseTokenOutput;
  resetAccountSetup?: Maybe<ResetAccountSetupOutput>;
  saveDevice?: Maybe<SaveDeviceOutput>;
  storeVaultedCardAccount?: Maybe<StoreVaultedCardAccountOutput>;
  submitEventsPrivate?: Maybe<SubmitEventsOutput>;
  submitEventsPublic?: Maybe<SubmitEventsOutput>;
  /** Updates User Settings */
  updateUserSettings?: Maybe<UpdateUserSettingOutput>;
  /** update data of the table: "ad_campaign_admin_user" */
  update_ad_campaign_admin_user?: Maybe<Ad_Campaign_Admin_User_Mutation_Response>;
  /** update multiples rows of table: "ad_campaign_admin_user" */
  update_ad_campaign_admin_user_many?: Maybe<Array<Maybe<Ad_Campaign_Admin_User_Mutation_Response>>>;
  /** update data of the table: "ad_campaign_parking_authority" */
  update_ad_campaign_parking_authority?: Maybe<Ad_Campaign_Parking_Authority_Mutation_Response>;
  /** update multiples rows of table: "ad_campaign_parking_authority" */
  update_ad_campaign_parking_authority_many?: Maybe<Array<Maybe<Ad_Campaign_Parking_Authority_Mutation_Response>>>;
  /** update data of the table: "ad_campaigns" */
  update_ad_campaigns?: Maybe<Ad_Campaigns_Mutation_Response>;
  /** update single row of the table: "ad_campaigns" */
  update_ad_campaigns_by_pk?: Maybe<Ad_Campaigns>;
  /** update multiples rows of table: "ad_campaigns" */
  update_ad_campaigns_many?: Maybe<Array<Maybe<Ad_Campaigns_Mutation_Response>>>;
  /** update data of the table: "ad_events" */
  update_ad_events?: Maybe<Ad_Events_Mutation_Response>;
  /** update single row of the table: "ad_events" */
  update_ad_events_by_pk?: Maybe<Ad_Events>;
  /** update multiples rows of table: "ad_events" */
  update_ad_events_many?: Maybe<Array<Maybe<Ad_Events_Mutation_Response>>>;
  /** update data of the table: "ad_variants" */
  update_ad_variants?: Maybe<Ad_Variants_Mutation_Response>;
  /** update single row of the table: "ad_variants" */
  update_ad_variants_by_pk?: Maybe<Ad_Variants>;
  /** update multiples rows of table: "ad_variants" */
  update_ad_variants_many?: Maybe<Array<Maybe<Ad_Variants_Mutation_Response>>>;
  /** update data of the table: "admin_user_parking_authority" */
  update_admin_user_parking_authority?: Maybe<Admin_User_Parking_Authority_Mutation_Response>;
  /** update multiples rows of table: "admin_user_parking_authority" */
  update_admin_user_parking_authority_many?: Maybe<Array<Maybe<Admin_User_Parking_Authority_Mutation_Response>>>;
  /** update data of the table: "admin_users" */
  update_admin_users?: Maybe<Admin_Users_Mutation_Response>;
  /** update single row of the table: "admin_users" */
  update_admin_users_by_pk?: Maybe<Admin_Users>;
  /** update multiples rows of table: "admin_users" */
  update_admin_users_many?: Maybe<Array<Maybe<Admin_Users_Mutation_Response>>>;
  /** update data of the table: "ads" */
  update_ads?: Maybe<Ads_Mutation_Response>;
  /** update single row of the table: "ads" */
  update_ads_by_pk?: Maybe<Ads>;
  /** update multiples rows of table: "ads" */
  update_ads_many?: Maybe<Array<Maybe<Ads_Mutation_Response>>>;
  /** update data of the table: "batch_sets" */
  update_batch_sets?: Maybe<Batch_Sets_Mutation_Response>;
  /** update single row of the table: "batch_sets" */
  update_batch_sets_by_pk?: Maybe<Batch_Sets>;
  /** update multiples rows of table: "batch_sets" */
  update_batch_sets_many?: Maybe<Array<Maybe<Batch_Sets_Mutation_Response>>>;
  /** update data of the table: "blacklisted_credentials" */
  update_blacklisted_credentials?: Maybe<Blacklisted_Credentials_Mutation_Response>;
  /** update single row of the table: "blacklisted_credentials" */
  update_blacklisted_credentials_by_pk?: Maybe<Blacklisted_Credentials>;
  /** update multiples rows of table: "blacklisted_credentials" */
  update_blacklisted_credentials_many?: Maybe<Array<Maybe<Blacklisted_Credentials_Mutation_Response>>>;
  /** update data of the table: "device_user" */
  update_device_user?: Maybe<Device_User_Mutation_Response>;
  /** update single row of the table: "device_user" */
  update_device_user_by_pk?: Maybe<Device_User>;
  /** update multiples rows of table: "device_user" */
  update_device_user_many?: Maybe<Array<Maybe<Device_User_Mutation_Response>>>;
  /** update data of the table: "devices" */
  update_devices?: Maybe<Devices_Mutation_Response>;
  /** update single row of the table: "devices" */
  update_devices_by_pk?: Maybe<Devices>;
  /** update multiples rows of table: "devices" */
  update_devices_many?: Maybe<Array<Maybe<Devices_Mutation_Response>>>;
  /** update data of the table: "events" */
  update_events?: Maybe<Events_Mutation_Response>;
  /** update single row of the table: "events" */
  update_events_by_pk?: Maybe<Events>;
  /** update multiples rows of table: "events" */
  update_events_many?: Maybe<Array<Maybe<Events_Mutation_Response>>>;
  /** update data of the table: "failed_jobs" */
  update_failed_jobs?: Maybe<Failed_Jobs_Mutation_Response>;
  /** update single row of the table: "failed_jobs" */
  update_failed_jobs_by_pk?: Maybe<Failed_Jobs>;
  /** update multiples rows of table: "failed_jobs" */
  update_failed_jobs_many?: Maybe<Array<Maybe<Failed_Jobs_Mutation_Response>>>;
  /** update data of the table: "failed_sentry_messages" */
  update_failed_sentry_messages?: Maybe<Failed_Sentry_Messages_Mutation_Response>;
  /** update single row of the table: "failed_sentry_messages" */
  update_failed_sentry_messages_by_pk?: Maybe<Failed_Sentry_Messages>;
  /** update multiples rows of table: "failed_sentry_messages" */
  update_failed_sentry_messages_many?: Maybe<Array<Maybe<Failed_Sentry_Messages_Mutation_Response>>>;
  /** update data of the table: "identities" */
  update_identities?: Maybe<Identities_Mutation_Response>;
  /** update single row of the table: "identities" */
  update_identities_by_pk?: Maybe<Identities>;
  /** update multiples rows of table: "identities" */
  update_identities_many?: Maybe<Array<Maybe<Identities_Mutation_Response>>>;
  /** update data of the table: "invoice_parkable_transaction" */
  update_invoice_parkable_transaction?: Maybe<Invoice_Parkable_Transaction_Mutation_Response>;
  /** update single row of the table: "invoice_parkable_transaction" */
  update_invoice_parkable_transaction_by_pk?: Maybe<Invoice_Parkable_Transaction>;
  /** update multiples rows of table: "invoice_parkable_transaction" */
  update_invoice_parkable_transaction_many?: Maybe<Array<Maybe<Invoice_Parkable_Transaction_Mutation_Response>>>;
  /** update data of the table: "invoice_wallet_transaction" */
  update_invoice_wallet_transaction?: Maybe<Invoice_Wallet_Transaction_Mutation_Response>;
  /** update single row of the table: "invoice_wallet_transaction" */
  update_invoice_wallet_transaction_by_pk?: Maybe<Invoice_Wallet_Transaction>;
  /** update multiples rows of table: "invoice_wallet_transaction" */
  update_invoice_wallet_transaction_many?: Maybe<Array<Maybe<Invoice_Wallet_Transaction_Mutation_Response>>>;
  /** update data of the table: "invoices" */
  update_invoices?: Maybe<Invoices_Mutation_Response>;
  /** update single row of the table: "invoices" */
  update_invoices_by_pk?: Maybe<Invoices>;
  /** update multiples rows of table: "invoices" */
  update_invoices_many?: Maybe<Array<Maybe<Invoices_Mutation_Response>>>;
  /** update data of the table: "jobs" */
  update_jobs?: Maybe<Jobs_Mutation_Response>;
  /** update single row of the table: "jobs" */
  update_jobs_by_pk?: Maybe<Jobs>;
  /** update multiples rows of table: "jobs" */
  update_jobs_many?: Maybe<Array<Maybe<Jobs_Mutation_Response>>>;
  /** update data of the table: "legacy_migrations" */
  update_legacy_migrations?: Maybe<Legacy_Migrations_Mutation_Response>;
  /** update single row of the table: "legacy_migrations" */
  update_legacy_migrations_by_pk?: Maybe<Legacy_Migrations>;
  /** update multiples rows of table: "legacy_migrations" */
  update_legacy_migrations_many?: Maybe<Array<Maybe<Legacy_Migrations_Mutation_Response>>>;
  /** update data of the table: "legacy_parkable_transactions" */
  update_legacy_parkable_transactions?: Maybe<Legacy_Parkable_Transactions_Mutation_Response>;
  /** update multiples rows of table: "legacy_parkable_transactions" */
  update_legacy_parkable_transactions_many?: Maybe<Array<Maybe<Legacy_Parkable_Transactions_Mutation_Response>>>;
  /** update data of the table: "legacy_payments" */
  update_legacy_payments?: Maybe<Legacy_Payments_Mutation_Response>;
  /** update multiples rows of table: "legacy_payments" */
  update_legacy_payments_many?: Maybe<Array<Maybe<Legacy_Payments_Mutation_Response>>>;
  /** update data of the table: "legacy_wallet_transactions" */
  update_legacy_wallet_transactions?: Maybe<Legacy_Wallet_Transactions_Mutation_Response>;
  /** update multiples rows of table: "legacy_wallet_transactions" */
  update_legacy_wallet_transactions_many?: Maybe<Array<Maybe<Legacy_Wallet_Transactions_Mutation_Response>>>;
  /** update data of the table: "line_item_parkable_transaction" */
  update_line_item_parkable_transaction?: Maybe<Line_Item_Parkable_Transaction_Mutation_Response>;
  /** update multiples rows of table: "line_item_parkable_transaction" */
  update_line_item_parkable_transaction_many?: Maybe<Array<Maybe<Line_Item_Parkable_Transaction_Mutation_Response>>>;
  /** update data of the table: "line_item_payment" */
  update_line_item_payment?: Maybe<Line_Item_Payment_Mutation_Response>;
  /** update single row of the table: "line_item_payment" */
  update_line_item_payment_by_pk?: Maybe<Line_Item_Payment>;
  /** update multiples rows of table: "line_item_payment" */
  update_line_item_payment_many?: Maybe<Array<Maybe<Line_Item_Payment_Mutation_Response>>>;
  /** update data of the table: "line_item_wallet_transaction" */
  update_line_item_wallet_transaction?: Maybe<Line_Item_Wallet_Transaction_Mutation_Response>;
  /** update single row of the table: "line_item_wallet_transaction" */
  update_line_item_wallet_transaction_by_pk?: Maybe<Line_Item_Wallet_Transaction>;
  /** update multiples rows of table: "line_item_wallet_transaction" */
  update_line_item_wallet_transaction_many?: Maybe<Array<Maybe<Line_Item_Wallet_Transaction_Mutation_Response>>>;
  /** update data of the table: "line_items" */
  update_line_items?: Maybe<Line_Items_Mutation_Response>;
  /** update single row of the table: "line_items" */
  update_line_items_by_pk?: Maybe<Line_Items>;
  /** update multiples rows of table: "line_items" */
  update_line_items_many?: Maybe<Array<Maybe<Line_Items_Mutation_Response>>>;
  /** update data of the table: "login_codes" */
  update_login_codes?: Maybe<Login_Codes_Mutation_Response>;
  /** update single row of the table: "login_codes" */
  update_login_codes_by_pk?: Maybe<Login_Codes>;
  /** update multiples rows of table: "login_codes" */
  update_login_codes_many?: Maybe<Array<Maybe<Login_Codes_Mutation_Response>>>;
  /** update data of the table: "migrations" */
  update_migrations?: Maybe<Migrations_Mutation_Response>;
  /** update single row of the table: "migrations" */
  update_migrations_by_pk?: Maybe<Migrations>;
  /** update multiples rows of table: "migrations" */
  update_migrations_many?: Maybe<Array<Maybe<Migrations_Mutation_Response>>>;
  /** update data of the table: "mx_merchant_pa_bank_account_metas" */
  update_mx_merchant_pa_bank_account_metas?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Mutation_Response>;
  /** update single row of the table: "mx_merchant_pa_bank_account_metas" */
  update_mx_merchant_pa_bank_account_metas_by_pk?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas>;
  /** update multiples rows of table: "mx_merchant_pa_bank_account_metas" */
  update_mx_merchant_pa_bank_account_metas_many?: Maybe<Array<Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Mutation_Response>>>;
  /** update data of the table: "mx_merchant_payment_batch_metas" */
  update_mx_merchant_payment_batch_metas?: Maybe<Mx_Merchant_Payment_Batch_Metas_Mutation_Response>;
  /** update single row of the table: "mx_merchant_payment_batch_metas" */
  update_mx_merchant_payment_batch_metas_by_pk?: Maybe<Mx_Merchant_Payment_Batch_Metas>;
  /** update multiples rows of table: "mx_merchant_payment_batch_metas" */
  update_mx_merchant_payment_batch_metas_many?: Maybe<Array<Maybe<Mx_Merchant_Payment_Batch_Metas_Mutation_Response>>>;
  /** update data of the table: "mx_merchant_payment_metas" */
  update_mx_merchant_payment_metas?: Maybe<Mx_Merchant_Payment_Metas_Mutation_Response>;
  /** update single row of the table: "mx_merchant_payment_metas" */
  update_mx_merchant_payment_metas_by_pk?: Maybe<Mx_Merchant_Payment_Metas>;
  /** update multiples rows of table: "mx_merchant_payment_metas" */
  update_mx_merchant_payment_metas_many?: Maybe<Array<Maybe<Mx_Merchant_Payment_Metas_Mutation_Response>>>;
  /** update data of the table: "mx_merchant_payment_method_metas" */
  update_mx_merchant_payment_method_metas?: Maybe<Mx_Merchant_Payment_Method_Metas_Mutation_Response>;
  /** update single row of the table: "mx_merchant_payment_method_metas" */
  update_mx_merchant_payment_method_metas_by_pk?: Maybe<Mx_Merchant_Payment_Method_Metas>;
  /** update multiples rows of table: "mx_merchant_payment_method_metas" */
  update_mx_merchant_payment_method_metas_many?: Maybe<Array<Maybe<Mx_Merchant_Payment_Method_Metas_Mutation_Response>>>;
  /** update data of the table: "parkable_group_parkable_schedule" */
  update_parkable_group_parkable_schedule?: Maybe<Parkable_Group_Parkable_Schedule_Mutation_Response>;
  /** update single row of the table: "parkable_group_parkable_schedule" */
  update_parkable_group_parkable_schedule_by_pk?: Maybe<Parkable_Group_Parkable_Schedule>;
  /** update multiples rows of table: "parkable_group_parkable_schedule" */
  update_parkable_group_parkable_schedule_many?: Maybe<Array<Maybe<Parkable_Group_Parkable_Schedule_Mutation_Response>>>;
  /** update data of the table: "parkable_groups" */
  update_parkable_groups?: Maybe<Parkable_Groups_Mutation_Response>;
  /** update single row of the table: "parkable_groups" */
  update_parkable_groups_by_pk?: Maybe<Parkable_Groups>;
  /** update multiples rows of table: "parkable_groups" */
  update_parkable_groups_many?: Maybe<Array<Maybe<Parkable_Groups_Mutation_Response>>>;
  /** update data of the table: "parkable_parkable_group" */
  update_parkable_parkable_group?: Maybe<Parkable_Parkable_Group_Mutation_Response>;
  /** update single row of the table: "parkable_parkable_group" */
  update_parkable_parkable_group_by_pk?: Maybe<Parkable_Parkable_Group>;
  /** update multiples rows of table: "parkable_parkable_group" */
  update_parkable_parkable_group_many?: Maybe<Array<Maybe<Parkable_Parkable_Group_Mutation_Response>>>;
  /** update data of the table: "parkable_qr_code" */
  update_parkable_qr_code?: Maybe<Parkable_Qr_Code_Mutation_Response>;
  /** update multiples rows of table: "parkable_qr_code" */
  update_parkable_qr_code_many?: Maybe<Array<Maybe<Parkable_Qr_Code_Mutation_Response>>>;
  /** update data of the table: "parkable_schedules" */
  update_parkable_schedules?: Maybe<Parkable_Schedules_Mutation_Response>;
  /** update single row of the table: "parkable_schedules" */
  update_parkable_schedules_by_pk?: Maybe<Parkable_Schedules>;
  /** update multiples rows of table: "parkable_schedules" */
  update_parkable_schedules_many?: Maybe<Array<Maybe<Parkable_Schedules_Mutation_Response>>>;
  /** update data of the table: "parkable_transaction_task" */
  update_parkable_transaction_task?: Maybe<Parkable_Transaction_Task_Mutation_Response>;
  /** update single row of the table: "parkable_transaction_task" */
  update_parkable_transaction_task_by_pk?: Maybe<Parkable_Transaction_Task>;
  /** update multiples rows of table: "parkable_transaction_task" */
  update_parkable_transaction_task_many?: Maybe<Array<Maybe<Parkable_Transaction_Task_Mutation_Response>>>;
  /** update data of the table: "parkable_transaction_wallet_transaction" */
  update_parkable_transaction_wallet_transaction?: Maybe<Parkable_Transaction_Wallet_Transaction_Mutation_Response>;
  /** update single row of the table: "parkable_transaction_wallet_transaction" */
  update_parkable_transaction_wallet_transaction_by_pk?: Maybe<Parkable_Transaction_Wallet_Transaction>;
  /** update multiples rows of table: "parkable_transaction_wallet_transaction" */
  update_parkable_transaction_wallet_transaction_many?: Maybe<Array<Maybe<Parkable_Transaction_Wallet_Transaction_Mutation_Response>>>;
  /** update data of the table: "parkable_transactions" */
  update_parkable_transactions?: Maybe<Parkable_Transactions_Mutation_Response>;
  /** update single row of the table: "parkable_transactions" */
  update_parkable_transactions_by_pk?: Maybe<Parkable_Transactions>;
  /** update multiples rows of table: "parkable_transactions" */
  update_parkable_transactions_many?: Maybe<Array<Maybe<Parkable_Transactions_Mutation_Response>>>;
  /** update data of the table: "parkables" */
  update_parkables?: Maybe<Parkables_Mutation_Response>;
  /** update single row of the table: "parkables" */
  update_parkables_by_pk?: Maybe<Parkables>;
  /** update multiples rows of table: "parkables" */
  update_parkables_many?: Maybe<Array<Maybe<Parkables_Mutation_Response>>>;
  /** update data of the table: "parking_authorities" */
  update_parking_authorities?: Maybe<Parking_Authorities_Mutation_Response>;
  /** update single row of the table: "parking_authorities" */
  update_parking_authorities_by_pk?: Maybe<Parking_Authorities>;
  /** update multiples rows of table: "parking_authorities" */
  update_parking_authorities_many?: Maybe<Array<Maybe<Parking_Authorities_Mutation_Response>>>;
  /** update data of the table: "parking_authority_bank_accounts" */
  update_parking_authority_bank_accounts?: Maybe<Parking_Authority_Bank_Accounts_Mutation_Response>;
  /** update single row of the table: "parking_authority_bank_accounts" */
  update_parking_authority_bank_accounts_by_pk?: Maybe<Parking_Authority_Bank_Accounts>;
  /** update multiples rows of table: "parking_authority_bank_accounts" */
  update_parking_authority_bank_accounts_many?: Maybe<Array<Maybe<Parking_Authority_Bank_Accounts_Mutation_Response>>>;
  /** update data of the table: "parking_authority_settings" */
  update_parking_authority_settings?: Maybe<Parking_Authority_Settings_Mutation_Response>;
  /** update single row of the table: "parking_authority_settings" */
  update_parking_authority_settings_by_pk?: Maybe<Parking_Authority_Settings>;
  /** update multiples rows of table: "parking_authority_settings" */
  update_parking_authority_settings_many?: Maybe<Array<Maybe<Parking_Authority_Settings_Mutation_Response>>>;
  /** update data of the table: "parking_authority_user" */
  update_parking_authority_user?: Maybe<Parking_Authority_User_Mutation_Response>;
  /** update single row of the table: "parking_authority_user" */
  update_parking_authority_user_by_pk?: Maybe<Parking_Authority_User>;
  /** update multiples rows of table: "parking_authority_user" */
  update_parking_authority_user_many?: Maybe<Array<Maybe<Parking_Authority_User_Mutation_Response>>>;
  /** update data of the table: "payment_batches" */
  update_payment_batches?: Maybe<Payment_Batches_Mutation_Response>;
  /** update single row of the table: "payment_batches" */
  update_payment_batches_by_pk?: Maybe<Payment_Batches>;
  /** update multiples rows of table: "payment_batches" */
  update_payment_batches_many?: Maybe<Array<Maybe<Payment_Batches_Mutation_Response>>>;
  /** update data of the table: "payment_methods" */
  update_payment_methods?: Maybe<Payment_Methods_Mutation_Response>;
  /** update single row of the table: "payment_methods" */
  update_payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** update multiples rows of table: "payment_methods" */
  update_payment_methods_many?: Maybe<Array<Maybe<Payment_Methods_Mutation_Response>>>;
  /** update data of the table: "payment_wallet_transaction" */
  update_payment_wallet_transaction?: Maybe<Payment_Wallet_Transaction_Mutation_Response>;
  /** update single row of the table: "payment_wallet_transaction" */
  update_payment_wallet_transaction_by_pk?: Maybe<Payment_Wallet_Transaction>;
  /** update multiples rows of table: "payment_wallet_transaction" */
  update_payment_wallet_transaction_many?: Maybe<Array<Maybe<Payment_Wallet_Transaction_Mutation_Response>>>;
  /** update data of the table: "payments" */
  update_payments?: Maybe<Payments_Mutation_Response>;
  /** update single row of the table: "payments" */
  update_payments_by_pk?: Maybe<Payments>;
  /** update multiples rows of table: "payments" */
  update_payments_many?: Maybe<Array<Maybe<Payments_Mutation_Response>>>;
  /** update data of the table: "pending_users" */
  update_pending_users?: Maybe<Pending_Users_Mutation_Response>;
  /** update single row of the table: "pending_users" */
  update_pending_users_by_pk?: Maybe<Pending_Users>;
  /** update multiples rows of table: "pending_users" */
  update_pending_users_many?: Maybe<Array<Maybe<Pending_Users_Mutation_Response>>>;
  /** update data of the table: "personal_access_tokens" */
  update_personal_access_tokens?: Maybe<Personal_Access_Tokens_Mutation_Response>;
  /** update single row of the table: "personal_access_tokens" */
  update_personal_access_tokens_by_pk?: Maybe<Personal_Access_Tokens>;
  /** update multiples rows of table: "personal_access_tokens" */
  update_personal_access_tokens_many?: Maybe<Array<Maybe<Personal_Access_Tokens_Mutation_Response>>>;
  /** update data of the table: "public_keys" */
  update_public_keys?: Maybe<Public_Keys_Mutation_Response>;
  /** update multiples rows of table: "public_keys" */
  update_public_keys_many?: Maybe<Array<Maybe<Public_Keys_Mutation_Response>>>;
  /** update data of the table: "qr_codes" */
  update_qr_codes?: Maybe<Qr_Codes_Mutation_Response>;
  /** update single row of the table: "qr_codes" */
  update_qr_codes_by_pk?: Maybe<Qr_Codes>;
  /** update multiples rows of table: "qr_codes" */
  update_qr_codes_many?: Maybe<Array<Maybe<Qr_Codes_Mutation_Response>>>;
  /** update data of the table: "r_line_item_payments" */
  update_r_line_item_payments?: Maybe<R_Line_Item_Payments_Mutation_Response>;
  /** update single row of the table: "r_line_item_payments" */
  update_r_line_item_payments_by_pk?: Maybe<R_Line_Item_Payments>;
  /** update multiples rows of table: "r_line_item_payments" */
  update_r_line_item_payments_many?: Maybe<Array<Maybe<R_Line_Item_Payments_Mutation_Response>>>;
  /** update data of the table: "r_parkable_transactions" */
  update_r_parkable_transactions?: Maybe<R_Parkable_Transactions_Mutation_Response>;
  /** update single row of the table: "r_parkable_transactions" */
  update_r_parkable_transactions_by_pk?: Maybe<R_Parkable_Transactions>;
  /** update multiples rows of table: "r_parkable_transactions" */
  update_r_parkable_transactions_many?: Maybe<Array<Maybe<R_Parkable_Transactions_Mutation_Response>>>;
  /** update data of the table: "r_parking_authorities" */
  update_r_parking_authorities?: Maybe<R_Parking_Authorities_Mutation_Response>;
  /** update single row of the table: "r_parking_authorities" */
  update_r_parking_authorities_by_pk?: Maybe<R_Parking_Authorities>;
  /** update multiples rows of table: "r_parking_authorities" */
  update_r_parking_authorities_many?: Maybe<Array<Maybe<R_Parking_Authorities_Mutation_Response>>>;
  /** update data of the table: "r_payment_batches" */
  update_r_payment_batches?: Maybe<R_Payment_Batches_Mutation_Response>;
  /** update single row of the table: "r_payment_batches" */
  update_r_payment_batches_by_pk?: Maybe<R_Payment_Batches>;
  /** update multiples rows of table: "r_payment_batches" */
  update_r_payment_batches_many?: Maybe<Array<Maybe<R_Payment_Batches_Mutation_Response>>>;
  /** update data of the table: "r_transfer_batches" */
  update_r_transfer_batches?: Maybe<R_Transfer_Batches_Mutation_Response>;
  /** update single row of the table: "r_transfer_batches" */
  update_r_transfer_batches_by_pk?: Maybe<R_Transfer_Batches>;
  /** update multiples rows of table: "r_transfer_batches" */
  update_r_transfer_batches_many?: Maybe<Array<Maybe<R_Transfer_Batches_Mutation_Response>>>;
  /** update data of the table: "r_users" */
  update_r_users?: Maybe<R_Users_Mutation_Response>;
  /** update single row of the table: "r_users" */
  update_r_users_by_pk?: Maybe<R_Users>;
  /** update multiples rows of table: "r_users" */
  update_r_users_many?: Maybe<Array<Maybe<R_Users_Mutation_Response>>>;
  /** update data of the table: "reports" */
  update_reports?: Maybe<Reports_Mutation_Response>;
  /** update single row of the table: "reports" */
  update_reports_by_pk?: Maybe<Reports>;
  /** update multiples rows of table: "reports" */
  update_reports_many?: Maybe<Array<Maybe<Reports_Mutation_Response>>>;
  /** update data of the table: "session_overlap_results" */
  update_session_overlap_results?: Maybe<Session_Overlap_Results_Mutation_Response>;
  /** update single row of the table: "session_overlap_results" */
  update_session_overlap_results_by_pk?: Maybe<Session_Overlap_Results>;
  /** update multiples rows of table: "session_overlap_results" */
  update_session_overlap_results_many?: Maybe<Array<Maybe<Session_Overlap_Results_Mutation_Response>>>;
  /** update data of the table: "support_tickets" */
  update_support_tickets?: Maybe<Support_Tickets_Mutation_Response>;
  /** update single row of the table: "support_tickets" */
  update_support_tickets_by_pk?: Maybe<Support_Tickets>;
  /** update multiples rows of table: "support_tickets" */
  update_support_tickets_many?: Maybe<Array<Maybe<Support_Tickets_Mutation_Response>>>;
  /** update data of the table: "task_events" */
  update_task_events?: Maybe<Task_Events_Mutation_Response>;
  /** update single row of the table: "task_events" */
  update_task_events_by_pk?: Maybe<Task_Events>;
  /** update multiples rows of table: "task_events" */
  update_task_events_many?: Maybe<Array<Maybe<Task_Events_Mutation_Response>>>;
  /** update data of the table: "task_states" */
  update_task_states?: Maybe<Task_States_Mutation_Response>;
  /** update single row of the table: "task_states" */
  update_task_states_by_pk?: Maybe<Task_States>;
  /** update multiples rows of table: "task_states" */
  update_task_states_many?: Maybe<Array<Maybe<Task_States_Mutation_Response>>>;
  /** update data of the table: "task_user" */
  update_task_user?: Maybe<Task_User_Mutation_Response>;
  /** update single row of the table: "task_user" */
  update_task_user_by_pk?: Maybe<Task_User>;
  /** update multiples rows of table: "task_user" */
  update_task_user_many?: Maybe<Array<Maybe<Task_User_Mutation_Response>>>;
  /** update data of the table: "tasks" */
  update_tasks?: Maybe<Tasks_Mutation_Response>;
  /** update single row of the table: "tasks" */
  update_tasks_by_pk?: Maybe<Tasks>;
  /** update multiples rows of table: "tasks" */
  update_tasks_many?: Maybe<Array<Maybe<Tasks_Mutation_Response>>>;
  /** update data of the table: "transfer_batches" */
  update_transfer_batches?: Maybe<Transfer_Batches_Mutation_Response>;
  /** update single row of the table: "transfer_batches" */
  update_transfer_batches_by_pk?: Maybe<Transfer_Batches>;
  /** update multiples rows of table: "transfer_batches" */
  update_transfer_batches_many?: Maybe<Array<Maybe<Transfer_Batches_Mutation_Response>>>;
  /** update data of the table: "user_activities" */
  update_user_activities?: Maybe<User_Activities_Mutation_Response>;
  /** update single row of the table: "user_activities" */
  update_user_activities_by_pk?: Maybe<User_Activities>;
  /** update multiples rows of table: "user_activities" */
  update_user_activities_many?: Maybe<Array<Maybe<User_Activities_Mutation_Response>>>;
  /** update data of the table: "user_lists" */
  update_user_lists?: Maybe<User_Lists_Mutation_Response>;
  /** update single row of the table: "user_lists" */
  update_user_lists_by_pk?: Maybe<User_Lists>;
  /** update multiples rows of table: "user_lists" */
  update_user_lists_many?: Maybe<Array<Maybe<User_Lists_Mutation_Response>>>;
  /** update data of the table: "user_settings" */
  update_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** update data of the table: "user_settings_all" */
  update_user_settings_all?: Maybe<User_Settings_All_Mutation_Response>;
  /** update multiples rows of table: "user_settings_all" */
  update_user_settings_all_many?: Maybe<Array<Maybe<User_Settings_All_Mutation_Response>>>;
  /** update single row of the table: "user_settings" */
  update_user_settings_by_pk?: Maybe<User_Settings>;
  /** update multiples rows of table: "user_settings" */
  update_user_settings_many?: Maybe<Array<Maybe<User_Settings_Mutation_Response>>>;
  /** update data of the table: "user_user_list" */
  update_user_user_list?: Maybe<User_User_List_Mutation_Response>;
  /** update single row of the table: "user_user_list" */
  update_user_user_list_by_pk?: Maybe<User_User_List>;
  /** update multiples rows of table: "user_user_list" */
  update_user_user_list_many?: Maybe<Array<Maybe<User_User_List_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "vehicles" */
  update_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** update single row of the table: "vehicles" */
  update_vehicles_by_pk?: Maybe<Vehicles>;
  /** update multiples rows of table: "vehicles" */
  update_vehicles_many?: Maybe<Array<Maybe<Vehicles_Mutation_Response>>>;
  /** update data of the table: "wallet_transactions" */
  update_wallet_transactions?: Maybe<Wallet_Transactions_Mutation_Response>;
  /** update single row of the table: "wallet_transactions" */
  update_wallet_transactions_by_pk?: Maybe<Wallet_Transactions>;
  /** update multiples rows of table: "wallet_transactions" */
  update_wallet_transactions_many?: Maybe<Array<Maybe<Wallet_Transactions_Mutation_Response>>>;
  /** update data of the table: "wallets" */
  update_wallets?: Maybe<Wallets_Mutation_Response>;
  /** update single row of the table: "wallets" */
  update_wallets_by_pk?: Maybe<Wallets>;
  /** update multiples rows of table: "wallets" */
  update_wallets_many?: Maybe<Array<Maybe<Wallets_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootBlockUserArgs = {
  block?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootCancelParkableTransactionArgs = {
  parkableTransactionId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootChangePhoneNumberArgs = {
  accountToKeep: Scalars['bigint']['input'];
  accountsToDelete?: InputMaybe<Array<Scalars['bigint']['input']>>;
  finalPhoneNumber: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateAccountingReportArgs = {
  idempotentKey: Scalars['String']['input'];
  paymentBatchIds: Array<InputMaybe<Scalars['bigint']['input']>>;
};


/** mutation root */
export type Mutation_RootCreateEscrowReportArgs = {
  endDate: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateParkableTransactionArgs = {
  idempotentKey: Scalars['uuid']['input'];
  parkableId: Scalars['bigint']['input'];
  paymentMethodId?: InputMaybe<Scalars['bigint']['input']>;
  promoStateId?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  time: Scalars['Int']['input'];
  vehicleId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootCreateSupportTicketArgs = {
  contextData?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<ClientDevice>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateSupportTicketGuestArgs = {
  contextData?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<ClientDevice>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateTransfersReportArgs = {
  idempotentKey: Scalars['String']['input'];
  transferBatchIds: Array<InputMaybe<Scalars['bigint']['input']>>;
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodArgs = {
  paymentMethodId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVehicleArgs = {
  vehicleId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_Campaign_Admin_UserArgs = {
  where: Ad_Campaign_Admin_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Campaign_Parking_AuthorityArgs = {
  where: Ad_Campaign_Parking_Authority_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_CampaignsArgs = {
  where: Ad_Campaigns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Campaigns_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_EventsArgs = {
  where: Ad_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_VariantsArgs = {
  where: Ad_Variants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Variants_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Admin_User_Parking_AuthorityArgs = {
  where: Admin_User_Parking_Authority_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_UsersArgs = {
  where: Admin_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AdsArgs = {
  where: Ads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Batch_SetsArgs = {
  where: Batch_Sets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Batch_Sets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Blacklisted_CredentialsArgs = {
  where: Blacklisted_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Blacklisted_Credentials_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Device_UserArgs = {
  where: Device_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Device_User_By_PkArgs = {
  device_id: Scalars['bigint']['input'];
  user_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DevicesArgs = {
  where: Devices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Devices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventsArgs = {
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Failed_JobsArgs = {
  where: Failed_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Failed_Jobs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Failed_Sentry_MessagesArgs = {
  where: Failed_Sentry_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Failed_Sentry_Messages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IdentitiesArgs = {
  where: Identities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Identities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Invoice_Parkable_TransactionArgs = {
  where: Invoice_Parkable_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_Parkable_Transaction_By_PkArgs = {
  invoice_id: Scalars['bigint']['input'];
  parkable_transaction_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Invoice_Wallet_TransactionArgs = {
  where: Invoice_Wallet_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_Wallet_Transaction_By_PkArgs = {
  invoice_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InvoicesArgs = {
  where: Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_JobsArgs = {
  where: Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Jobs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Legacy_MigrationsArgs = {
  where: Legacy_Migrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Legacy_Migrations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Legacy_Parkable_TransactionsArgs = {
  where: Legacy_Parkable_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Legacy_PaymentsArgs = {
  where: Legacy_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Legacy_Wallet_TransactionsArgs = {
  where: Legacy_Wallet_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Line_Item_Parkable_TransactionArgs = {
  where: Line_Item_Parkable_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Line_Item_PaymentArgs = {
  where: Line_Item_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Line_Item_Payment_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Line_Item_Wallet_TransactionArgs = {
  where: Line_Item_Wallet_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Line_Item_Wallet_Transaction_By_PkArgs = {
  line_item_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Line_ItemsArgs = {
  where: Line_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Line_Items_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Login_CodesArgs = {
  where: Login_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Login_Codes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MigrationsArgs = {
  where: Migrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Migrations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mx_Merchant_Pa_Bank_Account_MetasArgs = {
  where: Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mx_Merchant_Pa_Bank_Account_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mx_Merchant_Payment_Batch_MetasArgs = {
  where: Mx_Merchant_Payment_Batch_Metas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mx_Merchant_Payment_Batch_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mx_Merchant_Payment_MetasArgs = {
  where: Mx_Merchant_Payment_Metas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mx_Merchant_Payment_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mx_Merchant_Payment_Method_MetasArgs = {
  where: Mx_Merchant_Payment_Method_Metas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mx_Merchant_Payment_Method_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Group_Parkable_ScheduleArgs = {
  where: Parkable_Group_Parkable_Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Group_Parkable_Schedule_By_PkArgs = {
  parkable_group_id: Scalars['bigint']['input'];
  parkable_schedule_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parkable_GroupsArgs = {
  where: Parkable_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Groups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Parkable_GroupArgs = {
  where: Parkable_Parkable_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Parkable_Group_By_PkArgs = {
  parkable_group_id: Scalars['bigint']['input'];
  parkable_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Qr_CodeArgs = {
  where: Parkable_Qr_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parkable_SchedulesArgs = {
  where: Parkable_Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Schedules_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Transaction_TaskArgs = {
  where: Parkable_Transaction_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Transaction_Task_By_PkArgs = {
  parkable_transaction_id: Scalars['bigint']['input'];
  task_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Transaction_Wallet_TransactionArgs = {
  where: Parkable_Transaction_Wallet_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Transaction_Wallet_Transaction_By_PkArgs = {
  parkable_transaction_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parkable_TransactionsArgs = {
  where: Parkable_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parkable_Transactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ParkablesArgs = {
  where: Parkables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parkables_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parking_AuthoritiesArgs = {
  where: Parking_Authorities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parking_Authorities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parking_Authority_Bank_AccountsArgs = {
  where: Parking_Authority_Bank_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parking_Authority_Bank_Accounts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parking_Authority_SettingsArgs = {
  where: Parking_Authority_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parking_Authority_Settings_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parking_Authority_UserArgs = {
  where: Parking_Authority_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parking_Authority_User_By_PkArgs = {
  parking_authority_id: Scalars['bigint']['input'];
  user_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_BatchesArgs = {
  where: Payment_Batches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_MethodsArgs = {
  where: Payment_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Methods_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_Wallet_TransactionArgs = {
  where: Payment_Wallet_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Wallet_Transaction_By_PkArgs = {
  payment_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaymentsArgs = {
  where: Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Pending_UsersArgs = {
  where: Pending_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pending_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Personal_Access_TokensArgs = {
  where: Personal_Access_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Personal_Access_Tokens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Public_KeysArgs = {
  where: Public_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Qr_CodesArgs = {
  where: Qr_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Qr_Codes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_R_Line_Item_PaymentsArgs = {
  where: R_Line_Item_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_R_Line_Item_Payments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_R_Parkable_TransactionsArgs = {
  where: R_Parkable_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_R_Parkable_Transactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_R_Parking_AuthoritiesArgs = {
  where: R_Parking_Authorities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_R_Parking_Authorities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_R_Payment_BatchesArgs = {
  where: R_Payment_Batches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_R_Payment_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_R_Transfer_BatchesArgs = {
  where: R_Transfer_Batches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_R_Transfer_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_R_UsersArgs = {
  where: R_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_R_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReportsArgs = {
  where: Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reports_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Session_Overlap_ResultsArgs = {
  where: Session_Overlap_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Session_Overlap_Results_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Support_TicketsArgs = {
  where: Support_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Support_Tickets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_EventsArgs = {
  where: Task_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_Events_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_StatesArgs = {
  where: Task_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_States_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_UserArgs = {
  where: Task_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_User_By_PkArgs = {
  task_id: Scalars['uuid']['input'];
  user_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TasksArgs = {
  where: Tasks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transfer_BatchesArgs = {
  where: Transfer_Batches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transfer_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_ActivitiesArgs = {
  where: User_Activities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Activities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_ListsArgs = {
  where: User_Lists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Lists_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_SettingsArgs = {
  where: User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Settings_AllArgs = {
  where: User_Settings_All_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Settings_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_User_ListArgs = {
  where: User_User_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_User_List_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_VehiclesArgs = {
  where: Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Wallet_TransactionsArgs = {
  where: Wallet_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wallet_Transactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_WalletsArgs = {
  where: Wallets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wallets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootExportParkableTransactionHistoryArgs = {
  email: Scalars['String']['input'];
  year?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootExtendTimeArgs = {
  idempotentKey: Scalars['uuid']['input'];
  parkableTransactionId: Scalars['bigint']['input'];
  promoStateId?: InputMaybe<Scalars['bigint']['input']>;
  time: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Ad_Campaign_Admin_UserArgs = {
  objects: Array<Ad_Campaign_Admin_User_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Campaign_Admin_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Campaign_Admin_User_OneArgs = {
  object: Ad_Campaign_Admin_User_Insert_Input;
  on_conflict?: InputMaybe<Ad_Campaign_Admin_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Campaign_Parking_AuthorityArgs = {
  objects: Array<Ad_Campaign_Parking_Authority_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Campaign_Parking_Authority_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Campaign_Parking_Authority_OneArgs = {
  object: Ad_Campaign_Parking_Authority_Insert_Input;
  on_conflict?: InputMaybe<Ad_Campaign_Parking_Authority_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_CampaignsArgs = {
  objects: Array<Ad_Campaigns_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Campaigns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Campaigns_OneArgs = {
  object: Ad_Campaigns_Insert_Input;
  on_conflict?: InputMaybe<Ad_Campaigns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_EventsArgs = {
  objects: Array<Ad_Events_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Events_OneArgs = {
  object: Ad_Events_Insert_Input;
  on_conflict?: InputMaybe<Ad_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_VariantsArgs = {
  objects: Array<Ad_Variants_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Variants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Variants_OneArgs = {
  object: Ad_Variants_Insert_Input;
  on_conflict?: InputMaybe<Ad_Variants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_User_Parking_AuthorityArgs = {
  objects: Array<Admin_User_Parking_Authority_Insert_Input>;
  on_conflict?: InputMaybe<Admin_User_Parking_Authority_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_User_Parking_Authority_OneArgs = {
  object: Admin_User_Parking_Authority_Insert_Input;
  on_conflict?: InputMaybe<Admin_User_Parking_Authority_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_UsersArgs = {
  objects: Array<Admin_Users_Insert_Input>;
  on_conflict?: InputMaybe<Admin_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Users_OneArgs = {
  object: Admin_Users_Insert_Input;
  on_conflict?: InputMaybe<Admin_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AdsArgs = {
  objects: Array<Ads_Insert_Input>;
  on_conflict?: InputMaybe<Ads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ads_OneArgs = {
  object: Ads_Insert_Input;
  on_conflict?: InputMaybe<Ads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Batch_SetsArgs = {
  objects: Array<Batch_Sets_Insert_Input>;
  on_conflict?: InputMaybe<Batch_Sets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Batch_Sets_OneArgs = {
  object: Batch_Sets_Insert_Input;
  on_conflict?: InputMaybe<Batch_Sets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blacklisted_CredentialsArgs = {
  objects: Array<Blacklisted_Credentials_Insert_Input>;
  on_conflict?: InputMaybe<Blacklisted_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blacklisted_Credentials_OneArgs = {
  object: Blacklisted_Credentials_Insert_Input;
  on_conflict?: InputMaybe<Blacklisted_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Device_UserArgs = {
  objects: Array<Device_User_Insert_Input>;
  on_conflict?: InputMaybe<Device_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Device_User_OneArgs = {
  object: Device_User_Insert_Input;
  on_conflict?: InputMaybe<Device_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DevicesArgs = {
  objects: Array<Devices_Insert_Input>;
  on_conflict?: InputMaybe<Devices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Devices_OneArgs = {
  object: Devices_Insert_Input;
  on_conflict?: InputMaybe<Devices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventsArgs = {
  objects: Array<Events_Insert_Input>;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Events_OneArgs = {
  object: Events_Insert_Input;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Failed_JobsArgs = {
  objects: Array<Failed_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Failed_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Failed_Jobs_OneArgs = {
  object: Failed_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Failed_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Failed_Sentry_MessagesArgs = {
  objects: Array<Failed_Sentry_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Failed_Sentry_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Failed_Sentry_Messages_OneArgs = {
  object: Failed_Sentry_Messages_Insert_Input;
  on_conflict?: InputMaybe<Failed_Sentry_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IdentitiesArgs = {
  objects: Array<Identities_Insert_Input>;
  on_conflict?: InputMaybe<Identities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Identities_OneArgs = {
  object: Identities_Insert_Input;
  on_conflict?: InputMaybe<Identities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Parkable_TransactionArgs = {
  objects: Array<Invoice_Parkable_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Invoice_Parkable_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Parkable_Transaction_OneArgs = {
  object: Invoice_Parkable_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Invoice_Parkable_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Wallet_TransactionArgs = {
  objects: Array<Invoice_Wallet_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Invoice_Wallet_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Wallet_Transaction_OneArgs = {
  object: Invoice_Wallet_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Invoice_Wallet_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvoicesArgs = {
  objects: Array<Invoices_Insert_Input>;
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoices_OneArgs = {
  object: Invoices_Insert_Input;
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_JobsArgs = {
  objects: Array<Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Jobs_OneArgs = {
  object: Jobs_Insert_Input;
  on_conflict?: InputMaybe<Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_MigrationsArgs = {
  objects: Array<Legacy_Migrations_Insert_Input>;
  on_conflict?: InputMaybe<Legacy_Migrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_Migrations_OneArgs = {
  object: Legacy_Migrations_Insert_Input;
  on_conflict?: InputMaybe<Legacy_Migrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_Parkable_TransactionsArgs = {
  objects: Array<Legacy_Parkable_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Legacy_Parkable_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_Parkable_Transactions_OneArgs = {
  object: Legacy_Parkable_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Legacy_Parkable_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_PaymentsArgs = {
  objects: Array<Legacy_Payments_Insert_Input>;
  on_conflict?: InputMaybe<Legacy_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_Payments_OneArgs = {
  object: Legacy_Payments_Insert_Input;
  on_conflict?: InputMaybe<Legacy_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_Wallet_TransactionsArgs = {
  objects: Array<Legacy_Wallet_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Legacy_Wallet_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_Wallet_Transactions_OneArgs = {
  object: Legacy_Wallet_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Legacy_Wallet_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Item_Parkable_TransactionArgs = {
  objects: Array<Line_Item_Parkable_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Line_Item_Parkable_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Item_Parkable_Transaction_OneArgs = {
  object: Line_Item_Parkable_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Line_Item_Parkable_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Item_PaymentArgs = {
  objects: Array<Line_Item_Payment_Insert_Input>;
  on_conflict?: InputMaybe<Line_Item_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Item_Payment_OneArgs = {
  object: Line_Item_Payment_Insert_Input;
  on_conflict?: InputMaybe<Line_Item_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Item_Wallet_TransactionArgs = {
  objects: Array<Line_Item_Wallet_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Line_Item_Wallet_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Item_Wallet_Transaction_OneArgs = {
  object: Line_Item_Wallet_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Line_Item_Wallet_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_ItemsArgs = {
  objects: Array<Line_Items_Insert_Input>;
  on_conflict?: InputMaybe<Line_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Items_OneArgs = {
  object: Line_Items_Insert_Input;
  on_conflict?: InputMaybe<Line_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Login_CodesArgs = {
  objects: Array<Login_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Login_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Login_Codes_OneArgs = {
  object: Login_Codes_Insert_Input;
  on_conflict?: InputMaybe<Login_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MigrationsArgs = {
  objects: Array<Migrations_Insert_Input>;
  on_conflict?: InputMaybe<Migrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Migrations_OneArgs = {
  object: Migrations_Insert_Input;
  on_conflict?: InputMaybe<Migrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mx_Merchant_Pa_Bank_Account_MetasArgs = {
  objects: Array<Mx_Merchant_Pa_Bank_Account_Metas_Insert_Input>;
  on_conflict?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mx_Merchant_Pa_Bank_Account_Metas_OneArgs = {
  object: Mx_Merchant_Pa_Bank_Account_Metas_Insert_Input;
  on_conflict?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mx_Merchant_Payment_Batch_MetasArgs = {
  objects: Array<Mx_Merchant_Payment_Batch_Metas_Insert_Input>;
  on_conflict?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mx_Merchant_Payment_Batch_Metas_OneArgs = {
  object: Mx_Merchant_Payment_Batch_Metas_Insert_Input;
  on_conflict?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mx_Merchant_Payment_MetasArgs = {
  objects: Array<Mx_Merchant_Payment_Metas_Insert_Input>;
  on_conflict?: InputMaybe<Mx_Merchant_Payment_Metas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mx_Merchant_Payment_Metas_OneArgs = {
  object: Mx_Merchant_Payment_Metas_Insert_Input;
  on_conflict?: InputMaybe<Mx_Merchant_Payment_Metas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mx_Merchant_Payment_Method_MetasArgs = {
  objects: Array<Mx_Merchant_Payment_Method_Metas_Insert_Input>;
  on_conflict?: InputMaybe<Mx_Merchant_Payment_Method_Metas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mx_Merchant_Payment_Method_Metas_OneArgs = {
  object: Mx_Merchant_Payment_Method_Metas_Insert_Input;
  on_conflict?: InputMaybe<Mx_Merchant_Payment_Method_Metas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Group_Parkable_ScheduleArgs = {
  objects: Array<Parkable_Group_Parkable_Schedule_Insert_Input>;
  on_conflict?: InputMaybe<Parkable_Group_Parkable_Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Group_Parkable_Schedule_OneArgs = {
  object: Parkable_Group_Parkable_Schedule_Insert_Input;
  on_conflict?: InputMaybe<Parkable_Group_Parkable_Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_GroupsArgs = {
  objects: Array<Parkable_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Parkable_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Groups_OneArgs = {
  object: Parkable_Groups_Insert_Input;
  on_conflict?: InputMaybe<Parkable_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Parkable_GroupArgs = {
  objects: Array<Parkable_Parkable_Group_Insert_Input>;
  on_conflict?: InputMaybe<Parkable_Parkable_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Parkable_Group_OneArgs = {
  object: Parkable_Parkable_Group_Insert_Input;
  on_conflict?: InputMaybe<Parkable_Parkable_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Qr_CodeArgs = {
  objects: Array<Parkable_Qr_Code_Insert_Input>;
  on_conflict?: InputMaybe<Parkable_Qr_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Qr_Code_OneArgs = {
  object: Parkable_Qr_Code_Insert_Input;
  on_conflict?: InputMaybe<Parkable_Qr_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_SchedulesArgs = {
  objects: Array<Parkable_Schedules_Insert_Input>;
  on_conflict?: InputMaybe<Parkable_Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Schedules_OneArgs = {
  object: Parkable_Schedules_Insert_Input;
  on_conflict?: InputMaybe<Parkable_Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Transaction_TaskArgs = {
  objects: Array<Parkable_Transaction_Task_Insert_Input>;
  on_conflict?: InputMaybe<Parkable_Transaction_Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Transaction_Task_OneArgs = {
  object: Parkable_Transaction_Task_Insert_Input;
  on_conflict?: InputMaybe<Parkable_Transaction_Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Transaction_Wallet_TransactionArgs = {
  objects: Array<Parkable_Transaction_Wallet_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Parkable_Transaction_Wallet_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Transaction_Wallet_Transaction_OneArgs = {
  object: Parkable_Transaction_Wallet_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Parkable_Transaction_Wallet_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_TransactionsArgs = {
  objects: Array<Parkable_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Parkable_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkable_Transactions_OneArgs = {
  object: Parkable_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Parkable_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ParkablesArgs = {
  objects: Array<Parkables_Insert_Input>;
  on_conflict?: InputMaybe<Parkables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parkables_OneArgs = {
  object: Parkables_Insert_Input;
  on_conflict?: InputMaybe<Parkables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parking_AuthoritiesArgs = {
  objects: Array<Parking_Authorities_Insert_Input>;
  on_conflict?: InputMaybe<Parking_Authorities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parking_Authorities_OneArgs = {
  object: Parking_Authorities_Insert_Input;
  on_conflict?: InputMaybe<Parking_Authorities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parking_Authority_Bank_AccountsArgs = {
  objects: Array<Parking_Authority_Bank_Accounts_Insert_Input>;
  on_conflict?: InputMaybe<Parking_Authority_Bank_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parking_Authority_Bank_Accounts_OneArgs = {
  object: Parking_Authority_Bank_Accounts_Insert_Input;
  on_conflict?: InputMaybe<Parking_Authority_Bank_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parking_Authority_SettingsArgs = {
  objects: Array<Parking_Authority_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Parking_Authority_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parking_Authority_Settings_OneArgs = {
  object: Parking_Authority_Settings_Insert_Input;
  on_conflict?: InputMaybe<Parking_Authority_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parking_Authority_UserArgs = {
  objects: Array<Parking_Authority_User_Insert_Input>;
  on_conflict?: InputMaybe<Parking_Authority_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parking_Authority_User_OneArgs = {
  object: Parking_Authority_User_Insert_Input;
  on_conflict?: InputMaybe<Parking_Authority_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_BatchesArgs = {
  objects: Array<Payment_Batches_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Batches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Batches_OneArgs = {
  object: Payment_Batches_Insert_Input;
  on_conflict?: InputMaybe<Payment_Batches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_MethodsArgs = {
  objects: Array<Payment_Methods_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Methods_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Methods_OneArgs = {
  object: Payment_Methods_Insert_Input;
  on_conflict?: InputMaybe<Payment_Methods_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Wallet_TransactionArgs = {
  objects: Array<Payment_Wallet_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Wallet_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Wallet_Transaction_OneArgs = {
  object: Payment_Wallet_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Payment_Wallet_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentsArgs = {
  objects: Array<Payments_Insert_Input>;
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payments_OneArgs = {
  object: Payments_Insert_Input;
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pending_UsersArgs = {
  objects: Array<Pending_Users_Insert_Input>;
  on_conflict?: InputMaybe<Pending_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pending_Users_OneArgs = {
  object: Pending_Users_Insert_Input;
  on_conflict?: InputMaybe<Pending_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Personal_Access_TokensArgs = {
  objects: Array<Personal_Access_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Personal_Access_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Personal_Access_Tokens_OneArgs = {
  object: Personal_Access_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Personal_Access_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Public_KeysArgs = {
  objects: Array<Public_Keys_Insert_Input>;
  on_conflict?: InputMaybe<Public_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Public_Keys_OneArgs = {
  object: Public_Keys_Insert_Input;
  on_conflict?: InputMaybe<Public_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Qr_CodesArgs = {
  objects: Array<Qr_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Qr_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Qr_Codes_OneArgs = {
  object: Qr_Codes_Insert_Input;
  on_conflict?: InputMaybe<Qr_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Line_Item_PaymentsArgs = {
  objects: Array<R_Line_Item_Payments_Insert_Input>;
  on_conflict?: InputMaybe<R_Line_Item_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Line_Item_Payments_OneArgs = {
  object: R_Line_Item_Payments_Insert_Input;
  on_conflict?: InputMaybe<R_Line_Item_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Parkable_TransactionsArgs = {
  objects: Array<R_Parkable_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<R_Parkable_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Parkable_Transactions_OneArgs = {
  object: R_Parkable_Transactions_Insert_Input;
  on_conflict?: InputMaybe<R_Parkable_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Parking_AuthoritiesArgs = {
  objects: Array<R_Parking_Authorities_Insert_Input>;
  on_conflict?: InputMaybe<R_Parking_Authorities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Parking_Authorities_OneArgs = {
  object: R_Parking_Authorities_Insert_Input;
  on_conflict?: InputMaybe<R_Parking_Authorities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Payment_BatchesArgs = {
  objects: Array<R_Payment_Batches_Insert_Input>;
  on_conflict?: InputMaybe<R_Payment_Batches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Payment_Batches_OneArgs = {
  object: R_Payment_Batches_Insert_Input;
  on_conflict?: InputMaybe<R_Payment_Batches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Transfer_BatchesArgs = {
  objects: Array<R_Transfer_Batches_Insert_Input>;
  on_conflict?: InputMaybe<R_Transfer_Batches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Transfer_Batches_OneArgs = {
  object: R_Transfer_Batches_Insert_Input;
  on_conflict?: InputMaybe<R_Transfer_Batches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_UsersArgs = {
  objects: Array<R_Users_Insert_Input>;
  on_conflict?: InputMaybe<R_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_R_Users_OneArgs = {
  object: R_Users_Insert_Input;
  on_conflict?: InputMaybe<R_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportsArgs = {
  objects: Array<Reports_Insert_Input>;
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reports_OneArgs = {
  object: Reports_Insert_Input;
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Session_Overlap_ResultsArgs = {
  objects: Array<Session_Overlap_Results_Insert_Input>;
  on_conflict?: InputMaybe<Session_Overlap_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Session_Overlap_Results_OneArgs = {
  object: Session_Overlap_Results_Insert_Input;
  on_conflict?: InputMaybe<Session_Overlap_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_TicketsArgs = {
  objects: Array<Support_Tickets_Insert_Input>;
  on_conflict?: InputMaybe<Support_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_Tickets_OneArgs = {
  object: Support_Tickets_Insert_Input;
  on_conflict?: InputMaybe<Support_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_EventsArgs = {
  objects: Array<Task_Events_Insert_Input>;
  on_conflict?: InputMaybe<Task_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Events_OneArgs = {
  object: Task_Events_Insert_Input;
  on_conflict?: InputMaybe<Task_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_StatesArgs = {
  objects: Array<Task_States_Insert_Input>;
  on_conflict?: InputMaybe<Task_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_States_OneArgs = {
  object: Task_States_Insert_Input;
  on_conflict?: InputMaybe<Task_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_UserArgs = {
  objects: Array<Task_User_Insert_Input>;
  on_conflict?: InputMaybe<Task_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_User_OneArgs = {
  object: Task_User_Insert_Input;
  on_conflict?: InputMaybe<Task_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TasksArgs = {
  objects: Array<Tasks_Insert_Input>;
  on_conflict?: InputMaybe<Tasks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tasks_OneArgs = {
  object: Tasks_Insert_Input;
  on_conflict?: InputMaybe<Tasks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transfer_BatchesArgs = {
  objects: Array<Transfer_Batches_Insert_Input>;
  on_conflict?: InputMaybe<Transfer_Batches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transfer_Batches_OneArgs = {
  object: Transfer_Batches_Insert_Input;
  on_conflict?: InputMaybe<Transfer_Batches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ActivitiesArgs = {
  objects: Array<User_Activities_Insert_Input>;
  on_conflict?: InputMaybe<User_Activities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Activities_OneArgs = {
  object: User_Activities_Insert_Input;
  on_conflict?: InputMaybe<User_Activities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ListsArgs = {
  objects: Array<User_Lists_Insert_Input>;
  on_conflict?: InputMaybe<User_Lists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Lists_OneArgs = {
  object: User_Lists_Insert_Input;
  on_conflict?: InputMaybe<User_Lists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_SettingsArgs = {
  objects: Array<User_Settings_Insert_Input>;
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Settings_AllArgs = {
  objects: Array<User_Settings_All_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_User_Settings_All_OneArgs = {
  object: User_Settings_All_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_User_Settings_OneArgs = {
  object: User_Settings_Insert_Input;
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_User_ListArgs = {
  objects: Array<User_User_List_Insert_Input>;
  on_conflict?: InputMaybe<User_User_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_User_List_OneArgs = {
  object: User_User_List_Insert_Input;
  on_conflict?: InputMaybe<User_User_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VehiclesArgs = {
  objects: Array<Vehicles_Insert_Input>;
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicles_OneArgs = {
  object: Vehicles_Insert_Input;
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_TransactionsArgs = {
  objects: Array<Wallet_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Wallet_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_Transactions_OneArgs = {
  object: Wallet_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Wallet_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WalletsArgs = {
  objects: Array<Wallets_Insert_Input>;
  on_conflict?: InputMaybe<Wallets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallets_OneArgs = {
  object: Wallets_Insert_Input;
  on_conflict?: InputMaybe<Wallets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootQrAssignParkablesArgs = {
  meterProperties?: InputMaybe<SurveyDataMeterProperties>;
  parkableIds?: InputMaybe<Array<InputMaybe<Scalars['bigint']['input']>>>;
  qrCodeCodeId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootRefreshParkableTransactionEtlArgs = {
  parkableTransactionId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootRefreshPaymentBatchEtlArgs = {
  paymentBatchId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootRefreshTransferBatchEtlArgs = {
  transferBatchId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootRefreshUserEtlArgs = {
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootReloadWalletArgs = {
  amount: Scalars['Int']['input'];
  idempotentKey: Scalars['uuid']['input'];
  paymentMethodId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootResetAccountSetupArgs = {
  items?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** mutation root */
export type Mutation_RootSaveDeviceArgs = {
  device: ClientDevice;
};


/** mutation root */
export type Mutation_RootStoreVaultedCardAccountArgs = {
  alias: Scalars['String']['input'];
  cardAccountCardId?: InputMaybe<Scalars['String']['input']>;
  cardAccountCardType: Scalars['String']['input'];
  cardAccountId?: InputMaybe<Scalars['bigint']['input']>;
  cardAccountToken: Scalars['String']['input'];
  expiryMonth: Scalars['String']['input'];
  expiryYear: Scalars['String']['input'];
  lastFour: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSubmitEventsPrivateArgs = {
  device?: InputMaybe<ClientDevice>;
  eventsBatches: Array<EventsBatch>;
  now: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootSubmitEventsPublicArgs = {
  device?: InputMaybe<ClientDevice>;
  eventsBatches: Array<EventsBatch>;
  now: Scalars['Int']['input'];
  unauthenticatedCredentials?: InputMaybe<UnauthenticatedCredentials>;
};


/** mutation root */
export type Mutation_RootUpdateUserSettingsArgs = {
  userSettings: Array<InputMaybe<UserSetting>>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Campaign_Admin_UserArgs = {
  _inc?: InputMaybe<Ad_Campaign_Admin_User_Inc_Input>;
  _set?: InputMaybe<Ad_Campaign_Admin_User_Set_Input>;
  where: Ad_Campaign_Admin_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Campaign_Admin_User_ManyArgs = {
  updates: Array<Ad_Campaign_Admin_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Campaign_Parking_AuthorityArgs = {
  _inc?: InputMaybe<Ad_Campaign_Parking_Authority_Inc_Input>;
  _set?: InputMaybe<Ad_Campaign_Parking_Authority_Set_Input>;
  where: Ad_Campaign_Parking_Authority_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Campaign_Parking_Authority_ManyArgs = {
  updates: Array<Ad_Campaign_Parking_Authority_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_CampaignsArgs = {
  _inc?: InputMaybe<Ad_Campaigns_Inc_Input>;
  _set?: InputMaybe<Ad_Campaigns_Set_Input>;
  where: Ad_Campaigns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Campaigns_By_PkArgs = {
  _inc?: InputMaybe<Ad_Campaigns_Inc_Input>;
  _set?: InputMaybe<Ad_Campaigns_Set_Input>;
  pk_columns: Ad_Campaigns_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Campaigns_ManyArgs = {
  updates: Array<Ad_Campaigns_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_EventsArgs = {
  _inc?: InputMaybe<Ad_Events_Inc_Input>;
  _set?: InputMaybe<Ad_Events_Set_Input>;
  where: Ad_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Events_By_PkArgs = {
  _inc?: InputMaybe<Ad_Events_Inc_Input>;
  _set?: InputMaybe<Ad_Events_Set_Input>;
  pk_columns: Ad_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Events_ManyArgs = {
  updates: Array<Ad_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_VariantsArgs = {
  _inc?: InputMaybe<Ad_Variants_Inc_Input>;
  _set?: InputMaybe<Ad_Variants_Set_Input>;
  where: Ad_Variants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Variants_By_PkArgs = {
  _inc?: InputMaybe<Ad_Variants_Inc_Input>;
  _set?: InputMaybe<Ad_Variants_Set_Input>;
  pk_columns: Ad_Variants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Variants_ManyArgs = {
  updates: Array<Ad_Variants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_User_Parking_AuthorityArgs = {
  _inc?: InputMaybe<Admin_User_Parking_Authority_Inc_Input>;
  _set?: InputMaybe<Admin_User_Parking_Authority_Set_Input>;
  where: Admin_User_Parking_Authority_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_User_Parking_Authority_ManyArgs = {
  updates: Array<Admin_User_Parking_Authority_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_UsersArgs = {
  _inc?: InputMaybe<Admin_Users_Inc_Input>;
  _set?: InputMaybe<Admin_Users_Set_Input>;
  where: Admin_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Users_By_PkArgs = {
  _inc?: InputMaybe<Admin_Users_Inc_Input>;
  _set?: InputMaybe<Admin_Users_Set_Input>;
  pk_columns: Admin_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Users_ManyArgs = {
  updates: Array<Admin_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AdsArgs = {
  _inc?: InputMaybe<Ads_Inc_Input>;
  _set?: InputMaybe<Ads_Set_Input>;
  where: Ads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ads_By_PkArgs = {
  _inc?: InputMaybe<Ads_Inc_Input>;
  _set?: InputMaybe<Ads_Set_Input>;
  pk_columns: Ads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ads_ManyArgs = {
  updates: Array<Ads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Batch_SetsArgs = {
  _inc?: InputMaybe<Batch_Sets_Inc_Input>;
  _set?: InputMaybe<Batch_Sets_Set_Input>;
  where: Batch_Sets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Batch_Sets_By_PkArgs = {
  _inc?: InputMaybe<Batch_Sets_Inc_Input>;
  _set?: InputMaybe<Batch_Sets_Set_Input>;
  pk_columns: Batch_Sets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Batch_Sets_ManyArgs = {
  updates: Array<Batch_Sets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Blacklisted_CredentialsArgs = {
  _inc?: InputMaybe<Blacklisted_Credentials_Inc_Input>;
  _set?: InputMaybe<Blacklisted_Credentials_Set_Input>;
  where: Blacklisted_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Blacklisted_Credentials_By_PkArgs = {
  _inc?: InputMaybe<Blacklisted_Credentials_Inc_Input>;
  _set?: InputMaybe<Blacklisted_Credentials_Set_Input>;
  pk_columns: Blacklisted_Credentials_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Blacklisted_Credentials_ManyArgs = {
  updates: Array<Blacklisted_Credentials_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Device_UserArgs = {
  _inc?: InputMaybe<Device_User_Inc_Input>;
  _set?: InputMaybe<Device_User_Set_Input>;
  where: Device_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Device_User_By_PkArgs = {
  _inc?: InputMaybe<Device_User_Inc_Input>;
  _set?: InputMaybe<Device_User_Set_Input>;
  pk_columns: Device_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Device_User_ManyArgs = {
  updates: Array<Device_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DevicesArgs = {
  _inc?: InputMaybe<Devices_Inc_Input>;
  _set?: InputMaybe<Devices_Set_Input>;
  where: Devices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Devices_By_PkArgs = {
  _inc?: InputMaybe<Devices_Inc_Input>;
  _set?: InputMaybe<Devices_Set_Input>;
  pk_columns: Devices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Devices_ManyArgs = {
  updates: Array<Devices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventsArgs = {
  _inc?: InputMaybe<Events_Inc_Input>;
  _set?: InputMaybe<Events_Set_Input>;
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Events_By_PkArgs = {
  _inc?: InputMaybe<Events_Inc_Input>;
  _set?: InputMaybe<Events_Set_Input>;
  pk_columns: Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Events_ManyArgs = {
  updates: Array<Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Failed_JobsArgs = {
  _inc?: InputMaybe<Failed_Jobs_Inc_Input>;
  _set?: InputMaybe<Failed_Jobs_Set_Input>;
  where: Failed_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Failed_Jobs_By_PkArgs = {
  _inc?: InputMaybe<Failed_Jobs_Inc_Input>;
  _set?: InputMaybe<Failed_Jobs_Set_Input>;
  pk_columns: Failed_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Failed_Jobs_ManyArgs = {
  updates: Array<Failed_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Failed_Sentry_MessagesArgs = {
  _inc?: InputMaybe<Failed_Sentry_Messages_Inc_Input>;
  _set?: InputMaybe<Failed_Sentry_Messages_Set_Input>;
  where: Failed_Sentry_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Failed_Sentry_Messages_By_PkArgs = {
  _inc?: InputMaybe<Failed_Sentry_Messages_Inc_Input>;
  _set?: InputMaybe<Failed_Sentry_Messages_Set_Input>;
  pk_columns: Failed_Sentry_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Failed_Sentry_Messages_ManyArgs = {
  updates: Array<Failed_Sentry_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IdentitiesArgs = {
  _inc?: InputMaybe<Identities_Inc_Input>;
  _set?: InputMaybe<Identities_Set_Input>;
  where: Identities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Identities_By_PkArgs = {
  _inc?: InputMaybe<Identities_Inc_Input>;
  _set?: InputMaybe<Identities_Set_Input>;
  pk_columns: Identities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Identities_ManyArgs = {
  updates: Array<Identities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Parkable_TransactionArgs = {
  _inc?: InputMaybe<Invoice_Parkable_Transaction_Inc_Input>;
  _set?: InputMaybe<Invoice_Parkable_Transaction_Set_Input>;
  where: Invoice_Parkable_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Parkable_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Invoice_Parkable_Transaction_Inc_Input>;
  _set?: InputMaybe<Invoice_Parkable_Transaction_Set_Input>;
  pk_columns: Invoice_Parkable_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Parkable_Transaction_ManyArgs = {
  updates: Array<Invoice_Parkable_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Wallet_TransactionArgs = {
  _inc?: InputMaybe<Invoice_Wallet_Transaction_Inc_Input>;
  _set?: InputMaybe<Invoice_Wallet_Transaction_Set_Input>;
  where: Invoice_Wallet_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Wallet_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Invoice_Wallet_Transaction_Inc_Input>;
  _set?: InputMaybe<Invoice_Wallet_Transaction_Set_Input>;
  pk_columns: Invoice_Wallet_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Wallet_Transaction_ManyArgs = {
  updates: Array<Invoice_Wallet_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoicesArgs = {
  _inc?: InputMaybe<Invoices_Inc_Input>;
  _set?: InputMaybe<Invoices_Set_Input>;
  where: Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoices_By_PkArgs = {
  _inc?: InputMaybe<Invoices_Inc_Input>;
  _set?: InputMaybe<Invoices_Set_Input>;
  pk_columns: Invoices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoices_ManyArgs = {
  updates: Array<Invoices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_JobsArgs = {
  _inc?: InputMaybe<Jobs_Inc_Input>;
  _set?: InputMaybe<Jobs_Set_Input>;
  where: Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Jobs_By_PkArgs = {
  _inc?: InputMaybe<Jobs_Inc_Input>;
  _set?: InputMaybe<Jobs_Set_Input>;
  pk_columns: Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Jobs_ManyArgs = {
  updates: Array<Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_MigrationsArgs = {
  _inc?: InputMaybe<Legacy_Migrations_Inc_Input>;
  _set?: InputMaybe<Legacy_Migrations_Set_Input>;
  where: Legacy_Migrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Migrations_By_PkArgs = {
  _inc?: InputMaybe<Legacy_Migrations_Inc_Input>;
  _set?: InputMaybe<Legacy_Migrations_Set_Input>;
  pk_columns: Legacy_Migrations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Migrations_ManyArgs = {
  updates: Array<Legacy_Migrations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Parkable_TransactionsArgs = {
  _inc?: InputMaybe<Legacy_Parkable_Transactions_Inc_Input>;
  _set?: InputMaybe<Legacy_Parkable_Transactions_Set_Input>;
  where: Legacy_Parkable_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Parkable_Transactions_ManyArgs = {
  updates: Array<Legacy_Parkable_Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_PaymentsArgs = {
  _inc?: InputMaybe<Legacy_Payments_Inc_Input>;
  _set?: InputMaybe<Legacy_Payments_Set_Input>;
  where: Legacy_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Payments_ManyArgs = {
  updates: Array<Legacy_Payments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Wallet_TransactionsArgs = {
  _inc?: InputMaybe<Legacy_Wallet_Transactions_Inc_Input>;
  _set?: InputMaybe<Legacy_Wallet_Transactions_Set_Input>;
  where: Legacy_Wallet_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Wallet_Transactions_ManyArgs = {
  updates: Array<Legacy_Wallet_Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Item_Parkable_TransactionArgs = {
  _inc?: InputMaybe<Line_Item_Parkable_Transaction_Inc_Input>;
  _set?: InputMaybe<Line_Item_Parkable_Transaction_Set_Input>;
  where: Line_Item_Parkable_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Item_Parkable_Transaction_ManyArgs = {
  updates: Array<Line_Item_Parkable_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Item_PaymentArgs = {
  _inc?: InputMaybe<Line_Item_Payment_Inc_Input>;
  _set?: InputMaybe<Line_Item_Payment_Set_Input>;
  where: Line_Item_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Item_Payment_By_PkArgs = {
  _inc?: InputMaybe<Line_Item_Payment_Inc_Input>;
  _set?: InputMaybe<Line_Item_Payment_Set_Input>;
  pk_columns: Line_Item_Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Item_Payment_ManyArgs = {
  updates: Array<Line_Item_Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Item_Wallet_TransactionArgs = {
  _inc?: InputMaybe<Line_Item_Wallet_Transaction_Inc_Input>;
  _set?: InputMaybe<Line_Item_Wallet_Transaction_Set_Input>;
  where: Line_Item_Wallet_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Item_Wallet_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Line_Item_Wallet_Transaction_Inc_Input>;
  _set?: InputMaybe<Line_Item_Wallet_Transaction_Set_Input>;
  pk_columns: Line_Item_Wallet_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Item_Wallet_Transaction_ManyArgs = {
  updates: Array<Line_Item_Wallet_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Line_ItemsArgs = {
  _inc?: InputMaybe<Line_Items_Inc_Input>;
  _set?: InputMaybe<Line_Items_Set_Input>;
  where: Line_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Items_By_PkArgs = {
  _inc?: InputMaybe<Line_Items_Inc_Input>;
  _set?: InputMaybe<Line_Items_Set_Input>;
  pk_columns: Line_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Items_ManyArgs = {
  updates: Array<Line_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Login_CodesArgs = {
  _inc?: InputMaybe<Login_Codes_Inc_Input>;
  _set?: InputMaybe<Login_Codes_Set_Input>;
  where: Login_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Login_Codes_By_PkArgs = {
  _inc?: InputMaybe<Login_Codes_Inc_Input>;
  _set?: InputMaybe<Login_Codes_Set_Input>;
  pk_columns: Login_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Login_Codes_ManyArgs = {
  updates: Array<Login_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MigrationsArgs = {
  _inc?: InputMaybe<Migrations_Inc_Input>;
  _set?: InputMaybe<Migrations_Set_Input>;
  where: Migrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Migrations_By_PkArgs = {
  _inc?: InputMaybe<Migrations_Inc_Input>;
  _set?: InputMaybe<Migrations_Set_Input>;
  pk_columns: Migrations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Migrations_ManyArgs = {
  updates: Array<Migrations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Pa_Bank_Account_MetasArgs = {
  _inc?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Inc_Input>;
  _set?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Set_Input>;
  where: Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Pa_Bank_Account_Metas_By_PkArgs = {
  _inc?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Inc_Input>;
  _set?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Set_Input>;
  pk_columns: Mx_Merchant_Pa_Bank_Account_Metas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Pa_Bank_Account_Metas_ManyArgs = {
  updates: Array<Mx_Merchant_Pa_Bank_Account_Metas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Payment_Batch_MetasArgs = {
  _inc?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Inc_Input>;
  _set?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Set_Input>;
  where: Mx_Merchant_Payment_Batch_Metas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Payment_Batch_Metas_By_PkArgs = {
  _inc?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Inc_Input>;
  _set?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Set_Input>;
  pk_columns: Mx_Merchant_Payment_Batch_Metas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Payment_Batch_Metas_ManyArgs = {
  updates: Array<Mx_Merchant_Payment_Batch_Metas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Payment_MetasArgs = {
  _inc?: InputMaybe<Mx_Merchant_Payment_Metas_Inc_Input>;
  _set?: InputMaybe<Mx_Merchant_Payment_Metas_Set_Input>;
  where: Mx_Merchant_Payment_Metas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Payment_Metas_By_PkArgs = {
  _inc?: InputMaybe<Mx_Merchant_Payment_Metas_Inc_Input>;
  _set?: InputMaybe<Mx_Merchant_Payment_Metas_Set_Input>;
  pk_columns: Mx_Merchant_Payment_Metas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Payment_Metas_ManyArgs = {
  updates: Array<Mx_Merchant_Payment_Metas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Payment_Method_MetasArgs = {
  _inc?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Inc_Input>;
  _set?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Set_Input>;
  where: Mx_Merchant_Payment_Method_Metas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Payment_Method_Metas_By_PkArgs = {
  _inc?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Inc_Input>;
  _set?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Set_Input>;
  pk_columns: Mx_Merchant_Payment_Method_Metas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mx_Merchant_Payment_Method_Metas_ManyArgs = {
  updates: Array<Mx_Merchant_Payment_Method_Metas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Group_Parkable_ScheduleArgs = {
  _inc?: InputMaybe<Parkable_Group_Parkable_Schedule_Inc_Input>;
  _set?: InputMaybe<Parkable_Group_Parkable_Schedule_Set_Input>;
  where: Parkable_Group_Parkable_Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Group_Parkable_Schedule_By_PkArgs = {
  _inc?: InputMaybe<Parkable_Group_Parkable_Schedule_Inc_Input>;
  _set?: InputMaybe<Parkable_Group_Parkable_Schedule_Set_Input>;
  pk_columns: Parkable_Group_Parkable_Schedule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Group_Parkable_Schedule_ManyArgs = {
  updates: Array<Parkable_Group_Parkable_Schedule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_GroupsArgs = {
  _inc?: InputMaybe<Parkable_Groups_Inc_Input>;
  _set?: InputMaybe<Parkable_Groups_Set_Input>;
  where: Parkable_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Groups_By_PkArgs = {
  _inc?: InputMaybe<Parkable_Groups_Inc_Input>;
  _set?: InputMaybe<Parkable_Groups_Set_Input>;
  pk_columns: Parkable_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Groups_ManyArgs = {
  updates: Array<Parkable_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Parkable_GroupArgs = {
  _inc?: InputMaybe<Parkable_Parkable_Group_Inc_Input>;
  _set?: InputMaybe<Parkable_Parkable_Group_Set_Input>;
  where: Parkable_Parkable_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Parkable_Group_By_PkArgs = {
  _inc?: InputMaybe<Parkable_Parkable_Group_Inc_Input>;
  _set?: InputMaybe<Parkable_Parkable_Group_Set_Input>;
  pk_columns: Parkable_Parkable_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Parkable_Group_ManyArgs = {
  updates: Array<Parkable_Parkable_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Qr_CodeArgs = {
  _inc?: InputMaybe<Parkable_Qr_Code_Inc_Input>;
  _set?: InputMaybe<Parkable_Qr_Code_Set_Input>;
  where: Parkable_Qr_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Qr_Code_ManyArgs = {
  updates: Array<Parkable_Qr_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_SchedulesArgs = {
  _inc?: InputMaybe<Parkable_Schedules_Inc_Input>;
  _set?: InputMaybe<Parkable_Schedules_Set_Input>;
  where: Parkable_Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Schedules_By_PkArgs = {
  _inc?: InputMaybe<Parkable_Schedules_Inc_Input>;
  _set?: InputMaybe<Parkable_Schedules_Set_Input>;
  pk_columns: Parkable_Schedules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Schedules_ManyArgs = {
  updates: Array<Parkable_Schedules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Transaction_TaskArgs = {
  _inc?: InputMaybe<Parkable_Transaction_Task_Inc_Input>;
  _set?: InputMaybe<Parkable_Transaction_Task_Set_Input>;
  where: Parkable_Transaction_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Transaction_Task_By_PkArgs = {
  _inc?: InputMaybe<Parkable_Transaction_Task_Inc_Input>;
  _set?: InputMaybe<Parkable_Transaction_Task_Set_Input>;
  pk_columns: Parkable_Transaction_Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Transaction_Task_ManyArgs = {
  updates: Array<Parkable_Transaction_Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Transaction_Wallet_TransactionArgs = {
  _inc?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Inc_Input>;
  _set?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Set_Input>;
  where: Parkable_Transaction_Wallet_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Transaction_Wallet_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Inc_Input>;
  _set?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Set_Input>;
  pk_columns: Parkable_Transaction_Wallet_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Transaction_Wallet_Transaction_ManyArgs = {
  updates: Array<Parkable_Transaction_Wallet_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_TransactionsArgs = {
  _inc?: InputMaybe<Parkable_Transactions_Inc_Input>;
  _set?: InputMaybe<Parkable_Transactions_Set_Input>;
  where: Parkable_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Transactions_By_PkArgs = {
  _inc?: InputMaybe<Parkable_Transactions_Inc_Input>;
  _set?: InputMaybe<Parkable_Transactions_Set_Input>;
  pk_columns: Parkable_Transactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parkable_Transactions_ManyArgs = {
  updates: Array<Parkable_Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ParkablesArgs = {
  _inc?: InputMaybe<Parkables_Inc_Input>;
  _set?: InputMaybe<Parkables_Set_Input>;
  where: Parkables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parkables_By_PkArgs = {
  _inc?: InputMaybe<Parkables_Inc_Input>;
  _set?: InputMaybe<Parkables_Set_Input>;
  pk_columns: Parkables_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parkables_ManyArgs = {
  updates: Array<Parkables_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_AuthoritiesArgs = {
  _inc?: InputMaybe<Parking_Authorities_Inc_Input>;
  _set?: InputMaybe<Parking_Authorities_Set_Input>;
  where: Parking_Authorities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authorities_By_PkArgs = {
  _inc?: InputMaybe<Parking_Authorities_Inc_Input>;
  _set?: InputMaybe<Parking_Authorities_Set_Input>;
  pk_columns: Parking_Authorities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authorities_ManyArgs = {
  updates: Array<Parking_Authorities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authority_Bank_AccountsArgs = {
  _inc?: InputMaybe<Parking_Authority_Bank_Accounts_Inc_Input>;
  _set?: InputMaybe<Parking_Authority_Bank_Accounts_Set_Input>;
  where: Parking_Authority_Bank_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authority_Bank_Accounts_By_PkArgs = {
  _inc?: InputMaybe<Parking_Authority_Bank_Accounts_Inc_Input>;
  _set?: InputMaybe<Parking_Authority_Bank_Accounts_Set_Input>;
  pk_columns: Parking_Authority_Bank_Accounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authority_Bank_Accounts_ManyArgs = {
  updates: Array<Parking_Authority_Bank_Accounts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authority_SettingsArgs = {
  _inc?: InputMaybe<Parking_Authority_Settings_Inc_Input>;
  _set?: InputMaybe<Parking_Authority_Settings_Set_Input>;
  where: Parking_Authority_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authority_Settings_By_PkArgs = {
  _inc?: InputMaybe<Parking_Authority_Settings_Inc_Input>;
  _set?: InputMaybe<Parking_Authority_Settings_Set_Input>;
  pk_columns: Parking_Authority_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authority_Settings_ManyArgs = {
  updates: Array<Parking_Authority_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authority_UserArgs = {
  _inc?: InputMaybe<Parking_Authority_User_Inc_Input>;
  _set?: InputMaybe<Parking_Authority_User_Set_Input>;
  where: Parking_Authority_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authority_User_By_PkArgs = {
  _inc?: InputMaybe<Parking_Authority_User_Inc_Input>;
  _set?: InputMaybe<Parking_Authority_User_Set_Input>;
  pk_columns: Parking_Authority_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parking_Authority_User_ManyArgs = {
  updates: Array<Parking_Authority_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_BatchesArgs = {
  _inc?: InputMaybe<Payment_Batches_Inc_Input>;
  _set?: InputMaybe<Payment_Batches_Set_Input>;
  where: Payment_Batches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Batches_By_PkArgs = {
  _inc?: InputMaybe<Payment_Batches_Inc_Input>;
  _set?: InputMaybe<Payment_Batches_Set_Input>;
  pk_columns: Payment_Batches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Batches_ManyArgs = {
  updates: Array<Payment_Batches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_MethodsArgs = {
  _inc?: InputMaybe<Payment_Methods_Inc_Input>;
  _set?: InputMaybe<Payment_Methods_Set_Input>;
  where: Payment_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Methods_By_PkArgs = {
  _inc?: InputMaybe<Payment_Methods_Inc_Input>;
  _set?: InputMaybe<Payment_Methods_Set_Input>;
  pk_columns: Payment_Methods_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Methods_ManyArgs = {
  updates: Array<Payment_Methods_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Wallet_TransactionArgs = {
  _inc?: InputMaybe<Payment_Wallet_Transaction_Inc_Input>;
  _set?: InputMaybe<Payment_Wallet_Transaction_Set_Input>;
  where: Payment_Wallet_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Wallet_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Payment_Wallet_Transaction_Inc_Input>;
  _set?: InputMaybe<Payment_Wallet_Transaction_Set_Input>;
  pk_columns: Payment_Wallet_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Wallet_Transaction_ManyArgs = {
  updates: Array<Payment_Wallet_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentsArgs = {
  _inc?: InputMaybe<Payments_Inc_Input>;
  _set?: InputMaybe<Payments_Set_Input>;
  where: Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payments_By_PkArgs = {
  _inc?: InputMaybe<Payments_Inc_Input>;
  _set?: InputMaybe<Payments_Set_Input>;
  pk_columns: Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payments_ManyArgs = {
  updates: Array<Payments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pending_UsersArgs = {
  _inc?: InputMaybe<Pending_Users_Inc_Input>;
  _set?: InputMaybe<Pending_Users_Set_Input>;
  where: Pending_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pending_Users_By_PkArgs = {
  _inc?: InputMaybe<Pending_Users_Inc_Input>;
  _set?: InputMaybe<Pending_Users_Set_Input>;
  pk_columns: Pending_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pending_Users_ManyArgs = {
  updates: Array<Pending_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_Access_TokensArgs = {
  _inc?: InputMaybe<Personal_Access_Tokens_Inc_Input>;
  _set?: InputMaybe<Personal_Access_Tokens_Set_Input>;
  where: Personal_Access_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_Access_Tokens_By_PkArgs = {
  _inc?: InputMaybe<Personal_Access_Tokens_Inc_Input>;
  _set?: InputMaybe<Personal_Access_Tokens_Set_Input>;
  pk_columns: Personal_Access_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_Access_Tokens_ManyArgs = {
  updates: Array<Personal_Access_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Public_KeysArgs = {
  _set?: InputMaybe<Public_Keys_Set_Input>;
  where: Public_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Public_Keys_ManyArgs = {
  updates: Array<Public_Keys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Qr_CodesArgs = {
  _inc?: InputMaybe<Qr_Codes_Inc_Input>;
  _set?: InputMaybe<Qr_Codes_Set_Input>;
  where: Qr_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Qr_Codes_By_PkArgs = {
  _inc?: InputMaybe<Qr_Codes_Inc_Input>;
  _set?: InputMaybe<Qr_Codes_Set_Input>;
  pk_columns: Qr_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Qr_Codes_ManyArgs = {
  updates: Array<Qr_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_R_Line_Item_PaymentsArgs = {
  _inc?: InputMaybe<R_Line_Item_Payments_Inc_Input>;
  _set?: InputMaybe<R_Line_Item_Payments_Set_Input>;
  where: R_Line_Item_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_R_Line_Item_Payments_By_PkArgs = {
  _inc?: InputMaybe<R_Line_Item_Payments_Inc_Input>;
  _set?: InputMaybe<R_Line_Item_Payments_Set_Input>;
  pk_columns: R_Line_Item_Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_R_Line_Item_Payments_ManyArgs = {
  updates: Array<R_Line_Item_Payments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_R_Parkable_TransactionsArgs = {
  _inc?: InputMaybe<R_Parkable_Transactions_Inc_Input>;
  _set?: InputMaybe<R_Parkable_Transactions_Set_Input>;
  where: R_Parkable_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_R_Parkable_Transactions_By_PkArgs = {
  _inc?: InputMaybe<R_Parkable_Transactions_Inc_Input>;
  _set?: InputMaybe<R_Parkable_Transactions_Set_Input>;
  pk_columns: R_Parkable_Transactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_R_Parkable_Transactions_ManyArgs = {
  updates: Array<R_Parkable_Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_R_Parking_AuthoritiesArgs = {
  _inc?: InputMaybe<R_Parking_Authorities_Inc_Input>;
  _set?: InputMaybe<R_Parking_Authorities_Set_Input>;
  where: R_Parking_Authorities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_R_Parking_Authorities_By_PkArgs = {
  _inc?: InputMaybe<R_Parking_Authorities_Inc_Input>;
  _set?: InputMaybe<R_Parking_Authorities_Set_Input>;
  pk_columns: R_Parking_Authorities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_R_Parking_Authorities_ManyArgs = {
  updates: Array<R_Parking_Authorities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_R_Payment_BatchesArgs = {
  _inc?: InputMaybe<R_Payment_Batches_Inc_Input>;
  _set?: InputMaybe<R_Payment_Batches_Set_Input>;
  where: R_Payment_Batches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_R_Payment_Batches_By_PkArgs = {
  _inc?: InputMaybe<R_Payment_Batches_Inc_Input>;
  _set?: InputMaybe<R_Payment_Batches_Set_Input>;
  pk_columns: R_Payment_Batches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_R_Payment_Batches_ManyArgs = {
  updates: Array<R_Payment_Batches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_R_Transfer_BatchesArgs = {
  _inc?: InputMaybe<R_Transfer_Batches_Inc_Input>;
  _set?: InputMaybe<R_Transfer_Batches_Set_Input>;
  where: R_Transfer_Batches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_R_Transfer_Batches_By_PkArgs = {
  _inc?: InputMaybe<R_Transfer_Batches_Inc_Input>;
  _set?: InputMaybe<R_Transfer_Batches_Set_Input>;
  pk_columns: R_Transfer_Batches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_R_Transfer_Batches_ManyArgs = {
  updates: Array<R_Transfer_Batches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_R_UsersArgs = {
  _inc?: InputMaybe<R_Users_Inc_Input>;
  _set?: InputMaybe<R_Users_Set_Input>;
  where: R_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_R_Users_By_PkArgs = {
  _inc?: InputMaybe<R_Users_Inc_Input>;
  _set?: InputMaybe<R_Users_Set_Input>;
  pk_columns: R_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_R_Users_ManyArgs = {
  updates: Array<R_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportsArgs = {
  _inc?: InputMaybe<Reports_Inc_Input>;
  _set?: InputMaybe<Reports_Set_Input>;
  where: Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reports_By_PkArgs = {
  _inc?: InputMaybe<Reports_Inc_Input>;
  _set?: InputMaybe<Reports_Set_Input>;
  pk_columns: Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reports_ManyArgs = {
  updates: Array<Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Session_Overlap_ResultsArgs = {
  _inc?: InputMaybe<Session_Overlap_Results_Inc_Input>;
  _set?: InputMaybe<Session_Overlap_Results_Set_Input>;
  where: Session_Overlap_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Session_Overlap_Results_By_PkArgs = {
  _inc?: InputMaybe<Session_Overlap_Results_Inc_Input>;
  _set?: InputMaybe<Session_Overlap_Results_Set_Input>;
  pk_columns: Session_Overlap_Results_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Session_Overlap_Results_ManyArgs = {
  updates: Array<Session_Overlap_Results_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Support_TicketsArgs = {
  _inc?: InputMaybe<Support_Tickets_Inc_Input>;
  _set?: InputMaybe<Support_Tickets_Set_Input>;
  where: Support_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Tickets_By_PkArgs = {
  _inc?: InputMaybe<Support_Tickets_Inc_Input>;
  _set?: InputMaybe<Support_Tickets_Set_Input>;
  pk_columns: Support_Tickets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Tickets_ManyArgs = {
  updates: Array<Support_Tickets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_EventsArgs = {
  _inc?: InputMaybe<Task_Events_Inc_Input>;
  _set?: InputMaybe<Task_Events_Set_Input>;
  where: Task_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Events_By_PkArgs = {
  _inc?: InputMaybe<Task_Events_Inc_Input>;
  _set?: InputMaybe<Task_Events_Set_Input>;
  pk_columns: Task_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Events_ManyArgs = {
  updates: Array<Task_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_StatesArgs = {
  _inc?: InputMaybe<Task_States_Inc_Input>;
  _set?: InputMaybe<Task_States_Set_Input>;
  where: Task_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_States_By_PkArgs = {
  _inc?: InputMaybe<Task_States_Inc_Input>;
  _set?: InputMaybe<Task_States_Set_Input>;
  pk_columns: Task_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_States_ManyArgs = {
  updates: Array<Task_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_UserArgs = {
  _inc?: InputMaybe<Task_User_Inc_Input>;
  _set?: InputMaybe<Task_User_Set_Input>;
  where: Task_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_User_By_PkArgs = {
  _inc?: InputMaybe<Task_User_Inc_Input>;
  _set?: InputMaybe<Task_User_Set_Input>;
  pk_columns: Task_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_User_ManyArgs = {
  updates: Array<Task_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TasksArgs = {
  _inc?: InputMaybe<Tasks_Inc_Input>;
  _set?: InputMaybe<Tasks_Set_Input>;
  where: Tasks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tasks_By_PkArgs = {
  _inc?: InputMaybe<Tasks_Inc_Input>;
  _set?: InputMaybe<Tasks_Set_Input>;
  pk_columns: Tasks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tasks_ManyArgs = {
  updates: Array<Tasks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transfer_BatchesArgs = {
  _inc?: InputMaybe<Transfer_Batches_Inc_Input>;
  _set?: InputMaybe<Transfer_Batches_Set_Input>;
  where: Transfer_Batches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transfer_Batches_By_PkArgs = {
  _inc?: InputMaybe<Transfer_Batches_Inc_Input>;
  _set?: InputMaybe<Transfer_Batches_Set_Input>;
  pk_columns: Transfer_Batches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transfer_Batches_ManyArgs = {
  updates: Array<Transfer_Batches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ActivitiesArgs = {
  _inc?: InputMaybe<User_Activities_Inc_Input>;
  _set?: InputMaybe<User_Activities_Set_Input>;
  where: User_Activities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Activities_By_PkArgs = {
  _inc?: InputMaybe<User_Activities_Inc_Input>;
  _set?: InputMaybe<User_Activities_Set_Input>;
  pk_columns: User_Activities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Activities_ManyArgs = {
  updates: Array<User_Activities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ListsArgs = {
  _inc?: InputMaybe<User_Lists_Inc_Input>;
  _set?: InputMaybe<User_Lists_Set_Input>;
  where: User_Lists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Lists_By_PkArgs = {
  _inc?: InputMaybe<User_Lists_Inc_Input>;
  _set?: InputMaybe<User_Lists_Set_Input>;
  pk_columns: User_Lists_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Lists_ManyArgs = {
  updates: Array<User_Lists_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_SettingsArgs = {
  _inc?: InputMaybe<User_Settings_Inc_Input>;
  _set?: InputMaybe<User_Settings_Set_Input>;
  where: User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_AllArgs = {
  _inc?: InputMaybe<User_Settings_All_Inc_Input>;
  _set?: InputMaybe<User_Settings_All_Set_Input>;
  where: User_Settings_All_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_All_ManyArgs = {
  updates: Array<User_Settings_All_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_By_PkArgs = {
  _inc?: InputMaybe<User_Settings_Inc_Input>;
  _set?: InputMaybe<User_Settings_Set_Input>;
  pk_columns: User_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_ManyArgs = {
  updates: Array<User_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_User_ListArgs = {
  _inc?: InputMaybe<User_User_List_Inc_Input>;
  _set?: InputMaybe<User_User_List_Set_Input>;
  where: User_User_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_User_List_By_PkArgs = {
  _inc?: InputMaybe<User_User_List_Inc_Input>;
  _set?: InputMaybe<User_User_List_Set_Input>;
  pk_columns: User_User_List_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_User_List_ManyArgs = {
  updates: Array<User_User_List_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VehiclesArgs = {
  _inc?: InputMaybe<Vehicles_Inc_Input>;
  _set?: InputMaybe<Vehicles_Set_Input>;
  where: Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicles_By_PkArgs = {
  _inc?: InputMaybe<Vehicles_Inc_Input>;
  _set?: InputMaybe<Vehicles_Set_Input>;
  pk_columns: Vehicles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicles_ManyArgs = {
  updates: Array<Vehicles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_TransactionsArgs = {
  _inc?: InputMaybe<Wallet_Transactions_Inc_Input>;
  _set?: InputMaybe<Wallet_Transactions_Set_Input>;
  where: Wallet_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_Transactions_By_PkArgs = {
  _inc?: InputMaybe<Wallet_Transactions_Inc_Input>;
  _set?: InputMaybe<Wallet_Transactions_Set_Input>;
  pk_columns: Wallet_Transactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_Transactions_ManyArgs = {
  updates: Array<Wallet_Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WalletsArgs = {
  _inc?: InputMaybe<Wallets_Inc_Input>;
  _set?: InputMaybe<Wallets_Set_Input>;
  where: Wallets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wallets_By_PkArgs = {
  _inc?: InputMaybe<Wallets_Inc_Input>;
  _set?: InputMaybe<Wallets_Set_Input>;
  pk_columns: Wallets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wallets_ManyArgs = {
  updates: Array<Wallets_Updates>;
};

/** columns and relationships of "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas = {
  __typename?: 'mx_merchant_pa_bank_account_metas';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  meta_bank_account_address_id?: Maybe<Scalars['bigint']['output']>;
  meta_bank_account_card_id?: Maybe<Scalars['String']['output']>;
  meta_bank_account_hash?: Maybe<Scalars['String']['output']>;
  meta_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  meta_bank_account_last_4: Scalars['String']['output'];
  meta_bank_account_routing_number?: Maybe<Scalars['String']['output']>;
  meta_bank_account_token: Scalars['String']['output'];
  meta_bank_account_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parking_authority_bank_account: Parking_Authority_Bank_Accounts;
  parking_authority_bank_account_id: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas_Aggregate = {
  __typename?: 'mx_merchant_pa_bank_account_metas_aggregate';
  aggregate?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Aggregate_Fields>;
  nodes: Array<Mx_Merchant_Pa_Bank_Account_Metas>;
};

/** aggregate fields of "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas_Aggregate_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_aggregate_fields';
  avg?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Max_Fields>;
  min?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Min_Fields>;
  stddev?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Stddev_Fields>;
  stddev_pop?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Stddev_Samp_Fields>;
  sum?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Sum_Fields>;
  var_pop?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Var_Pop_Fields>;
  var_samp?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Var_Samp_Fields>;
  variance?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas_Variance_Fields>;
};


/** aggregate fields of "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mx_Merchant_Pa_Bank_Account_Metas_Avg_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_address_id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mx_merchant_pa_bank_account_metas". All fields are combined with a logical 'AND'. */
export type Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp = {
  _and?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp>>;
  _not?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp>;
  _or?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_bank_account_address_id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_bank_account_card_id?: InputMaybe<String_Comparison_Exp>;
  meta_bank_account_hash?: InputMaybe<String_Comparison_Exp>;
  meta_bank_account_id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_bank_account_last_4?: InputMaybe<String_Comparison_Exp>;
  meta_bank_account_routing_number?: InputMaybe<String_Comparison_Exp>;
  meta_bank_account_token?: InputMaybe<String_Comparison_Exp>;
  meta_bank_account_type?: InputMaybe<String_Comparison_Exp>;
  parking_authority_bank_account?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
  parking_authority_bank_account_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "mx_merchant_pa_bank_account_metas" */
export enum Mx_Merchant_Pa_Bank_Account_Metas_Constraint {
  /** unique or primary key constraint on columns "id" */
  MxMerchantPaBankAccountMetasPkey = 'mx_merchant_pa_bank_account_metas_pkey',
  /** unique or primary key constraint on columns "meta_bank_account_token", "parking_authority_bank_account_id" */
  MxmPabaPaBankAccountIdMetaBankAccountToken = 'mxm_paba_pa_bank_account_id_meta_bank_account_token',
  /** unique or primary key constraint on columns "parking_authority_bank_account_id" */
  MxmPabaParkingAuthorityBankAccountId = 'mxm_paba_parking_authority_bank_account_id'
}

/** input type for incrementing numeric columns in table "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_address_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_address_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_card_id?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_hash?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_last_4?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_routing_number?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_token?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_type?: InputMaybe<Scalars['String']['input']>;
  parking_authority_bank_account?: InputMaybe<Parking_Authority_Bank_Accounts_Obj_Rel_Insert_Input>;
  parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Mx_Merchant_Pa_Bank_Account_Metas_Max_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  meta_bank_account_address_id?: Maybe<Scalars['bigint']['output']>;
  meta_bank_account_card_id?: Maybe<Scalars['String']['output']>;
  meta_bank_account_hash?: Maybe<Scalars['String']['output']>;
  meta_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  meta_bank_account_last_4?: Maybe<Scalars['String']['output']>;
  meta_bank_account_routing_number?: Maybe<Scalars['String']['output']>;
  meta_bank_account_token?: Maybe<Scalars['String']['output']>;
  meta_bank_account_type?: Maybe<Scalars['String']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Mx_Merchant_Pa_Bank_Account_Metas_Min_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  meta_bank_account_address_id?: Maybe<Scalars['bigint']['output']>;
  meta_bank_account_card_id?: Maybe<Scalars['String']['output']>;
  meta_bank_account_hash?: Maybe<Scalars['String']['output']>;
  meta_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  meta_bank_account_last_4?: Maybe<Scalars['String']['output']>;
  meta_bank_account_routing_number?: Maybe<Scalars['String']['output']>;
  meta_bank_account_token?: Maybe<Scalars['String']['output']>;
  meta_bank_account_type?: Maybe<Scalars['String']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas_Mutation_Response = {
  __typename?: 'mx_merchant_pa_bank_account_metas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mx_Merchant_Pa_Bank_Account_Metas>;
};

/** input type for inserting object relation for remote table "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas_Obj_Rel_Insert_Input = {
  data: Mx_Merchant_Pa_Bank_Account_Metas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_On_Conflict>;
};

/** on_conflict condition type for table "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas_On_Conflict = {
  constraint: Mx_Merchant_Pa_Bank_Account_Metas_Constraint;
  update_columns?: Array<Mx_Merchant_Pa_Bank_Account_Metas_Update_Column>;
  where?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp>;
};

/** Ordering options when selecting data from "mx_merchant_pa_bank_account_metas". */
export type Mx_Merchant_Pa_Bank_Account_Metas_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_bank_account_address_id?: InputMaybe<Order_By>;
  meta_bank_account_card_id?: InputMaybe<Order_By>;
  meta_bank_account_hash?: InputMaybe<Order_By>;
  meta_bank_account_id?: InputMaybe<Order_By>;
  meta_bank_account_last_4?: InputMaybe<Order_By>;
  meta_bank_account_routing_number?: InputMaybe<Order_By>;
  meta_bank_account_token?: InputMaybe<Order_By>;
  meta_bank_account_type?: InputMaybe<Order_By>;
  parking_authority_bank_account?: InputMaybe<Parking_Authority_Bank_Accounts_Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mx_merchant_pa_bank_account_metas */
export type Mx_Merchant_Pa_Bank_Account_Metas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "mx_merchant_pa_bank_account_metas" */
export enum Mx_Merchant_Pa_Bank_Account_Metas_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetaBankAccountAddressId = 'meta_bank_account_address_id',
  /** column name */
  MetaBankAccountCardId = 'meta_bank_account_card_id',
  /** column name */
  MetaBankAccountHash = 'meta_bank_account_hash',
  /** column name */
  MetaBankAccountId = 'meta_bank_account_id',
  /** column name */
  MetaBankAccountLast_4 = 'meta_bank_account_last_4',
  /** column name */
  MetaBankAccountRoutingNumber = 'meta_bank_account_routing_number',
  /** column name */
  MetaBankAccountToken = 'meta_bank_account_token',
  /** column name */
  MetaBankAccountType = 'meta_bank_account_type',
  /** column name */
  ParkingAuthorityBankAccountId = 'parking_authority_bank_account_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_address_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_card_id?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_hash?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_last_4?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_routing_number?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_token?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_type?: InputMaybe<Scalars['String']['input']>;
  parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Mx_Merchant_Pa_Bank_Account_Metas_Stddev_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_address_id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mx_Merchant_Pa_Bank_Account_Metas_Stddev_Pop_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_address_id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mx_Merchant_Pa_Bank_Account_Metas_Stddev_Samp_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_address_id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mx_merchant_pa_bank_account_metas" */
export type Mx_Merchant_Pa_Bank_Account_Metas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mx_Merchant_Pa_Bank_Account_Metas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mx_Merchant_Pa_Bank_Account_Metas_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_address_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_card_id?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_hash?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_bank_account_last_4?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_routing_number?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_token?: InputMaybe<Scalars['String']['input']>;
  meta_bank_account_type?: InputMaybe<Scalars['String']['input']>;
  parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Mx_Merchant_Pa_Bank_Account_Metas_Sum_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  meta_bank_account_address_id?: Maybe<Scalars['bigint']['output']>;
  meta_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "mx_merchant_pa_bank_account_metas" */
export enum Mx_Merchant_Pa_Bank_Account_Metas_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetaBankAccountAddressId = 'meta_bank_account_address_id',
  /** column name */
  MetaBankAccountCardId = 'meta_bank_account_card_id',
  /** column name */
  MetaBankAccountHash = 'meta_bank_account_hash',
  /** column name */
  MetaBankAccountId = 'meta_bank_account_id',
  /** column name */
  MetaBankAccountLast_4 = 'meta_bank_account_last_4',
  /** column name */
  MetaBankAccountRoutingNumber = 'meta_bank_account_routing_number',
  /** column name */
  MetaBankAccountToken = 'meta_bank_account_token',
  /** column name */
  MetaBankAccountType = 'meta_bank_account_type',
  /** column name */
  ParkingAuthorityBankAccountId = 'parking_authority_bank_account_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Mx_Merchant_Pa_Bank_Account_Metas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mx_Merchant_Pa_Bank_Account_Metas_Var_Pop_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_address_id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mx_Merchant_Pa_Bank_Account_Metas_Var_Samp_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_address_id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mx_Merchant_Pa_Bank_Account_Metas_Variance_Fields = {
  __typename?: 'mx_merchant_pa_bank_account_metas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_address_id?: Maybe<Scalars['Float']['output']>;
  meta_bank_account_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas = {
  __typename?: 'mx_merchant_payment_batch_metas';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  meta_closed?: Maybe<Scalars['timestamp']['output']>;
  meta_closer_name?: Maybe<Scalars['String']['output']>;
  meta_device?: Maybe<Scalars['String']['output']>;
  meta_id: Scalars['bigint']['output'];
  meta_net_amount?: Maybe<Scalars['Int']['output']>;
  meta_net_count?: Maybe<Scalars['Int']['output']>;
  meta_net_tip?: Maybe<Scalars['Int']['output']>;
  meta_net_total?: Maybe<Scalars['Int']['output']>;
  meta_opened?: Maybe<Scalars['timestamp']['output']>;
  meta_processor_name?: Maybe<Scalars['String']['output']>;
  meta_reference?: Maybe<Scalars['String']['output']>;
  meta_return_amount?: Maybe<Scalars['Int']['output']>;
  meta_return_count?: Maybe<Scalars['Int']['output']>;
  meta_sale_amount?: Maybe<Scalars['Int']['output']>;
  meta_sale_count?: Maybe<Scalars['Int']['output']>;
  meta_status?: Maybe<Scalars['String']['output']>;
  meta_tender_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  payment_batch: Payment_Batches;
  payment_batch_id: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas_Aggregate = {
  __typename?: 'mx_merchant_payment_batch_metas_aggregate';
  aggregate?: Maybe<Mx_Merchant_Payment_Batch_Metas_Aggregate_Fields>;
  nodes: Array<Mx_Merchant_Payment_Batch_Metas>;
};

/** aggregate fields of "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas_Aggregate_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_aggregate_fields';
  avg?: Maybe<Mx_Merchant_Payment_Batch_Metas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mx_Merchant_Payment_Batch_Metas_Max_Fields>;
  min?: Maybe<Mx_Merchant_Payment_Batch_Metas_Min_Fields>;
  stddev?: Maybe<Mx_Merchant_Payment_Batch_Metas_Stddev_Fields>;
  stddev_pop?: Maybe<Mx_Merchant_Payment_Batch_Metas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mx_Merchant_Payment_Batch_Metas_Stddev_Samp_Fields>;
  sum?: Maybe<Mx_Merchant_Payment_Batch_Metas_Sum_Fields>;
  var_pop?: Maybe<Mx_Merchant_Payment_Batch_Metas_Var_Pop_Fields>;
  var_samp?: Maybe<Mx_Merchant_Payment_Batch_Metas_Var_Samp_Fields>;
  variance?: Maybe<Mx_Merchant_Payment_Batch_Metas_Variance_Fields>;
};


/** aggregate fields of "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mx_Merchant_Payment_Batch_Metas_Avg_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_net_amount?: Maybe<Scalars['Float']['output']>;
  meta_net_count?: Maybe<Scalars['Float']['output']>;
  meta_net_tip?: Maybe<Scalars['Float']['output']>;
  meta_net_total?: Maybe<Scalars['Float']['output']>;
  meta_return_amount?: Maybe<Scalars['Float']['output']>;
  meta_return_count?: Maybe<Scalars['Float']['output']>;
  meta_sale_amount?: Maybe<Scalars['Float']['output']>;
  meta_sale_count?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mx_merchant_payment_batch_metas". All fields are combined with a logical 'AND'. */
export type Mx_Merchant_Payment_Batch_Metas_Bool_Exp = {
  _and?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>>;
  _not?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>;
  _or?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_closed?: InputMaybe<Timestamp_Comparison_Exp>;
  meta_closer_name?: InputMaybe<String_Comparison_Exp>;
  meta_device?: InputMaybe<String_Comparison_Exp>;
  meta_id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_net_amount?: InputMaybe<Int_Comparison_Exp>;
  meta_net_count?: InputMaybe<Int_Comparison_Exp>;
  meta_net_tip?: InputMaybe<Int_Comparison_Exp>;
  meta_net_total?: InputMaybe<Int_Comparison_Exp>;
  meta_opened?: InputMaybe<Timestamp_Comparison_Exp>;
  meta_processor_name?: InputMaybe<String_Comparison_Exp>;
  meta_reference?: InputMaybe<String_Comparison_Exp>;
  meta_return_amount?: InputMaybe<Int_Comparison_Exp>;
  meta_return_count?: InputMaybe<Int_Comparison_Exp>;
  meta_sale_amount?: InputMaybe<Int_Comparison_Exp>;
  meta_sale_count?: InputMaybe<Int_Comparison_Exp>;
  meta_status?: InputMaybe<String_Comparison_Exp>;
  meta_tender_type?: InputMaybe<String_Comparison_Exp>;
  payment_batch?: InputMaybe<Payment_Batches_Bool_Exp>;
  payment_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "mx_merchant_payment_batch_metas" */
export enum Mx_Merchant_Payment_Batch_Metas_Constraint {
  /** unique or primary key constraint on columns "meta_id" */
  MxMerchantPaymentBatchMetasMetaIdUnique = 'mx_merchant_payment_batch_metas_meta_id_unique',
  /** unique or primary key constraint on columns "payment_batch_id" */
  MxMerchantPaymentBatchMetasPaymentBatchIdUnique = 'mx_merchant_payment_batch_metas_payment_batch_id_unique',
  /** unique or primary key constraint on columns "id" */
  MxMerchantPaymentBatchMetasPkey = 'mx_merchant_payment_batch_metas_pkey'
}

/** input type for incrementing numeric columns in table "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_net_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_net_count?: InputMaybe<Scalars['Int']['input']>;
  meta_net_tip?: InputMaybe<Scalars['Int']['input']>;
  meta_net_total?: InputMaybe<Scalars['Int']['input']>;
  meta_return_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_return_count?: InputMaybe<Scalars['Int']['input']>;
  meta_sale_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_sale_count?: InputMaybe<Scalars['Int']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_closed?: InputMaybe<Scalars['timestamp']['input']>;
  meta_closer_name?: InputMaybe<Scalars['String']['input']>;
  meta_device?: InputMaybe<Scalars['String']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_net_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_net_count?: InputMaybe<Scalars['Int']['input']>;
  meta_net_tip?: InputMaybe<Scalars['Int']['input']>;
  meta_net_total?: InputMaybe<Scalars['Int']['input']>;
  meta_opened?: InputMaybe<Scalars['timestamp']['input']>;
  meta_processor_name?: InputMaybe<Scalars['String']['input']>;
  meta_reference?: InputMaybe<Scalars['String']['input']>;
  meta_return_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_return_count?: InputMaybe<Scalars['Int']['input']>;
  meta_sale_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_sale_count?: InputMaybe<Scalars['Int']['input']>;
  meta_status?: InputMaybe<Scalars['String']['input']>;
  meta_tender_type?: InputMaybe<Scalars['String']['input']>;
  payment_batch?: InputMaybe<Payment_Batches_Obj_Rel_Insert_Input>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Mx_Merchant_Payment_Batch_Metas_Max_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  meta_closed?: Maybe<Scalars['timestamp']['output']>;
  meta_closer_name?: Maybe<Scalars['String']['output']>;
  meta_device?: Maybe<Scalars['String']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  meta_net_amount?: Maybe<Scalars['Int']['output']>;
  meta_net_count?: Maybe<Scalars['Int']['output']>;
  meta_net_tip?: Maybe<Scalars['Int']['output']>;
  meta_net_total?: Maybe<Scalars['Int']['output']>;
  meta_opened?: Maybe<Scalars['timestamp']['output']>;
  meta_processor_name?: Maybe<Scalars['String']['output']>;
  meta_reference?: Maybe<Scalars['String']['output']>;
  meta_return_amount?: Maybe<Scalars['Int']['output']>;
  meta_return_count?: Maybe<Scalars['Int']['output']>;
  meta_sale_amount?: Maybe<Scalars['Int']['output']>;
  meta_sale_count?: Maybe<Scalars['Int']['output']>;
  meta_status?: Maybe<Scalars['String']['output']>;
  meta_tender_type?: Maybe<Scalars['String']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Mx_Merchant_Payment_Batch_Metas_Min_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  meta_closed?: Maybe<Scalars['timestamp']['output']>;
  meta_closer_name?: Maybe<Scalars['String']['output']>;
  meta_device?: Maybe<Scalars['String']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  meta_net_amount?: Maybe<Scalars['Int']['output']>;
  meta_net_count?: Maybe<Scalars['Int']['output']>;
  meta_net_tip?: Maybe<Scalars['Int']['output']>;
  meta_net_total?: Maybe<Scalars['Int']['output']>;
  meta_opened?: Maybe<Scalars['timestamp']['output']>;
  meta_processor_name?: Maybe<Scalars['String']['output']>;
  meta_reference?: Maybe<Scalars['String']['output']>;
  meta_return_amount?: Maybe<Scalars['Int']['output']>;
  meta_return_count?: Maybe<Scalars['Int']['output']>;
  meta_sale_amount?: Maybe<Scalars['Int']['output']>;
  meta_sale_count?: Maybe<Scalars['Int']['output']>;
  meta_status?: Maybe<Scalars['String']['output']>;
  meta_tender_type?: Maybe<Scalars['String']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas_Mutation_Response = {
  __typename?: 'mx_merchant_payment_batch_metas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mx_Merchant_Payment_Batch_Metas>;
};

/** input type for inserting object relation for remote table "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas_Obj_Rel_Insert_Input = {
  data: Mx_Merchant_Payment_Batch_Metas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_On_Conflict>;
};

/** on_conflict condition type for table "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas_On_Conflict = {
  constraint: Mx_Merchant_Payment_Batch_Metas_Constraint;
  update_columns?: Array<Mx_Merchant_Payment_Batch_Metas_Update_Column>;
  where?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>;
};

/** Ordering options when selecting data from "mx_merchant_payment_batch_metas". */
export type Mx_Merchant_Payment_Batch_Metas_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_closed?: InputMaybe<Order_By>;
  meta_closer_name?: InputMaybe<Order_By>;
  meta_device?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_net_amount?: InputMaybe<Order_By>;
  meta_net_count?: InputMaybe<Order_By>;
  meta_net_tip?: InputMaybe<Order_By>;
  meta_net_total?: InputMaybe<Order_By>;
  meta_opened?: InputMaybe<Order_By>;
  meta_processor_name?: InputMaybe<Order_By>;
  meta_reference?: InputMaybe<Order_By>;
  meta_return_amount?: InputMaybe<Order_By>;
  meta_return_count?: InputMaybe<Order_By>;
  meta_sale_amount?: InputMaybe<Order_By>;
  meta_sale_count?: InputMaybe<Order_By>;
  meta_status?: InputMaybe<Order_By>;
  meta_tender_type?: InputMaybe<Order_By>;
  payment_batch?: InputMaybe<Payment_Batches_Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mx_merchant_payment_batch_metas */
export type Mx_Merchant_Payment_Batch_Metas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "mx_merchant_payment_batch_metas" */
export enum Mx_Merchant_Payment_Batch_Metas_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetaClosed = 'meta_closed',
  /** column name */
  MetaCloserName = 'meta_closer_name',
  /** column name */
  MetaDevice = 'meta_device',
  /** column name */
  MetaId = 'meta_id',
  /** column name */
  MetaNetAmount = 'meta_net_amount',
  /** column name */
  MetaNetCount = 'meta_net_count',
  /** column name */
  MetaNetTip = 'meta_net_tip',
  /** column name */
  MetaNetTotal = 'meta_net_total',
  /** column name */
  MetaOpened = 'meta_opened',
  /** column name */
  MetaProcessorName = 'meta_processor_name',
  /** column name */
  MetaReference = 'meta_reference',
  /** column name */
  MetaReturnAmount = 'meta_return_amount',
  /** column name */
  MetaReturnCount = 'meta_return_count',
  /** column name */
  MetaSaleAmount = 'meta_sale_amount',
  /** column name */
  MetaSaleCount = 'meta_sale_count',
  /** column name */
  MetaStatus = 'meta_status',
  /** column name */
  MetaTenderType = 'meta_tender_type',
  /** column name */
  PaymentBatchId = 'payment_batch_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_closed?: InputMaybe<Scalars['timestamp']['input']>;
  meta_closer_name?: InputMaybe<Scalars['String']['input']>;
  meta_device?: InputMaybe<Scalars['String']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_net_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_net_count?: InputMaybe<Scalars['Int']['input']>;
  meta_net_tip?: InputMaybe<Scalars['Int']['input']>;
  meta_net_total?: InputMaybe<Scalars['Int']['input']>;
  meta_opened?: InputMaybe<Scalars['timestamp']['input']>;
  meta_processor_name?: InputMaybe<Scalars['String']['input']>;
  meta_reference?: InputMaybe<Scalars['String']['input']>;
  meta_return_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_return_count?: InputMaybe<Scalars['Int']['input']>;
  meta_sale_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_sale_count?: InputMaybe<Scalars['Int']['input']>;
  meta_status?: InputMaybe<Scalars['String']['input']>;
  meta_tender_type?: InputMaybe<Scalars['String']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Mx_Merchant_Payment_Batch_Metas_Stddev_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_net_amount?: Maybe<Scalars['Float']['output']>;
  meta_net_count?: Maybe<Scalars['Float']['output']>;
  meta_net_tip?: Maybe<Scalars['Float']['output']>;
  meta_net_total?: Maybe<Scalars['Float']['output']>;
  meta_return_amount?: Maybe<Scalars['Float']['output']>;
  meta_return_count?: Maybe<Scalars['Float']['output']>;
  meta_sale_amount?: Maybe<Scalars['Float']['output']>;
  meta_sale_count?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mx_Merchant_Payment_Batch_Metas_Stddev_Pop_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_net_amount?: Maybe<Scalars['Float']['output']>;
  meta_net_count?: Maybe<Scalars['Float']['output']>;
  meta_net_tip?: Maybe<Scalars['Float']['output']>;
  meta_net_total?: Maybe<Scalars['Float']['output']>;
  meta_return_amount?: Maybe<Scalars['Float']['output']>;
  meta_return_count?: Maybe<Scalars['Float']['output']>;
  meta_sale_amount?: Maybe<Scalars['Float']['output']>;
  meta_sale_count?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mx_Merchant_Payment_Batch_Metas_Stddev_Samp_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_net_amount?: Maybe<Scalars['Float']['output']>;
  meta_net_count?: Maybe<Scalars['Float']['output']>;
  meta_net_tip?: Maybe<Scalars['Float']['output']>;
  meta_net_total?: Maybe<Scalars['Float']['output']>;
  meta_return_amount?: Maybe<Scalars['Float']['output']>;
  meta_return_count?: Maybe<Scalars['Float']['output']>;
  meta_sale_amount?: Maybe<Scalars['Float']['output']>;
  meta_sale_count?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mx_merchant_payment_batch_metas" */
export type Mx_Merchant_Payment_Batch_Metas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mx_Merchant_Payment_Batch_Metas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mx_Merchant_Payment_Batch_Metas_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_closed?: InputMaybe<Scalars['timestamp']['input']>;
  meta_closer_name?: InputMaybe<Scalars['String']['input']>;
  meta_device?: InputMaybe<Scalars['String']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_net_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_net_count?: InputMaybe<Scalars['Int']['input']>;
  meta_net_tip?: InputMaybe<Scalars['Int']['input']>;
  meta_net_total?: InputMaybe<Scalars['Int']['input']>;
  meta_opened?: InputMaybe<Scalars['timestamp']['input']>;
  meta_processor_name?: InputMaybe<Scalars['String']['input']>;
  meta_reference?: InputMaybe<Scalars['String']['input']>;
  meta_return_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_return_count?: InputMaybe<Scalars['Int']['input']>;
  meta_sale_amount?: InputMaybe<Scalars['Int']['input']>;
  meta_sale_count?: InputMaybe<Scalars['Int']['input']>;
  meta_status?: InputMaybe<Scalars['String']['input']>;
  meta_tender_type?: InputMaybe<Scalars['String']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Mx_Merchant_Payment_Batch_Metas_Sum_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  meta_net_amount?: Maybe<Scalars['Int']['output']>;
  meta_net_count?: Maybe<Scalars['Int']['output']>;
  meta_net_tip?: Maybe<Scalars['Int']['output']>;
  meta_net_total?: Maybe<Scalars['Int']['output']>;
  meta_return_amount?: Maybe<Scalars['Int']['output']>;
  meta_return_count?: Maybe<Scalars['Int']['output']>;
  meta_sale_amount?: Maybe<Scalars['Int']['output']>;
  meta_sale_count?: Maybe<Scalars['Int']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "mx_merchant_payment_batch_metas" */
export enum Mx_Merchant_Payment_Batch_Metas_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetaClosed = 'meta_closed',
  /** column name */
  MetaCloserName = 'meta_closer_name',
  /** column name */
  MetaDevice = 'meta_device',
  /** column name */
  MetaId = 'meta_id',
  /** column name */
  MetaNetAmount = 'meta_net_amount',
  /** column name */
  MetaNetCount = 'meta_net_count',
  /** column name */
  MetaNetTip = 'meta_net_tip',
  /** column name */
  MetaNetTotal = 'meta_net_total',
  /** column name */
  MetaOpened = 'meta_opened',
  /** column name */
  MetaProcessorName = 'meta_processor_name',
  /** column name */
  MetaReference = 'meta_reference',
  /** column name */
  MetaReturnAmount = 'meta_return_amount',
  /** column name */
  MetaReturnCount = 'meta_return_count',
  /** column name */
  MetaSaleAmount = 'meta_sale_amount',
  /** column name */
  MetaSaleCount = 'meta_sale_count',
  /** column name */
  MetaStatus = 'meta_status',
  /** column name */
  MetaTenderType = 'meta_tender_type',
  /** column name */
  PaymentBatchId = 'payment_batch_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Mx_Merchant_Payment_Batch_Metas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mx_Merchant_Payment_Batch_Metas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mx_Merchant_Payment_Batch_Metas_Var_Pop_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_net_amount?: Maybe<Scalars['Float']['output']>;
  meta_net_count?: Maybe<Scalars['Float']['output']>;
  meta_net_tip?: Maybe<Scalars['Float']['output']>;
  meta_net_total?: Maybe<Scalars['Float']['output']>;
  meta_return_amount?: Maybe<Scalars['Float']['output']>;
  meta_return_count?: Maybe<Scalars['Float']['output']>;
  meta_sale_amount?: Maybe<Scalars['Float']['output']>;
  meta_sale_count?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mx_Merchant_Payment_Batch_Metas_Var_Samp_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_net_amount?: Maybe<Scalars['Float']['output']>;
  meta_net_count?: Maybe<Scalars['Float']['output']>;
  meta_net_tip?: Maybe<Scalars['Float']['output']>;
  meta_net_total?: Maybe<Scalars['Float']['output']>;
  meta_return_amount?: Maybe<Scalars['Float']['output']>;
  meta_return_count?: Maybe<Scalars['Float']['output']>;
  meta_sale_amount?: Maybe<Scalars['Float']['output']>;
  meta_sale_count?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mx_Merchant_Payment_Batch_Metas_Variance_Fields = {
  __typename?: 'mx_merchant_payment_batch_metas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_net_amount?: Maybe<Scalars['Float']['output']>;
  meta_net_count?: Maybe<Scalars['Float']['output']>;
  meta_net_tip?: Maybe<Scalars['Float']['output']>;
  meta_net_total?: Maybe<Scalars['Float']['output']>;
  meta_return_amount?: Maybe<Scalars['Float']['output']>;
  meta_return_count?: Maybe<Scalars['Float']['output']>;
  meta_sale_amount?: Maybe<Scalars['Float']['output']>;
  meta_sale_count?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas = {
  __typename?: 'mx_merchant_payment_metas';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['bigint']['output'];
  meta_auth_code?: Maybe<Scalars['String']['output']>;
  meta_auth_message?: Maybe<Scalars['String']['output']>;
  meta_batch?: Maybe<Scalars['String']['output']>;
  meta_batch_id?: Maybe<Scalars['bigint']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  meta_original_id?: Maybe<Scalars['bigint']['output']>;
  meta_payment_token?: Maybe<Scalars['String']['output']>;
  meta_reference?: Maybe<Scalars['String']['output']>;
  meta_response_code?: Maybe<Scalars['Int']['output']>;
  meta_status?: Maybe<Scalars['String']['output']>;
  meta_tender_type?: Maybe<Scalars['String']['output']>;
  meta_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  payment: Payments;
  payment_id: Scalars['bigint']['output'];
  payment_resource?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Aggregate = {
  __typename?: 'mx_merchant_payment_metas_aggregate';
  aggregate?: Maybe<Mx_Merchant_Payment_Metas_Aggregate_Fields>;
  nodes: Array<Mx_Merchant_Payment_Metas>;
};

export type Mx_Merchant_Payment_Metas_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mx_Merchant_Payment_Metas_Aggregate_Bool_Exp_Count>;
};

export type Mx_Merchant_Payment_Metas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Aggregate_Fields = {
  __typename?: 'mx_merchant_payment_metas_aggregate_fields';
  avg?: Maybe<Mx_Merchant_Payment_Metas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mx_Merchant_Payment_Metas_Max_Fields>;
  min?: Maybe<Mx_Merchant_Payment_Metas_Min_Fields>;
  stddev?: Maybe<Mx_Merchant_Payment_Metas_Stddev_Fields>;
  stddev_pop?: Maybe<Mx_Merchant_Payment_Metas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mx_Merchant_Payment_Metas_Stddev_Samp_Fields>;
  sum?: Maybe<Mx_Merchant_Payment_Metas_Sum_Fields>;
  var_pop?: Maybe<Mx_Merchant_Payment_Metas_Var_Pop_Fields>;
  var_samp?: Maybe<Mx_Merchant_Payment_Metas_Var_Samp_Fields>;
  variance?: Maybe<Mx_Merchant_Payment_Metas_Variance_Fields>;
};


/** aggregate fields of "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Aggregate_Order_By = {
  avg?: InputMaybe<Mx_Merchant_Payment_Metas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mx_Merchant_Payment_Metas_Max_Order_By>;
  min?: InputMaybe<Mx_Merchant_Payment_Metas_Min_Order_By>;
  stddev?: InputMaybe<Mx_Merchant_Payment_Metas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mx_Merchant_Payment_Metas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mx_Merchant_Payment_Metas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mx_Merchant_Payment_Metas_Sum_Order_By>;
  var_pop?: InputMaybe<Mx_Merchant_Payment_Metas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mx_Merchant_Payment_Metas_Var_Samp_Order_By>;
  variance?: InputMaybe<Mx_Merchant_Payment_Metas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Arr_Rel_Insert_Input = {
  data: Array<Mx_Merchant_Payment_Metas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mx_Merchant_Payment_Metas_On_Conflict>;
};

/** aggregate avg on columns */
export type Mx_Merchant_Payment_Metas_Avg_Fields = {
  __typename?: 'mx_merchant_payment_metas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_batch_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_original_id?: Maybe<Scalars['Float']['output']>;
  meta_response_code?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mx_merchant_payment_metas". All fields are combined with a logical 'AND'. */
export type Mx_Merchant_Payment_Metas_Bool_Exp = {
  _and?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Bool_Exp>>;
  _not?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
  _or?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_auth_code?: InputMaybe<String_Comparison_Exp>;
  meta_auth_message?: InputMaybe<String_Comparison_Exp>;
  meta_batch?: InputMaybe<String_Comparison_Exp>;
  meta_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_original_id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_payment_token?: InputMaybe<String_Comparison_Exp>;
  meta_reference?: InputMaybe<String_Comparison_Exp>;
  meta_response_code?: InputMaybe<Int_Comparison_Exp>;
  meta_status?: InputMaybe<String_Comparison_Exp>;
  meta_tender_type?: InputMaybe<String_Comparison_Exp>;
  meta_type?: InputMaybe<String_Comparison_Exp>;
  payment?: InputMaybe<Payments_Bool_Exp>;
  payment_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_resource?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "mx_merchant_payment_metas" */
export enum Mx_Merchant_Payment_Metas_Constraint {
  /** unique or primary key constraint on columns "id" */
  MxMerchantPaymentMetasPkey = 'mx_merchant_payment_metas_pkey'
}

/** input type for incrementing numeric columns in table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_original_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_response_code?: InputMaybe<Scalars['Int']['input']>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_auth_code?: InputMaybe<Scalars['String']['input']>;
  meta_auth_message?: InputMaybe<Scalars['String']['input']>;
  meta_batch?: InputMaybe<Scalars['String']['input']>;
  meta_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_original_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_payment_token?: InputMaybe<Scalars['String']['input']>;
  meta_reference?: InputMaybe<Scalars['String']['input']>;
  meta_response_code?: InputMaybe<Scalars['Int']['input']>;
  meta_status?: InputMaybe<Scalars['String']['input']>;
  meta_tender_type?: InputMaybe<Scalars['String']['input']>;
  meta_type?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Payments_Obj_Rel_Insert_Input>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_resource?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Mx_Merchant_Payment_Metas_Max_Fields = {
  __typename?: 'mx_merchant_payment_metas_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  meta_auth_code?: Maybe<Scalars['String']['output']>;
  meta_auth_message?: Maybe<Scalars['String']['output']>;
  meta_batch?: Maybe<Scalars['String']['output']>;
  meta_batch_id?: Maybe<Scalars['bigint']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  meta_original_id?: Maybe<Scalars['bigint']['output']>;
  meta_payment_token?: Maybe<Scalars['String']['output']>;
  meta_reference?: Maybe<Scalars['String']['output']>;
  meta_response_code?: Maybe<Scalars['Int']['output']>;
  meta_status?: Maybe<Scalars['String']['output']>;
  meta_tender_type?: Maybe<Scalars['String']['output']>;
  meta_type?: Maybe<Scalars['String']['output']>;
  payment_id?: Maybe<Scalars['bigint']['output']>;
  payment_resource?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_auth_code?: InputMaybe<Order_By>;
  meta_auth_message?: InputMaybe<Order_By>;
  meta_batch?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_payment_token?: InputMaybe<Order_By>;
  meta_reference?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  meta_status?: InputMaybe<Order_By>;
  meta_tender_type?: InputMaybe<Order_By>;
  meta_type?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  payment_resource?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mx_Merchant_Payment_Metas_Min_Fields = {
  __typename?: 'mx_merchant_payment_metas_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  meta_auth_code?: Maybe<Scalars['String']['output']>;
  meta_auth_message?: Maybe<Scalars['String']['output']>;
  meta_batch?: Maybe<Scalars['String']['output']>;
  meta_batch_id?: Maybe<Scalars['bigint']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  meta_original_id?: Maybe<Scalars['bigint']['output']>;
  meta_payment_token?: Maybe<Scalars['String']['output']>;
  meta_reference?: Maybe<Scalars['String']['output']>;
  meta_response_code?: Maybe<Scalars['Int']['output']>;
  meta_status?: Maybe<Scalars['String']['output']>;
  meta_tender_type?: Maybe<Scalars['String']['output']>;
  meta_type?: Maybe<Scalars['String']['output']>;
  payment_id?: Maybe<Scalars['bigint']['output']>;
  payment_resource?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_auth_code?: InputMaybe<Order_By>;
  meta_auth_message?: InputMaybe<Order_By>;
  meta_batch?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_payment_token?: InputMaybe<Order_By>;
  meta_reference?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  meta_status?: InputMaybe<Order_By>;
  meta_tender_type?: InputMaybe<Order_By>;
  meta_type?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  payment_resource?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Mutation_Response = {
  __typename?: 'mx_merchant_payment_metas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mx_Merchant_Payment_Metas>;
};

/** on_conflict condition type for table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_On_Conflict = {
  constraint: Mx_Merchant_Payment_Metas_Constraint;
  update_columns?: Array<Mx_Merchant_Payment_Metas_Update_Column>;
  where?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
};

/** Ordering options when selecting data from "mx_merchant_payment_metas". */
export type Mx_Merchant_Payment_Metas_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_auth_code?: InputMaybe<Order_By>;
  meta_auth_message?: InputMaybe<Order_By>;
  meta_batch?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_payment_token?: InputMaybe<Order_By>;
  meta_reference?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  meta_status?: InputMaybe<Order_By>;
  meta_tender_type?: InputMaybe<Order_By>;
  meta_type?: InputMaybe<Order_By>;
  payment?: InputMaybe<Payments_Order_By>;
  payment_id?: InputMaybe<Order_By>;
  payment_resource?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mx_merchant_payment_metas */
export type Mx_Merchant_Payment_Metas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "mx_merchant_payment_metas" */
export enum Mx_Merchant_Payment_Metas_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetaAuthCode = 'meta_auth_code',
  /** column name */
  MetaAuthMessage = 'meta_auth_message',
  /** column name */
  MetaBatch = 'meta_batch',
  /** column name */
  MetaBatchId = 'meta_batch_id',
  /** column name */
  MetaId = 'meta_id',
  /** column name */
  MetaOriginalId = 'meta_original_id',
  /** column name */
  MetaPaymentToken = 'meta_payment_token',
  /** column name */
  MetaReference = 'meta_reference',
  /** column name */
  MetaResponseCode = 'meta_response_code',
  /** column name */
  MetaStatus = 'meta_status',
  /** column name */
  MetaTenderType = 'meta_tender_type',
  /** column name */
  MetaType = 'meta_type',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PaymentResource = 'payment_resource',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_auth_code?: InputMaybe<Scalars['String']['input']>;
  meta_auth_message?: InputMaybe<Scalars['String']['input']>;
  meta_batch?: InputMaybe<Scalars['String']['input']>;
  meta_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_original_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_payment_token?: InputMaybe<Scalars['String']['input']>;
  meta_reference?: InputMaybe<Scalars['String']['input']>;
  meta_response_code?: InputMaybe<Scalars['Int']['input']>;
  meta_status?: InputMaybe<Scalars['String']['input']>;
  meta_tender_type?: InputMaybe<Scalars['String']['input']>;
  meta_type?: InputMaybe<Scalars['String']['input']>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_resource?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Mx_Merchant_Payment_Metas_Stddev_Fields = {
  __typename?: 'mx_merchant_payment_metas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_batch_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_original_id?: Maybe<Scalars['Float']['output']>;
  meta_response_code?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mx_Merchant_Payment_Metas_Stddev_Pop_Fields = {
  __typename?: 'mx_merchant_payment_metas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_batch_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_original_id?: Maybe<Scalars['Float']['output']>;
  meta_response_code?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mx_Merchant_Payment_Metas_Stddev_Samp_Fields = {
  __typename?: 'mx_merchant_payment_metas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_batch_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_original_id?: Maybe<Scalars['Float']['output']>;
  meta_response_code?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mx_Merchant_Payment_Metas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mx_Merchant_Payment_Metas_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_auth_code?: InputMaybe<Scalars['String']['input']>;
  meta_auth_message?: InputMaybe<Scalars['String']['input']>;
  meta_batch?: InputMaybe<Scalars['String']['input']>;
  meta_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_original_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_payment_token?: InputMaybe<Scalars['String']['input']>;
  meta_reference?: InputMaybe<Scalars['String']['input']>;
  meta_response_code?: InputMaybe<Scalars['Int']['input']>;
  meta_status?: InputMaybe<Scalars['String']['input']>;
  meta_tender_type?: InputMaybe<Scalars['String']['input']>;
  meta_type?: InputMaybe<Scalars['String']['input']>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_resource?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Mx_Merchant_Payment_Metas_Sum_Fields = {
  __typename?: 'mx_merchant_payment_metas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  meta_batch_id?: Maybe<Scalars['bigint']['output']>;
  meta_id?: Maybe<Scalars['bigint']['output']>;
  meta_original_id?: Maybe<Scalars['bigint']['output']>;
  meta_response_code?: Maybe<Scalars['Int']['output']>;
  payment_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** update columns of table "mx_merchant_payment_metas" */
export enum Mx_Merchant_Payment_Metas_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetaAuthCode = 'meta_auth_code',
  /** column name */
  MetaAuthMessage = 'meta_auth_message',
  /** column name */
  MetaBatch = 'meta_batch',
  /** column name */
  MetaBatchId = 'meta_batch_id',
  /** column name */
  MetaId = 'meta_id',
  /** column name */
  MetaOriginalId = 'meta_original_id',
  /** column name */
  MetaPaymentToken = 'meta_payment_token',
  /** column name */
  MetaReference = 'meta_reference',
  /** column name */
  MetaResponseCode = 'meta_response_code',
  /** column name */
  MetaStatus = 'meta_status',
  /** column name */
  MetaTenderType = 'meta_tender_type',
  /** column name */
  MetaType = 'meta_type',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PaymentResource = 'payment_resource',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Mx_Merchant_Payment_Metas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mx_Merchant_Payment_Metas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mx_Merchant_Payment_Metas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mx_Merchant_Payment_Metas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mx_Merchant_Payment_Metas_Var_Pop_Fields = {
  __typename?: 'mx_merchant_payment_metas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_batch_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_original_id?: Maybe<Scalars['Float']['output']>;
  meta_response_code?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mx_Merchant_Payment_Metas_Var_Samp_Fields = {
  __typename?: 'mx_merchant_payment_metas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_batch_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_original_id?: Maybe<Scalars['Float']['output']>;
  meta_response_code?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mx_Merchant_Payment_Metas_Variance_Fields = {
  __typename?: 'mx_merchant_payment_metas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_batch_id?: Maybe<Scalars['Float']['output']>;
  meta_id?: Maybe<Scalars['Float']['output']>;
  meta_original_id?: Maybe<Scalars['Float']['output']>;
  meta_response_code?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mx_merchant_payment_metas" */
export type Mx_Merchant_Payment_Metas_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_batch_id?: InputMaybe<Order_By>;
  meta_id?: InputMaybe<Order_By>;
  meta_original_id?: InputMaybe<Order_By>;
  meta_response_code?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas = {
  __typename?: 'mx_merchant_payment_method_metas';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['bigint']['output'];
  meta_card_account_card_id?: Maybe<Scalars['String']['output']>;
  meta_card_account_card_type: Scalars['String']['output'];
  meta_card_account_expiry_month: Scalars['String']['output'];
  meta_card_account_expiry_year: Scalars['String']['output'];
  meta_card_account_id?: Maybe<Scalars['bigint']['output']>;
  meta_card_account_last_4: Scalars['String']['output'];
  meta_card_account_postal_code?: Maybe<Scalars['String']['output']>;
  meta_card_account_token: Scalars['String']['output'];
  /** An object relationship */
  payment_method: Payment_Methods;
  payment_method_id: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Aggregate = {
  __typename?: 'mx_merchant_payment_method_metas_aggregate';
  aggregate?: Maybe<Mx_Merchant_Payment_Method_Metas_Aggregate_Fields>;
  nodes: Array<Mx_Merchant_Payment_Method_Metas>;
};

export type Mx_Merchant_Payment_Method_Metas_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Aggregate_Bool_Exp_Count>;
};

export type Mx_Merchant_Payment_Method_Metas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Aggregate_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_aggregate_fields';
  avg?: Maybe<Mx_Merchant_Payment_Method_Metas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mx_Merchant_Payment_Method_Metas_Max_Fields>;
  min?: Maybe<Mx_Merchant_Payment_Method_Metas_Min_Fields>;
  stddev?: Maybe<Mx_Merchant_Payment_Method_Metas_Stddev_Fields>;
  stddev_pop?: Maybe<Mx_Merchant_Payment_Method_Metas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mx_Merchant_Payment_Method_Metas_Stddev_Samp_Fields>;
  sum?: Maybe<Mx_Merchant_Payment_Method_Metas_Sum_Fields>;
  var_pop?: Maybe<Mx_Merchant_Payment_Method_Metas_Var_Pop_Fields>;
  var_samp?: Maybe<Mx_Merchant_Payment_Method_Metas_Var_Samp_Fields>;
  variance?: Maybe<Mx_Merchant_Payment_Method_Metas_Variance_Fields>;
};


/** aggregate fields of "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Aggregate_Order_By = {
  avg?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Max_Order_By>;
  min?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Min_Order_By>;
  stddev?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Sum_Order_By>;
  var_pop?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Var_Samp_Order_By>;
  variance?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Arr_Rel_Insert_Input = {
  data: Array<Mx_Merchant_Payment_Method_Metas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mx_Merchant_Payment_Method_Metas_On_Conflict>;
};

/** aggregate avg on columns */
export type Mx_Merchant_Payment_Method_Metas_Avg_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_card_account_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mx_merchant_payment_method_metas". All fields are combined with a logical 'AND'. */
export type Mx_Merchant_Payment_Method_Metas_Bool_Exp = {
  _and?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Bool_Exp>>;
  _not?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
  _or?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_card_account_card_id?: InputMaybe<String_Comparison_Exp>;
  meta_card_account_card_type?: InputMaybe<String_Comparison_Exp>;
  meta_card_account_expiry_month?: InputMaybe<String_Comparison_Exp>;
  meta_card_account_expiry_year?: InputMaybe<String_Comparison_Exp>;
  meta_card_account_id?: InputMaybe<Bigint_Comparison_Exp>;
  meta_card_account_last_4?: InputMaybe<String_Comparison_Exp>;
  meta_card_account_postal_code?: InputMaybe<String_Comparison_Exp>;
  meta_card_account_token?: InputMaybe<String_Comparison_Exp>;
  payment_method?: InputMaybe<Payment_Methods_Bool_Exp>;
  payment_method_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "mx_merchant_payment_method_metas" */
export enum Mx_Merchant_Payment_Method_Metas_Constraint {
  /** unique or primary key constraint on columns "payment_method_id" */
  MxMerchantPaymentMethodMetasPaymentMethodIdUnique = 'mx_merchant_payment_method_metas_payment_method_id_unique',
  /** unique or primary key constraint on columns "id" */
  MxMerchantPaymentMethodMetasPkey = 'mx_merchant_payment_method_metas_pkey',
  /** unique or primary key constraint on columns "payment_method_id", "meta_card_account_token" */
  MxmPmmPaymentMethodIdMetaCardAccountToken = 'mxm_pmm_payment_method_id_meta_card_account_token'
}

/** input type for incrementing numeric columns in table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_card_account_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_card_account_card_id?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_card_type?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_expiry_month?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_expiry_year?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_card_account_last_4?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_postal_code?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_token?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Payment_Methods_Obj_Rel_Insert_Input>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Mx_Merchant_Payment_Method_Metas_Max_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  meta_card_account_card_id?: Maybe<Scalars['String']['output']>;
  meta_card_account_card_type?: Maybe<Scalars['String']['output']>;
  meta_card_account_expiry_month?: Maybe<Scalars['String']['output']>;
  meta_card_account_expiry_year?: Maybe<Scalars['String']['output']>;
  meta_card_account_id?: Maybe<Scalars['bigint']['output']>;
  meta_card_account_last_4?: Maybe<Scalars['String']['output']>;
  meta_card_account_postal_code?: Maybe<Scalars['String']['output']>;
  meta_card_account_token?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_card_account_card_id?: InputMaybe<Order_By>;
  meta_card_account_card_type?: InputMaybe<Order_By>;
  meta_card_account_expiry_month?: InputMaybe<Order_By>;
  meta_card_account_expiry_year?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  meta_card_account_last_4?: InputMaybe<Order_By>;
  meta_card_account_postal_code?: InputMaybe<Order_By>;
  meta_card_account_token?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mx_Merchant_Payment_Method_Metas_Min_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  meta_card_account_card_id?: Maybe<Scalars['String']['output']>;
  meta_card_account_card_type?: Maybe<Scalars['String']['output']>;
  meta_card_account_expiry_month?: Maybe<Scalars['String']['output']>;
  meta_card_account_expiry_year?: Maybe<Scalars['String']['output']>;
  meta_card_account_id?: Maybe<Scalars['bigint']['output']>;
  meta_card_account_last_4?: Maybe<Scalars['String']['output']>;
  meta_card_account_postal_code?: Maybe<Scalars['String']['output']>;
  meta_card_account_token?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_card_account_card_id?: InputMaybe<Order_By>;
  meta_card_account_card_type?: InputMaybe<Order_By>;
  meta_card_account_expiry_month?: InputMaybe<Order_By>;
  meta_card_account_expiry_year?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  meta_card_account_last_4?: InputMaybe<Order_By>;
  meta_card_account_postal_code?: InputMaybe<Order_By>;
  meta_card_account_token?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Mutation_Response = {
  __typename?: 'mx_merchant_payment_method_metas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mx_Merchant_Payment_Method_Metas>;
};

/** input type for inserting object relation for remote table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Obj_Rel_Insert_Input = {
  data: Mx_Merchant_Payment_Method_Metas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mx_Merchant_Payment_Method_Metas_On_Conflict>;
};

/** on_conflict condition type for table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_On_Conflict = {
  constraint: Mx_Merchant_Payment_Method_Metas_Constraint;
  update_columns?: Array<Mx_Merchant_Payment_Method_Metas_Update_Column>;
  where?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
};

/** Ordering options when selecting data from "mx_merchant_payment_method_metas". */
export type Mx_Merchant_Payment_Method_Metas_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta_card_account_card_id?: InputMaybe<Order_By>;
  meta_card_account_card_type?: InputMaybe<Order_By>;
  meta_card_account_expiry_month?: InputMaybe<Order_By>;
  meta_card_account_expiry_year?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  meta_card_account_last_4?: InputMaybe<Order_By>;
  meta_card_account_postal_code?: InputMaybe<Order_By>;
  meta_card_account_token?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Payment_Methods_Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mx_merchant_payment_method_metas */
export type Mx_Merchant_Payment_Method_Metas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "mx_merchant_payment_method_metas" */
export enum Mx_Merchant_Payment_Method_Metas_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetaCardAccountCardId = 'meta_card_account_card_id',
  /** column name */
  MetaCardAccountCardType = 'meta_card_account_card_type',
  /** column name */
  MetaCardAccountExpiryMonth = 'meta_card_account_expiry_month',
  /** column name */
  MetaCardAccountExpiryYear = 'meta_card_account_expiry_year',
  /** column name */
  MetaCardAccountId = 'meta_card_account_id',
  /** column name */
  MetaCardAccountLast_4 = 'meta_card_account_last_4',
  /** column name */
  MetaCardAccountPostalCode = 'meta_card_account_postal_code',
  /** column name */
  MetaCardAccountToken = 'meta_card_account_token',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_card_account_card_id?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_card_type?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_expiry_month?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_expiry_year?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_card_account_last_4?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_postal_code?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_token?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Mx_Merchant_Payment_Method_Metas_Stddev_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_card_account_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mx_Merchant_Payment_Method_Metas_Stddev_Pop_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_card_account_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mx_Merchant_Payment_Method_Metas_Stddev_Samp_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_card_account_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mx_Merchant_Payment_Method_Metas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mx_Merchant_Payment_Method_Metas_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  meta_card_account_card_id?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_card_type?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_expiry_month?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_expiry_year?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_id?: InputMaybe<Scalars['bigint']['input']>;
  meta_card_account_last_4?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_postal_code?: InputMaybe<Scalars['String']['input']>;
  meta_card_account_token?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Mx_Merchant_Payment_Method_Metas_Sum_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  meta_card_account_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
};

/** update columns of table "mx_merchant_payment_method_metas" */
export enum Mx_Merchant_Payment_Method_Metas_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MetaCardAccountCardId = 'meta_card_account_card_id',
  /** column name */
  MetaCardAccountCardType = 'meta_card_account_card_type',
  /** column name */
  MetaCardAccountExpiryMonth = 'meta_card_account_expiry_month',
  /** column name */
  MetaCardAccountExpiryYear = 'meta_card_account_expiry_year',
  /** column name */
  MetaCardAccountId = 'meta_card_account_id',
  /** column name */
  MetaCardAccountLast_4 = 'meta_card_account_last_4',
  /** column name */
  MetaCardAccountPostalCode = 'meta_card_account_postal_code',
  /** column name */
  MetaCardAccountToken = 'meta_card_account_token',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Mx_Merchant_Payment_Method_Metas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mx_Merchant_Payment_Method_Metas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mx_Merchant_Payment_Method_Metas_Var_Pop_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_card_account_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mx_Merchant_Payment_Method_Metas_Var_Samp_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_card_account_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mx_Merchant_Payment_Method_Metas_Variance_Fields = {
  __typename?: 'mx_merchant_payment_method_metas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meta_card_account_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mx_merchant_payment_method_metas" */
export type Mx_Merchant_Payment_Method_Metas_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  meta_card_account_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule = {
  __typename?: 'parkable_group_parkable_schedule';
  /** An object relationship */
  parkable_group: Parkable_Groups;
  parkable_group_id: Scalars['bigint']['output'];
  /** An object relationship */
  parkable_schedule: Parkable_Schedules;
  parkable_schedule_id: Scalars['bigint']['output'];
};

/** aggregated selection of "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Aggregate = {
  __typename?: 'parkable_group_parkable_schedule_aggregate';
  aggregate?: Maybe<Parkable_Group_Parkable_Schedule_Aggregate_Fields>;
  nodes: Array<Parkable_Group_Parkable_Schedule>;
};

export type Parkable_Group_Parkable_Schedule_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parkable_Group_Parkable_Schedule_Aggregate_Bool_Exp_Count>;
};

export type Parkable_Group_Parkable_Schedule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Aggregate_Fields = {
  __typename?: 'parkable_group_parkable_schedule_aggregate_fields';
  avg?: Maybe<Parkable_Group_Parkable_Schedule_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parkable_Group_Parkable_Schedule_Max_Fields>;
  min?: Maybe<Parkable_Group_Parkable_Schedule_Min_Fields>;
  stddev?: Maybe<Parkable_Group_Parkable_Schedule_Stddev_Fields>;
  stddev_pop?: Maybe<Parkable_Group_Parkable_Schedule_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parkable_Group_Parkable_Schedule_Stddev_Samp_Fields>;
  sum?: Maybe<Parkable_Group_Parkable_Schedule_Sum_Fields>;
  var_pop?: Maybe<Parkable_Group_Parkable_Schedule_Var_Pop_Fields>;
  var_samp?: Maybe<Parkable_Group_Parkable_Schedule_Var_Samp_Fields>;
  variance?: Maybe<Parkable_Group_Parkable_Schedule_Variance_Fields>;
};


/** aggregate fields of "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Aggregate_Order_By = {
  avg?: InputMaybe<Parkable_Group_Parkable_Schedule_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parkable_Group_Parkable_Schedule_Max_Order_By>;
  min?: InputMaybe<Parkable_Group_Parkable_Schedule_Min_Order_By>;
  stddev?: InputMaybe<Parkable_Group_Parkable_Schedule_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parkable_Group_Parkable_Schedule_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parkable_Group_Parkable_Schedule_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parkable_Group_Parkable_Schedule_Sum_Order_By>;
  var_pop?: InputMaybe<Parkable_Group_Parkable_Schedule_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parkable_Group_Parkable_Schedule_Var_Samp_Order_By>;
  variance?: InputMaybe<Parkable_Group_Parkable_Schedule_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Arr_Rel_Insert_Input = {
  data: Array<Parkable_Group_Parkable_Schedule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Group_Parkable_Schedule_On_Conflict>;
};

/** aggregate avg on columns */
export type Parkable_Group_Parkable_Schedule_Avg_Fields = {
  __typename?: 'parkable_group_parkable_schedule_avg_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Avg_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parkable_group_parkable_schedule". All fields are combined with a logical 'AND'. */
export type Parkable_Group_Parkable_Schedule_Bool_Exp = {
  _and?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Bool_Exp>>;
  _not?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
  _or?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Bool_Exp>>;
  parkable_group?: InputMaybe<Parkable_Groups_Bool_Exp>;
  parkable_group_id?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_schedule?: InputMaybe<Parkable_Schedules_Bool_Exp>;
  parkable_schedule_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "parkable_group_parkable_schedule" */
export enum Parkable_Group_Parkable_Schedule_Constraint {
  /** unique or primary key constraint on columns "parkable_schedule_id", "parkable_group_id" */
  ParkableGroupParkableSchedulePkey = 'parkable_group_parkable_schedule_pkey'
}

/** input type for incrementing numeric columns in table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Inc_Input = {
  parkable_group_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_schedule_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Insert_Input = {
  parkable_group?: InputMaybe<Parkable_Groups_Obj_Rel_Insert_Input>;
  parkable_group_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_schedule?: InputMaybe<Parkable_Schedules_Obj_Rel_Insert_Input>;
  parkable_schedule_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Parkable_Group_Parkable_Schedule_Max_Fields = {
  __typename?: 'parkable_group_parkable_schedule_max_fields';
  parkable_group_id?: Maybe<Scalars['bigint']['output']>;
  parkable_schedule_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Max_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parkable_Group_Parkable_Schedule_Min_Fields = {
  __typename?: 'parkable_group_parkable_schedule_min_fields';
  parkable_group_id?: Maybe<Scalars['bigint']['output']>;
  parkable_schedule_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Min_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Mutation_Response = {
  __typename?: 'parkable_group_parkable_schedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parkable_Group_Parkable_Schedule>;
};

/** on_conflict condition type for table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_On_Conflict = {
  constraint: Parkable_Group_Parkable_Schedule_Constraint;
  update_columns?: Array<Parkable_Group_Parkable_Schedule_Update_Column>;
  where?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
};

/** Ordering options when selecting data from "parkable_group_parkable_schedule". */
export type Parkable_Group_Parkable_Schedule_Order_By = {
  parkable_group?: InputMaybe<Parkable_Groups_Order_By>;
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule?: InputMaybe<Parkable_Schedules_Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parkable_group_parkable_schedule */
export type Parkable_Group_Parkable_Schedule_Pk_Columns_Input = {
  parkable_group_id: Scalars['bigint']['input'];
  parkable_schedule_id: Scalars['bigint']['input'];
};

/** select columns of table "parkable_group_parkable_schedule" */
export enum Parkable_Group_Parkable_Schedule_Select_Column {
  /** column name */
  ParkableGroupId = 'parkable_group_id',
  /** column name */
  ParkableScheduleId = 'parkable_schedule_id'
}

/** input type for updating data in table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Set_Input = {
  parkable_group_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_schedule_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Parkable_Group_Parkable_Schedule_Stddev_Fields = {
  __typename?: 'parkable_group_parkable_schedule_stddev_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Stddev_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parkable_Group_Parkable_Schedule_Stddev_Pop_Fields = {
  __typename?: 'parkable_group_parkable_schedule_stddev_pop_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Stddev_Pop_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parkable_Group_Parkable_Schedule_Stddev_Samp_Fields = {
  __typename?: 'parkable_group_parkable_schedule_stddev_samp_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Stddev_Samp_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parkable_Group_Parkable_Schedule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parkable_Group_Parkable_Schedule_Stream_Cursor_Value_Input = {
  parkable_group_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_schedule_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Parkable_Group_Parkable_Schedule_Sum_Fields = {
  __typename?: 'parkable_group_parkable_schedule_sum_fields';
  parkable_group_id?: Maybe<Scalars['bigint']['output']>;
  parkable_schedule_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Sum_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** update columns of table "parkable_group_parkable_schedule" */
export enum Parkable_Group_Parkable_Schedule_Update_Column {
  /** column name */
  ParkableGroupId = 'parkable_group_id',
  /** column name */
  ParkableScheduleId = 'parkable_schedule_id'
}

export type Parkable_Group_Parkable_Schedule_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parkable_Group_Parkable_Schedule_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parkable_Group_Parkable_Schedule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parkable_Group_Parkable_Schedule_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parkable_Group_Parkable_Schedule_Var_Pop_Fields = {
  __typename?: 'parkable_group_parkable_schedule_var_pop_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Var_Pop_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parkable_Group_Parkable_Schedule_Var_Samp_Fields = {
  __typename?: 'parkable_group_parkable_schedule_var_samp_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Var_Samp_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parkable_Group_Parkable_Schedule_Variance_Fields = {
  __typename?: 'parkable_group_parkable_schedule_variance_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parkable_group_parkable_schedule" */
export type Parkable_Group_Parkable_Schedule_Variance_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_schedule_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "parkable_groups" */
export type Parkable_Groups = {
  __typename?: 'parkable_groups';
  created_at: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  parkable_group_parkable_schedules: Array<Parkable_Group_Parkable_Schedule>;
  /** An aggregate relationship */
  parkable_group_parkable_schedules_aggregate: Parkable_Group_Parkable_Schedule_Aggregate;
  /** An array relationship */
  parkable_parkable_groups: Array<Parkable_Parkable_Group>;
  /** An aggregate relationship */
  parkable_parkable_groups_aggregate: Parkable_Parkable_Group_Aggregate;
  /** An object relationship */
  parking_authority: Parking_Authorities;
  parking_authority_id: Scalars['bigint']['output'];
  priority: Scalars['smallint']['output'];
  public: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "parkable_groups" */
export type Parkable_GroupsParkable_Group_Parkable_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Order_By>>;
  where?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
};


/** columns and relationships of "parkable_groups" */
export type Parkable_GroupsParkable_Group_Parkable_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Order_By>>;
  where?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
};


/** columns and relationships of "parkable_groups" */
export type Parkable_GroupsParkable_Parkable_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Parkable_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Parkable_Group_Order_By>>;
  where?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
};


/** columns and relationships of "parkable_groups" */
export type Parkable_GroupsParkable_Parkable_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Parkable_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Parkable_Group_Order_By>>;
  where?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
};

/** aggregated selection of "parkable_groups" */
export type Parkable_Groups_Aggregate = {
  __typename?: 'parkable_groups_aggregate';
  aggregate?: Maybe<Parkable_Groups_Aggregate_Fields>;
  nodes: Array<Parkable_Groups>;
};

export type Parkable_Groups_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Parkable_Groups_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Parkable_Groups_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Parkable_Groups_Aggregate_Bool_Exp_Count>;
};

export type Parkable_Groups_Aggregate_Bool_Exp_Bool_And = {
  arguments: Parkable_Groups_Select_Column_Parkable_Groups_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Groups_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parkable_Groups_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Parkable_Groups_Select_Column_Parkable_Groups_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Groups_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parkable_Groups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parkable_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Groups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parkable_groups" */
export type Parkable_Groups_Aggregate_Fields = {
  __typename?: 'parkable_groups_aggregate_fields';
  avg?: Maybe<Parkable_Groups_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parkable_Groups_Max_Fields>;
  min?: Maybe<Parkable_Groups_Min_Fields>;
  stddev?: Maybe<Parkable_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Parkable_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parkable_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Parkable_Groups_Sum_Fields>;
  var_pop?: Maybe<Parkable_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Parkable_Groups_Var_Samp_Fields>;
  variance?: Maybe<Parkable_Groups_Variance_Fields>;
};


/** aggregate fields of "parkable_groups" */
export type Parkable_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parkable_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parkable_groups" */
export type Parkable_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Parkable_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parkable_Groups_Max_Order_By>;
  min?: InputMaybe<Parkable_Groups_Min_Order_By>;
  stddev?: InputMaybe<Parkable_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parkable_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parkable_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parkable_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Parkable_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parkable_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Parkable_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parkable_groups" */
export type Parkable_Groups_Arr_Rel_Insert_Input = {
  data: Array<Parkable_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Parkable_Groups_Avg_Fields = {
  __typename?: 'parkable_groups_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parkable_groups" */
export type Parkable_Groups_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parkable_groups". All fields are combined with a logical 'AND'. */
export type Parkable_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Parkable_Groups_Bool_Exp>>;
  _not?: InputMaybe<Parkable_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Parkable_Groups_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parkable_group_parkable_schedules?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
  parkable_group_parkable_schedules_aggregate?: InputMaybe<Parkable_Group_Parkable_Schedule_Aggregate_Bool_Exp>;
  parkable_parkable_groups?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
  parkable_parkable_groups_aggregate?: InputMaybe<Parkable_Parkable_Group_Aggregate_Bool_Exp>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  priority?: InputMaybe<Smallint_Comparison_Exp>;
  public?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "parkable_groups" */
export enum Parkable_Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParkableGroupsPkey = 'parkable_groups_pkey'
}

/** input type for incrementing numeric columns in table "parkable_groups" */
export type Parkable_Groups_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  priority?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "parkable_groups" */
export type Parkable_Groups_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parkable_group_parkable_schedules?: InputMaybe<Parkable_Group_Parkable_Schedule_Arr_Rel_Insert_Input>;
  parkable_parkable_groups?: InputMaybe<Parkable_Parkable_Group_Arr_Rel_Insert_Input>;
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  priority?: InputMaybe<Scalars['smallint']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Parkable_Groups_Max_Fields = {
  __typename?: 'parkable_groups_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  priority?: Maybe<Scalars['smallint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "parkable_groups" */
export type Parkable_Groups_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parkable_Groups_Min_Fields = {
  __typename?: 'parkable_groups_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  priority?: Maybe<Scalars['smallint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "parkable_groups" */
export type Parkable_Groups_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parkable_groups" */
export type Parkable_Groups_Mutation_Response = {
  __typename?: 'parkable_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parkable_Groups>;
};

/** input type for inserting object relation for remote table "parkable_groups" */
export type Parkable_Groups_Obj_Rel_Insert_Input = {
  data: Parkable_Groups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Groups_On_Conflict>;
};

/** on_conflict condition type for table "parkable_groups" */
export type Parkable_Groups_On_Conflict = {
  constraint: Parkable_Groups_Constraint;
  update_columns?: Array<Parkable_Groups_Update_Column>;
  where?: InputMaybe<Parkable_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "parkable_groups". */
export type Parkable_Groups_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parkable_group_parkable_schedules_aggregate?: InputMaybe<Parkable_Group_Parkable_Schedule_Aggregate_Order_By>;
  parkable_parkable_groups_aggregate?: InputMaybe<Parkable_Parkable_Group_Aggregate_Order_By>;
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  public?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parkable_groups */
export type Parkable_Groups_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "parkable_groups" */
export enum Parkable_Groups_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  Public = 'public',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "parkable_groups_aggregate_bool_exp_bool_and_arguments_columns" columns of table "parkable_groups" */
export enum Parkable_Groups_Select_Column_Parkable_Groups_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Public = 'public'
}

/** select "parkable_groups_aggregate_bool_exp_bool_or_arguments_columns" columns of table "parkable_groups" */
export enum Parkable_Groups_Select_Column_Parkable_Groups_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Public = 'public'
}

/** input type for updating data in table "parkable_groups" */
export type Parkable_Groups_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  priority?: InputMaybe<Scalars['smallint']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Parkable_Groups_Stddev_Fields = {
  __typename?: 'parkable_groups_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parkable_groups" */
export type Parkable_Groups_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parkable_Groups_Stddev_Pop_Fields = {
  __typename?: 'parkable_groups_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parkable_groups" */
export type Parkable_Groups_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parkable_Groups_Stddev_Samp_Fields = {
  __typename?: 'parkable_groups_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parkable_groups" */
export type Parkable_Groups_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parkable_groups" */
export type Parkable_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parkable_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parkable_Groups_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  priority?: InputMaybe<Scalars['smallint']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Parkable_Groups_Sum_Fields = {
  __typename?: 'parkable_groups_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  priority?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "parkable_groups" */
export type Parkable_Groups_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** update columns of table "parkable_groups" */
export enum Parkable_Groups_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  Public = 'public',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Parkable_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parkable_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parkable_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parkable_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parkable_Groups_Var_Pop_Fields = {
  __typename?: 'parkable_groups_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parkable_groups" */
export type Parkable_Groups_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parkable_Groups_Var_Samp_Fields = {
  __typename?: 'parkable_groups_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parkable_groups" */
export type Parkable_Groups_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parkable_Groups_Variance_Fields = {
  __typename?: 'parkable_groups_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parkable_groups" */
export type Parkable_Groups_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** columns and relationships of "parkable_parkable_group" */
export type Parkable_Parkable_Group = {
  __typename?: 'parkable_parkable_group';
  /** An object relationship */
  parkable: Parkables;
  /** An object relationship */
  parkable_group: Parkable_Groups;
  parkable_group_id: Scalars['bigint']['output'];
  parkable_id: Scalars['bigint']['output'];
};

/** aggregated selection of "parkable_parkable_group" */
export type Parkable_Parkable_Group_Aggregate = {
  __typename?: 'parkable_parkable_group_aggregate';
  aggregate?: Maybe<Parkable_Parkable_Group_Aggregate_Fields>;
  nodes: Array<Parkable_Parkable_Group>;
};

export type Parkable_Parkable_Group_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parkable_Parkable_Group_Aggregate_Bool_Exp_Count>;
};

export type Parkable_Parkable_Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parkable_Parkable_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parkable_parkable_group" */
export type Parkable_Parkable_Group_Aggregate_Fields = {
  __typename?: 'parkable_parkable_group_aggregate_fields';
  avg?: Maybe<Parkable_Parkable_Group_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parkable_Parkable_Group_Max_Fields>;
  min?: Maybe<Parkable_Parkable_Group_Min_Fields>;
  stddev?: Maybe<Parkable_Parkable_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Parkable_Parkable_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parkable_Parkable_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Parkable_Parkable_Group_Sum_Fields>;
  var_pop?: Maybe<Parkable_Parkable_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Parkable_Parkable_Group_Var_Samp_Fields>;
  variance?: Maybe<Parkable_Parkable_Group_Variance_Fields>;
};


/** aggregate fields of "parkable_parkable_group" */
export type Parkable_Parkable_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parkable_Parkable_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Aggregate_Order_By = {
  avg?: InputMaybe<Parkable_Parkable_Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parkable_Parkable_Group_Max_Order_By>;
  min?: InputMaybe<Parkable_Parkable_Group_Min_Order_By>;
  stddev?: InputMaybe<Parkable_Parkable_Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parkable_Parkable_Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parkable_Parkable_Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parkable_Parkable_Group_Sum_Order_By>;
  var_pop?: InputMaybe<Parkable_Parkable_Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parkable_Parkable_Group_Var_Samp_Order_By>;
  variance?: InputMaybe<Parkable_Parkable_Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Arr_Rel_Insert_Input = {
  data: Array<Parkable_Parkable_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Parkable_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Parkable_Parkable_Group_Avg_Fields = {
  __typename?: 'parkable_parkable_group_avg_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Avg_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parkable_parkable_group". All fields are combined with a logical 'AND'. */
export type Parkable_Parkable_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Parkable_Parkable_Group_Bool_Exp>>;
  _not?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Parkable_Parkable_Group_Bool_Exp>>;
  parkable?: InputMaybe<Parkables_Bool_Exp>;
  parkable_group?: InputMaybe<Parkable_Groups_Bool_Exp>;
  parkable_group_id?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "parkable_parkable_group" */
export enum Parkable_Parkable_Group_Constraint {
  /** unique or primary key constraint on columns "parkable_id", "parkable_group_id" */
  ParkableParkableGroupPkey = 'parkable_parkable_group_pkey'
}

/** input type for incrementing numeric columns in table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Inc_Input = {
  parkable_group_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Insert_Input = {
  parkable?: InputMaybe<Parkables_Obj_Rel_Insert_Input>;
  parkable_group?: InputMaybe<Parkable_Groups_Obj_Rel_Insert_Input>;
  parkable_group_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Parkable_Parkable_Group_Max_Fields = {
  __typename?: 'parkable_parkable_group_max_fields';
  parkable_group_id?: Maybe<Scalars['bigint']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Max_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parkable_Parkable_Group_Min_Fields = {
  __typename?: 'parkable_parkable_group_min_fields';
  parkable_group_id?: Maybe<Scalars['bigint']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Min_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Mutation_Response = {
  __typename?: 'parkable_parkable_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parkable_Parkable_Group>;
};

/** on_conflict condition type for table "parkable_parkable_group" */
export type Parkable_Parkable_Group_On_Conflict = {
  constraint: Parkable_Parkable_Group_Constraint;
  update_columns?: Array<Parkable_Parkable_Group_Update_Column>;
  where?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "parkable_parkable_group". */
export type Parkable_Parkable_Group_Order_By = {
  parkable?: InputMaybe<Parkables_Order_By>;
  parkable_group?: InputMaybe<Parkable_Groups_Order_By>;
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parkable_parkable_group */
export type Parkable_Parkable_Group_Pk_Columns_Input = {
  parkable_group_id: Scalars['bigint']['input'];
  parkable_id: Scalars['bigint']['input'];
};

/** select columns of table "parkable_parkable_group" */
export enum Parkable_Parkable_Group_Select_Column {
  /** column name */
  ParkableGroupId = 'parkable_group_id',
  /** column name */
  ParkableId = 'parkable_id'
}

/** input type for updating data in table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Set_Input = {
  parkable_group_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Parkable_Parkable_Group_Stddev_Fields = {
  __typename?: 'parkable_parkable_group_stddev_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Stddev_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parkable_Parkable_Group_Stddev_Pop_Fields = {
  __typename?: 'parkable_parkable_group_stddev_pop_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Stddev_Pop_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parkable_Parkable_Group_Stddev_Samp_Fields = {
  __typename?: 'parkable_parkable_group_stddev_samp_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Stddev_Samp_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parkable_Parkable_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parkable_Parkable_Group_Stream_Cursor_Value_Input = {
  parkable_group_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Parkable_Parkable_Group_Sum_Fields = {
  __typename?: 'parkable_parkable_group_sum_fields';
  parkable_group_id?: Maybe<Scalars['bigint']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Sum_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** update columns of table "parkable_parkable_group" */
export enum Parkable_Parkable_Group_Update_Column {
  /** column name */
  ParkableGroupId = 'parkable_group_id',
  /** column name */
  ParkableId = 'parkable_id'
}

export type Parkable_Parkable_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parkable_Parkable_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parkable_Parkable_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parkable_Parkable_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parkable_Parkable_Group_Var_Pop_Fields = {
  __typename?: 'parkable_parkable_group_var_pop_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Var_Pop_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parkable_Parkable_Group_Var_Samp_Fields = {
  __typename?: 'parkable_parkable_group_var_samp_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Var_Samp_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parkable_Parkable_Group_Variance_Fields = {
  __typename?: 'parkable_parkable_group_variance_fields';
  parkable_group_id?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parkable_parkable_group" */
export type Parkable_Parkable_Group_Variance_Order_By = {
  parkable_group_id?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "parkable_qr_code" */
export type Parkable_Qr_Code = {
  __typename?: 'parkable_qr_code';
  /** An object relationship */
  parkable: Parkables;
  parkable_id: Scalars['bigint']['output'];
  /** An object relationship */
  qr_code: Qr_Codes;
  qr_code_id: Scalars['bigint']['output'];
};

/** aggregated selection of "parkable_qr_code" */
export type Parkable_Qr_Code_Aggregate = {
  __typename?: 'parkable_qr_code_aggregate';
  aggregate?: Maybe<Parkable_Qr_Code_Aggregate_Fields>;
  nodes: Array<Parkable_Qr_Code>;
};

export type Parkable_Qr_Code_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parkable_Qr_Code_Aggregate_Bool_Exp_Count>;
};

export type Parkable_Qr_Code_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parkable_Qr_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parkable_qr_code" */
export type Parkable_Qr_Code_Aggregate_Fields = {
  __typename?: 'parkable_qr_code_aggregate_fields';
  avg?: Maybe<Parkable_Qr_Code_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parkable_Qr_Code_Max_Fields>;
  min?: Maybe<Parkable_Qr_Code_Min_Fields>;
  stddev?: Maybe<Parkable_Qr_Code_Stddev_Fields>;
  stddev_pop?: Maybe<Parkable_Qr_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parkable_Qr_Code_Stddev_Samp_Fields>;
  sum?: Maybe<Parkable_Qr_Code_Sum_Fields>;
  var_pop?: Maybe<Parkable_Qr_Code_Var_Pop_Fields>;
  var_samp?: Maybe<Parkable_Qr_Code_Var_Samp_Fields>;
  variance?: Maybe<Parkable_Qr_Code_Variance_Fields>;
};


/** aggregate fields of "parkable_qr_code" */
export type Parkable_Qr_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parkable_Qr_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parkable_qr_code" */
export type Parkable_Qr_Code_Aggregate_Order_By = {
  avg?: InputMaybe<Parkable_Qr_Code_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parkable_Qr_Code_Max_Order_By>;
  min?: InputMaybe<Parkable_Qr_Code_Min_Order_By>;
  stddev?: InputMaybe<Parkable_Qr_Code_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parkable_Qr_Code_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parkable_Qr_Code_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parkable_Qr_Code_Sum_Order_By>;
  var_pop?: InputMaybe<Parkable_Qr_Code_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parkable_Qr_Code_Var_Samp_Order_By>;
  variance?: InputMaybe<Parkable_Qr_Code_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parkable_qr_code" */
export type Parkable_Qr_Code_Arr_Rel_Insert_Input = {
  data: Array<Parkable_Qr_Code_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Qr_Code_On_Conflict>;
};

/** aggregate avg on columns */
export type Parkable_Qr_Code_Avg_Fields = {
  __typename?: 'parkable_qr_code_avg_fields';
  parkable_id?: Maybe<Scalars['Float']['output']>;
  qr_code_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parkable_qr_code" */
export type Parkable_Qr_Code_Avg_Order_By = {
  parkable_id?: InputMaybe<Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parkable_qr_code". All fields are combined with a logical 'AND'. */
export type Parkable_Qr_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Parkable_Qr_Code_Bool_Exp>>;
  _not?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Parkable_Qr_Code_Bool_Exp>>;
  parkable?: InputMaybe<Parkables_Bool_Exp>;
  parkable_id?: InputMaybe<Bigint_Comparison_Exp>;
  qr_code?: InputMaybe<Qr_Codes_Bool_Exp>;
  qr_code_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "parkable_qr_code" */
export enum Parkable_Qr_Code_Constraint {
  /** unique or primary key constraint on columns "parkable_id", "qr_code_id" */
  ParkableQrCodeParkableIdQrCodeIdUnique = 'parkable_qr_code_parkable_id_qr_code_id_unique'
}

/** input type for incrementing numeric columns in table "parkable_qr_code" */
export type Parkable_Qr_Code_Inc_Input = {
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  qr_code_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "parkable_qr_code" */
export type Parkable_Qr_Code_Insert_Input = {
  parkable?: InputMaybe<Parkables_Obj_Rel_Insert_Input>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  qr_code?: InputMaybe<Qr_Codes_Obj_Rel_Insert_Input>;
  qr_code_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Parkable_Qr_Code_Max_Fields = {
  __typename?: 'parkable_qr_code_max_fields';
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  qr_code_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "parkable_qr_code" */
export type Parkable_Qr_Code_Max_Order_By = {
  parkable_id?: InputMaybe<Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parkable_Qr_Code_Min_Fields = {
  __typename?: 'parkable_qr_code_min_fields';
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  qr_code_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "parkable_qr_code" */
export type Parkable_Qr_Code_Min_Order_By = {
  parkable_id?: InputMaybe<Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parkable_qr_code" */
export type Parkable_Qr_Code_Mutation_Response = {
  __typename?: 'parkable_qr_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parkable_Qr_Code>;
};

/** on_conflict condition type for table "parkable_qr_code" */
export type Parkable_Qr_Code_On_Conflict = {
  constraint: Parkable_Qr_Code_Constraint;
  update_columns?: Array<Parkable_Qr_Code_Update_Column>;
  where?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "parkable_qr_code". */
export type Parkable_Qr_Code_Order_By = {
  parkable?: InputMaybe<Parkables_Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  qr_code?: InputMaybe<Qr_Codes_Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** select columns of table "parkable_qr_code" */
export enum Parkable_Qr_Code_Select_Column {
  /** column name */
  ParkableId = 'parkable_id',
  /** column name */
  QrCodeId = 'qr_code_id'
}

/** input type for updating data in table "parkable_qr_code" */
export type Parkable_Qr_Code_Set_Input = {
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  qr_code_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Parkable_Qr_Code_Stddev_Fields = {
  __typename?: 'parkable_qr_code_stddev_fields';
  parkable_id?: Maybe<Scalars['Float']['output']>;
  qr_code_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parkable_qr_code" */
export type Parkable_Qr_Code_Stddev_Order_By = {
  parkable_id?: InputMaybe<Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parkable_Qr_Code_Stddev_Pop_Fields = {
  __typename?: 'parkable_qr_code_stddev_pop_fields';
  parkable_id?: Maybe<Scalars['Float']['output']>;
  qr_code_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parkable_qr_code" */
export type Parkable_Qr_Code_Stddev_Pop_Order_By = {
  parkable_id?: InputMaybe<Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parkable_Qr_Code_Stddev_Samp_Fields = {
  __typename?: 'parkable_qr_code_stddev_samp_fields';
  parkable_id?: Maybe<Scalars['Float']['output']>;
  qr_code_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parkable_qr_code" */
export type Parkable_Qr_Code_Stddev_Samp_Order_By = {
  parkable_id?: InputMaybe<Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parkable_qr_code" */
export type Parkable_Qr_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parkable_Qr_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parkable_Qr_Code_Stream_Cursor_Value_Input = {
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  qr_code_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Parkable_Qr_Code_Sum_Fields = {
  __typename?: 'parkable_qr_code_sum_fields';
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  qr_code_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "parkable_qr_code" */
export type Parkable_Qr_Code_Sum_Order_By = {
  parkable_id?: InputMaybe<Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** update columns of table "parkable_qr_code" */
export enum Parkable_Qr_Code_Update_Column {
  /** column name */
  ParkableId = 'parkable_id',
  /** column name */
  QrCodeId = 'qr_code_id'
}

export type Parkable_Qr_Code_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parkable_Qr_Code_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parkable_Qr_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parkable_Qr_Code_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parkable_Qr_Code_Var_Pop_Fields = {
  __typename?: 'parkable_qr_code_var_pop_fields';
  parkable_id?: Maybe<Scalars['Float']['output']>;
  qr_code_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parkable_qr_code" */
export type Parkable_Qr_Code_Var_Pop_Order_By = {
  parkable_id?: InputMaybe<Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parkable_Qr_Code_Var_Samp_Fields = {
  __typename?: 'parkable_qr_code_var_samp_fields';
  parkable_id?: Maybe<Scalars['Float']['output']>;
  qr_code_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parkable_qr_code" */
export type Parkable_Qr_Code_Var_Samp_Order_By = {
  parkable_id?: InputMaybe<Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parkable_Qr_Code_Variance_Fields = {
  __typename?: 'parkable_qr_code_variance_fields';
  parkable_id?: Maybe<Scalars['Float']['output']>;
  qr_code_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parkable_qr_code" */
export type Parkable_Qr_Code_Variance_Order_By = {
  parkable_id?: InputMaybe<Order_By>;
  qr_code_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "parkable_schedules" */
export type Parkable_Schedules = {
  __typename?: 'parkable_schedules';
  actions?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  parkable_group_parkable_schedules: Array<Parkable_Group_Parkable_Schedule>;
  /** An aggregate relationship */
  parkable_group_parkable_schedules_aggregate: Parkable_Group_Parkable_Schedule_Aggregate;
  /** An object relationship */
  parking_authority: Parking_Authorities;
  parking_authority_id: Scalars['bigint']['output'];
  priority: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "parkable_schedules" */
export type Parkable_SchedulesParkable_Group_Parkable_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Order_By>>;
  where?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
};


/** columns and relationships of "parkable_schedules" */
export type Parkable_SchedulesParkable_Group_Parkable_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Order_By>>;
  where?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
};

/** aggregated selection of "parkable_schedules" */
export type Parkable_Schedules_Aggregate = {
  __typename?: 'parkable_schedules_aggregate';
  aggregate?: Maybe<Parkable_Schedules_Aggregate_Fields>;
  nodes: Array<Parkable_Schedules>;
};

export type Parkable_Schedules_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Parkable_Schedules_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Parkable_Schedules_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Parkable_Schedules_Aggregate_Bool_Exp_Count>;
};

export type Parkable_Schedules_Aggregate_Bool_Exp_Bool_And = {
  arguments: Parkable_Schedules_Select_Column_Parkable_Schedules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Schedules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parkable_Schedules_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Parkable_Schedules_Select_Column_Parkable_Schedules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Schedules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parkable_Schedules_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parkable_Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Schedules_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parkable_schedules" */
export type Parkable_Schedules_Aggregate_Fields = {
  __typename?: 'parkable_schedules_aggregate_fields';
  avg?: Maybe<Parkable_Schedules_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parkable_Schedules_Max_Fields>;
  min?: Maybe<Parkable_Schedules_Min_Fields>;
  stddev?: Maybe<Parkable_Schedules_Stddev_Fields>;
  stddev_pop?: Maybe<Parkable_Schedules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parkable_Schedules_Stddev_Samp_Fields>;
  sum?: Maybe<Parkable_Schedules_Sum_Fields>;
  var_pop?: Maybe<Parkable_Schedules_Var_Pop_Fields>;
  var_samp?: Maybe<Parkable_Schedules_Var_Samp_Fields>;
  variance?: Maybe<Parkable_Schedules_Variance_Fields>;
};


/** aggregate fields of "parkable_schedules" */
export type Parkable_Schedules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parkable_Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parkable_schedules" */
export type Parkable_Schedules_Aggregate_Order_By = {
  avg?: InputMaybe<Parkable_Schedules_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parkable_Schedules_Max_Order_By>;
  min?: InputMaybe<Parkable_Schedules_Min_Order_By>;
  stddev?: InputMaybe<Parkable_Schedules_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parkable_Schedules_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parkable_Schedules_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parkable_Schedules_Sum_Order_By>;
  var_pop?: InputMaybe<Parkable_Schedules_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parkable_Schedules_Var_Samp_Order_By>;
  variance?: InputMaybe<Parkable_Schedules_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parkable_schedules" */
export type Parkable_Schedules_Arr_Rel_Insert_Input = {
  data: Array<Parkable_Schedules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Schedules_On_Conflict>;
};

/** aggregate avg on columns */
export type Parkable_Schedules_Avg_Fields = {
  __typename?: 'parkable_schedules_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parkable_schedules" */
export type Parkable_Schedules_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parkable_schedules". All fields are combined with a logical 'AND'. */
export type Parkable_Schedules_Bool_Exp = {
  _and?: InputMaybe<Array<Parkable_Schedules_Bool_Exp>>;
  _not?: InputMaybe<Parkable_Schedules_Bool_Exp>;
  _or?: InputMaybe<Array<Parkable_Schedules_Bool_Exp>>;
  actions?: InputMaybe<String_Comparison_Exp>;
  conditions?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parkable_group_parkable_schedules?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
  parkable_group_parkable_schedules_aggregate?: InputMaybe<Parkable_Group_Parkable_Schedule_Aggregate_Bool_Exp>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "parkable_schedules" */
export enum Parkable_Schedules_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParkableSchedulesPkey = 'parkable_schedules_pkey'
}

/** input type for incrementing numeric columns in table "parkable_schedules" */
export type Parkable_Schedules_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "parkable_schedules" */
export type Parkable_Schedules_Insert_Input = {
  actions?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parkable_group_parkable_schedules?: InputMaybe<Parkable_Group_Parkable_Schedule_Arr_Rel_Insert_Input>;
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Parkable_Schedules_Max_Fields = {
  __typename?: 'parkable_schedules_max_fields';
  actions?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "parkable_schedules" */
export type Parkable_Schedules_Max_Order_By = {
  actions?: InputMaybe<Order_By>;
  conditions?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parkable_Schedules_Min_Fields = {
  __typename?: 'parkable_schedules_min_fields';
  actions?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "parkable_schedules" */
export type Parkable_Schedules_Min_Order_By = {
  actions?: InputMaybe<Order_By>;
  conditions?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parkable_schedules" */
export type Parkable_Schedules_Mutation_Response = {
  __typename?: 'parkable_schedules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parkable_Schedules>;
};

/** input type for inserting object relation for remote table "parkable_schedules" */
export type Parkable_Schedules_Obj_Rel_Insert_Input = {
  data: Parkable_Schedules_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Schedules_On_Conflict>;
};

/** on_conflict condition type for table "parkable_schedules" */
export type Parkable_Schedules_On_Conflict = {
  constraint: Parkable_Schedules_Constraint;
  update_columns?: Array<Parkable_Schedules_Update_Column>;
  where?: InputMaybe<Parkable_Schedules_Bool_Exp>;
};

/** Ordering options when selecting data from "parkable_schedules". */
export type Parkable_Schedules_Order_By = {
  actions?: InputMaybe<Order_By>;
  conditions?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parkable_group_parkable_schedules_aggregate?: InputMaybe<Parkable_Group_Parkable_Schedule_Aggregate_Order_By>;
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parkable_schedules */
export type Parkable_Schedules_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "parkable_schedules" */
export enum Parkable_Schedules_Select_Column {
  /** column name */
  Actions = 'actions',
  /** column name */
  Conditions = 'conditions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "parkable_schedules_aggregate_bool_exp_bool_and_arguments_columns" columns of table "parkable_schedules" */
export enum Parkable_Schedules_Select_Column_Parkable_Schedules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Enabled = 'enabled'
}

/** select "parkable_schedules_aggregate_bool_exp_bool_or_arguments_columns" columns of table "parkable_schedules" */
export enum Parkable_Schedules_Select_Column_Parkable_Schedules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "parkable_schedules" */
export type Parkable_Schedules_Set_Input = {
  actions?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Parkable_Schedules_Stddev_Fields = {
  __typename?: 'parkable_schedules_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parkable_schedules" */
export type Parkable_Schedules_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parkable_Schedules_Stddev_Pop_Fields = {
  __typename?: 'parkable_schedules_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parkable_schedules" */
export type Parkable_Schedules_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parkable_Schedules_Stddev_Samp_Fields = {
  __typename?: 'parkable_schedules_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parkable_schedules" */
export type Parkable_Schedules_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parkable_schedules" */
export type Parkable_Schedules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parkable_Schedules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parkable_Schedules_Stream_Cursor_Value_Input = {
  actions?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Parkable_Schedules_Sum_Fields = {
  __typename?: 'parkable_schedules_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "parkable_schedules" */
export type Parkable_Schedules_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** update columns of table "parkable_schedules" */
export enum Parkable_Schedules_Update_Column {
  /** column name */
  Actions = 'actions',
  /** column name */
  Conditions = 'conditions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Parkable_Schedules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parkable_Schedules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parkable_Schedules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parkable_Schedules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parkable_Schedules_Var_Pop_Fields = {
  __typename?: 'parkable_schedules_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parkable_schedules" */
export type Parkable_Schedules_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parkable_Schedules_Var_Samp_Fields = {
  __typename?: 'parkable_schedules_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parkable_schedules" */
export type Parkable_Schedules_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parkable_Schedules_Variance_Fields = {
  __typename?: 'parkable_schedules_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parkable_schedules" */
export type Parkable_Schedules_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** columns and relationships of "parkable_transaction_task" */
export type Parkable_Transaction_Task = {
  __typename?: 'parkable_transaction_task';
  /** An object relationship */
  parkable_transaction: Parkable_Transactions;
  parkable_transaction_id: Scalars['bigint']['output'];
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
};

/** aggregated selection of "parkable_transaction_task" */
export type Parkable_Transaction_Task_Aggregate = {
  __typename?: 'parkable_transaction_task_aggregate';
  aggregate?: Maybe<Parkable_Transaction_Task_Aggregate_Fields>;
  nodes: Array<Parkable_Transaction_Task>;
};

export type Parkable_Transaction_Task_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parkable_Transaction_Task_Aggregate_Bool_Exp_Count>;
};

export type Parkable_Transaction_Task_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parkable_Transaction_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parkable_transaction_task" */
export type Parkable_Transaction_Task_Aggregate_Fields = {
  __typename?: 'parkable_transaction_task_aggregate_fields';
  avg?: Maybe<Parkable_Transaction_Task_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parkable_Transaction_Task_Max_Fields>;
  min?: Maybe<Parkable_Transaction_Task_Min_Fields>;
  stddev?: Maybe<Parkable_Transaction_Task_Stddev_Fields>;
  stddev_pop?: Maybe<Parkable_Transaction_Task_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parkable_Transaction_Task_Stddev_Samp_Fields>;
  sum?: Maybe<Parkable_Transaction_Task_Sum_Fields>;
  var_pop?: Maybe<Parkable_Transaction_Task_Var_Pop_Fields>;
  var_samp?: Maybe<Parkable_Transaction_Task_Var_Samp_Fields>;
  variance?: Maybe<Parkable_Transaction_Task_Variance_Fields>;
};


/** aggregate fields of "parkable_transaction_task" */
export type Parkable_Transaction_Task_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parkable_Transaction_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Aggregate_Order_By = {
  avg?: InputMaybe<Parkable_Transaction_Task_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parkable_Transaction_Task_Max_Order_By>;
  min?: InputMaybe<Parkable_Transaction_Task_Min_Order_By>;
  stddev?: InputMaybe<Parkable_Transaction_Task_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parkable_Transaction_Task_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parkable_Transaction_Task_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parkable_Transaction_Task_Sum_Order_By>;
  var_pop?: InputMaybe<Parkable_Transaction_Task_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parkable_Transaction_Task_Var_Samp_Order_By>;
  variance?: InputMaybe<Parkable_Transaction_Task_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Arr_Rel_Insert_Input = {
  data: Array<Parkable_Transaction_Task_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Transaction_Task_On_Conflict>;
};

/** aggregate avg on columns */
export type Parkable_Transaction_Task_Avg_Fields = {
  __typename?: 'parkable_transaction_task_avg_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Avg_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parkable_transaction_task". All fields are combined with a logical 'AND'. */
export type Parkable_Transaction_Task_Bool_Exp = {
  _and?: InputMaybe<Array<Parkable_Transaction_Task_Bool_Exp>>;
  _not?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
  _or?: InputMaybe<Array<Parkable_Transaction_Task_Bool_Exp>>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "parkable_transaction_task" */
export enum Parkable_Transaction_Task_Constraint {
  /** unique or primary key constraint on columns "task_id", "parkable_transaction_id" */
  ParkableTransactionTaskPkey = 'parkable_transaction_task_pkey'
}

/** input type for incrementing numeric columns in table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Inc_Input = {
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Insert_Input = {
  parkable_transaction?: InputMaybe<Parkable_Transactions_Obj_Rel_Insert_Input>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Parkable_Transaction_Task_Max_Fields = {
  __typename?: 'parkable_transaction_task_max_fields';
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Max_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parkable_Transaction_Task_Min_Fields = {
  __typename?: 'parkable_transaction_task_min_fields';
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Min_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Mutation_Response = {
  __typename?: 'parkable_transaction_task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parkable_Transaction_Task>;
};

/** input type for inserting object relation for remote table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Obj_Rel_Insert_Input = {
  data: Parkable_Transaction_Task_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Transaction_Task_On_Conflict>;
};

/** on_conflict condition type for table "parkable_transaction_task" */
export type Parkable_Transaction_Task_On_Conflict = {
  constraint: Parkable_Transaction_Task_Constraint;
  update_columns?: Array<Parkable_Transaction_Task_Update_Column>;
  where?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
};

/** Ordering options when selecting data from "parkable_transaction_task". */
export type Parkable_Transaction_Task_Order_By = {
  parkable_transaction?: InputMaybe<Parkable_Transactions_Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parkable_transaction_task */
export type Parkable_Transaction_Task_Pk_Columns_Input = {
  parkable_transaction_id: Scalars['bigint']['input'];
  task_id: Scalars['uuid']['input'];
};

/** select columns of table "parkable_transaction_task" */
export enum Parkable_Transaction_Task_Select_Column {
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id',
  /** column name */
  TaskId = 'task_id'
}

/** input type for updating data in table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Set_Input = {
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Parkable_Transaction_Task_Stddev_Fields = {
  __typename?: 'parkable_transaction_task_stddev_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Stddev_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parkable_Transaction_Task_Stddev_Pop_Fields = {
  __typename?: 'parkable_transaction_task_stddev_pop_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Stddev_Pop_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parkable_Transaction_Task_Stddev_Samp_Fields = {
  __typename?: 'parkable_transaction_task_stddev_samp_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Stddev_Samp_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parkable_Transaction_Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parkable_Transaction_Task_Stream_Cursor_Value_Input = {
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Parkable_Transaction_Task_Sum_Fields = {
  __typename?: 'parkable_transaction_task_sum_fields';
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Sum_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "parkable_transaction_task" */
export enum Parkable_Transaction_Task_Update_Column {
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id',
  /** column name */
  TaskId = 'task_id'
}

export type Parkable_Transaction_Task_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parkable_Transaction_Task_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parkable_Transaction_Task_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parkable_Transaction_Task_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parkable_Transaction_Task_Var_Pop_Fields = {
  __typename?: 'parkable_transaction_task_var_pop_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Var_Pop_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parkable_Transaction_Task_Var_Samp_Fields = {
  __typename?: 'parkable_transaction_task_var_samp_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Var_Samp_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parkable_Transaction_Task_Variance_Fields = {
  __typename?: 'parkable_transaction_task_variance_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parkable_transaction_task" */
export type Parkable_Transaction_Task_Variance_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction = {
  __typename?: 'parkable_transaction_wallet_transaction';
  /** An object relationship */
  parkable_transaction: Parkable_Transactions;
  parkable_transaction_id: Scalars['bigint']['output'];
  /** An object relationship */
  wallet_transaction: Wallet_Transactions;
  wallet_transaction_id: Scalars['bigint']['output'];
};

/** aggregated selection of "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Aggregate = {
  __typename?: 'parkable_transaction_wallet_transaction_aggregate';
  aggregate?: Maybe<Parkable_Transaction_Wallet_Transaction_Aggregate_Fields>;
  nodes: Array<Parkable_Transaction_Wallet_Transaction>;
};

export type Parkable_Transaction_Wallet_Transaction_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Aggregate_Bool_Exp_Count>;
};

export type Parkable_Transaction_Wallet_Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Aggregate_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_aggregate_fields';
  avg?: Maybe<Parkable_Transaction_Wallet_Transaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parkable_Transaction_Wallet_Transaction_Max_Fields>;
  min?: Maybe<Parkable_Transaction_Wallet_Transaction_Min_Fields>;
  stddev?: Maybe<Parkable_Transaction_Wallet_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Parkable_Transaction_Wallet_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parkable_Transaction_Wallet_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Parkable_Transaction_Wallet_Transaction_Sum_Fields>;
  var_pop?: Maybe<Parkable_Transaction_Wallet_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Parkable_Transaction_Wallet_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Parkable_Transaction_Wallet_Transaction_Variance_Fields>;
};


/** aggregate fields of "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Max_Order_By>;
  min?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Parkable_Transaction_Wallet_Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Transaction_Wallet_Transaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Parkable_Transaction_Wallet_Transaction_Avg_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_avg_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Avg_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parkable_transaction_wallet_transaction". All fields are combined with a logical 'AND'. */
export type Parkable_Transaction_Wallet_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Bool_Exp>>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "parkable_transaction_wallet_transaction" */
export enum Parkable_Transaction_Wallet_Transaction_Constraint {
  /** unique or primary key constraint on columns "wallet_transaction_id", "parkable_transaction_id" */
  ParkableTransactionWalletTransactionPkey = 'parkable_transaction_wallet_transaction_pkey'
}

/** input type for incrementing numeric columns in table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Inc_Input = {
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Insert_Input = {
  parkable_transaction?: InputMaybe<Parkable_Transactions_Obj_Rel_Insert_Input>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Obj_Rel_Insert_Input>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Parkable_Transaction_Wallet_Transaction_Max_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_max_fields';
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Max_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parkable_Transaction_Wallet_Transaction_Min_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_min_fields';
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Min_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Mutation_Response = {
  __typename?: 'parkable_transaction_wallet_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parkable_Transaction_Wallet_Transaction>;
};

/** on_conflict condition type for table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_On_Conflict = {
  constraint: Parkable_Transaction_Wallet_Transaction_Constraint;
  update_columns?: Array<Parkable_Transaction_Wallet_Transaction_Update_Column>;
  where?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "parkable_transaction_wallet_transaction". */
export type Parkable_Transaction_Wallet_Transaction_Order_By = {
  parkable_transaction?: InputMaybe<Parkable_Transactions_Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parkable_transaction_wallet_transaction */
export type Parkable_Transaction_Wallet_Transaction_Pk_Columns_Input = {
  parkable_transaction_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};

/** select columns of table "parkable_transaction_wallet_transaction" */
export enum Parkable_Transaction_Wallet_Transaction_Select_Column {
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

/** input type for updating data in table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Set_Input = {
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Parkable_Transaction_Wallet_Transaction_Stddev_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_stddev_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Stddev_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parkable_Transaction_Wallet_Transaction_Stddev_Pop_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_stddev_pop_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Stddev_Pop_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parkable_Transaction_Wallet_Transaction_Stddev_Samp_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_stddev_samp_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Stddev_Samp_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parkable_Transaction_Wallet_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parkable_Transaction_Wallet_Transaction_Stream_Cursor_Value_Input = {
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Parkable_Transaction_Wallet_Transaction_Sum_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_sum_fields';
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Sum_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "parkable_transaction_wallet_transaction" */
export enum Parkable_Transaction_Wallet_Transaction_Update_Column {
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

export type Parkable_Transaction_Wallet_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parkable_Transaction_Wallet_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parkable_Transaction_Wallet_Transaction_Var_Pop_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_var_pop_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Var_Pop_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parkable_Transaction_Wallet_Transaction_Var_Samp_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_var_samp_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Var_Samp_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parkable_Transaction_Wallet_Transaction_Variance_Fields = {
  __typename?: 'parkable_transaction_wallet_transaction_variance_fields';
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parkable_transaction_wallet_transaction" */
export type Parkable_Transaction_Wallet_Transaction_Variance_Order_By = {
  parkable_transaction_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "parkable_transactions" */
export type Parkable_Transactions = {
  __typename?: 'parkable_transactions';
  app_version?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  browser_version?: Maybe<Scalars['String']['output']>;
  cancelled_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_client_id?: Maybe<Scalars['String']['output']>;
  expired_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  finalized_at?: Maybe<Scalars['timestamp']['output']>;
  funds_transferred_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  invoice_parkable_transactions: Array<Invoice_Parkable_Transaction>;
  /** An aggregate relationship */
  invoice_parkable_transactions_aggregate: Invoice_Parkable_Transaction_Aggregate;
  last_acknowledged_at?: Maybe<Scalars['timestamp']['output']>;
  last_enforcement_notified_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_time_extended_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  line_item_parkable_transactions: Array<Line_Item_Parkable_Transaction>;
  /** An aggregate relationship */
  line_item_parkable_transactions_aggregate: Line_Item_Parkable_Transaction_Aggregate;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  num_time_extensions: Scalars['smallint']['output'];
  operating_system?: Maybe<Scalars['String']['output']>;
  operating_system_version?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parkable: Parkables;
  parkable_id: Scalars['bigint']['output'];
  /** An array relationship */
  parkable_transaction_tasks: Array<Parkable_Transaction_Task>;
  /** An aggregate relationship */
  parkable_transaction_tasks_aggregate: Parkable_Transaction_Task_Aggregate;
  /** An array relationship */
  parkable_transaction_wallet_transactions: Array<Parkable_Transaction_Wallet_Transaction>;
  /** An aggregate relationship */
  parkable_transaction_wallet_transactions_aggregate: Parkable_Transaction_Wallet_Transaction_Aggregate;
  payment_finalized_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  payment_method?: Maybe<Payment_Methods>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  sms_notif_data?: Maybe<Scalars['json']['output']>;
  sms_notif_expired_sent_at?: Maybe<Scalars['timestamp']['output']>;
  sms_notif_warning_sent_at?: Maybe<Scalars['timestamp']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_license_plate?: Maybe<Scalars['String']['output']>;
  snapshot_price: Scalars['Int']['output'];
  snapshot_price_interval: Scalars['Int']['output'];
  snapshot_price_interval_unit: Scalars['String']['output'];
  snapshot_time_limit: Scalars['Int']['output'];
  snapshot_time_limit_unit: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  time: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
  /** An object relationship */
  vehicle: Vehicles;
  vehicle_id: Scalars['bigint']['output'];
};


/** columns and relationships of "parkable_transactions" */
export type Parkable_TransactionsInvoice_Parkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};


/** columns and relationships of "parkable_transactions" */
export type Parkable_TransactionsInvoice_Parkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};


/** columns and relationships of "parkable_transactions" */
export type Parkable_TransactionsLine_Item_Parkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
};


/** columns and relationships of "parkable_transactions" */
export type Parkable_TransactionsLine_Item_Parkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
};


/** columns and relationships of "parkable_transactions" */
export type Parkable_TransactionsParkable_Transaction_TasksArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Task_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
};


/** columns and relationships of "parkable_transactions" */
export type Parkable_TransactionsParkable_Transaction_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Task_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
};


/** columns and relationships of "parkable_transactions" */
export type Parkable_TransactionsParkable_Transaction_Wallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "parkable_transactions" */
export type Parkable_TransactionsParkable_Transaction_Wallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "parkable_transactions" */
export type Parkable_TransactionsSms_Notif_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "parkable_transactions" */
export type Parkable_Transactions_Aggregate = {
  __typename?: 'parkable_transactions_aggregate';
  aggregate?: Maybe<Parkable_Transactions_Aggregate_Fields>;
  nodes: Array<Parkable_Transactions>;
};

export type Parkable_Transactions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parkable_Transactions_Aggregate_Bool_Exp_Count>;
};

export type Parkable_Transactions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parkable_transactions" */
export type Parkable_Transactions_Aggregate_Fields = {
  __typename?: 'parkable_transactions_aggregate_fields';
  avg?: Maybe<Parkable_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parkable_Transactions_Max_Fields>;
  min?: Maybe<Parkable_Transactions_Min_Fields>;
  stddev?: Maybe<Parkable_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Parkable_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parkable_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Parkable_Transactions_Sum_Fields>;
  var_pop?: Maybe<Parkable_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Parkable_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Parkable_Transactions_Variance_Fields>;
};


/** aggregate fields of "parkable_transactions" */
export type Parkable_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parkable_transactions" */
export type Parkable_Transactions_Aggregate_Order_By = {
  avg?: InputMaybe<Parkable_Transactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parkable_Transactions_Max_Order_By>;
  min?: InputMaybe<Parkable_Transactions_Min_Order_By>;
  stddev?: InputMaybe<Parkable_Transactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parkable_Transactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parkable_Transactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parkable_Transactions_Sum_Order_By>;
  var_pop?: InputMaybe<Parkable_Transactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parkable_Transactions_Var_Samp_Order_By>;
  variance?: InputMaybe<Parkable_Transactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parkable_transactions" */
export type Parkable_Transactions_Arr_Rel_Insert_Input = {
  data: Array<Parkable_Transactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Transactions_On_Conflict>;
};

/** aggregate avg on columns */
export type Parkable_Transactions_Avg_Fields = {
  __typename?: 'parkable_transactions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parkable_transactions" */
export type Parkable_Transactions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parkable_transactions". All fields are combined with a logical 'AND'. */
export type Parkable_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Parkable_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Parkable_Transactions_Bool_Exp>>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  browser?: InputMaybe<String_Comparison_Exp>;
  browser_version?: InputMaybe<String_Comparison_Exp>;
  cancelled_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  device_client_id?: InputMaybe<String_Comparison_Exp>;
  expired_at?: InputMaybe<Timestamp_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamp_Comparison_Exp>;
  finalized_at?: InputMaybe<Timestamp_Comparison_Exp>;
  funds_transferred_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_parkable_transactions?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
  invoice_parkable_transactions_aggregate?: InputMaybe<Invoice_Parkable_Transaction_Aggregate_Bool_Exp>;
  last_acknowledged_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_enforcement_notified_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_time_extended_at?: InputMaybe<Timestamp_Comparison_Exp>;
  legacy_active_parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  line_item_parkable_transactions?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
  line_item_parkable_transactions_aggregate?: InputMaybe<Line_Item_Parkable_Transaction_Aggregate_Bool_Exp>;
  num_etl_failures?: InputMaybe<Smallint_Comparison_Exp>;
  num_etls?: InputMaybe<Bigint_Comparison_Exp>;
  num_time_extensions?: InputMaybe<Smallint_Comparison_Exp>;
  operating_system?: InputMaybe<String_Comparison_Exp>;
  operating_system_version?: InputMaybe<String_Comparison_Exp>;
  parkable?: InputMaybe<Parkables_Bool_Exp>;
  parkable_id?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_transaction_tasks?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
  parkable_transaction_tasks_aggregate?: InputMaybe<Parkable_Transaction_Task_Aggregate_Bool_Exp>;
  parkable_transaction_wallet_transactions?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
  parkable_transaction_wallet_transactions_aggregate?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Aggregate_Bool_Exp>;
  payment_finalized_at?: InputMaybe<Timestamp_Comparison_Exp>;
  payment_method?: InputMaybe<Payment_Methods_Bool_Exp>;
  payment_method_id?: InputMaybe<Bigint_Comparison_Exp>;
  sms_notif_data?: InputMaybe<Json_Comparison_Exp>;
  sms_notif_expired_sent_at?: InputMaybe<Timestamp_Comparison_Exp>;
  sms_notif_warning_sent_at?: InputMaybe<Timestamp_Comparison_Exp>;
  snapshot_fee?: InputMaybe<Int_Comparison_Exp>;
  snapshot_license_plate?: InputMaybe<String_Comparison_Exp>;
  snapshot_price?: InputMaybe<Int_Comparison_Exp>;
  snapshot_price_interval?: InputMaybe<Int_Comparison_Exp>;
  snapshot_price_interval_unit?: InputMaybe<String_Comparison_Exp>;
  snapshot_time_limit?: InputMaybe<Int_Comparison_Exp>;
  snapshot_time_limit_unit?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  time?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicles_Bool_Exp>;
  vehicle_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "parkable_transactions" */
export enum Parkable_Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParkableTransactionsPkey = 'parkable_transactions_pkey'
}

/** input type for incrementing numeric columns in table "parkable_transactions" */
export type Parkable_Transactions_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  num_time_extensions?: InputMaybe<Scalars['smallint']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "parkable_transactions" */
export type Parkable_Transactions_Insert_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  browser?: InputMaybe<Scalars['String']['input']>;
  browser_version?: InputMaybe<Scalars['String']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_client_id?: InputMaybe<Scalars['String']['input']>;
  expired_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  funds_transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  invoice_parkable_transactions?: InputMaybe<Invoice_Parkable_Transaction_Arr_Rel_Insert_Input>;
  last_acknowledged_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_enforcement_notified_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_time_extended_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_parkable_transactions?: InputMaybe<Line_Item_Parkable_Transaction_Arr_Rel_Insert_Input>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  num_time_extensions?: InputMaybe<Scalars['smallint']['input']>;
  operating_system?: InputMaybe<Scalars['String']['input']>;
  operating_system_version?: InputMaybe<Scalars['String']['input']>;
  parkable?: InputMaybe<Parkables_Obj_Rel_Insert_Input>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_tasks?: InputMaybe<Parkable_Transaction_Task_Arr_Rel_Insert_Input>;
  parkable_transaction_wallet_transactions?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Arr_Rel_Insert_Input>;
  payment_finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment_method?: InputMaybe<Payment_Methods_Obj_Rel_Insert_Input>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  sms_notif_data?: InputMaybe<Scalars['json']['input']>;
  sms_notif_expired_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  sms_notif_warning_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_license_plate?: InputMaybe<Scalars['String']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle?: InputMaybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Parkable_Transactions_Max_Fields = {
  __typename?: 'parkable_transactions_max_fields';
  app_version?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  browser_version?: Maybe<Scalars['String']['output']>;
  cancelled_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_client_id?: Maybe<Scalars['String']['output']>;
  expired_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  finalized_at?: Maybe<Scalars['timestamp']['output']>;
  funds_transferred_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  last_acknowledged_at?: Maybe<Scalars['timestamp']['output']>;
  last_enforcement_notified_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_time_extended_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  num_time_extensions?: Maybe<Scalars['smallint']['output']>;
  operating_system?: Maybe<Scalars['String']['output']>;
  operating_system_version?: Maybe<Scalars['String']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  payment_finalized_at?: Maybe<Scalars['timestamp']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  sms_notif_expired_sent_at?: Maybe<Scalars['timestamp']['output']>;
  sms_notif_warning_sent_at?: Maybe<Scalars['timestamp']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_license_plate?: Maybe<Scalars['String']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_unit?: Maybe<Scalars['String']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_unit?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "parkable_transactions" */
export type Parkable_Transactions_Max_Order_By = {
  app_version?: InputMaybe<Order_By>;
  browser?: InputMaybe<Order_By>;
  browser_version?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_client_id?: InputMaybe<Order_By>;
  expired_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  funds_transferred_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  last_acknowledged_at?: InputMaybe<Order_By>;
  last_enforcement_notified_at?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_time_extended_at?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  operating_system?: InputMaybe<Order_By>;
  operating_system_version?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  payment_finalized_at?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  sms_notif_expired_sent_at?: InputMaybe<Order_By>;
  sms_notif_warning_sent_at?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_license_plate?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_price_interval_unit?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  snapshot_time_limit_unit?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parkable_Transactions_Min_Fields = {
  __typename?: 'parkable_transactions_min_fields';
  app_version?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  browser_version?: Maybe<Scalars['String']['output']>;
  cancelled_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_client_id?: Maybe<Scalars['String']['output']>;
  expired_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  finalized_at?: Maybe<Scalars['timestamp']['output']>;
  funds_transferred_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  last_acknowledged_at?: Maybe<Scalars['timestamp']['output']>;
  last_enforcement_notified_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_time_extended_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  num_time_extensions?: Maybe<Scalars['smallint']['output']>;
  operating_system?: Maybe<Scalars['String']['output']>;
  operating_system_version?: Maybe<Scalars['String']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  payment_finalized_at?: Maybe<Scalars['timestamp']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  sms_notif_expired_sent_at?: Maybe<Scalars['timestamp']['output']>;
  sms_notif_warning_sent_at?: Maybe<Scalars['timestamp']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_license_plate?: Maybe<Scalars['String']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_unit?: Maybe<Scalars['String']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_unit?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "parkable_transactions" */
export type Parkable_Transactions_Min_Order_By = {
  app_version?: InputMaybe<Order_By>;
  browser?: InputMaybe<Order_By>;
  browser_version?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_client_id?: InputMaybe<Order_By>;
  expired_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  funds_transferred_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  last_acknowledged_at?: InputMaybe<Order_By>;
  last_enforcement_notified_at?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_time_extended_at?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  operating_system?: InputMaybe<Order_By>;
  operating_system_version?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  payment_finalized_at?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  sms_notif_expired_sent_at?: InputMaybe<Order_By>;
  sms_notif_warning_sent_at?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_license_plate?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_price_interval_unit?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  snapshot_time_limit_unit?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parkable_transactions" */
export type Parkable_Transactions_Mutation_Response = {
  __typename?: 'parkable_transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parkable_Transactions>;
};

/** input type for inserting object relation for remote table "parkable_transactions" */
export type Parkable_Transactions_Obj_Rel_Insert_Input = {
  data: Parkable_Transactions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkable_Transactions_On_Conflict>;
};

/** on_conflict condition type for table "parkable_transactions" */
export type Parkable_Transactions_On_Conflict = {
  constraint: Parkable_Transactions_Constraint;
  update_columns?: Array<Parkable_Transactions_Update_Column>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "parkable_transactions". */
export type Parkable_Transactions_Order_By = {
  app_version?: InputMaybe<Order_By>;
  browser?: InputMaybe<Order_By>;
  browser_version?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_client_id?: InputMaybe<Order_By>;
  expired_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  funds_transferred_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  invoice_parkable_transactions_aggregate?: InputMaybe<Invoice_Parkable_Transaction_Aggregate_Order_By>;
  last_acknowledged_at?: InputMaybe<Order_By>;
  last_enforcement_notified_at?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_time_extended_at?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  line_item_parkable_transactions_aggregate?: InputMaybe<Line_Item_Parkable_Transaction_Aggregate_Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  operating_system?: InputMaybe<Order_By>;
  operating_system_version?: InputMaybe<Order_By>;
  parkable?: InputMaybe<Parkables_Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  parkable_transaction_tasks_aggregate?: InputMaybe<Parkable_Transaction_Task_Aggregate_Order_By>;
  parkable_transaction_wallet_transactions_aggregate?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Aggregate_Order_By>;
  payment_finalized_at?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Payment_Methods_Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  sms_notif_data?: InputMaybe<Order_By>;
  sms_notif_expired_sent_at?: InputMaybe<Order_By>;
  sms_notif_warning_sent_at?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_license_plate?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_price_interval_unit?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  snapshot_time_limit_unit?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicles_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parkable_transactions */
export type Parkable_Transactions_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "parkable_transactions" */
export enum Parkable_Transactions_Select_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  Browser = 'browser',
  /** column name */
  BrowserVersion = 'browser_version',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceClientId = 'device_client_id',
  /** column name */
  ExpiredAt = 'expired_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  FinalizedAt = 'finalized_at',
  /** column name */
  FundsTransferredAt = 'funds_transferred_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  LastAcknowledgedAt = 'last_acknowledged_at',
  /** column name */
  LastEnforcementNotifiedAt = 'last_enforcement_notified_at',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastTimeExtendedAt = 'last_time_extended_at',
  /** column name */
  LegacyActiveParkableTransactionId = 'legacy_active_parkable_transaction_id',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  NumTimeExtensions = 'num_time_extensions',
  /** column name */
  OperatingSystem = 'operating_system',
  /** column name */
  OperatingSystemVersion = 'operating_system_version',
  /** column name */
  ParkableId = 'parkable_id',
  /** column name */
  PaymentFinalizedAt = 'payment_finalized_at',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  SmsNotifData = 'sms_notif_data',
  /** column name */
  SmsNotifExpiredSentAt = 'sms_notif_expired_sent_at',
  /** column name */
  SmsNotifWarningSentAt = 'sms_notif_warning_sent_at',
  /** column name */
  SnapshotFee = 'snapshot_fee',
  /** column name */
  SnapshotLicensePlate = 'snapshot_license_plate',
  /** column name */
  SnapshotPrice = 'snapshot_price',
  /** column name */
  SnapshotPriceInterval = 'snapshot_price_interval',
  /** column name */
  SnapshotPriceIntervalUnit = 'snapshot_price_interval_unit',
  /** column name */
  SnapshotTimeLimit = 'snapshot_time_limit',
  /** column name */
  SnapshotTimeLimitUnit = 'snapshot_time_limit_unit',
  /** column name */
  Source = 'source',
  /** column name */
  Time = 'time',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** input type for updating data in table "parkable_transactions" */
export type Parkable_Transactions_Set_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  browser?: InputMaybe<Scalars['String']['input']>;
  browser_version?: InputMaybe<Scalars['String']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_client_id?: InputMaybe<Scalars['String']['input']>;
  expired_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  funds_transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  last_acknowledged_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_enforcement_notified_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_time_extended_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  num_time_extensions?: InputMaybe<Scalars['smallint']['input']>;
  operating_system?: InputMaybe<Scalars['String']['input']>;
  operating_system_version?: InputMaybe<Scalars['String']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  sms_notif_data?: InputMaybe<Scalars['json']['input']>;
  sms_notif_expired_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  sms_notif_warning_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_license_plate?: InputMaybe<Scalars['String']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Parkable_Transactions_Stddev_Fields = {
  __typename?: 'parkable_transactions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parkable_transactions" */
export type Parkable_Transactions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parkable_Transactions_Stddev_Pop_Fields = {
  __typename?: 'parkable_transactions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parkable_transactions" */
export type Parkable_Transactions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parkable_Transactions_Stddev_Samp_Fields = {
  __typename?: 'parkable_transactions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parkable_transactions" */
export type Parkable_Transactions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parkable_transactions" */
export type Parkable_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parkable_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parkable_Transactions_Stream_Cursor_Value_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  browser?: InputMaybe<Scalars['String']['input']>;
  browser_version?: InputMaybe<Scalars['String']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_client_id?: InputMaybe<Scalars['String']['input']>;
  expired_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  funds_transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  last_acknowledged_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_enforcement_notified_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_time_extended_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_active_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  num_time_extensions?: InputMaybe<Scalars['smallint']['input']>;
  operating_system?: InputMaybe<Scalars['String']['input']>;
  operating_system_version?: InputMaybe<Scalars['String']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  sms_notif_data?: InputMaybe<Scalars['json']['input']>;
  sms_notif_expired_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  sms_notif_warning_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_license_plate?: InputMaybe<Scalars['String']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Parkable_Transactions_Sum_Fields = {
  __typename?: 'parkable_transactions_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  num_time_extensions?: Maybe<Scalars['smallint']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "parkable_transactions" */
export type Parkable_Transactions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** update columns of table "parkable_transactions" */
export enum Parkable_Transactions_Update_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  Browser = 'browser',
  /** column name */
  BrowserVersion = 'browser_version',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceClientId = 'device_client_id',
  /** column name */
  ExpiredAt = 'expired_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  FinalizedAt = 'finalized_at',
  /** column name */
  FundsTransferredAt = 'funds_transferred_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  LastAcknowledgedAt = 'last_acknowledged_at',
  /** column name */
  LastEnforcementNotifiedAt = 'last_enforcement_notified_at',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastTimeExtendedAt = 'last_time_extended_at',
  /** column name */
  LegacyActiveParkableTransactionId = 'legacy_active_parkable_transaction_id',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  NumTimeExtensions = 'num_time_extensions',
  /** column name */
  OperatingSystem = 'operating_system',
  /** column name */
  OperatingSystemVersion = 'operating_system_version',
  /** column name */
  ParkableId = 'parkable_id',
  /** column name */
  PaymentFinalizedAt = 'payment_finalized_at',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  SmsNotifData = 'sms_notif_data',
  /** column name */
  SmsNotifExpiredSentAt = 'sms_notif_expired_sent_at',
  /** column name */
  SmsNotifWarningSentAt = 'sms_notif_warning_sent_at',
  /** column name */
  SnapshotFee = 'snapshot_fee',
  /** column name */
  SnapshotLicensePlate = 'snapshot_license_plate',
  /** column name */
  SnapshotPrice = 'snapshot_price',
  /** column name */
  SnapshotPriceInterval = 'snapshot_price_interval',
  /** column name */
  SnapshotPriceIntervalUnit = 'snapshot_price_interval_unit',
  /** column name */
  SnapshotTimeLimit = 'snapshot_time_limit',
  /** column name */
  SnapshotTimeLimitUnit = 'snapshot_time_limit_unit',
  /** column name */
  Source = 'source',
  /** column name */
  Time = 'time',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Parkable_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parkable_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parkable_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parkable_Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parkable_Transactions_Var_Pop_Fields = {
  __typename?: 'parkable_transactions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parkable_transactions" */
export type Parkable_Transactions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parkable_Transactions_Var_Samp_Fields = {
  __typename?: 'parkable_transactions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parkable_transactions" */
export type Parkable_Transactions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parkable_Transactions_Variance_Fields = {
  __typename?: 'parkable_transactions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_active_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parkable_transactions" */
export type Parkable_Transactions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  legacy_active_parkable_transaction_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "parkables" */
export type Parkables = {
  __typename?: 'parkables';
  created_at: Scalars['timestamp']['output'];
  data?: Maybe<Scalars['json']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['bigint']['output'];
  identifier: Scalars['Int']['output'];
  last_survey_at?: Maybe<Scalars['timestamp']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  parkable_parkable_groups: Array<Parkable_Parkable_Group>;
  /** An aggregate relationship */
  parkable_parkable_groups_aggregate: Parkable_Parkable_Group_Aggregate;
  /** An array relationship */
  parkable_qr_codes: Array<Parkable_Qr_Code>;
  /** An aggregate relationship */
  parkable_qr_codes_aggregate: Parkable_Qr_Code_Aggregate;
  /** An array relationship */
  parkable_transactions: Array<Parkable_Transactions>;
  /** An aggregate relationship */
  parkable_transactions_aggregate: Parkable_Transactions_Aggregate;
  /** An object relationship */
  parking_authority: Parking_Authorities;
  parking_authority_id: Scalars['bigint']['output'];
  price: Scalars['Int']['output'];
  price_interval: Scalars['Int']['output'];
  price_interval_unit: Scalars['String']['output'];
  raw_import_data?: Maybe<Scalars['json']['output']>;
  survey_data?: Maybe<Scalars['json']['output']>;
  time_limit: Scalars['Int']['output'];
  time_limit_unit: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "parkables" */
export type ParkablesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "parkables" */
export type ParkablesParkable_Parkable_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Parkable_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Parkable_Group_Order_By>>;
  where?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
};


/** columns and relationships of "parkables" */
export type ParkablesParkable_Parkable_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Parkable_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Parkable_Group_Order_By>>;
  where?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
};


/** columns and relationships of "parkables" */
export type ParkablesParkable_Qr_CodesArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Qr_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Qr_Code_Order_By>>;
  where?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
};


/** columns and relationships of "parkables" */
export type ParkablesParkable_Qr_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Qr_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Qr_Code_Order_By>>;
  where?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
};


/** columns and relationships of "parkables" */
export type ParkablesParkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


/** columns and relationships of "parkables" */
export type ParkablesParkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


/** columns and relationships of "parkables" */
export type ParkablesRaw_Import_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "parkables" */
export type ParkablesSurvey_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "parkables" */
export type Parkables_Aggregate = {
  __typename?: 'parkables_aggregate';
  aggregate?: Maybe<Parkables_Aggregate_Fields>;
  nodes: Array<Parkables>;
};

export type Parkables_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Parkables_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Parkables_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Parkables_Aggregate_Bool_Exp_Count>;
};

export type Parkables_Aggregate_Bool_Exp_Bool_And = {
  arguments: Parkables_Select_Column_Parkables_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkables_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parkables_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Parkables_Select_Column_Parkables_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkables_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parkables_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parkables_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parkables_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parkables" */
export type Parkables_Aggregate_Fields = {
  __typename?: 'parkables_aggregate_fields';
  avg?: Maybe<Parkables_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parkables_Max_Fields>;
  min?: Maybe<Parkables_Min_Fields>;
  stddev?: Maybe<Parkables_Stddev_Fields>;
  stddev_pop?: Maybe<Parkables_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parkables_Stddev_Samp_Fields>;
  sum?: Maybe<Parkables_Sum_Fields>;
  var_pop?: Maybe<Parkables_Var_Pop_Fields>;
  var_samp?: Maybe<Parkables_Var_Samp_Fields>;
  variance?: Maybe<Parkables_Variance_Fields>;
};


/** aggregate fields of "parkables" */
export type Parkables_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parkables_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parkables" */
export type Parkables_Aggregate_Order_By = {
  avg?: InputMaybe<Parkables_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parkables_Max_Order_By>;
  min?: InputMaybe<Parkables_Min_Order_By>;
  stddev?: InputMaybe<Parkables_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parkables_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parkables_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parkables_Sum_Order_By>;
  var_pop?: InputMaybe<Parkables_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parkables_Var_Samp_Order_By>;
  variance?: InputMaybe<Parkables_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parkables" */
export type Parkables_Arr_Rel_Insert_Input = {
  data: Array<Parkables_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkables_On_Conflict>;
};

/** aggregate avg on columns */
export type Parkables_Avg_Fields = {
  __typename?: 'parkables_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identifier?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price_interval?: Maybe<Scalars['Float']['output']>;
  time_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parkables" */
export type Parkables_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parkables". All fields are combined with a logical 'AND'. */
export type Parkables_Bool_Exp = {
  _and?: InputMaybe<Array<Parkables_Bool_Exp>>;
  _not?: InputMaybe<Parkables_Bool_Exp>;
  _or?: InputMaybe<Array<Parkables_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  identifier?: InputMaybe<Int_Comparison_Exp>;
  last_survey_at?: InputMaybe<Timestamp_Comparison_Exp>;
  latitude?: InputMaybe<String_Comparison_Exp>;
  longitude?: InputMaybe<String_Comparison_Exp>;
  parkable_parkable_groups?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
  parkable_parkable_groups_aggregate?: InputMaybe<Parkable_Parkable_Group_Aggregate_Bool_Exp>;
  parkable_qr_codes?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
  parkable_qr_codes_aggregate?: InputMaybe<Parkable_Qr_Code_Aggregate_Bool_Exp>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  parkable_transactions_aggregate?: InputMaybe<Parkable_Transactions_Aggregate_Bool_Exp>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  price_interval?: InputMaybe<Int_Comparison_Exp>;
  price_interval_unit?: InputMaybe<String_Comparison_Exp>;
  raw_import_data?: InputMaybe<Json_Comparison_Exp>;
  survey_data?: InputMaybe<Json_Comparison_Exp>;
  time_limit?: InputMaybe<Int_Comparison_Exp>;
  time_limit_unit?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "parkables" */
export enum Parkables_Constraint {
  /** unique or primary key constraint on columns "parking_authority_id", "identifier" */
  ParkablesParkingAuthorityIdIdentifierUnique = 'parkables_parking_authority_id_identifier_unique',
  /** unique or primary key constraint on columns "id" */
  ParkablesPkey = 'parkables_pkey'
}

/** input type for incrementing numeric columns in table "parkables" */
export type Parkables_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  identifier?: InputMaybe<Scalars['Int']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  price_interval?: InputMaybe<Scalars['Int']['input']>;
  time_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "parkables" */
export type Parkables_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  identifier?: InputMaybe<Scalars['Int']['input']>;
  last_survey_at?: InputMaybe<Scalars['timestamp']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  parkable_parkable_groups?: InputMaybe<Parkable_Parkable_Group_Arr_Rel_Insert_Input>;
  parkable_qr_codes?: InputMaybe<Parkable_Qr_Code_Arr_Rel_Insert_Input>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Arr_Rel_Insert_Input>;
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  price_interval?: InputMaybe<Scalars['Int']['input']>;
  price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  raw_import_data?: InputMaybe<Scalars['json']['input']>;
  survey_data?: InputMaybe<Scalars['json']['input']>;
  time_limit?: InputMaybe<Scalars['Int']['input']>;
  time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Parkables_Max_Fields = {
  __typename?: 'parkables_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  identifier?: Maybe<Scalars['Int']['output']>;
  last_survey_at?: Maybe<Scalars['timestamp']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  price_interval?: Maybe<Scalars['Int']['output']>;
  price_interval_unit?: Maybe<Scalars['String']['output']>;
  time_limit?: Maybe<Scalars['Int']['output']>;
  time_limit_unit?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "parkables" */
export type Parkables_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  last_survey_at?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  price_interval_unit?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
  time_limit_unit?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parkables_Min_Fields = {
  __typename?: 'parkables_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  identifier?: Maybe<Scalars['Int']['output']>;
  last_survey_at?: Maybe<Scalars['timestamp']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  price_interval?: Maybe<Scalars['Int']['output']>;
  price_interval_unit?: Maybe<Scalars['String']['output']>;
  time_limit?: Maybe<Scalars['Int']['output']>;
  time_limit_unit?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "parkables" */
export type Parkables_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  last_survey_at?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  price_interval_unit?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
  time_limit_unit?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parkables" */
export type Parkables_Mutation_Response = {
  __typename?: 'parkables_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parkables>;
};

/** input type for inserting object relation for remote table "parkables" */
export type Parkables_Obj_Rel_Insert_Input = {
  data: Parkables_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parkables_On_Conflict>;
};

/** on_conflict condition type for table "parkables" */
export type Parkables_On_Conflict = {
  constraint: Parkables_Constraint;
  update_columns?: Array<Parkables_Update_Column>;
  where?: InputMaybe<Parkables_Bool_Exp>;
};

/** Ordering options when selecting data from "parkables". */
export type Parkables_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  last_survey_at?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  parkable_parkable_groups_aggregate?: InputMaybe<Parkable_Parkable_Group_Aggregate_Order_By>;
  parkable_qr_codes_aggregate?: InputMaybe<Parkable_Qr_Code_Aggregate_Order_By>;
  parkable_transactions_aggregate?: InputMaybe<Parkable_Transactions_Aggregate_Order_By>;
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  price_interval_unit?: InputMaybe<Order_By>;
  raw_import_data?: InputMaybe<Order_By>;
  survey_data?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
  time_limit_unit?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parkables */
export type Parkables_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "parkables" */
export enum Parkables_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  LastSurveyAt = 'last_survey_at',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceInterval = 'price_interval',
  /** column name */
  PriceIntervalUnit = 'price_interval_unit',
  /** column name */
  RawImportData = 'raw_import_data',
  /** column name */
  SurveyData = 'survey_data',
  /** column name */
  TimeLimit = 'time_limit',
  /** column name */
  TimeLimitUnit = 'time_limit_unit',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "parkables_aggregate_bool_exp_bool_and_arguments_columns" columns of table "parkables" */
export enum Parkables_Select_Column_Parkables_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Enabled = 'enabled'
}

/** select "parkables_aggregate_bool_exp_bool_or_arguments_columns" columns of table "parkables" */
export enum Parkables_Select_Column_Parkables_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Enabled = 'enabled'
}

/** input type for updating data in table "parkables" */
export type Parkables_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  identifier?: InputMaybe<Scalars['Int']['input']>;
  last_survey_at?: InputMaybe<Scalars['timestamp']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  price_interval?: InputMaybe<Scalars['Int']['input']>;
  price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  raw_import_data?: InputMaybe<Scalars['json']['input']>;
  survey_data?: InputMaybe<Scalars['json']['input']>;
  time_limit?: InputMaybe<Scalars['Int']['input']>;
  time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Parkables_Stddev_Fields = {
  __typename?: 'parkables_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identifier?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price_interval?: Maybe<Scalars['Float']['output']>;
  time_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parkables" */
export type Parkables_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parkables_Stddev_Pop_Fields = {
  __typename?: 'parkables_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identifier?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price_interval?: Maybe<Scalars['Float']['output']>;
  time_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parkables" */
export type Parkables_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parkables_Stddev_Samp_Fields = {
  __typename?: 'parkables_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identifier?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price_interval?: Maybe<Scalars['Float']['output']>;
  time_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parkables" */
export type Parkables_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parkables" */
export type Parkables_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parkables_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parkables_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  identifier?: InputMaybe<Scalars['Int']['input']>;
  last_survey_at?: InputMaybe<Scalars['timestamp']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  price_interval?: InputMaybe<Scalars['Int']['input']>;
  price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  raw_import_data?: InputMaybe<Scalars['json']['input']>;
  survey_data?: InputMaybe<Scalars['json']['input']>;
  time_limit?: InputMaybe<Scalars['Int']['input']>;
  time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Parkables_Sum_Fields = {
  __typename?: 'parkables_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  identifier?: Maybe<Scalars['Int']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  price_interval?: Maybe<Scalars['Int']['output']>;
  time_limit?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "parkables" */
export type Parkables_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
};

/** update columns of table "parkables" */
export enum Parkables_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  LastSurveyAt = 'last_survey_at',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceInterval = 'price_interval',
  /** column name */
  PriceIntervalUnit = 'price_interval_unit',
  /** column name */
  RawImportData = 'raw_import_data',
  /** column name */
  SurveyData = 'survey_data',
  /** column name */
  TimeLimit = 'time_limit',
  /** column name */
  TimeLimitUnit = 'time_limit_unit',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Parkables_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parkables_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parkables_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parkables_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parkables_Var_Pop_Fields = {
  __typename?: 'parkables_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identifier?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price_interval?: Maybe<Scalars['Float']['output']>;
  time_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parkables" */
export type Parkables_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parkables_Var_Samp_Fields = {
  __typename?: 'parkables_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identifier?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price_interval?: Maybe<Scalars['Float']['output']>;
  time_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parkables" */
export type Parkables_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parkables_Variance_Fields = {
  __typename?: 'parkables_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identifier?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price_interval?: Maybe<Scalars['Float']['output']>;
  time_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parkables" */
export type Parkables_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_interval?: InputMaybe<Order_By>;
  time_limit?: InputMaybe<Order_By>;
};

/** columns and relationships of "parking_authorities" */
export type Parking_Authorities = {
  __typename?: 'parking_authorities';
  /** An array relationship */
  ad_campaign_parking_authorities: Array<Ad_Campaign_Parking_Authority>;
  /** An aggregate relationship */
  ad_campaign_parking_authorities_aggregate: Ad_Campaign_Parking_Authority_Aggregate;
  address_street_1?: Maybe<Scalars['String']['output']>;
  address_street_2?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  admin_user_parking_authorities: Array<Admin_User_Parking_Authority>;
  /** An aggregate relationship */
  admin_user_parking_authorities_aggregate: Admin_User_Parking_Authority_Aggregate;
  app_url?: Maybe<Scalars['String']['output']>;
  card_fee: Scalars['smallint']['output'];
  city?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_first_name: Scalars['String']['output'];
  contact_last_name: Scalars['String']['output'];
  contact_phone_number?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  line_items: Array<Line_Items>;
  /** An aggregate relationship */
  line_items_aggregate: Line_Items_Aggregate;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  name: Scalars['String']['output'];
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  parkable_groups: Array<Parkable_Groups>;
  /** An aggregate relationship */
  parkable_groups_aggregate: Parkable_Groups_Aggregate;
  /** An array relationship */
  parkable_schedules: Array<Parkable_Schedules>;
  /** An aggregate relationship */
  parkable_schedules_aggregate: Parkable_Schedules_Aggregate;
  /** An array relationship */
  parkables: Array<Parkables>;
  /** An aggregate relationship */
  parkables_aggregate: Parkables_Aggregate;
  /** An array relationship */
  parking_authority_bank_accounts: Array<Parking_Authority_Bank_Accounts>;
  /** An aggregate relationship */
  parking_authority_bank_accounts_aggregate: Parking_Authority_Bank_Accounts_Aggregate;
  /** An array relationship */
  parking_authority_settings: Array<Parking_Authority_Settings>;
  /** An aggregate relationship */
  parking_authority_settings_aggregate: Parking_Authority_Settings_Aggregate;
  /** An array relationship */
  parking_authority_users: Array<Parking_Authority_User>;
  /** An aggregate relationship */
  parking_authority_users_aggregate: Parking_Authority_User_Aggregate;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  /** An array relationship */
  transfer_batches: Array<Transfer_Batches>;
  /** An aggregate relationship */
  transfer_batches_aggregate: Transfer_Batches_Aggregate;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  upsafety_client_id?: Maybe<Scalars['String']['output']>;
  wallet_fee: Scalars['smallint']['output'];
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesAd_Campaign_Parking_AuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesAd_Campaign_Parking_Authorities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesAdmin_User_Parking_AuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<Admin_User_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_User_Parking_Authority_Order_By>>;
  where?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesAdmin_User_Parking_Authorities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_User_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_User_Parking_Authority_Order_By>>;
  where?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesLine_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Items_Order_By>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesLine_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Items_Order_By>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParkable_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Groups_Order_By>>;
  where?: InputMaybe<Parkable_Groups_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParkable_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Groups_Order_By>>;
  where?: InputMaybe<Parkable_Groups_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParkable_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Schedules_Order_By>>;
  where?: InputMaybe<Parkable_Schedules_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParkable_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Schedules_Order_By>>;
  where?: InputMaybe<Parkable_Schedules_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParkablesArgs = {
  distinct_on?: InputMaybe<Array<Parkables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkables_Order_By>>;
  where?: InputMaybe<Parkables_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParkables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkables_Order_By>>;
  where?: InputMaybe<Parkables_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParking_Authority_Bank_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Order_By>>;
  where?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParking_Authority_Bank_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Order_By>>;
  where?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParking_Authority_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Settings_Order_By>>;
  where?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParking_Authority_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Settings_Order_By>>;
  where?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParking_Authority_UsersArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_User_Order_By>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesParking_Authority_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_User_Order_By>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesTransfer_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transfer_Batches_Order_By>>;
  where?: InputMaybe<Transfer_Batches_Bool_Exp>;
};


/** columns and relationships of "parking_authorities" */
export type Parking_AuthoritiesTransfer_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transfer_Batches_Order_By>>;
  where?: InputMaybe<Transfer_Batches_Bool_Exp>;
};

/** aggregated selection of "parking_authorities" */
export type Parking_Authorities_Aggregate = {
  __typename?: 'parking_authorities_aggregate';
  aggregate?: Maybe<Parking_Authorities_Aggregate_Fields>;
  nodes: Array<Parking_Authorities>;
};

/** aggregate fields of "parking_authorities" */
export type Parking_Authorities_Aggregate_Fields = {
  __typename?: 'parking_authorities_aggregate_fields';
  avg?: Maybe<Parking_Authorities_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parking_Authorities_Max_Fields>;
  min?: Maybe<Parking_Authorities_Min_Fields>;
  stddev?: Maybe<Parking_Authorities_Stddev_Fields>;
  stddev_pop?: Maybe<Parking_Authorities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parking_Authorities_Stddev_Samp_Fields>;
  sum?: Maybe<Parking_Authorities_Sum_Fields>;
  var_pop?: Maybe<Parking_Authorities_Var_Pop_Fields>;
  var_samp?: Maybe<Parking_Authorities_Var_Samp_Fields>;
  variance?: Maybe<Parking_Authorities_Variance_Fields>;
};


/** aggregate fields of "parking_authorities" */
export type Parking_Authorities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parking_Authorities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Parking_Authorities_Avg_Fields = {
  __typename?: 'parking_authorities_avg_fields';
  card_fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  wallet_fee?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "parking_authorities". All fields are combined with a logical 'AND'. */
export type Parking_Authorities_Bool_Exp = {
  _and?: InputMaybe<Array<Parking_Authorities_Bool_Exp>>;
  _not?: InputMaybe<Parking_Authorities_Bool_Exp>;
  _or?: InputMaybe<Array<Parking_Authorities_Bool_Exp>>;
  ad_campaign_parking_authorities?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
  ad_campaign_parking_authorities_aggregate?: InputMaybe<Ad_Campaign_Parking_Authority_Aggregate_Bool_Exp>;
  address_street_1?: InputMaybe<String_Comparison_Exp>;
  address_street_2?: InputMaybe<String_Comparison_Exp>;
  admin_user_parking_authorities?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
  admin_user_parking_authorities_aggregate?: InputMaybe<Admin_User_Parking_Authority_Aggregate_Bool_Exp>;
  app_url?: InputMaybe<String_Comparison_Exp>;
  card_fee?: InputMaybe<Smallint_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_first_name?: InputMaybe<String_Comparison_Exp>;
  contact_last_name?: InputMaybe<String_Comparison_Exp>;
  contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  line_items?: InputMaybe<Line_Items_Bool_Exp>;
  line_items_aggregate?: InputMaybe<Line_Items_Aggregate_Bool_Exp>;
  mxm_customer_id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  num_etl_failures?: InputMaybe<Smallint_Comparison_Exp>;
  num_etls?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_groups?: InputMaybe<Parkable_Groups_Bool_Exp>;
  parkable_groups_aggregate?: InputMaybe<Parkable_Groups_Aggregate_Bool_Exp>;
  parkable_schedules?: InputMaybe<Parkable_Schedules_Bool_Exp>;
  parkable_schedules_aggregate?: InputMaybe<Parkable_Schedules_Aggregate_Bool_Exp>;
  parkables?: InputMaybe<Parkables_Bool_Exp>;
  parkables_aggregate?: InputMaybe<Parkables_Aggregate_Bool_Exp>;
  parking_authority_bank_accounts?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
  parking_authority_bank_accounts_aggregate?: InputMaybe<Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp>;
  parking_authority_settings?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
  parking_authority_settings_aggregate?: InputMaybe<Parking_Authority_Settings_Aggregate_Bool_Exp>;
  parking_authority_users?: InputMaybe<Parking_Authority_User_Bool_Exp>;
  parking_authority_users_aggregate?: InputMaybe<Parking_Authority_User_Aggregate_Bool_Exp>;
  postal_code?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  transfer_batches?: InputMaybe<Transfer_Batches_Bool_Exp>;
  transfer_batches_aggregate?: InputMaybe<Transfer_Batches_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  upsafety_client_id?: InputMaybe<String_Comparison_Exp>;
  wallet_fee?: InputMaybe<Smallint_Comparison_Exp>;
};

/** unique or primary key constraints on table "parking_authorities" */
export enum Parking_Authorities_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParkingAuthoritiesPkey = 'parking_authorities_pkey'
}

/** input type for incrementing numeric columns in table "parking_authorities" */
export type Parking_Authorities_Inc_Input = {
  card_fee?: InputMaybe<Scalars['smallint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  wallet_fee?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "parking_authorities" */
export type Parking_Authorities_Insert_Input = {
  ad_campaign_parking_authorities?: InputMaybe<Ad_Campaign_Parking_Authority_Arr_Rel_Insert_Input>;
  address_street_1?: InputMaybe<Scalars['String']['input']>;
  address_street_2?: InputMaybe<Scalars['String']['input']>;
  admin_user_parking_authorities?: InputMaybe<Admin_User_Parking_Authority_Arr_Rel_Insert_Input>;
  app_url?: InputMaybe<Scalars['String']['input']>;
  card_fee?: InputMaybe<Scalars['smallint']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_first_name?: InputMaybe<Scalars['String']['input']>;
  contact_last_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  line_items?: InputMaybe<Line_Items_Arr_Rel_Insert_Input>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parkable_groups?: InputMaybe<Parkable_Groups_Arr_Rel_Insert_Input>;
  parkable_schedules?: InputMaybe<Parkable_Schedules_Arr_Rel_Insert_Input>;
  parkables?: InputMaybe<Parkables_Arr_Rel_Insert_Input>;
  parking_authority_bank_accounts?: InputMaybe<Parking_Authority_Bank_Accounts_Arr_Rel_Insert_Input>;
  parking_authority_settings?: InputMaybe<Parking_Authority_Settings_Arr_Rel_Insert_Input>;
  parking_authority_users?: InputMaybe<Parking_Authority_User_Arr_Rel_Insert_Input>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  transfer_batches?: InputMaybe<Transfer_Batches_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  upsafety_client_id?: InputMaybe<Scalars['String']['input']>;
  wallet_fee?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate max on columns */
export type Parking_Authorities_Max_Fields = {
  __typename?: 'parking_authorities_max_fields';
  address_street_1?: Maybe<Scalars['String']['output']>;
  address_street_2?: Maybe<Scalars['String']['output']>;
  app_url?: Maybe<Scalars['String']['output']>;
  card_fee?: Maybe<Scalars['smallint']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_first_name?: Maybe<Scalars['String']['output']>;
  contact_last_name?: Maybe<Scalars['String']['output']>;
  contact_phone_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  upsafety_client_id?: Maybe<Scalars['String']['output']>;
  wallet_fee?: Maybe<Scalars['smallint']['output']>;
};

/** aggregate min on columns */
export type Parking_Authorities_Min_Fields = {
  __typename?: 'parking_authorities_min_fields';
  address_street_1?: Maybe<Scalars['String']['output']>;
  address_street_2?: Maybe<Scalars['String']['output']>;
  app_url?: Maybe<Scalars['String']['output']>;
  card_fee?: Maybe<Scalars['smallint']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_first_name?: Maybe<Scalars['String']['output']>;
  contact_last_name?: Maybe<Scalars['String']['output']>;
  contact_phone_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  upsafety_client_id?: Maybe<Scalars['String']['output']>;
  wallet_fee?: Maybe<Scalars['smallint']['output']>;
};

/** response of any mutation on the table "parking_authorities" */
export type Parking_Authorities_Mutation_Response = {
  __typename?: 'parking_authorities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parking_Authorities>;
};

/** input type for inserting object relation for remote table "parking_authorities" */
export type Parking_Authorities_Obj_Rel_Insert_Input = {
  data: Parking_Authorities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parking_Authorities_On_Conflict>;
};

/** on_conflict condition type for table "parking_authorities" */
export type Parking_Authorities_On_Conflict = {
  constraint: Parking_Authorities_Constraint;
  update_columns?: Array<Parking_Authorities_Update_Column>;
  where?: InputMaybe<Parking_Authorities_Bool_Exp>;
};

/** Ordering options when selecting data from "parking_authorities". */
export type Parking_Authorities_Order_By = {
  ad_campaign_parking_authorities_aggregate?: InputMaybe<Ad_Campaign_Parking_Authority_Aggregate_Order_By>;
  address_street_1?: InputMaybe<Order_By>;
  address_street_2?: InputMaybe<Order_By>;
  admin_user_parking_authorities_aggregate?: InputMaybe<Admin_User_Parking_Authority_Aggregate_Order_By>;
  app_url?: InputMaybe<Order_By>;
  card_fee?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_first_name?: InputMaybe<Order_By>;
  contact_last_name?: InputMaybe<Order_By>;
  contact_phone_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  line_items_aggregate?: InputMaybe<Line_Items_Aggregate_Order_By>;
  mxm_customer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parkable_groups_aggregate?: InputMaybe<Parkable_Groups_Aggregate_Order_By>;
  parkable_schedules_aggregate?: InputMaybe<Parkable_Schedules_Aggregate_Order_By>;
  parkables_aggregate?: InputMaybe<Parkables_Aggregate_Order_By>;
  parking_authority_bank_accounts_aggregate?: InputMaybe<Parking_Authority_Bank_Accounts_Aggregate_Order_By>;
  parking_authority_settings_aggregate?: InputMaybe<Parking_Authority_Settings_Aggregate_Order_By>;
  parking_authority_users_aggregate?: InputMaybe<Parking_Authority_User_Aggregate_Order_By>;
  postal_code?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  transfer_batches_aggregate?: InputMaybe<Transfer_Batches_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upsafety_client_id?: InputMaybe<Order_By>;
  wallet_fee?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parking_authorities */
export type Parking_Authorities_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "parking_authorities" */
export enum Parking_Authorities_Select_Column {
  /** column name */
  AddressStreet_1 = 'address_street_1',
  /** column name */
  AddressStreet_2 = 'address_street_2',
  /** column name */
  AppUrl = 'app_url',
  /** column name */
  CardFee = 'card_fee',
  /** column name */
  City = 'city',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactFirstName = 'contact_first_name',
  /** column name */
  ContactLastName = 'contact_last_name',
  /** column name */
  ContactPhoneNumber = 'contact_phone_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  MxmCustomerId = 'mxm_customer_id',
  /** column name */
  Name = 'name',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  State = 'state',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpsafetyClientId = 'upsafety_client_id',
  /** column name */
  WalletFee = 'wallet_fee'
}

/** input type for updating data in table "parking_authorities" */
export type Parking_Authorities_Set_Input = {
  address_street_1?: InputMaybe<Scalars['String']['input']>;
  address_street_2?: InputMaybe<Scalars['String']['input']>;
  app_url?: InputMaybe<Scalars['String']['input']>;
  card_fee?: InputMaybe<Scalars['smallint']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_first_name?: InputMaybe<Scalars['String']['input']>;
  contact_last_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  upsafety_client_id?: InputMaybe<Scalars['String']['input']>;
  wallet_fee?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate stddev on columns */
export type Parking_Authorities_Stddev_Fields = {
  __typename?: 'parking_authorities_stddev_fields';
  card_fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  wallet_fee?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Parking_Authorities_Stddev_Pop_Fields = {
  __typename?: 'parking_authorities_stddev_pop_fields';
  card_fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  wallet_fee?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Parking_Authorities_Stddev_Samp_Fields = {
  __typename?: 'parking_authorities_stddev_samp_fields';
  card_fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  wallet_fee?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "parking_authorities" */
export type Parking_Authorities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parking_Authorities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parking_Authorities_Stream_Cursor_Value_Input = {
  address_street_1?: InputMaybe<Scalars['String']['input']>;
  address_street_2?: InputMaybe<Scalars['String']['input']>;
  app_url?: InputMaybe<Scalars['String']['input']>;
  card_fee?: InputMaybe<Scalars['smallint']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_first_name?: InputMaybe<Scalars['String']['input']>;
  contact_last_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  upsafety_client_id?: InputMaybe<Scalars['String']['input']>;
  wallet_fee?: InputMaybe<Scalars['smallint']['input']>;
};

/** aggregate sum on columns */
export type Parking_Authorities_Sum_Fields = {
  __typename?: 'parking_authorities_sum_fields';
  card_fee?: Maybe<Scalars['smallint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  wallet_fee?: Maybe<Scalars['smallint']['output']>;
};

/** update columns of table "parking_authorities" */
export enum Parking_Authorities_Update_Column {
  /** column name */
  AddressStreet_1 = 'address_street_1',
  /** column name */
  AddressStreet_2 = 'address_street_2',
  /** column name */
  AppUrl = 'app_url',
  /** column name */
  CardFee = 'card_fee',
  /** column name */
  City = 'city',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactFirstName = 'contact_first_name',
  /** column name */
  ContactLastName = 'contact_last_name',
  /** column name */
  ContactPhoneNumber = 'contact_phone_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  MxmCustomerId = 'mxm_customer_id',
  /** column name */
  Name = 'name',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  State = 'state',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpsafetyClientId = 'upsafety_client_id',
  /** column name */
  WalletFee = 'wallet_fee'
}

export type Parking_Authorities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parking_Authorities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parking_Authorities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parking_Authorities_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parking_Authorities_Var_Pop_Fields = {
  __typename?: 'parking_authorities_var_pop_fields';
  card_fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  wallet_fee?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Parking_Authorities_Var_Samp_Fields = {
  __typename?: 'parking_authorities_var_samp_fields';
  card_fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  wallet_fee?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Parking_Authorities_Variance_Fields = {
  __typename?: 'parking_authorities_variance_fields';
  card_fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  wallet_fee?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts = {
  __typename?: 'parking_authority_bank_accounts';
  alias?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  default: Scalars['Boolean']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  idempotent_key: Scalars['String']['output'];
  /** An object relationship */
  mx_merchant_pa_bank_account_meta?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas>;
  /** An object relationship */
  parking_authority: Parking_Authorities;
  parking_authority_id: Scalars['bigint']['output'];
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_AccountsPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_AccountsPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** aggregated selection of "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Aggregate = {
  __typename?: 'parking_authority_bank_accounts_aggregate';
  aggregate?: Maybe<Parking_Authority_Bank_Accounts_Aggregate_Fields>;
  nodes: Array<Parking_Authority_Bank_Accounts>;
};

export type Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp_Count>;
};

export type Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Parking_Authority_Bank_Accounts_Select_Column_Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Parking_Authority_Bank_Accounts_Select_Column_Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Aggregate_Fields = {
  __typename?: 'parking_authority_bank_accounts_aggregate_fields';
  avg?: Maybe<Parking_Authority_Bank_Accounts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parking_Authority_Bank_Accounts_Max_Fields>;
  min?: Maybe<Parking_Authority_Bank_Accounts_Min_Fields>;
  stddev?: Maybe<Parking_Authority_Bank_Accounts_Stddev_Fields>;
  stddev_pop?: Maybe<Parking_Authority_Bank_Accounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parking_Authority_Bank_Accounts_Stddev_Samp_Fields>;
  sum?: Maybe<Parking_Authority_Bank_Accounts_Sum_Fields>;
  var_pop?: Maybe<Parking_Authority_Bank_Accounts_Var_Pop_Fields>;
  var_samp?: Maybe<Parking_Authority_Bank_Accounts_Var_Samp_Fields>;
  variance?: Maybe<Parking_Authority_Bank_Accounts_Variance_Fields>;
};


/** aggregate fields of "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Aggregate_Order_By = {
  avg?: InputMaybe<Parking_Authority_Bank_Accounts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parking_Authority_Bank_Accounts_Max_Order_By>;
  min?: InputMaybe<Parking_Authority_Bank_Accounts_Min_Order_By>;
  stddev?: InputMaybe<Parking_Authority_Bank_Accounts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parking_Authority_Bank_Accounts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parking_Authority_Bank_Accounts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parking_Authority_Bank_Accounts_Sum_Order_By>;
  var_pop?: InputMaybe<Parking_Authority_Bank_Accounts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parking_Authority_Bank_Accounts_Var_Samp_Order_By>;
  variance?: InputMaybe<Parking_Authority_Bank_Accounts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Arr_Rel_Insert_Input = {
  data: Array<Parking_Authority_Bank_Accounts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parking_Authority_Bank_Accounts_On_Conflict>;
};

/** aggregate avg on columns */
export type Parking_Authority_Bank_Accounts_Avg_Fields = {
  __typename?: 'parking_authority_bank_accounts_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parking_authority_bank_accounts". All fields are combined with a logical 'AND'. */
export type Parking_Authority_Bank_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Bool_Exp>>;
  alias?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  default?: InputMaybe<Boolean_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<String_Comparison_Exp>;
  mx_merchant_pa_bank_account_meta?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "parking_authority_bank_accounts" */
export enum Parking_Authority_Bank_Accounts_Constraint {
  /** unique or primary key constraint on columns "idempotent_key" */
  ParkingAuthorityBankAccountsIdempotentKeyUnique = 'parking_authority_bank_accounts_idempotent_key_unique',
  /** unique or primary key constraint on columns "id" */
  ParkingAuthorityBankAccountsPkey = 'parking_authority_bank_accounts_pkey'
}

/** input type for incrementing numeric columns in table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Insert_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  mx_merchant_pa_bank_account_meta?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Obj_Rel_Insert_Input>;
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Parking_Authority_Bank_Accounts_Max_Fields = {
  __typename?: 'parking_authority_bank_accounts_max_fields';
  alias?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['String']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Max_Order_By = {
  alias?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parking_Authority_Bank_Accounts_Min_Fields = {
  __typename?: 'parking_authority_bank_accounts_min_fields';
  alias?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['String']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Min_Order_By = {
  alias?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Mutation_Response = {
  __typename?: 'parking_authority_bank_accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parking_Authority_Bank_Accounts>;
};

/** input type for inserting object relation for remote table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Obj_Rel_Insert_Input = {
  data: Parking_Authority_Bank_Accounts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parking_Authority_Bank_Accounts_On_Conflict>;
};

/** on_conflict condition type for table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_On_Conflict = {
  constraint: Parking_Authority_Bank_Accounts_Constraint;
  update_columns?: Array<Parking_Authority_Bank_Accounts_Update_Column>;
  where?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "parking_authority_bank_accounts". */
export type Parking_Authority_Bank_Accounts_Order_By = {
  alias?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  mx_merchant_pa_bank_account_meta?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Order_By>;
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parking_authority_bank_accounts */
export type Parking_Authority_Bank_Accounts_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "parking_authority_bank_accounts" */
export enum Parking_Authority_Bank_Accounts_Select_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Default = 'default',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "parking_authority_bank_accounts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "parking_authority_bank_accounts" */
export enum Parking_Authority_Bank_Accounts_Select_Column_Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Default = 'default'
}

/** select "parking_authority_bank_accounts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "parking_authority_bank_accounts" */
export enum Parking_Authority_Bank_Accounts_Select_Column_Parking_Authority_Bank_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Default = 'default'
}

/** input type for updating data in table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Set_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Parking_Authority_Bank_Accounts_Stddev_Fields = {
  __typename?: 'parking_authority_bank_accounts_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parking_Authority_Bank_Accounts_Stddev_Pop_Fields = {
  __typename?: 'parking_authority_bank_accounts_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parking_Authority_Bank_Accounts_Stddev_Samp_Fields = {
  __typename?: 'parking_authority_bank_accounts_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parking_Authority_Bank_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parking_Authority_Bank_Accounts_Stream_Cursor_Value_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Parking_Authority_Bank_Accounts_Sum_Fields = {
  __typename?: 'parking_authority_bank_accounts_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** update columns of table "parking_authority_bank_accounts" */
export enum Parking_Authority_Bank_Accounts_Update_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Default = 'default',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Parking_Authority_Bank_Accounts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parking_Authority_Bank_Accounts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parking_Authority_Bank_Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parking_Authority_Bank_Accounts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parking_Authority_Bank_Accounts_Var_Pop_Fields = {
  __typename?: 'parking_authority_bank_accounts_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parking_Authority_Bank_Accounts_Var_Samp_Fields = {
  __typename?: 'parking_authority_bank_accounts_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parking_Authority_Bank_Accounts_Variance_Fields = {
  __typename?: 'parking_authority_bank_accounts_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parking_authority_bank_accounts" */
export type Parking_Authority_Bank_Accounts_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "parking_authority_settings" */
export type Parking_Authority_Settings = {
  __typename?: 'parking_authority_settings';
  auto_approve_transfers?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  parkable_time_limits_enforce_mode?: Maybe<Scalars['String']['output']>;
  parkable_time_limits_max_interval_round_behavior?: Maybe<Scalars['String']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  parking_authority: Parking_Authorities;
  parking_authority_id: Scalars['bigint']['output'];
  transfer_delay_hours?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "parking_authority_settings" */
export type Parking_Authority_Settings_Aggregate = {
  __typename?: 'parking_authority_settings_aggregate';
  aggregate?: Maybe<Parking_Authority_Settings_Aggregate_Fields>;
  nodes: Array<Parking_Authority_Settings>;
};

export type Parking_Authority_Settings_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Parking_Authority_Settings_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Parking_Authority_Settings_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Parking_Authority_Settings_Aggregate_Bool_Exp_Count>;
};

export type Parking_Authority_Settings_Aggregate_Bool_Exp_Bool_And = {
  arguments: Parking_Authority_Settings_Select_Column_Parking_Authority_Settings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parking_Authority_Settings_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Parking_Authority_Settings_Select_Column_Parking_Authority_Settings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parking_Authority_Settings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parking_Authority_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parking_authority_settings" */
export type Parking_Authority_Settings_Aggregate_Fields = {
  __typename?: 'parking_authority_settings_aggregate_fields';
  avg?: Maybe<Parking_Authority_Settings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parking_Authority_Settings_Max_Fields>;
  min?: Maybe<Parking_Authority_Settings_Min_Fields>;
  stddev?: Maybe<Parking_Authority_Settings_Stddev_Fields>;
  stddev_pop?: Maybe<Parking_Authority_Settings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parking_Authority_Settings_Stddev_Samp_Fields>;
  sum?: Maybe<Parking_Authority_Settings_Sum_Fields>;
  var_pop?: Maybe<Parking_Authority_Settings_Var_Pop_Fields>;
  var_samp?: Maybe<Parking_Authority_Settings_Var_Samp_Fields>;
  variance?: Maybe<Parking_Authority_Settings_Variance_Fields>;
};


/** aggregate fields of "parking_authority_settings" */
export type Parking_Authority_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parking_Authority_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parking_authority_settings" */
export type Parking_Authority_Settings_Aggregate_Order_By = {
  avg?: InputMaybe<Parking_Authority_Settings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parking_Authority_Settings_Max_Order_By>;
  min?: InputMaybe<Parking_Authority_Settings_Min_Order_By>;
  stddev?: InputMaybe<Parking_Authority_Settings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parking_Authority_Settings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parking_Authority_Settings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parking_Authority_Settings_Sum_Order_By>;
  var_pop?: InputMaybe<Parking_Authority_Settings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parking_Authority_Settings_Var_Samp_Order_By>;
  variance?: InputMaybe<Parking_Authority_Settings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parking_authority_settings" */
export type Parking_Authority_Settings_Arr_Rel_Insert_Input = {
  data: Array<Parking_Authority_Settings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parking_Authority_Settings_On_Conflict>;
};

/** aggregate avg on columns */
export type Parking_Authority_Settings_Avg_Fields = {
  __typename?: 'parking_authority_settings_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  transfer_delay_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parking_authority_settings" */
export type Parking_Authority_Settings_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parking_authority_settings". All fields are combined with a logical 'AND'. */
export type Parking_Authority_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Parking_Authority_Settings_Bool_Exp>>;
  _not?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Parking_Authority_Settings_Bool_Exp>>;
  auto_approve_transfers?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_time_limits_enforce_mode?: InputMaybe<String_Comparison_Exp>;
  parkable_time_limits_max_interval_round_behavior?: InputMaybe<String_Comparison_Exp>;
  parkable_time_limits_max_session_gap?: InputMaybe<Int_Comparison_Exp>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  transfer_delay_hours?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "parking_authority_settings" */
export enum Parking_Authority_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParkingAuthoritySettingsPkey = 'parking_authority_settings_pkey'
}

/** input type for incrementing numeric columns in table "parking_authority_settings" */
export type Parking_Authority_Settings_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_time_limits_max_session_gap?: InputMaybe<Scalars['Int']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  transfer_delay_hours?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "parking_authority_settings" */
export type Parking_Authority_Settings_Insert_Input = {
  auto_approve_transfers?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_time_limits_enforce_mode?: InputMaybe<Scalars['String']['input']>;
  parkable_time_limits_max_interval_round_behavior?: InputMaybe<Scalars['String']['input']>;
  parkable_time_limits_max_session_gap?: InputMaybe<Scalars['Int']['input']>;
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  transfer_delay_hours?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Parking_Authority_Settings_Max_Fields = {
  __typename?: 'parking_authority_settings_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parkable_time_limits_enforce_mode?: Maybe<Scalars['String']['output']>;
  parkable_time_limits_max_interval_round_behavior?: Maybe<Scalars['String']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Int']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  transfer_delay_hours?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "parking_authority_settings" */
export type Parking_Authority_Settings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parkable_time_limits_enforce_mode?: InputMaybe<Order_By>;
  parkable_time_limits_max_interval_round_behavior?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parking_Authority_Settings_Min_Fields = {
  __typename?: 'parking_authority_settings_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parkable_time_limits_enforce_mode?: Maybe<Scalars['String']['output']>;
  parkable_time_limits_max_interval_round_behavior?: Maybe<Scalars['String']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Int']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  transfer_delay_hours?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "parking_authority_settings" */
export type Parking_Authority_Settings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parkable_time_limits_enforce_mode?: InputMaybe<Order_By>;
  parkable_time_limits_max_interval_round_behavior?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parking_authority_settings" */
export type Parking_Authority_Settings_Mutation_Response = {
  __typename?: 'parking_authority_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parking_Authority_Settings>;
};

/** input type for inserting object relation for remote table "parking_authority_settings" */
export type Parking_Authority_Settings_Obj_Rel_Insert_Input = {
  data: Parking_Authority_Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parking_Authority_Settings_On_Conflict>;
};

/** on_conflict condition type for table "parking_authority_settings" */
export type Parking_Authority_Settings_On_Conflict = {
  constraint: Parking_Authority_Settings_Constraint;
  update_columns?: Array<Parking_Authority_Settings_Update_Column>;
  where?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "parking_authority_settings". */
export type Parking_Authority_Settings_Order_By = {
  auto_approve_transfers?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parkable_time_limits_enforce_mode?: InputMaybe<Order_By>;
  parkable_time_limits_max_interval_round_behavior?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parking_authority_settings */
export type Parking_Authority_Settings_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "parking_authority_settings" */
export enum Parking_Authority_Settings_Select_Column {
  /** column name */
  AutoApproveTransfers = 'auto_approve_transfers',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParkableTimeLimitsEnforceMode = 'parkable_time_limits_enforce_mode',
  /** column name */
  ParkableTimeLimitsMaxIntervalRoundBehavior = 'parkable_time_limits_max_interval_round_behavior',
  /** column name */
  ParkableTimeLimitsMaxSessionGap = 'parkable_time_limits_max_session_gap',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  TransferDelayHours = 'transfer_delay_hours',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "parking_authority_settings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "parking_authority_settings" */
export enum Parking_Authority_Settings_Select_Column_Parking_Authority_Settings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AutoApproveTransfers = 'auto_approve_transfers'
}

/** select "parking_authority_settings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "parking_authority_settings" */
export enum Parking_Authority_Settings_Select_Column_Parking_Authority_Settings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AutoApproveTransfers = 'auto_approve_transfers'
}

/** input type for updating data in table "parking_authority_settings" */
export type Parking_Authority_Settings_Set_Input = {
  auto_approve_transfers?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_time_limits_enforce_mode?: InputMaybe<Scalars['String']['input']>;
  parkable_time_limits_max_interval_round_behavior?: InputMaybe<Scalars['String']['input']>;
  parkable_time_limits_max_session_gap?: InputMaybe<Scalars['Int']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  transfer_delay_hours?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Parking_Authority_Settings_Stddev_Fields = {
  __typename?: 'parking_authority_settings_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  transfer_delay_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parking_authority_settings" */
export type Parking_Authority_Settings_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parking_Authority_Settings_Stddev_Pop_Fields = {
  __typename?: 'parking_authority_settings_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  transfer_delay_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parking_authority_settings" */
export type Parking_Authority_Settings_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parking_Authority_Settings_Stddev_Samp_Fields = {
  __typename?: 'parking_authority_settings_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  transfer_delay_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parking_authority_settings" */
export type Parking_Authority_Settings_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parking_authority_settings" */
export type Parking_Authority_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parking_Authority_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parking_Authority_Settings_Stream_Cursor_Value_Input = {
  auto_approve_transfers?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_time_limits_enforce_mode?: InputMaybe<Scalars['String']['input']>;
  parkable_time_limits_max_interval_round_behavior?: InputMaybe<Scalars['String']['input']>;
  parkable_time_limits_max_session_gap?: InputMaybe<Scalars['Int']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  transfer_delay_hours?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Parking_Authority_Settings_Sum_Fields = {
  __typename?: 'parking_authority_settings_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Int']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  transfer_delay_hours?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "parking_authority_settings" */
export type Parking_Authority_Settings_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
};

/** update columns of table "parking_authority_settings" */
export enum Parking_Authority_Settings_Update_Column {
  /** column name */
  AutoApproveTransfers = 'auto_approve_transfers',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParkableTimeLimitsEnforceMode = 'parkable_time_limits_enforce_mode',
  /** column name */
  ParkableTimeLimitsMaxIntervalRoundBehavior = 'parkable_time_limits_max_interval_round_behavior',
  /** column name */
  ParkableTimeLimitsMaxSessionGap = 'parkable_time_limits_max_session_gap',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  TransferDelayHours = 'transfer_delay_hours',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Parking_Authority_Settings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parking_Authority_Settings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parking_Authority_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parking_Authority_Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parking_Authority_Settings_Var_Pop_Fields = {
  __typename?: 'parking_authority_settings_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  transfer_delay_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parking_authority_settings" */
export type Parking_Authority_Settings_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parking_Authority_Settings_Var_Samp_Fields = {
  __typename?: 'parking_authority_settings_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  transfer_delay_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parking_authority_settings" */
export type Parking_Authority_Settings_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parking_Authority_Settings_Variance_Fields = {
  __typename?: 'parking_authority_settings_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parkable_time_limits_max_session_gap?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  transfer_delay_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parking_authority_settings" */
export type Parking_Authority_Settings_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parkable_time_limits_max_session_gap?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  transfer_delay_hours?: InputMaybe<Order_By>;
};

/** columns and relationships of "parking_authority_user" */
export type Parking_Authority_User = {
  __typename?: 'parking_authority_user';
  /** An object relationship */
  parking_authority: Parking_Authorities;
  parking_authority_id: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "parking_authority_user" */
export type Parking_Authority_User_Aggregate = {
  __typename?: 'parking_authority_user_aggregate';
  aggregate?: Maybe<Parking_Authority_User_Aggregate_Fields>;
  nodes: Array<Parking_Authority_User>;
};

export type Parking_Authority_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parking_Authority_User_Aggregate_Bool_Exp_Count>;
};

export type Parking_Authority_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parking_Authority_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parking_authority_user" */
export type Parking_Authority_User_Aggregate_Fields = {
  __typename?: 'parking_authority_user_aggregate_fields';
  avg?: Maybe<Parking_Authority_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parking_Authority_User_Max_Fields>;
  min?: Maybe<Parking_Authority_User_Min_Fields>;
  stddev?: Maybe<Parking_Authority_User_Stddev_Fields>;
  stddev_pop?: Maybe<Parking_Authority_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parking_Authority_User_Stddev_Samp_Fields>;
  sum?: Maybe<Parking_Authority_User_Sum_Fields>;
  var_pop?: Maybe<Parking_Authority_User_Var_Pop_Fields>;
  var_samp?: Maybe<Parking_Authority_User_Var_Samp_Fields>;
  variance?: Maybe<Parking_Authority_User_Variance_Fields>;
};


/** aggregate fields of "parking_authority_user" */
export type Parking_Authority_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parking_authority_user" */
export type Parking_Authority_User_Aggregate_Order_By = {
  avg?: InputMaybe<Parking_Authority_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parking_Authority_User_Max_Order_By>;
  min?: InputMaybe<Parking_Authority_User_Min_Order_By>;
  stddev?: InputMaybe<Parking_Authority_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parking_Authority_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parking_Authority_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parking_Authority_User_Sum_Order_By>;
  var_pop?: InputMaybe<Parking_Authority_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parking_Authority_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Parking_Authority_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parking_authority_user" */
export type Parking_Authority_User_Arr_Rel_Insert_Input = {
  data: Array<Parking_Authority_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parking_Authority_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Parking_Authority_User_Avg_Fields = {
  __typename?: 'parking_authority_user_avg_fields';
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parking_authority_user" */
export type Parking_Authority_User_Avg_Order_By = {
  parking_authority_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parking_authority_user". All fields are combined with a logical 'AND'. */
export type Parking_Authority_User_Bool_Exp = {
  _and?: InputMaybe<Array<Parking_Authority_User_Bool_Exp>>;
  _not?: InputMaybe<Parking_Authority_User_Bool_Exp>;
  _or?: InputMaybe<Array<Parking_Authority_User_Bool_Exp>>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "parking_authority_user" */
export enum Parking_Authority_User_Constraint {
  /** unique or primary key constraint on columns "parking_authority_id", "user_id" */
  ParkingAuthorityUserPkey = 'parking_authority_user_pkey'
}

/** input type for incrementing numeric columns in table "parking_authority_user" */
export type Parking_Authority_User_Inc_Input = {
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "parking_authority_user" */
export type Parking_Authority_User_Insert_Input = {
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Parking_Authority_User_Max_Fields = {
  __typename?: 'parking_authority_user_max_fields';
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "parking_authority_user" */
export type Parking_Authority_User_Max_Order_By = {
  parking_authority_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parking_Authority_User_Min_Fields = {
  __typename?: 'parking_authority_user_min_fields';
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "parking_authority_user" */
export type Parking_Authority_User_Min_Order_By = {
  parking_authority_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parking_authority_user" */
export type Parking_Authority_User_Mutation_Response = {
  __typename?: 'parking_authority_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parking_Authority_User>;
};

/** on_conflict condition type for table "parking_authority_user" */
export type Parking_Authority_User_On_Conflict = {
  constraint: Parking_Authority_User_Constraint;
  update_columns?: Array<Parking_Authority_User_Update_Column>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};

/** Ordering options when selecting data from "parking_authority_user". */
export type Parking_Authority_User_Order_By = {
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parking_authority_user */
export type Parking_Authority_User_Pk_Columns_Input = {
  parking_authority_id: Scalars['bigint']['input'];
  user_id: Scalars['bigint']['input'];
};

/** select columns of table "parking_authority_user" */
export enum Parking_Authority_User_Select_Column {
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "parking_authority_user" */
export type Parking_Authority_User_Set_Input = {
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Parking_Authority_User_Stddev_Fields = {
  __typename?: 'parking_authority_user_stddev_fields';
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parking_authority_user" */
export type Parking_Authority_User_Stddev_Order_By = {
  parking_authority_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parking_Authority_User_Stddev_Pop_Fields = {
  __typename?: 'parking_authority_user_stddev_pop_fields';
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parking_authority_user" */
export type Parking_Authority_User_Stddev_Pop_Order_By = {
  parking_authority_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parking_Authority_User_Stddev_Samp_Fields = {
  __typename?: 'parking_authority_user_stddev_samp_fields';
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parking_authority_user" */
export type Parking_Authority_User_Stddev_Samp_Order_By = {
  parking_authority_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parking_authority_user" */
export type Parking_Authority_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parking_Authority_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parking_Authority_User_Stream_Cursor_Value_Input = {
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Parking_Authority_User_Sum_Fields = {
  __typename?: 'parking_authority_user_sum_fields';
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "parking_authority_user" */
export type Parking_Authority_User_Sum_Order_By = {
  parking_authority_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "parking_authority_user" */
export enum Parking_Authority_User_Update_Column {
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  UserId = 'user_id'
}

export type Parking_Authority_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parking_Authority_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parking_Authority_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parking_Authority_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parking_Authority_User_Var_Pop_Fields = {
  __typename?: 'parking_authority_user_var_pop_fields';
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parking_authority_user" */
export type Parking_Authority_User_Var_Pop_Order_By = {
  parking_authority_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parking_Authority_User_Var_Samp_Fields = {
  __typename?: 'parking_authority_user_var_samp_fields';
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parking_authority_user" */
export type Parking_Authority_User_Var_Samp_Order_By = {
  parking_authority_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parking_Authority_User_Variance_Fields = {
  __typename?: 'parking_authority_user_variance_fields';
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parking_authority_user" */
export type Parking_Authority_User_Variance_Order_By = {
  parking_authority_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "payment_batches" */
export type Payment_Batches = {
  __typename?: 'payment_batches';
  batch_net_count?: Maybe<Scalars['Int']['output']>;
  batch_net_total?: Maybe<Scalars['Int']['output']>;
  batch_return_count?: Maybe<Scalars['Int']['output']>;
  batch_return_total?: Maybe<Scalars['Int']['output']>;
  batch_sale_count?: Maybe<Scalars['Int']['output']>;
  batch_sale_total?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  batch_set?: Maybe<Batch_Sets>;
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_processed_at?: Maybe<Scalars['timestamp']['output']>;
  last_processing_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  mx_merchant_payment_batch_meta?: Maybe<Mx_Merchant_Payment_Batch_Metas>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  resource_net_count?: Maybe<Scalars['Int']['output']>;
  resource_net_total?: Maybe<Scalars['Int']['output']>;
  resource_return_count?: Maybe<Scalars['Int']['output']>;
  resource_return_total?: Maybe<Scalars['Int']['output']>;
  resource_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_sale_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  system_approved_count?: Maybe<Scalars['Int']['output']>;
  system_approved_total?: Maybe<Scalars['Int']['output']>;
  system_charged_back_count?: Maybe<Scalars['Int']['output']>;
  system_charged_back_total?: Maybe<Scalars['Int']['output']>;
  system_count?: Maybe<Scalars['Int']['output']>;
  system_declined_count?: Maybe<Scalars['Int']['output']>;
  system_declined_total?: Maybe<Scalars['Int']['output']>;
  system_failed_count?: Maybe<Scalars['Int']['output']>;
  system_failed_total?: Maybe<Scalars['Int']['output']>;
  system_net_count?: Maybe<Scalars['Int']['output']>;
  system_net_total?: Maybe<Scalars['Int']['output']>;
  system_prefund_count?: Maybe<Scalars['Int']['output']>;
  system_prefund_total?: Maybe<Scalars['Int']['output']>;
  system_return_count?: Maybe<Scalars['Int']['output']>;
  system_return_total?: Maybe<Scalars['Int']['output']>;
  system_sale_count?: Maybe<Scalars['Int']['output']>;
  system_sale_total?: Maybe<Scalars['Int']['output']>;
  system_settled_count?: Maybe<Scalars['Int']['output']>;
  system_settled_total?: Maybe<Scalars['Int']['output']>;
  system_transfer_count?: Maybe<Scalars['Int']['output']>;
  system_transfer_total?: Maybe<Scalars['Int']['output']>;
  system_voided_count?: Maybe<Scalars['Int']['output']>;
  system_voided_total?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "payment_batches" */
export type Payment_BatchesPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "payment_batches" */
export type Payment_BatchesPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** aggregated selection of "payment_batches" */
export type Payment_Batches_Aggregate = {
  __typename?: 'payment_batches_aggregate';
  aggregate?: Maybe<Payment_Batches_Aggregate_Fields>;
  nodes: Array<Payment_Batches>;
};

export type Payment_Batches_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payment_Batches_Aggregate_Bool_Exp_Count>;
};

export type Payment_Batches_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payment_Batches_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payment_batches" */
export type Payment_Batches_Aggregate_Fields = {
  __typename?: 'payment_batches_aggregate_fields';
  avg?: Maybe<Payment_Batches_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Payment_Batches_Max_Fields>;
  min?: Maybe<Payment_Batches_Min_Fields>;
  stddev?: Maybe<Payment_Batches_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Batches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Batches_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Batches_Sum_Fields>;
  var_pop?: Maybe<Payment_Batches_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Batches_Var_Samp_Fields>;
  variance?: Maybe<Payment_Batches_Variance_Fields>;
};


/** aggregate fields of "payment_batches" */
export type Payment_Batches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "payment_batches" */
export type Payment_Batches_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Batches_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Batches_Max_Order_By>;
  min?: InputMaybe<Payment_Batches_Min_Order_By>;
  stddev?: InputMaybe<Payment_Batches_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Batches_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Batches_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Batches_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Batches_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Batches_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Batches_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payment_batches" */
export type Payment_Batches_Arr_Rel_Insert_Input = {
  data: Array<Payment_Batches_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Batches_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Batches_Avg_Fields = {
  __typename?: 'payment_batches_avg_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "payment_batches" */
export type Payment_Batches_Avg_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_batches". All fields are combined with a logical 'AND'. */
export type Payment_Batches_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Batches_Bool_Exp>>;
  _not?: InputMaybe<Payment_Batches_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Batches_Bool_Exp>>;
  batch_net_count?: InputMaybe<Int_Comparison_Exp>;
  batch_net_total?: InputMaybe<Int_Comparison_Exp>;
  batch_return_count?: InputMaybe<Int_Comparison_Exp>;
  batch_return_total?: InputMaybe<Int_Comparison_Exp>;
  batch_sale_count?: InputMaybe<Int_Comparison_Exp>;
  batch_sale_total?: InputMaybe<Int_Comparison_Exp>;
  batch_set?: InputMaybe<Batch_Sets_Bool_Exp>;
  batch_set_id?: InputMaybe<Bigint_Comparison_Exp>;
  calculated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  calculating_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_processed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_processing_at?: InputMaybe<Timestamp_Comparison_Exp>;
  mx_merchant_payment_batch_meta?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>;
  num_etl_failures?: InputMaybe<Smallint_Comparison_Exp>;
  num_etls?: InputMaybe<Bigint_Comparison_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  resource_net_count?: InputMaybe<Int_Comparison_Exp>;
  resource_net_total?: InputMaybe<Int_Comparison_Exp>;
  resource_return_count?: InputMaybe<Int_Comparison_Exp>;
  resource_return_total?: InputMaybe<Int_Comparison_Exp>;
  resource_sale_count?: InputMaybe<Int_Comparison_Exp>;
  resource_sale_total?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_net_count?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_net_total?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_return_count?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_return_total?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_sale_count?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_sale_total?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  system_approved_count?: InputMaybe<Int_Comparison_Exp>;
  system_approved_total?: InputMaybe<Int_Comparison_Exp>;
  system_charged_back_count?: InputMaybe<Int_Comparison_Exp>;
  system_charged_back_total?: InputMaybe<Int_Comparison_Exp>;
  system_count?: InputMaybe<Int_Comparison_Exp>;
  system_declined_count?: InputMaybe<Int_Comparison_Exp>;
  system_declined_total?: InputMaybe<Int_Comparison_Exp>;
  system_failed_count?: InputMaybe<Int_Comparison_Exp>;
  system_failed_total?: InputMaybe<Int_Comparison_Exp>;
  system_net_count?: InputMaybe<Int_Comparison_Exp>;
  system_net_total?: InputMaybe<Int_Comparison_Exp>;
  system_prefund_count?: InputMaybe<Int_Comparison_Exp>;
  system_prefund_total?: InputMaybe<Int_Comparison_Exp>;
  system_return_count?: InputMaybe<Int_Comparison_Exp>;
  system_return_total?: InputMaybe<Int_Comparison_Exp>;
  system_sale_count?: InputMaybe<Int_Comparison_Exp>;
  system_sale_total?: InputMaybe<Int_Comparison_Exp>;
  system_settled_count?: InputMaybe<Int_Comparison_Exp>;
  system_settled_total?: InputMaybe<Int_Comparison_Exp>;
  system_transfer_count?: InputMaybe<Int_Comparison_Exp>;
  system_transfer_total?: InputMaybe<Int_Comparison_Exp>;
  system_voided_count?: InputMaybe<Int_Comparison_Exp>;
  system_voided_total?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_batches" */
export enum Payment_Batches_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentBatchesPkey = 'payment_batches_pkey'
}

/** input type for incrementing numeric columns in table "payment_batches" */
export type Payment_Batches_Inc_Input = {
  batch_net_count?: InputMaybe<Scalars['Int']['input']>;
  batch_net_total?: InputMaybe<Scalars['Int']['input']>;
  batch_return_count?: InputMaybe<Scalars['Int']['input']>;
  batch_return_total?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_count?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_total?: InputMaybe<Scalars['Int']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  resource_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_total?: InputMaybe<Scalars['Int']['input']>;
  system_approved_count?: InputMaybe<Scalars['Int']['input']>;
  system_approved_total?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_count?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_total?: InputMaybe<Scalars['Int']['input']>;
  system_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_total?: InputMaybe<Scalars['Int']['input']>;
  system_failed_count?: InputMaybe<Scalars['Int']['input']>;
  system_failed_total?: InputMaybe<Scalars['Int']['input']>;
  system_net_count?: InputMaybe<Scalars['Int']['input']>;
  system_net_total?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_count?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_total?: InputMaybe<Scalars['Int']['input']>;
  system_return_count?: InputMaybe<Scalars['Int']['input']>;
  system_return_total?: InputMaybe<Scalars['Int']['input']>;
  system_sale_count?: InputMaybe<Scalars['Int']['input']>;
  system_sale_total?: InputMaybe<Scalars['Int']['input']>;
  system_settled_count?: InputMaybe<Scalars['Int']['input']>;
  system_settled_total?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_count?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_total?: InputMaybe<Scalars['Int']['input']>;
  system_voided_count?: InputMaybe<Scalars['Int']['input']>;
  system_voided_total?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "payment_batches" */
export type Payment_Batches_Insert_Input = {
  batch_net_count?: InputMaybe<Scalars['Int']['input']>;
  batch_net_total?: InputMaybe<Scalars['Int']['input']>;
  batch_return_count?: InputMaybe<Scalars['Int']['input']>;
  batch_return_total?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_count?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_total?: InputMaybe<Scalars['Int']['input']>;
  batch_set?: InputMaybe<Batch_Sets_Obj_Rel_Insert_Input>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  mx_merchant_payment_batch_meta?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Obj_Rel_Insert_Input>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  resource_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  system_approved_count?: InputMaybe<Scalars['Int']['input']>;
  system_approved_total?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_count?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_total?: InputMaybe<Scalars['Int']['input']>;
  system_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_total?: InputMaybe<Scalars['Int']['input']>;
  system_failed_count?: InputMaybe<Scalars['Int']['input']>;
  system_failed_total?: InputMaybe<Scalars['Int']['input']>;
  system_net_count?: InputMaybe<Scalars['Int']['input']>;
  system_net_total?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_count?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_total?: InputMaybe<Scalars['Int']['input']>;
  system_return_count?: InputMaybe<Scalars['Int']['input']>;
  system_return_total?: InputMaybe<Scalars['Int']['input']>;
  system_sale_count?: InputMaybe<Scalars['Int']['input']>;
  system_sale_total?: InputMaybe<Scalars['Int']['input']>;
  system_settled_count?: InputMaybe<Scalars['Int']['input']>;
  system_settled_total?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_count?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_total?: InputMaybe<Scalars['Int']['input']>;
  system_voided_count?: InputMaybe<Scalars['Int']['input']>;
  system_voided_total?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Payment_Batches_Max_Fields = {
  __typename?: 'payment_batches_max_fields';
  batch_net_count?: Maybe<Scalars['Int']['output']>;
  batch_net_total?: Maybe<Scalars['Int']['output']>;
  batch_return_count?: Maybe<Scalars['Int']['output']>;
  batch_return_total?: Maybe<Scalars['Int']['output']>;
  batch_sale_count?: Maybe<Scalars['Int']['output']>;
  batch_sale_total?: Maybe<Scalars['Int']['output']>;
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_processed_at?: Maybe<Scalars['timestamp']['output']>;
  last_processing_at?: Maybe<Scalars['timestamp']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  resource_net_count?: Maybe<Scalars['Int']['output']>;
  resource_net_total?: Maybe<Scalars['Int']['output']>;
  resource_return_count?: Maybe<Scalars['Int']['output']>;
  resource_return_total?: Maybe<Scalars['Int']['output']>;
  resource_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_sale_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  system_approved_count?: Maybe<Scalars['Int']['output']>;
  system_approved_total?: Maybe<Scalars['Int']['output']>;
  system_charged_back_count?: Maybe<Scalars['Int']['output']>;
  system_charged_back_total?: Maybe<Scalars['Int']['output']>;
  system_count?: Maybe<Scalars['Int']['output']>;
  system_declined_count?: Maybe<Scalars['Int']['output']>;
  system_declined_total?: Maybe<Scalars['Int']['output']>;
  system_failed_count?: Maybe<Scalars['Int']['output']>;
  system_failed_total?: Maybe<Scalars['Int']['output']>;
  system_net_count?: Maybe<Scalars['Int']['output']>;
  system_net_total?: Maybe<Scalars['Int']['output']>;
  system_prefund_count?: Maybe<Scalars['Int']['output']>;
  system_prefund_total?: Maybe<Scalars['Int']['output']>;
  system_return_count?: Maybe<Scalars['Int']['output']>;
  system_return_total?: Maybe<Scalars['Int']['output']>;
  system_sale_count?: Maybe<Scalars['Int']['output']>;
  system_sale_total?: Maybe<Scalars['Int']['output']>;
  system_settled_count?: Maybe<Scalars['Int']['output']>;
  system_settled_total?: Maybe<Scalars['Int']['output']>;
  system_transfer_count?: Maybe<Scalars['Int']['output']>;
  system_transfer_total?: Maybe<Scalars['Int']['output']>;
  system_voided_count?: Maybe<Scalars['Int']['output']>;
  system_voided_total?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "payment_batches" */
export type Payment_Batches_Max_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  calculated_at?: InputMaybe<Order_By>;
  calculating_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_processed_at?: InputMaybe<Order_By>;
  last_processing_at?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Batches_Min_Fields = {
  __typename?: 'payment_batches_min_fields';
  batch_net_count?: Maybe<Scalars['Int']['output']>;
  batch_net_total?: Maybe<Scalars['Int']['output']>;
  batch_return_count?: Maybe<Scalars['Int']['output']>;
  batch_return_total?: Maybe<Scalars['Int']['output']>;
  batch_sale_count?: Maybe<Scalars['Int']['output']>;
  batch_sale_total?: Maybe<Scalars['Int']['output']>;
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_processed_at?: Maybe<Scalars['timestamp']['output']>;
  last_processing_at?: Maybe<Scalars['timestamp']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  resource_net_count?: Maybe<Scalars['Int']['output']>;
  resource_net_total?: Maybe<Scalars['Int']['output']>;
  resource_return_count?: Maybe<Scalars['Int']['output']>;
  resource_return_total?: Maybe<Scalars['Int']['output']>;
  resource_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_sale_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  system_approved_count?: Maybe<Scalars['Int']['output']>;
  system_approved_total?: Maybe<Scalars['Int']['output']>;
  system_charged_back_count?: Maybe<Scalars['Int']['output']>;
  system_charged_back_total?: Maybe<Scalars['Int']['output']>;
  system_count?: Maybe<Scalars['Int']['output']>;
  system_declined_count?: Maybe<Scalars['Int']['output']>;
  system_declined_total?: Maybe<Scalars['Int']['output']>;
  system_failed_count?: Maybe<Scalars['Int']['output']>;
  system_failed_total?: Maybe<Scalars['Int']['output']>;
  system_net_count?: Maybe<Scalars['Int']['output']>;
  system_net_total?: Maybe<Scalars['Int']['output']>;
  system_prefund_count?: Maybe<Scalars['Int']['output']>;
  system_prefund_total?: Maybe<Scalars['Int']['output']>;
  system_return_count?: Maybe<Scalars['Int']['output']>;
  system_return_total?: Maybe<Scalars['Int']['output']>;
  system_sale_count?: Maybe<Scalars['Int']['output']>;
  system_sale_total?: Maybe<Scalars['Int']['output']>;
  system_settled_count?: Maybe<Scalars['Int']['output']>;
  system_settled_total?: Maybe<Scalars['Int']['output']>;
  system_transfer_count?: Maybe<Scalars['Int']['output']>;
  system_transfer_total?: Maybe<Scalars['Int']['output']>;
  system_voided_count?: Maybe<Scalars['Int']['output']>;
  system_voided_total?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "payment_batches" */
export type Payment_Batches_Min_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  calculated_at?: InputMaybe<Order_By>;
  calculating_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_processed_at?: InputMaybe<Order_By>;
  last_processing_at?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment_batches" */
export type Payment_Batches_Mutation_Response = {
  __typename?: 'payment_batches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Batches>;
};

/** input type for inserting object relation for remote table "payment_batches" */
export type Payment_Batches_Obj_Rel_Insert_Input = {
  data: Payment_Batches_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Batches_On_Conflict>;
};

/** on_conflict condition type for table "payment_batches" */
export type Payment_Batches_On_Conflict = {
  constraint: Payment_Batches_Constraint;
  update_columns?: Array<Payment_Batches_Update_Column>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_batches". */
export type Payment_Batches_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set?: InputMaybe<Batch_Sets_Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  calculated_at?: InputMaybe<Order_By>;
  calculating_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_processed_at?: InputMaybe<Order_By>;
  last_processing_at?: InputMaybe<Order_By>;
  mx_merchant_payment_batch_meta?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_batches */
export type Payment_Batches_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "payment_batches" */
export enum Payment_Batches_Select_Column {
  /** column name */
  BatchNetCount = 'batch_net_count',
  /** column name */
  BatchNetTotal = 'batch_net_total',
  /** column name */
  BatchReturnCount = 'batch_return_count',
  /** column name */
  BatchReturnTotal = 'batch_return_total',
  /** column name */
  BatchSaleCount = 'batch_sale_count',
  /** column name */
  BatchSaleTotal = 'batch_sale_total',
  /** column name */
  BatchSetId = 'batch_set_id',
  /** column name */
  CalculatedAt = 'calculated_at',
  /** column name */
  CalculatingAt = 'calculating_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastProcessedAt = 'last_processed_at',
  /** column name */
  LastProcessingAt = 'last_processing_at',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  ResourceNetCount = 'resource_net_count',
  /** column name */
  ResourceNetTotal = 'resource_net_total',
  /** column name */
  ResourceReturnCount = 'resource_return_count',
  /** column name */
  ResourceReturnTotal = 'resource_return_total',
  /** column name */
  ResourceSaleCount = 'resource_sale_count',
  /** column name */
  ResourceSaleTotal = 'resource_sale_total',
  /** column name */
  ResourceUnmatchedNetCount = 'resource_unmatched_net_count',
  /** column name */
  ResourceUnmatchedNetTotal = 'resource_unmatched_net_total',
  /** column name */
  ResourceUnmatchedReturnCount = 'resource_unmatched_return_count',
  /** column name */
  ResourceUnmatchedReturnTotal = 'resource_unmatched_return_total',
  /** column name */
  ResourceUnmatchedSaleCount = 'resource_unmatched_sale_count',
  /** column name */
  ResourceUnmatchedSaleTotal = 'resource_unmatched_sale_total',
  /** column name */
  Status = 'status',
  /** column name */
  SystemApprovedCount = 'system_approved_count',
  /** column name */
  SystemApprovedTotal = 'system_approved_total',
  /** column name */
  SystemChargedBackCount = 'system_charged_back_count',
  /** column name */
  SystemChargedBackTotal = 'system_charged_back_total',
  /** column name */
  SystemCount = 'system_count',
  /** column name */
  SystemDeclinedCount = 'system_declined_count',
  /** column name */
  SystemDeclinedTotal = 'system_declined_total',
  /** column name */
  SystemFailedCount = 'system_failed_count',
  /** column name */
  SystemFailedTotal = 'system_failed_total',
  /** column name */
  SystemNetCount = 'system_net_count',
  /** column name */
  SystemNetTotal = 'system_net_total',
  /** column name */
  SystemPrefundCount = 'system_prefund_count',
  /** column name */
  SystemPrefundTotal = 'system_prefund_total',
  /** column name */
  SystemReturnCount = 'system_return_count',
  /** column name */
  SystemReturnTotal = 'system_return_total',
  /** column name */
  SystemSaleCount = 'system_sale_count',
  /** column name */
  SystemSaleTotal = 'system_sale_total',
  /** column name */
  SystemSettledCount = 'system_settled_count',
  /** column name */
  SystemSettledTotal = 'system_settled_total',
  /** column name */
  SystemTransferCount = 'system_transfer_count',
  /** column name */
  SystemTransferTotal = 'system_transfer_total',
  /** column name */
  SystemVoidedCount = 'system_voided_count',
  /** column name */
  SystemVoidedTotal = 'system_voided_total',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "payment_batches" */
export type Payment_Batches_Set_Input = {
  batch_net_count?: InputMaybe<Scalars['Int']['input']>;
  batch_net_total?: InputMaybe<Scalars['Int']['input']>;
  batch_return_count?: InputMaybe<Scalars['Int']['input']>;
  batch_return_total?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_count?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_total?: InputMaybe<Scalars['Int']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  resource_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  system_approved_count?: InputMaybe<Scalars['Int']['input']>;
  system_approved_total?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_count?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_total?: InputMaybe<Scalars['Int']['input']>;
  system_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_total?: InputMaybe<Scalars['Int']['input']>;
  system_failed_count?: InputMaybe<Scalars['Int']['input']>;
  system_failed_total?: InputMaybe<Scalars['Int']['input']>;
  system_net_count?: InputMaybe<Scalars['Int']['input']>;
  system_net_total?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_count?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_total?: InputMaybe<Scalars['Int']['input']>;
  system_return_count?: InputMaybe<Scalars['Int']['input']>;
  system_return_total?: InputMaybe<Scalars['Int']['input']>;
  system_sale_count?: InputMaybe<Scalars['Int']['input']>;
  system_sale_total?: InputMaybe<Scalars['Int']['input']>;
  system_settled_count?: InputMaybe<Scalars['Int']['input']>;
  system_settled_total?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_count?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_total?: InputMaybe<Scalars['Int']['input']>;
  system_voided_count?: InputMaybe<Scalars['Int']['input']>;
  system_voided_total?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Payment_Batches_Stddev_Fields = {
  __typename?: 'payment_batches_stddev_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "payment_batches" */
export type Payment_Batches_Stddev_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Batches_Stddev_Pop_Fields = {
  __typename?: 'payment_batches_stddev_pop_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "payment_batches" */
export type Payment_Batches_Stddev_Pop_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Batches_Stddev_Samp_Fields = {
  __typename?: 'payment_batches_stddev_samp_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "payment_batches" */
export type Payment_Batches_Stddev_Samp_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment_batches" */
export type Payment_Batches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Batches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Batches_Stream_Cursor_Value_Input = {
  batch_net_count?: InputMaybe<Scalars['Int']['input']>;
  batch_net_total?: InputMaybe<Scalars['Int']['input']>;
  batch_return_count?: InputMaybe<Scalars['Int']['input']>;
  batch_return_total?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_count?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_total?: InputMaybe<Scalars['Int']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  resource_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  system_approved_count?: InputMaybe<Scalars['Int']['input']>;
  system_approved_total?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_count?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_total?: InputMaybe<Scalars['Int']['input']>;
  system_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_total?: InputMaybe<Scalars['Int']['input']>;
  system_failed_count?: InputMaybe<Scalars['Int']['input']>;
  system_failed_total?: InputMaybe<Scalars['Int']['input']>;
  system_net_count?: InputMaybe<Scalars['Int']['input']>;
  system_net_total?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_count?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_total?: InputMaybe<Scalars['Int']['input']>;
  system_return_count?: InputMaybe<Scalars['Int']['input']>;
  system_return_total?: InputMaybe<Scalars['Int']['input']>;
  system_sale_count?: InputMaybe<Scalars['Int']['input']>;
  system_sale_total?: InputMaybe<Scalars['Int']['input']>;
  system_settled_count?: InputMaybe<Scalars['Int']['input']>;
  system_settled_total?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_count?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_total?: InputMaybe<Scalars['Int']['input']>;
  system_voided_count?: InputMaybe<Scalars['Int']['input']>;
  system_voided_total?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Payment_Batches_Sum_Fields = {
  __typename?: 'payment_batches_sum_fields';
  batch_net_count?: Maybe<Scalars['Int']['output']>;
  batch_net_total?: Maybe<Scalars['Int']['output']>;
  batch_return_count?: Maybe<Scalars['Int']['output']>;
  batch_return_total?: Maybe<Scalars['Int']['output']>;
  batch_sale_count?: Maybe<Scalars['Int']['output']>;
  batch_sale_total?: Maybe<Scalars['Int']['output']>;
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  resource_net_count?: Maybe<Scalars['Int']['output']>;
  resource_net_total?: Maybe<Scalars['Int']['output']>;
  resource_return_count?: Maybe<Scalars['Int']['output']>;
  resource_return_total?: Maybe<Scalars['Int']['output']>;
  resource_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_sale_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Int']['output']>;
  system_approved_count?: Maybe<Scalars['Int']['output']>;
  system_approved_total?: Maybe<Scalars['Int']['output']>;
  system_charged_back_count?: Maybe<Scalars['Int']['output']>;
  system_charged_back_total?: Maybe<Scalars['Int']['output']>;
  system_count?: Maybe<Scalars['Int']['output']>;
  system_declined_count?: Maybe<Scalars['Int']['output']>;
  system_declined_total?: Maybe<Scalars['Int']['output']>;
  system_failed_count?: Maybe<Scalars['Int']['output']>;
  system_failed_total?: Maybe<Scalars['Int']['output']>;
  system_net_count?: Maybe<Scalars['Int']['output']>;
  system_net_total?: Maybe<Scalars['Int']['output']>;
  system_prefund_count?: Maybe<Scalars['Int']['output']>;
  system_prefund_total?: Maybe<Scalars['Int']['output']>;
  system_return_count?: Maybe<Scalars['Int']['output']>;
  system_return_total?: Maybe<Scalars['Int']['output']>;
  system_sale_count?: Maybe<Scalars['Int']['output']>;
  system_sale_total?: Maybe<Scalars['Int']['output']>;
  system_settled_count?: Maybe<Scalars['Int']['output']>;
  system_settled_total?: Maybe<Scalars['Int']['output']>;
  system_transfer_count?: Maybe<Scalars['Int']['output']>;
  system_transfer_total?: Maybe<Scalars['Int']['output']>;
  system_voided_count?: Maybe<Scalars['Int']['output']>;
  system_voided_total?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "payment_batches" */
export type Payment_Batches_Sum_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
};

/** update columns of table "payment_batches" */
export enum Payment_Batches_Update_Column {
  /** column name */
  BatchNetCount = 'batch_net_count',
  /** column name */
  BatchNetTotal = 'batch_net_total',
  /** column name */
  BatchReturnCount = 'batch_return_count',
  /** column name */
  BatchReturnTotal = 'batch_return_total',
  /** column name */
  BatchSaleCount = 'batch_sale_count',
  /** column name */
  BatchSaleTotal = 'batch_sale_total',
  /** column name */
  BatchSetId = 'batch_set_id',
  /** column name */
  CalculatedAt = 'calculated_at',
  /** column name */
  CalculatingAt = 'calculating_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastProcessedAt = 'last_processed_at',
  /** column name */
  LastProcessingAt = 'last_processing_at',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  ResourceNetCount = 'resource_net_count',
  /** column name */
  ResourceNetTotal = 'resource_net_total',
  /** column name */
  ResourceReturnCount = 'resource_return_count',
  /** column name */
  ResourceReturnTotal = 'resource_return_total',
  /** column name */
  ResourceSaleCount = 'resource_sale_count',
  /** column name */
  ResourceSaleTotal = 'resource_sale_total',
  /** column name */
  ResourceUnmatchedNetCount = 'resource_unmatched_net_count',
  /** column name */
  ResourceUnmatchedNetTotal = 'resource_unmatched_net_total',
  /** column name */
  ResourceUnmatchedReturnCount = 'resource_unmatched_return_count',
  /** column name */
  ResourceUnmatchedReturnTotal = 'resource_unmatched_return_total',
  /** column name */
  ResourceUnmatchedSaleCount = 'resource_unmatched_sale_count',
  /** column name */
  ResourceUnmatchedSaleTotal = 'resource_unmatched_sale_total',
  /** column name */
  Status = 'status',
  /** column name */
  SystemApprovedCount = 'system_approved_count',
  /** column name */
  SystemApprovedTotal = 'system_approved_total',
  /** column name */
  SystemChargedBackCount = 'system_charged_back_count',
  /** column name */
  SystemChargedBackTotal = 'system_charged_back_total',
  /** column name */
  SystemCount = 'system_count',
  /** column name */
  SystemDeclinedCount = 'system_declined_count',
  /** column name */
  SystemDeclinedTotal = 'system_declined_total',
  /** column name */
  SystemFailedCount = 'system_failed_count',
  /** column name */
  SystemFailedTotal = 'system_failed_total',
  /** column name */
  SystemNetCount = 'system_net_count',
  /** column name */
  SystemNetTotal = 'system_net_total',
  /** column name */
  SystemPrefundCount = 'system_prefund_count',
  /** column name */
  SystemPrefundTotal = 'system_prefund_total',
  /** column name */
  SystemReturnCount = 'system_return_count',
  /** column name */
  SystemReturnTotal = 'system_return_total',
  /** column name */
  SystemSaleCount = 'system_sale_count',
  /** column name */
  SystemSaleTotal = 'system_sale_total',
  /** column name */
  SystemSettledCount = 'system_settled_count',
  /** column name */
  SystemSettledTotal = 'system_settled_total',
  /** column name */
  SystemTransferCount = 'system_transfer_count',
  /** column name */
  SystemTransferTotal = 'system_transfer_total',
  /** column name */
  SystemVoidedCount = 'system_voided_count',
  /** column name */
  SystemVoidedTotal = 'system_voided_total',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Payment_Batches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Batches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Batches_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payment_Batches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Batches_Var_Pop_Fields = {
  __typename?: 'payment_batches_var_pop_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "payment_batches" */
export type Payment_Batches_Var_Pop_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Batches_Var_Samp_Fields = {
  __typename?: 'payment_batches_var_samp_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "payment_batches" */
export type Payment_Batches_Var_Samp_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Batches_Variance_Fields = {
  __typename?: 'payment_batches_variance_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "payment_batches" */
export type Payment_Batches_Variance_Order_By = {
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
};

/** columns and relationships of "payment_methods" */
export type Payment_Methods = {
  __typename?: 'payment_methods';
  alias?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  default: Scalars['Boolean']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  idempotent_key: Scalars['String']['output'];
  last_payment_at?: Maybe<Scalars['timestamp']['output']>;
  last_payment_id?: Maybe<Scalars['bigint']['output']>;
  last_payment_response_code?: Maybe<Scalars['Int']['output']>;
  last_payment_response_code_info?: Maybe<Scalars['json']['output']>;
  last_payment_status?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  mx_merchant_payment_method_meta?: Maybe<Mx_Merchant_Payment_Method_Metas>;
  /** An array relationship */
  mx_merchant_payment_method_metas: Array<Mx_Merchant_Payment_Method_Metas>;
  /** An aggregate relationship */
  mx_merchant_payment_method_metas_aggregate: Mx_Merchant_Payment_Method_Metas_Aggregate;
  /** An array relationship */
  parkable_transactions: Array<Parkable_Transactions>;
  /** An aggregate relationship */
  parkable_transactions_aggregate: Parkable_Transactions_Aggregate;
  /** An object relationship */
  payment?: Maybe<Payments>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
  /** An array relationship */
  wallets: Array<Wallets>;
  /** An aggregate relationship */
  wallets_aggregate: Wallets_Aggregate;
};


/** columns and relationships of "payment_methods" */
export type Payment_MethodsLast_Payment_Response_Code_InfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "payment_methods" */
export type Payment_MethodsMx_Merchant_Payment_Method_MetasArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
};


/** columns and relationships of "payment_methods" */
export type Payment_MethodsMx_Merchant_Payment_Method_Metas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
};


/** columns and relationships of "payment_methods" */
export type Payment_MethodsParkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


/** columns and relationships of "payment_methods" */
export type Payment_MethodsParkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


/** columns and relationships of "payment_methods" */
export type Payment_MethodsPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "payment_methods" */
export type Payment_MethodsPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "payment_methods" */
export type Payment_MethodsWalletsArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


/** columns and relationships of "payment_methods" */
export type Payment_MethodsWallets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};

/** aggregated selection of "payment_methods" */
export type Payment_Methods_Aggregate = {
  __typename?: 'payment_methods_aggregate';
  aggregate?: Maybe<Payment_Methods_Aggregate_Fields>;
  nodes: Array<Payment_Methods>;
};

export type Payment_Methods_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Payment_Methods_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Payment_Methods_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Payment_Methods_Aggregate_Bool_Exp_Count>;
};

export type Payment_Methods_Aggregate_Bool_Exp_Bool_And = {
  arguments: Payment_Methods_Select_Column_Payment_Methods_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payment_Methods_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Payment_Methods_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Payment_Methods_Select_Column_Payment_Methods_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payment_Methods_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Payment_Methods_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payment_Methods_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payment_methods" */
export type Payment_Methods_Aggregate_Fields = {
  __typename?: 'payment_methods_aggregate_fields';
  avg?: Maybe<Payment_Methods_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Payment_Methods_Max_Fields>;
  min?: Maybe<Payment_Methods_Min_Fields>;
  stddev?: Maybe<Payment_Methods_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Methods_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Methods_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Methods_Sum_Fields>;
  var_pop?: Maybe<Payment_Methods_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Methods_Var_Samp_Fields>;
  variance?: Maybe<Payment_Methods_Variance_Fields>;
};


/** aggregate fields of "payment_methods" */
export type Payment_Methods_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "payment_methods" */
export type Payment_Methods_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Methods_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Methods_Max_Order_By>;
  min?: InputMaybe<Payment_Methods_Min_Order_By>;
  stddev?: InputMaybe<Payment_Methods_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Methods_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Methods_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Methods_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Methods_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Methods_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Methods_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payment_methods" */
export type Payment_Methods_Arr_Rel_Insert_Input = {
  data: Array<Payment_Methods_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Methods_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Methods_Avg_Fields = {
  __typename?: 'payment_methods_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_payment_id?: Maybe<Scalars['Float']['output']>;
  last_payment_response_code?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "payment_methods" */
export type Payment_Methods_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_methods". All fields are combined with a logical 'AND'. */
export type Payment_Methods_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Methods_Bool_Exp>>;
  _not?: InputMaybe<Payment_Methods_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Methods_Bool_Exp>>;
  alias?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  default?: InputMaybe<Boolean_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<String_Comparison_Exp>;
  last_payment_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_payment_id?: InputMaybe<Bigint_Comparison_Exp>;
  last_payment_response_code?: InputMaybe<Int_Comparison_Exp>;
  last_payment_response_code_info?: InputMaybe<Json_Comparison_Exp>;
  last_payment_status?: InputMaybe<String_Comparison_Exp>;
  mx_merchant_payment_method_meta?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
  mx_merchant_payment_method_metas?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
  mx_merchant_payment_method_metas_aggregate?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Aggregate_Bool_Exp>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  parkable_transactions_aggregate?: InputMaybe<Parkable_Transactions_Aggregate_Bool_Exp>;
  payment?: InputMaybe<Payments_Bool_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  wallets?: InputMaybe<Wallets_Bool_Exp>;
  wallets_aggregate?: InputMaybe<Wallets_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "payment_methods" */
export enum Payment_Methods_Constraint {
  /** unique or primary key constraint on columns "idempotent_key" */
  PaymentMethodsIdempotentKeyUnique = 'payment_methods_idempotent_key_unique',
  /** unique or primary key constraint on columns "id" */
  PaymentMethodsPkey = 'payment_methods_pkey'
}

/** input type for incrementing numeric columns in table "payment_methods" */
export type Payment_Methods_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  last_payment_response_code?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "payment_methods" */
export type Payment_Methods_Insert_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  last_payment_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  last_payment_response_code?: InputMaybe<Scalars['Int']['input']>;
  last_payment_response_code_info?: InputMaybe<Scalars['json']['input']>;
  last_payment_status?: InputMaybe<Scalars['String']['input']>;
  mx_merchant_payment_method_meta?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Obj_Rel_Insert_Input>;
  mx_merchant_payment_method_metas?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Arr_Rel_Insert_Input>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Arr_Rel_Insert_Input>;
  payment?: InputMaybe<Payments_Obj_Rel_Insert_Input>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  wallets?: InputMaybe<Wallets_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Payment_Methods_Max_Fields = {
  __typename?: 'payment_methods_max_fields';
  alias?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['String']['output']>;
  last_payment_at?: Maybe<Scalars['timestamp']['output']>;
  last_payment_id?: Maybe<Scalars['bigint']['output']>;
  last_payment_response_code?: Maybe<Scalars['Int']['output']>;
  last_payment_status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "payment_methods" */
export type Payment_Methods_Max_Order_By = {
  alias?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  last_payment_at?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  last_payment_status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Methods_Min_Fields = {
  __typename?: 'payment_methods_min_fields';
  alias?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['String']['output']>;
  last_payment_at?: Maybe<Scalars['timestamp']['output']>;
  last_payment_id?: Maybe<Scalars['bigint']['output']>;
  last_payment_response_code?: Maybe<Scalars['Int']['output']>;
  last_payment_status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "payment_methods" */
export type Payment_Methods_Min_Order_By = {
  alias?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  last_payment_at?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  last_payment_status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment_methods" */
export type Payment_Methods_Mutation_Response = {
  __typename?: 'payment_methods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Methods>;
};

/** input type for inserting object relation for remote table "payment_methods" */
export type Payment_Methods_Obj_Rel_Insert_Input = {
  data: Payment_Methods_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Methods_On_Conflict>;
};

/** on_conflict condition type for table "payment_methods" */
export type Payment_Methods_On_Conflict = {
  constraint: Payment_Methods_Constraint;
  update_columns?: Array<Payment_Methods_Update_Column>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_methods". */
export type Payment_Methods_Order_By = {
  alias?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  last_payment_at?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  last_payment_response_code_info?: InputMaybe<Order_By>;
  last_payment_status?: InputMaybe<Order_By>;
  mx_merchant_payment_method_meta?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Order_By>;
  mx_merchant_payment_method_metas_aggregate?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Aggregate_Order_By>;
  parkable_transactions_aggregate?: InputMaybe<Parkable_Transactions_Aggregate_Order_By>;
  payment?: InputMaybe<Payments_Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  wallets_aggregate?: InputMaybe<Wallets_Aggregate_Order_By>;
};

/** primary key columns input for table: payment_methods */
export type Payment_Methods_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "payment_methods" */
export enum Payment_Methods_Select_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Default = 'default',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  LastPaymentAt = 'last_payment_at',
  /** column name */
  LastPaymentId = 'last_payment_id',
  /** column name */
  LastPaymentResponseCode = 'last_payment_response_code',
  /** column name */
  LastPaymentResponseCodeInfo = 'last_payment_response_code_info',
  /** column name */
  LastPaymentStatus = 'last_payment_status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "payment_methods_aggregate_bool_exp_bool_and_arguments_columns" columns of table "payment_methods" */
export enum Payment_Methods_Select_Column_Payment_Methods_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Default = 'default'
}

/** select "payment_methods_aggregate_bool_exp_bool_or_arguments_columns" columns of table "payment_methods" */
export enum Payment_Methods_Select_Column_Payment_Methods_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Default = 'default'
}

/** input type for updating data in table "payment_methods" */
export type Payment_Methods_Set_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  last_payment_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  last_payment_response_code?: InputMaybe<Scalars['Int']['input']>;
  last_payment_response_code_info?: InputMaybe<Scalars['json']['input']>;
  last_payment_status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Payment_Methods_Stddev_Fields = {
  __typename?: 'payment_methods_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_payment_id?: Maybe<Scalars['Float']['output']>;
  last_payment_response_code?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "payment_methods" */
export type Payment_Methods_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Methods_Stddev_Pop_Fields = {
  __typename?: 'payment_methods_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_payment_id?: Maybe<Scalars['Float']['output']>;
  last_payment_response_code?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "payment_methods" */
export type Payment_Methods_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Methods_Stddev_Samp_Fields = {
  __typename?: 'payment_methods_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_payment_id?: Maybe<Scalars['Float']['output']>;
  last_payment_response_code?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "payment_methods" */
export type Payment_Methods_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment_methods" */
export type Payment_Methods_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Methods_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Methods_Stream_Cursor_Value_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  last_payment_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  last_payment_response_code?: InputMaybe<Scalars['Int']['input']>;
  last_payment_response_code_info?: InputMaybe<Scalars['json']['input']>;
  last_payment_status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Payment_Methods_Sum_Fields = {
  __typename?: 'payment_methods_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  last_payment_id?: Maybe<Scalars['bigint']['output']>;
  last_payment_response_code?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "payment_methods" */
export type Payment_Methods_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "payment_methods" */
export enum Payment_Methods_Update_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Default = 'default',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  LastPaymentAt = 'last_payment_at',
  /** column name */
  LastPaymentId = 'last_payment_id',
  /** column name */
  LastPaymentResponseCode = 'last_payment_response_code',
  /** column name */
  LastPaymentResponseCodeInfo = 'last_payment_response_code_info',
  /** column name */
  LastPaymentStatus = 'last_payment_status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Payment_Methods_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Methods_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Methods_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payment_Methods_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Methods_Var_Pop_Fields = {
  __typename?: 'payment_methods_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_payment_id?: Maybe<Scalars['Float']['output']>;
  last_payment_response_code?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "payment_methods" */
export type Payment_Methods_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Methods_Var_Samp_Fields = {
  __typename?: 'payment_methods_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_payment_id?: Maybe<Scalars['Float']['output']>;
  last_payment_response_code?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "payment_methods" */
export type Payment_Methods_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Methods_Variance_Fields = {
  __typename?: 'payment_methods_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_payment_id?: Maybe<Scalars['Float']['output']>;
  last_payment_response_code?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "payment_methods" */
export type Payment_Methods_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  last_payment_id?: InputMaybe<Order_By>;
  last_payment_response_code?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "payment_wallet_transaction" */
export type Payment_Wallet_Transaction = {
  __typename?: 'payment_wallet_transaction';
  /** An object relationship */
  payment: Payments;
  payment_id: Scalars['bigint']['output'];
  /** An object relationship */
  wallet_transaction: Wallet_Transactions;
  wallet_transaction_id: Scalars['bigint']['output'];
};

/** aggregated selection of "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Aggregate = {
  __typename?: 'payment_wallet_transaction_aggregate';
  aggregate?: Maybe<Payment_Wallet_Transaction_Aggregate_Fields>;
  nodes: Array<Payment_Wallet_Transaction>;
};

export type Payment_Wallet_Transaction_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payment_Wallet_Transaction_Aggregate_Bool_Exp_Count>;
};

export type Payment_Wallet_Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payment_Wallet_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Aggregate_Fields = {
  __typename?: 'payment_wallet_transaction_aggregate_fields';
  avg?: Maybe<Payment_Wallet_Transaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Payment_Wallet_Transaction_Max_Fields>;
  min?: Maybe<Payment_Wallet_Transaction_Min_Fields>;
  stddev?: Maybe<Payment_Wallet_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Wallet_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Wallet_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Wallet_Transaction_Sum_Fields>;
  var_pop?: Maybe<Payment_Wallet_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Wallet_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Payment_Wallet_Transaction_Variance_Fields>;
};


/** aggregate fields of "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Wallet_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Wallet_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Wallet_Transaction_Max_Order_By>;
  min?: InputMaybe<Payment_Wallet_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Payment_Wallet_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Wallet_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Wallet_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Wallet_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Wallet_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Wallet_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Wallet_Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Payment_Wallet_Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Wallet_Transaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Wallet_Transaction_Avg_Fields = {
  __typename?: 'payment_wallet_transaction_avg_fields';
  payment_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Avg_Order_By = {
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_wallet_transaction". All fields are combined with a logical 'AND'. */
export type Payment_Wallet_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Wallet_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Wallet_Transaction_Bool_Exp>>;
  payment?: InputMaybe<Payments_Bool_Exp>;
  payment_id?: InputMaybe<Bigint_Comparison_Exp>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_wallet_transaction" */
export enum Payment_Wallet_Transaction_Constraint {
  /** unique or primary key constraint on columns "wallet_transaction_id", "payment_id" */
  PaymentWalletTransactionPkey = 'payment_wallet_transaction_pkey'
}

/** input type for incrementing numeric columns in table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Inc_Input = {
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Insert_Input = {
  payment?: InputMaybe<Payments_Obj_Rel_Insert_Input>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Obj_Rel_Insert_Input>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Payment_Wallet_Transaction_Max_Fields = {
  __typename?: 'payment_wallet_transaction_max_fields';
  payment_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Max_Order_By = {
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Wallet_Transaction_Min_Fields = {
  __typename?: 'payment_wallet_transaction_min_fields';
  payment_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Min_Order_By = {
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Mutation_Response = {
  __typename?: 'payment_wallet_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Wallet_Transaction>;
};

/** on_conflict condition type for table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_On_Conflict = {
  constraint: Payment_Wallet_Transaction_Constraint;
  update_columns?: Array<Payment_Wallet_Transaction_Update_Column>;
  where?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_wallet_transaction". */
export type Payment_Wallet_Transaction_Order_By = {
  payment?: InputMaybe<Payments_Order_By>;
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_wallet_transaction */
export type Payment_Wallet_Transaction_Pk_Columns_Input = {
  payment_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};

/** select columns of table "payment_wallet_transaction" */
export enum Payment_Wallet_Transaction_Select_Column {
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

/** input type for updating data in table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Set_Input = {
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Payment_Wallet_Transaction_Stddev_Fields = {
  __typename?: 'payment_wallet_transaction_stddev_fields';
  payment_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Stddev_Order_By = {
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Wallet_Transaction_Stddev_Pop_Fields = {
  __typename?: 'payment_wallet_transaction_stddev_pop_fields';
  payment_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Stddev_Pop_Order_By = {
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Wallet_Transaction_Stddev_Samp_Fields = {
  __typename?: 'payment_wallet_transaction_stddev_samp_fields';
  payment_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Stddev_Samp_Order_By = {
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Wallet_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Wallet_Transaction_Stream_Cursor_Value_Input = {
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Payment_Wallet_Transaction_Sum_Fields = {
  __typename?: 'payment_wallet_transaction_sum_fields';
  payment_id?: Maybe<Scalars['bigint']['output']>;
  wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Sum_Order_By = {
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "payment_wallet_transaction" */
export enum Payment_Wallet_Transaction_Update_Column {
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

export type Payment_Wallet_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Wallet_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Wallet_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payment_Wallet_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Wallet_Transaction_Var_Pop_Fields = {
  __typename?: 'payment_wallet_transaction_var_pop_fields';
  payment_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Var_Pop_Order_By = {
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Wallet_Transaction_Var_Samp_Fields = {
  __typename?: 'payment_wallet_transaction_var_samp_fields';
  payment_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Var_Samp_Order_By = {
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Wallet_Transaction_Variance_Fields = {
  __typename?: 'payment_wallet_transaction_variance_fields';
  payment_id?: Maybe<Scalars['Float']['output']>;
  wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "payment_wallet_transaction" */
export type Payment_Wallet_Transaction_Variance_Order_By = {
  payment_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "payments" */
export type Payments = {
  __typename?: 'payments';
  amount: Scalars['Int']['output'];
  auth_only: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  invoice?: Maybe<Invoices>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  is_parking_authority_funds_transfer: Scalars['Boolean']['output'];
  is_prefund: Scalars['Boolean']['output'];
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  line_item_payments: Array<Line_Item_Payment>;
  /** An aggregate relationship */
  line_item_payments_aggregate: Line_Item_Payment_Aggregate;
  /** An array relationship */
  mx_merchant_payment_metas: Array<Mx_Merchant_Payment_Metas>;
  /** An aggregate relationship */
  mx_merchant_payment_metas_aggregate: Mx_Merchant_Payment_Metas_Aggregate;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parent_payment_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  parking_authority_bank_account?: Maybe<Parking_Authority_Bank_Accounts>;
  parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  payment?: Maybe<Payments>;
  /** An object relationship */
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  payment_method?: Maybe<Payment_Methods>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  payment_methods: Array<Payment_Methods>;
  /** An aggregate relationship */
  payment_methods_aggregate: Payment_Methods_Aggregate;
  /** An array relationship */
  payment_wallet_transactions: Array<Payment_Wallet_Transaction>;
  /** An aggregate relationship */
  payment_wallet_transactions_aggregate: Payment_Wallet_Transaction_Aggregate;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  status: Scalars['String']['output'];
  /** An object relationship */
  transfer_batch?: Maybe<Transfer_Batches>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  try: Scalars['smallint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "payments" */
export type PaymentsLine_Item_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Payment_Order_By>>;
  where?: InputMaybe<Line_Item_Payment_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsLine_Item_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Payment_Order_By>>;
  where?: InputMaybe<Line_Item_Payment_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsMx_Merchant_Payment_MetasArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsMx_Merchant_Payment_Metas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsPayment_Wallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsPayment_Wallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** aggregated selection of "payments" */
export type Payments_Aggregate = {
  __typename?: 'payments_aggregate';
  aggregate?: Maybe<Payments_Aggregate_Fields>;
  nodes: Array<Payments>;
};

export type Payments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Payments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Payments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Payments_Aggregate_Bool_Exp_Count>;
};

export type Payments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Payments_Select_Column_Payments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Payments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Payments_Select_Column_Payments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Payments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payments" */
export type Payments_Aggregate_Fields = {
  __typename?: 'payments_aggregate_fields';
  avg?: Maybe<Payments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Payments_Max_Fields>;
  min?: Maybe<Payments_Min_Fields>;
  stddev?: Maybe<Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Payments_Sum_Fields>;
  var_pop?: Maybe<Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Payments_Var_Samp_Fields>;
  variance?: Maybe<Payments_Variance_Fields>;
};


/** aggregate fields of "payments" */
export type Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "payments" */
export type Payments_Aggregate_Order_By = {
  avg?: InputMaybe<Payments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payments_Max_Order_By>;
  min?: InputMaybe<Payments_Min_Order_By>;
  stddev?: InputMaybe<Payments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payments_Sum_Order_By>;
  var_pop?: InputMaybe<Payments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payments_Var_Samp_Order_By>;
  variance?: InputMaybe<Payments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payments" */
export type Payments_Arr_Rel_Insert_Input = {
  data: Array<Payments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};

/** aggregate avg on columns */
export type Payments_Avg_Fields = {
  __typename?: 'payments_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parent_payment_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "payments" */
export type Payments_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payments". All fields are combined with a logical 'AND'. */
export type Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Payments_Bool_Exp>>;
  _not?: InputMaybe<Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Payments_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  auth_only?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  invoice?: InputMaybe<Invoices_Bool_Exp>;
  invoice_id?: InputMaybe<Bigint_Comparison_Exp>;
  is_parking_authority_funds_transfer?: InputMaybe<Boolean_Comparison_Exp>;
  is_prefund?: InputMaybe<Boolean_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  line_item_payments?: InputMaybe<Line_Item_Payment_Bool_Exp>;
  line_item_payments_aggregate?: InputMaybe<Line_Item_Payment_Aggregate_Bool_Exp>;
  mx_merchant_payment_metas?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
  mx_merchant_payment_metas_aggregate?: InputMaybe<Mx_Merchant_Payment_Metas_Aggregate_Bool_Exp>;
  num_etl_failures?: InputMaybe<Smallint_Comparison_Exp>;
  num_etls?: InputMaybe<Bigint_Comparison_Exp>;
  parent_payment_id?: InputMaybe<Bigint_Comparison_Exp>;
  parking_authority_bank_account?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
  parking_authority_bank_account_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment?: InputMaybe<Payments_Bool_Exp>;
  payment_batch?: InputMaybe<Payment_Batches_Bool_Exp>;
  payment_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_method?: InputMaybe<Payment_Methods_Bool_Exp>;
  payment_method_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_methods?: InputMaybe<Payment_Methods_Bool_Exp>;
  payment_methods_aggregate?: InputMaybe<Payment_Methods_Aggregate_Bool_Exp>;
  payment_wallet_transactions?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
  payment_wallet_transactions_aggregate?: InputMaybe<Payment_Wallet_Transaction_Aggregate_Bool_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  transfer_batch?: InputMaybe<Transfer_Batches_Bool_Exp>;
  transfer_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  try?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "payments" */
export enum Payments_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentsPkey = 'payments_pkey'
}

/** input type for incrementing numeric columns in table "payments" */
export type Payments_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parent_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "payments" */
export type Payments_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  auth_only?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  invoice?: InputMaybe<Invoices_Obj_Rel_Insert_Input>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  is_parking_authority_funds_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  is_prefund?: InputMaybe<Scalars['Boolean']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  line_item_payments?: InputMaybe<Line_Item_Payment_Arr_Rel_Insert_Input>;
  mx_merchant_payment_metas?: InputMaybe<Mx_Merchant_Payment_Metas_Arr_Rel_Insert_Input>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parent_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_bank_account?: InputMaybe<Parking_Authority_Bank_Accounts_Obj_Rel_Insert_Input>;
  parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  payment?: InputMaybe<Payments_Obj_Rel_Insert_Input>;
  payment_batch?: InputMaybe<Payment_Batches_Obj_Rel_Insert_Input>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method?: InputMaybe<Payment_Methods_Obj_Rel_Insert_Input>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_methods?: InputMaybe<Payment_Methods_Arr_Rel_Insert_Input>;
  payment_wallet_transactions?: InputMaybe<Payment_Wallet_Transaction_Arr_Rel_Insert_Input>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_batch?: InputMaybe<Transfer_Batches_Obj_Rel_Insert_Input>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Payments_Max_Fields = {
  __typename?: 'payments_max_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parent_payment_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "payments" */
export type Payments_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payments_Min_Fields = {
  __typename?: 'payments_min_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parent_payment_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "payments" */
export type Payments_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payments" */
export type Payments_Mutation_Response = {
  __typename?: 'payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Payments>;
};

/** input type for inserting object relation for remote table "payments" */
export type Payments_Obj_Rel_Insert_Input = {
  data: Payments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};

/** on_conflict condition type for table "payments" */
export type Payments_On_Conflict = {
  constraint: Payments_Constraint;
  update_columns?: Array<Payments_Update_Column>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "payments". */
export type Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  auth_only?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoices_Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  is_parking_authority_funds_transfer?: InputMaybe<Order_By>;
  is_prefund?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  line_item_payments_aggregate?: InputMaybe<Line_Item_Payment_Aggregate_Order_By>;
  mx_merchant_payment_metas_aggregate?: InputMaybe<Mx_Merchant_Payment_Metas_Aggregate_Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account?: InputMaybe<Parking_Authority_Bank_Accounts_Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment?: InputMaybe<Payments_Order_By>;
  payment_batch?: InputMaybe<Payment_Batches_Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Payment_Methods_Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  payment_methods_aggregate?: InputMaybe<Payment_Methods_Aggregate_Order_By>;
  payment_wallet_transactions_aggregate?: InputMaybe<Payment_Wallet_Transaction_Aggregate_Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_batch?: InputMaybe<Transfer_Batches_Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payments */
export type Payments_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "payments" */
export enum Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AuthOnly = 'auth_only',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsParkingAuthorityFundsTransfer = 'is_parking_authority_funds_transfer',
  /** column name */
  IsPrefund = 'is_prefund',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  ParentPaymentId = 'parent_payment_id',
  /** column name */
  ParkingAuthorityBankAccountId = 'parking_authority_bank_account_id',
  /** column name */
  PaymentBatchId = 'payment_batch_id',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  Status = 'status',
  /** column name */
  TransferBatchId = 'transfer_batch_id',
  /** column name */
  Try = 'try',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "payments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "payments" */
export enum Payments_Select_Column_Payments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AuthOnly = 'auth_only',
  /** column name */
  IsParkingAuthorityFundsTransfer = 'is_parking_authority_funds_transfer',
  /** column name */
  IsPrefund = 'is_prefund'
}

/** select "payments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "payments" */
export enum Payments_Select_Column_Payments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AuthOnly = 'auth_only',
  /** column name */
  IsParkingAuthorityFundsTransfer = 'is_parking_authority_funds_transfer',
  /** column name */
  IsPrefund = 'is_prefund'
}

/** input type for updating data in table "payments" */
export type Payments_Set_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  auth_only?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  is_parking_authority_funds_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  is_prefund?: InputMaybe<Scalars['Boolean']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parent_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Payments_Stddev_Fields = {
  __typename?: 'payments_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parent_payment_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "payments" */
export type Payments_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payments_Stddev_Pop_Fields = {
  __typename?: 'payments_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parent_payment_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "payments" */
export type Payments_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payments_Stddev_Samp_Fields = {
  __typename?: 'payments_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parent_payment_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "payments" */
export type Payments_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payments" */
export type Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  auth_only?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  is_parking_authority_funds_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  is_prefund?: InputMaybe<Scalars['Boolean']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parent_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Payments_Sum_Fields = {
  __typename?: 'payments_sum_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parent_payment_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "payments" */
export type Payments_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** update columns of table "payments" */
export enum Payments_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AuthOnly = 'auth_only',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsParkingAuthorityFundsTransfer = 'is_parking_authority_funds_transfer',
  /** column name */
  IsPrefund = 'is_prefund',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  ParentPaymentId = 'parent_payment_id',
  /** column name */
  ParkingAuthorityBankAccountId = 'parking_authority_bank_account_id',
  /** column name */
  PaymentBatchId = 'payment_batch_id',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  Status = 'status',
  /** column name */
  TransferBatchId = 'transfer_batch_id',
  /** column name */
  Try = 'try',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Payments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payments_Var_Pop_Fields = {
  __typename?: 'payments_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parent_payment_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "payments" */
export type Payments_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payments_Var_Samp_Fields = {
  __typename?: 'payments_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parent_payment_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "payments" */
export type Payments_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payments_Variance_Fields = {
  __typename?: 'payments_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parent_payment_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "payments" */
export type Payments_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parent_payment_id?: InputMaybe<Order_By>;
  parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** columns and relationships of "pending_users" */
export type Pending_Users = {
  __typename?: 'pending_users';
  cognito_created_time?: Maybe<Scalars['timestamp']['output']>;
  cognito_enabled?: Maybe<Scalars['String']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  cognito_last_updated_time?: Maybe<Scalars['timestamp']['output']>;
  cognito_updated_at_attribute?: Maybe<Scalars['timestamp']['output']>;
  cognito_user_status?: Maybe<Scalars['String']['output']>;
  communication_opted_out_sms_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['json']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  ignore_until?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_proactive_outreach_response_sms_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_sms_at?: Maybe<Scalars['timestamp']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  parked: Scalars['Boolean']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "pending_users" */
export type Pending_UsersDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "pending_users" */
export type Pending_Users_Aggregate = {
  __typename?: 'pending_users_aggregate';
  aggregate?: Maybe<Pending_Users_Aggregate_Fields>;
  nodes: Array<Pending_Users>;
};

/** aggregate fields of "pending_users" */
export type Pending_Users_Aggregate_Fields = {
  __typename?: 'pending_users_aggregate_fields';
  avg?: Maybe<Pending_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pending_Users_Max_Fields>;
  min?: Maybe<Pending_Users_Min_Fields>;
  stddev?: Maybe<Pending_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Pending_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pending_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Pending_Users_Sum_Fields>;
  var_pop?: Maybe<Pending_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Pending_Users_Var_Samp_Fields>;
  variance?: Maybe<Pending_Users_Variance_Fields>;
};


/** aggregate fields of "pending_users" */
export type Pending_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pending_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pending_Users_Avg_Fields = {
  __typename?: 'pending_users_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "pending_users". All fields are combined with a logical 'AND'. */
export type Pending_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Pending_Users_Bool_Exp>>;
  _not?: InputMaybe<Pending_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Pending_Users_Bool_Exp>>;
  cognito_created_time?: InputMaybe<Timestamp_Comparison_Exp>;
  cognito_enabled?: InputMaybe<String_Comparison_Exp>;
  cognito_identity_id?: InputMaybe<String_Comparison_Exp>;
  cognito_last_updated_time?: InputMaybe<Timestamp_Comparison_Exp>;
  cognito_updated_at_attribute?: InputMaybe<Timestamp_Comparison_Exp>;
  cognito_user_status?: InputMaybe<String_Comparison_Exp>;
  communication_opted_out_sms_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  ignore_until?: InputMaybe<Timestamp_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  last_proactive_outreach_response_sms_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_proactive_outreach_sms_at?: InputMaybe<Timestamp_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  parked?: InputMaybe<Boolean_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "pending_users" */
export enum Pending_Users_Constraint {
  /** unique or primary key constraint on columns "cognito_identity_id" */
  PendingUsersCognitoIdentityIdUnique = 'pending_users_cognito_identity_id_unique',
  /** unique or primary key constraint on columns "phone_number" */
  PendingUsersPhoneNumberUnique = 'pending_users_phone_number_unique',
  /** unique or primary key constraint on columns "id" */
  PendingUsersPkey = 'pending_users_pkey',
  /** unique or primary key constraint on columns "user_id" */
  PendingUsersUserIdUnique = 'pending_users_user_id_unique'
}

/** input type for incrementing numeric columns in table "pending_users" */
export type Pending_Users_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "pending_users" */
export type Pending_Users_Insert_Input = {
  cognito_created_time?: InputMaybe<Scalars['timestamp']['input']>;
  cognito_enabled?: InputMaybe<Scalars['String']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  cognito_last_updated_time?: InputMaybe<Scalars['timestamp']['input']>;
  cognito_updated_at_attribute?: InputMaybe<Scalars['timestamp']['input']>;
  cognito_user_status?: InputMaybe<Scalars['String']['input']>;
  communication_opted_out_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ignore_until?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_proactive_outreach_response_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parked?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Pending_Users_Max_Fields = {
  __typename?: 'pending_users_max_fields';
  cognito_created_time?: Maybe<Scalars['timestamp']['output']>;
  cognito_enabled?: Maybe<Scalars['String']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  cognito_last_updated_time?: Maybe<Scalars['timestamp']['output']>;
  cognito_updated_at_attribute?: Maybe<Scalars['timestamp']['output']>;
  cognito_user_status?: Maybe<Scalars['String']['output']>;
  communication_opted_out_sms_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ignore_until?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_proactive_outreach_response_sms_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_sms_at?: Maybe<Scalars['timestamp']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Pending_Users_Min_Fields = {
  __typename?: 'pending_users_min_fields';
  cognito_created_time?: Maybe<Scalars['timestamp']['output']>;
  cognito_enabled?: Maybe<Scalars['String']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  cognito_last_updated_time?: Maybe<Scalars['timestamp']['output']>;
  cognito_updated_at_attribute?: Maybe<Scalars['timestamp']['output']>;
  cognito_user_status?: Maybe<Scalars['String']['output']>;
  communication_opted_out_sms_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ignore_until?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_proactive_outreach_response_sms_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_sms_at?: Maybe<Scalars['timestamp']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "pending_users" */
export type Pending_Users_Mutation_Response = {
  __typename?: 'pending_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pending_Users>;
};

/** on_conflict condition type for table "pending_users" */
export type Pending_Users_On_Conflict = {
  constraint: Pending_Users_Constraint;
  update_columns?: Array<Pending_Users_Update_Column>;
  where?: InputMaybe<Pending_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "pending_users". */
export type Pending_Users_Order_By = {
  cognito_created_time?: InputMaybe<Order_By>;
  cognito_enabled?: InputMaybe<Order_By>;
  cognito_identity_id?: InputMaybe<Order_By>;
  cognito_last_updated_time?: InputMaybe<Order_By>;
  cognito_updated_at_attribute?: InputMaybe<Order_By>;
  cognito_user_status?: InputMaybe<Order_By>;
  communication_opted_out_sms_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignore_until?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  last_proactive_outreach_response_sms_at?: InputMaybe<Order_By>;
  last_proactive_outreach_sms_at?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  parked?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pending_users */
export type Pending_Users_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "pending_users" */
export enum Pending_Users_Select_Column {
  /** column name */
  CognitoCreatedTime = 'cognito_created_time',
  /** column name */
  CognitoEnabled = 'cognito_enabled',
  /** column name */
  CognitoIdentityId = 'cognito_identity_id',
  /** column name */
  CognitoLastUpdatedTime = 'cognito_last_updated_time',
  /** column name */
  CognitoUpdatedAtAttribute = 'cognito_updated_at_attribute',
  /** column name */
  CognitoUserStatus = 'cognito_user_status',
  /** column name */
  CommunicationOptedOutSmsAt = 'communication_opted_out_sms_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoreUntil = 'ignore_until',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastProactiveOutreachResponseSmsAt = 'last_proactive_outreach_response_sms_at',
  /** column name */
  LastProactiveOutreachSmsAt = 'last_proactive_outreach_sms_at',
  /** column name */
  Note = 'note',
  /** column name */
  Parked = 'parked',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "pending_users" */
export type Pending_Users_Set_Input = {
  cognito_created_time?: InputMaybe<Scalars['timestamp']['input']>;
  cognito_enabled?: InputMaybe<Scalars['String']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  cognito_last_updated_time?: InputMaybe<Scalars['timestamp']['input']>;
  cognito_updated_at_attribute?: InputMaybe<Scalars['timestamp']['input']>;
  cognito_user_status?: InputMaybe<Scalars['String']['input']>;
  communication_opted_out_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ignore_until?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_proactive_outreach_response_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parked?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Pending_Users_Stddev_Fields = {
  __typename?: 'pending_users_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pending_Users_Stddev_Pop_Fields = {
  __typename?: 'pending_users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pending_Users_Stddev_Samp_Fields = {
  __typename?: 'pending_users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "pending_users" */
export type Pending_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pending_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pending_Users_Stream_Cursor_Value_Input = {
  cognito_created_time?: InputMaybe<Scalars['timestamp']['input']>;
  cognito_enabled?: InputMaybe<Scalars['String']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  cognito_last_updated_time?: InputMaybe<Scalars['timestamp']['input']>;
  cognito_updated_at_attribute?: InputMaybe<Scalars['timestamp']['input']>;
  cognito_user_status?: InputMaybe<Scalars['String']['input']>;
  communication_opted_out_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ignore_until?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_proactive_outreach_response_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parked?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Pending_Users_Sum_Fields = {
  __typename?: 'pending_users_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "pending_users" */
export enum Pending_Users_Update_Column {
  /** column name */
  CognitoCreatedTime = 'cognito_created_time',
  /** column name */
  CognitoEnabled = 'cognito_enabled',
  /** column name */
  CognitoIdentityId = 'cognito_identity_id',
  /** column name */
  CognitoLastUpdatedTime = 'cognito_last_updated_time',
  /** column name */
  CognitoUpdatedAtAttribute = 'cognito_updated_at_attribute',
  /** column name */
  CognitoUserStatus = 'cognito_user_status',
  /** column name */
  CommunicationOptedOutSmsAt = 'communication_opted_out_sms_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoreUntil = 'ignore_until',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastProactiveOutreachResponseSmsAt = 'last_proactive_outreach_response_sms_at',
  /** column name */
  LastProactiveOutreachSmsAt = 'last_proactive_outreach_sms_at',
  /** column name */
  Note = 'note',
  /** column name */
  Parked = 'parked',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Pending_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pending_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pending_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pending_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pending_Users_Var_Pop_Fields = {
  __typename?: 'pending_users_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pending_Users_Var_Samp_Fields = {
  __typename?: 'pending_users_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pending_Users_Variance_Fields = {
  __typename?: 'pending_users_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "personal_access_tokens" */
export type Personal_Access_Tokens = {
  __typename?: 'personal_access_tokens';
  abilities?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  last_used_at?: Maybe<Scalars['timestamp']['output']>;
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
  tokenable_id: Scalars['bigint']['output'];
  tokenable_type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "personal_access_tokens" */
export type Personal_Access_Tokens_Aggregate = {
  __typename?: 'personal_access_tokens_aggregate';
  aggregate?: Maybe<Personal_Access_Tokens_Aggregate_Fields>;
  nodes: Array<Personal_Access_Tokens>;
};

/** aggregate fields of "personal_access_tokens" */
export type Personal_Access_Tokens_Aggregate_Fields = {
  __typename?: 'personal_access_tokens_aggregate_fields';
  avg?: Maybe<Personal_Access_Tokens_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Personal_Access_Tokens_Max_Fields>;
  min?: Maybe<Personal_Access_Tokens_Min_Fields>;
  stddev?: Maybe<Personal_Access_Tokens_Stddev_Fields>;
  stddev_pop?: Maybe<Personal_Access_Tokens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Personal_Access_Tokens_Stddev_Samp_Fields>;
  sum?: Maybe<Personal_Access_Tokens_Sum_Fields>;
  var_pop?: Maybe<Personal_Access_Tokens_Var_Pop_Fields>;
  var_samp?: Maybe<Personal_Access_Tokens_Var_Samp_Fields>;
  variance?: Maybe<Personal_Access_Tokens_Variance_Fields>;
};


/** aggregate fields of "personal_access_tokens" */
export type Personal_Access_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Personal_Access_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Personal_Access_Tokens_Avg_Fields = {
  __typename?: 'personal_access_tokens_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "personal_access_tokens". All fields are combined with a logical 'AND'. */
export type Personal_Access_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Personal_Access_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Personal_Access_Tokens_Bool_Exp>>;
  abilities?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_used_at?: InputMaybe<Timestamp_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  tokenable_id?: InputMaybe<Bigint_Comparison_Exp>;
  tokenable_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "personal_access_tokens" */
export enum Personal_Access_Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  PersonalAccessTokensPkey = 'personal_access_tokens_pkey',
  /** unique or primary key constraint on columns "token" */
  PersonalAccessTokensTokenUnique = 'personal_access_tokens_token_unique'
}

/** input type for incrementing numeric columns in table "personal_access_tokens" */
export type Personal_Access_Tokens_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  tokenable_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "personal_access_tokens" */
export type Personal_Access_Tokens_Insert_Input = {
  abilities?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_used_at?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenable_id?: InputMaybe<Scalars['bigint']['input']>;
  tokenable_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Personal_Access_Tokens_Max_Fields = {
  __typename?: 'personal_access_tokens_max_fields';
  abilities?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_used_at?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenable_id?: Maybe<Scalars['bigint']['output']>;
  tokenable_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Personal_Access_Tokens_Min_Fields = {
  __typename?: 'personal_access_tokens_min_fields';
  abilities?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_used_at?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenable_id?: Maybe<Scalars['bigint']['output']>;
  tokenable_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "personal_access_tokens" */
export type Personal_Access_Tokens_Mutation_Response = {
  __typename?: 'personal_access_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Personal_Access_Tokens>;
};

/** on_conflict condition type for table "personal_access_tokens" */
export type Personal_Access_Tokens_On_Conflict = {
  constraint: Personal_Access_Tokens_Constraint;
  update_columns?: Array<Personal_Access_Tokens_Update_Column>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "personal_access_tokens". */
export type Personal_Access_Tokens_Order_By = {
  abilities?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  tokenable_id?: InputMaybe<Order_By>;
  tokenable_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: personal_access_tokens */
export type Personal_Access_Tokens_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "personal_access_tokens" */
export enum Personal_Access_Tokens_Select_Column {
  /** column name */
  Abilities = 'abilities',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  Name = 'name',
  /** column name */
  Token = 'token',
  /** column name */
  TokenableId = 'tokenable_id',
  /** column name */
  TokenableType = 'tokenable_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "personal_access_tokens" */
export type Personal_Access_Tokens_Set_Input = {
  abilities?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_used_at?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenable_id?: InputMaybe<Scalars['bigint']['input']>;
  tokenable_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Personal_Access_Tokens_Stddev_Fields = {
  __typename?: 'personal_access_tokens_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Personal_Access_Tokens_Stddev_Pop_Fields = {
  __typename?: 'personal_access_tokens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Personal_Access_Tokens_Stddev_Samp_Fields = {
  __typename?: 'personal_access_tokens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "personal_access_tokens" */
export type Personal_Access_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Personal_Access_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Personal_Access_Tokens_Stream_Cursor_Value_Input = {
  abilities?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_used_at?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenable_id?: InputMaybe<Scalars['bigint']['input']>;
  tokenable_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Personal_Access_Tokens_Sum_Fields = {
  __typename?: 'personal_access_tokens_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  tokenable_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "personal_access_tokens" */
export enum Personal_Access_Tokens_Update_Column {
  /** column name */
  Abilities = 'abilities',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  Name = 'name',
  /** column name */
  Token = 'token',
  /** column name */
  TokenableId = 'tokenable_id',
  /** column name */
  TokenableType = 'tokenable_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Personal_Access_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Personal_Access_Tokens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Personal_Access_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Personal_Access_Tokens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Personal_Access_Tokens_Var_Pop_Fields = {
  __typename?: 'personal_access_tokens_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Personal_Access_Tokens_Var_Samp_Fields = {
  __typename?: 'personal_access_tokens_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Personal_Access_Tokens_Variance_Fields = {
  __typename?: 'personal_access_tokens_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tokenable_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "public_keys" */
export type Public_Keys = {
  __typename?: 'public_keys';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  kid: Scalars['String']['output'];
  public_key: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "public_keys" */
export type Public_Keys_Aggregate = {
  __typename?: 'public_keys_aggregate';
  aggregate?: Maybe<Public_Keys_Aggregate_Fields>;
  nodes: Array<Public_Keys>;
};

/** aggregate fields of "public_keys" */
export type Public_Keys_Aggregate_Fields = {
  __typename?: 'public_keys_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Public_Keys_Max_Fields>;
  min?: Maybe<Public_Keys_Min_Fields>;
};


/** aggregate fields of "public_keys" */
export type Public_Keys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Public_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "public_keys". All fields are combined with a logical 'AND'. */
export type Public_Keys_Bool_Exp = {
  _and?: InputMaybe<Array<Public_Keys_Bool_Exp>>;
  _not?: InputMaybe<Public_Keys_Bool_Exp>;
  _or?: InputMaybe<Array<Public_Keys_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  kid?: InputMaybe<String_Comparison_Exp>;
  public_key?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "public_keys" */
export enum Public_Keys_Constraint {
  /** unique or primary key constraint on columns "kid" */
  PublicKeysKidUnique = 'public_keys_kid_unique'
}

/** input type for inserting data into table "public_keys" */
export type Public_Keys_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  kid?: InputMaybe<Scalars['String']['input']>;
  public_key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Public_Keys_Max_Fields = {
  __typename?: 'public_keys_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  kid?: Maybe<Scalars['String']['output']>;
  public_key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Public_Keys_Min_Fields = {
  __typename?: 'public_keys_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  kid?: Maybe<Scalars['String']['output']>;
  public_key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "public_keys" */
export type Public_Keys_Mutation_Response = {
  __typename?: 'public_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Public_Keys>;
};

/** on_conflict condition type for table "public_keys" */
export type Public_Keys_On_Conflict = {
  constraint: Public_Keys_Constraint;
  update_columns?: Array<Public_Keys_Update_Column>;
  where?: InputMaybe<Public_Keys_Bool_Exp>;
};

/** Ordering options when selecting data from "public_keys". */
export type Public_Keys_Order_By = {
  created_at?: InputMaybe<Order_By>;
  kid?: InputMaybe<Order_By>;
  public_key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "public_keys" */
export enum Public_Keys_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Kid = 'kid',
  /** column name */
  PublicKey = 'public_key',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "public_keys" */
export type Public_Keys_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  kid?: InputMaybe<Scalars['String']['input']>;
  public_key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "public_keys" */
export type Public_Keys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Public_Keys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Public_Keys_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  kid?: InputMaybe<Scalars['String']['input']>;
  public_key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "public_keys" */
export enum Public_Keys_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Kid = 'kid',
  /** column name */
  PublicKey = 'public_key',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Public_Keys_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Public_Keys_Set_Input>;
  /** filter the rows which have to be updated */
  where: Public_Keys_Bool_Exp;
};

/** columns and relationships of "qr_codes" */
export type Qr_Codes = {
  __typename?: 'qr_codes';
  code_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  medium?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  parkable_qr_codes: Array<Parkable_Qr_Code>;
  /** An aggregate relationship */
  parkable_qr_codes_aggregate: Parkable_Qr_Code_Aggregate;
  scans: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "qr_codes" */
export type Qr_CodesParkable_Qr_CodesArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Qr_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Qr_Code_Order_By>>;
  where?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
};


/** columns and relationships of "qr_codes" */
export type Qr_CodesParkable_Qr_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Qr_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Qr_Code_Order_By>>;
  where?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
};

/** aggregated selection of "qr_codes" */
export type Qr_Codes_Aggregate = {
  __typename?: 'qr_codes_aggregate';
  aggregate?: Maybe<Qr_Codes_Aggregate_Fields>;
  nodes: Array<Qr_Codes>;
};

/** aggregate fields of "qr_codes" */
export type Qr_Codes_Aggregate_Fields = {
  __typename?: 'qr_codes_aggregate_fields';
  avg?: Maybe<Qr_Codes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Qr_Codes_Max_Fields>;
  min?: Maybe<Qr_Codes_Min_Fields>;
  stddev?: Maybe<Qr_Codes_Stddev_Fields>;
  stddev_pop?: Maybe<Qr_Codes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Qr_Codes_Stddev_Samp_Fields>;
  sum?: Maybe<Qr_Codes_Sum_Fields>;
  var_pop?: Maybe<Qr_Codes_Var_Pop_Fields>;
  var_samp?: Maybe<Qr_Codes_Var_Samp_Fields>;
  variance?: Maybe<Qr_Codes_Variance_Fields>;
};


/** aggregate fields of "qr_codes" */
export type Qr_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Qr_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Qr_Codes_Avg_Fields = {
  __typename?: 'qr_codes_avg_fields';
  code_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  scans?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "qr_codes". All fields are combined with a logical 'AND'. */
export type Qr_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Qr_Codes_Bool_Exp>>;
  _not?: InputMaybe<Qr_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Qr_Codes_Bool_Exp>>;
  code_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  medium?: InputMaybe<String_Comparison_Exp>;
  parkable_qr_codes?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
  parkable_qr_codes_aggregate?: InputMaybe<Parkable_Qr_Code_Aggregate_Bool_Exp>;
  scans?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "qr_codes" */
export enum Qr_Codes_Constraint {
  /** unique or primary key constraint on columns "id" */
  QrCodesPkey = 'qr_codes_pkey'
}

/** input type for incrementing numeric columns in table "qr_codes" */
export type Qr_Codes_Inc_Input = {
  code_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  scans?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "qr_codes" */
export type Qr_Codes_Insert_Input = {
  code_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  parkable_qr_codes?: InputMaybe<Parkable_Qr_Code_Arr_Rel_Insert_Input>;
  scans?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Qr_Codes_Max_Fields = {
  __typename?: 'qr_codes_max_fields';
  code_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  scans?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Qr_Codes_Min_Fields = {
  __typename?: 'qr_codes_min_fields';
  code_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  scans?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "qr_codes" */
export type Qr_Codes_Mutation_Response = {
  __typename?: 'qr_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Qr_Codes>;
};

/** input type for inserting object relation for remote table "qr_codes" */
export type Qr_Codes_Obj_Rel_Insert_Input = {
  data: Qr_Codes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Qr_Codes_On_Conflict>;
};

/** on_conflict condition type for table "qr_codes" */
export type Qr_Codes_On_Conflict = {
  constraint: Qr_Codes_Constraint;
  update_columns?: Array<Qr_Codes_Update_Column>;
  where?: InputMaybe<Qr_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "qr_codes". */
export type Qr_Codes_Order_By = {
  code_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medium?: InputMaybe<Order_By>;
  parkable_qr_codes_aggregate?: InputMaybe<Parkable_Qr_Code_Aggregate_Order_By>;
  scans?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: qr_codes */
export type Qr_Codes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "qr_codes" */
export enum Qr_Codes_Select_Column {
  /** column name */
  CodeId = 'code_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Medium = 'medium',
  /** column name */
  Scans = 'scans',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "qr_codes" */
export type Qr_Codes_Set_Input = {
  code_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  scans?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Qr_Codes_Stddev_Fields = {
  __typename?: 'qr_codes_stddev_fields';
  code_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  scans?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Qr_Codes_Stddev_Pop_Fields = {
  __typename?: 'qr_codes_stddev_pop_fields';
  code_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  scans?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Qr_Codes_Stddev_Samp_Fields = {
  __typename?: 'qr_codes_stddev_samp_fields';
  code_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  scans?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "qr_codes" */
export type Qr_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Qr_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Qr_Codes_Stream_Cursor_Value_Input = {
  code_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  scans?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Qr_Codes_Sum_Fields = {
  __typename?: 'qr_codes_sum_fields';
  code_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  scans?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "qr_codes" */
export enum Qr_Codes_Update_Column {
  /** column name */
  CodeId = 'code_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Medium = 'medium',
  /** column name */
  Scans = 'scans',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Qr_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Qr_Codes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Qr_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Qr_Codes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Qr_Codes_Var_Pop_Fields = {
  __typename?: 'qr_codes_var_pop_fields';
  code_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  scans?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Qr_Codes_Var_Samp_Fields = {
  __typename?: 'qr_codes_var_samp_fields';
  code_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  scans?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Qr_Codes_Variance_Fields = {
  __typename?: 'qr_codes_variance_fields';
  code_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  scans?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  adEventsByInterval?: Maybe<AdEventsByIntervalOutput>;
  /** fetch data from the table: "ad_campaign_admin_user" */
  ad_campaign_admin_user: Array<Ad_Campaign_Admin_User>;
  /** fetch aggregated fields from the table: "ad_campaign_admin_user" */
  ad_campaign_admin_user_aggregate: Ad_Campaign_Admin_User_Aggregate;
  /** fetch data from the table: "ad_campaign_parking_authority" */
  ad_campaign_parking_authority: Array<Ad_Campaign_Parking_Authority>;
  /** fetch aggregated fields from the table: "ad_campaign_parking_authority" */
  ad_campaign_parking_authority_aggregate: Ad_Campaign_Parking_Authority_Aggregate;
  /** fetch data from the table: "ad_campaigns" */
  ad_campaigns: Array<Ad_Campaigns>;
  /** fetch aggregated fields from the table: "ad_campaigns" */
  ad_campaigns_aggregate: Ad_Campaigns_Aggregate;
  /** fetch data from the table: "ad_campaigns" using primary key columns */
  ad_campaigns_by_pk?: Maybe<Ad_Campaigns>;
  /** An array relationship */
  ad_events: Array<Ad_Events>;
  /** An aggregate relationship */
  ad_events_aggregate: Ad_Events_Aggregate;
  /** fetch data from the table: "ad_events" using primary key columns */
  ad_events_by_pk?: Maybe<Ad_Events>;
  /** An array relationship */
  ad_variants: Array<Ad_Variants>;
  /** An aggregate relationship */
  ad_variants_aggregate: Ad_Variants_Aggregate;
  /** fetch data from the table: "ad_variants" using primary key columns */
  ad_variants_by_pk?: Maybe<Ad_Variants>;
  /** fetch data from the table: "admin_user_parking_authority" */
  admin_user_parking_authority: Array<Admin_User_Parking_Authority>;
  /** fetch aggregated fields from the table: "admin_user_parking_authority" */
  admin_user_parking_authority_aggregate: Admin_User_Parking_Authority_Aggregate;
  /** fetch data from the table: "admin_users" */
  admin_users: Array<Admin_Users>;
  /** fetch aggregated fields from the table: "admin_users" */
  admin_users_aggregate: Admin_Users_Aggregate;
  /** fetch data from the table: "admin_users" using primary key columns */
  admin_users_by_pk?: Maybe<Admin_Users>;
  /** An array relationship */
  ads: Array<Ads>;
  /** An aggregate relationship */
  ads_aggregate: Ads_Aggregate;
  /** fetch data from the table: "ads" using primary key columns */
  ads_by_pk?: Maybe<Ads>;
  /** fetch data from the table: "batch_sets" */
  batch_sets: Array<Batch_Sets>;
  /** fetch aggregated fields from the table: "batch_sets" */
  batch_sets_aggregate: Batch_Sets_Aggregate;
  /** fetch data from the table: "batch_sets" using primary key columns */
  batch_sets_by_pk?: Maybe<Batch_Sets>;
  /** An array relationship */
  blacklisted_credentials: Array<Blacklisted_Credentials>;
  /** An aggregate relationship */
  blacklisted_credentials_aggregate: Blacklisted_Credentials_Aggregate;
  /** fetch data from the table: "blacklisted_credentials" using primary key columns */
  blacklisted_credentials_by_pk?: Maybe<Blacklisted_Credentials>;
  config?: Maybe<ConfigOutput>;
  configV2?: Maybe<ConfigV2Output>;
  /** fetch data from the table: "device_user" */
  device_user: Array<Device_User>;
  /** fetch aggregated fields from the table: "device_user" */
  device_user_aggregate: Device_User_Aggregate;
  /** fetch data from the table: "device_user" using primary key columns */
  device_user_by_pk?: Maybe<Device_User>;
  /** fetch data from the table: "devices" */
  devices: Array<Devices>;
  /** fetch aggregated fields from the table: "devices" */
  devices_aggregate: Devices_Aggregate;
  /** fetch data from the table: "devices" using primary key columns */
  devices_by_pk?: Maybe<Devices>;
  /** fetch data from the table: "events" */
  events: Array<Events>;
  /** fetch aggregated fields from the table: "events" */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** fetch data from the table: "failed_jobs" */
  failed_jobs: Array<Failed_Jobs>;
  /** fetch aggregated fields from the table: "failed_jobs" */
  failed_jobs_aggregate: Failed_Jobs_Aggregate;
  /** fetch data from the table: "failed_jobs" using primary key columns */
  failed_jobs_by_pk?: Maybe<Failed_Jobs>;
  /** fetch data from the table: "failed_sentry_messages" */
  failed_sentry_messages: Array<Failed_Sentry_Messages>;
  /** fetch aggregated fields from the table: "failed_sentry_messages" */
  failed_sentry_messages_aggregate: Failed_Sentry_Messages_Aggregate;
  /** fetch data from the table: "failed_sentry_messages" using primary key columns */
  failed_sentry_messages_by_pk?: Maybe<Failed_Sentry_Messages>;
  /** An array relationship */
  identities: Array<Identities>;
  /** An aggregate relationship */
  identities_aggregate: Identities_Aggregate;
  /** fetch data from the table: "identities" using primary key columns */
  identities_by_pk?: Maybe<Identities>;
  /** fetch data from the table: "invoice_parkable_transaction" */
  invoice_parkable_transaction: Array<Invoice_Parkable_Transaction>;
  /** fetch aggregated fields from the table: "invoice_parkable_transaction" */
  invoice_parkable_transaction_aggregate: Invoice_Parkable_Transaction_Aggregate;
  /** fetch data from the table: "invoice_parkable_transaction" using primary key columns */
  invoice_parkable_transaction_by_pk?: Maybe<Invoice_Parkable_Transaction>;
  /** fetch data from the table: "invoice_wallet_transaction" */
  invoice_wallet_transaction: Array<Invoice_Wallet_Transaction>;
  /** fetch aggregated fields from the table: "invoice_wallet_transaction" */
  invoice_wallet_transaction_aggregate: Invoice_Wallet_Transaction_Aggregate;
  /** fetch data from the table: "invoice_wallet_transaction" using primary key columns */
  invoice_wallet_transaction_by_pk?: Maybe<Invoice_Wallet_Transaction>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table: "jobs" */
  jobs: Array<Jobs>;
  /** fetch aggregated fields from the table: "jobs" */
  jobs_aggregate: Jobs_Aggregate;
  /** fetch data from the table: "jobs" using primary key columns */
  jobs_by_pk?: Maybe<Jobs>;
  /** An array relationship */
  legacy_migrations: Array<Legacy_Migrations>;
  /** An aggregate relationship */
  legacy_migrations_aggregate: Legacy_Migrations_Aggregate;
  /** fetch data from the table: "legacy_migrations" using primary key columns */
  legacy_migrations_by_pk?: Maybe<Legacy_Migrations>;
  /** fetch data from the table: "legacy_parkable_transactions" */
  legacy_parkable_transactions: Array<Legacy_Parkable_Transactions>;
  /** fetch aggregated fields from the table: "legacy_parkable_transactions" */
  legacy_parkable_transactions_aggregate: Legacy_Parkable_Transactions_Aggregate;
  /** fetch data from the table: "legacy_payments" */
  legacy_payments: Array<Legacy_Payments>;
  /** fetch aggregated fields from the table: "legacy_payments" */
  legacy_payments_aggregate: Legacy_Payments_Aggregate;
  /** fetch data from the table: "legacy_wallet_transactions" */
  legacy_wallet_transactions: Array<Legacy_Wallet_Transactions>;
  /** fetch aggregated fields from the table: "legacy_wallet_transactions" */
  legacy_wallet_transactions_aggregate: Legacy_Wallet_Transactions_Aggregate;
  /** fetch data from the table: "line_item_parkable_transaction" */
  line_item_parkable_transaction: Array<Line_Item_Parkable_Transaction>;
  /** fetch aggregated fields from the table: "line_item_parkable_transaction" */
  line_item_parkable_transaction_aggregate: Line_Item_Parkable_Transaction_Aggregate;
  /** fetch data from the table: "line_item_payment" */
  line_item_payment: Array<Line_Item_Payment>;
  /** fetch aggregated fields from the table: "line_item_payment" */
  line_item_payment_aggregate: Line_Item_Payment_Aggregate;
  /** fetch data from the table: "line_item_payment" using primary key columns */
  line_item_payment_by_pk?: Maybe<Line_Item_Payment>;
  /** fetch data from the table: "line_item_wallet_transaction" */
  line_item_wallet_transaction: Array<Line_Item_Wallet_Transaction>;
  /** fetch aggregated fields from the table: "line_item_wallet_transaction" */
  line_item_wallet_transaction_aggregate: Line_Item_Wallet_Transaction_Aggregate;
  /** fetch data from the table: "line_item_wallet_transaction" using primary key columns */
  line_item_wallet_transaction_by_pk?: Maybe<Line_Item_Wallet_Transaction>;
  /** An array relationship */
  line_items: Array<Line_Items>;
  /** An aggregate relationship */
  line_items_aggregate: Line_Items_Aggregate;
  /** fetch data from the table: "line_items" using primary key columns */
  line_items_by_pk?: Maybe<Line_Items>;
  /** fetch data from the table: "login_codes" */
  login_codes: Array<Login_Codes>;
  /** fetch aggregated fields from the table: "login_codes" */
  login_codes_aggregate: Login_Codes_Aggregate;
  /** fetch data from the table: "login_codes" using primary key columns */
  login_codes_by_pk?: Maybe<Login_Codes>;
  /** fetch data from the table: "migrations" */
  migrations: Array<Migrations>;
  /** fetch aggregated fields from the table: "migrations" */
  migrations_aggregate: Migrations_Aggregate;
  /** fetch data from the table: "migrations" using primary key columns */
  migrations_by_pk?: Maybe<Migrations>;
  /** fetch data from the table: "mx_merchant_pa_bank_account_metas" */
  mx_merchant_pa_bank_account_metas: Array<Mx_Merchant_Pa_Bank_Account_Metas>;
  /** fetch aggregated fields from the table: "mx_merchant_pa_bank_account_metas" */
  mx_merchant_pa_bank_account_metas_aggregate: Mx_Merchant_Pa_Bank_Account_Metas_Aggregate;
  /** fetch data from the table: "mx_merchant_pa_bank_account_metas" using primary key columns */
  mx_merchant_pa_bank_account_metas_by_pk?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas>;
  /** fetch data from the table: "mx_merchant_payment_batch_metas" */
  mx_merchant_payment_batch_metas: Array<Mx_Merchant_Payment_Batch_Metas>;
  /** fetch aggregated fields from the table: "mx_merchant_payment_batch_metas" */
  mx_merchant_payment_batch_metas_aggregate: Mx_Merchant_Payment_Batch_Metas_Aggregate;
  /** fetch data from the table: "mx_merchant_payment_batch_metas" using primary key columns */
  mx_merchant_payment_batch_metas_by_pk?: Maybe<Mx_Merchant_Payment_Batch_Metas>;
  /** An array relationship */
  mx_merchant_payment_metas: Array<Mx_Merchant_Payment_Metas>;
  /** An aggregate relationship */
  mx_merchant_payment_metas_aggregate: Mx_Merchant_Payment_Metas_Aggregate;
  /** fetch data from the table: "mx_merchant_payment_metas" using primary key columns */
  mx_merchant_payment_metas_by_pk?: Maybe<Mx_Merchant_Payment_Metas>;
  /** An array relationship */
  mx_merchant_payment_method_metas: Array<Mx_Merchant_Payment_Method_Metas>;
  /** An aggregate relationship */
  mx_merchant_payment_method_metas_aggregate: Mx_Merchant_Payment_Method_Metas_Aggregate;
  /** fetch data from the table: "mx_merchant_payment_method_metas" using primary key columns */
  mx_merchant_payment_method_metas_by_pk?: Maybe<Mx_Merchant_Payment_Method_Metas>;
  parkableTransactionTaskDetails?: Maybe<ParkTaskDetailsOutput>;
  /** fetch data from the table: "parkable_group_parkable_schedule" */
  parkable_group_parkable_schedule: Array<Parkable_Group_Parkable_Schedule>;
  /** fetch aggregated fields from the table: "parkable_group_parkable_schedule" */
  parkable_group_parkable_schedule_aggregate: Parkable_Group_Parkable_Schedule_Aggregate;
  /** fetch data from the table: "parkable_group_parkable_schedule" using primary key columns */
  parkable_group_parkable_schedule_by_pk?: Maybe<Parkable_Group_Parkable_Schedule>;
  /** An array relationship */
  parkable_groups: Array<Parkable_Groups>;
  /** An aggregate relationship */
  parkable_groups_aggregate: Parkable_Groups_Aggregate;
  /** fetch data from the table: "parkable_groups" using primary key columns */
  parkable_groups_by_pk?: Maybe<Parkable_Groups>;
  /** fetch data from the table: "parkable_parkable_group" */
  parkable_parkable_group: Array<Parkable_Parkable_Group>;
  /** fetch aggregated fields from the table: "parkable_parkable_group" */
  parkable_parkable_group_aggregate: Parkable_Parkable_Group_Aggregate;
  /** fetch data from the table: "parkable_parkable_group" using primary key columns */
  parkable_parkable_group_by_pk?: Maybe<Parkable_Parkable_Group>;
  /** fetch data from the table: "parkable_qr_code" */
  parkable_qr_code: Array<Parkable_Qr_Code>;
  /** fetch aggregated fields from the table: "parkable_qr_code" */
  parkable_qr_code_aggregate: Parkable_Qr_Code_Aggregate;
  /** An array relationship */
  parkable_schedules: Array<Parkable_Schedules>;
  /** An aggregate relationship */
  parkable_schedules_aggregate: Parkable_Schedules_Aggregate;
  /** fetch data from the table: "parkable_schedules" using primary key columns */
  parkable_schedules_by_pk?: Maybe<Parkable_Schedules>;
  /** fetch data from the table: "parkable_transaction_task" */
  parkable_transaction_task: Array<Parkable_Transaction_Task>;
  /** fetch aggregated fields from the table: "parkable_transaction_task" */
  parkable_transaction_task_aggregate: Parkable_Transaction_Task_Aggregate;
  /** fetch data from the table: "parkable_transaction_task" using primary key columns */
  parkable_transaction_task_by_pk?: Maybe<Parkable_Transaction_Task>;
  /** fetch data from the table: "parkable_transaction_wallet_transaction" */
  parkable_transaction_wallet_transaction: Array<Parkable_Transaction_Wallet_Transaction>;
  /** fetch aggregated fields from the table: "parkable_transaction_wallet_transaction" */
  parkable_transaction_wallet_transaction_aggregate: Parkable_Transaction_Wallet_Transaction_Aggregate;
  /** fetch data from the table: "parkable_transaction_wallet_transaction" using primary key columns */
  parkable_transaction_wallet_transaction_by_pk?: Maybe<Parkable_Transaction_Wallet_Transaction>;
  /** An array relationship */
  parkable_transactions: Array<Parkable_Transactions>;
  /** An aggregate relationship */
  parkable_transactions_aggregate: Parkable_Transactions_Aggregate;
  /** fetch data from the table: "parkable_transactions" using primary key columns */
  parkable_transactions_by_pk?: Maybe<Parkable_Transactions>;
  /** An array relationship */
  parkables: Array<Parkables>;
  /** An aggregate relationship */
  parkables_aggregate: Parkables_Aggregate;
  /** fetch data from the table: "parkables" using primary key columns */
  parkables_by_pk?: Maybe<Parkables>;
  /** fetch data from the table: "parking_authorities" */
  parking_authorities: Array<Parking_Authorities>;
  /** fetch aggregated fields from the table: "parking_authorities" */
  parking_authorities_aggregate: Parking_Authorities_Aggregate;
  /** fetch data from the table: "parking_authorities" using primary key columns */
  parking_authorities_by_pk?: Maybe<Parking_Authorities>;
  /** An array relationship */
  parking_authority_bank_accounts: Array<Parking_Authority_Bank_Accounts>;
  /** An aggregate relationship */
  parking_authority_bank_accounts_aggregate: Parking_Authority_Bank_Accounts_Aggregate;
  /** fetch data from the table: "parking_authority_bank_accounts" using primary key columns */
  parking_authority_bank_accounts_by_pk?: Maybe<Parking_Authority_Bank_Accounts>;
  /** An array relationship */
  parking_authority_settings: Array<Parking_Authority_Settings>;
  /** An aggregate relationship */
  parking_authority_settings_aggregate: Parking_Authority_Settings_Aggregate;
  /** fetch data from the table: "parking_authority_settings" using primary key columns */
  parking_authority_settings_by_pk?: Maybe<Parking_Authority_Settings>;
  /** fetch data from the table: "parking_authority_user" */
  parking_authority_user: Array<Parking_Authority_User>;
  /** fetch aggregated fields from the table: "parking_authority_user" */
  parking_authority_user_aggregate: Parking_Authority_User_Aggregate;
  /** fetch data from the table: "parking_authority_user" using primary key columns */
  parking_authority_user_by_pk?: Maybe<Parking_Authority_User>;
  /** An array relationship */
  payment_batches: Array<Payment_Batches>;
  /** An aggregate relationship */
  payment_batches_aggregate: Payment_Batches_Aggregate;
  /** fetch data from the table: "payment_batches" using primary key columns */
  payment_batches_by_pk?: Maybe<Payment_Batches>;
  /** An array relationship */
  payment_methods: Array<Payment_Methods>;
  /** An aggregate relationship */
  payment_methods_aggregate: Payment_Methods_Aggregate;
  /** fetch data from the table: "payment_methods" using primary key columns */
  payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** fetch data from the table: "payment_wallet_transaction" */
  payment_wallet_transaction: Array<Payment_Wallet_Transaction>;
  /** fetch aggregated fields from the table: "payment_wallet_transaction" */
  payment_wallet_transaction_aggregate: Payment_Wallet_Transaction_Aggregate;
  /** fetch data from the table: "payment_wallet_transaction" using primary key columns */
  payment_wallet_transaction_by_pk?: Maybe<Payment_Wallet_Transaction>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** fetch data from the table: "pending_users" */
  pending_users: Array<Pending_Users>;
  /** fetch aggregated fields from the table: "pending_users" */
  pending_users_aggregate: Pending_Users_Aggregate;
  /** fetch data from the table: "pending_users" using primary key columns */
  pending_users_by_pk?: Maybe<Pending_Users>;
  /** fetch data from the table: "personal_access_tokens" */
  personal_access_tokens: Array<Personal_Access_Tokens>;
  /** fetch aggregated fields from the table: "personal_access_tokens" */
  personal_access_tokens_aggregate: Personal_Access_Tokens_Aggregate;
  /** fetch data from the table: "personal_access_tokens" using primary key columns */
  personal_access_tokens_by_pk?: Maybe<Personal_Access_Tokens>;
  preAuthenticationCheck: PreAuthenticationCheckOutput;
  promos?: Maybe<PromosOutput>;
  /** fetch data from the table: "public_keys" */
  public_keys: Array<Public_Keys>;
  /** fetch aggregated fields from the table: "public_keys" */
  public_keys_aggregate: Public_Keys_Aggregate;
  /** fetch data from the table: "qr_codes" */
  qr_codes: Array<Qr_Codes>;
  /** fetch aggregated fields from the table: "qr_codes" */
  qr_codes_aggregate: Qr_Codes_Aggregate;
  /** fetch data from the table: "qr_codes" using primary key columns */
  qr_codes_by_pk?: Maybe<Qr_Codes>;
  /** fetch data from the table: "r_line_item_payments" */
  r_line_item_payments: Array<R_Line_Item_Payments>;
  /** fetch aggregated fields from the table: "r_line_item_payments" */
  r_line_item_payments_aggregate: R_Line_Item_Payments_Aggregate;
  /** fetch data from the table: "r_line_item_payments" using primary key columns */
  r_line_item_payments_by_pk?: Maybe<R_Line_Item_Payments>;
  /** fetch data from the table: "r_parkable_transactions" */
  r_parkable_transactions: Array<R_Parkable_Transactions>;
  /** fetch aggregated fields from the table: "r_parkable_transactions" */
  r_parkable_transactions_aggregate: R_Parkable_Transactions_Aggregate;
  /** fetch data from the table: "r_parkable_transactions" using primary key columns */
  r_parkable_transactions_by_pk?: Maybe<R_Parkable_Transactions>;
  /** fetch data from the table: "r_parking_authorities" */
  r_parking_authorities: Array<R_Parking_Authorities>;
  /** fetch aggregated fields from the table: "r_parking_authorities" */
  r_parking_authorities_aggregate: R_Parking_Authorities_Aggregate;
  /** fetch data from the table: "r_parking_authorities" using primary key columns */
  r_parking_authorities_by_pk?: Maybe<R_Parking_Authorities>;
  /** fetch data from the table: "r_payment_batches" */
  r_payment_batches: Array<R_Payment_Batches>;
  /** fetch aggregated fields from the table: "r_payment_batches" */
  r_payment_batches_aggregate: R_Payment_Batches_Aggregate;
  /** fetch data from the table: "r_payment_batches" using primary key columns */
  r_payment_batches_by_pk?: Maybe<R_Payment_Batches>;
  /** fetch data from the table: "r_transfer_batches" */
  r_transfer_batches: Array<R_Transfer_Batches>;
  /** fetch aggregated fields from the table: "r_transfer_batches" */
  r_transfer_batches_aggregate: R_Transfer_Batches_Aggregate;
  /** fetch data from the table: "r_transfer_batches" using primary key columns */
  r_transfer_batches_by_pk?: Maybe<R_Transfer_Batches>;
  /** fetch data from the table: "r_users" */
  r_users: Array<R_Users>;
  /** fetch aggregated fields from the table: "r_users" */
  r_users_aggregate: R_Users_Aggregate;
  /** fetch data from the table: "r_users" using primary key columns */
  r_users_by_pk?: Maybe<R_Users>;
  /** An array relationship */
  reports: Array<Reports>;
  /** An aggregate relationship */
  reports_aggregate: Reports_Aggregate;
  /** fetch data from the table: "reports" using primary key columns */
  reports_by_pk?: Maybe<Reports>;
  searchAccounts: SearchAccountsOutput;
  /** fetch data from the table: "session_overlap_results" */
  session_overlap_results: Array<Session_Overlap_Results>;
  /** fetch aggregated fields from the table: "session_overlap_results" */
  session_overlap_results_aggregate: Session_Overlap_Results_Aggregate;
  /** fetch data from the table: "session_overlap_results" using primary key columns */
  session_overlap_results_by_pk?: Maybe<Session_Overlap_Results>;
  /** An array relationship */
  support_tickets: Array<Support_Tickets>;
  /** An aggregate relationship */
  support_tickets_aggregate: Support_Tickets_Aggregate;
  /** fetch data from the table: "support_tickets" using primary key columns */
  support_tickets_by_pk?: Maybe<Support_Tickets>;
  systemOverview?: Maybe<SystemOverviewOutput>;
  systemStatus?: Maybe<SystemStatusOutput>;
  /** An array relationship */
  task_events: Array<Task_Events>;
  /** An aggregate relationship */
  task_events_aggregate: Task_Events_Aggregate;
  /** fetch data from the table: "task_events" using primary key columns */
  task_events_by_pk?: Maybe<Task_Events>;
  /** An array relationship */
  task_states: Array<Task_States>;
  /** An aggregate relationship */
  task_states_aggregate: Task_States_Aggregate;
  /** fetch data from the table: "task_states" using primary key columns */
  task_states_by_pk?: Maybe<Task_States>;
  /** fetch data from the table: "task_user" */
  task_user: Array<Task_User>;
  /** fetch aggregated fields from the table: "task_user" */
  task_user_aggregate: Task_User_Aggregate;
  /** fetch data from the table: "task_user" using primary key columns */
  task_user_by_pk?: Maybe<Task_User>;
  /** fetch data from the table: "tasks" */
  tasks: Array<Tasks>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: Tasks_Aggregate;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: Maybe<Tasks>;
  /** Test Local API */
  test?: Maybe<TestOutput>;
  /** An array relationship */
  transfer_batches: Array<Transfer_Batches>;
  /** An aggregate relationship */
  transfer_batches_aggregate: Transfer_Batches_Aggregate;
  /** fetch data from the table: "transfer_batches" using primary key columns */
  transfer_batches_by_pk?: Maybe<Transfer_Batches>;
  transfersOverview?: Maybe<TransfersOverviewOutput>;
  /** An array relationship */
  user_activities: Array<User_Activities>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activities_Aggregate;
  /** fetch data from the table: "user_activities" using primary key columns */
  user_activities_by_pk?: Maybe<User_Activities>;
  /** fetch data from the table: "user_lists" */
  user_lists: Array<User_Lists>;
  /** fetch aggregated fields from the table: "user_lists" */
  user_lists_aggregate: User_Lists_Aggregate;
  /** fetch data from the table: "user_lists" using primary key columns */
  user_lists_by_pk?: Maybe<User_Lists>;
  /** An array relationship */
  user_settings: Array<User_Settings>;
  /** An aggregate relationship */
  user_settings_aggregate: User_Settings_Aggregate;
  /** fetch data from the table: "user_settings_all" */
  user_settings_all: Array<User_Settings_All>;
  /** fetch aggregated fields from the table: "user_settings_all" */
  user_settings_all_aggregate: User_Settings_All_Aggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  user_settings_by_pk?: Maybe<User_Settings>;
  /** fetch data from the table: "user_user_list" */
  user_user_list: Array<User_User_List>;
  /** fetch aggregated fields from the table: "user_user_list" */
  user_user_list_aggregate: User_User_List_Aggregate;
  /** fetch data from the table: "user_user_list" using primary key columns */
  user_user_list_by_pk?: Maybe<User_User_List>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** An array relationship */
  vehicles: Array<Vehicles>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicles_Aggregate;
  /** fetch data from the table: "vehicles" using primary key columns */
  vehicles_by_pk?: Maybe<Vehicles>;
  /** An array relationship */
  wallet_transactions: Array<Wallet_Transactions>;
  /** An aggregate relationship */
  wallet_transactions_aggregate: Wallet_Transactions_Aggregate;
  /** fetch data from the table: "wallet_transactions" using primary key columns */
  wallet_transactions_by_pk?: Maybe<Wallet_Transactions>;
  /** An array relationship */
  wallets: Array<Wallets>;
  /** An aggregate relationship */
  wallets_aggregate: Wallets_Aggregate;
  /** fetch data from the table: "wallets" using primary key columns */
  wallets_by_pk?: Maybe<Wallets>;
};


export type Query_RootAdEventsByIntervalArgs = {
  adVariantIds: Array<Scalars['bigint']['input']>;
  endLocalDatetime: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  localTimezone: Scalars['String']['input'];
  startLocalDatetime: Scalars['String']['input'];
};


export type Query_RootAd_Campaign_Admin_UserArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Admin_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Admin_User_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
};


export type Query_RootAd_Campaign_Admin_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Admin_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Admin_User_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
};


export type Query_RootAd_Campaign_Parking_AuthorityArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
};


export type Query_RootAd_Campaign_Parking_Authority_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
};


export type Query_RootAd_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaigns_Order_By>>;
  where?: InputMaybe<Ad_Campaigns_Bool_Exp>;
};


export type Query_RootAd_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaigns_Order_By>>;
  where?: InputMaybe<Ad_Campaigns_Bool_Exp>;
};


export type Query_RootAd_Campaigns_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAd_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Events_Order_By>>;
  where?: InputMaybe<Ad_Events_Bool_Exp>;
};


export type Query_RootAd_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Events_Order_By>>;
  where?: InputMaybe<Ad_Events_Bool_Exp>;
};


export type Query_RootAd_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAd_VariantsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Variants_Order_By>>;
  where?: InputMaybe<Ad_Variants_Bool_Exp>;
};


export type Query_RootAd_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Variants_Order_By>>;
  where?: InputMaybe<Ad_Variants_Bool_Exp>;
};


export type Query_RootAd_Variants_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAdmin_User_Parking_AuthorityArgs = {
  distinct_on?: InputMaybe<Array<Admin_User_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_User_Parking_Authority_Order_By>>;
  where?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
};


export type Query_RootAdmin_User_Parking_Authority_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_User_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_User_Parking_Authority_Order_By>>;
  where?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
};


export type Query_RootAdmin_UsersArgs = {
  distinct_on?: InputMaybe<Array<Admin_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Users_Order_By>>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};


export type Query_RootAdmin_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Users_Order_By>>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};


export type Query_RootAdmin_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAdsArgs = {
  distinct_on?: InputMaybe<Array<Ads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ads_Order_By>>;
  where?: InputMaybe<Ads_Bool_Exp>;
};


export type Query_RootAds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ads_Order_By>>;
  where?: InputMaybe<Ads_Bool_Exp>;
};


export type Query_RootAds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBatch_SetsArgs = {
  distinct_on?: InputMaybe<Array<Batch_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Batch_Sets_Order_By>>;
  where?: InputMaybe<Batch_Sets_Bool_Exp>;
};


export type Query_RootBatch_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Batch_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Batch_Sets_Order_By>>;
  where?: InputMaybe<Batch_Sets_Bool_Exp>;
};


export type Query_RootBatch_Sets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBlacklisted_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Blacklisted_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blacklisted_Credentials_Order_By>>;
  where?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
};


export type Query_RootBlacklisted_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blacklisted_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blacklisted_Credentials_Order_By>>;
  where?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
};


export type Query_RootBlacklisted_Credentials_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDevice_UserArgs = {
  distinct_on?: InputMaybe<Array<Device_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_User_Order_By>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


export type Query_RootDevice_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_User_Order_By>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


export type Query_RootDevice_User_By_PkArgs = {
  device_id: Scalars['bigint']['input'];
  user_id: Scalars['bigint']['input'];
};


export type Query_RootDevicesArgs = {
  distinct_on?: InputMaybe<Array<Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devices_Order_By>>;
  where?: InputMaybe<Devices_Bool_Exp>;
};


export type Query_RootDevices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devices_Order_By>>;
  where?: InputMaybe<Devices_Bool_Exp>;
};


export type Query_RootDevices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFailed_JobsArgs = {
  distinct_on?: InputMaybe<Array<Failed_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Jobs_Order_By>>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};


export type Query_RootFailed_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Failed_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Jobs_Order_By>>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};


export type Query_RootFailed_Jobs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFailed_Sentry_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Failed_Sentry_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Sentry_Messages_Order_By>>;
  where?: InputMaybe<Failed_Sentry_Messages_Bool_Exp>;
};


export type Query_RootFailed_Sentry_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Failed_Sentry_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Sentry_Messages_Order_By>>;
  where?: InputMaybe<Failed_Sentry_Messages_Bool_Exp>;
};


export type Query_RootFailed_Sentry_Messages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


export type Query_RootIdentities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


export type Query_RootIdentities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootInvoice_Parkable_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};


export type Query_RootInvoice_Parkable_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};


export type Query_RootInvoice_Parkable_Transaction_By_PkArgs = {
  invoice_id: Scalars['bigint']['input'];
  parkable_transaction_id: Scalars['bigint']['input'];
};


export type Query_RootInvoice_Wallet_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
};


export type Query_RootInvoice_Wallet_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
};


export type Query_RootInvoice_Wallet_Transaction_By_PkArgs = {
  invoice_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


export type Query_RootInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Query_RootInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Query_RootInvoices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootJobsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Query_RootJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Query_RootJobs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLegacy_MigrationsArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Migrations_Order_By>>;
  where?: InputMaybe<Legacy_Migrations_Bool_Exp>;
};


export type Query_RootLegacy_Migrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Migrations_Order_By>>;
  where?: InputMaybe<Legacy_Migrations_Bool_Exp>;
};


export type Query_RootLegacy_Migrations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLegacy_Parkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Legacy_Parkable_Transactions_Bool_Exp>;
};


export type Query_RootLegacy_Parkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Legacy_Parkable_Transactions_Bool_Exp>;
};


export type Query_RootLegacy_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Payments_Order_By>>;
  where?: InputMaybe<Legacy_Payments_Bool_Exp>;
};


export type Query_RootLegacy_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Payments_Order_By>>;
  where?: InputMaybe<Legacy_Payments_Bool_Exp>;
};


export type Query_RootLegacy_Wallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Legacy_Wallet_Transactions_Bool_Exp>;
};


export type Query_RootLegacy_Wallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Legacy_Wallet_Transactions_Bool_Exp>;
};


export type Query_RootLine_Item_Parkable_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
};


export type Query_RootLine_Item_Parkable_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
};


export type Query_RootLine_Item_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Payment_Order_By>>;
  where?: InputMaybe<Line_Item_Payment_Bool_Exp>;
};


export type Query_RootLine_Item_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Payment_Order_By>>;
  where?: InputMaybe<Line_Item_Payment_Bool_Exp>;
};


export type Query_RootLine_Item_Payment_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLine_Item_Wallet_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
};


export type Query_RootLine_Item_Wallet_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
};


export type Query_RootLine_Item_Wallet_Transaction_By_PkArgs = {
  line_item_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


export type Query_RootLine_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Items_Order_By>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};


export type Query_RootLine_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Items_Order_By>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};


export type Query_RootLine_Items_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLogin_CodesArgs = {
  distinct_on?: InputMaybe<Array<Login_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Codes_Order_By>>;
  where?: InputMaybe<Login_Codes_Bool_Exp>;
};


export type Query_RootLogin_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Login_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Codes_Order_By>>;
  where?: InputMaybe<Login_Codes_Bool_Exp>;
};


export type Query_RootLogin_Codes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMigrationsArgs = {
  distinct_on?: InputMaybe<Array<Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Migrations_Order_By>>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};


export type Query_RootMigrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Migrations_Order_By>>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};


export type Query_RootMigrations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMx_Merchant_Pa_Bank_Account_MetasArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp>;
};


export type Query_RootMx_Merchant_Pa_Bank_Account_Metas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp>;
};


export type Query_RootMx_Merchant_Pa_Bank_Account_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMx_Merchant_Payment_Batch_MetasArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>;
};


export type Query_RootMx_Merchant_Payment_Batch_Metas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>;
};


export type Query_RootMx_Merchant_Payment_Batch_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMx_Merchant_Payment_MetasArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
};


export type Query_RootMx_Merchant_Payment_Metas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
};


export type Query_RootMx_Merchant_Payment_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMx_Merchant_Payment_Method_MetasArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
};


export type Query_RootMx_Merchant_Payment_Method_Metas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
};


export type Query_RootMx_Merchant_Payment_Method_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootParkableTransactionTaskDetailsArgs = {
  parkableTransactionId: Scalars['bigint']['input'];
};


export type Query_RootParkable_Group_Parkable_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Order_By>>;
  where?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
};


export type Query_RootParkable_Group_Parkable_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Order_By>>;
  where?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
};


export type Query_RootParkable_Group_Parkable_Schedule_By_PkArgs = {
  parkable_group_id: Scalars['bigint']['input'];
  parkable_schedule_id: Scalars['bigint']['input'];
};


export type Query_RootParkable_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Groups_Order_By>>;
  where?: InputMaybe<Parkable_Groups_Bool_Exp>;
};


export type Query_RootParkable_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Groups_Order_By>>;
  where?: InputMaybe<Parkable_Groups_Bool_Exp>;
};


export type Query_RootParkable_Groups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootParkable_Parkable_GroupArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Parkable_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Parkable_Group_Order_By>>;
  where?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
};


export type Query_RootParkable_Parkable_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Parkable_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Parkable_Group_Order_By>>;
  where?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
};


export type Query_RootParkable_Parkable_Group_By_PkArgs = {
  parkable_group_id: Scalars['bigint']['input'];
  parkable_id: Scalars['bigint']['input'];
};


export type Query_RootParkable_Qr_CodeArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Qr_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Qr_Code_Order_By>>;
  where?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
};


export type Query_RootParkable_Qr_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Qr_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Qr_Code_Order_By>>;
  where?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
};


export type Query_RootParkable_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Schedules_Order_By>>;
  where?: InputMaybe<Parkable_Schedules_Bool_Exp>;
};


export type Query_RootParkable_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Schedules_Order_By>>;
  where?: InputMaybe<Parkable_Schedules_Bool_Exp>;
};


export type Query_RootParkable_Schedules_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootParkable_Transaction_TaskArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Task_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
};


export type Query_RootParkable_Transaction_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Task_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
};


export type Query_RootParkable_Transaction_Task_By_PkArgs = {
  parkable_transaction_id: Scalars['bigint']['input'];
  task_id: Scalars['uuid']['input'];
};


export type Query_RootParkable_Transaction_Wallet_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
};


export type Query_RootParkable_Transaction_Wallet_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
};


export type Query_RootParkable_Transaction_Wallet_Transaction_By_PkArgs = {
  parkable_transaction_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


export type Query_RootParkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


export type Query_RootParkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


export type Query_RootParkable_Transactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootParkablesArgs = {
  distinct_on?: InputMaybe<Array<Parkables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkables_Order_By>>;
  where?: InputMaybe<Parkables_Bool_Exp>;
};


export type Query_RootParkables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkables_Order_By>>;
  where?: InputMaybe<Parkables_Bool_Exp>;
};


export type Query_RootParkables_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootParking_AuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authorities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authorities_Order_By>>;
  where?: InputMaybe<Parking_Authorities_Bool_Exp>;
};


export type Query_RootParking_Authorities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authorities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authorities_Order_By>>;
  where?: InputMaybe<Parking_Authorities_Bool_Exp>;
};


export type Query_RootParking_Authorities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootParking_Authority_Bank_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Order_By>>;
  where?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
};


export type Query_RootParking_Authority_Bank_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Order_By>>;
  where?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
};


export type Query_RootParking_Authority_Bank_Accounts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootParking_Authority_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Settings_Order_By>>;
  where?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
};


export type Query_RootParking_Authority_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Settings_Order_By>>;
  where?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
};


export type Query_RootParking_Authority_Settings_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootParking_Authority_UserArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_User_Order_By>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


export type Query_RootParking_Authority_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_User_Order_By>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


export type Query_RootParking_Authority_User_By_PkArgs = {
  parking_authority_id: Scalars['bigint']['input'];
  user_id: Scalars['bigint']['input'];
};


export type Query_RootPayment_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Query_RootPayment_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Query_RootPayment_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Query_RootPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Query_RootPayment_Methods_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPayment_Wallet_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Payment_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
};


export type Query_RootPayment_Wallet_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
};


export type Query_RootPayment_Wallet_Transaction_By_PkArgs = {
  payment_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


export type Query_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPending_UsersArgs = {
  distinct_on?: InputMaybe<Array<Pending_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pending_Users_Order_By>>;
  where?: InputMaybe<Pending_Users_Bool_Exp>;
};


export type Query_RootPending_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pending_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pending_Users_Order_By>>;
  where?: InputMaybe<Pending_Users_Bool_Exp>;
};


export type Query_RootPending_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPersonal_Access_TokensArgs = {
  distinct_on?: InputMaybe<Array<Personal_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Access_Tokens_Order_By>>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};


export type Query_RootPersonal_Access_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Personal_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Access_Tokens_Order_By>>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};


export type Query_RootPersonal_Access_Tokens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPreAuthenticationCheckArgs = {
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootPublic_KeysArgs = {
  distinct_on?: InputMaybe<Array<Public_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Public_Keys_Order_By>>;
  where?: InputMaybe<Public_Keys_Bool_Exp>;
};


export type Query_RootPublic_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Public_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Public_Keys_Order_By>>;
  where?: InputMaybe<Public_Keys_Bool_Exp>;
};


export type Query_RootQr_CodesArgs = {
  distinct_on?: InputMaybe<Array<Qr_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Qr_Codes_Order_By>>;
  where?: InputMaybe<Qr_Codes_Bool_Exp>;
};


export type Query_RootQr_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Qr_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Qr_Codes_Order_By>>;
  where?: InputMaybe<Qr_Codes_Bool_Exp>;
};


export type Query_RootQr_Codes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootR_Line_Item_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<R_Line_Item_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Line_Item_Payments_Order_By>>;
  where?: InputMaybe<R_Line_Item_Payments_Bool_Exp>;
};


export type Query_RootR_Line_Item_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Line_Item_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Line_Item_Payments_Order_By>>;
  where?: InputMaybe<R_Line_Item_Payments_Bool_Exp>;
};


export type Query_RootR_Line_Item_Payments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootR_Parkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<R_Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Parkable_Transactions_Order_By>>;
  where?: InputMaybe<R_Parkable_Transactions_Bool_Exp>;
};


export type Query_RootR_Parkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Parkable_Transactions_Order_By>>;
  where?: InputMaybe<R_Parkable_Transactions_Bool_Exp>;
};


export type Query_RootR_Parkable_Transactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootR_Parking_AuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<R_Parking_Authorities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Parking_Authorities_Order_By>>;
  where?: InputMaybe<R_Parking_Authorities_Bool_Exp>;
};


export type Query_RootR_Parking_Authorities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Parking_Authorities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Parking_Authorities_Order_By>>;
  where?: InputMaybe<R_Parking_Authorities_Bool_Exp>;
};


export type Query_RootR_Parking_Authorities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootR_Payment_BatchesArgs = {
  distinct_on?: InputMaybe<Array<R_Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Payment_Batches_Order_By>>;
  where?: InputMaybe<R_Payment_Batches_Bool_Exp>;
};


export type Query_RootR_Payment_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Payment_Batches_Order_By>>;
  where?: InputMaybe<R_Payment_Batches_Bool_Exp>;
};


export type Query_RootR_Payment_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootR_Transfer_BatchesArgs = {
  distinct_on?: InputMaybe<Array<R_Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Transfer_Batches_Order_By>>;
  where?: InputMaybe<R_Transfer_Batches_Bool_Exp>;
};


export type Query_RootR_Transfer_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Transfer_Batches_Order_By>>;
  where?: InputMaybe<R_Transfer_Batches_Bool_Exp>;
};


export type Query_RootR_Transfer_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootR_UsersArgs = {
  distinct_on?: InputMaybe<Array<R_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Users_Order_By>>;
  where?: InputMaybe<R_Users_Bool_Exp>;
};


export type Query_RootR_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Users_Order_By>>;
  where?: InputMaybe<R_Users_Bool_Exp>;
};


export type Query_RootR_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


export type Query_RootReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


export type Query_RootReports_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSearchAccountsArgs = {
  searchCredentials: Array<SearchCredential>;
};


export type Query_RootSession_Overlap_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Session_Overlap_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_Overlap_Results_Order_By>>;
  where?: InputMaybe<Session_Overlap_Results_Bool_Exp>;
};


export type Query_RootSession_Overlap_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Session_Overlap_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_Overlap_Results_Order_By>>;
  where?: InputMaybe<Session_Overlap_Results_Bool_Exp>;
};


export type Query_RootSession_Overlap_Results_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSupport_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


export type Query_RootSupport_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


export type Query_RootSupport_Tickets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSystemOverviewArgs = {
  parkingAuthorityId?: InputMaybe<Scalars['bigint']['input']>;
};


export type Query_RootTask_EventsArgs = {
  distinct_on?: InputMaybe<Array<Task_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Events_Order_By>>;
  where?: InputMaybe<Task_Events_Bool_Exp>;
};


export type Query_RootTask_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Events_Order_By>>;
  where?: InputMaybe<Task_Events_Bool_Exp>;
};


export type Query_RootTask_Events_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_StatesArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Order_By>>;
  where?: InputMaybe<Task_States_Bool_Exp>;
};


export type Query_RootTask_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Order_By>>;
  where?: InputMaybe<Task_States_Bool_Exp>;
};


export type Query_RootTask_States_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_UserArgs = {
  distinct_on?: InputMaybe<Array<Task_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_User_Order_By>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};


export type Query_RootTask_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_User_Order_By>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};


export type Query_RootTask_User_By_PkArgs = {
  task_id: Scalars['uuid']['input'];
  user_id: Scalars['bigint']['input'];
};


export type Query_RootTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Query_RootTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Query_RootTasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTestArgs = {
  test?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootTransfer_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transfer_Batches_Order_By>>;
  where?: InputMaybe<Transfer_Batches_Bool_Exp>;
};


export type Query_RootTransfer_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transfer_Batches_Order_By>>;
  where?: InputMaybe<Transfer_Batches_Bool_Exp>;
};


export type Query_RootTransfer_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTransfersOverviewArgs = {
  parkingAuthorityId?: InputMaybe<Scalars['bigint']['input']>;
};


export type Query_RootUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


export type Query_RootUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


export type Query_RootUser_Activities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUser_ListsArgs = {
  distinct_on?: InputMaybe<Array<User_Lists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Lists_Order_By>>;
  where?: InputMaybe<User_Lists_Bool_Exp>;
};


export type Query_RootUser_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Lists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Lists_Order_By>>;
  where?: InputMaybe<User_Lists_Bool_Exp>;
};


export type Query_RootUser_Lists_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Query_RootUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Query_RootUser_Settings_AllArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_All_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_All_Order_By>>;
  where?: InputMaybe<User_Settings_All_Bool_Exp>;
};


export type Query_RootUser_Settings_All_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_All_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_All_Order_By>>;
  where?: InputMaybe<User_Settings_All_Bool_Exp>;
};


export type Query_RootUser_Settings_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUser_User_ListArgs = {
  distinct_on?: InputMaybe<Array<User_User_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_User_List_Order_By>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};


export type Query_RootUser_User_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_User_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_User_List_Order_By>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};


export type Query_RootUser_User_List_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Query_RootVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Query_RootVehicles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootWallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


export type Query_RootWallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


export type Query_RootWallet_Transactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootWalletsArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


export type Query_RootWallets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


export type Query_RootWallets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "r_line_item_payments" */
export type R_Line_Item_Payments = {
  __typename?: 'r_line_item_payments';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  idempotent_key?: Maybe<Scalars['String']['output']>;
  invoice__user_id?: Maybe<Scalars['bigint']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  legacy_payment_id?: Maybe<Scalars['bigint']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  line_item__amount: Scalars['Int']['output'];
  line_item__created_at: Scalars['timestamp']['output'];
  line_item__description?: Maybe<Scalars['String']['output']>;
  line_item__discount_total: Scalars['Int']['output'];
  line_item__idempotent_key?: Maybe<Scalars['uuid']['output']>;
  line_item__net_amount: Scalars['Int']['output'];
  line_item__taxable: Scalars['Boolean']['output'];
  line_item__transferable: Scalars['Boolean']['output'];
  line_item__type: Scalars['String']['output'];
  line_item__updated_at?: Maybe<Scalars['timestamp']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['bigint']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['bigint']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  line_item_payment__amount: Scalars['Int']['output'];
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment__amount: Scalars['Int']['output'];
  payment__auth_only: Scalars['Boolean']['output'];
  payment__batch_set_id?: Maybe<Scalars['bigint']['output']>;
  payment__created_at: Scalars['timestamp']['output'];
  payment__description?: Maybe<Scalars['String']['output']>;
  payment__idempotent_key?: Maybe<Scalars['uuid']['output']>;
  payment__is_parking_authority_funds_transfer: Scalars['Boolean']['output'];
  payment__is_prefund: Scalars['Boolean']['output'];
  payment__last_4?: Maybe<Scalars['String']['output']>;
  payment__meta_id?: Maybe<Scalars['bigint']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['bigint']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_method_id?: Maybe<Scalars['bigint']['output']>;
  payment__status: Scalars['String']['output'];
  payment__tender?: Maybe<Scalars['String']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment__try: Scalars['smallint']['output'];
  payment__updated_at?: Maybe<Scalars['timestamp']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['bigint']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['bigint']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment_id?: Maybe<Scalars['bigint']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "r_line_item_payments" */
export type R_Line_Item_Payments_Aggregate = {
  __typename?: 'r_line_item_payments_aggregate';
  aggregate?: Maybe<R_Line_Item_Payments_Aggregate_Fields>;
  nodes: Array<R_Line_Item_Payments>;
};

/** aggregate fields of "r_line_item_payments" */
export type R_Line_Item_Payments_Aggregate_Fields = {
  __typename?: 'r_line_item_payments_aggregate_fields';
  avg?: Maybe<R_Line_Item_Payments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<R_Line_Item_Payments_Max_Fields>;
  min?: Maybe<R_Line_Item_Payments_Min_Fields>;
  stddev?: Maybe<R_Line_Item_Payments_Stddev_Fields>;
  stddev_pop?: Maybe<R_Line_Item_Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<R_Line_Item_Payments_Stddev_Samp_Fields>;
  sum?: Maybe<R_Line_Item_Payments_Sum_Fields>;
  var_pop?: Maybe<R_Line_Item_Payments_Var_Pop_Fields>;
  var_samp?: Maybe<R_Line_Item_Payments_Var_Samp_Fields>;
  variance?: Maybe<R_Line_Item_Payments_Variance_Fields>;
};


/** aggregate fields of "r_line_item_payments" */
export type R_Line_Item_Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<R_Line_Item_Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type R_Line_Item_Payments_Avg_Fields = {
  __typename?: 'r_line_item_payments_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  invoice__user_id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  legacy_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item__amount?: Maybe<Scalars['Float']['output']>;
  line_item__discount_total?: Maybe<Scalars['Float']['output']>;
  line_item__net_amount?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  line_item_payment__amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment__amount?: Maybe<Scalars['Float']['output']>;
  payment__batch_set_id?: Maybe<Scalars['Float']['output']>;
  payment__meta_id?: Maybe<Scalars['Float']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['Float']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__try?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "r_line_item_payments". All fields are combined with a logical 'AND'. */
export type R_Line_Item_Payments_Bool_Exp = {
  _and?: InputMaybe<Array<R_Line_Item_Payments_Bool_Exp>>;
  _not?: InputMaybe<R_Line_Item_Payments_Bool_Exp>;
  _or?: InputMaybe<Array<R_Line_Item_Payments_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<String_Comparison_Exp>;
  invoice__user_id?: InputMaybe<Bigint_Comparison_Exp>;
  invoice_id?: InputMaybe<Bigint_Comparison_Exp>;
  legacy_payment_id?: InputMaybe<Bigint_Comparison_Exp>;
  legacy_wallet_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  line_item__amount?: InputMaybe<Int_Comparison_Exp>;
  line_item__created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  line_item__description?: InputMaybe<String_Comparison_Exp>;
  line_item__discount_total?: InputMaybe<Int_Comparison_Exp>;
  line_item__idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  line_item__net_amount?: InputMaybe<Int_Comparison_Exp>;
  line_item__taxable?: InputMaybe<Boolean_Comparison_Exp>;
  line_item__transferable?: InputMaybe<Boolean_Comparison_Exp>;
  line_item__type?: InputMaybe<String_Comparison_Exp>;
  line_item__updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  line_item__wallet_transaction__wallet__user_id?: InputMaybe<Bigint_Comparison_Exp>;
  line_item__wallet_transaction__wallet_id?: InputMaybe<Bigint_Comparison_Exp>;
  line_item__wallet_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  line_item_id?: InputMaybe<Bigint_Comparison_Exp>;
  line_item_payment__amount?: InputMaybe<Int_Comparison_Exp>;
  parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__amount?: InputMaybe<Int_Comparison_Exp>;
  payment__auth_only?: InputMaybe<Boolean_Comparison_Exp>;
  payment__batch_set_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  payment__description?: InputMaybe<String_Comparison_Exp>;
  payment__idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  payment__is_parking_authority_funds_transfer?: InputMaybe<Boolean_Comparison_Exp>;
  payment__is_prefund?: InputMaybe<Boolean_Comparison_Exp>;
  payment__last_4?: InputMaybe<String_Comparison_Exp>;
  payment__meta_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__parent_payment_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__parking_authority_bank_account_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__payment_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__payment_method__user_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__payment_method_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__status?: InputMaybe<String_Comparison_Exp>;
  payment__tender?: InputMaybe<String_Comparison_Exp>;
  payment__transfer_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__try?: InputMaybe<Smallint_Comparison_Exp>;
  payment__updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  payment__wallet_transaction__wallet__user_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__wallet_transaction__wallet_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment__wallet_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_id?: InputMaybe<Bigint_Comparison_Exp>;
  transferable_parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "r_line_item_payments" */
export enum R_Line_Item_Payments_Constraint {
  /** unique or primary key constraint on columns "idempotent_key" */
  RLineItemPaymentsIdempotentKeyUnique = 'r_line_item_payments_idempotent_key_unique',
  /** unique or primary key constraint on columns "id" */
  RLineItemPaymentsPkey = 'r_line_item_payments_pkey'
}

/** input type for incrementing numeric columns in table "r_line_item_payments" */
export type R_Line_Item_Payments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  invoice__user_id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__amount?: InputMaybe<Scalars['Int']['input']>;
  line_item__discount_total?: InputMaybe<Scalars['Int']['input']>;
  line_item__net_amount?: InputMaybe<Scalars['Int']['input']>;
  line_item__wallet_transaction__wallet__user_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__wallet_transaction__wallet_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_payment__amount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__amount?: InputMaybe<Scalars['Int']['input']>;
  payment__batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__meta_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__parent_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_method__user_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__try?: InputMaybe<Scalars['smallint']['input']>;
  payment__wallet_transaction__wallet__user_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__wallet_transaction__wallet_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  transferable_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "r_line_item_payments" */
export type R_Line_Item_Payments_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  invoice__user_id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__amount?: InputMaybe<Scalars['Int']['input']>;
  line_item__created_at?: InputMaybe<Scalars['timestamp']['input']>;
  line_item__description?: InputMaybe<Scalars['String']['input']>;
  line_item__discount_total?: InputMaybe<Scalars['Int']['input']>;
  line_item__idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  line_item__net_amount?: InputMaybe<Scalars['Int']['input']>;
  line_item__taxable?: InputMaybe<Scalars['Boolean']['input']>;
  line_item__transferable?: InputMaybe<Scalars['Boolean']['input']>;
  line_item__type?: InputMaybe<Scalars['String']['input']>;
  line_item__updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  line_item__wallet_transaction__wallet__user_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__wallet_transaction__wallet_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_payment__amount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__amount?: InputMaybe<Scalars['Int']['input']>;
  payment__auth_only?: InputMaybe<Scalars['Boolean']['input']>;
  payment__batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__created_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment__description?: InputMaybe<Scalars['String']['input']>;
  payment__idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  payment__is_parking_authority_funds_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  payment__is_prefund?: InputMaybe<Scalars['Boolean']['input']>;
  payment__last_4?: InputMaybe<Scalars['String']['input']>;
  payment__meta_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__parent_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_method__user_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__status?: InputMaybe<Scalars['String']['input']>;
  payment__tender?: InputMaybe<Scalars['String']['input']>;
  payment__transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__try?: InputMaybe<Scalars['smallint']['input']>;
  payment__updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment__wallet_transaction__wallet__user_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__wallet_transaction__wallet_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  transferable_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type R_Line_Item_Payments_Max_Fields = {
  __typename?: 'r_line_item_payments_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['String']['output']>;
  invoice__user_id?: Maybe<Scalars['bigint']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  legacy_payment_id?: Maybe<Scalars['bigint']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  line_item__amount?: Maybe<Scalars['Int']['output']>;
  line_item__created_at?: Maybe<Scalars['timestamp']['output']>;
  line_item__description?: Maybe<Scalars['String']['output']>;
  line_item__discount_total?: Maybe<Scalars['Int']['output']>;
  line_item__idempotent_key?: Maybe<Scalars['uuid']['output']>;
  line_item__net_amount?: Maybe<Scalars['Int']['output']>;
  line_item__type?: Maybe<Scalars['String']['output']>;
  line_item__updated_at?: Maybe<Scalars['timestamp']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['bigint']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['bigint']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  line_item_payment__amount?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment__amount?: Maybe<Scalars['Int']['output']>;
  payment__batch_set_id?: Maybe<Scalars['bigint']['output']>;
  payment__created_at?: Maybe<Scalars['timestamp']['output']>;
  payment__description?: Maybe<Scalars['String']['output']>;
  payment__idempotent_key?: Maybe<Scalars['uuid']['output']>;
  payment__last_4?: Maybe<Scalars['String']['output']>;
  payment__meta_id?: Maybe<Scalars['bigint']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['bigint']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_method_id?: Maybe<Scalars['bigint']['output']>;
  payment__status?: Maybe<Scalars['String']['output']>;
  payment__tender?: Maybe<Scalars['String']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment__try?: Maybe<Scalars['smallint']['output']>;
  payment__updated_at?: Maybe<Scalars['timestamp']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['bigint']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['bigint']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment_id?: Maybe<Scalars['bigint']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type R_Line_Item_Payments_Min_Fields = {
  __typename?: 'r_line_item_payments_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['String']['output']>;
  invoice__user_id?: Maybe<Scalars['bigint']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  legacy_payment_id?: Maybe<Scalars['bigint']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  line_item__amount?: Maybe<Scalars['Int']['output']>;
  line_item__created_at?: Maybe<Scalars['timestamp']['output']>;
  line_item__description?: Maybe<Scalars['String']['output']>;
  line_item__discount_total?: Maybe<Scalars['Int']['output']>;
  line_item__idempotent_key?: Maybe<Scalars['uuid']['output']>;
  line_item__net_amount?: Maybe<Scalars['Int']['output']>;
  line_item__type?: Maybe<Scalars['String']['output']>;
  line_item__updated_at?: Maybe<Scalars['timestamp']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['bigint']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['bigint']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  line_item_payment__amount?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment__amount?: Maybe<Scalars['Int']['output']>;
  payment__batch_set_id?: Maybe<Scalars['bigint']['output']>;
  payment__created_at?: Maybe<Scalars['timestamp']['output']>;
  payment__description?: Maybe<Scalars['String']['output']>;
  payment__idempotent_key?: Maybe<Scalars['uuid']['output']>;
  payment__last_4?: Maybe<Scalars['String']['output']>;
  payment__meta_id?: Maybe<Scalars['bigint']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['bigint']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_method_id?: Maybe<Scalars['bigint']['output']>;
  payment__status?: Maybe<Scalars['String']['output']>;
  payment__tender?: Maybe<Scalars['String']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment__try?: Maybe<Scalars['smallint']['output']>;
  payment__updated_at?: Maybe<Scalars['timestamp']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['bigint']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['bigint']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment_id?: Maybe<Scalars['bigint']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "r_line_item_payments" */
export type R_Line_Item_Payments_Mutation_Response = {
  __typename?: 'r_line_item_payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<R_Line_Item_Payments>;
};

/** on_conflict condition type for table "r_line_item_payments" */
export type R_Line_Item_Payments_On_Conflict = {
  constraint: R_Line_Item_Payments_Constraint;
  update_columns?: Array<R_Line_Item_Payments_Update_Column>;
  where?: InputMaybe<R_Line_Item_Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "r_line_item_payments". */
export type R_Line_Item_Payments_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  invoice__user_id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  legacy_payment_id?: InputMaybe<Order_By>;
  legacy_wallet_transaction_id?: InputMaybe<Order_By>;
  line_item__amount?: InputMaybe<Order_By>;
  line_item__created_at?: InputMaybe<Order_By>;
  line_item__description?: InputMaybe<Order_By>;
  line_item__discount_total?: InputMaybe<Order_By>;
  line_item__idempotent_key?: InputMaybe<Order_By>;
  line_item__net_amount?: InputMaybe<Order_By>;
  line_item__taxable?: InputMaybe<Order_By>;
  line_item__transferable?: InputMaybe<Order_By>;
  line_item__type?: InputMaybe<Order_By>;
  line_item__updated_at?: InputMaybe<Order_By>;
  line_item__wallet_transaction__wallet__user_id?: InputMaybe<Order_By>;
  line_item__wallet_transaction__wallet_id?: InputMaybe<Order_By>;
  line_item__wallet_transaction_id?: InputMaybe<Order_By>;
  line_item_id?: InputMaybe<Order_By>;
  line_item_payment__amount?: InputMaybe<Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
  payment__amount?: InputMaybe<Order_By>;
  payment__auth_only?: InputMaybe<Order_By>;
  payment__batch_set_id?: InputMaybe<Order_By>;
  payment__created_at?: InputMaybe<Order_By>;
  payment__description?: InputMaybe<Order_By>;
  payment__idempotent_key?: InputMaybe<Order_By>;
  payment__is_parking_authority_funds_transfer?: InputMaybe<Order_By>;
  payment__is_prefund?: InputMaybe<Order_By>;
  payment__last_4?: InputMaybe<Order_By>;
  payment__meta_id?: InputMaybe<Order_By>;
  payment__parent_payment_id?: InputMaybe<Order_By>;
  payment__parking_authority_bank_account_id?: InputMaybe<Order_By>;
  payment__payment_batch_id?: InputMaybe<Order_By>;
  payment__payment_method__user_id?: InputMaybe<Order_By>;
  payment__payment_method_id?: InputMaybe<Order_By>;
  payment__status?: InputMaybe<Order_By>;
  payment__tender?: InputMaybe<Order_By>;
  payment__transfer_batch_id?: InputMaybe<Order_By>;
  payment__try?: InputMaybe<Order_By>;
  payment__updated_at?: InputMaybe<Order_By>;
  payment__wallet_transaction__wallet__user_id?: InputMaybe<Order_By>;
  payment__wallet_transaction__wallet_id?: InputMaybe<Order_By>;
  payment__wallet_transaction_id?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  transferable_parking_authority_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: r_line_item_payments */
export type R_Line_Item_Payments_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "r_line_item_payments" */
export enum R_Line_Item_Payments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  InvoiceUserId = 'invoice__user_id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  LegacyPaymentId = 'legacy_payment_id',
  /** column name */
  LegacyWalletTransactionId = 'legacy_wallet_transaction_id',
  /** column name */
  LineItemAmount = 'line_item__amount',
  /** column name */
  LineItemCreatedAt = 'line_item__created_at',
  /** column name */
  LineItemDescription = 'line_item__description',
  /** column name */
  LineItemDiscountTotal = 'line_item__discount_total',
  /** column name */
  LineItemIdempotentKey = 'line_item__idempotent_key',
  /** column name */
  LineItemNetAmount = 'line_item__net_amount',
  /** column name */
  LineItemTaxable = 'line_item__taxable',
  /** column name */
  LineItemTransferable = 'line_item__transferable',
  /** column name */
  LineItemType = 'line_item__type',
  /** column name */
  LineItemUpdatedAt = 'line_item__updated_at',
  /** column name */
  LineItemWalletTransactionWalletUserId = 'line_item__wallet_transaction__wallet__user_id',
  /** column name */
  LineItemWalletTransactionWalletId = 'line_item__wallet_transaction__wallet_id',
  /** column name */
  LineItemWalletTransactionId = 'line_item__wallet_transaction_id',
  /** column name */
  LineItemId = 'line_item_id',
  /** column name */
  LineItemPaymentAmount = 'line_item_payment__amount',
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id',
  /** column name */
  PaymentAmount = 'payment__amount',
  /** column name */
  PaymentAuthOnly = 'payment__auth_only',
  /** column name */
  PaymentBatchSetId = 'payment__batch_set_id',
  /** column name */
  PaymentCreatedAt = 'payment__created_at',
  /** column name */
  PaymentDescription = 'payment__description',
  /** column name */
  PaymentIdempotentKey = 'payment__idempotent_key',
  /** column name */
  PaymentIsParkingAuthorityFundsTransfer = 'payment__is_parking_authority_funds_transfer',
  /** column name */
  PaymentIsPrefund = 'payment__is_prefund',
  /** column name */
  PaymentLast_4 = 'payment__last_4',
  /** column name */
  PaymentMetaId = 'payment__meta_id',
  /** column name */
  PaymentParentPaymentId = 'payment__parent_payment_id',
  /** column name */
  PaymentParkingAuthorityBankAccountId = 'payment__parking_authority_bank_account_id',
  /** column name */
  PaymentPaymentBatchId = 'payment__payment_batch_id',
  /** column name */
  PaymentPaymentMethodUserId = 'payment__payment_method__user_id',
  /** column name */
  PaymentPaymentMethodId = 'payment__payment_method_id',
  /** column name */
  PaymentStatus = 'payment__status',
  /** column name */
  PaymentTender = 'payment__tender',
  /** column name */
  PaymentTransferBatchId = 'payment__transfer_batch_id',
  /** column name */
  PaymentTry = 'payment__try',
  /** column name */
  PaymentUpdatedAt = 'payment__updated_at',
  /** column name */
  PaymentWalletTransactionWalletUserId = 'payment__wallet_transaction__wallet__user_id',
  /** column name */
  PaymentWalletTransactionWalletId = 'payment__wallet_transaction__wallet_id',
  /** column name */
  PaymentWalletTransactionId = 'payment__wallet_transaction_id',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  TransferableParkingAuthorityId = 'transferable_parking_authority_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "r_line_item_payments" */
export type R_Line_Item_Payments_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  invoice__user_id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__amount?: InputMaybe<Scalars['Int']['input']>;
  line_item__created_at?: InputMaybe<Scalars['timestamp']['input']>;
  line_item__description?: InputMaybe<Scalars['String']['input']>;
  line_item__discount_total?: InputMaybe<Scalars['Int']['input']>;
  line_item__idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  line_item__net_amount?: InputMaybe<Scalars['Int']['input']>;
  line_item__taxable?: InputMaybe<Scalars['Boolean']['input']>;
  line_item__transferable?: InputMaybe<Scalars['Boolean']['input']>;
  line_item__type?: InputMaybe<Scalars['String']['input']>;
  line_item__updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  line_item__wallet_transaction__wallet__user_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__wallet_transaction__wallet_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_payment__amount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__amount?: InputMaybe<Scalars['Int']['input']>;
  payment__auth_only?: InputMaybe<Scalars['Boolean']['input']>;
  payment__batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__created_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment__description?: InputMaybe<Scalars['String']['input']>;
  payment__idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  payment__is_parking_authority_funds_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  payment__is_prefund?: InputMaybe<Scalars['Boolean']['input']>;
  payment__last_4?: InputMaybe<Scalars['String']['input']>;
  payment__meta_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__parent_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_method__user_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__status?: InputMaybe<Scalars['String']['input']>;
  payment__tender?: InputMaybe<Scalars['String']['input']>;
  payment__transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__try?: InputMaybe<Scalars['smallint']['input']>;
  payment__updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment__wallet_transaction__wallet__user_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__wallet_transaction__wallet_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  transferable_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type R_Line_Item_Payments_Stddev_Fields = {
  __typename?: 'r_line_item_payments_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  invoice__user_id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  legacy_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item__amount?: Maybe<Scalars['Float']['output']>;
  line_item__discount_total?: Maybe<Scalars['Float']['output']>;
  line_item__net_amount?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  line_item_payment__amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment__amount?: Maybe<Scalars['Float']['output']>;
  payment__batch_set_id?: Maybe<Scalars['Float']['output']>;
  payment__meta_id?: Maybe<Scalars['Float']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['Float']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__try?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type R_Line_Item_Payments_Stddev_Pop_Fields = {
  __typename?: 'r_line_item_payments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  invoice__user_id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  legacy_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item__amount?: Maybe<Scalars['Float']['output']>;
  line_item__discount_total?: Maybe<Scalars['Float']['output']>;
  line_item__net_amount?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  line_item_payment__amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment__amount?: Maybe<Scalars['Float']['output']>;
  payment__batch_set_id?: Maybe<Scalars['Float']['output']>;
  payment__meta_id?: Maybe<Scalars['Float']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['Float']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__try?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type R_Line_Item_Payments_Stddev_Samp_Fields = {
  __typename?: 'r_line_item_payments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  invoice__user_id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  legacy_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item__amount?: Maybe<Scalars['Float']['output']>;
  line_item__discount_total?: Maybe<Scalars['Float']['output']>;
  line_item__net_amount?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  line_item_payment__amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment__amount?: Maybe<Scalars['Float']['output']>;
  payment__batch_set_id?: Maybe<Scalars['Float']['output']>;
  payment__meta_id?: Maybe<Scalars['Float']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['Float']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__try?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "r_line_item_payments" */
export type R_Line_Item_Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: R_Line_Item_Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type R_Line_Item_Payments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  invoice__user_id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__amount?: InputMaybe<Scalars['Int']['input']>;
  line_item__created_at?: InputMaybe<Scalars['timestamp']['input']>;
  line_item__description?: InputMaybe<Scalars['String']['input']>;
  line_item__discount_total?: InputMaybe<Scalars['Int']['input']>;
  line_item__idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  line_item__net_amount?: InputMaybe<Scalars['Int']['input']>;
  line_item__taxable?: InputMaybe<Scalars['Boolean']['input']>;
  line_item__transferable?: InputMaybe<Scalars['Boolean']['input']>;
  line_item__type?: InputMaybe<Scalars['String']['input']>;
  line_item__updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  line_item__wallet_transaction__wallet__user_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__wallet_transaction__wallet_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item__wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_id?: InputMaybe<Scalars['bigint']['input']>;
  line_item_payment__amount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__amount?: InputMaybe<Scalars['Int']['input']>;
  payment__auth_only?: InputMaybe<Scalars['Boolean']['input']>;
  payment__batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__created_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment__description?: InputMaybe<Scalars['String']['input']>;
  payment__idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  payment__is_parking_authority_funds_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  payment__is_prefund?: InputMaybe<Scalars['Boolean']['input']>;
  payment__last_4?: InputMaybe<Scalars['String']['input']>;
  payment__meta_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__parent_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__parking_authority_bank_account_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_method__user_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__status?: InputMaybe<Scalars['String']['input']>;
  payment__tender?: InputMaybe<Scalars['String']['input']>;
  payment__transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__try?: InputMaybe<Scalars['smallint']['input']>;
  payment__updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment__wallet_transaction__wallet__user_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__wallet_transaction__wallet_id?: InputMaybe<Scalars['bigint']['input']>;
  payment__wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_id?: InputMaybe<Scalars['bigint']['input']>;
  transferable_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type R_Line_Item_Payments_Sum_Fields = {
  __typename?: 'r_line_item_payments_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  invoice__user_id?: Maybe<Scalars['bigint']['output']>;
  invoice_id?: Maybe<Scalars['bigint']['output']>;
  legacy_payment_id?: Maybe<Scalars['bigint']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  line_item__amount?: Maybe<Scalars['Int']['output']>;
  line_item__discount_total?: Maybe<Scalars['Int']['output']>;
  line_item__net_amount?: Maybe<Scalars['Int']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['bigint']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['bigint']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  line_item_id?: Maybe<Scalars['bigint']['output']>;
  line_item_payment__amount?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment__amount?: Maybe<Scalars['Int']['output']>;
  payment__batch_set_id?: Maybe<Scalars['bigint']['output']>;
  payment__meta_id?: Maybe<Scalars['bigint']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['bigint']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['bigint']['output']>;
  payment__payment_method_id?: Maybe<Scalars['bigint']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  payment__try?: Maybe<Scalars['smallint']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['bigint']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['bigint']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  payment_id?: Maybe<Scalars['bigint']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "r_line_item_payments" */
export enum R_Line_Item_Payments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  InvoiceUserId = 'invoice__user_id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  LegacyPaymentId = 'legacy_payment_id',
  /** column name */
  LegacyWalletTransactionId = 'legacy_wallet_transaction_id',
  /** column name */
  LineItemAmount = 'line_item__amount',
  /** column name */
  LineItemCreatedAt = 'line_item__created_at',
  /** column name */
  LineItemDescription = 'line_item__description',
  /** column name */
  LineItemDiscountTotal = 'line_item__discount_total',
  /** column name */
  LineItemIdempotentKey = 'line_item__idempotent_key',
  /** column name */
  LineItemNetAmount = 'line_item__net_amount',
  /** column name */
  LineItemTaxable = 'line_item__taxable',
  /** column name */
  LineItemTransferable = 'line_item__transferable',
  /** column name */
  LineItemType = 'line_item__type',
  /** column name */
  LineItemUpdatedAt = 'line_item__updated_at',
  /** column name */
  LineItemWalletTransactionWalletUserId = 'line_item__wallet_transaction__wallet__user_id',
  /** column name */
  LineItemWalletTransactionWalletId = 'line_item__wallet_transaction__wallet_id',
  /** column name */
  LineItemWalletTransactionId = 'line_item__wallet_transaction_id',
  /** column name */
  LineItemId = 'line_item_id',
  /** column name */
  LineItemPaymentAmount = 'line_item_payment__amount',
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id',
  /** column name */
  PaymentAmount = 'payment__amount',
  /** column name */
  PaymentAuthOnly = 'payment__auth_only',
  /** column name */
  PaymentBatchSetId = 'payment__batch_set_id',
  /** column name */
  PaymentCreatedAt = 'payment__created_at',
  /** column name */
  PaymentDescription = 'payment__description',
  /** column name */
  PaymentIdempotentKey = 'payment__idempotent_key',
  /** column name */
  PaymentIsParkingAuthorityFundsTransfer = 'payment__is_parking_authority_funds_transfer',
  /** column name */
  PaymentIsPrefund = 'payment__is_prefund',
  /** column name */
  PaymentLast_4 = 'payment__last_4',
  /** column name */
  PaymentMetaId = 'payment__meta_id',
  /** column name */
  PaymentParentPaymentId = 'payment__parent_payment_id',
  /** column name */
  PaymentParkingAuthorityBankAccountId = 'payment__parking_authority_bank_account_id',
  /** column name */
  PaymentPaymentBatchId = 'payment__payment_batch_id',
  /** column name */
  PaymentPaymentMethodUserId = 'payment__payment_method__user_id',
  /** column name */
  PaymentPaymentMethodId = 'payment__payment_method_id',
  /** column name */
  PaymentStatus = 'payment__status',
  /** column name */
  PaymentTender = 'payment__tender',
  /** column name */
  PaymentTransferBatchId = 'payment__transfer_batch_id',
  /** column name */
  PaymentTry = 'payment__try',
  /** column name */
  PaymentUpdatedAt = 'payment__updated_at',
  /** column name */
  PaymentWalletTransactionWalletUserId = 'payment__wallet_transaction__wallet__user_id',
  /** column name */
  PaymentWalletTransactionWalletId = 'payment__wallet_transaction__wallet_id',
  /** column name */
  PaymentWalletTransactionId = 'payment__wallet_transaction_id',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  TransferableParkingAuthorityId = 'transferable_parking_authority_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type R_Line_Item_Payments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<R_Line_Item_Payments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<R_Line_Item_Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: R_Line_Item_Payments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type R_Line_Item_Payments_Var_Pop_Fields = {
  __typename?: 'r_line_item_payments_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  invoice__user_id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  legacy_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item__amount?: Maybe<Scalars['Float']['output']>;
  line_item__discount_total?: Maybe<Scalars['Float']['output']>;
  line_item__net_amount?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  line_item_payment__amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment__amount?: Maybe<Scalars['Float']['output']>;
  payment__batch_set_id?: Maybe<Scalars['Float']['output']>;
  payment__meta_id?: Maybe<Scalars['Float']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['Float']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__try?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type R_Line_Item_Payments_Var_Samp_Fields = {
  __typename?: 'r_line_item_payments_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  invoice__user_id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  legacy_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item__amount?: Maybe<Scalars['Float']['output']>;
  line_item__discount_total?: Maybe<Scalars['Float']['output']>;
  line_item__net_amount?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  line_item_payment__amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment__amount?: Maybe<Scalars['Float']['output']>;
  payment__batch_set_id?: Maybe<Scalars['Float']['output']>;
  payment__meta_id?: Maybe<Scalars['Float']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['Float']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__try?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type R_Line_Item_Payments_Variance_Fields = {
  __typename?: 'r_line_item_payments_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  invoice__user_id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  legacy_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item__amount?: Maybe<Scalars['Float']['output']>;
  line_item__discount_total?: Maybe<Scalars['Float']['output']>;
  line_item__net_amount?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  line_item__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  line_item_id?: Maybe<Scalars['Float']['output']>;
  line_item_payment__amount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment__amount?: Maybe<Scalars['Float']['output']>;
  payment__batch_set_id?: Maybe<Scalars['Float']['output']>;
  payment__meta_id?: Maybe<Scalars['Float']['output']>;
  payment__parent_payment_id?: Maybe<Scalars['Float']['output']>;
  payment__parking_authority_bank_account_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method__user_id?: Maybe<Scalars['Float']['output']>;
  payment__payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment__transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  payment__try?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet__user_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction__wallet_id?: Maybe<Scalars['Float']['output']>;
  payment__wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
  transferable_parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "r_parkable_transactions" */
export type R_Parkable_Transactions = {
  __typename?: 'r_parkable_transactions';
  app_version?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  browser_version?: Maybe<Scalars['String']['output']>;
  cancelled_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_client_id?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['bigint']['output']>;
  did_trigger_wallet_auto_reload?: Maybe<Scalars['Boolean']['output']>;
  expired_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  fee_net_tax?: Maybe<Scalars['Int']['output']>;
  fee_net_total?: Maybe<Scalars['Int']['output']>;
  fee_subtotal?: Maybe<Scalars['Int']['output']>;
  fee_total_discount?: Maybe<Scalars['Int']['output']>;
  fee_total_refund?: Maybe<Scalars['Int']['output']>;
  finalized_at?: Maybe<Scalars['timestamp']['output']>;
  funds_transferred_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  invoice_parkable_transactions: Array<Invoice_Parkable_Transaction>;
  /** An aggregate relationship */
  invoice_parkable_transactions_aggregate: Invoice_Parkable_Transaction_Aggregate;
  last_acknowledged_at?: Maybe<Scalars['timestamp']['output']>;
  last_enforcement_notified_at?: Maybe<Scalars['timestamp']['output']>;
  last_failed_payment_at?: Maybe<Scalars['timestamp']['output']>;
  last_successful_payment_at?: Maybe<Scalars['timestamp']['output']>;
  last_time_extended_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  legacy_parkable_transaction?: Maybe<Legacy_Parkable_Transactions>;
  legacy_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  membership_id?: Maybe<Scalars['bigint']['output']>;
  net_tax?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  num_payment_errors?: Maybe<Scalars['smallint']['output']>;
  num_payment_methods?: Maybe<Scalars['smallint']['output']>;
  num_payments?: Maybe<Scalars['smallint']['output']>;
  num_time_extensions?: Maybe<Scalars['smallint']['output']>;
  operating_system?: Maybe<Scalars['String']['output']>;
  operating_system_version?: Maybe<Scalars['String']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  other_net_tax?: Maybe<Scalars['Int']['output']>;
  other_net_total?: Maybe<Scalars['Int']['output']>;
  other_subtotal?: Maybe<Scalars['Int']['output']>;
  other_total_discount?: Maybe<Scalars['Int']['output']>;
  other_total_refund?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  parkable?: Maybe<Parkables>;
  /** An object relationship */
  parkableTransactionTask?: Maybe<Parkable_Transaction_Task>;
  parkable_area_name?: Maybe<Scalars['String']['output']>;
  parkable_id: Scalars['bigint']['output'];
  parkable_identifier?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  parkable_transaction?: Maybe<Parkable_Transactions>;
  parkable_transaction_id: Scalars['bigint']['output'];
  parkable_transaction_net_tax?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Int']['output']>;
  parkable_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parking_authority?: Maybe<Parking_Authorities>;
  parking_authority_id: Scalars['bigint']['output'];
  payment_finalized_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  payment_method?: Maybe<Payment_Methods>;
  payment_method_alias?: Maybe<Scalars['String']['output']>;
  payment_method_card_type?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_last_4?: Maybe<Scalars['String']['output']>;
  payment_method_tender?: Maybe<Scalars['String']['output']>;
  payment_method_user_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  r_parking_authority?: Maybe<R_Parking_Authorities>;
  /** An object relationship */
  r_user?: Maybe<R_Users>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_license_plate?: Maybe<Scalars['String']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_unit?: Maybe<Scalars['String']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_unit?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  total_discount?: Maybe<Scalars['Int']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_refund?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferable_net_tax?: Maybe<Scalars['Int']['output']>;
  transferable_net_total?: Maybe<Scalars['Int']['output']>;
  transferable_subtotal?: Maybe<Scalars['Int']['output']>;
  transferable_total_discount?: Maybe<Scalars['Int']['output']>;
  transferable_total_refund?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['bigint']['output'];
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_name?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "r_parkable_transactions" */
export type R_Parkable_TransactionsInvoice_Parkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};


/** columns and relationships of "r_parkable_transactions" */
export type R_Parkable_TransactionsInvoice_Parkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};

/** aggregated selection of "r_parkable_transactions" */
export type R_Parkable_Transactions_Aggregate = {
  __typename?: 'r_parkable_transactions_aggregate';
  aggregate?: Maybe<R_Parkable_Transactions_Aggregate_Fields>;
  nodes: Array<R_Parkable_Transactions>;
};

/** aggregate fields of "r_parkable_transactions" */
export type R_Parkable_Transactions_Aggregate_Fields = {
  __typename?: 'r_parkable_transactions_aggregate_fields';
  avg?: Maybe<R_Parkable_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<R_Parkable_Transactions_Max_Fields>;
  min?: Maybe<R_Parkable_Transactions_Min_Fields>;
  stddev?: Maybe<R_Parkable_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<R_Parkable_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<R_Parkable_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<R_Parkable_Transactions_Sum_Fields>;
  var_pop?: Maybe<R_Parkable_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<R_Parkable_Transactions_Var_Samp_Fields>;
  variance?: Maybe<R_Parkable_Transactions_Variance_Fields>;
};


/** aggregate fields of "r_parkable_transactions" */
export type R_Parkable_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<R_Parkable_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type R_Parkable_Transactions_Avg_Fields = {
  __typename?: 'r_parkable_transactions_avg_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  fee_net_tax?: Maybe<Scalars['Float']['output']>;
  fee_net_total?: Maybe<Scalars['Float']['output']>;
  fee_subtotal?: Maybe<Scalars['Float']['output']>;
  fee_total_discount?: Maybe<Scalars['Float']['output']>;
  fee_total_refund?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  membership_id?: Maybe<Scalars['Float']['output']>;
  net_tax?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_payment_errors?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_payments?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  other_net_tax?: Maybe<Scalars['Float']['output']>;
  other_net_total?: Maybe<Scalars['Float']['output']>;
  other_subtotal?: Maybe<Scalars['Float']['output']>;
  other_total_discount?: Maybe<Scalars['Float']['output']>;
  other_total_refund?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_tax?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment_method_user_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  total_discount?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_refund?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_net_tax?: Maybe<Scalars['Float']['output']>;
  transferable_net_total?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_total_discount?: Maybe<Scalars['Float']['output']>;
  transferable_total_refund?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "r_parkable_transactions". All fields are combined with a logical 'AND'. */
export type R_Parkable_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<R_Parkable_Transactions_Bool_Exp>>;
  _not?: InputMaybe<R_Parkable_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<R_Parkable_Transactions_Bool_Exp>>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  browser?: InputMaybe<String_Comparison_Exp>;
  browser_version?: InputMaybe<String_Comparison_Exp>;
  cancelled_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  device_client_id?: InputMaybe<String_Comparison_Exp>;
  device_id?: InputMaybe<Bigint_Comparison_Exp>;
  did_trigger_wallet_auto_reload?: InputMaybe<Boolean_Comparison_Exp>;
  expired_at?: InputMaybe<Timestamp_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fee_net_tax?: InputMaybe<Int_Comparison_Exp>;
  fee_net_total?: InputMaybe<Int_Comparison_Exp>;
  fee_subtotal?: InputMaybe<Int_Comparison_Exp>;
  fee_total_discount?: InputMaybe<Int_Comparison_Exp>;
  fee_total_refund?: InputMaybe<Int_Comparison_Exp>;
  finalized_at?: InputMaybe<Timestamp_Comparison_Exp>;
  funds_transferred_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  invoice_parkable_transactions?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
  invoice_parkable_transactions_aggregate?: InputMaybe<Invoice_Parkable_Transaction_Aggregate_Bool_Exp>;
  last_acknowledged_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_enforcement_notified_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_failed_payment_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_successful_payment_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_time_extended_at?: InputMaybe<Timestamp_Comparison_Exp>;
  legacy_parkable_transaction?: InputMaybe<Legacy_Parkable_Transactions_Bool_Exp>;
  legacy_parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  membership_id?: InputMaybe<Bigint_Comparison_Exp>;
  net_tax?: InputMaybe<Int_Comparison_Exp>;
  net_total?: InputMaybe<Int_Comparison_Exp>;
  num_payment_errors?: InputMaybe<Smallint_Comparison_Exp>;
  num_payment_methods?: InputMaybe<Smallint_Comparison_Exp>;
  num_payments?: InputMaybe<Smallint_Comparison_Exp>;
  num_time_extensions?: InputMaybe<Smallint_Comparison_Exp>;
  operating_system?: InputMaybe<String_Comparison_Exp>;
  operating_system_version?: InputMaybe<String_Comparison_Exp>;
  original_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  original_updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  other_net_tax?: InputMaybe<Int_Comparison_Exp>;
  other_net_total?: InputMaybe<Int_Comparison_Exp>;
  other_subtotal?: InputMaybe<Int_Comparison_Exp>;
  other_total_discount?: InputMaybe<Int_Comparison_Exp>;
  other_total_refund?: InputMaybe<Int_Comparison_Exp>;
  parkable?: InputMaybe<Parkables_Bool_Exp>;
  parkableTransactionTask?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
  parkable_area_name?: InputMaybe<String_Comparison_Exp>;
  parkable_id?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_identifier?: InputMaybe<Int_Comparison_Exp>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  parkable_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  parkable_transaction_net_tax?: InputMaybe<Int_Comparison_Exp>;
  parkable_transaction_net_total?: InputMaybe<Int_Comparison_Exp>;
  parkable_transaction_subtotal?: InputMaybe<Int_Comparison_Exp>;
  parkable_transaction_total_discount?: InputMaybe<Int_Comparison_Exp>;
  parkable_transaction_total_refund?: InputMaybe<Int_Comparison_Exp>;
  parkable_type?: InputMaybe<String_Comparison_Exp>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_finalized_at?: InputMaybe<Timestamp_Comparison_Exp>;
  payment_method?: InputMaybe<Payment_Methods_Bool_Exp>;
  payment_method_alias?: InputMaybe<String_Comparison_Exp>;
  payment_method_card_type?: InputMaybe<String_Comparison_Exp>;
  payment_method_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_method_last_4?: InputMaybe<String_Comparison_Exp>;
  payment_method_tender?: InputMaybe<String_Comparison_Exp>;
  payment_method_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  r_parking_authority?: InputMaybe<R_Parking_Authorities_Bool_Exp>;
  r_user?: InputMaybe<R_Users_Bool_Exp>;
  snapshot_fee?: InputMaybe<Int_Comparison_Exp>;
  snapshot_license_plate?: InputMaybe<String_Comparison_Exp>;
  snapshot_price?: InputMaybe<Int_Comparison_Exp>;
  snapshot_price_interval?: InputMaybe<Int_Comparison_Exp>;
  snapshot_price_interval_seconds?: InputMaybe<Int_Comparison_Exp>;
  snapshot_price_interval_unit?: InputMaybe<String_Comparison_Exp>;
  snapshot_time_limit?: InputMaybe<Int_Comparison_Exp>;
  snapshot_time_limit_seconds?: InputMaybe<Int_Comparison_Exp>;
  snapshot_time_limit_unit?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  subtotal?: InputMaybe<Int_Comparison_Exp>;
  time?: InputMaybe<Int_Comparison_Exp>;
  total_discount?: InputMaybe<Int_Comparison_Exp>;
  total_paid?: InputMaybe<Int_Comparison_Exp>;
  total_refund?: InputMaybe<Int_Comparison_Exp>;
  total_unpaid?: InputMaybe<Int_Comparison_Exp>;
  transferable_net_tax?: InputMaybe<Int_Comparison_Exp>;
  transferable_net_total?: InputMaybe<Int_Comparison_Exp>;
  transferable_subtotal?: InputMaybe<Int_Comparison_Exp>;
  transferable_total_discount?: InputMaybe<Int_Comparison_Exp>;
  transferable_total_refund?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicles_Bool_Exp>;
  vehicle_id?: InputMaybe<Bigint_Comparison_Exp>;
  vehicle_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "r_parkable_transactions" */
export enum R_Parkable_Transactions_Constraint {
  /** unique or primary key constraint on columns "legacy_parkable_transaction_id" */
  RParkableTransactionsLegacyParkableTransactionIdUnique = 'r_parkable_transactions_legacy_parkable_transaction_id_unique',
  /** unique or primary key constraint on columns "parkable_transaction_id" */
  RParkableTransactionsParkableTransactionIdUnique = 'r_parkable_transactions_parkable_transaction_id_unique',
  /** unique or primary key constraint on columns "id" */
  RParkableTransactionsPkey = 'r_parkable_transactions_pkey'
}

/** input type for incrementing numeric columns in table "r_parkable_transactions" */
export type R_Parkable_Transactions_Inc_Input = {
  device_id?: InputMaybe<Scalars['bigint']['input']>;
  fee_net_tax?: InputMaybe<Scalars['Int']['input']>;
  fee_net_total?: InputMaybe<Scalars['Int']['input']>;
  fee_subtotal?: InputMaybe<Scalars['Int']['input']>;
  fee_total_discount?: InputMaybe<Scalars['Int']['input']>;
  fee_total_refund?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  membership_id?: InputMaybe<Scalars['bigint']['input']>;
  net_tax?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  num_payment_errors?: InputMaybe<Scalars['smallint']['input']>;
  num_payment_methods?: InputMaybe<Scalars['smallint']['input']>;
  num_payments?: InputMaybe<Scalars['smallint']['input']>;
  num_time_extensions?: InputMaybe<Scalars['smallint']['input']>;
  other_net_tax?: InputMaybe<Scalars['Int']['input']>;
  other_net_total?: InputMaybe<Scalars['Int']['input']>;
  other_subtotal?: InputMaybe<Scalars['Int']['input']>;
  other_total_discount?: InputMaybe<Scalars['Int']['input']>;
  other_total_refund?: InputMaybe<Scalars['Int']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_identifier?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_net_tax?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_net_total?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_subtotal?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_total_discount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_total_refund?: InputMaybe<Scalars['Int']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_user_id?: InputMaybe<Scalars['bigint']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_seconds?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_seconds?: InputMaybe<Scalars['Int']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  total_discount?: InputMaybe<Scalars['Int']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_refund?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferable_net_tax?: InputMaybe<Scalars['Int']['input']>;
  transferable_net_total?: InputMaybe<Scalars['Int']['input']>;
  transferable_subtotal?: InputMaybe<Scalars['Int']['input']>;
  transferable_total_discount?: InputMaybe<Scalars['Int']['input']>;
  transferable_total_refund?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "r_parkable_transactions" */
export type R_Parkable_Transactions_Insert_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  browser?: InputMaybe<Scalars['String']['input']>;
  browser_version?: InputMaybe<Scalars['String']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_client_id?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['bigint']['input']>;
  did_trigger_wallet_auto_reload?: InputMaybe<Scalars['Boolean']['input']>;
  expired_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  fee_net_tax?: InputMaybe<Scalars['Int']['input']>;
  fee_net_total?: InputMaybe<Scalars['Int']['input']>;
  fee_subtotal?: InputMaybe<Scalars['Int']['input']>;
  fee_total_discount?: InputMaybe<Scalars['Int']['input']>;
  fee_total_refund?: InputMaybe<Scalars['Int']['input']>;
  finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  funds_transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  invoice_parkable_transactions?: InputMaybe<Invoice_Parkable_Transaction_Arr_Rel_Insert_Input>;
  last_acknowledged_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_enforcement_notified_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_failed_payment_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_successful_payment_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_time_extended_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_parkable_transaction?: InputMaybe<Legacy_Parkable_Transactions_Obj_Rel_Insert_Input>;
  legacy_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  membership_id?: InputMaybe<Scalars['bigint']['input']>;
  net_tax?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  num_payment_errors?: InputMaybe<Scalars['smallint']['input']>;
  num_payment_methods?: InputMaybe<Scalars['smallint']['input']>;
  num_payments?: InputMaybe<Scalars['smallint']['input']>;
  num_time_extensions?: InputMaybe<Scalars['smallint']['input']>;
  operating_system?: InputMaybe<Scalars['String']['input']>;
  operating_system_version?: InputMaybe<Scalars['String']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  other_net_tax?: InputMaybe<Scalars['Int']['input']>;
  other_net_total?: InputMaybe<Scalars['Int']['input']>;
  other_subtotal?: InputMaybe<Scalars['Int']['input']>;
  other_total_discount?: InputMaybe<Scalars['Int']['input']>;
  other_total_refund?: InputMaybe<Scalars['Int']['input']>;
  parkable?: InputMaybe<Parkables_Obj_Rel_Insert_Input>;
  parkableTransactionTask?: InputMaybe<Parkable_Transaction_Task_Obj_Rel_Insert_Input>;
  parkable_area_name?: InputMaybe<Scalars['String']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_identifier?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Obj_Rel_Insert_Input>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_net_tax?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_net_total?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_subtotal?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_total_discount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_total_refund?: InputMaybe<Scalars['Int']['input']>;
  parkable_type?: InputMaybe<Scalars['String']['input']>;
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment_method?: InputMaybe<Payment_Methods_Obj_Rel_Insert_Input>;
  payment_method_alias?: InputMaybe<Scalars['String']['input']>;
  payment_method_card_type?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_last_4?: InputMaybe<Scalars['String']['input']>;
  payment_method_tender?: InputMaybe<Scalars['String']['input']>;
  payment_method_user_id?: InputMaybe<Scalars['bigint']['input']>;
  r_parking_authority?: InputMaybe<R_Parking_Authorities_Obj_Rel_Insert_Input>;
  r_user?: InputMaybe<R_Users_Obj_Rel_Insert_Input>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_license_plate?: InputMaybe<Scalars['String']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_seconds?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_seconds?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  total_discount?: InputMaybe<Scalars['Int']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_refund?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferable_net_tax?: InputMaybe<Scalars['Int']['input']>;
  transferable_net_total?: InputMaybe<Scalars['Int']['input']>;
  transferable_subtotal?: InputMaybe<Scalars['Int']['input']>;
  transferable_total_discount?: InputMaybe<Scalars['Int']['input']>;
  transferable_total_refund?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle?: InputMaybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type R_Parkable_Transactions_Max_Fields = {
  __typename?: 'r_parkable_transactions_max_fields';
  app_version?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  browser_version?: Maybe<Scalars['String']['output']>;
  cancelled_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_client_id?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['bigint']['output']>;
  expired_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  fee_net_tax?: Maybe<Scalars['Int']['output']>;
  fee_net_total?: Maybe<Scalars['Int']['output']>;
  fee_subtotal?: Maybe<Scalars['Int']['output']>;
  fee_total_discount?: Maybe<Scalars['Int']['output']>;
  fee_total_refund?: Maybe<Scalars['Int']['output']>;
  finalized_at?: Maybe<Scalars['timestamp']['output']>;
  funds_transferred_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_acknowledged_at?: Maybe<Scalars['timestamp']['output']>;
  last_enforcement_notified_at?: Maybe<Scalars['timestamp']['output']>;
  last_failed_payment_at?: Maybe<Scalars['timestamp']['output']>;
  last_successful_payment_at?: Maybe<Scalars['timestamp']['output']>;
  last_time_extended_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  membership_id?: Maybe<Scalars['bigint']['output']>;
  net_tax?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  num_payment_errors?: Maybe<Scalars['smallint']['output']>;
  num_payment_methods?: Maybe<Scalars['smallint']['output']>;
  num_payments?: Maybe<Scalars['smallint']['output']>;
  num_time_extensions?: Maybe<Scalars['smallint']['output']>;
  operating_system?: Maybe<Scalars['String']['output']>;
  operating_system_version?: Maybe<Scalars['String']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  other_net_tax?: Maybe<Scalars['Int']['output']>;
  other_net_total?: Maybe<Scalars['Int']['output']>;
  other_subtotal?: Maybe<Scalars['Int']['output']>;
  other_total_discount?: Maybe<Scalars['Int']['output']>;
  other_total_refund?: Maybe<Scalars['Int']['output']>;
  parkable_area_name?: Maybe<Scalars['String']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  parkable_identifier?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_net_tax?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Int']['output']>;
  parkable_type?: Maybe<Scalars['String']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  payment_finalized_at?: Maybe<Scalars['timestamp']['output']>;
  payment_method_alias?: Maybe<Scalars['String']['output']>;
  payment_method_card_type?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_last_4?: Maybe<Scalars['String']['output']>;
  payment_method_tender?: Maybe<Scalars['String']['output']>;
  payment_method_user_id?: Maybe<Scalars['bigint']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_license_plate?: Maybe<Scalars['String']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_unit?: Maybe<Scalars['String']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_unit?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  total_discount?: Maybe<Scalars['Int']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_refund?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferable_net_tax?: Maybe<Scalars['Int']['output']>;
  transferable_net_total?: Maybe<Scalars['Int']['output']>;
  transferable_subtotal?: Maybe<Scalars['Int']['output']>;
  transferable_total_discount?: Maybe<Scalars['Int']['output']>;
  transferable_total_refund?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type R_Parkable_Transactions_Min_Fields = {
  __typename?: 'r_parkable_transactions_min_fields';
  app_version?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  browser_version?: Maybe<Scalars['String']['output']>;
  cancelled_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_client_id?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['bigint']['output']>;
  expired_at?: Maybe<Scalars['timestamp']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  fee_net_tax?: Maybe<Scalars['Int']['output']>;
  fee_net_total?: Maybe<Scalars['Int']['output']>;
  fee_subtotal?: Maybe<Scalars['Int']['output']>;
  fee_total_discount?: Maybe<Scalars['Int']['output']>;
  fee_total_refund?: Maybe<Scalars['Int']['output']>;
  finalized_at?: Maybe<Scalars['timestamp']['output']>;
  funds_transferred_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_acknowledged_at?: Maybe<Scalars['timestamp']['output']>;
  last_enforcement_notified_at?: Maybe<Scalars['timestamp']['output']>;
  last_failed_payment_at?: Maybe<Scalars['timestamp']['output']>;
  last_successful_payment_at?: Maybe<Scalars['timestamp']['output']>;
  last_time_extended_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  membership_id?: Maybe<Scalars['bigint']['output']>;
  net_tax?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  num_payment_errors?: Maybe<Scalars['smallint']['output']>;
  num_payment_methods?: Maybe<Scalars['smallint']['output']>;
  num_payments?: Maybe<Scalars['smallint']['output']>;
  num_time_extensions?: Maybe<Scalars['smallint']['output']>;
  operating_system?: Maybe<Scalars['String']['output']>;
  operating_system_version?: Maybe<Scalars['String']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  other_net_tax?: Maybe<Scalars['Int']['output']>;
  other_net_total?: Maybe<Scalars['Int']['output']>;
  other_subtotal?: Maybe<Scalars['Int']['output']>;
  other_total_discount?: Maybe<Scalars['Int']['output']>;
  other_total_refund?: Maybe<Scalars['Int']['output']>;
  parkable_area_name?: Maybe<Scalars['String']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  parkable_identifier?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_net_tax?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Int']['output']>;
  parkable_type?: Maybe<Scalars['String']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  payment_finalized_at?: Maybe<Scalars['timestamp']['output']>;
  payment_method_alias?: Maybe<Scalars['String']['output']>;
  payment_method_card_type?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_last_4?: Maybe<Scalars['String']['output']>;
  payment_method_tender?: Maybe<Scalars['String']['output']>;
  payment_method_user_id?: Maybe<Scalars['bigint']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_license_plate?: Maybe<Scalars['String']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_unit?: Maybe<Scalars['String']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_unit?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  total_discount?: Maybe<Scalars['Int']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_refund?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferable_net_tax?: Maybe<Scalars['Int']['output']>;
  transferable_net_total?: Maybe<Scalars['Int']['output']>;
  transferable_subtotal?: Maybe<Scalars['Int']['output']>;
  transferable_total_discount?: Maybe<Scalars['Int']['output']>;
  transferable_total_refund?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "r_parkable_transactions" */
export type R_Parkable_Transactions_Mutation_Response = {
  __typename?: 'r_parkable_transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<R_Parkable_Transactions>;
};

/** input type for inserting object relation for remote table "r_parkable_transactions" */
export type R_Parkable_Transactions_Obj_Rel_Insert_Input = {
  data: R_Parkable_Transactions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<R_Parkable_Transactions_On_Conflict>;
};

/** on_conflict condition type for table "r_parkable_transactions" */
export type R_Parkable_Transactions_On_Conflict = {
  constraint: R_Parkable_Transactions_Constraint;
  update_columns?: Array<R_Parkable_Transactions_Update_Column>;
  where?: InputMaybe<R_Parkable_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "r_parkable_transactions". */
export type R_Parkable_Transactions_Order_By = {
  app_version?: InputMaybe<Order_By>;
  browser?: InputMaybe<Order_By>;
  browser_version?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_client_id?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  did_trigger_wallet_auto_reload?: InputMaybe<Order_By>;
  expired_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  fee_net_tax?: InputMaybe<Order_By>;
  fee_net_total?: InputMaybe<Order_By>;
  fee_subtotal?: InputMaybe<Order_By>;
  fee_total_discount?: InputMaybe<Order_By>;
  fee_total_refund?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  funds_transferred_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_parkable_transactions_aggregate?: InputMaybe<Invoice_Parkable_Transaction_Aggregate_Order_By>;
  last_acknowledged_at?: InputMaybe<Order_By>;
  last_enforcement_notified_at?: InputMaybe<Order_By>;
  last_failed_payment_at?: InputMaybe<Order_By>;
  last_successful_payment_at?: InputMaybe<Order_By>;
  last_time_extended_at?: InputMaybe<Order_By>;
  legacy_parkable_transaction?: InputMaybe<Legacy_Parkable_Transactions_Order_By>;
  legacy_parkable_transaction_id?: InputMaybe<Order_By>;
  membership_id?: InputMaybe<Order_By>;
  net_tax?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_payment_errors?: InputMaybe<Order_By>;
  num_payment_methods?: InputMaybe<Order_By>;
  num_payments?: InputMaybe<Order_By>;
  num_time_extensions?: InputMaybe<Order_By>;
  operating_system?: InputMaybe<Order_By>;
  operating_system_version?: InputMaybe<Order_By>;
  original_created_at?: InputMaybe<Order_By>;
  original_updated_at?: InputMaybe<Order_By>;
  other_net_tax?: InputMaybe<Order_By>;
  other_net_total?: InputMaybe<Order_By>;
  other_subtotal?: InputMaybe<Order_By>;
  other_total_discount?: InputMaybe<Order_By>;
  other_total_refund?: InputMaybe<Order_By>;
  parkable?: InputMaybe<Parkables_Order_By>;
  parkableTransactionTask?: InputMaybe<Parkable_Transaction_Task_Order_By>;
  parkable_area_name?: InputMaybe<Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  parkable_identifier?: InputMaybe<Order_By>;
  parkable_transaction?: InputMaybe<Parkable_Transactions_Order_By>;
  parkable_transaction_id?: InputMaybe<Order_By>;
  parkable_transaction_net_tax?: InputMaybe<Order_By>;
  parkable_transaction_net_total?: InputMaybe<Order_By>;
  parkable_transaction_subtotal?: InputMaybe<Order_By>;
  parkable_transaction_total_discount?: InputMaybe<Order_By>;
  parkable_transaction_total_refund?: InputMaybe<Order_By>;
  parkable_type?: InputMaybe<Order_By>;
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  payment_finalized_at?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Payment_Methods_Order_By>;
  payment_method_alias?: InputMaybe<Order_By>;
  payment_method_card_type?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  payment_method_last_4?: InputMaybe<Order_By>;
  payment_method_tender?: InputMaybe<Order_By>;
  payment_method_user_id?: InputMaybe<Order_By>;
  r_parking_authority?: InputMaybe<R_Parking_Authorities_Order_By>;
  r_user?: InputMaybe<R_Users_Order_By>;
  snapshot_fee?: InputMaybe<Order_By>;
  snapshot_license_plate?: InputMaybe<Order_By>;
  snapshot_price?: InputMaybe<Order_By>;
  snapshot_price_interval?: InputMaybe<Order_By>;
  snapshot_price_interval_seconds?: InputMaybe<Order_By>;
  snapshot_price_interval_unit?: InputMaybe<Order_By>;
  snapshot_time_limit?: InputMaybe<Order_By>;
  snapshot_time_limit_seconds?: InputMaybe<Order_By>;
  snapshot_time_limit_unit?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_refund?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferable_net_tax?: InputMaybe<Order_By>;
  transferable_net_total?: InputMaybe<Order_By>;
  transferable_subtotal?: InputMaybe<Order_By>;
  transferable_total_discount?: InputMaybe<Order_By>;
  transferable_total_refund?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicles_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
  vehicle_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: r_parkable_transactions */
export type R_Parkable_Transactions_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "r_parkable_transactions" */
export enum R_Parkable_Transactions_Select_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  Browser = 'browser',
  /** column name */
  BrowserVersion = 'browser_version',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceClientId = 'device_client_id',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DidTriggerWalletAutoReload = 'did_trigger_wallet_auto_reload',
  /** column name */
  ExpiredAt = 'expired_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  FeeNetTax = 'fee_net_tax',
  /** column name */
  FeeNetTotal = 'fee_net_total',
  /** column name */
  FeeSubtotal = 'fee_subtotal',
  /** column name */
  FeeTotalDiscount = 'fee_total_discount',
  /** column name */
  FeeTotalRefund = 'fee_total_refund',
  /** column name */
  FinalizedAt = 'finalized_at',
  /** column name */
  FundsTransferredAt = 'funds_transferred_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastAcknowledgedAt = 'last_acknowledged_at',
  /** column name */
  LastEnforcementNotifiedAt = 'last_enforcement_notified_at',
  /** column name */
  LastFailedPaymentAt = 'last_failed_payment_at',
  /** column name */
  LastSuccessfulPaymentAt = 'last_successful_payment_at',
  /** column name */
  LastTimeExtendedAt = 'last_time_extended_at',
  /** column name */
  LegacyParkableTransactionId = 'legacy_parkable_transaction_id',
  /** column name */
  MembershipId = 'membership_id',
  /** column name */
  NetTax = 'net_tax',
  /** column name */
  NetTotal = 'net_total',
  /** column name */
  NumPaymentErrors = 'num_payment_errors',
  /** column name */
  NumPaymentMethods = 'num_payment_methods',
  /** column name */
  NumPayments = 'num_payments',
  /** column name */
  NumTimeExtensions = 'num_time_extensions',
  /** column name */
  OperatingSystem = 'operating_system',
  /** column name */
  OperatingSystemVersion = 'operating_system_version',
  /** column name */
  OriginalCreatedAt = 'original_created_at',
  /** column name */
  OriginalUpdatedAt = 'original_updated_at',
  /** column name */
  OtherNetTax = 'other_net_tax',
  /** column name */
  OtherNetTotal = 'other_net_total',
  /** column name */
  OtherSubtotal = 'other_subtotal',
  /** column name */
  OtherTotalDiscount = 'other_total_discount',
  /** column name */
  OtherTotalRefund = 'other_total_refund',
  /** column name */
  ParkableAreaName = 'parkable_area_name',
  /** column name */
  ParkableId = 'parkable_id',
  /** column name */
  ParkableIdentifier = 'parkable_identifier',
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id',
  /** column name */
  ParkableTransactionNetTax = 'parkable_transaction_net_tax',
  /** column name */
  ParkableTransactionNetTotal = 'parkable_transaction_net_total',
  /** column name */
  ParkableTransactionSubtotal = 'parkable_transaction_subtotal',
  /** column name */
  ParkableTransactionTotalDiscount = 'parkable_transaction_total_discount',
  /** column name */
  ParkableTransactionTotalRefund = 'parkable_transaction_total_refund',
  /** column name */
  ParkableType = 'parkable_type',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  PaymentFinalizedAt = 'payment_finalized_at',
  /** column name */
  PaymentMethodAlias = 'payment_method_alias',
  /** column name */
  PaymentMethodCardType = 'payment_method_card_type',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  PaymentMethodLast_4 = 'payment_method_last_4',
  /** column name */
  PaymentMethodTender = 'payment_method_tender',
  /** column name */
  PaymentMethodUserId = 'payment_method_user_id',
  /** column name */
  SnapshotFee = 'snapshot_fee',
  /** column name */
  SnapshotLicensePlate = 'snapshot_license_plate',
  /** column name */
  SnapshotPrice = 'snapshot_price',
  /** column name */
  SnapshotPriceInterval = 'snapshot_price_interval',
  /** column name */
  SnapshotPriceIntervalSeconds = 'snapshot_price_interval_seconds',
  /** column name */
  SnapshotPriceIntervalUnit = 'snapshot_price_interval_unit',
  /** column name */
  SnapshotTimeLimit = 'snapshot_time_limit',
  /** column name */
  SnapshotTimeLimitSeconds = 'snapshot_time_limit_seconds',
  /** column name */
  SnapshotTimeLimitUnit = 'snapshot_time_limit_unit',
  /** column name */
  Source = 'source',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Time = 'time',
  /** column name */
  TotalDiscount = 'total_discount',
  /** column name */
  TotalPaid = 'total_paid',
  /** column name */
  TotalRefund = 'total_refund',
  /** column name */
  TotalUnpaid = 'total_unpaid',
  /** column name */
  TransferableNetTax = 'transferable_net_tax',
  /** column name */
  TransferableNetTotal = 'transferable_net_total',
  /** column name */
  TransferableSubtotal = 'transferable_subtotal',
  /** column name */
  TransferableTotalDiscount = 'transferable_total_discount',
  /** column name */
  TransferableTotalRefund = 'transferable_total_refund',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  VehicleName = 'vehicle_name'
}

/** input type for updating data in table "r_parkable_transactions" */
export type R_Parkable_Transactions_Set_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  browser?: InputMaybe<Scalars['String']['input']>;
  browser_version?: InputMaybe<Scalars['String']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_client_id?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['bigint']['input']>;
  did_trigger_wallet_auto_reload?: InputMaybe<Scalars['Boolean']['input']>;
  expired_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  fee_net_tax?: InputMaybe<Scalars['Int']['input']>;
  fee_net_total?: InputMaybe<Scalars['Int']['input']>;
  fee_subtotal?: InputMaybe<Scalars['Int']['input']>;
  fee_total_discount?: InputMaybe<Scalars['Int']['input']>;
  fee_total_refund?: InputMaybe<Scalars['Int']['input']>;
  finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  funds_transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_acknowledged_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_enforcement_notified_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_failed_payment_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_successful_payment_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_time_extended_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  membership_id?: InputMaybe<Scalars['bigint']['input']>;
  net_tax?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  num_payment_errors?: InputMaybe<Scalars['smallint']['input']>;
  num_payment_methods?: InputMaybe<Scalars['smallint']['input']>;
  num_payments?: InputMaybe<Scalars['smallint']['input']>;
  num_time_extensions?: InputMaybe<Scalars['smallint']['input']>;
  operating_system?: InputMaybe<Scalars['String']['input']>;
  operating_system_version?: InputMaybe<Scalars['String']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  other_net_tax?: InputMaybe<Scalars['Int']['input']>;
  other_net_total?: InputMaybe<Scalars['Int']['input']>;
  other_subtotal?: InputMaybe<Scalars['Int']['input']>;
  other_total_discount?: InputMaybe<Scalars['Int']['input']>;
  other_total_refund?: InputMaybe<Scalars['Int']['input']>;
  parkable_area_name?: InputMaybe<Scalars['String']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_identifier?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_net_tax?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_net_total?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_subtotal?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_total_discount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_total_refund?: InputMaybe<Scalars['Int']['input']>;
  parkable_type?: InputMaybe<Scalars['String']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment_method_alias?: InputMaybe<Scalars['String']['input']>;
  payment_method_card_type?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_last_4?: InputMaybe<Scalars['String']['input']>;
  payment_method_tender?: InputMaybe<Scalars['String']['input']>;
  payment_method_user_id?: InputMaybe<Scalars['bigint']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_license_plate?: InputMaybe<Scalars['String']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_seconds?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_seconds?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  total_discount?: InputMaybe<Scalars['Int']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_refund?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferable_net_tax?: InputMaybe<Scalars['Int']['input']>;
  transferable_net_total?: InputMaybe<Scalars['Int']['input']>;
  transferable_subtotal?: InputMaybe<Scalars['Int']['input']>;
  transferable_total_discount?: InputMaybe<Scalars['Int']['input']>;
  transferable_total_refund?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type R_Parkable_Transactions_Stddev_Fields = {
  __typename?: 'r_parkable_transactions_stddev_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  fee_net_tax?: Maybe<Scalars['Float']['output']>;
  fee_net_total?: Maybe<Scalars['Float']['output']>;
  fee_subtotal?: Maybe<Scalars['Float']['output']>;
  fee_total_discount?: Maybe<Scalars['Float']['output']>;
  fee_total_refund?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  membership_id?: Maybe<Scalars['Float']['output']>;
  net_tax?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_payment_errors?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_payments?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  other_net_tax?: Maybe<Scalars['Float']['output']>;
  other_net_total?: Maybe<Scalars['Float']['output']>;
  other_subtotal?: Maybe<Scalars['Float']['output']>;
  other_total_discount?: Maybe<Scalars['Float']['output']>;
  other_total_refund?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_tax?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment_method_user_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  total_discount?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_refund?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_net_tax?: Maybe<Scalars['Float']['output']>;
  transferable_net_total?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_total_discount?: Maybe<Scalars['Float']['output']>;
  transferable_total_refund?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type R_Parkable_Transactions_Stddev_Pop_Fields = {
  __typename?: 'r_parkable_transactions_stddev_pop_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  fee_net_tax?: Maybe<Scalars['Float']['output']>;
  fee_net_total?: Maybe<Scalars['Float']['output']>;
  fee_subtotal?: Maybe<Scalars['Float']['output']>;
  fee_total_discount?: Maybe<Scalars['Float']['output']>;
  fee_total_refund?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  membership_id?: Maybe<Scalars['Float']['output']>;
  net_tax?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_payment_errors?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_payments?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  other_net_tax?: Maybe<Scalars['Float']['output']>;
  other_net_total?: Maybe<Scalars['Float']['output']>;
  other_subtotal?: Maybe<Scalars['Float']['output']>;
  other_total_discount?: Maybe<Scalars['Float']['output']>;
  other_total_refund?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_tax?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment_method_user_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  total_discount?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_refund?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_net_tax?: Maybe<Scalars['Float']['output']>;
  transferable_net_total?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_total_discount?: Maybe<Scalars['Float']['output']>;
  transferable_total_refund?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type R_Parkable_Transactions_Stddev_Samp_Fields = {
  __typename?: 'r_parkable_transactions_stddev_samp_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  fee_net_tax?: Maybe<Scalars['Float']['output']>;
  fee_net_total?: Maybe<Scalars['Float']['output']>;
  fee_subtotal?: Maybe<Scalars['Float']['output']>;
  fee_total_discount?: Maybe<Scalars['Float']['output']>;
  fee_total_refund?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  membership_id?: Maybe<Scalars['Float']['output']>;
  net_tax?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_payment_errors?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_payments?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  other_net_tax?: Maybe<Scalars['Float']['output']>;
  other_net_total?: Maybe<Scalars['Float']['output']>;
  other_subtotal?: Maybe<Scalars['Float']['output']>;
  other_total_discount?: Maybe<Scalars['Float']['output']>;
  other_total_refund?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_tax?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment_method_user_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  total_discount?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_refund?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_net_tax?: Maybe<Scalars['Float']['output']>;
  transferable_net_total?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_total_discount?: Maybe<Scalars['Float']['output']>;
  transferable_total_refund?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "r_parkable_transactions" */
export type R_Parkable_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: R_Parkable_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type R_Parkable_Transactions_Stream_Cursor_Value_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  browser?: InputMaybe<Scalars['String']['input']>;
  browser_version?: InputMaybe<Scalars['String']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_client_id?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['bigint']['input']>;
  did_trigger_wallet_auto_reload?: InputMaybe<Scalars['Boolean']['input']>;
  expired_at?: InputMaybe<Scalars['timestamp']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  fee_net_tax?: InputMaybe<Scalars['Int']['input']>;
  fee_net_total?: InputMaybe<Scalars['Int']['input']>;
  fee_subtotal?: InputMaybe<Scalars['Int']['input']>;
  fee_total_discount?: InputMaybe<Scalars['Int']['input']>;
  fee_total_refund?: InputMaybe<Scalars['Int']['input']>;
  finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  funds_transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_acknowledged_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_enforcement_notified_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_failed_payment_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_successful_payment_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_time_extended_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  membership_id?: InputMaybe<Scalars['bigint']['input']>;
  net_tax?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  num_payment_errors?: InputMaybe<Scalars['smallint']['input']>;
  num_payment_methods?: InputMaybe<Scalars['smallint']['input']>;
  num_payments?: InputMaybe<Scalars['smallint']['input']>;
  num_time_extensions?: InputMaybe<Scalars['smallint']['input']>;
  operating_system?: InputMaybe<Scalars['String']['input']>;
  operating_system_version?: InputMaybe<Scalars['String']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  other_net_tax?: InputMaybe<Scalars['Int']['input']>;
  other_net_total?: InputMaybe<Scalars['Int']['input']>;
  other_subtotal?: InputMaybe<Scalars['Int']['input']>;
  other_total_discount?: InputMaybe<Scalars['Int']['input']>;
  other_total_refund?: InputMaybe<Scalars['Int']['input']>;
  parkable_area_name?: InputMaybe<Scalars['String']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_identifier?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  parkable_transaction_net_tax?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_net_total?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_subtotal?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_total_discount?: InputMaybe<Scalars['Int']['input']>;
  parkable_transaction_total_refund?: InputMaybe<Scalars['Int']['input']>;
  parkable_type?: InputMaybe<Scalars['String']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_finalized_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment_method_alias?: InputMaybe<Scalars['String']['input']>;
  payment_method_card_type?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method_last_4?: InputMaybe<Scalars['String']['input']>;
  payment_method_tender?: InputMaybe<Scalars['String']['input']>;
  payment_method_user_id?: InputMaybe<Scalars['bigint']['input']>;
  snapshot_fee?: InputMaybe<Scalars['Int']['input']>;
  snapshot_license_plate?: InputMaybe<Scalars['String']['input']>;
  snapshot_price?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_seconds?: InputMaybe<Scalars['Int']['input']>;
  snapshot_price_interval_unit?: InputMaybe<Scalars['String']['input']>;
  snapshot_time_limit?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_seconds?: InputMaybe<Scalars['Int']['input']>;
  snapshot_time_limit_unit?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  total_discount?: InputMaybe<Scalars['Int']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_refund?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferable_net_tax?: InputMaybe<Scalars['Int']['input']>;
  transferable_net_total?: InputMaybe<Scalars['Int']['input']>;
  transferable_subtotal?: InputMaybe<Scalars['Int']['input']>;
  transferable_total_discount?: InputMaybe<Scalars['Int']['input']>;
  transferable_total_refund?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_id?: InputMaybe<Scalars['bigint']['input']>;
  vehicle_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type R_Parkable_Transactions_Sum_Fields = {
  __typename?: 'r_parkable_transactions_sum_fields';
  device_id?: Maybe<Scalars['bigint']['output']>;
  fee_net_tax?: Maybe<Scalars['Int']['output']>;
  fee_net_total?: Maybe<Scalars['Int']['output']>;
  fee_subtotal?: Maybe<Scalars['Int']['output']>;
  fee_total_discount?: Maybe<Scalars['Int']['output']>;
  fee_total_refund?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  legacy_parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  membership_id?: Maybe<Scalars['bigint']['output']>;
  net_tax?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  num_payment_errors?: Maybe<Scalars['smallint']['output']>;
  num_payment_methods?: Maybe<Scalars['smallint']['output']>;
  num_payments?: Maybe<Scalars['smallint']['output']>;
  num_time_extensions?: Maybe<Scalars['smallint']['output']>;
  other_net_tax?: Maybe<Scalars['Int']['output']>;
  other_net_total?: Maybe<Scalars['Int']['output']>;
  other_subtotal?: Maybe<Scalars['Int']['output']>;
  other_total_discount?: Maybe<Scalars['Int']['output']>;
  other_total_refund?: Maybe<Scalars['Int']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  parkable_identifier?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_id?: Maybe<Scalars['bigint']['output']>;
  parkable_transaction_net_tax?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Int']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Int']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_id?: Maybe<Scalars['bigint']['output']>;
  payment_method_user_id?: Maybe<Scalars['bigint']['output']>;
  snapshot_fee?: Maybe<Scalars['Int']['output']>;
  snapshot_price?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Int']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Int']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  total_discount?: Maybe<Scalars['Int']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_refund?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferable_net_tax?: Maybe<Scalars['Int']['output']>;
  transferable_net_total?: Maybe<Scalars['Int']['output']>;
  transferable_subtotal?: Maybe<Scalars['Int']['output']>;
  transferable_total_discount?: Maybe<Scalars['Int']['output']>;
  transferable_total_refund?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  vehicle_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "r_parkable_transactions" */
export enum R_Parkable_Transactions_Update_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  Browser = 'browser',
  /** column name */
  BrowserVersion = 'browser_version',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceClientId = 'device_client_id',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DidTriggerWalletAutoReload = 'did_trigger_wallet_auto_reload',
  /** column name */
  ExpiredAt = 'expired_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  FeeNetTax = 'fee_net_tax',
  /** column name */
  FeeNetTotal = 'fee_net_total',
  /** column name */
  FeeSubtotal = 'fee_subtotal',
  /** column name */
  FeeTotalDiscount = 'fee_total_discount',
  /** column name */
  FeeTotalRefund = 'fee_total_refund',
  /** column name */
  FinalizedAt = 'finalized_at',
  /** column name */
  FundsTransferredAt = 'funds_transferred_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastAcknowledgedAt = 'last_acknowledged_at',
  /** column name */
  LastEnforcementNotifiedAt = 'last_enforcement_notified_at',
  /** column name */
  LastFailedPaymentAt = 'last_failed_payment_at',
  /** column name */
  LastSuccessfulPaymentAt = 'last_successful_payment_at',
  /** column name */
  LastTimeExtendedAt = 'last_time_extended_at',
  /** column name */
  LegacyParkableTransactionId = 'legacy_parkable_transaction_id',
  /** column name */
  MembershipId = 'membership_id',
  /** column name */
  NetTax = 'net_tax',
  /** column name */
  NetTotal = 'net_total',
  /** column name */
  NumPaymentErrors = 'num_payment_errors',
  /** column name */
  NumPaymentMethods = 'num_payment_methods',
  /** column name */
  NumPayments = 'num_payments',
  /** column name */
  NumTimeExtensions = 'num_time_extensions',
  /** column name */
  OperatingSystem = 'operating_system',
  /** column name */
  OperatingSystemVersion = 'operating_system_version',
  /** column name */
  OriginalCreatedAt = 'original_created_at',
  /** column name */
  OriginalUpdatedAt = 'original_updated_at',
  /** column name */
  OtherNetTax = 'other_net_tax',
  /** column name */
  OtherNetTotal = 'other_net_total',
  /** column name */
  OtherSubtotal = 'other_subtotal',
  /** column name */
  OtherTotalDiscount = 'other_total_discount',
  /** column name */
  OtherTotalRefund = 'other_total_refund',
  /** column name */
  ParkableAreaName = 'parkable_area_name',
  /** column name */
  ParkableId = 'parkable_id',
  /** column name */
  ParkableIdentifier = 'parkable_identifier',
  /** column name */
  ParkableTransactionId = 'parkable_transaction_id',
  /** column name */
  ParkableTransactionNetTax = 'parkable_transaction_net_tax',
  /** column name */
  ParkableTransactionNetTotal = 'parkable_transaction_net_total',
  /** column name */
  ParkableTransactionSubtotal = 'parkable_transaction_subtotal',
  /** column name */
  ParkableTransactionTotalDiscount = 'parkable_transaction_total_discount',
  /** column name */
  ParkableTransactionTotalRefund = 'parkable_transaction_total_refund',
  /** column name */
  ParkableType = 'parkable_type',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  PaymentFinalizedAt = 'payment_finalized_at',
  /** column name */
  PaymentMethodAlias = 'payment_method_alias',
  /** column name */
  PaymentMethodCardType = 'payment_method_card_type',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  PaymentMethodLast_4 = 'payment_method_last_4',
  /** column name */
  PaymentMethodTender = 'payment_method_tender',
  /** column name */
  PaymentMethodUserId = 'payment_method_user_id',
  /** column name */
  SnapshotFee = 'snapshot_fee',
  /** column name */
  SnapshotLicensePlate = 'snapshot_license_plate',
  /** column name */
  SnapshotPrice = 'snapshot_price',
  /** column name */
  SnapshotPriceInterval = 'snapshot_price_interval',
  /** column name */
  SnapshotPriceIntervalSeconds = 'snapshot_price_interval_seconds',
  /** column name */
  SnapshotPriceIntervalUnit = 'snapshot_price_interval_unit',
  /** column name */
  SnapshotTimeLimit = 'snapshot_time_limit',
  /** column name */
  SnapshotTimeLimitSeconds = 'snapshot_time_limit_seconds',
  /** column name */
  SnapshotTimeLimitUnit = 'snapshot_time_limit_unit',
  /** column name */
  Source = 'source',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Time = 'time',
  /** column name */
  TotalDiscount = 'total_discount',
  /** column name */
  TotalPaid = 'total_paid',
  /** column name */
  TotalRefund = 'total_refund',
  /** column name */
  TotalUnpaid = 'total_unpaid',
  /** column name */
  TransferableNetTax = 'transferable_net_tax',
  /** column name */
  TransferableNetTotal = 'transferable_net_total',
  /** column name */
  TransferableSubtotal = 'transferable_subtotal',
  /** column name */
  TransferableTotalDiscount = 'transferable_total_discount',
  /** column name */
  TransferableTotalRefund = 'transferable_total_refund',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  VehicleName = 'vehicle_name'
}

export type R_Parkable_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<R_Parkable_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<R_Parkable_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: R_Parkable_Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type R_Parkable_Transactions_Var_Pop_Fields = {
  __typename?: 'r_parkable_transactions_var_pop_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  fee_net_tax?: Maybe<Scalars['Float']['output']>;
  fee_net_total?: Maybe<Scalars['Float']['output']>;
  fee_subtotal?: Maybe<Scalars['Float']['output']>;
  fee_total_discount?: Maybe<Scalars['Float']['output']>;
  fee_total_refund?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  membership_id?: Maybe<Scalars['Float']['output']>;
  net_tax?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_payment_errors?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_payments?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  other_net_tax?: Maybe<Scalars['Float']['output']>;
  other_net_total?: Maybe<Scalars['Float']['output']>;
  other_subtotal?: Maybe<Scalars['Float']['output']>;
  other_total_discount?: Maybe<Scalars['Float']['output']>;
  other_total_refund?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_tax?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment_method_user_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  total_discount?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_refund?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_net_tax?: Maybe<Scalars['Float']['output']>;
  transferable_net_total?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_total_discount?: Maybe<Scalars['Float']['output']>;
  transferable_total_refund?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type R_Parkable_Transactions_Var_Samp_Fields = {
  __typename?: 'r_parkable_transactions_var_samp_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  fee_net_tax?: Maybe<Scalars['Float']['output']>;
  fee_net_total?: Maybe<Scalars['Float']['output']>;
  fee_subtotal?: Maybe<Scalars['Float']['output']>;
  fee_total_discount?: Maybe<Scalars['Float']['output']>;
  fee_total_refund?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  membership_id?: Maybe<Scalars['Float']['output']>;
  net_tax?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_payment_errors?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_payments?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  other_net_tax?: Maybe<Scalars['Float']['output']>;
  other_net_total?: Maybe<Scalars['Float']['output']>;
  other_subtotal?: Maybe<Scalars['Float']['output']>;
  other_total_discount?: Maybe<Scalars['Float']['output']>;
  other_total_refund?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_tax?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment_method_user_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  total_discount?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_refund?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_net_tax?: Maybe<Scalars['Float']['output']>;
  transferable_net_total?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_total_discount?: Maybe<Scalars['Float']['output']>;
  transferable_total_refund?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type R_Parkable_Transactions_Variance_Fields = {
  __typename?: 'r_parkable_transactions_variance_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
  fee_net_tax?: Maybe<Scalars['Float']['output']>;
  fee_net_total?: Maybe<Scalars['Float']['output']>;
  fee_subtotal?: Maybe<Scalars['Float']['output']>;
  fee_total_discount?: Maybe<Scalars['Float']['output']>;
  fee_total_refund?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  membership_id?: Maybe<Scalars['Float']['output']>;
  net_tax?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_payment_errors?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_payments?: Maybe<Scalars['Float']['output']>;
  num_time_extensions?: Maybe<Scalars['Float']['output']>;
  other_net_tax?: Maybe<Scalars['Float']['output']>;
  other_net_total?: Maybe<Scalars['Float']['output']>;
  other_subtotal?: Maybe<Scalars['Float']['output']>;
  other_total_discount?: Maybe<Scalars['Float']['output']>;
  other_total_refund?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  parkable_identifier?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_id?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_tax?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_net_total?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_subtotal?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_discount?: Maybe<Scalars['Float']['output']>;
  parkable_transaction_total_refund?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  payment_method_id?: Maybe<Scalars['Float']['output']>;
  payment_method_user_id?: Maybe<Scalars['Float']['output']>;
  snapshot_fee?: Maybe<Scalars['Float']['output']>;
  snapshot_price?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval?: Maybe<Scalars['Float']['output']>;
  snapshot_price_interval_seconds?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit?: Maybe<Scalars['Float']['output']>;
  snapshot_time_limit_seconds?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  total_discount?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_refund?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transferable_net_tax?: Maybe<Scalars['Float']['output']>;
  transferable_net_total?: Maybe<Scalars['Float']['output']>;
  transferable_subtotal?: Maybe<Scalars['Float']['output']>;
  transferable_total_discount?: Maybe<Scalars['Float']['output']>;
  transferable_total_refund?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  vehicle_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "r_parking_authorities" */
export type R_Parking_Authorities = {
  __typename?: 'r_parking_authorities';
  city?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_first_name?: Maybe<Scalars['String']['output']>;
  contact_last_name?: Maybe<Scalars['String']['output']>;
  contact_phone_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  legacy_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_created_at: Scalars['timestamp']['output'];
  original_deleted_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  parkingAuthoritySettings?: Maybe<Parking_Authority_Settings>;
  parking_authority_id: Scalars['bigint']['output'];
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "r_parking_authorities" */
export type R_Parking_Authorities_Aggregate = {
  __typename?: 'r_parking_authorities_aggregate';
  aggregate?: Maybe<R_Parking_Authorities_Aggregate_Fields>;
  nodes: Array<R_Parking_Authorities>;
};

/** aggregate fields of "r_parking_authorities" */
export type R_Parking_Authorities_Aggregate_Fields = {
  __typename?: 'r_parking_authorities_aggregate_fields';
  avg?: Maybe<R_Parking_Authorities_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<R_Parking_Authorities_Max_Fields>;
  min?: Maybe<R_Parking_Authorities_Min_Fields>;
  stddev?: Maybe<R_Parking_Authorities_Stddev_Fields>;
  stddev_pop?: Maybe<R_Parking_Authorities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<R_Parking_Authorities_Stddev_Samp_Fields>;
  sum?: Maybe<R_Parking_Authorities_Sum_Fields>;
  var_pop?: Maybe<R_Parking_Authorities_Var_Pop_Fields>;
  var_samp?: Maybe<R_Parking_Authorities_Var_Samp_Fields>;
  variance?: Maybe<R_Parking_Authorities_Variance_Fields>;
};


/** aggregate fields of "r_parking_authorities" */
export type R_Parking_Authorities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<R_Parking_Authorities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type R_Parking_Authorities_Avg_Fields = {
  __typename?: 'r_parking_authorities_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "r_parking_authorities". All fields are combined with a logical 'AND'. */
export type R_Parking_Authorities_Bool_Exp = {
  _and?: InputMaybe<Array<R_Parking_Authorities_Bool_Exp>>;
  _not?: InputMaybe<R_Parking_Authorities_Bool_Exp>;
  _or?: InputMaybe<Array<R_Parking_Authorities_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_first_name?: InputMaybe<String_Comparison_Exp>;
  contact_last_name?: InputMaybe<String_Comparison_Exp>;
  contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  legacy_parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  mxm_customer_id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  original_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  original_deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  original_updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  parkingAuthoritySettings?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  postal_code?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "r_parking_authorities" */
export enum R_Parking_Authorities_Constraint {
  /** unique or primary key constraint on columns "legacy_parking_authority_id" */
  RParkingAuthoritiesLegacyParkingAuthorityIdUnique = 'r_parking_authorities_legacy_parking_authority_id_unique',
  /** unique or primary key constraint on columns "parking_authority_id" */
  RParkingAuthoritiesParkingAuthorityIdUnique = 'r_parking_authorities_parking_authority_id_unique',
  /** unique or primary key constraint on columns "id" */
  RParkingAuthoritiesPkey = 'r_parking_authorities_pkey'
}

/** input type for incrementing numeric columns in table "r_parking_authorities" */
export type R_Parking_Authorities_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "r_parking_authorities" */
export type R_Parking_Authorities_Insert_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_first_name?: InputMaybe<Scalars['String']['input']>;
  contact_last_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  parkingAuthoritySettings?: InputMaybe<Parking_Authority_Settings_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type R_Parking_Authorities_Max_Fields = {
  __typename?: 'r_parking_authorities_max_fields';
  city?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_first_name?: Maybe<Scalars['String']['output']>;
  contact_last_name?: Maybe<Scalars['String']['output']>;
  contact_phone_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  legacy_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_deleted_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type R_Parking_Authorities_Min_Fields = {
  __typename?: 'r_parking_authorities_min_fields';
  city?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_first_name?: Maybe<Scalars['String']['output']>;
  contact_last_name?: Maybe<Scalars['String']['output']>;
  contact_phone_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  legacy_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_deleted_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "r_parking_authorities" */
export type R_Parking_Authorities_Mutation_Response = {
  __typename?: 'r_parking_authorities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<R_Parking_Authorities>;
};

/** input type for inserting object relation for remote table "r_parking_authorities" */
export type R_Parking_Authorities_Obj_Rel_Insert_Input = {
  data: R_Parking_Authorities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<R_Parking_Authorities_On_Conflict>;
};

/** on_conflict condition type for table "r_parking_authorities" */
export type R_Parking_Authorities_On_Conflict = {
  constraint: R_Parking_Authorities_Constraint;
  update_columns?: Array<R_Parking_Authorities_Update_Column>;
  where?: InputMaybe<R_Parking_Authorities_Bool_Exp>;
};

/** Ordering options when selecting data from "r_parking_authorities". */
export type R_Parking_Authorities_Order_By = {
  city?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_first_name?: InputMaybe<Order_By>;
  contact_last_name?: InputMaybe<Order_By>;
  contact_phone_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacy_parking_authority_id?: InputMaybe<Order_By>;
  mxm_customer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  original_created_at?: InputMaybe<Order_By>;
  original_deleted_at?: InputMaybe<Order_By>;
  original_updated_at?: InputMaybe<Order_By>;
  parkingAuthoritySettings?: InputMaybe<Parking_Authority_Settings_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: r_parking_authorities */
export type R_Parking_Authorities_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "r_parking_authorities" */
export enum R_Parking_Authorities_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactFirstName = 'contact_first_name',
  /** column name */
  ContactLastName = 'contact_last_name',
  /** column name */
  ContactPhoneNumber = 'contact_phone_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LegacyParkingAuthorityId = 'legacy_parking_authority_id',
  /** column name */
  MxmCustomerId = 'mxm_customer_id',
  /** column name */
  Name = 'name',
  /** column name */
  OriginalCreatedAt = 'original_created_at',
  /** column name */
  OriginalDeletedAt = 'original_deleted_at',
  /** column name */
  OriginalUpdatedAt = 'original_updated_at',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  State = 'state',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "r_parking_authorities" */
export type R_Parking_Authorities_Set_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_first_name?: InputMaybe<Scalars['String']['input']>;
  contact_last_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type R_Parking_Authorities_Stddev_Fields = {
  __typename?: 'r_parking_authorities_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type R_Parking_Authorities_Stddev_Pop_Fields = {
  __typename?: 'r_parking_authorities_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type R_Parking_Authorities_Stddev_Samp_Fields = {
  __typename?: 'r_parking_authorities_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "r_parking_authorities" */
export type R_Parking_Authorities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: R_Parking_Authorities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type R_Parking_Authorities_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_first_name?: InputMaybe<Scalars['String']['input']>;
  contact_last_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type R_Parking_Authorities_Sum_Fields = {
  __typename?: 'r_parking_authorities_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  legacy_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "r_parking_authorities" */
export enum R_Parking_Authorities_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactFirstName = 'contact_first_name',
  /** column name */
  ContactLastName = 'contact_last_name',
  /** column name */
  ContactPhoneNumber = 'contact_phone_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LegacyParkingAuthorityId = 'legacy_parking_authority_id',
  /** column name */
  MxmCustomerId = 'mxm_customer_id',
  /** column name */
  Name = 'name',
  /** column name */
  OriginalCreatedAt = 'original_created_at',
  /** column name */
  OriginalDeletedAt = 'original_deleted_at',
  /** column name */
  OriginalUpdatedAt = 'original_updated_at',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  State = 'state',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type R_Parking_Authorities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<R_Parking_Authorities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<R_Parking_Authorities_Set_Input>;
  /** filter the rows which have to be updated */
  where: R_Parking_Authorities_Bool_Exp;
};

/** aggregate var_pop on columns */
export type R_Parking_Authorities_Var_Pop_Fields = {
  __typename?: 'r_parking_authorities_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type R_Parking_Authorities_Var_Samp_Fields = {
  __typename?: 'r_parking_authorities_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type R_Parking_Authorities_Variance_Fields = {
  __typename?: 'r_parking_authorities_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "r_payment_batches" */
export type R_Payment_Batches = {
  __typename?: 'r_payment_batches';
  /** An object relationship */
  batchSet?: Maybe<Batch_Sets>;
  batch_net_count?: Maybe<Scalars['Int']['output']>;
  batch_net_total?: Maybe<Scalars['Int']['output']>;
  batch_return_count?: Maybe<Scalars['Int']['output']>;
  batch_return_total?: Maybe<Scalars['Int']['output']>;
  batch_sale_count?: Maybe<Scalars['Int']['output']>;
  batch_sale_total?: Maybe<Scalars['Int']['output']>;
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  estimated_bank_settle_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  mxMerchantPaymentBatchMeta?: Maybe<Mx_Merchant_Payment_Batch_Metas>;
  original_created_at: Scalars['timestamp']['output'];
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id: Scalars['bigint']['output'];
  resource_net_count?: Maybe<Scalars['Int']['output']>;
  resource_net_total?: Maybe<Scalars['Int']['output']>;
  resource_return_count?: Maybe<Scalars['Int']['output']>;
  resource_return_total?: Maybe<Scalars['Int']['output']>;
  resource_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_sale_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  system_approved_count?: Maybe<Scalars['Int']['output']>;
  system_approved_total?: Maybe<Scalars['Int']['output']>;
  system_charged_back_count?: Maybe<Scalars['Int']['output']>;
  system_charged_back_total?: Maybe<Scalars['Int']['output']>;
  system_count?: Maybe<Scalars['Int']['output']>;
  system_declined_count?: Maybe<Scalars['Int']['output']>;
  system_declined_total?: Maybe<Scalars['Int']['output']>;
  system_failed_count?: Maybe<Scalars['Int']['output']>;
  system_failed_total?: Maybe<Scalars['Int']['output']>;
  system_net_count?: Maybe<Scalars['Int']['output']>;
  system_net_total?: Maybe<Scalars['Int']['output']>;
  system_prefund_count?: Maybe<Scalars['Int']['output']>;
  system_prefund_total?: Maybe<Scalars['Int']['output']>;
  system_return_count?: Maybe<Scalars['Int']['output']>;
  system_return_total?: Maybe<Scalars['Int']['output']>;
  system_sale_count?: Maybe<Scalars['Int']['output']>;
  system_sale_total?: Maybe<Scalars['Int']['output']>;
  system_settled_count?: Maybe<Scalars['Int']['output']>;
  system_settled_total?: Maybe<Scalars['Int']['output']>;
  system_transfer_count?: Maybe<Scalars['Int']['output']>;
  system_transfer_total?: Maybe<Scalars['Int']['output']>;
  system_voided_count?: Maybe<Scalars['Int']['output']>;
  system_voided_total?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "r_payment_batches" */
export type R_Payment_Batches_Aggregate = {
  __typename?: 'r_payment_batches_aggregate';
  aggregate?: Maybe<R_Payment_Batches_Aggregate_Fields>;
  nodes: Array<R_Payment_Batches>;
};

/** aggregate fields of "r_payment_batches" */
export type R_Payment_Batches_Aggregate_Fields = {
  __typename?: 'r_payment_batches_aggregate_fields';
  avg?: Maybe<R_Payment_Batches_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<R_Payment_Batches_Max_Fields>;
  min?: Maybe<R_Payment_Batches_Min_Fields>;
  stddev?: Maybe<R_Payment_Batches_Stddev_Fields>;
  stddev_pop?: Maybe<R_Payment_Batches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<R_Payment_Batches_Stddev_Samp_Fields>;
  sum?: Maybe<R_Payment_Batches_Sum_Fields>;
  var_pop?: Maybe<R_Payment_Batches_Var_Pop_Fields>;
  var_samp?: Maybe<R_Payment_Batches_Var_Samp_Fields>;
  variance?: Maybe<R_Payment_Batches_Variance_Fields>;
};


/** aggregate fields of "r_payment_batches" */
export type R_Payment_Batches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<R_Payment_Batches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type R_Payment_Batches_Avg_Fields = {
  __typename?: 'r_payment_batches_avg_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "r_payment_batches". All fields are combined with a logical 'AND'. */
export type R_Payment_Batches_Bool_Exp = {
  _and?: InputMaybe<Array<R_Payment_Batches_Bool_Exp>>;
  _not?: InputMaybe<R_Payment_Batches_Bool_Exp>;
  _or?: InputMaybe<Array<R_Payment_Batches_Bool_Exp>>;
  batchSet?: InputMaybe<Batch_Sets_Bool_Exp>;
  batch_net_count?: InputMaybe<Int_Comparison_Exp>;
  batch_net_total?: InputMaybe<Int_Comparison_Exp>;
  batch_return_count?: InputMaybe<Int_Comparison_Exp>;
  batch_return_total?: InputMaybe<Int_Comparison_Exp>;
  batch_sale_count?: InputMaybe<Int_Comparison_Exp>;
  batch_sale_total?: InputMaybe<Int_Comparison_Exp>;
  batch_set_id?: InputMaybe<Bigint_Comparison_Exp>;
  calculated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  calculating_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  estimated_bank_settle_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  mxMerchantPaymentBatchMeta?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>;
  original_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  original_updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  payment_batch?: InputMaybe<Payment_Batches_Bool_Exp>;
  payment_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  resource_net_count?: InputMaybe<Int_Comparison_Exp>;
  resource_net_total?: InputMaybe<Int_Comparison_Exp>;
  resource_return_count?: InputMaybe<Int_Comparison_Exp>;
  resource_return_total?: InputMaybe<Int_Comparison_Exp>;
  resource_sale_count?: InputMaybe<Int_Comparison_Exp>;
  resource_sale_total?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_net_count?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_net_total?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_return_count?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_return_total?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_sale_count?: InputMaybe<Int_Comparison_Exp>;
  resource_unmatched_sale_total?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  system_approved_count?: InputMaybe<Int_Comparison_Exp>;
  system_approved_total?: InputMaybe<Int_Comparison_Exp>;
  system_charged_back_count?: InputMaybe<Int_Comparison_Exp>;
  system_charged_back_total?: InputMaybe<Int_Comparison_Exp>;
  system_count?: InputMaybe<Int_Comparison_Exp>;
  system_declined_count?: InputMaybe<Int_Comparison_Exp>;
  system_declined_total?: InputMaybe<Int_Comparison_Exp>;
  system_failed_count?: InputMaybe<Int_Comparison_Exp>;
  system_failed_total?: InputMaybe<Int_Comparison_Exp>;
  system_net_count?: InputMaybe<Int_Comparison_Exp>;
  system_net_total?: InputMaybe<Int_Comparison_Exp>;
  system_prefund_count?: InputMaybe<Int_Comparison_Exp>;
  system_prefund_total?: InputMaybe<Int_Comparison_Exp>;
  system_return_count?: InputMaybe<Int_Comparison_Exp>;
  system_return_total?: InputMaybe<Int_Comparison_Exp>;
  system_sale_count?: InputMaybe<Int_Comparison_Exp>;
  system_sale_total?: InputMaybe<Int_Comparison_Exp>;
  system_settled_count?: InputMaybe<Int_Comparison_Exp>;
  system_settled_total?: InputMaybe<Int_Comparison_Exp>;
  system_transfer_count?: InputMaybe<Int_Comparison_Exp>;
  system_transfer_total?: InputMaybe<Int_Comparison_Exp>;
  system_voided_count?: InputMaybe<Int_Comparison_Exp>;
  system_voided_total?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "r_payment_batches" */
export enum R_Payment_Batches_Constraint {
  /** unique or primary key constraint on columns "payment_batch_id" */
  RPaymentBatchesPaymentBatchIdUnique = 'r_payment_batches_payment_batch_id_unique',
  /** unique or primary key constraint on columns "id" */
  RPaymentBatchesPkey = 'r_payment_batches_pkey'
}

/** input type for incrementing numeric columns in table "r_payment_batches" */
export type R_Payment_Batches_Inc_Input = {
  batch_net_count?: InputMaybe<Scalars['Int']['input']>;
  batch_net_total?: InputMaybe<Scalars['Int']['input']>;
  batch_return_count?: InputMaybe<Scalars['Int']['input']>;
  batch_return_total?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_count?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_total?: InputMaybe<Scalars['Int']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  resource_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_total?: InputMaybe<Scalars['Int']['input']>;
  system_approved_count?: InputMaybe<Scalars['Int']['input']>;
  system_approved_total?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_count?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_total?: InputMaybe<Scalars['Int']['input']>;
  system_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_total?: InputMaybe<Scalars['Int']['input']>;
  system_failed_count?: InputMaybe<Scalars['Int']['input']>;
  system_failed_total?: InputMaybe<Scalars['Int']['input']>;
  system_net_count?: InputMaybe<Scalars['Int']['input']>;
  system_net_total?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_count?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_total?: InputMaybe<Scalars['Int']['input']>;
  system_return_count?: InputMaybe<Scalars['Int']['input']>;
  system_return_total?: InputMaybe<Scalars['Int']['input']>;
  system_sale_count?: InputMaybe<Scalars['Int']['input']>;
  system_sale_total?: InputMaybe<Scalars['Int']['input']>;
  system_settled_count?: InputMaybe<Scalars['Int']['input']>;
  system_settled_total?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_count?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_total?: InputMaybe<Scalars['Int']['input']>;
  system_voided_count?: InputMaybe<Scalars['Int']['input']>;
  system_voided_total?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "r_payment_batches" */
export type R_Payment_Batches_Insert_Input = {
  batchSet?: InputMaybe<Batch_Sets_Obj_Rel_Insert_Input>;
  batch_net_count?: InputMaybe<Scalars['Int']['input']>;
  batch_net_total?: InputMaybe<Scalars['Int']['input']>;
  batch_return_count?: InputMaybe<Scalars['Int']['input']>;
  batch_return_total?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_count?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_total?: InputMaybe<Scalars['Int']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  estimated_bank_settle_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mxMerchantPaymentBatchMeta?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Obj_Rel_Insert_Input>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment_batch?: InputMaybe<Payment_Batches_Obj_Rel_Insert_Input>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  resource_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  system_approved_count?: InputMaybe<Scalars['Int']['input']>;
  system_approved_total?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_count?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_total?: InputMaybe<Scalars['Int']['input']>;
  system_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_total?: InputMaybe<Scalars['Int']['input']>;
  system_failed_count?: InputMaybe<Scalars['Int']['input']>;
  system_failed_total?: InputMaybe<Scalars['Int']['input']>;
  system_net_count?: InputMaybe<Scalars['Int']['input']>;
  system_net_total?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_count?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_total?: InputMaybe<Scalars['Int']['input']>;
  system_return_count?: InputMaybe<Scalars['Int']['input']>;
  system_return_total?: InputMaybe<Scalars['Int']['input']>;
  system_sale_count?: InputMaybe<Scalars['Int']['input']>;
  system_sale_total?: InputMaybe<Scalars['Int']['input']>;
  system_settled_count?: InputMaybe<Scalars['Int']['input']>;
  system_settled_total?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_count?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_total?: InputMaybe<Scalars['Int']['input']>;
  system_voided_count?: InputMaybe<Scalars['Int']['input']>;
  system_voided_total?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type R_Payment_Batches_Max_Fields = {
  __typename?: 'r_payment_batches_max_fields';
  batch_net_count?: Maybe<Scalars['Int']['output']>;
  batch_net_total?: Maybe<Scalars['Int']['output']>;
  batch_return_count?: Maybe<Scalars['Int']['output']>;
  batch_return_total?: Maybe<Scalars['Int']['output']>;
  batch_sale_count?: Maybe<Scalars['Int']['output']>;
  batch_sale_total?: Maybe<Scalars['Int']['output']>;
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  estimated_bank_settle_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  resource_net_count?: Maybe<Scalars['Int']['output']>;
  resource_net_total?: Maybe<Scalars['Int']['output']>;
  resource_return_count?: Maybe<Scalars['Int']['output']>;
  resource_return_total?: Maybe<Scalars['Int']['output']>;
  resource_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_sale_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  system_approved_count?: Maybe<Scalars['Int']['output']>;
  system_approved_total?: Maybe<Scalars['Int']['output']>;
  system_charged_back_count?: Maybe<Scalars['Int']['output']>;
  system_charged_back_total?: Maybe<Scalars['Int']['output']>;
  system_count?: Maybe<Scalars['Int']['output']>;
  system_declined_count?: Maybe<Scalars['Int']['output']>;
  system_declined_total?: Maybe<Scalars['Int']['output']>;
  system_failed_count?: Maybe<Scalars['Int']['output']>;
  system_failed_total?: Maybe<Scalars['Int']['output']>;
  system_net_count?: Maybe<Scalars['Int']['output']>;
  system_net_total?: Maybe<Scalars['Int']['output']>;
  system_prefund_count?: Maybe<Scalars['Int']['output']>;
  system_prefund_total?: Maybe<Scalars['Int']['output']>;
  system_return_count?: Maybe<Scalars['Int']['output']>;
  system_return_total?: Maybe<Scalars['Int']['output']>;
  system_sale_count?: Maybe<Scalars['Int']['output']>;
  system_sale_total?: Maybe<Scalars['Int']['output']>;
  system_settled_count?: Maybe<Scalars['Int']['output']>;
  system_settled_total?: Maybe<Scalars['Int']['output']>;
  system_transfer_count?: Maybe<Scalars['Int']['output']>;
  system_transfer_total?: Maybe<Scalars['Int']['output']>;
  system_voided_count?: Maybe<Scalars['Int']['output']>;
  system_voided_total?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type R_Payment_Batches_Min_Fields = {
  __typename?: 'r_payment_batches_min_fields';
  batch_net_count?: Maybe<Scalars['Int']['output']>;
  batch_net_total?: Maybe<Scalars['Int']['output']>;
  batch_return_count?: Maybe<Scalars['Int']['output']>;
  batch_return_total?: Maybe<Scalars['Int']['output']>;
  batch_sale_count?: Maybe<Scalars['Int']['output']>;
  batch_sale_total?: Maybe<Scalars['Int']['output']>;
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  estimated_bank_settle_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  resource_net_count?: Maybe<Scalars['Int']['output']>;
  resource_net_total?: Maybe<Scalars['Int']['output']>;
  resource_return_count?: Maybe<Scalars['Int']['output']>;
  resource_return_total?: Maybe<Scalars['Int']['output']>;
  resource_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_sale_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  system_approved_count?: Maybe<Scalars['Int']['output']>;
  system_approved_total?: Maybe<Scalars['Int']['output']>;
  system_charged_back_count?: Maybe<Scalars['Int']['output']>;
  system_charged_back_total?: Maybe<Scalars['Int']['output']>;
  system_count?: Maybe<Scalars['Int']['output']>;
  system_declined_count?: Maybe<Scalars['Int']['output']>;
  system_declined_total?: Maybe<Scalars['Int']['output']>;
  system_failed_count?: Maybe<Scalars['Int']['output']>;
  system_failed_total?: Maybe<Scalars['Int']['output']>;
  system_net_count?: Maybe<Scalars['Int']['output']>;
  system_net_total?: Maybe<Scalars['Int']['output']>;
  system_prefund_count?: Maybe<Scalars['Int']['output']>;
  system_prefund_total?: Maybe<Scalars['Int']['output']>;
  system_return_count?: Maybe<Scalars['Int']['output']>;
  system_return_total?: Maybe<Scalars['Int']['output']>;
  system_sale_count?: Maybe<Scalars['Int']['output']>;
  system_sale_total?: Maybe<Scalars['Int']['output']>;
  system_settled_count?: Maybe<Scalars['Int']['output']>;
  system_settled_total?: Maybe<Scalars['Int']['output']>;
  system_transfer_count?: Maybe<Scalars['Int']['output']>;
  system_transfer_total?: Maybe<Scalars['Int']['output']>;
  system_voided_count?: Maybe<Scalars['Int']['output']>;
  system_voided_total?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "r_payment_batches" */
export type R_Payment_Batches_Mutation_Response = {
  __typename?: 'r_payment_batches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<R_Payment_Batches>;
};

/** input type for inserting object relation for remote table "r_payment_batches" */
export type R_Payment_Batches_Obj_Rel_Insert_Input = {
  data: R_Payment_Batches_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<R_Payment_Batches_On_Conflict>;
};

/** on_conflict condition type for table "r_payment_batches" */
export type R_Payment_Batches_On_Conflict = {
  constraint: R_Payment_Batches_Constraint;
  update_columns?: Array<R_Payment_Batches_Update_Column>;
  where?: InputMaybe<R_Payment_Batches_Bool_Exp>;
};

/** Ordering options when selecting data from "r_payment_batches". */
export type R_Payment_Batches_Order_By = {
  batchSet?: InputMaybe<Batch_Sets_Order_By>;
  batch_net_count?: InputMaybe<Order_By>;
  batch_net_total?: InputMaybe<Order_By>;
  batch_return_count?: InputMaybe<Order_By>;
  batch_return_total?: InputMaybe<Order_By>;
  batch_sale_count?: InputMaybe<Order_By>;
  batch_sale_total?: InputMaybe<Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  calculated_at?: InputMaybe<Order_By>;
  calculating_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  estimated_bank_settle_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mxMerchantPaymentBatchMeta?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Order_By>;
  original_created_at?: InputMaybe<Order_By>;
  original_updated_at?: InputMaybe<Order_By>;
  payment_batch?: InputMaybe<Payment_Batches_Order_By>;
  payment_batch_id?: InputMaybe<Order_By>;
  resource_net_count?: InputMaybe<Order_By>;
  resource_net_total?: InputMaybe<Order_By>;
  resource_return_count?: InputMaybe<Order_By>;
  resource_return_total?: InputMaybe<Order_By>;
  resource_sale_count?: InputMaybe<Order_By>;
  resource_sale_total?: InputMaybe<Order_By>;
  resource_unmatched_net_count?: InputMaybe<Order_By>;
  resource_unmatched_net_total?: InputMaybe<Order_By>;
  resource_unmatched_return_count?: InputMaybe<Order_By>;
  resource_unmatched_return_total?: InputMaybe<Order_By>;
  resource_unmatched_sale_count?: InputMaybe<Order_By>;
  resource_unmatched_sale_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  system_approved_count?: InputMaybe<Order_By>;
  system_approved_total?: InputMaybe<Order_By>;
  system_charged_back_count?: InputMaybe<Order_By>;
  system_charged_back_total?: InputMaybe<Order_By>;
  system_count?: InputMaybe<Order_By>;
  system_declined_count?: InputMaybe<Order_By>;
  system_declined_total?: InputMaybe<Order_By>;
  system_failed_count?: InputMaybe<Order_By>;
  system_failed_total?: InputMaybe<Order_By>;
  system_net_count?: InputMaybe<Order_By>;
  system_net_total?: InputMaybe<Order_By>;
  system_prefund_count?: InputMaybe<Order_By>;
  system_prefund_total?: InputMaybe<Order_By>;
  system_return_count?: InputMaybe<Order_By>;
  system_return_total?: InputMaybe<Order_By>;
  system_sale_count?: InputMaybe<Order_By>;
  system_sale_total?: InputMaybe<Order_By>;
  system_settled_count?: InputMaybe<Order_By>;
  system_settled_total?: InputMaybe<Order_By>;
  system_transfer_count?: InputMaybe<Order_By>;
  system_transfer_total?: InputMaybe<Order_By>;
  system_voided_count?: InputMaybe<Order_By>;
  system_voided_total?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: r_payment_batches */
export type R_Payment_Batches_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "r_payment_batches" */
export enum R_Payment_Batches_Select_Column {
  /** column name */
  BatchNetCount = 'batch_net_count',
  /** column name */
  BatchNetTotal = 'batch_net_total',
  /** column name */
  BatchReturnCount = 'batch_return_count',
  /** column name */
  BatchReturnTotal = 'batch_return_total',
  /** column name */
  BatchSaleCount = 'batch_sale_count',
  /** column name */
  BatchSaleTotal = 'batch_sale_total',
  /** column name */
  BatchSetId = 'batch_set_id',
  /** column name */
  CalculatedAt = 'calculated_at',
  /** column name */
  CalculatingAt = 'calculating_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstimatedBankSettleAt = 'estimated_bank_settle_at',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalCreatedAt = 'original_created_at',
  /** column name */
  OriginalUpdatedAt = 'original_updated_at',
  /** column name */
  PaymentBatchId = 'payment_batch_id',
  /** column name */
  ResourceNetCount = 'resource_net_count',
  /** column name */
  ResourceNetTotal = 'resource_net_total',
  /** column name */
  ResourceReturnCount = 'resource_return_count',
  /** column name */
  ResourceReturnTotal = 'resource_return_total',
  /** column name */
  ResourceSaleCount = 'resource_sale_count',
  /** column name */
  ResourceSaleTotal = 'resource_sale_total',
  /** column name */
  ResourceUnmatchedNetCount = 'resource_unmatched_net_count',
  /** column name */
  ResourceUnmatchedNetTotal = 'resource_unmatched_net_total',
  /** column name */
  ResourceUnmatchedReturnCount = 'resource_unmatched_return_count',
  /** column name */
  ResourceUnmatchedReturnTotal = 'resource_unmatched_return_total',
  /** column name */
  ResourceUnmatchedSaleCount = 'resource_unmatched_sale_count',
  /** column name */
  ResourceUnmatchedSaleTotal = 'resource_unmatched_sale_total',
  /** column name */
  Status = 'status',
  /** column name */
  SystemApprovedCount = 'system_approved_count',
  /** column name */
  SystemApprovedTotal = 'system_approved_total',
  /** column name */
  SystemChargedBackCount = 'system_charged_back_count',
  /** column name */
  SystemChargedBackTotal = 'system_charged_back_total',
  /** column name */
  SystemCount = 'system_count',
  /** column name */
  SystemDeclinedCount = 'system_declined_count',
  /** column name */
  SystemDeclinedTotal = 'system_declined_total',
  /** column name */
  SystemFailedCount = 'system_failed_count',
  /** column name */
  SystemFailedTotal = 'system_failed_total',
  /** column name */
  SystemNetCount = 'system_net_count',
  /** column name */
  SystemNetTotal = 'system_net_total',
  /** column name */
  SystemPrefundCount = 'system_prefund_count',
  /** column name */
  SystemPrefundTotal = 'system_prefund_total',
  /** column name */
  SystemReturnCount = 'system_return_count',
  /** column name */
  SystemReturnTotal = 'system_return_total',
  /** column name */
  SystemSaleCount = 'system_sale_count',
  /** column name */
  SystemSaleTotal = 'system_sale_total',
  /** column name */
  SystemSettledCount = 'system_settled_count',
  /** column name */
  SystemSettledTotal = 'system_settled_total',
  /** column name */
  SystemTransferCount = 'system_transfer_count',
  /** column name */
  SystemTransferTotal = 'system_transfer_total',
  /** column name */
  SystemVoidedCount = 'system_voided_count',
  /** column name */
  SystemVoidedTotal = 'system_voided_total',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "r_payment_batches" */
export type R_Payment_Batches_Set_Input = {
  batch_net_count?: InputMaybe<Scalars['Int']['input']>;
  batch_net_total?: InputMaybe<Scalars['Int']['input']>;
  batch_return_count?: InputMaybe<Scalars['Int']['input']>;
  batch_return_total?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_count?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_total?: InputMaybe<Scalars['Int']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  estimated_bank_settle_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  resource_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  system_approved_count?: InputMaybe<Scalars['Int']['input']>;
  system_approved_total?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_count?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_total?: InputMaybe<Scalars['Int']['input']>;
  system_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_total?: InputMaybe<Scalars['Int']['input']>;
  system_failed_count?: InputMaybe<Scalars['Int']['input']>;
  system_failed_total?: InputMaybe<Scalars['Int']['input']>;
  system_net_count?: InputMaybe<Scalars['Int']['input']>;
  system_net_total?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_count?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_total?: InputMaybe<Scalars['Int']['input']>;
  system_return_count?: InputMaybe<Scalars['Int']['input']>;
  system_return_total?: InputMaybe<Scalars['Int']['input']>;
  system_sale_count?: InputMaybe<Scalars['Int']['input']>;
  system_sale_total?: InputMaybe<Scalars['Int']['input']>;
  system_settled_count?: InputMaybe<Scalars['Int']['input']>;
  system_settled_total?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_count?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_total?: InputMaybe<Scalars['Int']['input']>;
  system_voided_count?: InputMaybe<Scalars['Int']['input']>;
  system_voided_total?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type R_Payment_Batches_Stddev_Fields = {
  __typename?: 'r_payment_batches_stddev_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type R_Payment_Batches_Stddev_Pop_Fields = {
  __typename?: 'r_payment_batches_stddev_pop_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type R_Payment_Batches_Stddev_Samp_Fields = {
  __typename?: 'r_payment_batches_stddev_samp_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "r_payment_batches" */
export type R_Payment_Batches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: R_Payment_Batches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type R_Payment_Batches_Stream_Cursor_Value_Input = {
  batch_net_count?: InputMaybe<Scalars['Int']['input']>;
  batch_net_total?: InputMaybe<Scalars['Int']['input']>;
  batch_return_count?: InputMaybe<Scalars['Int']['input']>;
  batch_return_total?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_count?: InputMaybe<Scalars['Int']['input']>;
  batch_sale_total?: InputMaybe<Scalars['Int']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  estimated_bank_settle_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  payment_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  resource_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_sale_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_net_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_return_total?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_count?: InputMaybe<Scalars['Int']['input']>;
  resource_unmatched_sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  system_approved_count?: InputMaybe<Scalars['Int']['input']>;
  system_approved_total?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_count?: InputMaybe<Scalars['Int']['input']>;
  system_charged_back_total?: InputMaybe<Scalars['Int']['input']>;
  system_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_count?: InputMaybe<Scalars['Int']['input']>;
  system_declined_total?: InputMaybe<Scalars['Int']['input']>;
  system_failed_count?: InputMaybe<Scalars['Int']['input']>;
  system_failed_total?: InputMaybe<Scalars['Int']['input']>;
  system_net_count?: InputMaybe<Scalars['Int']['input']>;
  system_net_total?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_count?: InputMaybe<Scalars['Int']['input']>;
  system_prefund_total?: InputMaybe<Scalars['Int']['input']>;
  system_return_count?: InputMaybe<Scalars['Int']['input']>;
  system_return_total?: InputMaybe<Scalars['Int']['input']>;
  system_sale_count?: InputMaybe<Scalars['Int']['input']>;
  system_sale_total?: InputMaybe<Scalars['Int']['input']>;
  system_settled_count?: InputMaybe<Scalars['Int']['input']>;
  system_settled_total?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_count?: InputMaybe<Scalars['Int']['input']>;
  system_transfer_total?: InputMaybe<Scalars['Int']['input']>;
  system_voided_count?: InputMaybe<Scalars['Int']['input']>;
  system_voided_total?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type R_Payment_Batches_Sum_Fields = {
  __typename?: 'r_payment_batches_sum_fields';
  batch_net_count?: Maybe<Scalars['Int']['output']>;
  batch_net_total?: Maybe<Scalars['Int']['output']>;
  batch_return_count?: Maybe<Scalars['Int']['output']>;
  batch_return_total?: Maybe<Scalars['Int']['output']>;
  batch_sale_count?: Maybe<Scalars['Int']['output']>;
  batch_sale_total?: Maybe<Scalars['Int']['output']>;
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  payment_batch_id?: Maybe<Scalars['bigint']['output']>;
  resource_net_count?: Maybe<Scalars['Int']['output']>;
  resource_net_total?: Maybe<Scalars['Int']['output']>;
  resource_return_count?: Maybe<Scalars['Int']['output']>;
  resource_return_total?: Maybe<Scalars['Int']['output']>;
  resource_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_sale_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Int']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Int']['output']>;
  system_approved_count?: Maybe<Scalars['Int']['output']>;
  system_approved_total?: Maybe<Scalars['Int']['output']>;
  system_charged_back_count?: Maybe<Scalars['Int']['output']>;
  system_charged_back_total?: Maybe<Scalars['Int']['output']>;
  system_count?: Maybe<Scalars['Int']['output']>;
  system_declined_count?: Maybe<Scalars['Int']['output']>;
  system_declined_total?: Maybe<Scalars['Int']['output']>;
  system_failed_count?: Maybe<Scalars['Int']['output']>;
  system_failed_total?: Maybe<Scalars['Int']['output']>;
  system_net_count?: Maybe<Scalars['Int']['output']>;
  system_net_total?: Maybe<Scalars['Int']['output']>;
  system_prefund_count?: Maybe<Scalars['Int']['output']>;
  system_prefund_total?: Maybe<Scalars['Int']['output']>;
  system_return_count?: Maybe<Scalars['Int']['output']>;
  system_return_total?: Maybe<Scalars['Int']['output']>;
  system_sale_count?: Maybe<Scalars['Int']['output']>;
  system_sale_total?: Maybe<Scalars['Int']['output']>;
  system_settled_count?: Maybe<Scalars['Int']['output']>;
  system_settled_total?: Maybe<Scalars['Int']['output']>;
  system_transfer_count?: Maybe<Scalars['Int']['output']>;
  system_transfer_total?: Maybe<Scalars['Int']['output']>;
  system_voided_count?: Maybe<Scalars['Int']['output']>;
  system_voided_total?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "r_payment_batches" */
export enum R_Payment_Batches_Update_Column {
  /** column name */
  BatchNetCount = 'batch_net_count',
  /** column name */
  BatchNetTotal = 'batch_net_total',
  /** column name */
  BatchReturnCount = 'batch_return_count',
  /** column name */
  BatchReturnTotal = 'batch_return_total',
  /** column name */
  BatchSaleCount = 'batch_sale_count',
  /** column name */
  BatchSaleTotal = 'batch_sale_total',
  /** column name */
  BatchSetId = 'batch_set_id',
  /** column name */
  CalculatedAt = 'calculated_at',
  /** column name */
  CalculatingAt = 'calculating_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstimatedBankSettleAt = 'estimated_bank_settle_at',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalCreatedAt = 'original_created_at',
  /** column name */
  OriginalUpdatedAt = 'original_updated_at',
  /** column name */
  PaymentBatchId = 'payment_batch_id',
  /** column name */
  ResourceNetCount = 'resource_net_count',
  /** column name */
  ResourceNetTotal = 'resource_net_total',
  /** column name */
  ResourceReturnCount = 'resource_return_count',
  /** column name */
  ResourceReturnTotal = 'resource_return_total',
  /** column name */
  ResourceSaleCount = 'resource_sale_count',
  /** column name */
  ResourceSaleTotal = 'resource_sale_total',
  /** column name */
  ResourceUnmatchedNetCount = 'resource_unmatched_net_count',
  /** column name */
  ResourceUnmatchedNetTotal = 'resource_unmatched_net_total',
  /** column name */
  ResourceUnmatchedReturnCount = 'resource_unmatched_return_count',
  /** column name */
  ResourceUnmatchedReturnTotal = 'resource_unmatched_return_total',
  /** column name */
  ResourceUnmatchedSaleCount = 'resource_unmatched_sale_count',
  /** column name */
  ResourceUnmatchedSaleTotal = 'resource_unmatched_sale_total',
  /** column name */
  Status = 'status',
  /** column name */
  SystemApprovedCount = 'system_approved_count',
  /** column name */
  SystemApprovedTotal = 'system_approved_total',
  /** column name */
  SystemChargedBackCount = 'system_charged_back_count',
  /** column name */
  SystemChargedBackTotal = 'system_charged_back_total',
  /** column name */
  SystemCount = 'system_count',
  /** column name */
  SystemDeclinedCount = 'system_declined_count',
  /** column name */
  SystemDeclinedTotal = 'system_declined_total',
  /** column name */
  SystemFailedCount = 'system_failed_count',
  /** column name */
  SystemFailedTotal = 'system_failed_total',
  /** column name */
  SystemNetCount = 'system_net_count',
  /** column name */
  SystemNetTotal = 'system_net_total',
  /** column name */
  SystemPrefundCount = 'system_prefund_count',
  /** column name */
  SystemPrefundTotal = 'system_prefund_total',
  /** column name */
  SystemReturnCount = 'system_return_count',
  /** column name */
  SystemReturnTotal = 'system_return_total',
  /** column name */
  SystemSaleCount = 'system_sale_count',
  /** column name */
  SystemSaleTotal = 'system_sale_total',
  /** column name */
  SystemSettledCount = 'system_settled_count',
  /** column name */
  SystemSettledTotal = 'system_settled_total',
  /** column name */
  SystemTransferCount = 'system_transfer_count',
  /** column name */
  SystemTransferTotal = 'system_transfer_total',
  /** column name */
  SystemVoidedCount = 'system_voided_count',
  /** column name */
  SystemVoidedTotal = 'system_voided_total',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type R_Payment_Batches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<R_Payment_Batches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<R_Payment_Batches_Set_Input>;
  /** filter the rows which have to be updated */
  where: R_Payment_Batches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type R_Payment_Batches_Var_Pop_Fields = {
  __typename?: 'r_payment_batches_var_pop_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type R_Payment_Batches_Var_Samp_Fields = {
  __typename?: 'r_payment_batches_var_samp_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type R_Payment_Batches_Variance_Fields = {
  __typename?: 'r_payment_batches_variance_fields';
  batch_net_count?: Maybe<Scalars['Float']['output']>;
  batch_net_total?: Maybe<Scalars['Float']['output']>;
  batch_return_count?: Maybe<Scalars['Float']['output']>;
  batch_return_total?: Maybe<Scalars['Float']['output']>;
  batch_sale_count?: Maybe<Scalars['Float']['output']>;
  batch_sale_total?: Maybe<Scalars['Float']['output']>;
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  payment_batch_id?: Maybe<Scalars['Float']['output']>;
  resource_net_count?: Maybe<Scalars['Float']['output']>;
  resource_net_total?: Maybe<Scalars['Float']['output']>;
  resource_return_count?: Maybe<Scalars['Float']['output']>;
  resource_return_total?: Maybe<Scalars['Float']['output']>;
  resource_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_sale_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_net_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_return_total?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_count?: Maybe<Scalars['Float']['output']>;
  resource_unmatched_sale_total?: Maybe<Scalars['Float']['output']>;
  system_approved_count?: Maybe<Scalars['Float']['output']>;
  system_approved_total?: Maybe<Scalars['Float']['output']>;
  system_charged_back_count?: Maybe<Scalars['Float']['output']>;
  system_charged_back_total?: Maybe<Scalars['Float']['output']>;
  system_count?: Maybe<Scalars['Float']['output']>;
  system_declined_count?: Maybe<Scalars['Float']['output']>;
  system_declined_total?: Maybe<Scalars['Float']['output']>;
  system_failed_count?: Maybe<Scalars['Float']['output']>;
  system_failed_total?: Maybe<Scalars['Float']['output']>;
  system_net_count?: Maybe<Scalars['Float']['output']>;
  system_net_total?: Maybe<Scalars['Float']['output']>;
  system_prefund_count?: Maybe<Scalars['Float']['output']>;
  system_prefund_total?: Maybe<Scalars['Float']['output']>;
  system_return_count?: Maybe<Scalars['Float']['output']>;
  system_return_total?: Maybe<Scalars['Float']['output']>;
  system_sale_count?: Maybe<Scalars['Float']['output']>;
  system_sale_total?: Maybe<Scalars['Float']['output']>;
  system_settled_count?: Maybe<Scalars['Float']['output']>;
  system_settled_total?: Maybe<Scalars['Float']['output']>;
  system_transfer_count?: Maybe<Scalars['Float']['output']>;
  system_transfer_total?: Maybe<Scalars['Float']['output']>;
  system_voided_count?: Maybe<Scalars['Float']['output']>;
  system_voided_total?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "r_transfer_batches" */
export type R_Transfer_Batches = {
  __typename?: 'r_transfer_batches';
  approved_for_transfer?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  batchSet?: Maybe<Batch_Sets>;
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  card_net_count?: Maybe<Scalars['Int']['output']>;
  card_net_total?: Maybe<Scalars['Int']['output']>;
  card_return_count?: Maybe<Scalars['Int']['output']>;
  card_return_total?: Maybe<Scalars['Int']['output']>;
  card_sale_count?: Maybe<Scalars['Int']['output']>;
  card_sale_total?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  estimated_bank_settle_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  last_successful_payment__meta_id?: Maybe<Scalars['bigint']['output']>;
  last_successful_payment_id?: Maybe<Scalars['bigint']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  net_count?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  original_created_at: Scalars['timestamp']['output'];
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  parkingAuthority?: Maybe<Parking_Authorities>;
  parking_authority_id: Scalars['bigint']['output'];
  payment_batches_datetime_range_end?: Maybe<Scalars['timestamp']['output']>;
  payment_batches_datetime_range_start?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  rParkingAuthority?: Maybe<R_Parking_Authorities>;
  return_count?: Maybe<Scalars['Int']['output']>;
  return_total?: Maybe<Scalars['Int']['output']>;
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_total?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  transfer_batch?: Maybe<Transfer_Batches>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  transferred_at?: Maybe<Scalars['timestamp']['output']>;
  transferring_at?: Maybe<Scalars['timestamp']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  voided_at?: Maybe<Scalars['timestamp']['output']>;
  waiting_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_net_count?: Maybe<Scalars['Int']['output']>;
  wallet_net_total?: Maybe<Scalars['Int']['output']>;
  wallet_return_count?: Maybe<Scalars['Int']['output']>;
  wallet_return_total?: Maybe<Scalars['Int']['output']>;
  wallet_sale_count?: Maybe<Scalars['Int']['output']>;
  wallet_sale_total?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "r_transfer_batches" */
export type R_Transfer_Batches_Aggregate = {
  __typename?: 'r_transfer_batches_aggregate';
  aggregate?: Maybe<R_Transfer_Batches_Aggregate_Fields>;
  nodes: Array<R_Transfer_Batches>;
};

/** aggregate fields of "r_transfer_batches" */
export type R_Transfer_Batches_Aggregate_Fields = {
  __typename?: 'r_transfer_batches_aggregate_fields';
  avg?: Maybe<R_Transfer_Batches_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<R_Transfer_Batches_Max_Fields>;
  min?: Maybe<R_Transfer_Batches_Min_Fields>;
  stddev?: Maybe<R_Transfer_Batches_Stddev_Fields>;
  stddev_pop?: Maybe<R_Transfer_Batches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<R_Transfer_Batches_Stddev_Samp_Fields>;
  sum?: Maybe<R_Transfer_Batches_Sum_Fields>;
  var_pop?: Maybe<R_Transfer_Batches_Var_Pop_Fields>;
  var_samp?: Maybe<R_Transfer_Batches_Var_Samp_Fields>;
  variance?: Maybe<R_Transfer_Batches_Variance_Fields>;
};


/** aggregate fields of "r_transfer_batches" */
export type R_Transfer_Batches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<R_Transfer_Batches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type R_Transfer_Batches_Avg_Fields = {
  __typename?: 'r_transfer_batches_avg_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment__meta_id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "r_transfer_batches". All fields are combined with a logical 'AND'. */
export type R_Transfer_Batches_Bool_Exp = {
  _and?: InputMaybe<Array<R_Transfer_Batches_Bool_Exp>>;
  _not?: InputMaybe<R_Transfer_Batches_Bool_Exp>;
  _or?: InputMaybe<Array<R_Transfer_Batches_Bool_Exp>>;
  approved_for_transfer?: InputMaybe<Boolean_Comparison_Exp>;
  batchSet?: InputMaybe<Batch_Sets_Bool_Exp>;
  batch_set_id?: InputMaybe<Bigint_Comparison_Exp>;
  calculated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  calculating_at?: InputMaybe<Timestamp_Comparison_Exp>;
  card_net_count?: InputMaybe<Int_Comparison_Exp>;
  card_net_total?: InputMaybe<Int_Comparison_Exp>;
  card_return_count?: InputMaybe<Int_Comparison_Exp>;
  card_return_total?: InputMaybe<Int_Comparison_Exp>;
  card_sale_count?: InputMaybe<Int_Comparison_Exp>;
  card_sale_total?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  estimated_bank_settle_at?: InputMaybe<Timestamp_Comparison_Exp>;
  failed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_successful_payment__meta_id?: InputMaybe<Bigint_Comparison_Exp>;
  last_successful_payment_id?: InputMaybe<Bigint_Comparison_Exp>;
  legacy_transfer_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  net_count?: InputMaybe<Int_Comparison_Exp>;
  net_total?: InputMaybe<Int_Comparison_Exp>;
  original_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  original_updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  parkingAuthority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_batches_datetime_range_end?: InputMaybe<Timestamp_Comparison_Exp>;
  payment_batches_datetime_range_start?: InputMaybe<Timestamp_Comparison_Exp>;
  rParkingAuthority?: InputMaybe<R_Parking_Authorities_Bool_Exp>;
  return_count?: InputMaybe<Int_Comparison_Exp>;
  return_total?: InputMaybe<Int_Comparison_Exp>;
  sale_count?: InputMaybe<Int_Comparison_Exp>;
  sale_total?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  total_paid?: InputMaybe<Int_Comparison_Exp>;
  total_unpaid?: InputMaybe<Int_Comparison_Exp>;
  transfer_batch?: InputMaybe<Transfer_Batches_Bool_Exp>;
  transfer_batch_id?: InputMaybe<Bigint_Comparison_Exp>;
  transferred_at?: InputMaybe<Timestamp_Comparison_Exp>;
  transferring_at?: InputMaybe<Timestamp_Comparison_Exp>;
  try?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  voided_at?: InputMaybe<Timestamp_Comparison_Exp>;
  waiting_at?: InputMaybe<Timestamp_Comparison_Exp>;
  wallet_net_count?: InputMaybe<Int_Comparison_Exp>;
  wallet_net_total?: InputMaybe<Int_Comparison_Exp>;
  wallet_return_count?: InputMaybe<Int_Comparison_Exp>;
  wallet_return_total?: InputMaybe<Int_Comparison_Exp>;
  wallet_sale_count?: InputMaybe<Int_Comparison_Exp>;
  wallet_sale_total?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "r_transfer_batches" */
export enum R_Transfer_Batches_Constraint {
  /** unique or primary key constraint on columns "legacy_transfer_batch_id" */
  RTransferBatchesLegacyTransferBatchIdUnique = 'r_transfer_batches_legacy_transfer_batch_id_unique',
  /** unique or primary key constraint on columns "id" */
  RTransferBatchesPkey = 'r_transfer_batches_pkey',
  /** unique or primary key constraint on columns "transfer_batch_id" */
  RTransferBatchesTransferBatchIdUnique = 'r_transfer_batches_transfer_batch_id_unique'
}

/** input type for incrementing numeric columns in table "r_transfer_batches" */
export type R_Transfer_Batches_Inc_Input = {
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  card_net_count?: InputMaybe<Scalars['Int']['input']>;
  card_net_total?: InputMaybe<Scalars['Int']['input']>;
  card_return_count?: InputMaybe<Scalars['Int']['input']>;
  card_return_total?: InputMaybe<Scalars['Int']['input']>;
  card_sale_count?: InputMaybe<Scalars['Int']['input']>;
  card_sale_total?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_successful_payment__meta_id?: InputMaybe<Scalars['bigint']['input']>;
  last_successful_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  net_count?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  return_count?: InputMaybe<Scalars['Int']['input']>;
  return_total?: InputMaybe<Scalars['Int']['input']>;
  sale_count?: InputMaybe<Scalars['Int']['input']>;
  sale_total?: InputMaybe<Scalars['Int']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  wallet_net_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_net_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_total?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "r_transfer_batches" */
export type R_Transfer_Batches_Insert_Input = {
  approved_for_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  batchSet?: InputMaybe<Batch_Sets_Obj_Rel_Insert_Input>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  card_net_count?: InputMaybe<Scalars['Int']['input']>;
  card_net_total?: InputMaybe<Scalars['Int']['input']>;
  card_return_count?: InputMaybe<Scalars['Int']['input']>;
  card_return_total?: InputMaybe<Scalars['Int']['input']>;
  card_sale_count?: InputMaybe<Scalars['Int']['input']>;
  card_sale_total?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  estimated_bank_settle_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_successful_payment__meta_id?: InputMaybe<Scalars['bigint']['input']>;
  last_successful_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  net_count?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  parkingAuthority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batches_datetime_range_end?: InputMaybe<Scalars['timestamp']['input']>;
  payment_batches_datetime_range_start?: InputMaybe<Scalars['timestamp']['input']>;
  rParkingAuthority?: InputMaybe<R_Parking_Authorities_Obj_Rel_Insert_Input>;
  return_count?: InputMaybe<Scalars['Int']['input']>;
  return_total?: InputMaybe<Scalars['Int']['input']>;
  sale_count?: InputMaybe<Scalars['Int']['input']>;
  sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transfer_batch?: InputMaybe<Transfer_Batches_Obj_Rel_Insert_Input>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  transferring_at?: InputMaybe<Scalars['timestamp']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  voided_at?: InputMaybe<Scalars['timestamp']['input']>;
  waiting_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_net_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_net_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_total?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type R_Transfer_Batches_Max_Fields = {
  __typename?: 'r_transfer_batches_max_fields';
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  card_net_count?: Maybe<Scalars['Int']['output']>;
  card_net_total?: Maybe<Scalars['Int']['output']>;
  card_return_count?: Maybe<Scalars['Int']['output']>;
  card_return_total?: Maybe<Scalars['Int']['output']>;
  card_sale_count?: Maybe<Scalars['Int']['output']>;
  card_sale_total?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  estimated_bank_settle_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_successful_payment__meta_id?: Maybe<Scalars['bigint']['output']>;
  last_successful_payment_id?: Maybe<Scalars['bigint']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  net_count?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  payment_batches_datetime_range_end?: Maybe<Scalars['timestamp']['output']>;
  payment_batches_datetime_range_start?: Maybe<Scalars['timestamp']['output']>;
  return_count?: Maybe<Scalars['Int']['output']>;
  return_total?: Maybe<Scalars['Int']['output']>;
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_total?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  transferred_at?: Maybe<Scalars['timestamp']['output']>;
  transferring_at?: Maybe<Scalars['timestamp']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  voided_at?: Maybe<Scalars['timestamp']['output']>;
  waiting_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_net_count?: Maybe<Scalars['Int']['output']>;
  wallet_net_total?: Maybe<Scalars['Int']['output']>;
  wallet_return_count?: Maybe<Scalars['Int']['output']>;
  wallet_return_total?: Maybe<Scalars['Int']['output']>;
  wallet_sale_count?: Maybe<Scalars['Int']['output']>;
  wallet_sale_total?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type R_Transfer_Batches_Min_Fields = {
  __typename?: 'r_transfer_batches_min_fields';
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  card_net_count?: Maybe<Scalars['Int']['output']>;
  card_net_total?: Maybe<Scalars['Int']['output']>;
  card_return_count?: Maybe<Scalars['Int']['output']>;
  card_return_total?: Maybe<Scalars['Int']['output']>;
  card_sale_count?: Maybe<Scalars['Int']['output']>;
  card_sale_total?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  estimated_bank_settle_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_successful_payment__meta_id?: Maybe<Scalars['bigint']['output']>;
  last_successful_payment_id?: Maybe<Scalars['bigint']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  net_count?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  payment_batches_datetime_range_end?: Maybe<Scalars['timestamp']['output']>;
  payment_batches_datetime_range_start?: Maybe<Scalars['timestamp']['output']>;
  return_count?: Maybe<Scalars['Int']['output']>;
  return_total?: Maybe<Scalars['Int']['output']>;
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_total?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  transferred_at?: Maybe<Scalars['timestamp']['output']>;
  transferring_at?: Maybe<Scalars['timestamp']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  voided_at?: Maybe<Scalars['timestamp']['output']>;
  waiting_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_net_count?: Maybe<Scalars['Int']['output']>;
  wallet_net_total?: Maybe<Scalars['Int']['output']>;
  wallet_return_count?: Maybe<Scalars['Int']['output']>;
  wallet_return_total?: Maybe<Scalars['Int']['output']>;
  wallet_sale_count?: Maybe<Scalars['Int']['output']>;
  wallet_sale_total?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "r_transfer_batches" */
export type R_Transfer_Batches_Mutation_Response = {
  __typename?: 'r_transfer_batches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<R_Transfer_Batches>;
};

/** input type for inserting object relation for remote table "r_transfer_batches" */
export type R_Transfer_Batches_Obj_Rel_Insert_Input = {
  data: R_Transfer_Batches_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<R_Transfer_Batches_On_Conflict>;
};

/** on_conflict condition type for table "r_transfer_batches" */
export type R_Transfer_Batches_On_Conflict = {
  constraint: R_Transfer_Batches_Constraint;
  update_columns?: Array<R_Transfer_Batches_Update_Column>;
  where?: InputMaybe<R_Transfer_Batches_Bool_Exp>;
};

/** Ordering options when selecting data from "r_transfer_batches". */
export type R_Transfer_Batches_Order_By = {
  approved_for_transfer?: InputMaybe<Order_By>;
  batchSet?: InputMaybe<Batch_Sets_Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  calculated_at?: InputMaybe<Order_By>;
  calculating_at?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  estimated_bank_settle_at?: InputMaybe<Order_By>;
  failed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_successful_payment__meta_id?: InputMaybe<Order_By>;
  last_successful_payment_id?: InputMaybe<Order_By>;
  legacy_transfer_batch_id?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  original_created_at?: InputMaybe<Order_By>;
  original_updated_at?: InputMaybe<Order_By>;
  parkingAuthority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  payment_batches_datetime_range_end?: InputMaybe<Order_By>;
  payment_batches_datetime_range_start?: InputMaybe<Order_By>;
  rParkingAuthority?: InputMaybe<R_Parking_Authorities_Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transfer_batch?: InputMaybe<Transfer_Batches_Order_By>;
  transfer_batch_id?: InputMaybe<Order_By>;
  transferred_at?: InputMaybe<Order_By>;
  transferring_at?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  voided_at?: InputMaybe<Order_By>;
  waiting_at?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** primary key columns input for table: r_transfer_batches */
export type R_Transfer_Batches_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "r_transfer_batches" */
export enum R_Transfer_Batches_Select_Column {
  /** column name */
  ApprovedForTransfer = 'approved_for_transfer',
  /** column name */
  BatchSetId = 'batch_set_id',
  /** column name */
  CalculatedAt = 'calculated_at',
  /** column name */
  CalculatingAt = 'calculating_at',
  /** column name */
  CardNetCount = 'card_net_count',
  /** column name */
  CardNetTotal = 'card_net_total',
  /** column name */
  CardReturnCount = 'card_return_count',
  /** column name */
  CardReturnTotal = 'card_return_total',
  /** column name */
  CardSaleCount = 'card_sale_count',
  /** column name */
  CardSaleTotal = 'card_sale_total',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstimatedBankSettleAt = 'estimated_bank_settle_at',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastSuccessfulPaymentMetaId = 'last_successful_payment__meta_id',
  /** column name */
  LastSuccessfulPaymentId = 'last_successful_payment_id',
  /** column name */
  LegacyTransferBatchId = 'legacy_transfer_batch_id',
  /** column name */
  NetCount = 'net_count',
  /** column name */
  NetTotal = 'net_total',
  /** column name */
  OriginalCreatedAt = 'original_created_at',
  /** column name */
  OriginalUpdatedAt = 'original_updated_at',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  PaymentBatchesDatetimeRangeEnd = 'payment_batches_datetime_range_end',
  /** column name */
  PaymentBatchesDatetimeRangeStart = 'payment_batches_datetime_range_start',
  /** column name */
  ReturnCount = 'return_count',
  /** column name */
  ReturnTotal = 'return_total',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleTotal = 'sale_total',
  /** column name */
  Status = 'status',
  /** column name */
  TotalPaid = 'total_paid',
  /** column name */
  TotalUnpaid = 'total_unpaid',
  /** column name */
  TransferBatchId = 'transfer_batch_id',
  /** column name */
  TransferredAt = 'transferred_at',
  /** column name */
  TransferringAt = 'transferring_at',
  /** column name */
  Try = 'try',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidedAt = 'voided_at',
  /** column name */
  WaitingAt = 'waiting_at',
  /** column name */
  WalletNetCount = 'wallet_net_count',
  /** column name */
  WalletNetTotal = 'wallet_net_total',
  /** column name */
  WalletReturnCount = 'wallet_return_count',
  /** column name */
  WalletReturnTotal = 'wallet_return_total',
  /** column name */
  WalletSaleCount = 'wallet_sale_count',
  /** column name */
  WalletSaleTotal = 'wallet_sale_total'
}

/** input type for updating data in table "r_transfer_batches" */
export type R_Transfer_Batches_Set_Input = {
  approved_for_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  card_net_count?: InputMaybe<Scalars['Int']['input']>;
  card_net_total?: InputMaybe<Scalars['Int']['input']>;
  card_return_count?: InputMaybe<Scalars['Int']['input']>;
  card_return_total?: InputMaybe<Scalars['Int']['input']>;
  card_sale_count?: InputMaybe<Scalars['Int']['input']>;
  card_sale_total?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  estimated_bank_settle_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_successful_payment__meta_id?: InputMaybe<Scalars['bigint']['input']>;
  last_successful_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  net_count?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batches_datetime_range_end?: InputMaybe<Scalars['timestamp']['input']>;
  payment_batches_datetime_range_start?: InputMaybe<Scalars['timestamp']['input']>;
  return_count?: InputMaybe<Scalars['Int']['input']>;
  return_total?: InputMaybe<Scalars['Int']['input']>;
  sale_count?: InputMaybe<Scalars['Int']['input']>;
  sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  transferring_at?: InputMaybe<Scalars['timestamp']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  voided_at?: InputMaybe<Scalars['timestamp']['input']>;
  waiting_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_net_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_net_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_total?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type R_Transfer_Batches_Stddev_Fields = {
  __typename?: 'r_transfer_batches_stddev_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment__meta_id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type R_Transfer_Batches_Stddev_Pop_Fields = {
  __typename?: 'r_transfer_batches_stddev_pop_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment__meta_id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type R_Transfer_Batches_Stddev_Samp_Fields = {
  __typename?: 'r_transfer_batches_stddev_samp_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment__meta_id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "r_transfer_batches" */
export type R_Transfer_Batches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: R_Transfer_Batches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type R_Transfer_Batches_Stream_Cursor_Value_Input = {
  approved_for_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  card_net_count?: InputMaybe<Scalars['Int']['input']>;
  card_net_total?: InputMaybe<Scalars['Int']['input']>;
  card_return_count?: InputMaybe<Scalars['Int']['input']>;
  card_return_total?: InputMaybe<Scalars['Int']['input']>;
  card_sale_count?: InputMaybe<Scalars['Int']['input']>;
  card_sale_total?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  estimated_bank_settle_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_successful_payment__meta_id?: InputMaybe<Scalars['bigint']['input']>;
  last_successful_payment_id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  net_count?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_batches_datetime_range_end?: InputMaybe<Scalars['timestamp']['input']>;
  payment_batches_datetime_range_start?: InputMaybe<Scalars['timestamp']['input']>;
  return_count?: InputMaybe<Scalars['Int']['input']>;
  return_total?: InputMaybe<Scalars['Int']['input']>;
  sale_count?: InputMaybe<Scalars['Int']['input']>;
  sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transfer_batch_id?: InputMaybe<Scalars['bigint']['input']>;
  transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  transferring_at?: InputMaybe<Scalars['timestamp']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  voided_at?: InputMaybe<Scalars['timestamp']['input']>;
  waiting_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_net_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_net_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_total?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type R_Transfer_Batches_Sum_Fields = {
  __typename?: 'r_transfer_batches_sum_fields';
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  card_net_count?: Maybe<Scalars['Int']['output']>;
  card_net_total?: Maybe<Scalars['Int']['output']>;
  card_return_count?: Maybe<Scalars['Int']['output']>;
  card_return_total?: Maybe<Scalars['Int']['output']>;
  card_sale_count?: Maybe<Scalars['Int']['output']>;
  card_sale_total?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_successful_payment__meta_id?: Maybe<Scalars['bigint']['output']>;
  last_successful_payment_id?: Maybe<Scalars['bigint']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  net_count?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  return_count?: Maybe<Scalars['Int']['output']>;
  return_total?: Maybe<Scalars['Int']['output']>;
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_total?: Maybe<Scalars['Int']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transfer_batch_id?: Maybe<Scalars['bigint']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  wallet_net_count?: Maybe<Scalars['Int']['output']>;
  wallet_net_total?: Maybe<Scalars['Int']['output']>;
  wallet_return_count?: Maybe<Scalars['Int']['output']>;
  wallet_return_total?: Maybe<Scalars['Int']['output']>;
  wallet_sale_count?: Maybe<Scalars['Int']['output']>;
  wallet_sale_total?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "r_transfer_batches" */
export enum R_Transfer_Batches_Update_Column {
  /** column name */
  ApprovedForTransfer = 'approved_for_transfer',
  /** column name */
  BatchSetId = 'batch_set_id',
  /** column name */
  CalculatedAt = 'calculated_at',
  /** column name */
  CalculatingAt = 'calculating_at',
  /** column name */
  CardNetCount = 'card_net_count',
  /** column name */
  CardNetTotal = 'card_net_total',
  /** column name */
  CardReturnCount = 'card_return_count',
  /** column name */
  CardReturnTotal = 'card_return_total',
  /** column name */
  CardSaleCount = 'card_sale_count',
  /** column name */
  CardSaleTotal = 'card_sale_total',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstimatedBankSettleAt = 'estimated_bank_settle_at',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastSuccessfulPaymentMetaId = 'last_successful_payment__meta_id',
  /** column name */
  LastSuccessfulPaymentId = 'last_successful_payment_id',
  /** column name */
  LegacyTransferBatchId = 'legacy_transfer_batch_id',
  /** column name */
  NetCount = 'net_count',
  /** column name */
  NetTotal = 'net_total',
  /** column name */
  OriginalCreatedAt = 'original_created_at',
  /** column name */
  OriginalUpdatedAt = 'original_updated_at',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  PaymentBatchesDatetimeRangeEnd = 'payment_batches_datetime_range_end',
  /** column name */
  PaymentBatchesDatetimeRangeStart = 'payment_batches_datetime_range_start',
  /** column name */
  ReturnCount = 'return_count',
  /** column name */
  ReturnTotal = 'return_total',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleTotal = 'sale_total',
  /** column name */
  Status = 'status',
  /** column name */
  TotalPaid = 'total_paid',
  /** column name */
  TotalUnpaid = 'total_unpaid',
  /** column name */
  TransferBatchId = 'transfer_batch_id',
  /** column name */
  TransferredAt = 'transferred_at',
  /** column name */
  TransferringAt = 'transferring_at',
  /** column name */
  Try = 'try',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidedAt = 'voided_at',
  /** column name */
  WaitingAt = 'waiting_at',
  /** column name */
  WalletNetCount = 'wallet_net_count',
  /** column name */
  WalletNetTotal = 'wallet_net_total',
  /** column name */
  WalletReturnCount = 'wallet_return_count',
  /** column name */
  WalletReturnTotal = 'wallet_return_total',
  /** column name */
  WalletSaleCount = 'wallet_sale_count',
  /** column name */
  WalletSaleTotal = 'wallet_sale_total'
}

export type R_Transfer_Batches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<R_Transfer_Batches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<R_Transfer_Batches_Set_Input>;
  /** filter the rows which have to be updated */
  where: R_Transfer_Batches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type R_Transfer_Batches_Var_Pop_Fields = {
  __typename?: 'r_transfer_batches_var_pop_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment__meta_id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type R_Transfer_Batches_Var_Samp_Fields = {
  __typename?: 'r_transfer_batches_var_samp_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment__meta_id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type R_Transfer_Batches_Variance_Fields = {
  __typename?: 'r_transfer_batches_variance_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment__meta_id?: Maybe<Scalars['Float']['output']>;
  last_successful_payment_id?: Maybe<Scalars['Float']['output']>;
  legacy_transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  transfer_batch_id?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "r_users" */
export type R_Users = {
  __typename?: 'r_users';
  anonymized_at?: Maybe<Scalars['timestamp']['output']>;
  auto_reload_enabled?: Maybe<Scalars['Boolean']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  device_users: Array<Device_User>;
  /** An aggregate relationship */
  device_users_aggregate: Device_User_Aggregate;
  email?: Maybe<Scalars['String']['output']>;
  exclude_from_issues: Scalars['Boolean']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  is_legacy_migration: Scalars['Boolean']['output'];
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_auto_reloaded_wallet_at?: Maybe<Scalars['timestamp']['output']>;
  last_error_at?: Maybe<Scalars['timestamp']['output']>;
  last_legacy_parkable_transaction_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_parkable_transaction_at?: Maybe<Scalars['timestamp']['output']>;
  last_payment_decline_at?: Maybe<Scalars['timestamp']['output']>;
  last_reloaded_wallet_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  legacyMigration?: Maybe<Legacy_Migrations>;
  legacy_migration__completed_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_migration__started_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_user_id?: Maybe<Scalars['bigint']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  num_errors: Scalars['Int']['output'];
  num_legacy_parkable_transactions?: Maybe<Scalars['Int']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Int']['output']>;
  num_payment_declines: Scalars['Int']['output'];
  num_recent_errors: Scalars['Int']['output'];
  num_recent_payment_declines: Scalars['Int']['output'];
  num_wallet_transactions?: Maybe<Scalars['Int']['output']>;
  original_created_at: Scalars['timestamp']['output'];
  original_deleted_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  parkable_transactions?: Maybe<Parkable_Transactions>;
  /** An array relationship */
  parking_authority_users: Array<Parking_Authority_User>;
  /** An aggregate relationship */
  parking_authority_users_aggregate: Parking_Authority_User_Aggregate;
  /** An array relationship */
  payment_methods: Array<Payment_Methods>;
  /** An aggregate relationship */
  payment_methods_aggregate: Payment_Methods_Aggregate;
  pending_deletion_at?: Maybe<Scalars['timestamp']['output']>;
  percent_wallet_usage?: Maybe<Scalars['float8']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  reports: Array<Reports>;
  /** An aggregate relationship */
  reports_aggregate: Reports_Aggregate;
  /** An array relationship */
  support_tickets: Array<Support_Tickets>;
  /** An aggregate relationship */
  support_tickets_aggregate: Support_Tickets_Aggregate;
  /** An array relationship */
  task_users: Array<Task_User>;
  /** An aggregate relationship */
  task_users_aggregate: Task_User_Aggregate;
  terms_of_service_last_accepted?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An array relationship */
  userActivities: Array<User_Activities>;
  /** An aggregate relationship */
  userActivities_aggregate: User_Activities_Aggregate;
  /** An array relationship */
  user_activities: Array<User_Activities>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activities_Aggregate;
  user_id: Scalars['bigint']['output'];
  /** An array relationship */
  user_settings: Array<User_Settings>;
  /** An aggregate relationship */
  user_settings_aggregate: User_Settings_Aggregate;
  /** An array relationship */
  user_user_lists: Array<User_User_List>;
  /** An aggregate relationship */
  user_user_lists_aggregate: User_User_List_Aggregate;
  /** An array relationship */
  vehicles: Array<Vehicles>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicles_Aggregate;
  /** An object relationship */
  wallet?: Maybe<Wallets>;
  wallet_balance?: Maybe<Scalars['Int']['output']>;
  wallet_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "r_users" */
export type R_UsersDevice_UsersArgs = {
  distinct_on?: InputMaybe<Array<Device_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_User_Order_By>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersDevice_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_User_Order_By>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersParking_Authority_UsersArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_User_Order_By>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersParking_Authority_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_User_Order_By>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersSupport_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersSupport_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersTask_UsersArgs = {
  distinct_on?: InputMaybe<Array<Task_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_User_Order_By>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersTask_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_User_Order_By>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersUserActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersUserActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersUser_User_ListsArgs = {
  distinct_on?: InputMaybe<Array<User_User_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_User_List_Order_By>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersUser_User_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_User_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_User_List_Order_By>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


/** columns and relationships of "r_users" */
export type R_UsersVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};

/** aggregated selection of "r_users" */
export type R_Users_Aggregate = {
  __typename?: 'r_users_aggregate';
  aggregate?: Maybe<R_Users_Aggregate_Fields>;
  nodes: Array<R_Users>;
};

/** aggregate fields of "r_users" */
export type R_Users_Aggregate_Fields = {
  __typename?: 'r_users_aggregate_fields';
  avg?: Maybe<R_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<R_Users_Max_Fields>;
  min?: Maybe<R_Users_Min_Fields>;
  stddev?: Maybe<R_Users_Stddev_Fields>;
  stddev_pop?: Maybe<R_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<R_Users_Stddev_Samp_Fields>;
  sum?: Maybe<R_Users_Sum_Fields>;
  var_pop?: Maybe<R_Users_Var_Pop_Fields>;
  var_samp?: Maybe<R_Users_Var_Samp_Fields>;
  variance?: Maybe<R_Users_Variance_Fields>;
};


/** aggregate fields of "r_users" */
export type R_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<R_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type R_Users_Avg_Fields = {
  __typename?: 'r_users_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_user_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_errors?: Maybe<Scalars['Float']['output']>;
  num_legacy_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_recent_errors?: Maybe<Scalars['Float']['output']>;
  num_recent_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_wallet_transactions?: Maybe<Scalars['Float']['output']>;
  percent_wallet_usage?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_balance?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "r_users". All fields are combined with a logical 'AND'. */
export type R_Users_Bool_Exp = {
  _and?: InputMaybe<Array<R_Users_Bool_Exp>>;
  _not?: InputMaybe<R_Users_Bool_Exp>;
  _or?: InputMaybe<Array<R_Users_Bool_Exp>>;
  anonymized_at?: InputMaybe<Timestamp_Comparison_Exp>;
  auto_reload_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  cognito_identity_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  device_users?: InputMaybe<Device_User_Bool_Exp>;
  device_users_aggregate?: InputMaybe<Device_User_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  exclude_from_issues?: InputMaybe<Boolean_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  invoices?: InputMaybe<Invoices_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Bool_Exp>;
  is_legacy_migration?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_auto_reloaded_wallet_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_error_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_legacy_parkable_transaction_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_login_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  last_parkable_transaction_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_payment_decline_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_reloaded_wallet_at?: InputMaybe<Timestamp_Comparison_Exp>;
  legacyMigration?: InputMaybe<Legacy_Migrations_Bool_Exp>;
  legacy_migration__completed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  legacy_migration__started_at?: InputMaybe<Timestamp_Comparison_Exp>;
  legacy_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  mxm_customer_id?: InputMaybe<Bigint_Comparison_Exp>;
  num_errors?: InputMaybe<Int_Comparison_Exp>;
  num_legacy_parkable_transactions?: InputMaybe<Int_Comparison_Exp>;
  num_parkable_transactions?: InputMaybe<Int_Comparison_Exp>;
  num_payment_declines?: InputMaybe<Int_Comparison_Exp>;
  num_recent_errors?: InputMaybe<Int_Comparison_Exp>;
  num_recent_payment_declines?: InputMaybe<Int_Comparison_Exp>;
  num_wallet_transactions?: InputMaybe<Int_Comparison_Exp>;
  original_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  original_deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  original_updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  parking_authority_users?: InputMaybe<Parking_Authority_User_Bool_Exp>;
  parking_authority_users_aggregate?: InputMaybe<Parking_Authority_User_Aggregate_Bool_Exp>;
  payment_methods?: InputMaybe<Payment_Methods_Bool_Exp>;
  payment_methods_aggregate?: InputMaybe<Payment_Methods_Aggregate_Bool_Exp>;
  pending_deletion_at?: InputMaybe<Timestamp_Comparison_Exp>;
  percent_wallet_usage?: InputMaybe<Float8_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  reports?: InputMaybe<Reports_Bool_Exp>;
  reports_aggregate?: InputMaybe<Reports_Aggregate_Bool_Exp>;
  support_tickets?: InputMaybe<Support_Tickets_Bool_Exp>;
  support_tickets_aggregate?: InputMaybe<Support_Tickets_Aggregate_Bool_Exp>;
  task_users?: InputMaybe<Task_User_Bool_Exp>;
  task_users_aggregate?: InputMaybe<Task_User_Aggregate_Bool_Exp>;
  terms_of_service_last_accepted?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userActivities?: InputMaybe<User_Activities_Bool_Exp>;
  userActivities_aggregate?: InputMaybe<User_Activities_Aggregate_Bool_Exp>;
  user_activities?: InputMaybe<User_Activities_Bool_Exp>;
  user_activities_aggregate?: InputMaybe<User_Activities_Aggregate_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_settings?: InputMaybe<User_Settings_Bool_Exp>;
  user_settings_aggregate?: InputMaybe<User_Settings_Aggregate_Bool_Exp>;
  user_user_lists?: InputMaybe<User_User_List_Bool_Exp>;
  user_user_lists_aggregate?: InputMaybe<User_User_List_Aggregate_Bool_Exp>;
  vehicles?: InputMaybe<Vehicles_Bool_Exp>;
  vehicles_aggregate?: InputMaybe<Vehicles_Aggregate_Bool_Exp>;
  wallet?: InputMaybe<Wallets_Bool_Exp>;
  wallet_balance?: InputMaybe<Int_Comparison_Exp>;
  wallet_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "r_users" */
export enum R_Users_Constraint {
  /** unique or primary key constraint on columns "legacy_user_id" */
  RUsersLegacyUserIdUnique = 'r_users_legacy_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  RUsersPkey = 'r_users_pkey',
  /** unique or primary key constraint on columns "user_id" */
  RUsersUserIdUnique = 'r_users_user_id_unique',
  /** unique or primary key constraint on columns "wallet_id" */
  RUsersWalletIdUnique = 'r_users_wallet_id_unique'
}

/** input type for incrementing numeric columns in table "r_users" */
export type R_Users_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  legacy_user_id?: InputMaybe<Scalars['bigint']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  num_errors?: InputMaybe<Scalars['Int']['input']>;
  num_legacy_parkable_transactions?: InputMaybe<Scalars['Int']['input']>;
  num_parkable_transactions?: InputMaybe<Scalars['Int']['input']>;
  num_payment_declines?: InputMaybe<Scalars['Int']['input']>;
  num_recent_errors?: InputMaybe<Scalars['Int']['input']>;
  num_recent_payment_declines?: InputMaybe<Scalars['Int']['input']>;
  num_wallet_transactions?: InputMaybe<Scalars['Int']['input']>;
  percent_wallet_usage?: InputMaybe<Scalars['float8']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_balance?: InputMaybe<Scalars['Int']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "r_users" */
export type R_Users_Insert_Input = {
  anonymized_at?: InputMaybe<Scalars['timestamp']['input']>;
  auto_reload_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_users?: InputMaybe<Device_User_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  exclude_from_issues?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  invoices?: InputMaybe<Invoices_Arr_Rel_Insert_Input>;
  is_legacy_migration?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_auto_reloaded_wallet_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_error_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_legacy_parkable_transaction_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_parkable_transaction_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_payment_decline_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_reloaded_wallet_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacyMigration?: InputMaybe<Legacy_Migrations_Obj_Rel_Insert_Input>;
  legacy_migration__completed_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_migration__started_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_user_id?: InputMaybe<Scalars['bigint']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  num_errors?: InputMaybe<Scalars['Int']['input']>;
  num_legacy_parkable_transactions?: InputMaybe<Scalars['Int']['input']>;
  num_parkable_transactions?: InputMaybe<Scalars['Int']['input']>;
  num_payment_declines?: InputMaybe<Scalars['Int']['input']>;
  num_recent_errors?: InputMaybe<Scalars['Int']['input']>;
  num_recent_payment_declines?: InputMaybe<Scalars['Int']['input']>;
  num_wallet_transactions?: InputMaybe<Scalars['Int']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Obj_Rel_Insert_Input>;
  parking_authority_users?: InputMaybe<Parking_Authority_User_Arr_Rel_Insert_Input>;
  payment_methods?: InputMaybe<Payment_Methods_Arr_Rel_Insert_Input>;
  pending_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
  percent_wallet_usage?: InputMaybe<Scalars['float8']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  reports?: InputMaybe<Reports_Arr_Rel_Insert_Input>;
  support_tickets?: InputMaybe<Support_Tickets_Arr_Rel_Insert_Input>;
  task_users?: InputMaybe<Task_User_Arr_Rel_Insert_Input>;
  terms_of_service_last_accepted?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userActivities?: InputMaybe<User_Activities_Arr_Rel_Insert_Input>;
  user_activities?: InputMaybe<User_Activities_Arr_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  user_settings?: InputMaybe<User_Settings_Arr_Rel_Insert_Input>;
  user_user_lists?: InputMaybe<User_User_List_Arr_Rel_Insert_Input>;
  vehicles?: InputMaybe<Vehicles_Arr_Rel_Insert_Input>;
  wallet?: InputMaybe<Wallets_Obj_Rel_Insert_Input>;
  wallet_balance?: InputMaybe<Scalars['Int']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type R_Users_Max_Fields = {
  __typename?: 'r_users_max_fields';
  anonymized_at?: Maybe<Scalars['timestamp']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_auto_reloaded_wallet_at?: Maybe<Scalars['timestamp']['output']>;
  last_error_at?: Maybe<Scalars['timestamp']['output']>;
  last_legacy_parkable_transaction_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_parkable_transaction_at?: Maybe<Scalars['timestamp']['output']>;
  last_payment_decline_at?: Maybe<Scalars['timestamp']['output']>;
  last_reloaded_wallet_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_migration__completed_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_migration__started_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_user_id?: Maybe<Scalars['bigint']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  num_errors?: Maybe<Scalars['Int']['output']>;
  num_legacy_parkable_transactions?: Maybe<Scalars['Int']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Int']['output']>;
  num_payment_declines?: Maybe<Scalars['Int']['output']>;
  num_recent_errors?: Maybe<Scalars['Int']['output']>;
  num_recent_payment_declines?: Maybe<Scalars['Int']['output']>;
  num_wallet_transactions?: Maybe<Scalars['Int']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_deleted_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  pending_deletion_at?: Maybe<Scalars['timestamp']['output']>;
  percent_wallet_usage?: Maybe<Scalars['float8']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  terms_of_service_last_accepted?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  wallet_balance?: Maybe<Scalars['Int']['output']>;
  wallet_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type R_Users_Min_Fields = {
  __typename?: 'r_users_min_fields';
  anonymized_at?: Maybe<Scalars['timestamp']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_auto_reloaded_wallet_at?: Maybe<Scalars['timestamp']['output']>;
  last_error_at?: Maybe<Scalars['timestamp']['output']>;
  last_legacy_parkable_transaction_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_parkable_transaction_at?: Maybe<Scalars['timestamp']['output']>;
  last_payment_decline_at?: Maybe<Scalars['timestamp']['output']>;
  last_reloaded_wallet_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_migration__completed_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_migration__started_at?: Maybe<Scalars['timestamp']['output']>;
  legacy_user_id?: Maybe<Scalars['bigint']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  num_errors?: Maybe<Scalars['Int']['output']>;
  num_legacy_parkable_transactions?: Maybe<Scalars['Int']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Int']['output']>;
  num_payment_declines?: Maybe<Scalars['Int']['output']>;
  num_recent_errors?: Maybe<Scalars['Int']['output']>;
  num_recent_payment_declines?: Maybe<Scalars['Int']['output']>;
  num_wallet_transactions?: Maybe<Scalars['Int']['output']>;
  original_created_at?: Maybe<Scalars['timestamp']['output']>;
  original_deleted_at?: Maybe<Scalars['timestamp']['output']>;
  original_updated_at?: Maybe<Scalars['timestamp']['output']>;
  pending_deletion_at?: Maybe<Scalars['timestamp']['output']>;
  percent_wallet_usage?: Maybe<Scalars['float8']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  terms_of_service_last_accepted?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  wallet_balance?: Maybe<Scalars['Int']['output']>;
  wallet_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "r_users" */
export type R_Users_Mutation_Response = {
  __typename?: 'r_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<R_Users>;
};

/** input type for inserting object relation for remote table "r_users" */
export type R_Users_Obj_Rel_Insert_Input = {
  data: R_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<R_Users_On_Conflict>;
};

/** on_conflict condition type for table "r_users" */
export type R_Users_On_Conflict = {
  constraint: R_Users_Constraint;
  update_columns?: Array<R_Users_Update_Column>;
  where?: InputMaybe<R_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "r_users". */
export type R_Users_Order_By = {
  anonymized_at?: InputMaybe<Order_By>;
  auto_reload_enabled?: InputMaybe<Order_By>;
  cognito_identity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_users_aggregate?: InputMaybe<Device_User_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  exclude_from_issues?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Order_By>;
  is_legacy_migration?: InputMaybe<Order_By>;
  last_active_at?: InputMaybe<Order_By>;
  last_auto_reloaded_wallet_at?: InputMaybe<Order_By>;
  last_error_at?: InputMaybe<Order_By>;
  last_legacy_parkable_transaction_at?: InputMaybe<Order_By>;
  last_login_at?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  last_parkable_transaction_at?: InputMaybe<Order_By>;
  last_payment_decline_at?: InputMaybe<Order_By>;
  last_reloaded_wallet_at?: InputMaybe<Order_By>;
  legacyMigration?: InputMaybe<Legacy_Migrations_Order_By>;
  legacy_migration__completed_at?: InputMaybe<Order_By>;
  legacy_migration__started_at?: InputMaybe<Order_By>;
  legacy_user_id?: InputMaybe<Order_By>;
  mxm_customer_id?: InputMaybe<Order_By>;
  num_errors?: InputMaybe<Order_By>;
  num_legacy_parkable_transactions?: InputMaybe<Order_By>;
  num_parkable_transactions?: InputMaybe<Order_By>;
  num_payment_declines?: InputMaybe<Order_By>;
  num_recent_errors?: InputMaybe<Order_By>;
  num_recent_payment_declines?: InputMaybe<Order_By>;
  num_wallet_transactions?: InputMaybe<Order_By>;
  original_created_at?: InputMaybe<Order_By>;
  original_deleted_at?: InputMaybe<Order_By>;
  original_updated_at?: InputMaybe<Order_By>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Order_By>;
  parking_authority_users_aggregate?: InputMaybe<Parking_Authority_User_Aggregate_Order_By>;
  payment_methods_aggregate?: InputMaybe<Payment_Methods_Aggregate_Order_By>;
  pending_deletion_at?: InputMaybe<Order_By>;
  percent_wallet_usage?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  reports_aggregate?: InputMaybe<Reports_Aggregate_Order_By>;
  support_tickets_aggregate?: InputMaybe<Support_Tickets_Aggregate_Order_By>;
  task_users_aggregate?: InputMaybe<Task_User_Aggregate_Order_By>;
  terms_of_service_last_accepted?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userActivities_aggregate?: InputMaybe<User_Activities_Aggregate_Order_By>;
  user_activities_aggregate?: InputMaybe<User_Activities_Aggregate_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_settings_aggregate?: InputMaybe<User_Settings_Aggregate_Order_By>;
  user_user_lists_aggregate?: InputMaybe<User_User_List_Aggregate_Order_By>;
  vehicles_aggregate?: InputMaybe<Vehicles_Aggregate_Order_By>;
  wallet?: InputMaybe<Wallets_Order_By>;
  wallet_balance?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: r_users */
export type R_Users_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "r_users" */
export enum R_Users_Select_Column {
  /** column name */
  AnonymizedAt = 'anonymized_at',
  /** column name */
  AutoReloadEnabled = 'auto_reload_enabled',
  /** column name */
  CognitoIdentityId = 'cognito_identity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExcludeFromIssues = 'exclude_from_issues',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsLegacyMigration = 'is_legacy_migration',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LastAutoReloadedWalletAt = 'last_auto_reloaded_wallet_at',
  /** column name */
  LastErrorAt = 'last_error_at',
  /** column name */
  LastLegacyParkableTransactionAt = 'last_legacy_parkable_transaction_at',
  /** column name */
  LastLoginAt = 'last_login_at',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastParkableTransactionAt = 'last_parkable_transaction_at',
  /** column name */
  LastPaymentDeclineAt = 'last_payment_decline_at',
  /** column name */
  LastReloadedWalletAt = 'last_reloaded_wallet_at',
  /** column name */
  LegacyMigrationCompletedAt = 'legacy_migration__completed_at',
  /** column name */
  LegacyMigrationStartedAt = 'legacy_migration__started_at',
  /** column name */
  LegacyUserId = 'legacy_user_id',
  /** column name */
  MxmCustomerId = 'mxm_customer_id',
  /** column name */
  NumErrors = 'num_errors',
  /** column name */
  NumLegacyParkableTransactions = 'num_legacy_parkable_transactions',
  /** column name */
  NumParkableTransactions = 'num_parkable_transactions',
  /** column name */
  NumPaymentDeclines = 'num_payment_declines',
  /** column name */
  NumRecentErrors = 'num_recent_errors',
  /** column name */
  NumRecentPaymentDeclines = 'num_recent_payment_declines',
  /** column name */
  NumWalletTransactions = 'num_wallet_transactions',
  /** column name */
  OriginalCreatedAt = 'original_created_at',
  /** column name */
  OriginalDeletedAt = 'original_deleted_at',
  /** column name */
  OriginalUpdatedAt = 'original_updated_at',
  /** column name */
  PendingDeletionAt = 'pending_deletion_at',
  /** column name */
  PercentWalletUsage = 'percent_wallet_usage',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TermsOfServiceLastAccepted = 'terms_of_service_last_accepted',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WalletBalance = 'wallet_balance',
  /** column name */
  WalletId = 'wallet_id'
}

/** input type for updating data in table "r_users" */
export type R_Users_Set_Input = {
  anonymized_at?: InputMaybe<Scalars['timestamp']['input']>;
  auto_reload_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exclude_from_issues?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_legacy_migration?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_auto_reloaded_wallet_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_error_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_legacy_parkable_transaction_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_parkable_transaction_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_payment_decline_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_reloaded_wallet_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_migration__completed_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_migration__started_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_user_id?: InputMaybe<Scalars['bigint']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  num_errors?: InputMaybe<Scalars['Int']['input']>;
  num_legacy_parkable_transactions?: InputMaybe<Scalars['Int']['input']>;
  num_parkable_transactions?: InputMaybe<Scalars['Int']['input']>;
  num_payment_declines?: InputMaybe<Scalars['Int']['input']>;
  num_recent_errors?: InputMaybe<Scalars['Int']['input']>;
  num_recent_payment_declines?: InputMaybe<Scalars['Int']['input']>;
  num_wallet_transactions?: InputMaybe<Scalars['Int']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  pending_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
  percent_wallet_usage?: InputMaybe<Scalars['float8']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  terms_of_service_last_accepted?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_balance?: InputMaybe<Scalars['Int']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type R_Users_Stddev_Fields = {
  __typename?: 'r_users_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_user_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_errors?: Maybe<Scalars['Float']['output']>;
  num_legacy_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_recent_errors?: Maybe<Scalars['Float']['output']>;
  num_recent_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_wallet_transactions?: Maybe<Scalars['Float']['output']>;
  percent_wallet_usage?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_balance?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type R_Users_Stddev_Pop_Fields = {
  __typename?: 'r_users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_user_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_errors?: Maybe<Scalars['Float']['output']>;
  num_legacy_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_recent_errors?: Maybe<Scalars['Float']['output']>;
  num_recent_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_wallet_transactions?: Maybe<Scalars['Float']['output']>;
  percent_wallet_usage?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_balance?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type R_Users_Stddev_Samp_Fields = {
  __typename?: 'r_users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_user_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_errors?: Maybe<Scalars['Float']['output']>;
  num_legacy_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_recent_errors?: Maybe<Scalars['Float']['output']>;
  num_recent_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_wallet_transactions?: Maybe<Scalars['Float']['output']>;
  percent_wallet_usage?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_balance?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "r_users" */
export type R_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: R_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type R_Users_Stream_Cursor_Value_Input = {
  anonymized_at?: InputMaybe<Scalars['timestamp']['input']>;
  auto_reload_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exclude_from_issues?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_legacy_migration?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_auto_reloaded_wallet_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_error_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_legacy_parkable_transaction_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_parkable_transaction_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_payment_decline_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_reloaded_wallet_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_migration__completed_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_migration__started_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacy_user_id?: InputMaybe<Scalars['bigint']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  num_errors?: InputMaybe<Scalars['Int']['input']>;
  num_legacy_parkable_transactions?: InputMaybe<Scalars['Int']['input']>;
  num_parkable_transactions?: InputMaybe<Scalars['Int']['input']>;
  num_payment_declines?: InputMaybe<Scalars['Int']['input']>;
  num_recent_errors?: InputMaybe<Scalars['Int']['input']>;
  num_recent_payment_declines?: InputMaybe<Scalars['Int']['input']>;
  num_wallet_transactions?: InputMaybe<Scalars['Int']['input']>;
  original_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  original_updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  pending_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
  percent_wallet_usage?: InputMaybe<Scalars['float8']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  terms_of_service_last_accepted?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_balance?: InputMaybe<Scalars['Int']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type R_Users_Sum_Fields = {
  __typename?: 'r_users_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  legacy_user_id?: Maybe<Scalars['bigint']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  num_errors?: Maybe<Scalars['Int']['output']>;
  num_legacy_parkable_transactions?: Maybe<Scalars['Int']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Int']['output']>;
  num_payment_declines?: Maybe<Scalars['Int']['output']>;
  num_recent_errors?: Maybe<Scalars['Int']['output']>;
  num_recent_payment_declines?: Maybe<Scalars['Int']['output']>;
  num_wallet_transactions?: Maybe<Scalars['Int']['output']>;
  percent_wallet_usage?: Maybe<Scalars['float8']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  wallet_balance?: Maybe<Scalars['Int']['output']>;
  wallet_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "r_users" */
export enum R_Users_Update_Column {
  /** column name */
  AnonymizedAt = 'anonymized_at',
  /** column name */
  AutoReloadEnabled = 'auto_reload_enabled',
  /** column name */
  CognitoIdentityId = 'cognito_identity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExcludeFromIssues = 'exclude_from_issues',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsLegacyMigration = 'is_legacy_migration',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LastAutoReloadedWalletAt = 'last_auto_reloaded_wallet_at',
  /** column name */
  LastErrorAt = 'last_error_at',
  /** column name */
  LastLegacyParkableTransactionAt = 'last_legacy_parkable_transaction_at',
  /** column name */
  LastLoginAt = 'last_login_at',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastParkableTransactionAt = 'last_parkable_transaction_at',
  /** column name */
  LastPaymentDeclineAt = 'last_payment_decline_at',
  /** column name */
  LastReloadedWalletAt = 'last_reloaded_wallet_at',
  /** column name */
  LegacyMigrationCompletedAt = 'legacy_migration__completed_at',
  /** column name */
  LegacyMigrationStartedAt = 'legacy_migration__started_at',
  /** column name */
  LegacyUserId = 'legacy_user_id',
  /** column name */
  MxmCustomerId = 'mxm_customer_id',
  /** column name */
  NumErrors = 'num_errors',
  /** column name */
  NumLegacyParkableTransactions = 'num_legacy_parkable_transactions',
  /** column name */
  NumParkableTransactions = 'num_parkable_transactions',
  /** column name */
  NumPaymentDeclines = 'num_payment_declines',
  /** column name */
  NumRecentErrors = 'num_recent_errors',
  /** column name */
  NumRecentPaymentDeclines = 'num_recent_payment_declines',
  /** column name */
  NumWalletTransactions = 'num_wallet_transactions',
  /** column name */
  OriginalCreatedAt = 'original_created_at',
  /** column name */
  OriginalDeletedAt = 'original_deleted_at',
  /** column name */
  OriginalUpdatedAt = 'original_updated_at',
  /** column name */
  PendingDeletionAt = 'pending_deletion_at',
  /** column name */
  PercentWalletUsage = 'percent_wallet_usage',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TermsOfServiceLastAccepted = 'terms_of_service_last_accepted',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WalletBalance = 'wallet_balance',
  /** column name */
  WalletId = 'wallet_id'
}

export type R_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<R_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<R_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: R_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type R_Users_Var_Pop_Fields = {
  __typename?: 'r_users_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_user_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_errors?: Maybe<Scalars['Float']['output']>;
  num_legacy_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_recent_errors?: Maybe<Scalars['Float']['output']>;
  num_recent_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_wallet_transactions?: Maybe<Scalars['Float']['output']>;
  percent_wallet_usage?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_balance?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type R_Users_Var_Samp_Fields = {
  __typename?: 'r_users_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_user_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_errors?: Maybe<Scalars['Float']['output']>;
  num_legacy_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_recent_errors?: Maybe<Scalars['Float']['output']>;
  num_recent_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_wallet_transactions?: Maybe<Scalars['Float']['output']>;
  percent_wallet_usage?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_balance?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type R_Users_Variance_Fields = {
  __typename?: 'r_users_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  legacy_user_id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_errors?: Maybe<Scalars['Float']['output']>;
  num_legacy_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_parkable_transactions?: Maybe<Scalars['Float']['output']>;
  num_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_recent_errors?: Maybe<Scalars['Float']['output']>;
  num_recent_payment_declines?: Maybe<Scalars['Float']['output']>;
  num_wallet_transactions?: Maybe<Scalars['Float']['output']>;
  percent_wallet_usage?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  wallet_balance?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "reports" */
export type Reports = {
  __typename?: 'reports';
  /** An object relationship */
  admin_user?: Maybe<Admin_Users>;
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data: Scalars['json']['output'];
  id: Scalars['bigint']['output'];
  idempotent_key: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "reports" */
export type ReportsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "reports" */
export type Reports_Aggregate = {
  __typename?: 'reports_aggregate';
  aggregate?: Maybe<Reports_Aggregate_Fields>;
  nodes: Array<Reports>;
};

export type Reports_Aggregate_Bool_Exp = {
  count?: InputMaybe<Reports_Aggregate_Bool_Exp_Count>;
};

export type Reports_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reports_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reports" */
export type Reports_Aggregate_Fields = {
  __typename?: 'reports_aggregate_fields';
  avg?: Maybe<Reports_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reports_Max_Fields>;
  min?: Maybe<Reports_Min_Fields>;
  stddev?: Maybe<Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Reports_Sum_Fields>;
  var_pop?: Maybe<Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Reports_Var_Samp_Fields>;
  variance?: Maybe<Reports_Variance_Fields>;
};


/** aggregate fields of "reports" */
export type Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reports" */
export type Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reports_Max_Order_By>;
  min?: InputMaybe<Reports_Min_Order_By>;
  stddev?: InputMaybe<Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Reports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reports" */
export type Reports_Arr_Rel_Insert_Input = {
  data: Array<Reports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Reports_Avg_Fields = {
  __typename?: 'reports_avg_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reports" */
export type Reports_Avg_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reports". All fields are combined with a logical 'AND'. */
export type Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Reports_Bool_Exp>>;
  _not?: InputMaybe<Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Reports_Bool_Exp>>;
  admin_user?: InputMaybe<Admin_Users_Bool_Exp>;
  admin_user_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "reports" */
export enum Reports_Constraint {
  /** unique or primary key constraint on columns "idempotent_key" */
  ReportsIdempotentKeyUnique = 'reports_idempotent_key_unique',
  /** unique or primary key constraint on columns "id" */
  ReportsPkey = 'reports_pkey'
}

/** input type for incrementing numeric columns in table "reports" */
export type Reports_Inc_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "reports" */
export type Reports_Insert_Input = {
  admin_user?: InputMaybe<Admin_Users_Obj_Rel_Insert_Input>;
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Reports_Max_Fields = {
  __typename?: 'reports_max_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "reports" */
export type Reports_Max_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reports_Min_Fields = {
  __typename?: 'reports_min_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "reports" */
export type Reports_Min_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reports" */
export type Reports_Mutation_Response = {
  __typename?: 'reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reports>;
};

/** on_conflict condition type for table "reports" */
export type Reports_On_Conflict = {
  constraint: Reports_Constraint;
  update_columns?: Array<Reports_Update_Column>;
  where?: InputMaybe<Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "reports". */
export type Reports_Order_By = {
  admin_user?: InputMaybe<Admin_Users_Order_By>;
  admin_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reports */
export type Reports_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "reports" */
export enum Reports_Select_Column {
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "reports" */
export type Reports_Set_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Reports_Stddev_Fields = {
  __typename?: 'reports_stddev_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reports" */
export type Reports_Stddev_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reports_Stddev_Pop_Fields = {
  __typename?: 'reports_stddev_pop_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reports" */
export type Reports_Stddev_Pop_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reports_Stddev_Samp_Fields = {
  __typename?: 'reports_stddev_samp_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reports" */
export type Reports_Stddev_Samp_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reports" */
export type Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reports_Stream_Cursor_Value_Input = {
  admin_user_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Reports_Sum_Fields = {
  __typename?: 'reports_sum_fields';
  admin_user_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "reports" */
export type Reports_Sum_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "reports" */
export enum Reports_Update_Column {
  /** column name */
  AdminUserId = 'admin_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Reports_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reports_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reports_Var_Pop_Fields = {
  __typename?: 'reports_var_pop_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reports" */
export type Reports_Var_Pop_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reports_Var_Samp_Fields = {
  __typename?: 'reports_var_samp_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reports" */
export type Reports_Var_Samp_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reports_Variance_Fields = {
  __typename?: 'reports_variance_fields';
  admin_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reports" */
export type Reports_Variance_Order_By = {
  admin_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "session_overlap_results" */
export type Session_Overlap_Results = {
  __typename?: 'session_overlap_results';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  end: Scalars['timestamp']['output'];
  id: Scalars['bigint']['output'];
  max_sessions_per_span?: Maybe<Scalars['bigint']['output']>;
  min_sessions_per_span?: Maybe<Scalars['bigint']['output']>;
  num_meters_analyzed: Scalars['bigint']['output'];
  num_non_overlapping_sessions: Scalars['bigint']['output'];
  num_overlapping_sessions: Scalars['bigint']['output'];
  num_sessions_analyzed: Scalars['bigint']['output'];
  /** An object relationship */
  parkable?: Maybe<Parkables>;
  parkable_id: Scalars['bigint']['output'];
  set_key?: Maybe<Scalars['String']['output']>;
  start: Scalars['timestamp']['output'];
  total_money_gained: Scalars['bigint']['output'];
  total_money_with_overlap: Scalars['bigint']['output'];
  total_money_without_overlap: Scalars['bigint']['output'];
  total_time_gained: Scalars['bigint']['output'];
  total_time_with_overlap: Scalars['bigint']['output'];
  total_time_without_overlap: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "session_overlap_results" */
export type Session_Overlap_Results_Aggregate = {
  __typename?: 'session_overlap_results_aggregate';
  aggregate?: Maybe<Session_Overlap_Results_Aggregate_Fields>;
  nodes: Array<Session_Overlap_Results>;
};

/** aggregate fields of "session_overlap_results" */
export type Session_Overlap_Results_Aggregate_Fields = {
  __typename?: 'session_overlap_results_aggregate_fields';
  avg?: Maybe<Session_Overlap_Results_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Session_Overlap_Results_Max_Fields>;
  min?: Maybe<Session_Overlap_Results_Min_Fields>;
  stddev?: Maybe<Session_Overlap_Results_Stddev_Fields>;
  stddev_pop?: Maybe<Session_Overlap_Results_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Session_Overlap_Results_Stddev_Samp_Fields>;
  sum?: Maybe<Session_Overlap_Results_Sum_Fields>;
  var_pop?: Maybe<Session_Overlap_Results_Var_Pop_Fields>;
  var_samp?: Maybe<Session_Overlap_Results_Var_Samp_Fields>;
  variance?: Maybe<Session_Overlap_Results_Variance_Fields>;
};


/** aggregate fields of "session_overlap_results" */
export type Session_Overlap_Results_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Session_Overlap_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Session_Overlap_Results_Avg_Fields = {
  __typename?: 'session_overlap_results_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  min_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  num_meters_analyzed?: Maybe<Scalars['Float']['output']>;
  num_non_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_sessions_analyzed?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  total_money_gained?: Maybe<Scalars['Float']['output']>;
  total_money_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_money_without_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_gained?: Maybe<Scalars['Float']['output']>;
  total_time_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_without_overlap?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "session_overlap_results". All fields are combined with a logical 'AND'. */
export type Session_Overlap_Results_Bool_Exp = {
  _and?: InputMaybe<Array<Session_Overlap_Results_Bool_Exp>>;
  _not?: InputMaybe<Session_Overlap_Results_Bool_Exp>;
  _or?: InputMaybe<Array<Session_Overlap_Results_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  end?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  max_sessions_per_span?: InputMaybe<Bigint_Comparison_Exp>;
  min_sessions_per_span?: InputMaybe<Bigint_Comparison_Exp>;
  num_meters_analyzed?: InputMaybe<Bigint_Comparison_Exp>;
  num_non_overlapping_sessions?: InputMaybe<Bigint_Comparison_Exp>;
  num_overlapping_sessions?: InputMaybe<Bigint_Comparison_Exp>;
  num_sessions_analyzed?: InputMaybe<Bigint_Comparison_Exp>;
  parkable?: InputMaybe<Parkables_Bool_Exp>;
  parkable_id?: InputMaybe<Bigint_Comparison_Exp>;
  set_key?: InputMaybe<String_Comparison_Exp>;
  start?: InputMaybe<Timestamp_Comparison_Exp>;
  total_money_gained?: InputMaybe<Bigint_Comparison_Exp>;
  total_money_with_overlap?: InputMaybe<Bigint_Comparison_Exp>;
  total_money_without_overlap?: InputMaybe<Bigint_Comparison_Exp>;
  total_time_gained?: InputMaybe<Bigint_Comparison_Exp>;
  total_time_with_overlap?: InputMaybe<Bigint_Comparison_Exp>;
  total_time_without_overlap?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "session_overlap_results" */
export enum Session_Overlap_Results_Constraint {
  /** unique or primary key constraint on columns "id" */
  SessionOverlapResultsPkey = 'session_overlap_results_pkey',
  /** unique or primary key constraint on columns "parkable_id", "start", "end", "set_key" */
  SessionOverlapResultsSetKeyStartEndParkableIdUnique = 'session_overlap_results_set_key_start_end_parkable_id_unique'
}

/** input type for incrementing numeric columns in table "session_overlap_results" */
export type Session_Overlap_Results_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  max_sessions_per_span?: InputMaybe<Scalars['bigint']['input']>;
  min_sessions_per_span?: InputMaybe<Scalars['bigint']['input']>;
  num_meters_analyzed?: InputMaybe<Scalars['bigint']['input']>;
  num_non_overlapping_sessions?: InputMaybe<Scalars['bigint']['input']>;
  num_overlapping_sessions?: InputMaybe<Scalars['bigint']['input']>;
  num_sessions_analyzed?: InputMaybe<Scalars['bigint']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  total_money_gained?: InputMaybe<Scalars['bigint']['input']>;
  total_money_with_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_money_without_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_time_gained?: InputMaybe<Scalars['bigint']['input']>;
  total_time_with_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_time_without_overlap?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "session_overlap_results" */
export type Session_Overlap_Results_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  max_sessions_per_span?: InputMaybe<Scalars['bigint']['input']>;
  min_sessions_per_span?: InputMaybe<Scalars['bigint']['input']>;
  num_meters_analyzed?: InputMaybe<Scalars['bigint']['input']>;
  num_non_overlapping_sessions?: InputMaybe<Scalars['bigint']['input']>;
  num_overlapping_sessions?: InputMaybe<Scalars['bigint']['input']>;
  num_sessions_analyzed?: InputMaybe<Scalars['bigint']['input']>;
  parkable?: InputMaybe<Parkables_Obj_Rel_Insert_Input>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  set_key?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  total_money_gained?: InputMaybe<Scalars['bigint']['input']>;
  total_money_with_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_money_without_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_time_gained?: InputMaybe<Scalars['bigint']['input']>;
  total_time_with_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_time_without_overlap?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Session_Overlap_Results_Max_Fields = {
  __typename?: 'session_overlap_results_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  max_sessions_per_span?: Maybe<Scalars['bigint']['output']>;
  min_sessions_per_span?: Maybe<Scalars['bigint']['output']>;
  num_meters_analyzed?: Maybe<Scalars['bigint']['output']>;
  num_non_overlapping_sessions?: Maybe<Scalars['bigint']['output']>;
  num_overlapping_sessions?: Maybe<Scalars['bigint']['output']>;
  num_sessions_analyzed?: Maybe<Scalars['bigint']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  set_key?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  total_money_gained?: Maybe<Scalars['bigint']['output']>;
  total_money_with_overlap?: Maybe<Scalars['bigint']['output']>;
  total_money_without_overlap?: Maybe<Scalars['bigint']['output']>;
  total_time_gained?: Maybe<Scalars['bigint']['output']>;
  total_time_with_overlap?: Maybe<Scalars['bigint']['output']>;
  total_time_without_overlap?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Session_Overlap_Results_Min_Fields = {
  __typename?: 'session_overlap_results_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  max_sessions_per_span?: Maybe<Scalars['bigint']['output']>;
  min_sessions_per_span?: Maybe<Scalars['bigint']['output']>;
  num_meters_analyzed?: Maybe<Scalars['bigint']['output']>;
  num_non_overlapping_sessions?: Maybe<Scalars['bigint']['output']>;
  num_overlapping_sessions?: Maybe<Scalars['bigint']['output']>;
  num_sessions_analyzed?: Maybe<Scalars['bigint']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  set_key?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  total_money_gained?: Maybe<Scalars['bigint']['output']>;
  total_money_with_overlap?: Maybe<Scalars['bigint']['output']>;
  total_money_without_overlap?: Maybe<Scalars['bigint']['output']>;
  total_time_gained?: Maybe<Scalars['bigint']['output']>;
  total_time_with_overlap?: Maybe<Scalars['bigint']['output']>;
  total_time_without_overlap?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "session_overlap_results" */
export type Session_Overlap_Results_Mutation_Response = {
  __typename?: 'session_overlap_results_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Session_Overlap_Results>;
};

/** on_conflict condition type for table "session_overlap_results" */
export type Session_Overlap_Results_On_Conflict = {
  constraint: Session_Overlap_Results_Constraint;
  update_columns?: Array<Session_Overlap_Results_Update_Column>;
  where?: InputMaybe<Session_Overlap_Results_Bool_Exp>;
};

/** Ordering options when selecting data from "session_overlap_results". */
export type Session_Overlap_Results_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_sessions_per_span?: InputMaybe<Order_By>;
  min_sessions_per_span?: InputMaybe<Order_By>;
  num_meters_analyzed?: InputMaybe<Order_By>;
  num_non_overlapping_sessions?: InputMaybe<Order_By>;
  num_overlapping_sessions?: InputMaybe<Order_By>;
  num_sessions_analyzed?: InputMaybe<Order_By>;
  parkable?: InputMaybe<Parkables_Order_By>;
  parkable_id?: InputMaybe<Order_By>;
  set_key?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  total_money_gained?: InputMaybe<Order_By>;
  total_money_with_overlap?: InputMaybe<Order_By>;
  total_money_without_overlap?: InputMaybe<Order_By>;
  total_time_gained?: InputMaybe<Order_By>;
  total_time_with_overlap?: InputMaybe<Order_By>;
  total_time_without_overlap?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: session_overlap_results */
export type Session_Overlap_Results_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "session_overlap_results" */
export enum Session_Overlap_Results_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  MaxSessionsPerSpan = 'max_sessions_per_span',
  /** column name */
  MinSessionsPerSpan = 'min_sessions_per_span',
  /** column name */
  NumMetersAnalyzed = 'num_meters_analyzed',
  /** column name */
  NumNonOverlappingSessions = 'num_non_overlapping_sessions',
  /** column name */
  NumOverlappingSessions = 'num_overlapping_sessions',
  /** column name */
  NumSessionsAnalyzed = 'num_sessions_analyzed',
  /** column name */
  ParkableId = 'parkable_id',
  /** column name */
  SetKey = 'set_key',
  /** column name */
  Start = 'start',
  /** column name */
  TotalMoneyGained = 'total_money_gained',
  /** column name */
  TotalMoneyWithOverlap = 'total_money_with_overlap',
  /** column name */
  TotalMoneyWithoutOverlap = 'total_money_without_overlap',
  /** column name */
  TotalTimeGained = 'total_time_gained',
  /** column name */
  TotalTimeWithOverlap = 'total_time_with_overlap',
  /** column name */
  TotalTimeWithoutOverlap = 'total_time_without_overlap',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "session_overlap_results" */
export type Session_Overlap_Results_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  max_sessions_per_span?: InputMaybe<Scalars['bigint']['input']>;
  min_sessions_per_span?: InputMaybe<Scalars['bigint']['input']>;
  num_meters_analyzed?: InputMaybe<Scalars['bigint']['input']>;
  num_non_overlapping_sessions?: InputMaybe<Scalars['bigint']['input']>;
  num_overlapping_sessions?: InputMaybe<Scalars['bigint']['input']>;
  num_sessions_analyzed?: InputMaybe<Scalars['bigint']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  set_key?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  total_money_gained?: InputMaybe<Scalars['bigint']['input']>;
  total_money_with_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_money_without_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_time_gained?: InputMaybe<Scalars['bigint']['input']>;
  total_time_with_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_time_without_overlap?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Session_Overlap_Results_Stddev_Fields = {
  __typename?: 'session_overlap_results_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  min_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  num_meters_analyzed?: Maybe<Scalars['Float']['output']>;
  num_non_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_sessions_analyzed?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  total_money_gained?: Maybe<Scalars['Float']['output']>;
  total_money_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_money_without_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_gained?: Maybe<Scalars['Float']['output']>;
  total_time_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_without_overlap?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Session_Overlap_Results_Stddev_Pop_Fields = {
  __typename?: 'session_overlap_results_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  min_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  num_meters_analyzed?: Maybe<Scalars['Float']['output']>;
  num_non_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_sessions_analyzed?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  total_money_gained?: Maybe<Scalars['Float']['output']>;
  total_money_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_money_without_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_gained?: Maybe<Scalars['Float']['output']>;
  total_time_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_without_overlap?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Session_Overlap_Results_Stddev_Samp_Fields = {
  __typename?: 'session_overlap_results_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  min_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  num_meters_analyzed?: Maybe<Scalars['Float']['output']>;
  num_non_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_sessions_analyzed?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  total_money_gained?: Maybe<Scalars['Float']['output']>;
  total_money_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_money_without_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_gained?: Maybe<Scalars['Float']['output']>;
  total_time_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_without_overlap?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "session_overlap_results" */
export type Session_Overlap_Results_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Session_Overlap_Results_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Session_Overlap_Results_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  max_sessions_per_span?: InputMaybe<Scalars['bigint']['input']>;
  min_sessions_per_span?: InputMaybe<Scalars['bigint']['input']>;
  num_meters_analyzed?: InputMaybe<Scalars['bigint']['input']>;
  num_non_overlapping_sessions?: InputMaybe<Scalars['bigint']['input']>;
  num_overlapping_sessions?: InputMaybe<Scalars['bigint']['input']>;
  num_sessions_analyzed?: InputMaybe<Scalars['bigint']['input']>;
  parkable_id?: InputMaybe<Scalars['bigint']['input']>;
  set_key?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  total_money_gained?: InputMaybe<Scalars['bigint']['input']>;
  total_money_with_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_money_without_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_time_gained?: InputMaybe<Scalars['bigint']['input']>;
  total_time_with_overlap?: InputMaybe<Scalars['bigint']['input']>;
  total_time_without_overlap?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Session_Overlap_Results_Sum_Fields = {
  __typename?: 'session_overlap_results_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  max_sessions_per_span?: Maybe<Scalars['bigint']['output']>;
  min_sessions_per_span?: Maybe<Scalars['bigint']['output']>;
  num_meters_analyzed?: Maybe<Scalars['bigint']['output']>;
  num_non_overlapping_sessions?: Maybe<Scalars['bigint']['output']>;
  num_overlapping_sessions?: Maybe<Scalars['bigint']['output']>;
  num_sessions_analyzed?: Maybe<Scalars['bigint']['output']>;
  parkable_id?: Maybe<Scalars['bigint']['output']>;
  total_money_gained?: Maybe<Scalars['bigint']['output']>;
  total_money_with_overlap?: Maybe<Scalars['bigint']['output']>;
  total_money_without_overlap?: Maybe<Scalars['bigint']['output']>;
  total_time_gained?: Maybe<Scalars['bigint']['output']>;
  total_time_with_overlap?: Maybe<Scalars['bigint']['output']>;
  total_time_without_overlap?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "session_overlap_results" */
export enum Session_Overlap_Results_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  MaxSessionsPerSpan = 'max_sessions_per_span',
  /** column name */
  MinSessionsPerSpan = 'min_sessions_per_span',
  /** column name */
  NumMetersAnalyzed = 'num_meters_analyzed',
  /** column name */
  NumNonOverlappingSessions = 'num_non_overlapping_sessions',
  /** column name */
  NumOverlappingSessions = 'num_overlapping_sessions',
  /** column name */
  NumSessionsAnalyzed = 'num_sessions_analyzed',
  /** column name */
  ParkableId = 'parkable_id',
  /** column name */
  SetKey = 'set_key',
  /** column name */
  Start = 'start',
  /** column name */
  TotalMoneyGained = 'total_money_gained',
  /** column name */
  TotalMoneyWithOverlap = 'total_money_with_overlap',
  /** column name */
  TotalMoneyWithoutOverlap = 'total_money_without_overlap',
  /** column name */
  TotalTimeGained = 'total_time_gained',
  /** column name */
  TotalTimeWithOverlap = 'total_time_with_overlap',
  /** column name */
  TotalTimeWithoutOverlap = 'total_time_without_overlap',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Session_Overlap_Results_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Session_Overlap_Results_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Session_Overlap_Results_Set_Input>;
  /** filter the rows which have to be updated */
  where: Session_Overlap_Results_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Session_Overlap_Results_Var_Pop_Fields = {
  __typename?: 'session_overlap_results_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  min_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  num_meters_analyzed?: Maybe<Scalars['Float']['output']>;
  num_non_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_sessions_analyzed?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  total_money_gained?: Maybe<Scalars['Float']['output']>;
  total_money_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_money_without_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_gained?: Maybe<Scalars['Float']['output']>;
  total_time_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_without_overlap?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Session_Overlap_Results_Var_Samp_Fields = {
  __typename?: 'session_overlap_results_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  min_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  num_meters_analyzed?: Maybe<Scalars['Float']['output']>;
  num_non_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_sessions_analyzed?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  total_money_gained?: Maybe<Scalars['Float']['output']>;
  total_money_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_money_without_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_gained?: Maybe<Scalars['Float']['output']>;
  total_time_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_without_overlap?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Session_Overlap_Results_Variance_Fields = {
  __typename?: 'session_overlap_results_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  min_sessions_per_span?: Maybe<Scalars['Float']['output']>;
  num_meters_analyzed?: Maybe<Scalars['Float']['output']>;
  num_non_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_overlapping_sessions?: Maybe<Scalars['Float']['output']>;
  num_sessions_analyzed?: Maybe<Scalars['Float']['output']>;
  parkable_id?: Maybe<Scalars['Float']['output']>;
  total_money_gained?: Maybe<Scalars['Float']['output']>;
  total_money_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_money_without_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_gained?: Maybe<Scalars['Float']['output']>;
  total_time_with_overlap?: Maybe<Scalars['Float']['output']>;
  total_time_without_overlap?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "ad_campaign_admin_user" */
  ad_campaign_admin_user: Array<Ad_Campaign_Admin_User>;
  /** fetch aggregated fields from the table: "ad_campaign_admin_user" */
  ad_campaign_admin_user_aggregate: Ad_Campaign_Admin_User_Aggregate;
  /** fetch data from the table in a streaming manner: "ad_campaign_admin_user" */
  ad_campaign_admin_user_stream: Array<Ad_Campaign_Admin_User>;
  /** fetch data from the table: "ad_campaign_parking_authority" */
  ad_campaign_parking_authority: Array<Ad_Campaign_Parking_Authority>;
  /** fetch aggregated fields from the table: "ad_campaign_parking_authority" */
  ad_campaign_parking_authority_aggregate: Ad_Campaign_Parking_Authority_Aggregate;
  /** fetch data from the table in a streaming manner: "ad_campaign_parking_authority" */
  ad_campaign_parking_authority_stream: Array<Ad_Campaign_Parking_Authority>;
  /** fetch data from the table: "ad_campaigns" */
  ad_campaigns: Array<Ad_Campaigns>;
  /** fetch aggregated fields from the table: "ad_campaigns" */
  ad_campaigns_aggregate: Ad_Campaigns_Aggregate;
  /** fetch data from the table: "ad_campaigns" using primary key columns */
  ad_campaigns_by_pk?: Maybe<Ad_Campaigns>;
  /** fetch data from the table in a streaming manner: "ad_campaigns" */
  ad_campaigns_stream: Array<Ad_Campaigns>;
  /** An array relationship */
  ad_events: Array<Ad_Events>;
  /** An aggregate relationship */
  ad_events_aggregate: Ad_Events_Aggregate;
  /** fetch data from the table: "ad_events" using primary key columns */
  ad_events_by_pk?: Maybe<Ad_Events>;
  /** fetch data from the table in a streaming manner: "ad_events" */
  ad_events_stream: Array<Ad_Events>;
  /** An array relationship */
  ad_variants: Array<Ad_Variants>;
  /** An aggregate relationship */
  ad_variants_aggregate: Ad_Variants_Aggregate;
  /** fetch data from the table: "ad_variants" using primary key columns */
  ad_variants_by_pk?: Maybe<Ad_Variants>;
  /** fetch data from the table in a streaming manner: "ad_variants" */
  ad_variants_stream: Array<Ad_Variants>;
  /** fetch data from the table: "admin_user_parking_authority" */
  admin_user_parking_authority: Array<Admin_User_Parking_Authority>;
  /** fetch aggregated fields from the table: "admin_user_parking_authority" */
  admin_user_parking_authority_aggregate: Admin_User_Parking_Authority_Aggregate;
  /** fetch data from the table in a streaming manner: "admin_user_parking_authority" */
  admin_user_parking_authority_stream: Array<Admin_User_Parking_Authority>;
  /** fetch data from the table: "admin_users" */
  admin_users: Array<Admin_Users>;
  /** fetch aggregated fields from the table: "admin_users" */
  admin_users_aggregate: Admin_Users_Aggregate;
  /** fetch data from the table: "admin_users" using primary key columns */
  admin_users_by_pk?: Maybe<Admin_Users>;
  /** fetch data from the table in a streaming manner: "admin_users" */
  admin_users_stream: Array<Admin_Users>;
  /** An array relationship */
  ads: Array<Ads>;
  /** An aggregate relationship */
  ads_aggregate: Ads_Aggregate;
  /** fetch data from the table: "ads" using primary key columns */
  ads_by_pk?: Maybe<Ads>;
  /** fetch data from the table in a streaming manner: "ads" */
  ads_stream: Array<Ads>;
  /** fetch data from the table: "batch_sets" */
  batch_sets: Array<Batch_Sets>;
  /** fetch aggregated fields from the table: "batch_sets" */
  batch_sets_aggregate: Batch_Sets_Aggregate;
  /** fetch data from the table: "batch_sets" using primary key columns */
  batch_sets_by_pk?: Maybe<Batch_Sets>;
  /** fetch data from the table in a streaming manner: "batch_sets" */
  batch_sets_stream: Array<Batch_Sets>;
  /** An array relationship */
  blacklisted_credentials: Array<Blacklisted_Credentials>;
  /** An aggregate relationship */
  blacklisted_credentials_aggregate: Blacklisted_Credentials_Aggregate;
  /** fetch data from the table: "blacklisted_credentials" using primary key columns */
  blacklisted_credentials_by_pk?: Maybe<Blacklisted_Credentials>;
  /** fetch data from the table in a streaming manner: "blacklisted_credentials" */
  blacklisted_credentials_stream: Array<Blacklisted_Credentials>;
  /** fetch data from the table: "device_user" */
  device_user: Array<Device_User>;
  /** fetch aggregated fields from the table: "device_user" */
  device_user_aggregate: Device_User_Aggregate;
  /** fetch data from the table: "device_user" using primary key columns */
  device_user_by_pk?: Maybe<Device_User>;
  /** fetch data from the table in a streaming manner: "device_user" */
  device_user_stream: Array<Device_User>;
  /** fetch data from the table: "devices" */
  devices: Array<Devices>;
  /** fetch aggregated fields from the table: "devices" */
  devices_aggregate: Devices_Aggregate;
  /** fetch data from the table: "devices" using primary key columns */
  devices_by_pk?: Maybe<Devices>;
  /** fetch data from the table in a streaming manner: "devices" */
  devices_stream: Array<Devices>;
  /** fetch data from the table: "events" */
  events: Array<Events>;
  /** fetch aggregated fields from the table: "events" */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** fetch data from the table in a streaming manner: "events" */
  events_stream: Array<Events>;
  /** fetch data from the table: "failed_jobs" */
  failed_jobs: Array<Failed_Jobs>;
  /** fetch aggregated fields from the table: "failed_jobs" */
  failed_jobs_aggregate: Failed_Jobs_Aggregate;
  /** fetch data from the table: "failed_jobs" using primary key columns */
  failed_jobs_by_pk?: Maybe<Failed_Jobs>;
  /** fetch data from the table in a streaming manner: "failed_jobs" */
  failed_jobs_stream: Array<Failed_Jobs>;
  /** fetch data from the table: "failed_sentry_messages" */
  failed_sentry_messages: Array<Failed_Sentry_Messages>;
  /** fetch aggregated fields from the table: "failed_sentry_messages" */
  failed_sentry_messages_aggregate: Failed_Sentry_Messages_Aggregate;
  /** fetch data from the table: "failed_sentry_messages" using primary key columns */
  failed_sentry_messages_by_pk?: Maybe<Failed_Sentry_Messages>;
  /** fetch data from the table in a streaming manner: "failed_sentry_messages" */
  failed_sentry_messages_stream: Array<Failed_Sentry_Messages>;
  /** An array relationship */
  identities: Array<Identities>;
  /** An aggregate relationship */
  identities_aggregate: Identities_Aggregate;
  /** fetch data from the table: "identities" using primary key columns */
  identities_by_pk?: Maybe<Identities>;
  /** fetch data from the table in a streaming manner: "identities" */
  identities_stream: Array<Identities>;
  /** fetch data from the table: "invoice_parkable_transaction" */
  invoice_parkable_transaction: Array<Invoice_Parkable_Transaction>;
  /** fetch aggregated fields from the table: "invoice_parkable_transaction" */
  invoice_parkable_transaction_aggregate: Invoice_Parkable_Transaction_Aggregate;
  /** fetch data from the table: "invoice_parkable_transaction" using primary key columns */
  invoice_parkable_transaction_by_pk?: Maybe<Invoice_Parkable_Transaction>;
  /** fetch data from the table in a streaming manner: "invoice_parkable_transaction" */
  invoice_parkable_transaction_stream: Array<Invoice_Parkable_Transaction>;
  /** fetch data from the table: "invoice_wallet_transaction" */
  invoice_wallet_transaction: Array<Invoice_Wallet_Transaction>;
  /** fetch aggregated fields from the table: "invoice_wallet_transaction" */
  invoice_wallet_transaction_aggregate: Invoice_Wallet_Transaction_Aggregate;
  /** fetch data from the table: "invoice_wallet_transaction" using primary key columns */
  invoice_wallet_transaction_by_pk?: Maybe<Invoice_Wallet_Transaction>;
  /** fetch data from the table in a streaming manner: "invoice_wallet_transaction" */
  invoice_wallet_transaction_stream: Array<Invoice_Wallet_Transaction>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table in a streaming manner: "invoices" */
  invoices_stream: Array<Invoices>;
  /** fetch data from the table: "jobs" */
  jobs: Array<Jobs>;
  /** fetch aggregated fields from the table: "jobs" */
  jobs_aggregate: Jobs_Aggregate;
  /** fetch data from the table: "jobs" using primary key columns */
  jobs_by_pk?: Maybe<Jobs>;
  /** fetch data from the table in a streaming manner: "jobs" */
  jobs_stream: Array<Jobs>;
  /** An array relationship */
  legacy_migrations: Array<Legacy_Migrations>;
  /** An aggregate relationship */
  legacy_migrations_aggregate: Legacy_Migrations_Aggregate;
  /** fetch data from the table: "legacy_migrations" using primary key columns */
  legacy_migrations_by_pk?: Maybe<Legacy_Migrations>;
  /** fetch data from the table in a streaming manner: "legacy_migrations" */
  legacy_migrations_stream: Array<Legacy_Migrations>;
  /** fetch data from the table: "legacy_parkable_transactions" */
  legacy_parkable_transactions: Array<Legacy_Parkable_Transactions>;
  /** fetch aggregated fields from the table: "legacy_parkable_transactions" */
  legacy_parkable_transactions_aggregate: Legacy_Parkable_Transactions_Aggregate;
  /** fetch data from the table in a streaming manner: "legacy_parkable_transactions" */
  legacy_parkable_transactions_stream: Array<Legacy_Parkable_Transactions>;
  /** fetch data from the table: "legacy_payments" */
  legacy_payments: Array<Legacy_Payments>;
  /** fetch aggregated fields from the table: "legacy_payments" */
  legacy_payments_aggregate: Legacy_Payments_Aggregate;
  /** fetch data from the table in a streaming manner: "legacy_payments" */
  legacy_payments_stream: Array<Legacy_Payments>;
  /** fetch data from the table: "legacy_wallet_transactions" */
  legacy_wallet_transactions: Array<Legacy_Wallet_Transactions>;
  /** fetch aggregated fields from the table: "legacy_wallet_transactions" */
  legacy_wallet_transactions_aggregate: Legacy_Wallet_Transactions_Aggregate;
  /** fetch data from the table in a streaming manner: "legacy_wallet_transactions" */
  legacy_wallet_transactions_stream: Array<Legacy_Wallet_Transactions>;
  /** fetch data from the table: "line_item_parkable_transaction" */
  line_item_parkable_transaction: Array<Line_Item_Parkable_Transaction>;
  /** fetch aggregated fields from the table: "line_item_parkable_transaction" */
  line_item_parkable_transaction_aggregate: Line_Item_Parkable_Transaction_Aggregate;
  /** fetch data from the table in a streaming manner: "line_item_parkable_transaction" */
  line_item_parkable_transaction_stream: Array<Line_Item_Parkable_Transaction>;
  /** fetch data from the table: "line_item_payment" */
  line_item_payment: Array<Line_Item_Payment>;
  /** fetch aggregated fields from the table: "line_item_payment" */
  line_item_payment_aggregate: Line_Item_Payment_Aggregate;
  /** fetch data from the table: "line_item_payment" using primary key columns */
  line_item_payment_by_pk?: Maybe<Line_Item_Payment>;
  /** fetch data from the table in a streaming manner: "line_item_payment" */
  line_item_payment_stream: Array<Line_Item_Payment>;
  /** fetch data from the table: "line_item_wallet_transaction" */
  line_item_wallet_transaction: Array<Line_Item_Wallet_Transaction>;
  /** fetch aggregated fields from the table: "line_item_wallet_transaction" */
  line_item_wallet_transaction_aggregate: Line_Item_Wallet_Transaction_Aggregate;
  /** fetch data from the table: "line_item_wallet_transaction" using primary key columns */
  line_item_wallet_transaction_by_pk?: Maybe<Line_Item_Wallet_Transaction>;
  /** fetch data from the table in a streaming manner: "line_item_wallet_transaction" */
  line_item_wallet_transaction_stream: Array<Line_Item_Wallet_Transaction>;
  /** An array relationship */
  line_items: Array<Line_Items>;
  /** An aggregate relationship */
  line_items_aggregate: Line_Items_Aggregate;
  /** fetch data from the table: "line_items" using primary key columns */
  line_items_by_pk?: Maybe<Line_Items>;
  /** fetch data from the table in a streaming manner: "line_items" */
  line_items_stream: Array<Line_Items>;
  /** fetch data from the table: "login_codes" */
  login_codes: Array<Login_Codes>;
  /** fetch aggregated fields from the table: "login_codes" */
  login_codes_aggregate: Login_Codes_Aggregate;
  /** fetch data from the table: "login_codes" using primary key columns */
  login_codes_by_pk?: Maybe<Login_Codes>;
  /** fetch data from the table in a streaming manner: "login_codes" */
  login_codes_stream: Array<Login_Codes>;
  /** fetch data from the table: "migrations" */
  migrations: Array<Migrations>;
  /** fetch aggregated fields from the table: "migrations" */
  migrations_aggregate: Migrations_Aggregate;
  /** fetch data from the table: "migrations" using primary key columns */
  migrations_by_pk?: Maybe<Migrations>;
  /** fetch data from the table in a streaming manner: "migrations" */
  migrations_stream: Array<Migrations>;
  /** fetch data from the table: "mx_merchant_pa_bank_account_metas" */
  mx_merchant_pa_bank_account_metas: Array<Mx_Merchant_Pa_Bank_Account_Metas>;
  /** fetch aggregated fields from the table: "mx_merchant_pa_bank_account_metas" */
  mx_merchant_pa_bank_account_metas_aggregate: Mx_Merchant_Pa_Bank_Account_Metas_Aggregate;
  /** fetch data from the table: "mx_merchant_pa_bank_account_metas" using primary key columns */
  mx_merchant_pa_bank_account_metas_by_pk?: Maybe<Mx_Merchant_Pa_Bank_Account_Metas>;
  /** fetch data from the table in a streaming manner: "mx_merchant_pa_bank_account_metas" */
  mx_merchant_pa_bank_account_metas_stream: Array<Mx_Merchant_Pa_Bank_Account_Metas>;
  /** fetch data from the table: "mx_merchant_payment_batch_metas" */
  mx_merchant_payment_batch_metas: Array<Mx_Merchant_Payment_Batch_Metas>;
  /** fetch aggregated fields from the table: "mx_merchant_payment_batch_metas" */
  mx_merchant_payment_batch_metas_aggregate: Mx_Merchant_Payment_Batch_Metas_Aggregate;
  /** fetch data from the table: "mx_merchant_payment_batch_metas" using primary key columns */
  mx_merchant_payment_batch_metas_by_pk?: Maybe<Mx_Merchant_Payment_Batch_Metas>;
  /** fetch data from the table in a streaming manner: "mx_merchant_payment_batch_metas" */
  mx_merchant_payment_batch_metas_stream: Array<Mx_Merchant_Payment_Batch_Metas>;
  /** An array relationship */
  mx_merchant_payment_metas: Array<Mx_Merchant_Payment_Metas>;
  /** An aggregate relationship */
  mx_merchant_payment_metas_aggregate: Mx_Merchant_Payment_Metas_Aggregate;
  /** fetch data from the table: "mx_merchant_payment_metas" using primary key columns */
  mx_merchant_payment_metas_by_pk?: Maybe<Mx_Merchant_Payment_Metas>;
  /** fetch data from the table in a streaming manner: "mx_merchant_payment_metas" */
  mx_merchant_payment_metas_stream: Array<Mx_Merchant_Payment_Metas>;
  /** An array relationship */
  mx_merchant_payment_method_metas: Array<Mx_Merchant_Payment_Method_Metas>;
  /** An aggregate relationship */
  mx_merchant_payment_method_metas_aggregate: Mx_Merchant_Payment_Method_Metas_Aggregate;
  /** fetch data from the table: "mx_merchant_payment_method_metas" using primary key columns */
  mx_merchant_payment_method_metas_by_pk?: Maybe<Mx_Merchant_Payment_Method_Metas>;
  /** fetch data from the table in a streaming manner: "mx_merchant_payment_method_metas" */
  mx_merchant_payment_method_metas_stream: Array<Mx_Merchant_Payment_Method_Metas>;
  /** fetch data from the table: "parkable_group_parkable_schedule" */
  parkable_group_parkable_schedule: Array<Parkable_Group_Parkable_Schedule>;
  /** fetch aggregated fields from the table: "parkable_group_parkable_schedule" */
  parkable_group_parkable_schedule_aggregate: Parkable_Group_Parkable_Schedule_Aggregate;
  /** fetch data from the table: "parkable_group_parkable_schedule" using primary key columns */
  parkable_group_parkable_schedule_by_pk?: Maybe<Parkable_Group_Parkable_Schedule>;
  /** fetch data from the table in a streaming manner: "parkable_group_parkable_schedule" */
  parkable_group_parkable_schedule_stream: Array<Parkable_Group_Parkable_Schedule>;
  /** An array relationship */
  parkable_groups: Array<Parkable_Groups>;
  /** An aggregate relationship */
  parkable_groups_aggregate: Parkable_Groups_Aggregate;
  /** fetch data from the table: "parkable_groups" using primary key columns */
  parkable_groups_by_pk?: Maybe<Parkable_Groups>;
  /** fetch data from the table in a streaming manner: "parkable_groups" */
  parkable_groups_stream: Array<Parkable_Groups>;
  /** fetch data from the table: "parkable_parkable_group" */
  parkable_parkable_group: Array<Parkable_Parkable_Group>;
  /** fetch aggregated fields from the table: "parkable_parkable_group" */
  parkable_parkable_group_aggregate: Parkable_Parkable_Group_Aggregate;
  /** fetch data from the table: "parkable_parkable_group" using primary key columns */
  parkable_parkable_group_by_pk?: Maybe<Parkable_Parkable_Group>;
  /** fetch data from the table in a streaming manner: "parkable_parkable_group" */
  parkable_parkable_group_stream: Array<Parkable_Parkable_Group>;
  /** fetch data from the table: "parkable_qr_code" */
  parkable_qr_code: Array<Parkable_Qr_Code>;
  /** fetch aggregated fields from the table: "parkable_qr_code" */
  parkable_qr_code_aggregate: Parkable_Qr_Code_Aggregate;
  /** fetch data from the table in a streaming manner: "parkable_qr_code" */
  parkable_qr_code_stream: Array<Parkable_Qr_Code>;
  /** An array relationship */
  parkable_schedules: Array<Parkable_Schedules>;
  /** An aggregate relationship */
  parkable_schedules_aggregate: Parkable_Schedules_Aggregate;
  /** fetch data from the table: "parkable_schedules" using primary key columns */
  parkable_schedules_by_pk?: Maybe<Parkable_Schedules>;
  /** fetch data from the table in a streaming manner: "parkable_schedules" */
  parkable_schedules_stream: Array<Parkable_Schedules>;
  /** fetch data from the table: "parkable_transaction_task" */
  parkable_transaction_task: Array<Parkable_Transaction_Task>;
  /** fetch aggregated fields from the table: "parkable_transaction_task" */
  parkable_transaction_task_aggregate: Parkable_Transaction_Task_Aggregate;
  /** fetch data from the table: "parkable_transaction_task" using primary key columns */
  parkable_transaction_task_by_pk?: Maybe<Parkable_Transaction_Task>;
  /** fetch data from the table in a streaming manner: "parkable_transaction_task" */
  parkable_transaction_task_stream: Array<Parkable_Transaction_Task>;
  /** fetch data from the table: "parkable_transaction_wallet_transaction" */
  parkable_transaction_wallet_transaction: Array<Parkable_Transaction_Wallet_Transaction>;
  /** fetch aggregated fields from the table: "parkable_transaction_wallet_transaction" */
  parkable_transaction_wallet_transaction_aggregate: Parkable_Transaction_Wallet_Transaction_Aggregate;
  /** fetch data from the table: "parkable_transaction_wallet_transaction" using primary key columns */
  parkable_transaction_wallet_transaction_by_pk?: Maybe<Parkable_Transaction_Wallet_Transaction>;
  /** fetch data from the table in a streaming manner: "parkable_transaction_wallet_transaction" */
  parkable_transaction_wallet_transaction_stream: Array<Parkable_Transaction_Wallet_Transaction>;
  /** An array relationship */
  parkable_transactions: Array<Parkable_Transactions>;
  /** An aggregate relationship */
  parkable_transactions_aggregate: Parkable_Transactions_Aggregate;
  /** fetch data from the table: "parkable_transactions" using primary key columns */
  parkable_transactions_by_pk?: Maybe<Parkable_Transactions>;
  /** fetch data from the table in a streaming manner: "parkable_transactions" */
  parkable_transactions_stream: Array<Parkable_Transactions>;
  /** An array relationship */
  parkables: Array<Parkables>;
  /** An aggregate relationship */
  parkables_aggregate: Parkables_Aggregate;
  /** fetch data from the table: "parkables" using primary key columns */
  parkables_by_pk?: Maybe<Parkables>;
  /** fetch data from the table in a streaming manner: "parkables" */
  parkables_stream: Array<Parkables>;
  /** fetch data from the table: "parking_authorities" */
  parking_authorities: Array<Parking_Authorities>;
  /** fetch aggregated fields from the table: "parking_authorities" */
  parking_authorities_aggregate: Parking_Authorities_Aggregate;
  /** fetch data from the table: "parking_authorities" using primary key columns */
  parking_authorities_by_pk?: Maybe<Parking_Authorities>;
  /** fetch data from the table in a streaming manner: "parking_authorities" */
  parking_authorities_stream: Array<Parking_Authorities>;
  /** An array relationship */
  parking_authority_bank_accounts: Array<Parking_Authority_Bank_Accounts>;
  /** An aggregate relationship */
  parking_authority_bank_accounts_aggregate: Parking_Authority_Bank_Accounts_Aggregate;
  /** fetch data from the table: "parking_authority_bank_accounts" using primary key columns */
  parking_authority_bank_accounts_by_pk?: Maybe<Parking_Authority_Bank_Accounts>;
  /** fetch data from the table in a streaming manner: "parking_authority_bank_accounts" */
  parking_authority_bank_accounts_stream: Array<Parking_Authority_Bank_Accounts>;
  /** An array relationship */
  parking_authority_settings: Array<Parking_Authority_Settings>;
  /** An aggregate relationship */
  parking_authority_settings_aggregate: Parking_Authority_Settings_Aggregate;
  /** fetch data from the table: "parking_authority_settings" using primary key columns */
  parking_authority_settings_by_pk?: Maybe<Parking_Authority_Settings>;
  /** fetch data from the table in a streaming manner: "parking_authority_settings" */
  parking_authority_settings_stream: Array<Parking_Authority_Settings>;
  /** fetch data from the table: "parking_authority_user" */
  parking_authority_user: Array<Parking_Authority_User>;
  /** fetch aggregated fields from the table: "parking_authority_user" */
  parking_authority_user_aggregate: Parking_Authority_User_Aggregate;
  /** fetch data from the table: "parking_authority_user" using primary key columns */
  parking_authority_user_by_pk?: Maybe<Parking_Authority_User>;
  /** fetch data from the table in a streaming manner: "parking_authority_user" */
  parking_authority_user_stream: Array<Parking_Authority_User>;
  /** An array relationship */
  payment_batches: Array<Payment_Batches>;
  /** An aggregate relationship */
  payment_batches_aggregate: Payment_Batches_Aggregate;
  /** fetch data from the table: "payment_batches" using primary key columns */
  payment_batches_by_pk?: Maybe<Payment_Batches>;
  /** fetch data from the table in a streaming manner: "payment_batches" */
  payment_batches_stream: Array<Payment_Batches>;
  /** An array relationship */
  payment_methods: Array<Payment_Methods>;
  /** An aggregate relationship */
  payment_methods_aggregate: Payment_Methods_Aggregate;
  /** fetch data from the table: "payment_methods" using primary key columns */
  payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** fetch data from the table in a streaming manner: "payment_methods" */
  payment_methods_stream: Array<Payment_Methods>;
  /** fetch data from the table: "payment_wallet_transaction" */
  payment_wallet_transaction: Array<Payment_Wallet_Transaction>;
  /** fetch aggregated fields from the table: "payment_wallet_transaction" */
  payment_wallet_transaction_aggregate: Payment_Wallet_Transaction_Aggregate;
  /** fetch data from the table: "payment_wallet_transaction" using primary key columns */
  payment_wallet_transaction_by_pk?: Maybe<Payment_Wallet_Transaction>;
  /** fetch data from the table in a streaming manner: "payment_wallet_transaction" */
  payment_wallet_transaction_stream: Array<Payment_Wallet_Transaction>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** fetch data from the table in a streaming manner: "payments" */
  payments_stream: Array<Payments>;
  /** fetch data from the table: "pending_users" */
  pending_users: Array<Pending_Users>;
  /** fetch aggregated fields from the table: "pending_users" */
  pending_users_aggregate: Pending_Users_Aggregate;
  /** fetch data from the table: "pending_users" using primary key columns */
  pending_users_by_pk?: Maybe<Pending_Users>;
  /** fetch data from the table in a streaming manner: "pending_users" */
  pending_users_stream: Array<Pending_Users>;
  /** fetch data from the table: "personal_access_tokens" */
  personal_access_tokens: Array<Personal_Access_Tokens>;
  /** fetch aggregated fields from the table: "personal_access_tokens" */
  personal_access_tokens_aggregate: Personal_Access_Tokens_Aggregate;
  /** fetch data from the table: "personal_access_tokens" using primary key columns */
  personal_access_tokens_by_pk?: Maybe<Personal_Access_Tokens>;
  /** fetch data from the table in a streaming manner: "personal_access_tokens" */
  personal_access_tokens_stream: Array<Personal_Access_Tokens>;
  /** fetch data from the table: "public_keys" */
  public_keys: Array<Public_Keys>;
  /** fetch aggregated fields from the table: "public_keys" */
  public_keys_aggregate: Public_Keys_Aggregate;
  /** fetch data from the table in a streaming manner: "public_keys" */
  public_keys_stream: Array<Public_Keys>;
  /** fetch data from the table: "qr_codes" */
  qr_codes: Array<Qr_Codes>;
  /** fetch aggregated fields from the table: "qr_codes" */
  qr_codes_aggregate: Qr_Codes_Aggregate;
  /** fetch data from the table: "qr_codes" using primary key columns */
  qr_codes_by_pk?: Maybe<Qr_Codes>;
  /** fetch data from the table in a streaming manner: "qr_codes" */
  qr_codes_stream: Array<Qr_Codes>;
  /** fetch data from the table: "r_line_item_payments" */
  r_line_item_payments: Array<R_Line_Item_Payments>;
  /** fetch aggregated fields from the table: "r_line_item_payments" */
  r_line_item_payments_aggregate: R_Line_Item_Payments_Aggregate;
  /** fetch data from the table: "r_line_item_payments" using primary key columns */
  r_line_item_payments_by_pk?: Maybe<R_Line_Item_Payments>;
  /** fetch data from the table in a streaming manner: "r_line_item_payments" */
  r_line_item_payments_stream: Array<R_Line_Item_Payments>;
  /** fetch data from the table: "r_parkable_transactions" */
  r_parkable_transactions: Array<R_Parkable_Transactions>;
  /** fetch aggregated fields from the table: "r_parkable_transactions" */
  r_parkable_transactions_aggregate: R_Parkable_Transactions_Aggregate;
  /** fetch data from the table: "r_parkable_transactions" using primary key columns */
  r_parkable_transactions_by_pk?: Maybe<R_Parkable_Transactions>;
  /** fetch data from the table in a streaming manner: "r_parkable_transactions" */
  r_parkable_transactions_stream: Array<R_Parkable_Transactions>;
  /** fetch data from the table: "r_parking_authorities" */
  r_parking_authorities: Array<R_Parking_Authorities>;
  /** fetch aggregated fields from the table: "r_parking_authorities" */
  r_parking_authorities_aggregate: R_Parking_Authorities_Aggregate;
  /** fetch data from the table: "r_parking_authorities" using primary key columns */
  r_parking_authorities_by_pk?: Maybe<R_Parking_Authorities>;
  /** fetch data from the table in a streaming manner: "r_parking_authorities" */
  r_parking_authorities_stream: Array<R_Parking_Authorities>;
  /** fetch data from the table: "r_payment_batches" */
  r_payment_batches: Array<R_Payment_Batches>;
  /** fetch aggregated fields from the table: "r_payment_batches" */
  r_payment_batches_aggregate: R_Payment_Batches_Aggregate;
  /** fetch data from the table: "r_payment_batches" using primary key columns */
  r_payment_batches_by_pk?: Maybe<R_Payment_Batches>;
  /** fetch data from the table in a streaming manner: "r_payment_batches" */
  r_payment_batches_stream: Array<R_Payment_Batches>;
  /** fetch data from the table: "r_transfer_batches" */
  r_transfer_batches: Array<R_Transfer_Batches>;
  /** fetch aggregated fields from the table: "r_transfer_batches" */
  r_transfer_batches_aggregate: R_Transfer_Batches_Aggregate;
  /** fetch data from the table: "r_transfer_batches" using primary key columns */
  r_transfer_batches_by_pk?: Maybe<R_Transfer_Batches>;
  /** fetch data from the table in a streaming manner: "r_transfer_batches" */
  r_transfer_batches_stream: Array<R_Transfer_Batches>;
  /** fetch data from the table: "r_users" */
  r_users: Array<R_Users>;
  /** fetch aggregated fields from the table: "r_users" */
  r_users_aggregate: R_Users_Aggregate;
  /** fetch data from the table: "r_users" using primary key columns */
  r_users_by_pk?: Maybe<R_Users>;
  /** fetch data from the table in a streaming manner: "r_users" */
  r_users_stream: Array<R_Users>;
  /** An array relationship */
  reports: Array<Reports>;
  /** An aggregate relationship */
  reports_aggregate: Reports_Aggregate;
  /** fetch data from the table: "reports" using primary key columns */
  reports_by_pk?: Maybe<Reports>;
  /** fetch data from the table in a streaming manner: "reports" */
  reports_stream: Array<Reports>;
  /** fetch data from the table: "session_overlap_results" */
  session_overlap_results: Array<Session_Overlap_Results>;
  /** fetch aggregated fields from the table: "session_overlap_results" */
  session_overlap_results_aggregate: Session_Overlap_Results_Aggregate;
  /** fetch data from the table: "session_overlap_results" using primary key columns */
  session_overlap_results_by_pk?: Maybe<Session_Overlap_Results>;
  /** fetch data from the table in a streaming manner: "session_overlap_results" */
  session_overlap_results_stream: Array<Session_Overlap_Results>;
  /** An array relationship */
  support_tickets: Array<Support_Tickets>;
  /** An aggregate relationship */
  support_tickets_aggregate: Support_Tickets_Aggregate;
  /** fetch data from the table: "support_tickets" using primary key columns */
  support_tickets_by_pk?: Maybe<Support_Tickets>;
  /** fetch data from the table in a streaming manner: "support_tickets" */
  support_tickets_stream: Array<Support_Tickets>;
  /** An array relationship */
  task_events: Array<Task_Events>;
  /** An aggregate relationship */
  task_events_aggregate: Task_Events_Aggregate;
  /** fetch data from the table: "task_events" using primary key columns */
  task_events_by_pk?: Maybe<Task_Events>;
  /** fetch data from the table in a streaming manner: "task_events" */
  task_events_stream: Array<Task_Events>;
  /** An array relationship */
  task_states: Array<Task_States>;
  /** An aggregate relationship */
  task_states_aggregate: Task_States_Aggregate;
  /** fetch data from the table: "task_states" using primary key columns */
  task_states_by_pk?: Maybe<Task_States>;
  /** fetch data from the table in a streaming manner: "task_states" */
  task_states_stream: Array<Task_States>;
  /** fetch data from the table: "task_user" */
  task_user: Array<Task_User>;
  /** fetch aggregated fields from the table: "task_user" */
  task_user_aggregate: Task_User_Aggregate;
  /** fetch data from the table: "task_user" using primary key columns */
  task_user_by_pk?: Maybe<Task_User>;
  /** fetch data from the table in a streaming manner: "task_user" */
  task_user_stream: Array<Task_User>;
  /** fetch data from the table: "tasks" */
  tasks: Array<Tasks>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: Tasks_Aggregate;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: Maybe<Tasks>;
  /** fetch data from the table in a streaming manner: "tasks" */
  tasks_stream: Array<Tasks>;
  /** An array relationship */
  transfer_batches: Array<Transfer_Batches>;
  /** An aggregate relationship */
  transfer_batches_aggregate: Transfer_Batches_Aggregate;
  /** fetch data from the table: "transfer_batches" using primary key columns */
  transfer_batches_by_pk?: Maybe<Transfer_Batches>;
  /** fetch data from the table in a streaming manner: "transfer_batches" */
  transfer_batches_stream: Array<Transfer_Batches>;
  /** An array relationship */
  user_activities: Array<User_Activities>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activities_Aggregate;
  /** fetch data from the table: "user_activities" using primary key columns */
  user_activities_by_pk?: Maybe<User_Activities>;
  /** fetch data from the table in a streaming manner: "user_activities" */
  user_activities_stream: Array<User_Activities>;
  /** fetch data from the table: "user_lists" */
  user_lists: Array<User_Lists>;
  /** fetch aggregated fields from the table: "user_lists" */
  user_lists_aggregate: User_Lists_Aggregate;
  /** fetch data from the table: "user_lists" using primary key columns */
  user_lists_by_pk?: Maybe<User_Lists>;
  /** fetch data from the table in a streaming manner: "user_lists" */
  user_lists_stream: Array<User_Lists>;
  /** An array relationship */
  user_settings: Array<User_Settings>;
  /** An aggregate relationship */
  user_settings_aggregate: User_Settings_Aggregate;
  /** fetch data from the table: "user_settings_all" */
  user_settings_all: Array<User_Settings_All>;
  /** fetch aggregated fields from the table: "user_settings_all" */
  user_settings_all_aggregate: User_Settings_All_Aggregate;
  /** fetch data from the table in a streaming manner: "user_settings_all" */
  user_settings_all_stream: Array<User_Settings_All>;
  /** fetch data from the table: "user_settings" using primary key columns */
  user_settings_by_pk?: Maybe<User_Settings>;
  /** fetch data from the table in a streaming manner: "user_settings" */
  user_settings_stream: Array<User_Settings>;
  /** fetch data from the table: "user_user_list" */
  user_user_list: Array<User_User_List>;
  /** fetch aggregated fields from the table: "user_user_list" */
  user_user_list_aggregate: User_User_List_Aggregate;
  /** fetch data from the table: "user_user_list" using primary key columns */
  user_user_list_by_pk?: Maybe<User_User_List>;
  /** fetch data from the table in a streaming manner: "user_user_list" */
  user_user_list_stream: Array<User_User_List>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** An array relationship */
  vehicles: Array<Vehicles>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicles_Aggregate;
  /** fetch data from the table: "vehicles" using primary key columns */
  vehicles_by_pk?: Maybe<Vehicles>;
  /** fetch data from the table in a streaming manner: "vehicles" */
  vehicles_stream: Array<Vehicles>;
  /** An array relationship */
  wallet_transactions: Array<Wallet_Transactions>;
  /** An aggregate relationship */
  wallet_transactions_aggregate: Wallet_Transactions_Aggregate;
  /** fetch data from the table: "wallet_transactions" using primary key columns */
  wallet_transactions_by_pk?: Maybe<Wallet_Transactions>;
  /** fetch data from the table in a streaming manner: "wallet_transactions" */
  wallet_transactions_stream: Array<Wallet_Transactions>;
  /** An array relationship */
  wallets: Array<Wallets>;
  /** An aggregate relationship */
  wallets_aggregate: Wallets_Aggregate;
  /** fetch data from the table: "wallets" using primary key columns */
  wallets_by_pk?: Maybe<Wallets>;
  /** fetch data from the table in a streaming manner: "wallets" */
  wallets_stream: Array<Wallets>;
};


export type Subscription_RootAd_Campaign_Admin_UserArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Admin_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Admin_User_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
};


export type Subscription_RootAd_Campaign_Admin_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Admin_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Admin_User_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
};


export type Subscription_RootAd_Campaign_Admin_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Campaign_Admin_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Campaign_Admin_User_Bool_Exp>;
};


export type Subscription_RootAd_Campaign_Parking_AuthorityArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
};


export type Subscription_RootAd_Campaign_Parking_Authority_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaign_Parking_Authority_Order_By>>;
  where?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
};


export type Subscription_RootAd_Campaign_Parking_Authority_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Campaign_Parking_Authority_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Campaign_Parking_Authority_Bool_Exp>;
};


export type Subscription_RootAd_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaigns_Order_By>>;
  where?: InputMaybe<Ad_Campaigns_Bool_Exp>;
};


export type Subscription_RootAd_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Campaigns_Order_By>>;
  where?: InputMaybe<Ad_Campaigns_Bool_Exp>;
};


export type Subscription_RootAd_Campaigns_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAd_Campaigns_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Campaigns_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Campaigns_Bool_Exp>;
};


export type Subscription_RootAd_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Events_Order_By>>;
  where?: InputMaybe<Ad_Events_Bool_Exp>;
};


export type Subscription_RootAd_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Events_Order_By>>;
  where?: InputMaybe<Ad_Events_Bool_Exp>;
};


export type Subscription_RootAd_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAd_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Events_Bool_Exp>;
};


export type Subscription_RootAd_VariantsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Variants_Order_By>>;
  where?: InputMaybe<Ad_Variants_Bool_Exp>;
};


export type Subscription_RootAd_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Variants_Order_By>>;
  where?: InputMaybe<Ad_Variants_Bool_Exp>;
};


export type Subscription_RootAd_Variants_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAd_Variants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ad_Variants_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Variants_Bool_Exp>;
};


export type Subscription_RootAdmin_User_Parking_AuthorityArgs = {
  distinct_on?: InputMaybe<Array<Admin_User_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_User_Parking_Authority_Order_By>>;
  where?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
};


export type Subscription_RootAdmin_User_Parking_Authority_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_User_Parking_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_User_Parking_Authority_Order_By>>;
  where?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
};


export type Subscription_RootAdmin_User_Parking_Authority_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_User_Parking_Authority_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_User_Parking_Authority_Bool_Exp>;
};


export type Subscription_RootAdmin_UsersArgs = {
  distinct_on?: InputMaybe<Array<Admin_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Users_Order_By>>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};


export type Subscription_RootAdmin_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Users_Order_By>>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};


export type Subscription_RootAdmin_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAdmin_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Users_Bool_Exp>;
};


export type Subscription_RootAdsArgs = {
  distinct_on?: InputMaybe<Array<Ads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ads_Order_By>>;
  where?: InputMaybe<Ads_Bool_Exp>;
};


export type Subscription_RootAds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ads_Order_By>>;
  where?: InputMaybe<Ads_Bool_Exp>;
};


export type Subscription_RootAds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAds_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ads_Stream_Cursor_Input>>;
  where?: InputMaybe<Ads_Bool_Exp>;
};


export type Subscription_RootBatch_SetsArgs = {
  distinct_on?: InputMaybe<Array<Batch_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Batch_Sets_Order_By>>;
  where?: InputMaybe<Batch_Sets_Bool_Exp>;
};


export type Subscription_RootBatch_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Batch_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Batch_Sets_Order_By>>;
  where?: InputMaybe<Batch_Sets_Bool_Exp>;
};


export type Subscription_RootBatch_Sets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBatch_Sets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Batch_Sets_Stream_Cursor_Input>>;
  where?: InputMaybe<Batch_Sets_Bool_Exp>;
};


export type Subscription_RootBlacklisted_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Blacklisted_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blacklisted_Credentials_Order_By>>;
  where?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
};


export type Subscription_RootBlacklisted_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blacklisted_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blacklisted_Credentials_Order_By>>;
  where?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
};


export type Subscription_RootBlacklisted_Credentials_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBlacklisted_Credentials_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Blacklisted_Credentials_Stream_Cursor_Input>>;
  where?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
};


export type Subscription_RootDevice_UserArgs = {
  distinct_on?: InputMaybe<Array<Device_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_User_Order_By>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


export type Subscription_RootDevice_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_User_Order_By>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


export type Subscription_RootDevice_User_By_PkArgs = {
  device_id: Scalars['bigint']['input'];
  user_id: Scalars['bigint']['input'];
};


export type Subscription_RootDevice_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Device_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


export type Subscription_RootDevicesArgs = {
  distinct_on?: InputMaybe<Array<Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devices_Order_By>>;
  where?: InputMaybe<Devices_Bool_Exp>;
};


export type Subscription_RootDevices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devices_Order_By>>;
  where?: InputMaybe<Devices_Bool_Exp>;
};


export type Subscription_RootDevices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDevices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Devices_Stream_Cursor_Input>>;
  where?: InputMaybe<Devices_Bool_Exp>;
};


export type Subscription_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEvents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootFailed_JobsArgs = {
  distinct_on?: InputMaybe<Array<Failed_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Jobs_Order_By>>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};


export type Subscription_RootFailed_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Failed_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Jobs_Order_By>>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};


export type Subscription_RootFailed_Jobs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFailed_Jobs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Failed_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Failed_Jobs_Bool_Exp>;
};


export type Subscription_RootFailed_Sentry_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Failed_Sentry_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Sentry_Messages_Order_By>>;
  where?: InputMaybe<Failed_Sentry_Messages_Bool_Exp>;
};


export type Subscription_RootFailed_Sentry_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Failed_Sentry_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failed_Sentry_Messages_Order_By>>;
  where?: InputMaybe<Failed_Sentry_Messages_Bool_Exp>;
};


export type Subscription_RootFailed_Sentry_Messages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFailed_Sentry_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Failed_Sentry_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Failed_Sentry_Messages_Bool_Exp>;
};


export type Subscription_RootIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


export type Subscription_RootIdentities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


export type Subscription_RootIdentities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootIdentities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Identities_Stream_Cursor_Input>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


export type Subscription_RootInvoice_Parkable_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};


export type Subscription_RootInvoice_Parkable_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};


export type Subscription_RootInvoice_Parkable_Transaction_By_PkArgs = {
  invoice_id: Scalars['bigint']['input'];
  parkable_transaction_id: Scalars['bigint']['input'];
};


export type Subscription_RootInvoice_Parkable_Transaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoice_Parkable_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Parkable_Transaction_Bool_Exp>;
};


export type Subscription_RootInvoice_Wallet_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootInvoice_Wallet_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootInvoice_Wallet_Transaction_By_PkArgs = {
  invoice_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


export type Subscription_RootInvoice_Wallet_Transaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoice_Wallet_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootInvoices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootInvoices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoices_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootJobsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Subscription_RootJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Subscription_RootJobs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootJobs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Subscription_RootLegacy_MigrationsArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Migrations_Order_By>>;
  where?: InputMaybe<Legacy_Migrations_Bool_Exp>;
};


export type Subscription_RootLegacy_Migrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Migrations_Order_By>>;
  where?: InputMaybe<Legacy_Migrations_Bool_Exp>;
};


export type Subscription_RootLegacy_Migrations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLegacy_Migrations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Legacy_Migrations_Stream_Cursor_Input>>;
  where?: InputMaybe<Legacy_Migrations_Bool_Exp>;
};


export type Subscription_RootLegacy_Parkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Legacy_Parkable_Transactions_Bool_Exp>;
};


export type Subscription_RootLegacy_Parkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Legacy_Parkable_Transactions_Bool_Exp>;
};


export type Subscription_RootLegacy_Parkable_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Legacy_Parkable_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Legacy_Parkable_Transactions_Bool_Exp>;
};


export type Subscription_RootLegacy_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Payments_Order_By>>;
  where?: InputMaybe<Legacy_Payments_Bool_Exp>;
};


export type Subscription_RootLegacy_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Payments_Order_By>>;
  where?: InputMaybe<Legacy_Payments_Bool_Exp>;
};


export type Subscription_RootLegacy_Payments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Legacy_Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Legacy_Payments_Bool_Exp>;
};


export type Subscription_RootLegacy_Wallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Legacy_Wallet_Transactions_Bool_Exp>;
};


export type Subscription_RootLegacy_Wallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Legacy_Wallet_Transactions_Bool_Exp>;
};


export type Subscription_RootLegacy_Wallet_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Legacy_Wallet_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Legacy_Wallet_Transactions_Bool_Exp>;
};


export type Subscription_RootLine_Item_Parkable_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
};


export type Subscription_RootLine_Item_Parkable_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Parkable_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Parkable_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
};


export type Subscription_RootLine_Item_Parkable_Transaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Line_Item_Parkable_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Line_Item_Parkable_Transaction_Bool_Exp>;
};


export type Subscription_RootLine_Item_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Payment_Order_By>>;
  where?: InputMaybe<Line_Item_Payment_Bool_Exp>;
};


export type Subscription_RootLine_Item_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Payment_Order_By>>;
  where?: InputMaybe<Line_Item_Payment_Bool_Exp>;
};


export type Subscription_RootLine_Item_Payment_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLine_Item_Payment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Line_Item_Payment_Stream_Cursor_Input>>;
  where?: InputMaybe<Line_Item_Payment_Bool_Exp>;
};


export type Subscription_RootLine_Item_Wallet_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootLine_Item_Wallet_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootLine_Item_Wallet_Transaction_By_PkArgs = {
  line_item_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


export type Subscription_RootLine_Item_Wallet_Transaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Line_Item_Wallet_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootLine_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Items_Order_By>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};


export type Subscription_RootLine_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Items_Order_By>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};


export type Subscription_RootLine_Items_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLine_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Line_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Line_Items_Bool_Exp>;
};


export type Subscription_RootLogin_CodesArgs = {
  distinct_on?: InputMaybe<Array<Login_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Codes_Order_By>>;
  where?: InputMaybe<Login_Codes_Bool_Exp>;
};


export type Subscription_RootLogin_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Login_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Codes_Order_By>>;
  where?: InputMaybe<Login_Codes_Bool_Exp>;
};


export type Subscription_RootLogin_Codes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLogin_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Login_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Login_Codes_Bool_Exp>;
};


export type Subscription_RootMigrationsArgs = {
  distinct_on?: InputMaybe<Array<Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Migrations_Order_By>>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};


export type Subscription_RootMigrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Migrations_Order_By>>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};


export type Subscription_RootMigrations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootMigrations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Migrations_Stream_Cursor_Input>>;
  where?: InputMaybe<Migrations_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Pa_Bank_Account_MetasArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Pa_Bank_Account_Metas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Pa_Bank_Account_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Pa_Bank_Account_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMx_Merchant_Pa_Bank_Account_Metas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Stream_Cursor_Input>>;
  where?: InputMaybe<Mx_Merchant_Pa_Bank_Account_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Payment_Batch_MetasArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Payment_Batch_Metas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Batch_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Payment_Batch_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMx_Merchant_Payment_Batch_Metas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mx_Merchant_Payment_Batch_Metas_Stream_Cursor_Input>>;
  where?: InputMaybe<Mx_Merchant_Payment_Batch_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Payment_MetasArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Payment_Metas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Payment_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMx_Merchant_Payment_Metas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mx_Merchant_Payment_Metas_Stream_Cursor_Input>>;
  where?: InputMaybe<Mx_Merchant_Payment_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Payment_Method_MetasArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Payment_Method_Metas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mx_Merchant_Payment_Method_Metas_Order_By>>;
  where?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
};


export type Subscription_RootMx_Merchant_Payment_Method_Metas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMx_Merchant_Payment_Method_Metas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mx_Merchant_Payment_Method_Metas_Stream_Cursor_Input>>;
  where?: InputMaybe<Mx_Merchant_Payment_Method_Metas_Bool_Exp>;
};


export type Subscription_RootParkable_Group_Parkable_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Order_By>>;
  where?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
};


export type Subscription_RootParkable_Group_Parkable_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Group_Parkable_Schedule_Order_By>>;
  where?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
};


export type Subscription_RootParkable_Group_Parkable_Schedule_By_PkArgs = {
  parkable_group_id: Scalars['bigint']['input'];
  parkable_schedule_id: Scalars['bigint']['input'];
};


export type Subscription_RootParkable_Group_Parkable_Schedule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parkable_Group_Parkable_Schedule_Stream_Cursor_Input>>;
  where?: InputMaybe<Parkable_Group_Parkable_Schedule_Bool_Exp>;
};


export type Subscription_RootParkable_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Groups_Order_By>>;
  where?: InputMaybe<Parkable_Groups_Bool_Exp>;
};


export type Subscription_RootParkable_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Groups_Order_By>>;
  where?: InputMaybe<Parkable_Groups_Bool_Exp>;
};


export type Subscription_RootParkable_Groups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootParkable_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parkable_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Parkable_Groups_Bool_Exp>;
};


export type Subscription_RootParkable_Parkable_GroupArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Parkable_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Parkable_Group_Order_By>>;
  where?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
};


export type Subscription_RootParkable_Parkable_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Parkable_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Parkable_Group_Order_By>>;
  where?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
};


export type Subscription_RootParkable_Parkable_Group_By_PkArgs = {
  parkable_group_id: Scalars['bigint']['input'];
  parkable_id: Scalars['bigint']['input'];
};


export type Subscription_RootParkable_Parkable_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parkable_Parkable_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Parkable_Parkable_Group_Bool_Exp>;
};


export type Subscription_RootParkable_Qr_CodeArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Qr_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Qr_Code_Order_By>>;
  where?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
};


export type Subscription_RootParkable_Qr_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Qr_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Qr_Code_Order_By>>;
  where?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
};


export type Subscription_RootParkable_Qr_Code_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parkable_Qr_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Parkable_Qr_Code_Bool_Exp>;
};


export type Subscription_RootParkable_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Schedules_Order_By>>;
  where?: InputMaybe<Parkable_Schedules_Bool_Exp>;
};


export type Subscription_RootParkable_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Schedules_Order_By>>;
  where?: InputMaybe<Parkable_Schedules_Bool_Exp>;
};


export type Subscription_RootParkable_Schedules_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootParkable_Schedules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parkable_Schedules_Stream_Cursor_Input>>;
  where?: InputMaybe<Parkable_Schedules_Bool_Exp>;
};


export type Subscription_RootParkable_Transaction_TaskArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Task_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
};


export type Subscription_RootParkable_Transaction_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Task_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
};


export type Subscription_RootParkable_Transaction_Task_By_PkArgs = {
  parkable_transaction_id: Scalars['bigint']['input'];
  task_id: Scalars['uuid']['input'];
};


export type Subscription_RootParkable_Transaction_Task_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parkable_Transaction_Task_Stream_Cursor_Input>>;
  where?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
};


export type Subscription_RootParkable_Transaction_Wallet_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootParkable_Transaction_Wallet_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootParkable_Transaction_Wallet_Transaction_By_PkArgs = {
  parkable_transaction_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


export type Subscription_RootParkable_Transaction_Wallet_Transaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parkable_Transaction_Wallet_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootParkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


export type Subscription_RootParkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


export type Subscription_RootParkable_Transactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootParkable_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parkable_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


export type Subscription_RootParkablesArgs = {
  distinct_on?: InputMaybe<Array<Parkables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkables_Order_By>>;
  where?: InputMaybe<Parkables_Bool_Exp>;
};


export type Subscription_RootParkables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkables_Order_By>>;
  where?: InputMaybe<Parkables_Bool_Exp>;
};


export type Subscription_RootParkables_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootParkables_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parkables_Stream_Cursor_Input>>;
  where?: InputMaybe<Parkables_Bool_Exp>;
};


export type Subscription_RootParking_AuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authorities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authorities_Order_By>>;
  where?: InputMaybe<Parking_Authorities_Bool_Exp>;
};


export type Subscription_RootParking_Authorities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authorities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authorities_Order_By>>;
  where?: InputMaybe<Parking_Authorities_Bool_Exp>;
};


export type Subscription_RootParking_Authorities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootParking_Authorities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parking_Authorities_Stream_Cursor_Input>>;
  where?: InputMaybe<Parking_Authorities_Bool_Exp>;
};


export type Subscription_RootParking_Authority_Bank_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Order_By>>;
  where?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
};


export type Subscription_RootParking_Authority_Bank_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Bank_Accounts_Order_By>>;
  where?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
};


export type Subscription_RootParking_Authority_Bank_Accounts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootParking_Authority_Bank_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parking_Authority_Bank_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Parking_Authority_Bank_Accounts_Bool_Exp>;
};


export type Subscription_RootParking_Authority_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Settings_Order_By>>;
  where?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
};


export type Subscription_RootParking_Authority_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_Settings_Order_By>>;
  where?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
};


export type Subscription_RootParking_Authority_Settings_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootParking_Authority_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parking_Authority_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Parking_Authority_Settings_Bool_Exp>;
};


export type Subscription_RootParking_Authority_UserArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_User_Order_By>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


export type Subscription_RootParking_Authority_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_User_Order_By>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


export type Subscription_RootParking_Authority_User_By_PkArgs = {
  parking_authority_id: Scalars['bigint']['input'];
  user_id: Scalars['bigint']['input'];
};


export type Subscription_RootParking_Authority_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parking_Authority_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


export type Subscription_RootPayment_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Subscription_RootPayment_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Subscription_RootPayment_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPayment_Batches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Batches_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Subscription_RootPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPayment_Methods_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPayment_Methods_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Methods_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPayment_Wallet_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Payment_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootPayment_Wallet_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootPayment_Wallet_Transaction_By_PkArgs = {
  payment_id: Scalars['bigint']['input'];
  wallet_transaction_id: Scalars['bigint']['input'];
};


export type Subscription_RootPayment_Wallet_Transaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Wallet_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
};


export type Subscription_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPayments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPending_UsersArgs = {
  distinct_on?: InputMaybe<Array<Pending_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pending_Users_Order_By>>;
  where?: InputMaybe<Pending_Users_Bool_Exp>;
};


export type Subscription_RootPending_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pending_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pending_Users_Order_By>>;
  where?: InputMaybe<Pending_Users_Bool_Exp>;
};


export type Subscription_RootPending_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPending_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pending_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Pending_Users_Bool_Exp>;
};


export type Subscription_RootPersonal_Access_TokensArgs = {
  distinct_on?: InputMaybe<Array<Personal_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Access_Tokens_Order_By>>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};


export type Subscription_RootPersonal_Access_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Personal_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Personal_Access_Tokens_Order_By>>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};


export type Subscription_RootPersonal_Access_Tokens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPersonal_Access_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Personal_Access_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Personal_Access_Tokens_Bool_Exp>;
};


export type Subscription_RootPublic_KeysArgs = {
  distinct_on?: InputMaybe<Array<Public_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Public_Keys_Order_By>>;
  where?: InputMaybe<Public_Keys_Bool_Exp>;
};


export type Subscription_RootPublic_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Public_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Public_Keys_Order_By>>;
  where?: InputMaybe<Public_Keys_Bool_Exp>;
};


export type Subscription_RootPublic_Keys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Public_Keys_Stream_Cursor_Input>>;
  where?: InputMaybe<Public_Keys_Bool_Exp>;
};


export type Subscription_RootQr_CodesArgs = {
  distinct_on?: InputMaybe<Array<Qr_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Qr_Codes_Order_By>>;
  where?: InputMaybe<Qr_Codes_Bool_Exp>;
};


export type Subscription_RootQr_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Qr_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Qr_Codes_Order_By>>;
  where?: InputMaybe<Qr_Codes_Bool_Exp>;
};


export type Subscription_RootQr_Codes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootQr_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Qr_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Qr_Codes_Bool_Exp>;
};


export type Subscription_RootR_Line_Item_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<R_Line_Item_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Line_Item_Payments_Order_By>>;
  where?: InputMaybe<R_Line_Item_Payments_Bool_Exp>;
};


export type Subscription_RootR_Line_Item_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Line_Item_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Line_Item_Payments_Order_By>>;
  where?: InputMaybe<R_Line_Item_Payments_Bool_Exp>;
};


export type Subscription_RootR_Line_Item_Payments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootR_Line_Item_Payments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<R_Line_Item_Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<R_Line_Item_Payments_Bool_Exp>;
};


export type Subscription_RootR_Parkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<R_Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Parkable_Transactions_Order_By>>;
  where?: InputMaybe<R_Parkable_Transactions_Bool_Exp>;
};


export type Subscription_RootR_Parkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Parkable_Transactions_Order_By>>;
  where?: InputMaybe<R_Parkable_Transactions_Bool_Exp>;
};


export type Subscription_RootR_Parkable_Transactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootR_Parkable_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<R_Parkable_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<R_Parkable_Transactions_Bool_Exp>;
};


export type Subscription_RootR_Parking_AuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<R_Parking_Authorities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Parking_Authorities_Order_By>>;
  where?: InputMaybe<R_Parking_Authorities_Bool_Exp>;
};


export type Subscription_RootR_Parking_Authorities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Parking_Authorities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Parking_Authorities_Order_By>>;
  where?: InputMaybe<R_Parking_Authorities_Bool_Exp>;
};


export type Subscription_RootR_Parking_Authorities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootR_Parking_Authorities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<R_Parking_Authorities_Stream_Cursor_Input>>;
  where?: InputMaybe<R_Parking_Authorities_Bool_Exp>;
};


export type Subscription_RootR_Payment_BatchesArgs = {
  distinct_on?: InputMaybe<Array<R_Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Payment_Batches_Order_By>>;
  where?: InputMaybe<R_Payment_Batches_Bool_Exp>;
};


export type Subscription_RootR_Payment_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Payment_Batches_Order_By>>;
  where?: InputMaybe<R_Payment_Batches_Bool_Exp>;
};


export type Subscription_RootR_Payment_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootR_Payment_Batches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<R_Payment_Batches_Stream_Cursor_Input>>;
  where?: InputMaybe<R_Payment_Batches_Bool_Exp>;
};


export type Subscription_RootR_Transfer_BatchesArgs = {
  distinct_on?: InputMaybe<Array<R_Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Transfer_Batches_Order_By>>;
  where?: InputMaybe<R_Transfer_Batches_Bool_Exp>;
};


export type Subscription_RootR_Transfer_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Transfer_Batches_Order_By>>;
  where?: InputMaybe<R_Transfer_Batches_Bool_Exp>;
};


export type Subscription_RootR_Transfer_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootR_Transfer_Batches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<R_Transfer_Batches_Stream_Cursor_Input>>;
  where?: InputMaybe<R_Transfer_Batches_Bool_Exp>;
};


export type Subscription_RootR_UsersArgs = {
  distinct_on?: InputMaybe<Array<R_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Users_Order_By>>;
  where?: InputMaybe<R_Users_Bool_Exp>;
};


export type Subscription_RootR_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<R_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<R_Users_Order_By>>;
  where?: InputMaybe<R_Users_Bool_Exp>;
};


export type Subscription_RootR_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootR_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<R_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<R_Users_Bool_Exp>;
};


export type Subscription_RootReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


export type Subscription_RootReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


export type Subscription_RootReports_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootReports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


export type Subscription_RootSession_Overlap_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Session_Overlap_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_Overlap_Results_Order_By>>;
  where?: InputMaybe<Session_Overlap_Results_Bool_Exp>;
};


export type Subscription_RootSession_Overlap_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Session_Overlap_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_Overlap_Results_Order_By>>;
  where?: InputMaybe<Session_Overlap_Results_Bool_Exp>;
};


export type Subscription_RootSession_Overlap_Results_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSession_Overlap_Results_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Session_Overlap_Results_Stream_Cursor_Input>>;
  where?: InputMaybe<Session_Overlap_Results_Bool_Exp>;
};


export type Subscription_RootSupport_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


export type Subscription_RootSupport_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


export type Subscription_RootSupport_Tickets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSupport_Tickets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Support_Tickets_Stream_Cursor_Input>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


export type Subscription_RootTask_EventsArgs = {
  distinct_on?: InputMaybe<Array<Task_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Events_Order_By>>;
  where?: InputMaybe<Task_Events_Bool_Exp>;
};


export type Subscription_RootTask_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Events_Order_By>>;
  where?: InputMaybe<Task_Events_Bool_Exp>;
};


export type Subscription_RootTask_Events_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Events_Bool_Exp>;
};


export type Subscription_RootTask_StatesArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Order_By>>;
  where?: InputMaybe<Task_States_Bool_Exp>;
};


export type Subscription_RootTask_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Order_By>>;
  where?: InputMaybe<Task_States_Bool_Exp>;
};


export type Subscription_RootTask_States_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_States_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_States_Bool_Exp>;
};


export type Subscription_RootTask_UserArgs = {
  distinct_on?: InputMaybe<Array<Task_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_User_Order_By>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};


export type Subscription_RootTask_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_User_Order_By>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};


export type Subscription_RootTask_User_By_PkArgs = {
  task_id: Scalars['uuid']['input'];
  user_id: Scalars['bigint']['input'];
};


export type Subscription_RootTask_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};


export type Subscription_RootTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Subscription_RootTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Subscription_RootTasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTasks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tasks_Stream_Cursor_Input>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Subscription_RootTransfer_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transfer_Batches_Order_By>>;
  where?: InputMaybe<Transfer_Batches_Bool_Exp>;
};


export type Subscription_RootTransfer_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transfer_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transfer_Batches_Order_By>>;
  where?: InputMaybe<Transfer_Batches_Bool_Exp>;
};


export type Subscription_RootTransfer_Batches_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTransfer_Batches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transfer_Batches_Stream_Cursor_Input>>;
  where?: InputMaybe<Transfer_Batches_Bool_Exp>;
};


export type Subscription_RootUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


export type Subscription_RootUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


export type Subscription_RootUser_Activities_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUser_Activities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Activities_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


export type Subscription_RootUser_ListsArgs = {
  distinct_on?: InputMaybe<Array<User_Lists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Lists_Order_By>>;
  where?: InputMaybe<User_Lists_Bool_Exp>;
};


export type Subscription_RootUser_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Lists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Lists_Order_By>>;
  where?: InputMaybe<User_Lists_Bool_Exp>;
};


export type Subscription_RootUser_Lists_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUser_Lists_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Lists_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Lists_Bool_Exp>;
};


export type Subscription_RootUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_Settings_AllArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_All_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_All_Order_By>>;
  where?: InputMaybe<User_Settings_All_Bool_Exp>;
};


export type Subscription_RootUser_Settings_All_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_All_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_All_Order_By>>;
  where?: InputMaybe<User_Settings_All_Bool_Exp>;
};


export type Subscription_RootUser_Settings_All_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Settings_All_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Settings_All_Bool_Exp>;
};


export type Subscription_RootUser_Settings_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUser_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_User_ListArgs = {
  distinct_on?: InputMaybe<Array<User_User_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_User_List_Order_By>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};


export type Subscription_RootUser_User_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_User_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_User_List_Order_By>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};


export type Subscription_RootUser_User_List_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUser_User_List_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_User_List_Stream_Cursor_Input>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Subscription_RootVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Subscription_RootVehicles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVehicles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicles_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Subscription_RootWallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


export type Subscription_RootWallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


export type Subscription_RootWallet_Transactions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootWallet_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wallet_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


export type Subscription_RootWalletsArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


export type Subscription_RootWallets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


export type Subscription_RootWallets_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootWallets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wallets_Stream_Cursor_Input>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};

/** columns and relationships of "support_tickets" */
export type Support_Tickets = {
  __typename?: 'support_tickets';
  app_version?: Maybe<Scalars['String']['output']>;
  context_data?: Maybe<Scalars['json']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device?: Maybe<Scalars['json']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_submitted: Scalars['Boolean']['output'];
  external_ticket_id?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  idempotent_key: Scalars['uuid']['output'];
  /** An object relationship */
  identity?: Maybe<Identities>;
  identity_id?: Maybe<Scalars['bigint']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "support_tickets" */
export type Support_TicketsContext_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "support_tickets" */
export type Support_TicketsDeviceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "support_tickets" */
export type Support_Tickets_Aggregate = {
  __typename?: 'support_tickets_aggregate';
  aggregate?: Maybe<Support_Tickets_Aggregate_Fields>;
  nodes: Array<Support_Tickets>;
};

export type Support_Tickets_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Support_Tickets_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Support_Tickets_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Support_Tickets_Aggregate_Bool_Exp_Count>;
};

export type Support_Tickets_Aggregate_Bool_Exp_Bool_And = {
  arguments: Support_Tickets_Select_Column_Support_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Support_Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Support_Tickets_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Support_Tickets_Select_Column_Support_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Support_Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Support_Tickets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Support_Tickets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "support_tickets" */
export type Support_Tickets_Aggregate_Fields = {
  __typename?: 'support_tickets_aggregate_fields';
  avg?: Maybe<Support_Tickets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Support_Tickets_Max_Fields>;
  min?: Maybe<Support_Tickets_Min_Fields>;
  stddev?: Maybe<Support_Tickets_Stddev_Fields>;
  stddev_pop?: Maybe<Support_Tickets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Support_Tickets_Stddev_Samp_Fields>;
  sum?: Maybe<Support_Tickets_Sum_Fields>;
  var_pop?: Maybe<Support_Tickets_Var_Pop_Fields>;
  var_samp?: Maybe<Support_Tickets_Var_Samp_Fields>;
  variance?: Maybe<Support_Tickets_Variance_Fields>;
};


/** aggregate fields of "support_tickets" */
export type Support_Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "support_tickets" */
export type Support_Tickets_Aggregate_Order_By = {
  avg?: InputMaybe<Support_Tickets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Support_Tickets_Max_Order_By>;
  min?: InputMaybe<Support_Tickets_Min_Order_By>;
  stddev?: InputMaybe<Support_Tickets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Support_Tickets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Support_Tickets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Support_Tickets_Sum_Order_By>;
  var_pop?: InputMaybe<Support_Tickets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Support_Tickets_Var_Samp_Order_By>;
  variance?: InputMaybe<Support_Tickets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "support_tickets" */
export type Support_Tickets_Arr_Rel_Insert_Input = {
  data: Array<Support_Tickets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Support_Tickets_On_Conflict>;
};

/** aggregate avg on columns */
export type Support_Tickets_Avg_Fields = {
  __typename?: 'support_tickets_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identity_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "support_tickets" */
export type Support_Tickets_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  identity_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "support_tickets". All fields are combined with a logical 'AND'. */
export type Support_Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Support_Tickets_Bool_Exp>>;
  _not?: InputMaybe<Support_Tickets_Bool_Exp>;
  _or?: InputMaybe<Array<Support_Tickets_Bool_Exp>>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  context_data?: InputMaybe<Json_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  device?: InputMaybe<Json_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_submitted?: InputMaybe<Boolean_Comparison_Exp>;
  external_ticket_id?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  identity?: InputMaybe<Identities_Bool_Exp>;
  identity_id?: InputMaybe<Bigint_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "support_tickets" */
export enum Support_Tickets_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupportTicketsPkey = 'support_tickets_pkey'
}

/** input type for incrementing numeric columns in table "support_tickets" */
export type Support_Tickets_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  identity_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "support_tickets" */
export type Support_Tickets_Insert_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  context_data?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device?: InputMaybe<Scalars['json']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_submitted?: InputMaybe<Scalars['Boolean']['input']>;
  external_ticket_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  identity?: InputMaybe<Identities_Obj_Rel_Insert_Input>;
  identity_id?: InputMaybe<Scalars['bigint']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Support_Tickets_Max_Fields = {
  __typename?: 'support_tickets_max_fields';
  app_version?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_ticket_id?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  identity_id?: Maybe<Scalars['bigint']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "support_tickets" */
export type Support_Tickets_Max_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  external_ticket_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  identity_id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Support_Tickets_Min_Fields = {
  __typename?: 'support_tickets_min_fields';
  app_version?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_ticket_id?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  identity_id?: Maybe<Scalars['bigint']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "support_tickets" */
export type Support_Tickets_Min_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  external_ticket_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  identity_id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "support_tickets" */
export type Support_Tickets_Mutation_Response = {
  __typename?: 'support_tickets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Support_Tickets>;
};

/** on_conflict condition type for table "support_tickets" */
export type Support_Tickets_On_Conflict = {
  constraint: Support_Tickets_Constraint;
  update_columns?: Array<Support_Tickets_Update_Column>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};

/** Ordering options when selecting data from "support_tickets". */
export type Support_Tickets_Order_By = {
  app_version?: InputMaybe<Order_By>;
  context_data?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  external_submitted?: InputMaybe<Order_By>;
  external_ticket_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  identity?: InputMaybe<Identities_Order_By>;
  identity_id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: support_tickets */
export type Support_Tickets_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "support_tickets" */
export enum Support_Tickets_Select_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  ContextData = 'context_data',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Device = 'device',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalSubmitted = 'external_submitted',
  /** column name */
  ExternalTicketId = 'external_ticket_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  IdentityId = 'identity_id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Message = 'message',
  /** column name */
  Phone = 'phone',
  /** column name */
  Platform = 'platform',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "support_tickets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "support_tickets" */
export enum Support_Tickets_Select_Column_Support_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ExternalSubmitted = 'external_submitted'
}

/** select "support_tickets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "support_tickets" */
export enum Support_Tickets_Select_Column_Support_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ExternalSubmitted = 'external_submitted'
}

/** input type for updating data in table "support_tickets" */
export type Support_Tickets_Set_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  context_data?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device?: InputMaybe<Scalars['json']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_submitted?: InputMaybe<Scalars['Boolean']['input']>;
  external_ticket_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  identity_id?: InputMaybe<Scalars['bigint']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Support_Tickets_Stddev_Fields = {
  __typename?: 'support_tickets_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identity_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "support_tickets" */
export type Support_Tickets_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  identity_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Support_Tickets_Stddev_Pop_Fields = {
  __typename?: 'support_tickets_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identity_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "support_tickets" */
export type Support_Tickets_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  identity_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Support_Tickets_Stddev_Samp_Fields = {
  __typename?: 'support_tickets_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identity_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "support_tickets" */
export type Support_Tickets_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  identity_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "support_tickets" */
export type Support_Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Support_Tickets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Support_Tickets_Stream_Cursor_Value_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  context_data?: InputMaybe<Scalars['json']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device?: InputMaybe<Scalars['json']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_submitted?: InputMaybe<Scalars['Boolean']['input']>;
  external_ticket_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  identity_id?: InputMaybe<Scalars['bigint']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Support_Tickets_Sum_Fields = {
  __typename?: 'support_tickets_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  identity_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "support_tickets" */
export type Support_Tickets_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  identity_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "support_tickets" */
export enum Support_Tickets_Update_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  ContextData = 'context_data',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Device = 'device',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalSubmitted = 'external_submitted',
  /** column name */
  ExternalTicketId = 'external_ticket_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  IdentityId = 'identity_id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Message = 'message',
  /** column name */
  Phone = 'phone',
  /** column name */
  Platform = 'platform',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Support_Tickets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Support_Tickets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Support_Tickets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Support_Tickets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Support_Tickets_Var_Pop_Fields = {
  __typename?: 'support_tickets_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identity_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "support_tickets" */
export type Support_Tickets_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  identity_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Support_Tickets_Var_Samp_Fields = {
  __typename?: 'support_tickets_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identity_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "support_tickets" */
export type Support_Tickets_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  identity_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Support_Tickets_Variance_Fields = {
  __typename?: 'support_tickets_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  identity_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "support_tickets" */
export type Support_Tickets_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  identity_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "task_events" */
export type Task_Events = {
  __typename?: 'task_events';
  aborted_at?: Maybe<Scalars['timestamp']['output']>;
  actionable: Scalars['Boolean']['output'];
  backoff_multiplier?: Maybe<Scalars['smallint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  last_failed_try_at?: Maybe<Scalars['timestamp']['output']>;
  life: Scalars['smallint']['output'];
  parent_id?: Maybe<Scalars['uuid']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  processing_at?: Maybe<Scalars['timestamp']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  task: Tasks;
  /** An object relationship */
  task_event?: Maybe<Task_Events>;
  /** An array relationship */
  task_events: Array<Task_Events>;
  /** An aggregate relationship */
  task_events_aggregate: Task_Events_Aggregate;
  task_id: Scalars['uuid']['output'];
  try?: Maybe<Scalars['smallint']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  waiting_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "task_events" */
export type Task_EventsTask_EventsArgs = {
  distinct_on?: InputMaybe<Array<Task_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Events_Order_By>>;
  where?: InputMaybe<Task_Events_Bool_Exp>;
};


/** columns and relationships of "task_events" */
export type Task_EventsTask_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Events_Order_By>>;
  where?: InputMaybe<Task_Events_Bool_Exp>;
};

/** aggregated selection of "task_events" */
export type Task_Events_Aggregate = {
  __typename?: 'task_events_aggregate';
  aggregate?: Maybe<Task_Events_Aggregate_Fields>;
  nodes: Array<Task_Events>;
};

export type Task_Events_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Task_Events_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Task_Events_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Task_Events_Aggregate_Bool_Exp_Count>;
};

export type Task_Events_Aggregate_Bool_Exp_Bool_And = {
  arguments: Task_Events_Select_Column_Task_Events_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Events_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Events_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Task_Events_Select_Column_Task_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Events_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Task_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "task_events" */
export type Task_Events_Aggregate_Fields = {
  __typename?: 'task_events_aggregate_fields';
  avg?: Maybe<Task_Events_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Events_Max_Fields>;
  min?: Maybe<Task_Events_Min_Fields>;
  stddev?: Maybe<Task_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Task_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Task_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Task_Events_Sum_Fields>;
  var_pop?: Maybe<Task_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Task_Events_Var_Samp_Fields>;
  variance?: Maybe<Task_Events_Variance_Fields>;
};


/** aggregate fields of "task_events" */
export type Task_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "task_events" */
export type Task_Events_Aggregate_Order_By = {
  avg?: InputMaybe<Task_Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Events_Max_Order_By>;
  min?: InputMaybe<Task_Events_Min_Order_By>;
  stddev?: InputMaybe<Task_Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Task_Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Task_Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Task_Events_Sum_Order_By>;
  var_pop?: InputMaybe<Task_Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Task_Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Task_Events_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "task_events" */
export type Task_Events_Arr_Rel_Insert_Input = {
  data: Array<Task_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Task_Events_Avg_Fields = {
  __typename?: 'task_events_avg_fields';
  backoff_multiplier?: Maybe<Scalars['Float']['output']>;
  life?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "task_events" */
export type Task_Events_Avg_Order_By = {
  backoff_multiplier?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "task_events". All fields are combined with a logical 'AND'. */
export type Task_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Events_Bool_Exp>>;
  _not?: InputMaybe<Task_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Events_Bool_Exp>>;
  aborted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  actionable?: InputMaybe<Boolean_Comparison_Exp>;
  backoff_multiplier?: InputMaybe<Smallint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  failed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  last_failed_try_at?: InputMaybe<Timestamp_Comparison_Exp>;
  life?: InputMaybe<Smallint_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  processed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  processing_at?: InputMaybe<Timestamp_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_event?: InputMaybe<Task_Events_Bool_Exp>;
  task_events?: InputMaybe<Task_Events_Bool_Exp>;
  task_events_aggregate?: InputMaybe<Task_Events_Aggregate_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  try?: InputMaybe<Smallint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  waiting_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "task_events" */
export enum Task_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskEventsPkey = 'task_events_pkey'
}

/** input type for incrementing numeric columns in table "task_events" */
export type Task_Events_Inc_Input = {
  backoff_multiplier?: InputMaybe<Scalars['smallint']['input']>;
  life?: InputMaybe<Scalars['smallint']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "task_events" */
export type Task_Events_Insert_Input = {
  aborted_at?: InputMaybe<Scalars['timestamp']['input']>;
  actionable?: InputMaybe<Scalars['Boolean']['input']>;
  backoff_multiplier?: InputMaybe<Scalars['smallint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  last_failed_try_at?: InputMaybe<Scalars['timestamp']['input']>;
  life?: InputMaybe<Scalars['smallint']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_event?: InputMaybe<Task_Events_Obj_Rel_Insert_Input>;
  task_events?: InputMaybe<Task_Events_Arr_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  waiting_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Task_Events_Max_Fields = {
  __typename?: 'task_events_max_fields';
  aborted_at?: Maybe<Scalars['timestamp']['output']>;
  backoff_multiplier?: Maybe<Scalars['smallint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  last_failed_try_at?: Maybe<Scalars['timestamp']['output']>;
  life?: Maybe<Scalars['smallint']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  processing_at?: Maybe<Scalars['timestamp']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  waiting_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "task_events" */
export type Task_Events_Max_Order_By = {
  aborted_at?: InputMaybe<Order_By>;
  backoff_multiplier?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  failed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  last_failed_try_at?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  processing_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  waiting_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Task_Events_Min_Fields = {
  __typename?: 'task_events_min_fields';
  aborted_at?: Maybe<Scalars['timestamp']['output']>;
  backoff_multiplier?: Maybe<Scalars['smallint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  last_failed_try_at?: Maybe<Scalars['timestamp']['output']>;
  life?: Maybe<Scalars['smallint']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  processing_at?: Maybe<Scalars['timestamp']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  waiting_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "task_events" */
export type Task_Events_Min_Order_By = {
  aborted_at?: InputMaybe<Order_By>;
  backoff_multiplier?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  failed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  last_failed_try_at?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  processing_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  waiting_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task_events" */
export type Task_Events_Mutation_Response = {
  __typename?: 'task_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_Events>;
};

/** input type for inserting object relation for remote table "task_events" */
export type Task_Events_Obj_Rel_Insert_Input = {
  data: Task_Events_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_Events_On_Conflict>;
};

/** on_conflict condition type for table "task_events" */
export type Task_Events_On_Conflict = {
  constraint: Task_Events_Constraint;
  update_columns?: Array<Task_Events_Update_Column>;
  where?: InputMaybe<Task_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "task_events". */
export type Task_Events_Order_By = {
  aborted_at?: InputMaybe<Order_By>;
  actionable?: InputMaybe<Order_By>;
  backoff_multiplier?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  failed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  last_failed_try_at?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  processing_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_event?: InputMaybe<Task_Events_Order_By>;
  task_events_aggregate?: InputMaybe<Task_Events_Aggregate_Order_By>;
  task_id?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  waiting_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task_events */
export type Task_Events_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "task_events" */
export enum Task_Events_Select_Column {
  /** column name */
  AbortedAt = 'aborted_at',
  /** column name */
  Actionable = 'actionable',
  /** column name */
  BackoffMultiplier = 'backoff_multiplier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  LastFailedTryAt = 'last_failed_try_at',
  /** column name */
  Life = 'life',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ProcessingAt = 'processing_at',
  /** column name */
  Status = 'status',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Try = 'try',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WaitingAt = 'waiting_at'
}

/** select "task_events_aggregate_bool_exp_bool_and_arguments_columns" columns of table "task_events" */
export enum Task_Events_Select_Column_Task_Events_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Actionable = 'actionable'
}

/** select "task_events_aggregate_bool_exp_bool_or_arguments_columns" columns of table "task_events" */
export enum Task_Events_Select_Column_Task_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Actionable = 'actionable'
}

/** input type for updating data in table "task_events" */
export type Task_Events_Set_Input = {
  aborted_at?: InputMaybe<Scalars['timestamp']['input']>;
  actionable?: InputMaybe<Scalars['Boolean']['input']>;
  backoff_multiplier?: InputMaybe<Scalars['smallint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  last_failed_try_at?: InputMaybe<Scalars['timestamp']['input']>;
  life?: InputMaybe<Scalars['smallint']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  waiting_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Task_Events_Stddev_Fields = {
  __typename?: 'task_events_stddev_fields';
  backoff_multiplier?: Maybe<Scalars['Float']['output']>;
  life?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "task_events" */
export type Task_Events_Stddev_Order_By = {
  backoff_multiplier?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Task_Events_Stddev_Pop_Fields = {
  __typename?: 'task_events_stddev_pop_fields';
  backoff_multiplier?: Maybe<Scalars['Float']['output']>;
  life?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "task_events" */
export type Task_Events_Stddev_Pop_Order_By = {
  backoff_multiplier?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Task_Events_Stddev_Samp_Fields = {
  __typename?: 'task_events_stddev_samp_fields';
  backoff_multiplier?: Maybe<Scalars['Float']['output']>;
  life?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "task_events" */
export type Task_Events_Stddev_Samp_Order_By = {
  backoff_multiplier?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "task_events" */
export type Task_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Events_Stream_Cursor_Value_Input = {
  aborted_at?: InputMaybe<Scalars['timestamp']['input']>;
  actionable?: InputMaybe<Scalars['Boolean']['input']>;
  backoff_multiplier?: InputMaybe<Scalars['smallint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  last_failed_try_at?: InputMaybe<Scalars['timestamp']['input']>;
  life?: InputMaybe<Scalars['smallint']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  waiting_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Task_Events_Sum_Fields = {
  __typename?: 'task_events_sum_fields';
  backoff_multiplier?: Maybe<Scalars['smallint']['output']>;
  life?: Maybe<Scalars['smallint']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "task_events" */
export type Task_Events_Sum_Order_By = {
  backoff_multiplier?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** update columns of table "task_events" */
export enum Task_Events_Update_Column {
  /** column name */
  AbortedAt = 'aborted_at',
  /** column name */
  Actionable = 'actionable',
  /** column name */
  BackoffMultiplier = 'backoff_multiplier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  LastFailedTryAt = 'last_failed_try_at',
  /** column name */
  Life = 'life',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ProcessingAt = 'processing_at',
  /** column name */
  Status = 'status',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Try = 'try',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WaitingAt = 'waiting_at'
}

export type Task_Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Task_Events_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Task_Events_Var_Pop_Fields = {
  __typename?: 'task_events_var_pop_fields';
  backoff_multiplier?: Maybe<Scalars['Float']['output']>;
  life?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "task_events" */
export type Task_Events_Var_Pop_Order_By = {
  backoff_multiplier?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Task_Events_Var_Samp_Fields = {
  __typename?: 'task_events_var_samp_fields';
  backoff_multiplier?: Maybe<Scalars['Float']['output']>;
  life?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "task_events" */
export type Task_Events_Var_Samp_Order_By = {
  backoff_multiplier?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Task_Events_Variance_Fields = {
  __typename?: 'task_events_variance_fields';
  backoff_multiplier?: Maybe<Scalars['Float']['output']>;
  life?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "task_events" */
export type Task_Events_Variance_Order_By = {
  backoff_multiplier?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
};

/** columns and relationships of "task_states" */
export type Task_States = {
  __typename?: 'task_states';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  life: Scalars['smallint']['output'];
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "task_states" */
export type Task_States_Aggregate = {
  __typename?: 'task_states_aggregate';
  aggregate?: Maybe<Task_States_Aggregate_Fields>;
  nodes: Array<Task_States>;
};

export type Task_States_Aggregate_Bool_Exp = {
  count?: InputMaybe<Task_States_Aggregate_Bool_Exp_Count>;
};

export type Task_States_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Task_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_States_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "task_states" */
export type Task_States_Aggregate_Fields = {
  __typename?: 'task_states_aggregate_fields';
  avg?: Maybe<Task_States_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Task_States_Max_Fields>;
  min?: Maybe<Task_States_Min_Fields>;
  stddev?: Maybe<Task_States_Stddev_Fields>;
  stddev_pop?: Maybe<Task_States_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Task_States_Stddev_Samp_Fields>;
  sum?: Maybe<Task_States_Sum_Fields>;
  var_pop?: Maybe<Task_States_Var_Pop_Fields>;
  var_samp?: Maybe<Task_States_Var_Samp_Fields>;
  variance?: Maybe<Task_States_Variance_Fields>;
};


/** aggregate fields of "task_states" */
export type Task_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "task_states" */
export type Task_States_Aggregate_Order_By = {
  avg?: InputMaybe<Task_States_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_States_Max_Order_By>;
  min?: InputMaybe<Task_States_Min_Order_By>;
  stddev?: InputMaybe<Task_States_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Task_States_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Task_States_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Task_States_Sum_Order_By>;
  var_pop?: InputMaybe<Task_States_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Task_States_Var_Samp_Order_By>;
  variance?: InputMaybe<Task_States_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "task_states" */
export type Task_States_Arr_Rel_Insert_Input = {
  data: Array<Task_States_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_States_On_Conflict>;
};

/** aggregate avg on columns */
export type Task_States_Avg_Fields = {
  __typename?: 'task_states_avg_fields';
  life?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "task_states" */
export type Task_States_Avg_Order_By = {
  life?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "task_states". All fields are combined with a logical 'AND'. */
export type Task_States_Bool_Exp = {
  _and?: InputMaybe<Array<Task_States_Bool_Exp>>;
  _not?: InputMaybe<Task_States_Bool_Exp>;
  _or?: InputMaybe<Array<Task_States_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  life?: InputMaybe<Smallint_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "task_states" */
export enum Task_States_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskStatesPkey = 'task_states_pkey'
}

/** input type for incrementing numeric columns in table "task_states" */
export type Task_States_Inc_Input = {
  life?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "task_states" */
export type Task_States_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  life?: InputMaybe<Scalars['smallint']['input']>;
  task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Task_States_Max_Fields = {
  __typename?: 'task_states_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  life?: Maybe<Scalars['smallint']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "task_states" */
export type Task_States_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Task_States_Min_Fields = {
  __typename?: 'task_states_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  life?: Maybe<Scalars['smallint']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "task_states" */
export type Task_States_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task_states" */
export type Task_States_Mutation_Response = {
  __typename?: 'task_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_States>;
};

/** on_conflict condition type for table "task_states" */
export type Task_States_On_Conflict = {
  constraint: Task_States_Constraint;
  update_columns?: Array<Task_States_Update_Column>;
  where?: InputMaybe<Task_States_Bool_Exp>;
};

/** Ordering options when selecting data from "task_states". */
export type Task_States_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  life?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task_states */
export type Task_States_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "task_states" */
export enum Task_States_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Life = 'life',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "task_states" */
export type Task_States_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  life?: InputMaybe<Scalars['smallint']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Task_States_Stddev_Fields = {
  __typename?: 'task_states_stddev_fields';
  life?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "task_states" */
export type Task_States_Stddev_Order_By = {
  life?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Task_States_Stddev_Pop_Fields = {
  __typename?: 'task_states_stddev_pop_fields';
  life?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "task_states" */
export type Task_States_Stddev_Pop_Order_By = {
  life?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Task_States_Stddev_Samp_Fields = {
  __typename?: 'task_states_stddev_samp_fields';
  life?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "task_states" */
export type Task_States_Stddev_Samp_Order_By = {
  life?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "task_states" */
export type Task_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_States_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  life?: InputMaybe<Scalars['smallint']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Task_States_Sum_Fields = {
  __typename?: 'task_states_sum_fields';
  life?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "task_states" */
export type Task_States_Sum_Order_By = {
  life?: InputMaybe<Order_By>;
};

/** update columns of table "task_states" */
export enum Task_States_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Life = 'life',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Task_States_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Task_States_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_States_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Task_States_Var_Pop_Fields = {
  __typename?: 'task_states_var_pop_fields';
  life?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "task_states" */
export type Task_States_Var_Pop_Order_By = {
  life?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Task_States_Var_Samp_Fields = {
  __typename?: 'task_states_var_samp_fields';
  life?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "task_states" */
export type Task_States_Var_Samp_Order_By = {
  life?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Task_States_Variance_Fields = {
  __typename?: 'task_states_variance_fields';
  life?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "task_states" */
export type Task_States_Variance_Order_By = {
  life?: InputMaybe<Order_By>;
};

/** columns and relationships of "task_user" */
export type Task_User = {
  __typename?: 'task_user';
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "task_user" */
export type Task_User_Aggregate = {
  __typename?: 'task_user_aggregate';
  aggregate?: Maybe<Task_User_Aggregate_Fields>;
  nodes: Array<Task_User>;
};

export type Task_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Task_User_Aggregate_Bool_Exp_Count>;
};

export type Task_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Task_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "task_user" */
export type Task_User_Aggregate_Fields = {
  __typename?: 'task_user_aggregate_fields';
  avg?: Maybe<Task_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Task_User_Max_Fields>;
  min?: Maybe<Task_User_Min_Fields>;
  stddev?: Maybe<Task_User_Stddev_Fields>;
  stddev_pop?: Maybe<Task_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Task_User_Stddev_Samp_Fields>;
  sum?: Maybe<Task_User_Sum_Fields>;
  var_pop?: Maybe<Task_User_Var_Pop_Fields>;
  var_samp?: Maybe<Task_User_Var_Samp_Fields>;
  variance?: Maybe<Task_User_Variance_Fields>;
};


/** aggregate fields of "task_user" */
export type Task_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "task_user" */
export type Task_User_Aggregate_Order_By = {
  avg?: InputMaybe<Task_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_User_Max_Order_By>;
  min?: InputMaybe<Task_User_Min_Order_By>;
  stddev?: InputMaybe<Task_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Task_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Task_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Task_User_Sum_Order_By>;
  var_pop?: InputMaybe<Task_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Task_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Task_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "task_user" */
export type Task_User_Arr_Rel_Insert_Input = {
  data: Array<Task_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Task_User_Avg_Fields = {
  __typename?: 'task_user_avg_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "task_user" */
export type Task_User_Avg_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "task_user". All fields are combined with a logical 'AND'. */
export type Task_User_Bool_Exp = {
  _and?: InputMaybe<Array<Task_User_Bool_Exp>>;
  _not?: InputMaybe<Task_User_Bool_Exp>;
  _or?: InputMaybe<Array<Task_User_Bool_Exp>>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "task_user" */
export enum Task_User_Constraint {
  /** unique or primary key constraint on columns "task_id", "user_id" */
  TaskUserPkey = 'task_user_pkey'
}

/** input type for incrementing numeric columns in table "task_user" */
export type Task_User_Inc_Input = {
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "task_user" */
export type Task_User_Insert_Input = {
  task?: InputMaybe<Tasks_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Task_User_Max_Fields = {
  __typename?: 'task_user_max_fields';
  task_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "task_user" */
export type Task_User_Max_Order_By = {
  task_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Task_User_Min_Fields = {
  __typename?: 'task_user_min_fields';
  task_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "task_user" */
export type Task_User_Min_Order_By = {
  task_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task_user" */
export type Task_User_Mutation_Response = {
  __typename?: 'task_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_User>;
};

/** on_conflict condition type for table "task_user" */
export type Task_User_On_Conflict = {
  constraint: Task_User_Constraint;
  update_columns?: Array<Task_User_Update_Column>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};

/** Ordering options when selecting data from "task_user". */
export type Task_User_Order_By = {
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task_user */
export type Task_User_Pk_Columns_Input = {
  task_id: Scalars['uuid']['input'];
  user_id: Scalars['bigint']['input'];
};

/** select columns of table "task_user" */
export enum Task_User_Select_Column {
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "task_user" */
export type Task_User_Set_Input = {
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Task_User_Stddev_Fields = {
  __typename?: 'task_user_stddev_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "task_user" */
export type Task_User_Stddev_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Task_User_Stddev_Pop_Fields = {
  __typename?: 'task_user_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "task_user" */
export type Task_User_Stddev_Pop_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Task_User_Stddev_Samp_Fields = {
  __typename?: 'task_user_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "task_user" */
export type Task_User_Stddev_Samp_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "task_user" */
export type Task_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_User_Stream_Cursor_Value_Input = {
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Task_User_Sum_Fields = {
  __typename?: 'task_user_sum_fields';
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "task_user" */
export type Task_User_Sum_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "task_user" */
export enum Task_User_Update_Column {
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UserId = 'user_id'
}

export type Task_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Task_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Task_User_Var_Pop_Fields = {
  __typename?: 'task_user_var_pop_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "task_user" */
export type Task_User_Var_Pop_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Task_User_Var_Samp_Fields = {
  __typename?: 'task_user_var_samp_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "task_user" */
export type Task_User_Var_Samp_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Task_User_Variance_Fields = {
  __typename?: 'task_user_variance_fields';
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "task_user" */
export type Task_User_Variance_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "tasks" */
export type Tasks = {
  __typename?: 'tasks';
  aborted_at?: Maybe<Scalars['timestamp']['output']>;
  check_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  last_cycle_at?: Maybe<Scalars['timestamp']['output']>;
  last_error_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_life?: Maybe<Scalars['smallint']['output']>;
  loaded_life?: Maybe<Scalars['smallint']['output']>;
  lock_expires_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  parkable_transaction_tasks: Array<Parkable_Transaction_Task>;
  /** An aggregate relationship */
  parkable_transaction_tasks_aggregate: Parkable_Transaction_Task_Aggregate;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  processing_at?: Maybe<Scalars['timestamp']['output']>;
  review_note?: Maybe<Scalars['String']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  sub_status?: Maybe<Scalars['smallint']['output']>;
  /** An array relationship */
  task_events: Array<Task_Events>;
  /** An aggregate relationship */
  task_events_aggregate: Task_Events_Aggregate;
  /** An array relationship */
  task_states: Array<Task_States>;
  /** An aggregate relationship */
  task_states_aggregate: Task_States_Aggregate;
  /** An array relationship */
  task_users: Array<Task_User>;
  /** An aggregate relationship */
  task_users_aggregate: Task_User_Aggregate;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "tasks" */
export type TasksParkable_Transaction_TasksArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Task_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
};


/** columns and relationships of "tasks" */
export type TasksParkable_Transaction_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Task_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
};


/** columns and relationships of "tasks" */
export type TasksTask_EventsArgs = {
  distinct_on?: InputMaybe<Array<Task_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Events_Order_By>>;
  where?: InputMaybe<Task_Events_Bool_Exp>;
};


/** columns and relationships of "tasks" */
export type TasksTask_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Events_Order_By>>;
  where?: InputMaybe<Task_Events_Bool_Exp>;
};


/** columns and relationships of "tasks" */
export type TasksTask_StatesArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Order_By>>;
  where?: InputMaybe<Task_States_Bool_Exp>;
};


/** columns and relationships of "tasks" */
export type TasksTask_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Order_By>>;
  where?: InputMaybe<Task_States_Bool_Exp>;
};


/** columns and relationships of "tasks" */
export type TasksTask_UsersArgs = {
  distinct_on?: InputMaybe<Array<Task_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_User_Order_By>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};


/** columns and relationships of "tasks" */
export type TasksTask_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_User_Order_By>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};

/** aggregated selection of "tasks" */
export type Tasks_Aggregate = {
  __typename?: 'tasks_aggregate';
  aggregate?: Maybe<Tasks_Aggregate_Fields>;
  nodes: Array<Tasks>;
};

/** aggregate fields of "tasks" */
export type Tasks_Aggregate_Fields = {
  __typename?: 'tasks_aggregate_fields';
  avg?: Maybe<Tasks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tasks_Max_Fields>;
  min?: Maybe<Tasks_Min_Fields>;
  stddev?: Maybe<Tasks_Stddev_Fields>;
  stddev_pop?: Maybe<Tasks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tasks_Stddev_Samp_Fields>;
  sum?: Maybe<Tasks_Sum_Fields>;
  var_pop?: Maybe<Tasks_Var_Pop_Fields>;
  var_samp?: Maybe<Tasks_Var_Samp_Fields>;
  variance?: Maybe<Tasks_Variance_Fields>;
};


/** aggregate fields of "tasks" */
export type Tasks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Tasks_Avg_Fields = {
  __typename?: 'tasks_avg_fields';
  last_life?: Maybe<Scalars['Float']['output']>;
  loaded_life?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tasks". All fields are combined with a logical 'AND'. */
export type Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Tasks_Bool_Exp>>;
  _not?: InputMaybe<Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Tasks_Bool_Exp>>;
  aborted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  check_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  failed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_cycle_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_error_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_life?: InputMaybe<Smallint_Comparison_Exp>;
  loaded_life?: InputMaybe<Smallint_Comparison_Exp>;
  lock_expires_at?: InputMaybe<Timestamp_Comparison_Exp>;
  parkable_transaction_tasks?: InputMaybe<Parkable_Transaction_Task_Bool_Exp>;
  parkable_transaction_tasks_aggregate?: InputMaybe<Parkable_Transaction_Task_Aggregate_Bool_Exp>;
  processed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  processing_at?: InputMaybe<Timestamp_Comparison_Exp>;
  review_note?: InputMaybe<String_Comparison_Exp>;
  reviewed?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  sub_status?: InputMaybe<Smallint_Comparison_Exp>;
  task_events?: InputMaybe<Task_Events_Bool_Exp>;
  task_events_aggregate?: InputMaybe<Task_Events_Aggregate_Bool_Exp>;
  task_states?: InputMaybe<Task_States_Bool_Exp>;
  task_states_aggregate?: InputMaybe<Task_States_Aggregate_Bool_Exp>;
  task_users?: InputMaybe<Task_User_Bool_Exp>;
  task_users_aggregate?: InputMaybe<Task_User_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tasks" */
export enum Tasks_Constraint {
  /** unique or primary key constraint on columns "id" */
  TasksPkey = 'tasks_pkey'
}

/** input type for incrementing numeric columns in table "tasks" */
export type Tasks_Inc_Input = {
  last_life?: InputMaybe<Scalars['smallint']['input']>;
  loaded_life?: InputMaybe<Scalars['smallint']['input']>;
  sub_status?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "tasks" */
export type Tasks_Insert_Input = {
  aborted_at?: InputMaybe<Scalars['timestamp']['input']>;
  check_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_cycle_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_error_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_life?: InputMaybe<Scalars['smallint']['input']>;
  loaded_life?: InputMaybe<Scalars['smallint']['input']>;
  lock_expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  parkable_transaction_tasks?: InputMaybe<Parkable_Transaction_Task_Arr_Rel_Insert_Input>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  review_note?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['smallint']['input']>;
  task_events?: InputMaybe<Task_Events_Arr_Rel_Insert_Input>;
  task_states?: InputMaybe<Task_States_Arr_Rel_Insert_Input>;
  task_users?: InputMaybe<Task_User_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Tasks_Max_Fields = {
  __typename?: 'tasks_max_fields';
  aborted_at?: Maybe<Scalars['timestamp']['output']>;
  check_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_cycle_at?: Maybe<Scalars['timestamp']['output']>;
  last_error_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_life?: Maybe<Scalars['smallint']['output']>;
  loaded_life?: Maybe<Scalars['smallint']['output']>;
  lock_expires_at?: Maybe<Scalars['timestamp']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  processing_at?: Maybe<Scalars['timestamp']['output']>;
  review_note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['smallint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Tasks_Min_Fields = {
  __typename?: 'tasks_min_fields';
  aborted_at?: Maybe<Scalars['timestamp']['output']>;
  check_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_cycle_at?: Maybe<Scalars['timestamp']['output']>;
  last_error_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_life?: Maybe<Scalars['smallint']['output']>;
  loaded_life?: Maybe<Scalars['smallint']['output']>;
  lock_expires_at?: Maybe<Scalars['timestamp']['output']>;
  processed_at?: Maybe<Scalars['timestamp']['output']>;
  processing_at?: Maybe<Scalars['timestamp']['output']>;
  review_note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['smallint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "tasks" */
export type Tasks_Mutation_Response = {
  __typename?: 'tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tasks>;
};

/** input type for inserting object relation for remote table "tasks" */
export type Tasks_Obj_Rel_Insert_Input = {
  data: Tasks_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tasks_On_Conflict>;
};

/** on_conflict condition type for table "tasks" */
export type Tasks_On_Conflict = {
  constraint: Tasks_Constraint;
  update_columns?: Array<Tasks_Update_Column>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

/** Ordering options when selecting data from "tasks". */
export type Tasks_Order_By = {
  aborted_at?: InputMaybe<Order_By>;
  check_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  failed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_cycle_at?: InputMaybe<Order_By>;
  last_error_at?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_life?: InputMaybe<Order_By>;
  loaded_life?: InputMaybe<Order_By>;
  lock_expires_at?: InputMaybe<Order_By>;
  parkable_transaction_tasks_aggregate?: InputMaybe<Parkable_Transaction_Task_Aggregate_Order_By>;
  processed_at?: InputMaybe<Order_By>;
  processing_at?: InputMaybe<Order_By>;
  review_note?: InputMaybe<Order_By>;
  reviewed?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_status?: InputMaybe<Order_By>;
  task_events_aggregate?: InputMaybe<Task_Events_Aggregate_Order_By>;
  task_states_aggregate?: InputMaybe<Task_States_Aggregate_Order_By>;
  task_users_aggregate?: InputMaybe<Task_User_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tasks */
export type Tasks_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tasks" */
export enum Tasks_Select_Column {
  /** column name */
  AbortedAt = 'aborted_at',
  /** column name */
  CheckAt = 'check_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastCycleAt = 'last_cycle_at',
  /** column name */
  LastErrorAt = 'last_error_at',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastLife = 'last_life',
  /** column name */
  LoadedLife = 'loaded_life',
  /** column name */
  LockExpiresAt = 'lock_expires_at',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ProcessingAt = 'processing_at',
  /** column name */
  ReviewNote = 'review_note',
  /** column name */
  Reviewed = 'reviewed',
  /** column name */
  Status = 'status',
  /** column name */
  SubStatus = 'sub_status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tasks" */
export type Tasks_Set_Input = {
  aborted_at?: InputMaybe<Scalars['timestamp']['input']>;
  check_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_cycle_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_error_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_life?: InputMaybe<Scalars['smallint']['input']>;
  loaded_life?: InputMaybe<Scalars['smallint']['input']>;
  lock_expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  review_note?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['smallint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Tasks_Stddev_Fields = {
  __typename?: 'tasks_stddev_fields';
  last_life?: Maybe<Scalars['Float']['output']>;
  loaded_life?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Tasks_Stddev_Pop_Fields = {
  __typename?: 'tasks_stddev_pop_fields';
  last_life?: Maybe<Scalars['Float']['output']>;
  loaded_life?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Tasks_Stddev_Samp_Fields = {
  __typename?: 'tasks_stddev_samp_fields';
  last_life?: Maybe<Scalars['Float']['output']>;
  loaded_life?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tasks" */
export type Tasks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tasks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tasks_Stream_Cursor_Value_Input = {
  aborted_at?: InputMaybe<Scalars['timestamp']['input']>;
  check_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_cycle_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_error_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_life?: InputMaybe<Scalars['smallint']['input']>;
  loaded_life?: InputMaybe<Scalars['smallint']['input']>;
  lock_expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  review_note?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['smallint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Tasks_Sum_Fields = {
  __typename?: 'tasks_sum_fields';
  last_life?: Maybe<Scalars['smallint']['output']>;
  loaded_life?: Maybe<Scalars['smallint']['output']>;
  sub_status?: Maybe<Scalars['smallint']['output']>;
};

/** update columns of table "tasks" */
export enum Tasks_Update_Column {
  /** column name */
  AbortedAt = 'aborted_at',
  /** column name */
  CheckAt = 'check_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastCycleAt = 'last_cycle_at',
  /** column name */
  LastErrorAt = 'last_error_at',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastLife = 'last_life',
  /** column name */
  LoadedLife = 'loaded_life',
  /** column name */
  LockExpiresAt = 'lock_expires_at',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ProcessingAt = 'processing_at',
  /** column name */
  ReviewNote = 'review_note',
  /** column name */
  Reviewed = 'reviewed',
  /** column name */
  Status = 'status',
  /** column name */
  SubStatus = 'sub_status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Tasks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tasks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tasks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tasks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tasks_Var_Pop_Fields = {
  __typename?: 'tasks_var_pop_fields';
  last_life?: Maybe<Scalars['Float']['output']>;
  loaded_life?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Tasks_Var_Samp_Fields = {
  __typename?: 'tasks_var_samp_fields';
  last_life?: Maybe<Scalars['Float']['output']>;
  loaded_life?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Tasks_Variance_Fields = {
  __typename?: 'tasks_variance_fields';
  last_life?: Maybe<Scalars['Float']['output']>;
  loaded_life?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** columns and relationships of "transfer_batches" */
export type Transfer_Batches = {
  __typename?: 'transfer_batches';
  approved_for_transfer: Scalars['Boolean']['output'];
  /** An object relationship */
  batch_set?: Maybe<Batch_Sets>;
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  card_net_count?: Maybe<Scalars['Int']['output']>;
  card_net_total?: Maybe<Scalars['Int']['output']>;
  card_return_count?: Maybe<Scalars['Int']['output']>;
  card_return_total?: Maybe<Scalars['Int']['output']>;
  card_sale_count?: Maybe<Scalars['Int']['output']>;
  card_sale_total?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_processed_at?: Maybe<Scalars['timestamp']['output']>;
  last_processing_at?: Maybe<Scalars['timestamp']['output']>;
  last_report_integrity_check_at?: Maybe<Scalars['timestamp']['output']>;
  last_report_integrity_check_status?: Maybe<Scalars['String']['output']>;
  net_count?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  parking_authority: Parking_Authorities;
  parking_authority_id: Scalars['bigint']['output'];
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  return_count?: Maybe<Scalars['Int']['output']>;
  return_total?: Maybe<Scalars['Int']['output']>;
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_total?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferred_at?: Maybe<Scalars['timestamp']['output']>;
  transferring_at?: Maybe<Scalars['timestamp']['output']>;
  try: Scalars['smallint']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  voided_at?: Maybe<Scalars['timestamp']['output']>;
  waiting_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_net_count?: Maybe<Scalars['Int']['output']>;
  wallet_net_total?: Maybe<Scalars['Int']['output']>;
  wallet_return_count?: Maybe<Scalars['Int']['output']>;
  wallet_return_total?: Maybe<Scalars['Int']['output']>;
  wallet_sale_count?: Maybe<Scalars['Int']['output']>;
  wallet_sale_total?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "transfer_batches" */
export type Transfer_BatchesPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "transfer_batches" */
export type Transfer_BatchesPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** aggregated selection of "transfer_batches" */
export type Transfer_Batches_Aggregate = {
  __typename?: 'transfer_batches_aggregate';
  aggregate?: Maybe<Transfer_Batches_Aggregate_Fields>;
  nodes: Array<Transfer_Batches>;
};

export type Transfer_Batches_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Transfer_Batches_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Transfer_Batches_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Transfer_Batches_Aggregate_Bool_Exp_Count>;
};

export type Transfer_Batches_Aggregate_Bool_Exp_Bool_And = {
  arguments: Transfer_Batches_Select_Column_Transfer_Batches_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transfer_Batches_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Transfer_Batches_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Transfer_Batches_Select_Column_Transfer_Batches_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transfer_Batches_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Transfer_Batches_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Transfer_Batches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transfer_Batches_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "transfer_batches" */
export type Transfer_Batches_Aggregate_Fields = {
  __typename?: 'transfer_batches_aggregate_fields';
  avg?: Maybe<Transfer_Batches_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Transfer_Batches_Max_Fields>;
  min?: Maybe<Transfer_Batches_Min_Fields>;
  stddev?: Maybe<Transfer_Batches_Stddev_Fields>;
  stddev_pop?: Maybe<Transfer_Batches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transfer_Batches_Stddev_Samp_Fields>;
  sum?: Maybe<Transfer_Batches_Sum_Fields>;
  var_pop?: Maybe<Transfer_Batches_Var_Pop_Fields>;
  var_samp?: Maybe<Transfer_Batches_Var_Samp_Fields>;
  variance?: Maybe<Transfer_Batches_Variance_Fields>;
};


/** aggregate fields of "transfer_batches" */
export type Transfer_Batches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transfer_Batches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "transfer_batches" */
export type Transfer_Batches_Aggregate_Order_By = {
  avg?: InputMaybe<Transfer_Batches_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transfer_Batches_Max_Order_By>;
  min?: InputMaybe<Transfer_Batches_Min_Order_By>;
  stddev?: InputMaybe<Transfer_Batches_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transfer_Batches_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transfer_Batches_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transfer_Batches_Sum_Order_By>;
  var_pop?: InputMaybe<Transfer_Batches_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transfer_Batches_Var_Samp_Order_By>;
  variance?: InputMaybe<Transfer_Batches_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "transfer_batches" */
export type Transfer_Batches_Arr_Rel_Insert_Input = {
  data: Array<Transfer_Batches_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transfer_Batches_On_Conflict>;
};

/** aggregate avg on columns */
export type Transfer_Batches_Avg_Fields = {
  __typename?: 'transfer_batches_avg_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "transfer_batches" */
export type Transfer_Batches_Avg_Order_By = {
  batch_set_id?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transfer_batches". All fields are combined with a logical 'AND'. */
export type Transfer_Batches_Bool_Exp = {
  _and?: InputMaybe<Array<Transfer_Batches_Bool_Exp>>;
  _not?: InputMaybe<Transfer_Batches_Bool_Exp>;
  _or?: InputMaybe<Array<Transfer_Batches_Bool_Exp>>;
  approved_for_transfer?: InputMaybe<Boolean_Comparison_Exp>;
  batch_set?: InputMaybe<Batch_Sets_Bool_Exp>;
  batch_set_id?: InputMaybe<Bigint_Comparison_Exp>;
  calculated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  calculating_at?: InputMaybe<Timestamp_Comparison_Exp>;
  card_net_count?: InputMaybe<Int_Comparison_Exp>;
  card_net_total?: InputMaybe<Int_Comparison_Exp>;
  card_return_count?: InputMaybe<Int_Comparison_Exp>;
  card_return_total?: InputMaybe<Int_Comparison_Exp>;
  card_sale_count?: InputMaybe<Int_Comparison_Exp>;
  card_sale_total?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  failed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_processed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_processing_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_report_integrity_check_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_report_integrity_check_status?: InputMaybe<String_Comparison_Exp>;
  net_count?: InputMaybe<Int_Comparison_Exp>;
  net_total?: InputMaybe<Int_Comparison_Exp>;
  num_etl_failures?: InputMaybe<Smallint_Comparison_Exp>;
  num_etls?: InputMaybe<Bigint_Comparison_Exp>;
  parking_authority?: InputMaybe<Parking_Authorities_Bool_Exp>;
  parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  return_count?: InputMaybe<Int_Comparison_Exp>;
  return_total?: InputMaybe<Int_Comparison_Exp>;
  sale_count?: InputMaybe<Int_Comparison_Exp>;
  sale_total?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  total_paid?: InputMaybe<Int_Comparison_Exp>;
  total_unpaid?: InputMaybe<Int_Comparison_Exp>;
  transferred_at?: InputMaybe<Timestamp_Comparison_Exp>;
  transferring_at?: InputMaybe<Timestamp_Comparison_Exp>;
  try?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  voided_at?: InputMaybe<Timestamp_Comparison_Exp>;
  waiting_at?: InputMaybe<Timestamp_Comparison_Exp>;
  wallet_net_count?: InputMaybe<Int_Comparison_Exp>;
  wallet_net_total?: InputMaybe<Int_Comparison_Exp>;
  wallet_return_count?: InputMaybe<Int_Comparison_Exp>;
  wallet_return_total?: InputMaybe<Int_Comparison_Exp>;
  wallet_sale_count?: InputMaybe<Int_Comparison_Exp>;
  wallet_sale_total?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "transfer_batches" */
export enum Transfer_Batches_Constraint {
  /** unique or primary key constraint on columns "parking_authority_id", "batch_set_id" */
  TransferBatchesBatchSetIdParkingAuthorityIdUnique = 'transfer_batches_batch_set_id_parking_authority_id_unique',
  /** unique or primary key constraint on columns "id" */
  TransferBatchesPkey = 'transfer_batches_pkey'
}

/** input type for incrementing numeric columns in table "transfer_batches" */
export type Transfer_Batches_Inc_Input = {
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  card_net_count?: InputMaybe<Scalars['Int']['input']>;
  card_net_total?: InputMaybe<Scalars['Int']['input']>;
  card_return_count?: InputMaybe<Scalars['Int']['input']>;
  card_return_total?: InputMaybe<Scalars['Int']['input']>;
  card_sale_count?: InputMaybe<Scalars['Int']['input']>;
  card_sale_total?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  net_count?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  return_count?: InputMaybe<Scalars['Int']['input']>;
  return_total?: InputMaybe<Scalars['Int']['input']>;
  sale_count?: InputMaybe<Scalars['Int']['input']>;
  sale_total?: InputMaybe<Scalars['Int']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  wallet_net_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_net_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_total?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "transfer_batches" */
export type Transfer_Batches_Insert_Input = {
  approved_for_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  batch_set?: InputMaybe<Batch_Sets_Obj_Rel_Insert_Input>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  card_net_count?: InputMaybe<Scalars['Int']['input']>;
  card_net_total?: InputMaybe<Scalars['Int']['input']>;
  card_return_count?: InputMaybe<Scalars['Int']['input']>;
  card_return_total?: InputMaybe<Scalars['Int']['input']>;
  card_sale_count?: InputMaybe<Scalars['Int']['input']>;
  card_sale_total?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_report_integrity_check_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_report_integrity_check_status?: InputMaybe<Scalars['String']['input']>;
  net_count?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority?: InputMaybe<Parking_Authorities_Obj_Rel_Insert_Input>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  return_count?: InputMaybe<Scalars['Int']['input']>;
  return_total?: InputMaybe<Scalars['Int']['input']>;
  sale_count?: InputMaybe<Scalars['Int']['input']>;
  sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  transferring_at?: InputMaybe<Scalars['timestamp']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  voided_at?: InputMaybe<Scalars['timestamp']['input']>;
  waiting_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_net_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_net_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_total?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Transfer_Batches_Max_Fields = {
  __typename?: 'transfer_batches_max_fields';
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  card_net_count?: Maybe<Scalars['Int']['output']>;
  card_net_total?: Maybe<Scalars['Int']['output']>;
  card_return_count?: Maybe<Scalars['Int']['output']>;
  card_return_total?: Maybe<Scalars['Int']['output']>;
  card_sale_count?: Maybe<Scalars['Int']['output']>;
  card_sale_total?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_processed_at?: Maybe<Scalars['timestamp']['output']>;
  last_processing_at?: Maybe<Scalars['timestamp']['output']>;
  last_report_integrity_check_at?: Maybe<Scalars['timestamp']['output']>;
  last_report_integrity_check_status?: Maybe<Scalars['String']['output']>;
  net_count?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  return_count?: Maybe<Scalars['Int']['output']>;
  return_total?: Maybe<Scalars['Int']['output']>;
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_total?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferred_at?: Maybe<Scalars['timestamp']['output']>;
  transferring_at?: Maybe<Scalars['timestamp']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  voided_at?: Maybe<Scalars['timestamp']['output']>;
  waiting_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_net_count?: Maybe<Scalars['Int']['output']>;
  wallet_net_total?: Maybe<Scalars['Int']['output']>;
  wallet_return_count?: Maybe<Scalars['Int']['output']>;
  wallet_return_total?: Maybe<Scalars['Int']['output']>;
  wallet_sale_count?: Maybe<Scalars['Int']['output']>;
  wallet_sale_total?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "transfer_batches" */
export type Transfer_Batches_Max_Order_By = {
  batch_set_id?: InputMaybe<Order_By>;
  calculated_at?: InputMaybe<Order_By>;
  calculating_at?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_processed_at?: InputMaybe<Order_By>;
  last_processing_at?: InputMaybe<Order_By>;
  last_report_integrity_check_at?: InputMaybe<Order_By>;
  last_report_integrity_check_status?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferred_at?: InputMaybe<Order_By>;
  transferring_at?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  voided_at?: InputMaybe<Order_By>;
  waiting_at?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transfer_Batches_Min_Fields = {
  __typename?: 'transfer_batches_min_fields';
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  calculated_at?: Maybe<Scalars['timestamp']['output']>;
  calculating_at?: Maybe<Scalars['timestamp']['output']>;
  card_net_count?: Maybe<Scalars['Int']['output']>;
  card_net_total?: Maybe<Scalars['Int']['output']>;
  card_return_count?: Maybe<Scalars['Int']['output']>;
  card_return_total?: Maybe<Scalars['Int']['output']>;
  card_sale_count?: Maybe<Scalars['Int']['output']>;
  card_sale_total?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  failed_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_processed_at?: Maybe<Scalars['timestamp']['output']>;
  last_processing_at?: Maybe<Scalars['timestamp']['output']>;
  last_report_integrity_check_at?: Maybe<Scalars['timestamp']['output']>;
  last_report_integrity_check_status?: Maybe<Scalars['String']['output']>;
  net_count?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  return_count?: Maybe<Scalars['Int']['output']>;
  return_total?: Maybe<Scalars['Int']['output']>;
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_total?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  transferred_at?: Maybe<Scalars['timestamp']['output']>;
  transferring_at?: Maybe<Scalars['timestamp']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  voided_at?: Maybe<Scalars['timestamp']['output']>;
  waiting_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_net_count?: Maybe<Scalars['Int']['output']>;
  wallet_net_total?: Maybe<Scalars['Int']['output']>;
  wallet_return_count?: Maybe<Scalars['Int']['output']>;
  wallet_return_total?: Maybe<Scalars['Int']['output']>;
  wallet_sale_count?: Maybe<Scalars['Int']['output']>;
  wallet_sale_total?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "transfer_batches" */
export type Transfer_Batches_Min_Order_By = {
  batch_set_id?: InputMaybe<Order_By>;
  calculated_at?: InputMaybe<Order_By>;
  calculating_at?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_processed_at?: InputMaybe<Order_By>;
  last_processing_at?: InputMaybe<Order_By>;
  last_report_integrity_check_at?: InputMaybe<Order_By>;
  last_report_integrity_check_status?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferred_at?: InputMaybe<Order_By>;
  transferring_at?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  voided_at?: InputMaybe<Order_By>;
  waiting_at?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transfer_batches" */
export type Transfer_Batches_Mutation_Response = {
  __typename?: 'transfer_batches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transfer_Batches>;
};

/** input type for inserting object relation for remote table "transfer_batches" */
export type Transfer_Batches_Obj_Rel_Insert_Input = {
  data: Transfer_Batches_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transfer_Batches_On_Conflict>;
};

/** on_conflict condition type for table "transfer_batches" */
export type Transfer_Batches_On_Conflict = {
  constraint: Transfer_Batches_Constraint;
  update_columns?: Array<Transfer_Batches_Update_Column>;
  where?: InputMaybe<Transfer_Batches_Bool_Exp>;
};

/** Ordering options when selecting data from "transfer_batches". */
export type Transfer_Batches_Order_By = {
  approved_for_transfer?: InputMaybe<Order_By>;
  batch_set?: InputMaybe<Batch_Sets_Order_By>;
  batch_set_id?: InputMaybe<Order_By>;
  calculated_at?: InputMaybe<Order_By>;
  calculating_at?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  failed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_processed_at?: InputMaybe<Order_By>;
  last_processing_at?: InputMaybe<Order_By>;
  last_report_integrity_check_at?: InputMaybe<Order_By>;
  last_report_integrity_check_status?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority?: InputMaybe<Parking_Authorities_Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  transferred_at?: InputMaybe<Order_By>;
  transferring_at?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  voided_at?: InputMaybe<Order_By>;
  waiting_at?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transfer_batches */
export type Transfer_Batches_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "transfer_batches" */
export enum Transfer_Batches_Select_Column {
  /** column name */
  ApprovedForTransfer = 'approved_for_transfer',
  /** column name */
  BatchSetId = 'batch_set_id',
  /** column name */
  CalculatedAt = 'calculated_at',
  /** column name */
  CalculatingAt = 'calculating_at',
  /** column name */
  CardNetCount = 'card_net_count',
  /** column name */
  CardNetTotal = 'card_net_total',
  /** column name */
  CardReturnCount = 'card_return_count',
  /** column name */
  CardReturnTotal = 'card_return_total',
  /** column name */
  CardSaleCount = 'card_sale_count',
  /** column name */
  CardSaleTotal = 'card_sale_total',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastProcessedAt = 'last_processed_at',
  /** column name */
  LastProcessingAt = 'last_processing_at',
  /** column name */
  LastReportIntegrityCheckAt = 'last_report_integrity_check_at',
  /** column name */
  LastReportIntegrityCheckStatus = 'last_report_integrity_check_status',
  /** column name */
  NetCount = 'net_count',
  /** column name */
  NetTotal = 'net_total',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  ReturnCount = 'return_count',
  /** column name */
  ReturnTotal = 'return_total',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleTotal = 'sale_total',
  /** column name */
  Status = 'status',
  /** column name */
  TotalPaid = 'total_paid',
  /** column name */
  TotalUnpaid = 'total_unpaid',
  /** column name */
  TransferredAt = 'transferred_at',
  /** column name */
  TransferringAt = 'transferring_at',
  /** column name */
  Try = 'try',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidedAt = 'voided_at',
  /** column name */
  WaitingAt = 'waiting_at',
  /** column name */
  WalletNetCount = 'wallet_net_count',
  /** column name */
  WalletNetTotal = 'wallet_net_total',
  /** column name */
  WalletReturnCount = 'wallet_return_count',
  /** column name */
  WalletReturnTotal = 'wallet_return_total',
  /** column name */
  WalletSaleCount = 'wallet_sale_count',
  /** column name */
  WalletSaleTotal = 'wallet_sale_total'
}

/** select "transfer_batches_aggregate_bool_exp_bool_and_arguments_columns" columns of table "transfer_batches" */
export enum Transfer_Batches_Select_Column_Transfer_Batches_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ApprovedForTransfer = 'approved_for_transfer'
}

/** select "transfer_batches_aggregate_bool_exp_bool_or_arguments_columns" columns of table "transfer_batches" */
export enum Transfer_Batches_Select_Column_Transfer_Batches_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ApprovedForTransfer = 'approved_for_transfer'
}

/** input type for updating data in table "transfer_batches" */
export type Transfer_Batches_Set_Input = {
  approved_for_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  card_net_count?: InputMaybe<Scalars['Int']['input']>;
  card_net_total?: InputMaybe<Scalars['Int']['input']>;
  card_return_count?: InputMaybe<Scalars['Int']['input']>;
  card_return_total?: InputMaybe<Scalars['Int']['input']>;
  card_sale_count?: InputMaybe<Scalars['Int']['input']>;
  card_sale_total?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_report_integrity_check_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_report_integrity_check_status?: InputMaybe<Scalars['String']['input']>;
  net_count?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  return_count?: InputMaybe<Scalars['Int']['input']>;
  return_total?: InputMaybe<Scalars['Int']['input']>;
  sale_count?: InputMaybe<Scalars['Int']['input']>;
  sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  transferring_at?: InputMaybe<Scalars['timestamp']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  voided_at?: InputMaybe<Scalars['timestamp']['input']>;
  waiting_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_net_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_net_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_total?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Transfer_Batches_Stddev_Fields = {
  __typename?: 'transfer_batches_stddev_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "transfer_batches" */
export type Transfer_Batches_Stddev_Order_By = {
  batch_set_id?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transfer_Batches_Stddev_Pop_Fields = {
  __typename?: 'transfer_batches_stddev_pop_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "transfer_batches" */
export type Transfer_Batches_Stddev_Pop_Order_By = {
  batch_set_id?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transfer_Batches_Stddev_Samp_Fields = {
  __typename?: 'transfer_batches_stddev_samp_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "transfer_batches" */
export type Transfer_Batches_Stddev_Samp_Order_By = {
  batch_set_id?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transfer_batches" */
export type Transfer_Batches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transfer_Batches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transfer_Batches_Stream_Cursor_Value_Input = {
  approved_for_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  batch_set_id?: InputMaybe<Scalars['bigint']['input']>;
  calculated_at?: InputMaybe<Scalars['timestamp']['input']>;
  calculating_at?: InputMaybe<Scalars['timestamp']['input']>;
  card_net_count?: InputMaybe<Scalars['Int']['input']>;
  card_net_total?: InputMaybe<Scalars['Int']['input']>;
  card_return_count?: InputMaybe<Scalars['Int']['input']>;
  card_return_total?: InputMaybe<Scalars['Int']['input']>;
  card_sale_count?: InputMaybe<Scalars['Int']['input']>;
  card_sale_total?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  failed_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processed_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_processing_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_report_integrity_check_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_report_integrity_check_status?: InputMaybe<Scalars['String']['input']>;
  net_count?: InputMaybe<Scalars['Int']['input']>;
  net_total?: InputMaybe<Scalars['Int']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  return_count?: InputMaybe<Scalars['Int']['input']>;
  return_total?: InputMaybe<Scalars['Int']['input']>;
  sale_count?: InputMaybe<Scalars['Int']['input']>;
  sale_total?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_paid?: InputMaybe<Scalars['Int']['input']>;
  total_unpaid?: InputMaybe<Scalars['Int']['input']>;
  transferred_at?: InputMaybe<Scalars['timestamp']['input']>;
  transferring_at?: InputMaybe<Scalars['timestamp']['input']>;
  try?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  voided_at?: InputMaybe<Scalars['timestamp']['input']>;
  waiting_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_net_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_net_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_return_total?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_count?: InputMaybe<Scalars['Int']['input']>;
  wallet_sale_total?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Transfer_Batches_Sum_Fields = {
  __typename?: 'transfer_batches_sum_fields';
  batch_set_id?: Maybe<Scalars['bigint']['output']>;
  card_net_count?: Maybe<Scalars['Int']['output']>;
  card_net_total?: Maybe<Scalars['Int']['output']>;
  card_return_count?: Maybe<Scalars['Int']['output']>;
  card_return_total?: Maybe<Scalars['Int']['output']>;
  card_sale_count?: Maybe<Scalars['Int']['output']>;
  card_sale_total?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  net_count?: Maybe<Scalars['Int']['output']>;
  net_total?: Maybe<Scalars['Int']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  return_count?: Maybe<Scalars['Int']['output']>;
  return_total?: Maybe<Scalars['Int']['output']>;
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_total?: Maybe<Scalars['Int']['output']>;
  total_paid?: Maybe<Scalars['Int']['output']>;
  total_unpaid?: Maybe<Scalars['Int']['output']>;
  try?: Maybe<Scalars['smallint']['output']>;
  wallet_net_count?: Maybe<Scalars['Int']['output']>;
  wallet_net_total?: Maybe<Scalars['Int']['output']>;
  wallet_return_count?: Maybe<Scalars['Int']['output']>;
  wallet_return_total?: Maybe<Scalars['Int']['output']>;
  wallet_sale_count?: Maybe<Scalars['Int']['output']>;
  wallet_sale_total?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "transfer_batches" */
export type Transfer_Batches_Sum_Order_By = {
  batch_set_id?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** update columns of table "transfer_batches" */
export enum Transfer_Batches_Update_Column {
  /** column name */
  ApprovedForTransfer = 'approved_for_transfer',
  /** column name */
  BatchSetId = 'batch_set_id',
  /** column name */
  CalculatedAt = 'calculated_at',
  /** column name */
  CalculatingAt = 'calculating_at',
  /** column name */
  CardNetCount = 'card_net_count',
  /** column name */
  CardNetTotal = 'card_net_total',
  /** column name */
  CardReturnCount = 'card_return_count',
  /** column name */
  CardReturnTotal = 'card_return_total',
  /** column name */
  CardSaleCount = 'card_sale_count',
  /** column name */
  CardSaleTotal = 'card_sale_total',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastProcessedAt = 'last_processed_at',
  /** column name */
  LastProcessingAt = 'last_processing_at',
  /** column name */
  LastReportIntegrityCheckAt = 'last_report_integrity_check_at',
  /** column name */
  LastReportIntegrityCheckStatus = 'last_report_integrity_check_status',
  /** column name */
  NetCount = 'net_count',
  /** column name */
  NetTotal = 'net_total',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  ParkingAuthorityId = 'parking_authority_id',
  /** column name */
  ReturnCount = 'return_count',
  /** column name */
  ReturnTotal = 'return_total',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleTotal = 'sale_total',
  /** column name */
  Status = 'status',
  /** column name */
  TotalPaid = 'total_paid',
  /** column name */
  TotalUnpaid = 'total_unpaid',
  /** column name */
  TransferredAt = 'transferred_at',
  /** column name */
  TransferringAt = 'transferring_at',
  /** column name */
  Try = 'try',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidedAt = 'voided_at',
  /** column name */
  WaitingAt = 'waiting_at',
  /** column name */
  WalletNetCount = 'wallet_net_count',
  /** column name */
  WalletNetTotal = 'wallet_net_total',
  /** column name */
  WalletReturnCount = 'wallet_return_count',
  /** column name */
  WalletReturnTotal = 'wallet_return_total',
  /** column name */
  WalletSaleCount = 'wallet_sale_count',
  /** column name */
  WalletSaleTotal = 'wallet_sale_total'
}

export type Transfer_Batches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transfer_Batches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transfer_Batches_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transfer_Batches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transfer_Batches_Var_Pop_Fields = {
  __typename?: 'transfer_batches_var_pop_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "transfer_batches" */
export type Transfer_Batches_Var_Pop_Order_By = {
  batch_set_id?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transfer_Batches_Var_Samp_Fields = {
  __typename?: 'transfer_batches_var_samp_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "transfer_batches" */
export type Transfer_Batches_Var_Samp_Order_By = {
  batch_set_id?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transfer_Batches_Variance_Fields = {
  __typename?: 'transfer_batches_variance_fields';
  batch_set_id?: Maybe<Scalars['Float']['output']>;
  card_net_count?: Maybe<Scalars['Float']['output']>;
  card_net_total?: Maybe<Scalars['Float']['output']>;
  card_return_count?: Maybe<Scalars['Float']['output']>;
  card_return_total?: Maybe<Scalars['Float']['output']>;
  card_sale_count?: Maybe<Scalars['Float']['output']>;
  card_sale_total?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  net_count?: Maybe<Scalars['Float']['output']>;
  net_total?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  parking_authority_id?: Maybe<Scalars['Float']['output']>;
  return_count?: Maybe<Scalars['Float']['output']>;
  return_total?: Maybe<Scalars['Float']['output']>;
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_total?: Maybe<Scalars['Float']['output']>;
  total_paid?: Maybe<Scalars['Float']['output']>;
  total_unpaid?: Maybe<Scalars['Float']['output']>;
  try?: Maybe<Scalars['Float']['output']>;
  wallet_net_count?: Maybe<Scalars['Float']['output']>;
  wallet_net_total?: Maybe<Scalars['Float']['output']>;
  wallet_return_count?: Maybe<Scalars['Float']['output']>;
  wallet_return_total?: Maybe<Scalars['Float']['output']>;
  wallet_sale_count?: Maybe<Scalars['Float']['output']>;
  wallet_sale_total?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "transfer_batches" */
export type Transfer_Batches_Variance_Order_By = {
  batch_set_id?: InputMaybe<Order_By>;
  card_net_count?: InputMaybe<Order_By>;
  card_net_total?: InputMaybe<Order_By>;
  card_return_count?: InputMaybe<Order_By>;
  card_return_total?: InputMaybe<Order_By>;
  card_sale_count?: InputMaybe<Order_By>;
  card_sale_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  net_count?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  parking_authority_id?: InputMaybe<Order_By>;
  return_count?: InputMaybe<Order_By>;
  return_total?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_total?: InputMaybe<Order_By>;
  total_paid?: InputMaybe<Order_By>;
  total_unpaid?: InputMaybe<Order_By>;
  try?: InputMaybe<Order_By>;
  wallet_net_count?: InputMaybe<Order_By>;
  wallet_net_total?: InputMaybe<Order_By>;
  wallet_return_count?: InputMaybe<Order_By>;
  wallet_return_total?: InputMaybe<Order_By>;
  wallet_sale_count?: InputMaybe<Order_By>;
  wallet_sale_total?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_activities" */
export type User_Activities = {
  __typename?: 'user_activities';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data?: Maybe<Scalars['json']['output']>;
  id: Scalars['bigint']['output'];
  significance: Scalars['smallint']['output'];
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "user_activities" */
export type User_ActivitiesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "user_activities" */
export type User_Activities_Aggregate = {
  __typename?: 'user_activities_aggregate';
  aggregate?: Maybe<User_Activities_Aggregate_Fields>;
  nodes: Array<User_Activities>;
};

export type User_Activities_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Activities_Aggregate_Bool_Exp_Count>;
};

export type User_Activities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Activities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_activities" */
export type User_Activities_Aggregate_Fields = {
  __typename?: 'user_activities_aggregate_fields';
  avg?: Maybe<User_Activities_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Activities_Max_Fields>;
  min?: Maybe<User_Activities_Min_Fields>;
  stddev?: Maybe<User_Activities_Stddev_Fields>;
  stddev_pop?: Maybe<User_Activities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Activities_Stddev_Samp_Fields>;
  sum?: Maybe<User_Activities_Sum_Fields>;
  var_pop?: Maybe<User_Activities_Var_Pop_Fields>;
  var_samp?: Maybe<User_Activities_Var_Samp_Fields>;
  variance?: Maybe<User_Activities_Variance_Fields>;
};


/** aggregate fields of "user_activities" */
export type User_Activities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_activities" */
export type User_Activities_Aggregate_Order_By = {
  avg?: InputMaybe<User_Activities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Activities_Max_Order_By>;
  min?: InputMaybe<User_Activities_Min_Order_By>;
  stddev?: InputMaybe<User_Activities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Activities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Activities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Activities_Sum_Order_By>;
  var_pop?: InputMaybe<User_Activities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Activities_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Activities_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_activities" */
export type User_Activities_Arr_Rel_Insert_Input = {
  data: Array<User_Activities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Activities_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Activities_Avg_Fields = {
  __typename?: 'user_activities_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  significance?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_activities" */
export type User_Activities_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_activities". All fields are combined with a logical 'AND'. */
export type User_Activities_Bool_Exp = {
  _and?: InputMaybe<Array<User_Activities_Bool_Exp>>;
  _not?: InputMaybe<User_Activities_Bool_Exp>;
  _or?: InputMaybe<Array<User_Activities_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  significance?: InputMaybe<Smallint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_activities" */
export enum User_Activities_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserActivitiesPkey = 'user_activities_pkey'
}

/** input type for incrementing numeric columns in table "user_activities" */
export type User_Activities_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  significance?: InputMaybe<Scalars['smallint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "user_activities" */
export type User_Activities_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  significance?: InputMaybe<Scalars['smallint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type User_Activities_Max_Fields = {
  __typename?: 'user_activities_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  significance?: Maybe<Scalars['smallint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "user_activities" */
export type User_Activities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Activities_Min_Fields = {
  __typename?: 'user_activities_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  significance?: Maybe<Scalars['smallint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "user_activities" */
export type User_Activities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_activities" */
export type User_Activities_Mutation_Response = {
  __typename?: 'user_activities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Activities>;
};

/** on_conflict condition type for table "user_activities" */
export type User_Activities_On_Conflict = {
  constraint: User_Activities_Constraint;
  update_columns?: Array<User_Activities_Update_Column>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};

/** Ordering options when selecting data from "user_activities". */
export type User_Activities_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_activities */
export type User_Activities_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "user_activities" */
export enum User_Activities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Significance = 'significance',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_activities" */
export type User_Activities_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  significance?: InputMaybe<Scalars['smallint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type User_Activities_Stddev_Fields = {
  __typename?: 'user_activities_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  significance?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_activities" */
export type User_Activities_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Activities_Stddev_Pop_Fields = {
  __typename?: 'user_activities_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  significance?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_activities" */
export type User_Activities_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Activities_Stddev_Samp_Fields = {
  __typename?: 'user_activities_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  significance?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_activities" */
export type User_Activities_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_activities" */
export type User_Activities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Activities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Activities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  significance?: InputMaybe<Scalars['smallint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type User_Activities_Sum_Fields = {
  __typename?: 'user_activities_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  significance?: Maybe<Scalars['smallint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "user_activities" */
export type User_Activities_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_activities" */
export enum User_Activities_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Significance = 'significance',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Activities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Activities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Activities_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Activities_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Activities_Var_Pop_Fields = {
  __typename?: 'user_activities_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  significance?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_activities" */
export type User_Activities_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Activities_Var_Samp_Fields = {
  __typename?: 'user_activities_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  significance?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_activities" */
export type User_Activities_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Activities_Variance_Fields = {
  __typename?: 'user_activities_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  significance?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_activities" */
export type User_Activities_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  significance?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_lists" */
export type User_Lists = {
  __typename?: 'user_lists';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  num_contacted: Scalars['Int']['output'];
  num_ignored: Scalars['Int']['output'];
  num_opted_out: Scalars['Int']['output'];
  num_pending_outreach: Scalars['Int']['output'];
  num_users: Scalars['Int']['output'];
  priority: Scalars['smallint']['output'];
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  user_user_lists: Array<User_User_List>;
  /** An aggregate relationship */
  user_user_lists_aggregate: User_User_List_Aggregate;
};


/** columns and relationships of "user_lists" */
export type User_ListsUser_User_ListsArgs = {
  distinct_on?: InputMaybe<Array<User_User_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_User_List_Order_By>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};


/** columns and relationships of "user_lists" */
export type User_ListsUser_User_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_User_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_User_List_Order_By>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};

/** aggregated selection of "user_lists" */
export type User_Lists_Aggregate = {
  __typename?: 'user_lists_aggregate';
  aggregate?: Maybe<User_Lists_Aggregate_Fields>;
  nodes: Array<User_Lists>;
};

/** aggregate fields of "user_lists" */
export type User_Lists_Aggregate_Fields = {
  __typename?: 'user_lists_aggregate_fields';
  avg?: Maybe<User_Lists_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Lists_Max_Fields>;
  min?: Maybe<User_Lists_Min_Fields>;
  stddev?: Maybe<User_Lists_Stddev_Fields>;
  stddev_pop?: Maybe<User_Lists_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Lists_Stddev_Samp_Fields>;
  sum?: Maybe<User_Lists_Sum_Fields>;
  var_pop?: Maybe<User_Lists_Var_Pop_Fields>;
  var_samp?: Maybe<User_Lists_Var_Samp_Fields>;
  variance?: Maybe<User_Lists_Variance_Fields>;
};


/** aggregate fields of "user_lists" */
export type User_Lists_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Lists_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Lists_Avg_Fields = {
  __typename?: 'user_lists_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_contacted?: Maybe<Scalars['Float']['output']>;
  num_ignored?: Maybe<Scalars['Float']['output']>;
  num_opted_out?: Maybe<Scalars['Float']['output']>;
  num_pending_outreach?: Maybe<Scalars['Float']['output']>;
  num_users?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_lists". All fields are combined with a logical 'AND'. */
export type User_Lists_Bool_Exp = {
  _and?: InputMaybe<Array<User_Lists_Bool_Exp>>;
  _not?: InputMaybe<User_Lists_Bool_Exp>;
  _or?: InputMaybe<Array<User_Lists_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  num_contacted?: InputMaybe<Int_Comparison_Exp>;
  num_ignored?: InputMaybe<Int_Comparison_Exp>;
  num_opted_out?: InputMaybe<Int_Comparison_Exp>;
  num_pending_outreach?: InputMaybe<Int_Comparison_Exp>;
  num_users?: InputMaybe<Int_Comparison_Exp>;
  priority?: InputMaybe<Smallint_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_user_lists?: InputMaybe<User_User_List_Bool_Exp>;
  user_user_lists_aggregate?: InputMaybe<User_User_List_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user_lists" */
export enum User_Lists_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserListsPkey = 'user_lists_pkey',
  /** unique or primary key constraint on columns "slug" */
  UserListsSlugUnique = 'user_lists_slug_unique'
}

/** input type for incrementing numeric columns in table "user_lists" */
export type User_Lists_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  num_contacted?: InputMaybe<Scalars['Int']['input']>;
  num_ignored?: InputMaybe<Scalars['Int']['input']>;
  num_opted_out?: InputMaybe<Scalars['Int']['input']>;
  num_pending_outreach?: InputMaybe<Scalars['Int']['input']>;
  num_users?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "user_lists" */
export type User_Lists_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  num_contacted?: InputMaybe<Scalars['Int']['input']>;
  num_ignored?: InputMaybe<Scalars['Int']['input']>;
  num_opted_out?: InputMaybe<Scalars['Int']['input']>;
  num_pending_outreach?: InputMaybe<Scalars['Int']['input']>;
  num_users?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['smallint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_user_lists?: InputMaybe<User_User_List_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Lists_Max_Fields = {
  __typename?: 'user_lists_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  num_contacted?: Maybe<Scalars['Int']['output']>;
  num_ignored?: Maybe<Scalars['Int']['output']>;
  num_opted_out?: Maybe<Scalars['Int']['output']>;
  num_pending_outreach?: Maybe<Scalars['Int']['output']>;
  num_users?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['smallint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type User_Lists_Min_Fields = {
  __typename?: 'user_lists_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  num_contacted?: Maybe<Scalars['Int']['output']>;
  num_ignored?: Maybe<Scalars['Int']['output']>;
  num_opted_out?: Maybe<Scalars['Int']['output']>;
  num_pending_outreach?: Maybe<Scalars['Int']['output']>;
  num_users?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['smallint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "user_lists" */
export type User_Lists_Mutation_Response = {
  __typename?: 'user_lists_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Lists>;
};

/** input type for inserting object relation for remote table "user_lists" */
export type User_Lists_Obj_Rel_Insert_Input = {
  data: User_Lists_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Lists_On_Conflict>;
};

/** on_conflict condition type for table "user_lists" */
export type User_Lists_On_Conflict = {
  constraint: User_Lists_Constraint;
  update_columns?: Array<User_Lists_Update_Column>;
  where?: InputMaybe<User_Lists_Bool_Exp>;
};

/** Ordering options when selecting data from "user_lists". */
export type User_Lists_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  num_contacted?: InputMaybe<Order_By>;
  num_ignored?: InputMaybe<Order_By>;
  num_opted_out?: InputMaybe<Order_By>;
  num_pending_outreach?: InputMaybe<Order_By>;
  num_users?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_user_lists_aggregate?: InputMaybe<User_User_List_Aggregate_Order_By>;
};

/** primary key columns input for table: user_lists */
export type User_Lists_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "user_lists" */
export enum User_Lists_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NumContacted = 'num_contacted',
  /** column name */
  NumIgnored = 'num_ignored',
  /** column name */
  NumOptedOut = 'num_opted_out',
  /** column name */
  NumPendingOutreach = 'num_pending_outreach',
  /** column name */
  NumUsers = 'num_users',
  /** column name */
  Priority = 'priority',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user_lists" */
export type User_Lists_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  num_contacted?: InputMaybe<Scalars['Int']['input']>;
  num_ignored?: InputMaybe<Scalars['Int']['input']>;
  num_opted_out?: InputMaybe<Scalars['Int']['input']>;
  num_pending_outreach?: InputMaybe<Scalars['Int']['input']>;
  num_users?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['smallint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type User_Lists_Stddev_Fields = {
  __typename?: 'user_lists_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_contacted?: Maybe<Scalars['Float']['output']>;
  num_ignored?: Maybe<Scalars['Float']['output']>;
  num_opted_out?: Maybe<Scalars['Float']['output']>;
  num_pending_outreach?: Maybe<Scalars['Float']['output']>;
  num_users?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Lists_Stddev_Pop_Fields = {
  __typename?: 'user_lists_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_contacted?: Maybe<Scalars['Float']['output']>;
  num_ignored?: Maybe<Scalars['Float']['output']>;
  num_opted_out?: Maybe<Scalars['Float']['output']>;
  num_pending_outreach?: Maybe<Scalars['Float']['output']>;
  num_users?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Lists_Stddev_Samp_Fields = {
  __typename?: 'user_lists_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_contacted?: Maybe<Scalars['Float']['output']>;
  num_ignored?: Maybe<Scalars['Float']['output']>;
  num_opted_out?: Maybe<Scalars['Float']['output']>;
  num_pending_outreach?: Maybe<Scalars['Float']['output']>;
  num_users?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_lists" */
export type User_Lists_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Lists_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Lists_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  num_contacted?: InputMaybe<Scalars['Int']['input']>;
  num_ignored?: InputMaybe<Scalars['Int']['input']>;
  num_opted_out?: InputMaybe<Scalars['Int']['input']>;
  num_pending_outreach?: InputMaybe<Scalars['Int']['input']>;
  num_users?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['smallint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type User_Lists_Sum_Fields = {
  __typename?: 'user_lists_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  num_contacted?: Maybe<Scalars['Int']['output']>;
  num_ignored?: Maybe<Scalars['Int']['output']>;
  num_opted_out?: Maybe<Scalars['Int']['output']>;
  num_pending_outreach?: Maybe<Scalars['Int']['output']>;
  num_users?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['smallint']['output']>;
};

/** update columns of table "user_lists" */
export enum User_Lists_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NumContacted = 'num_contacted',
  /** column name */
  NumIgnored = 'num_ignored',
  /** column name */
  NumOptedOut = 'num_opted_out',
  /** column name */
  NumPendingOutreach = 'num_pending_outreach',
  /** column name */
  NumUsers = 'num_users',
  /** column name */
  Priority = 'priority',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Lists_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Lists_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Lists_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Lists_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Lists_Var_Pop_Fields = {
  __typename?: 'user_lists_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_contacted?: Maybe<Scalars['Float']['output']>;
  num_ignored?: Maybe<Scalars['Float']['output']>;
  num_opted_out?: Maybe<Scalars['Float']['output']>;
  num_pending_outreach?: Maybe<Scalars['Float']['output']>;
  num_users?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Lists_Var_Samp_Fields = {
  __typename?: 'user_lists_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_contacted?: Maybe<Scalars['Float']['output']>;
  num_ignored?: Maybe<Scalars['Float']['output']>;
  num_opted_out?: Maybe<Scalars['Float']['output']>;
  num_pending_outreach?: Maybe<Scalars['Float']['output']>;
  num_users?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Lists_Variance_Fields = {
  __typename?: 'user_lists_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_contacted?: Maybe<Scalars['Float']['output']>;
  num_ignored?: Maybe<Scalars['Float']['output']>;
  num_opted_out?: Maybe<Scalars['Float']['output']>;
  num_pending_outreach?: Maybe<Scalars['Float']['output']>;
  num_users?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_settings" */
export type User_Settings = {
  __typename?: 'user_settings';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['bigint']['output'];
  is_legacy: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['bigint']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_settings" */
export type User_Settings_Aggregate = {
  __typename?: 'user_settings_aggregate';
  aggregate?: Maybe<User_Settings_Aggregate_Fields>;
  nodes: Array<User_Settings>;
};

export type User_Settings_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Settings_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Settings_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Settings_Aggregate_Bool_Exp_Count>;
};

export type User_Settings_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Settings_Select_Column_User_Settings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Settings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Settings_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Settings_Select_Column_User_Settings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Settings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Settings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Settings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_settings" */
export type User_Settings_Aggregate_Fields = {
  __typename?: 'user_settings_aggregate_fields';
  avg?: Maybe<User_Settings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Settings_Max_Fields>;
  min?: Maybe<User_Settings_Min_Fields>;
  stddev?: Maybe<User_Settings_Stddev_Fields>;
  stddev_pop?: Maybe<User_Settings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Settings_Stddev_Samp_Fields>;
  sum?: Maybe<User_Settings_Sum_Fields>;
  var_pop?: Maybe<User_Settings_Var_Pop_Fields>;
  var_samp?: Maybe<User_Settings_Var_Samp_Fields>;
  variance?: Maybe<User_Settings_Variance_Fields>;
};


/** aggregate fields of "user_settings" */
export type User_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_settings" */
export type User_Settings_Aggregate_Order_By = {
  avg?: InputMaybe<User_Settings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Settings_Max_Order_By>;
  min?: InputMaybe<User_Settings_Min_Order_By>;
  stddev?: InputMaybe<User_Settings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Settings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Settings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Settings_Sum_Order_By>;
  var_pop?: InputMaybe<User_Settings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Settings_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Settings_Variance_Order_By>;
};

/** columns and relationships of "user_settings_all" */
export type User_Settings_All = {
  __typename?: 'user_settings_all';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  is_legacy?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_settings_all" */
export type User_Settings_All_Aggregate = {
  __typename?: 'user_settings_all_aggregate';
  aggregate?: Maybe<User_Settings_All_Aggregate_Fields>;
  nodes: Array<User_Settings_All>;
};

/** aggregate fields of "user_settings_all" */
export type User_Settings_All_Aggregate_Fields = {
  __typename?: 'user_settings_all_aggregate_fields';
  avg?: Maybe<User_Settings_All_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Settings_All_Max_Fields>;
  min?: Maybe<User_Settings_All_Min_Fields>;
  stddev?: Maybe<User_Settings_All_Stddev_Fields>;
  stddev_pop?: Maybe<User_Settings_All_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Settings_All_Stddev_Samp_Fields>;
  sum?: Maybe<User_Settings_All_Sum_Fields>;
  var_pop?: Maybe<User_Settings_All_Var_Pop_Fields>;
  var_samp?: Maybe<User_Settings_All_Var_Samp_Fields>;
  variance?: Maybe<User_Settings_All_Variance_Fields>;
};


/** aggregate fields of "user_settings_all" */
export type User_Settings_All_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Settings_All_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Settings_All_Avg_Fields = {
  __typename?: 'user_settings_all_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_settings_all". All fields are combined with a logical 'AND'. */
export type User_Settings_All_Bool_Exp = {
  _and?: InputMaybe<Array<User_Settings_All_Bool_Exp>>;
  _not?: InputMaybe<User_Settings_All_Bool_Exp>;
  _or?: InputMaybe<Array<User_Settings_All_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_legacy?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "user_settings_all" */
export type User_Settings_All_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "user_settings_all" */
export type User_Settings_All_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_legacy?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Settings_All_Max_Fields = {
  __typename?: 'user_settings_all_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Settings_All_Min_Fields = {
  __typename?: 'user_settings_all_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_settings_all" */
export type User_Settings_All_Mutation_Response = {
  __typename?: 'user_settings_all_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Settings_All>;
};

/** Ordering options when selecting data from "user_settings_all". */
export type User_Settings_All_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_legacy?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "user_settings_all" */
export enum User_Settings_All_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsLegacy = 'is_legacy',
  /** column name */
  Key = 'key',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_settings_all" */
export type User_Settings_All_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_legacy?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Settings_All_Stddev_Fields = {
  __typename?: 'user_settings_all_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Settings_All_Stddev_Pop_Fields = {
  __typename?: 'user_settings_all_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Settings_All_Stddev_Samp_Fields = {
  __typename?: 'user_settings_all_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_settings_all" */
export type User_Settings_All_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Settings_All_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Settings_All_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_legacy?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Settings_All_Sum_Fields = {
  __typename?: 'user_settings_all_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

export type User_Settings_All_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Settings_All_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Settings_All_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Settings_All_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Settings_All_Var_Pop_Fields = {
  __typename?: 'user_settings_all_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Settings_All_Var_Samp_Fields = {
  __typename?: 'user_settings_all_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Settings_All_Variance_Fields = {
  __typename?: 'user_settings_all_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting array relation for remote table "user_settings" */
export type User_Settings_Arr_Rel_Insert_Input = {
  data: Array<User_Settings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Settings_Avg_Fields = {
  __typename?: 'user_settings_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_settings" */
export type User_Settings_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_settings". All fields are combined with a logical 'AND'. */
export type User_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<User_Settings_Bool_Exp>>;
  _not?: InputMaybe<User_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<User_Settings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_legacy?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_settings" */
export enum User_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSettingsPkey = 'user_settings_pkey',
  /** unique or primary key constraint on columns "key", "user_id" */
  UserSettingsUserIdKeyUnique = 'user_settings_user_id_key_unique'
}

/** input type for incrementing numeric columns in table "user_settings" */
export type User_Settings_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "user_settings" */
export type User_Settings_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_legacy?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Settings_Max_Fields = {
  __typename?: 'user_settings_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_settings" */
export type User_Settings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Settings_Min_Fields = {
  __typename?: 'user_settings_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_settings" */
export type User_Settings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_settings" */
export type User_Settings_Mutation_Response = {
  __typename?: 'user_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Settings>;
};

/** on_conflict condition type for table "user_settings" */
export type User_Settings_On_Conflict = {
  constraint: User_Settings_Constraint;
  update_columns?: Array<User_Settings_Update_Column>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "user_settings". */
export type User_Settings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_legacy?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_settings */
export type User_Settings_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "user_settings" */
export enum User_Settings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsLegacy = 'is_legacy',
  /** column name */
  Key = 'key',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** select "user_settings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_settings" */
export enum User_Settings_Select_Column_User_Settings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsLegacy = 'is_legacy'
}

/** select "user_settings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_settings" */
export enum User_Settings_Select_Column_User_Settings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsLegacy = 'is_legacy'
}

/** input type for updating data in table "user_settings" */
export type User_Settings_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_legacy?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Settings_Stddev_Fields = {
  __typename?: 'user_settings_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_settings" */
export type User_Settings_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Settings_Stddev_Pop_Fields = {
  __typename?: 'user_settings_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_settings" */
export type User_Settings_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Settings_Stddev_Samp_Fields = {
  __typename?: 'user_settings_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_settings" */
export type User_Settings_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_settings" */
export type User_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Settings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_legacy?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Settings_Sum_Fields = {
  __typename?: 'user_settings_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "user_settings" */
export type User_Settings_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_settings" */
export enum User_Settings_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsLegacy = 'is_legacy',
  /** column name */
  Key = 'key',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type User_Settings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Settings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Settings_Var_Pop_Fields = {
  __typename?: 'user_settings_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_settings" */
export type User_Settings_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Settings_Var_Samp_Fields = {
  __typename?: 'user_settings_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_settings" */
export type User_Settings_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Settings_Variance_Fields = {
  __typename?: 'user_settings_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_settings" */
export type User_Settings_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_user_list" */
export type User_User_List = {
  __typename?: 'user_user_list';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  ignored_at?: Maybe<Scalars['timestamp']['output']>;
  opted_out_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
  /** An object relationship */
  user_list: User_Lists;
  user_list_id: Scalars['bigint']['output'];
};

/** aggregated selection of "user_user_list" */
export type User_User_List_Aggregate = {
  __typename?: 'user_user_list_aggregate';
  aggregate?: Maybe<User_User_List_Aggregate_Fields>;
  nodes: Array<User_User_List>;
};

export type User_User_List_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_User_List_Aggregate_Bool_Exp_Count>;
};

export type User_User_List_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_User_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_User_List_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_user_list" */
export type User_User_List_Aggregate_Fields = {
  __typename?: 'user_user_list_aggregate_fields';
  avg?: Maybe<User_User_List_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_User_List_Max_Fields>;
  min?: Maybe<User_User_List_Min_Fields>;
  stddev?: Maybe<User_User_List_Stddev_Fields>;
  stddev_pop?: Maybe<User_User_List_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_User_List_Stddev_Samp_Fields>;
  sum?: Maybe<User_User_List_Sum_Fields>;
  var_pop?: Maybe<User_User_List_Var_Pop_Fields>;
  var_samp?: Maybe<User_User_List_Var_Samp_Fields>;
  variance?: Maybe<User_User_List_Variance_Fields>;
};


/** aggregate fields of "user_user_list" */
export type User_User_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_User_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_user_list" */
export type User_User_List_Aggregate_Order_By = {
  avg?: InputMaybe<User_User_List_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_User_List_Max_Order_By>;
  min?: InputMaybe<User_User_List_Min_Order_By>;
  stddev?: InputMaybe<User_User_List_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_User_List_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_User_List_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_User_List_Sum_Order_By>;
  var_pop?: InputMaybe<User_User_List_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_User_List_Var_Samp_Order_By>;
  variance?: InputMaybe<User_User_List_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_user_list" */
export type User_User_List_Arr_Rel_Insert_Input = {
  data: Array<User_User_List_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_User_List_On_Conflict>;
};

/** aggregate avg on columns */
export type User_User_List_Avg_Fields = {
  __typename?: 'user_user_list_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  user_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_user_list" */
export type User_User_List_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_user_list". All fields are combined with a logical 'AND'. */
export type User_User_List_Bool_Exp = {
  _and?: InputMaybe<Array<User_User_List_Bool_Exp>>;
  _not?: InputMaybe<User_User_List_Bool_Exp>;
  _or?: InputMaybe<Array<User_User_List_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  ignored_at?: InputMaybe<Timestamp_Comparison_Exp>;
  opted_out_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_list?: InputMaybe<User_Lists_Bool_Exp>;
  user_list_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_user_list" */
export enum User_User_List_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserUserListPkey = 'user_user_list_pkey',
  /** unique or primary key constraint on columns "user_id", "user_list_id" */
  UserUserListUserIdUserListIdUnique = 'user_user_list_user_id_user_list_id_unique'
}

/** input type for incrementing numeric columns in table "user_user_list" */
export type User_User_List_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  user_list_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "user_user_list" */
export type User_User_List_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ignored_at?: InputMaybe<Scalars['timestamp']['input']>;
  opted_out_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  user_list?: InputMaybe<User_Lists_Obj_Rel_Insert_Input>;
  user_list_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type User_User_List_Max_Fields = {
  __typename?: 'user_user_list_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ignored_at?: Maybe<Scalars['timestamp']['output']>;
  opted_out_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  user_list_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "user_user_list" */
export type User_User_List_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignored_at?: InputMaybe<Order_By>;
  opted_out_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_User_List_Min_Fields = {
  __typename?: 'user_user_list_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ignored_at?: Maybe<Scalars['timestamp']['output']>;
  opted_out_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  user_list_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "user_user_list" */
export type User_User_List_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignored_at?: InputMaybe<Order_By>;
  opted_out_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_user_list" */
export type User_User_List_Mutation_Response = {
  __typename?: 'user_user_list_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_User_List>;
};

/** on_conflict condition type for table "user_user_list" */
export type User_User_List_On_Conflict = {
  constraint: User_User_List_Constraint;
  update_columns?: Array<User_User_List_Update_Column>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};

/** Ordering options when selecting data from "user_user_list". */
export type User_User_List_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignored_at?: InputMaybe<Order_By>;
  opted_out_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list?: InputMaybe<User_Lists_Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_user_list */
export type User_User_List_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "user_user_list" */
export enum User_User_List_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoredAt = 'ignored_at',
  /** column name */
  OptedOutAt = 'opted_out_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserListId = 'user_list_id'
}

/** input type for updating data in table "user_user_list" */
export type User_User_List_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ignored_at?: InputMaybe<Scalars['timestamp']['input']>;
  opted_out_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  user_list_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type User_User_List_Stddev_Fields = {
  __typename?: 'user_user_list_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  user_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_user_list" */
export type User_User_List_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_User_List_Stddev_Pop_Fields = {
  __typename?: 'user_user_list_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  user_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_user_list" */
export type User_User_List_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_User_List_Stddev_Samp_Fields = {
  __typename?: 'user_user_list_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  user_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_user_list" */
export type User_User_List_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_user_list" */
export type User_User_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_User_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_User_List_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ignored_at?: InputMaybe<Scalars['timestamp']['input']>;
  opted_out_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  user_list_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type User_User_List_Sum_Fields = {
  __typename?: 'user_user_list_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  user_list_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "user_user_list" */
export type User_User_List_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_user_list" */
export enum User_User_List_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoredAt = 'ignored_at',
  /** column name */
  OptedOutAt = 'opted_out_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserListId = 'user_list_id'
}

export type User_User_List_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_User_List_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_User_List_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_User_List_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_User_List_Var_Pop_Fields = {
  __typename?: 'user_user_list_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  user_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_user_list" */
export type User_User_List_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_User_List_Var_Samp_Fields = {
  __typename?: 'user_user_list_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  user_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_user_list" */
export type User_User_List_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_User_List_Variance_Fields = {
  __typename?: 'user_user_list_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  user_list_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_user_list" */
export type User_User_List_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_list_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  account_setup_completed_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  ad_events: Array<Ad_Events>;
  /** An aggregate relationship */
  ad_events_aggregate: Ad_Events_Aggregate;
  allow_force_delete: Scalars['Boolean']['output'];
  allow_immediate_delete: Scalars['Boolean']['output'];
  anonymized_at?: Maybe<Scalars['timestamp']['output']>;
  beta_features_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  blacklisted_credentials: Array<Blacklisted_Credentials>;
  /** An aggregate relationship */
  blacklisted_credentials_aggregate: Blacklisted_Credentials_Aggregate;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  communication_opted_out_email_at?: Maybe<Scalars['timestamp']['output']>;
  communication_opted_out_in_app_at?: Maybe<Scalars['timestamp']['output']>;
  communication_opted_out_sms_at?: Maybe<Scalars['timestamp']['output']>;
  created_at: Scalars['timestamp']['output'];
  data?: Maybe<Scalars['json']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  device_users: Array<Device_User>;
  /** An aggregate relationship */
  device_users_aggregate: Device_User_Aggregate;
  email?: Maybe<Scalars['String']['output']>;
  exclude_from_issues: Scalars['Boolean']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  fraud_last_admin_review?: Maybe<Scalars['timestamp']['output']>;
  fraud_last_review_at?: Maybe<Scalars['timestamp']['output']>;
  fraud_review_force_next: Scalars['Boolean']['output'];
  fraud_review_status?: Maybe<Scalars['String']['output']>;
  fraud_score?: Maybe<Scalars['json']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  identities: Array<Identities>;
  /** An aggregate relationship */
  identities_aggregate: Identities_Aggregate;
  ignore_until?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  is_legacy_migration: Scalars['Boolean']['output'];
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_proactive_outreach_email_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_in_app_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_response_email_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_response_in_app_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_response_sms_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_sms_at?: Maybe<Scalars['timestamp']['output']>;
  last_review_prompt_at?: Maybe<Scalars['timestamp']['output']>;
  last_review_response_at?: Maybe<Scalars['timestamp']['output']>;
  last_support_ticket_at?: Maybe<Scalars['timestamp']['output']>;
  last_survey_prompt_at?: Maybe<Scalars['timestamp']['output']>;
  last_survey_response_at?: Maybe<Scalars['timestamp']['output']>;
  last_user_list_analysis_at?: Maybe<Scalars['timestamp']['output']>;
  last_wallet_prompt_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  legacyMigration?: Maybe<Legacy_Migrations>;
  /** An array relationship */
  legacy_migrations: Array<Legacy_Migrations>;
  /** An aggregate relationship */
  legacy_migrations_aggregate: Legacy_Migrations_Aggregate;
  locked_at?: Maybe<Scalars['timestamp']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  num_payment_methods: Scalars['smallint']['output'];
  num_vehicles: Scalars['smallint']['output'];
  /** An array relationship */
  parkable_transactions: Array<Parkable_Transactions>;
  /** An aggregate relationship */
  parkable_transactions_aggregate: Parkable_Transactions_Aggregate;
  /** An array relationship */
  parking_authority_users: Array<Parking_Authority_User>;
  /** An aggregate relationship */
  parking_authority_users_aggregate: Parking_Authority_User_Aggregate;
  /** An array relationship */
  payment_methods: Array<Payment_Methods>;
  /** An aggregate relationship */
  payment_methods_aggregate: Payment_Methods_Aggregate;
  pending_deletion_at?: Maybe<Scalars['timestamp']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  phone_number_verified: Scalars['Boolean']['output'];
  primary_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  r_user?: Maybe<R_Users>;
  /** An array relationship */
  reports: Array<Reports>;
  /** An aggregate relationship */
  reports_aggregate: Reports_Aggregate;
  satisfaction_rating?: Maybe<Scalars['smallint']['output']>;
  setup_payment_methods_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  setup_primary_parking_authority_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  setup_vehicles_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  setup_wallet_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  support_tickets: Array<Support_Tickets>;
  /** An aggregate relationship */
  support_tickets_aggregate: Support_Tickets_Aggregate;
  /** An array relationship */
  task_users: Array<Task_User>;
  /** An aggregate relationship */
  task_users_aggregate: Task_User_Aggregate;
  terms_of_service_last_accepted?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  user_activities: Array<User_Activities>;
  /** An aggregate relationship */
  user_activities_aggregate: User_Activities_Aggregate;
  /** An array relationship */
  user_settings: Array<User_Settings>;
  /** An aggregate relationship */
  user_settings_aggregate: User_Settings_Aggregate;
  /** An array relationship */
  user_user_lists: Array<User_User_List>;
  /** An aggregate relationship */
  user_user_lists_aggregate: User_User_List_Aggregate;
  /** An array relationship */
  vehicles: Array<Vehicles>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicles_Aggregate;
  /** An object relationship */
  wallet?: Maybe<Wallets>;
  /** An array relationship */
  wallets: Array<Wallets>;
  /** An aggregate relationship */
  wallets_aggregate: Wallets_Aggregate;
};


/** columns and relationships of "users" */
export type UsersAd_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Events_Order_By>>;
  where?: InputMaybe<Ad_Events_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAd_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ad_Events_Order_By>>;
  where?: InputMaybe<Ad_Events_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBlacklisted_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Blacklisted_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blacklisted_Credentials_Order_By>>;
  where?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBlacklisted_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blacklisted_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Blacklisted_Credentials_Order_By>>;
  where?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "users" */
export type UsersDevice_UsersArgs = {
  distinct_on?: InputMaybe<Array<Device_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_User_Order_By>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDevice_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_User_Order_By>>;
  where?: InputMaybe<Device_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFraud_ScoreArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "users" */
export type UsersIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersIdentities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Identities_Order_By>>;
  where?: InputMaybe<Identities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLegacy_MigrationsArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Migrations_Order_By>>;
  where?: InputMaybe<Legacy_Migrations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLegacy_Migrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Migrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Legacy_Migrations_Order_By>>;
  where?: InputMaybe<Legacy_Migrations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersParkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersParkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersParking_Authority_UsersArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_User_Order_By>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersParking_Authority_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parking_Authority_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parking_Authority_User_Order_By>>;
  where?: InputMaybe<Parking_Authority_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSupport_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSupport_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTask_UsersArgs = {
  distinct_on?: InputMaybe<Array<Task_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_User_Order_By>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTask_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_User_Order_By>>;
  where?: InputMaybe<Task_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Activities_Order_By>>;
  where?: InputMaybe<User_Activities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_User_ListsArgs = {
  distinct_on?: InputMaybe<Array<User_User_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_User_List_Order_By>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_User_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_User_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_User_List_Order_By>>;
  where?: InputMaybe<User_User_List_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersWalletsArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersWallets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_vehicles?: Maybe<Scalars['Float']['output']>;
  primary_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  satisfaction_rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  account_setup_completed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  ad_events?: InputMaybe<Ad_Events_Bool_Exp>;
  ad_events_aggregate?: InputMaybe<Ad_Events_Aggregate_Bool_Exp>;
  allow_force_delete?: InputMaybe<Boolean_Comparison_Exp>;
  allow_immediate_delete?: InputMaybe<Boolean_Comparison_Exp>;
  anonymized_at?: InputMaybe<Timestamp_Comparison_Exp>;
  beta_features_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  blacklisted_credentials?: InputMaybe<Blacklisted_Credentials_Bool_Exp>;
  blacklisted_credentials_aggregate?: InputMaybe<Blacklisted_Credentials_Aggregate_Bool_Exp>;
  cognito_identity_id?: InputMaybe<String_Comparison_Exp>;
  communication_opted_out_email_at?: InputMaybe<Timestamp_Comparison_Exp>;
  communication_opted_out_in_app_at?: InputMaybe<Timestamp_Comparison_Exp>;
  communication_opted_out_sms_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  device_users?: InputMaybe<Device_User_Bool_Exp>;
  device_users_aggregate?: InputMaybe<Device_User_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  exclude_from_issues?: InputMaybe<Boolean_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  fraud_last_admin_review?: InputMaybe<Timestamp_Comparison_Exp>;
  fraud_last_review_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fraud_review_force_next?: InputMaybe<Boolean_Comparison_Exp>;
  fraud_review_status?: InputMaybe<String_Comparison_Exp>;
  fraud_score?: InputMaybe<Json_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  identities?: InputMaybe<Identities_Bool_Exp>;
  identities_aggregate?: InputMaybe<Identities_Aggregate_Bool_Exp>;
  ignore_until?: InputMaybe<Timestamp_Comparison_Exp>;
  invoices?: InputMaybe<Invoices_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Bool_Exp>;
  is_legacy_migration?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_etl_trigger_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_login_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  last_proactive_outreach_email_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_proactive_outreach_in_app_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_proactive_outreach_response_email_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_proactive_outreach_response_in_app_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_proactive_outreach_response_sms_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_proactive_outreach_sms_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_review_prompt_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_review_response_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_support_ticket_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_survey_prompt_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_survey_response_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_user_list_analysis_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_wallet_prompt_at?: InputMaybe<Timestamp_Comparison_Exp>;
  legacyMigration?: InputMaybe<Legacy_Migrations_Bool_Exp>;
  legacy_migrations?: InputMaybe<Legacy_Migrations_Bool_Exp>;
  legacy_migrations_aggregate?: InputMaybe<Legacy_Migrations_Aggregate_Bool_Exp>;
  locked_at?: InputMaybe<Timestamp_Comparison_Exp>;
  mxm_customer_id?: InputMaybe<Bigint_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  num_etl_failures?: InputMaybe<Smallint_Comparison_Exp>;
  num_etls?: InputMaybe<Bigint_Comparison_Exp>;
  num_payment_methods?: InputMaybe<Smallint_Comparison_Exp>;
  num_vehicles?: InputMaybe<Smallint_Comparison_Exp>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  parkable_transactions_aggregate?: InputMaybe<Parkable_Transactions_Aggregate_Bool_Exp>;
  parking_authority_users?: InputMaybe<Parking_Authority_User_Bool_Exp>;
  parking_authority_users_aggregate?: InputMaybe<Parking_Authority_User_Aggregate_Bool_Exp>;
  payment_methods?: InputMaybe<Payment_Methods_Bool_Exp>;
  payment_methods_aggregate?: InputMaybe<Payment_Methods_Aggregate_Bool_Exp>;
  pending_deletion_at?: InputMaybe<Timestamp_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  phone_number_verified?: InputMaybe<Boolean_Comparison_Exp>;
  primary_parking_authority_id?: InputMaybe<Bigint_Comparison_Exp>;
  r_user?: InputMaybe<R_Users_Bool_Exp>;
  reports?: InputMaybe<Reports_Bool_Exp>;
  reports_aggregate?: InputMaybe<Reports_Aggregate_Bool_Exp>;
  satisfaction_rating?: InputMaybe<Smallint_Comparison_Exp>;
  setup_payment_methods_last_nag_at?: InputMaybe<Timestamp_Comparison_Exp>;
  setup_primary_parking_authority_last_nag_at?: InputMaybe<Timestamp_Comparison_Exp>;
  setup_vehicles_last_nag_at?: InputMaybe<Timestamp_Comparison_Exp>;
  setup_wallet_last_nag_at?: InputMaybe<Timestamp_Comparison_Exp>;
  support_tickets?: InputMaybe<Support_Tickets_Bool_Exp>;
  support_tickets_aggregate?: InputMaybe<Support_Tickets_Aggregate_Bool_Exp>;
  task_users?: InputMaybe<Task_User_Bool_Exp>;
  task_users_aggregate?: InputMaybe<Task_User_Aggregate_Bool_Exp>;
  terms_of_service_last_accepted?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_activities?: InputMaybe<User_Activities_Bool_Exp>;
  user_activities_aggregate?: InputMaybe<User_Activities_Aggregate_Bool_Exp>;
  user_settings?: InputMaybe<User_Settings_Bool_Exp>;
  user_settings_aggregate?: InputMaybe<User_Settings_Aggregate_Bool_Exp>;
  user_user_lists?: InputMaybe<User_User_List_Bool_Exp>;
  user_user_lists_aggregate?: InputMaybe<User_User_List_Aggregate_Bool_Exp>;
  vehicles?: InputMaybe<Vehicles_Bool_Exp>;
  vehicles_aggregate?: InputMaybe<Vehicles_Aggregate_Bool_Exp>;
  wallet?: InputMaybe<Wallets_Bool_Exp>;
  wallets?: InputMaybe<Wallets_Bool_Exp>;
  wallets_aggregate?: InputMaybe<Wallets_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "cognito_identity_id" */
  UsersCognitoIdentityIdUnique = 'users_cognito_identity_id_unique',
  /** unique or primary key constraint on columns "phone_number" */
  UsersPhoneNumberUnique = 'users_phone_number_unique',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  num_payment_methods?: InputMaybe<Scalars['smallint']['input']>;
  num_vehicles?: InputMaybe<Scalars['smallint']['input']>;
  primary_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  satisfaction_rating?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  account_setup_completed_at?: InputMaybe<Scalars['timestamp']['input']>;
  ad_events?: InputMaybe<Ad_Events_Arr_Rel_Insert_Input>;
  allow_force_delete?: InputMaybe<Scalars['Boolean']['input']>;
  allow_immediate_delete?: InputMaybe<Scalars['Boolean']['input']>;
  anonymized_at?: InputMaybe<Scalars['timestamp']['input']>;
  beta_features_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  blacklisted_credentials?: InputMaybe<Blacklisted_Credentials_Arr_Rel_Insert_Input>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  communication_opted_out_email_at?: InputMaybe<Scalars['timestamp']['input']>;
  communication_opted_out_in_app_at?: InputMaybe<Scalars['timestamp']['input']>;
  communication_opted_out_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_users?: InputMaybe<Device_User_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  exclude_from_issues?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  fraud_last_admin_review?: InputMaybe<Scalars['timestamp']['input']>;
  fraud_last_review_at?: InputMaybe<Scalars['timestamp']['input']>;
  fraud_review_force_next?: InputMaybe<Scalars['Boolean']['input']>;
  fraud_review_status?: InputMaybe<Scalars['String']['input']>;
  fraud_score?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  identities?: InputMaybe<Identities_Arr_Rel_Insert_Input>;
  ignore_until?: InputMaybe<Scalars['timestamp']['input']>;
  invoices?: InputMaybe<Invoices_Arr_Rel_Insert_Input>;
  is_legacy_migration?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_proactive_outreach_email_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_in_app_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_response_email_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_response_in_app_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_response_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_review_prompt_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_review_response_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_support_ticket_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_survey_prompt_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_survey_response_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_user_list_analysis_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_wallet_prompt_at?: InputMaybe<Scalars['timestamp']['input']>;
  legacyMigration?: InputMaybe<Legacy_Migrations_Obj_Rel_Insert_Input>;
  legacy_migrations?: InputMaybe<Legacy_Migrations_Arr_Rel_Insert_Input>;
  locked_at?: InputMaybe<Scalars['timestamp']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  num_payment_methods?: InputMaybe<Scalars['smallint']['input']>;
  num_vehicles?: InputMaybe<Scalars['smallint']['input']>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Arr_Rel_Insert_Input>;
  parking_authority_users?: InputMaybe<Parking_Authority_User_Arr_Rel_Insert_Input>;
  payment_methods?: InputMaybe<Payment_Methods_Arr_Rel_Insert_Input>;
  pending_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
  primary_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  r_user?: InputMaybe<R_Users_Obj_Rel_Insert_Input>;
  reports?: InputMaybe<Reports_Arr_Rel_Insert_Input>;
  satisfaction_rating?: InputMaybe<Scalars['smallint']['input']>;
  setup_payment_methods_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  setup_primary_parking_authority_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  setup_vehicles_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  setup_wallet_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  support_tickets?: InputMaybe<Support_Tickets_Arr_Rel_Insert_Input>;
  task_users?: InputMaybe<Task_User_Arr_Rel_Insert_Input>;
  terms_of_service_last_accepted?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_activities?: InputMaybe<User_Activities_Arr_Rel_Insert_Input>;
  user_settings?: InputMaybe<User_Settings_Arr_Rel_Insert_Input>;
  user_user_lists?: InputMaybe<User_User_List_Arr_Rel_Insert_Input>;
  vehicles?: InputMaybe<Vehicles_Arr_Rel_Insert_Input>;
  wallet?: InputMaybe<Wallets_Obj_Rel_Insert_Input>;
  wallets?: InputMaybe<Wallets_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  account_setup_completed_at?: Maybe<Scalars['timestamp']['output']>;
  anonymized_at?: Maybe<Scalars['timestamp']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  communication_opted_out_email_at?: Maybe<Scalars['timestamp']['output']>;
  communication_opted_out_in_app_at?: Maybe<Scalars['timestamp']['output']>;
  communication_opted_out_sms_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  fraud_last_admin_review?: Maybe<Scalars['timestamp']['output']>;
  fraud_last_review_at?: Maybe<Scalars['timestamp']['output']>;
  fraud_review_status?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ignore_until?: Maybe<Scalars['timestamp']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_proactive_outreach_email_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_in_app_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_response_email_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_response_in_app_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_response_sms_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_sms_at?: Maybe<Scalars['timestamp']['output']>;
  last_review_prompt_at?: Maybe<Scalars['timestamp']['output']>;
  last_review_response_at?: Maybe<Scalars['timestamp']['output']>;
  last_support_ticket_at?: Maybe<Scalars['timestamp']['output']>;
  last_survey_prompt_at?: Maybe<Scalars['timestamp']['output']>;
  last_survey_response_at?: Maybe<Scalars['timestamp']['output']>;
  last_user_list_analysis_at?: Maybe<Scalars['timestamp']['output']>;
  last_wallet_prompt_at?: Maybe<Scalars['timestamp']['output']>;
  locked_at?: Maybe<Scalars['timestamp']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  num_payment_methods?: Maybe<Scalars['smallint']['output']>;
  num_vehicles?: Maybe<Scalars['smallint']['output']>;
  pending_deletion_at?: Maybe<Scalars['timestamp']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  primary_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  satisfaction_rating?: Maybe<Scalars['smallint']['output']>;
  setup_payment_methods_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  setup_primary_parking_authority_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  setup_vehicles_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  setup_wallet_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  terms_of_service_last_accepted?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  account_setup_completed_at?: Maybe<Scalars['timestamp']['output']>;
  anonymized_at?: Maybe<Scalars['timestamp']['output']>;
  cognito_identity_id?: Maybe<Scalars['String']['output']>;
  communication_opted_out_email_at?: Maybe<Scalars['timestamp']['output']>;
  communication_opted_out_in_app_at?: Maybe<Scalars['timestamp']['output']>;
  communication_opted_out_sms_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  fraud_last_admin_review?: Maybe<Scalars['timestamp']['output']>;
  fraud_last_review_at?: Maybe<Scalars['timestamp']['output']>;
  fraud_review_status?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ignore_until?: Maybe<Scalars['timestamp']['output']>;
  last_active_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_at?: Maybe<Scalars['timestamp']['output']>;
  last_etl_trigger_at?: Maybe<Scalars['timestamp']['output']>;
  last_login_at?: Maybe<Scalars['timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_proactive_outreach_email_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_in_app_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_response_email_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_response_in_app_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_response_sms_at?: Maybe<Scalars['timestamp']['output']>;
  last_proactive_outreach_sms_at?: Maybe<Scalars['timestamp']['output']>;
  last_review_prompt_at?: Maybe<Scalars['timestamp']['output']>;
  last_review_response_at?: Maybe<Scalars['timestamp']['output']>;
  last_support_ticket_at?: Maybe<Scalars['timestamp']['output']>;
  last_survey_prompt_at?: Maybe<Scalars['timestamp']['output']>;
  last_survey_response_at?: Maybe<Scalars['timestamp']['output']>;
  last_user_list_analysis_at?: Maybe<Scalars['timestamp']['output']>;
  last_wallet_prompt_at?: Maybe<Scalars['timestamp']['output']>;
  locked_at?: Maybe<Scalars['timestamp']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  num_payment_methods?: Maybe<Scalars['smallint']['output']>;
  num_vehicles?: Maybe<Scalars['smallint']['output']>;
  pending_deletion_at?: Maybe<Scalars['timestamp']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  primary_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  satisfaction_rating?: Maybe<Scalars['smallint']['output']>;
  setup_payment_methods_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  setup_primary_parking_authority_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  setup_vehicles_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  setup_wallet_last_nag_at?: Maybe<Scalars['timestamp']['output']>;
  terms_of_service_last_accepted?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  account_setup_completed_at?: InputMaybe<Order_By>;
  ad_events_aggregate?: InputMaybe<Ad_Events_Aggregate_Order_By>;
  allow_force_delete?: InputMaybe<Order_By>;
  allow_immediate_delete?: InputMaybe<Order_By>;
  anonymized_at?: InputMaybe<Order_By>;
  beta_features_enabled?: InputMaybe<Order_By>;
  blacklisted_credentials_aggregate?: InputMaybe<Blacklisted_Credentials_Aggregate_Order_By>;
  cognito_identity_id?: InputMaybe<Order_By>;
  communication_opted_out_email_at?: InputMaybe<Order_By>;
  communication_opted_out_in_app_at?: InputMaybe<Order_By>;
  communication_opted_out_sms_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  device_users_aggregate?: InputMaybe<Device_User_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  exclude_from_issues?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  fraud_last_admin_review?: InputMaybe<Order_By>;
  fraud_last_review_at?: InputMaybe<Order_By>;
  fraud_review_force_next?: InputMaybe<Order_By>;
  fraud_review_status?: InputMaybe<Order_By>;
  fraud_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identities_aggregate?: InputMaybe<Identities_Aggregate_Order_By>;
  ignore_until?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Order_By>;
  is_legacy_migration?: InputMaybe<Order_By>;
  last_active_at?: InputMaybe<Order_By>;
  last_etl_at?: InputMaybe<Order_By>;
  last_etl_trigger_at?: InputMaybe<Order_By>;
  last_login_at?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  last_proactive_outreach_email_at?: InputMaybe<Order_By>;
  last_proactive_outreach_in_app_at?: InputMaybe<Order_By>;
  last_proactive_outreach_response_email_at?: InputMaybe<Order_By>;
  last_proactive_outreach_response_in_app_at?: InputMaybe<Order_By>;
  last_proactive_outreach_response_sms_at?: InputMaybe<Order_By>;
  last_proactive_outreach_sms_at?: InputMaybe<Order_By>;
  last_review_prompt_at?: InputMaybe<Order_By>;
  last_review_response_at?: InputMaybe<Order_By>;
  last_support_ticket_at?: InputMaybe<Order_By>;
  last_survey_prompt_at?: InputMaybe<Order_By>;
  last_survey_response_at?: InputMaybe<Order_By>;
  last_user_list_analysis_at?: InputMaybe<Order_By>;
  last_wallet_prompt_at?: InputMaybe<Order_By>;
  legacyMigration?: InputMaybe<Legacy_Migrations_Order_By>;
  legacy_migrations_aggregate?: InputMaybe<Legacy_Migrations_Aggregate_Order_By>;
  locked_at?: InputMaybe<Order_By>;
  mxm_customer_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  num_etl_failures?: InputMaybe<Order_By>;
  num_etls?: InputMaybe<Order_By>;
  num_payment_methods?: InputMaybe<Order_By>;
  num_vehicles?: InputMaybe<Order_By>;
  parkable_transactions_aggregate?: InputMaybe<Parkable_Transactions_Aggregate_Order_By>;
  parking_authority_users_aggregate?: InputMaybe<Parking_Authority_User_Aggregate_Order_By>;
  payment_methods_aggregate?: InputMaybe<Payment_Methods_Aggregate_Order_By>;
  pending_deletion_at?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  phone_number_verified?: InputMaybe<Order_By>;
  primary_parking_authority_id?: InputMaybe<Order_By>;
  r_user?: InputMaybe<R_Users_Order_By>;
  reports_aggregate?: InputMaybe<Reports_Aggregate_Order_By>;
  satisfaction_rating?: InputMaybe<Order_By>;
  setup_payment_methods_last_nag_at?: InputMaybe<Order_By>;
  setup_primary_parking_authority_last_nag_at?: InputMaybe<Order_By>;
  setup_vehicles_last_nag_at?: InputMaybe<Order_By>;
  setup_wallet_last_nag_at?: InputMaybe<Order_By>;
  support_tickets_aggregate?: InputMaybe<Support_Tickets_Aggregate_Order_By>;
  task_users_aggregate?: InputMaybe<Task_User_Aggregate_Order_By>;
  terms_of_service_last_accepted?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_activities_aggregate?: InputMaybe<User_Activities_Aggregate_Order_By>;
  user_settings_aggregate?: InputMaybe<User_Settings_Aggregate_Order_By>;
  user_user_lists_aggregate?: InputMaybe<User_User_List_Aggregate_Order_By>;
  vehicles_aggregate?: InputMaybe<Vehicles_Aggregate_Order_By>;
  wallet?: InputMaybe<Wallets_Order_By>;
  wallets_aggregate?: InputMaybe<Wallets_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AccountSetupCompletedAt = 'account_setup_completed_at',
  /** column name */
  AllowForceDelete = 'allow_force_delete',
  /** column name */
  AllowImmediateDelete = 'allow_immediate_delete',
  /** column name */
  AnonymizedAt = 'anonymized_at',
  /** column name */
  BetaFeaturesEnabled = 'beta_features_enabled',
  /** column name */
  CognitoIdentityId = 'cognito_identity_id',
  /** column name */
  CommunicationOptedOutEmailAt = 'communication_opted_out_email_at',
  /** column name */
  CommunicationOptedOutInAppAt = 'communication_opted_out_in_app_at',
  /** column name */
  CommunicationOptedOutSmsAt = 'communication_opted_out_sms_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExcludeFromIssues = 'exclude_from_issues',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FraudLastAdminReview = 'fraud_last_admin_review',
  /** column name */
  FraudLastReviewAt = 'fraud_last_review_at',
  /** column name */
  FraudReviewForceNext = 'fraud_review_force_next',
  /** column name */
  FraudReviewStatus = 'fraud_review_status',
  /** column name */
  FraudScore = 'fraud_score',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoreUntil = 'ignore_until',
  /** column name */
  IsLegacyMigration = 'is_legacy_migration',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastLoginAt = 'last_login_at',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastProactiveOutreachEmailAt = 'last_proactive_outreach_email_at',
  /** column name */
  LastProactiveOutreachInAppAt = 'last_proactive_outreach_in_app_at',
  /** column name */
  LastProactiveOutreachResponseEmailAt = 'last_proactive_outreach_response_email_at',
  /** column name */
  LastProactiveOutreachResponseInAppAt = 'last_proactive_outreach_response_in_app_at',
  /** column name */
  LastProactiveOutreachResponseSmsAt = 'last_proactive_outreach_response_sms_at',
  /** column name */
  LastProactiveOutreachSmsAt = 'last_proactive_outreach_sms_at',
  /** column name */
  LastReviewPromptAt = 'last_review_prompt_at',
  /** column name */
  LastReviewResponseAt = 'last_review_response_at',
  /** column name */
  LastSupportTicketAt = 'last_support_ticket_at',
  /** column name */
  LastSurveyPromptAt = 'last_survey_prompt_at',
  /** column name */
  LastSurveyResponseAt = 'last_survey_response_at',
  /** column name */
  LastUserListAnalysisAt = 'last_user_list_analysis_at',
  /** column name */
  LastWalletPromptAt = 'last_wallet_prompt_at',
  /** column name */
  LockedAt = 'locked_at',
  /** column name */
  MxmCustomerId = 'mxm_customer_id',
  /** column name */
  Note = 'note',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  NumPaymentMethods = 'num_payment_methods',
  /** column name */
  NumVehicles = 'num_vehicles',
  /** column name */
  PendingDeletionAt = 'pending_deletion_at',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PhoneNumberVerified = 'phone_number_verified',
  /** column name */
  PrimaryParkingAuthorityId = 'primary_parking_authority_id',
  /** column name */
  SatisfactionRating = 'satisfaction_rating',
  /** column name */
  SetupPaymentMethodsLastNagAt = 'setup_payment_methods_last_nag_at',
  /** column name */
  SetupPrimaryParkingAuthorityLastNagAt = 'setup_primary_parking_authority_last_nag_at',
  /** column name */
  SetupVehiclesLastNagAt = 'setup_vehicles_last_nag_at',
  /** column name */
  SetupWalletLastNagAt = 'setup_wallet_last_nag_at',
  /** column name */
  TermsOfServiceLastAccepted = 'terms_of_service_last_accepted',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  account_setup_completed_at?: InputMaybe<Scalars['timestamp']['input']>;
  allow_force_delete?: InputMaybe<Scalars['Boolean']['input']>;
  allow_immediate_delete?: InputMaybe<Scalars['Boolean']['input']>;
  anonymized_at?: InputMaybe<Scalars['timestamp']['input']>;
  beta_features_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  communication_opted_out_email_at?: InputMaybe<Scalars['timestamp']['input']>;
  communication_opted_out_in_app_at?: InputMaybe<Scalars['timestamp']['input']>;
  communication_opted_out_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exclude_from_issues?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  fraud_last_admin_review?: InputMaybe<Scalars['timestamp']['input']>;
  fraud_last_review_at?: InputMaybe<Scalars['timestamp']['input']>;
  fraud_review_force_next?: InputMaybe<Scalars['Boolean']['input']>;
  fraud_review_status?: InputMaybe<Scalars['String']['input']>;
  fraud_score?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ignore_until?: InputMaybe<Scalars['timestamp']['input']>;
  is_legacy_migration?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_proactive_outreach_email_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_in_app_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_response_email_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_response_in_app_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_response_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_review_prompt_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_review_response_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_support_ticket_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_survey_prompt_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_survey_response_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_user_list_analysis_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_wallet_prompt_at?: InputMaybe<Scalars['timestamp']['input']>;
  locked_at?: InputMaybe<Scalars['timestamp']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  num_payment_methods?: InputMaybe<Scalars['smallint']['input']>;
  num_vehicles?: InputMaybe<Scalars['smallint']['input']>;
  pending_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
  primary_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  satisfaction_rating?: InputMaybe<Scalars['smallint']['input']>;
  setup_payment_methods_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  setup_primary_parking_authority_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  setup_vehicles_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  setup_wallet_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  terms_of_service_last_accepted?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_vehicles?: Maybe<Scalars['Float']['output']>;
  primary_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  satisfaction_rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_vehicles?: Maybe<Scalars['Float']['output']>;
  primary_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  satisfaction_rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_vehicles?: Maybe<Scalars['Float']['output']>;
  primary_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  satisfaction_rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  account_setup_completed_at?: InputMaybe<Scalars['timestamp']['input']>;
  allow_force_delete?: InputMaybe<Scalars['Boolean']['input']>;
  allow_immediate_delete?: InputMaybe<Scalars['Boolean']['input']>;
  anonymized_at?: InputMaybe<Scalars['timestamp']['input']>;
  beta_features_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_identity_id?: InputMaybe<Scalars['String']['input']>;
  communication_opted_out_email_at?: InputMaybe<Scalars['timestamp']['input']>;
  communication_opted_out_in_app_at?: InputMaybe<Scalars['timestamp']['input']>;
  communication_opted_out_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exclude_from_issues?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  fraud_last_admin_review?: InputMaybe<Scalars['timestamp']['input']>;
  fraud_last_review_at?: InputMaybe<Scalars['timestamp']['input']>;
  fraud_review_force_next?: InputMaybe<Scalars['Boolean']['input']>;
  fraud_review_status?: InputMaybe<Scalars['String']['input']>;
  fraud_score?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ignore_until?: InputMaybe<Scalars['timestamp']['input']>;
  is_legacy_migration?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_etl_trigger_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_login_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_proactive_outreach_email_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_in_app_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_response_email_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_response_in_app_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_response_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_proactive_outreach_sms_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_review_prompt_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_review_response_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_support_ticket_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_survey_prompt_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_survey_response_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_user_list_analysis_at?: InputMaybe<Scalars['timestamp']['input']>;
  last_wallet_prompt_at?: InputMaybe<Scalars['timestamp']['input']>;
  locked_at?: InputMaybe<Scalars['timestamp']['input']>;
  mxm_customer_id?: InputMaybe<Scalars['bigint']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  num_etl_failures?: InputMaybe<Scalars['smallint']['input']>;
  num_etls?: InputMaybe<Scalars['bigint']['input']>;
  num_payment_methods?: InputMaybe<Scalars['smallint']['input']>;
  num_vehicles?: InputMaybe<Scalars['smallint']['input']>;
  pending_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  phone_number_verified?: InputMaybe<Scalars['Boolean']['input']>;
  primary_parking_authority_id?: InputMaybe<Scalars['bigint']['input']>;
  satisfaction_rating?: InputMaybe<Scalars['smallint']['input']>;
  setup_payment_methods_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  setup_primary_parking_authority_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  setup_vehicles_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  setup_wallet_last_nag_at?: InputMaybe<Scalars['timestamp']['input']>;
  terms_of_service_last_accepted?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  mxm_customer_id?: Maybe<Scalars['bigint']['output']>;
  num_etl_failures?: Maybe<Scalars['smallint']['output']>;
  num_etls?: Maybe<Scalars['bigint']['output']>;
  num_payment_methods?: Maybe<Scalars['smallint']['output']>;
  num_vehicles?: Maybe<Scalars['smallint']['output']>;
  primary_parking_authority_id?: Maybe<Scalars['bigint']['output']>;
  satisfaction_rating?: Maybe<Scalars['smallint']['output']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  AccountSetupCompletedAt = 'account_setup_completed_at',
  /** column name */
  AllowForceDelete = 'allow_force_delete',
  /** column name */
  AllowImmediateDelete = 'allow_immediate_delete',
  /** column name */
  AnonymizedAt = 'anonymized_at',
  /** column name */
  BetaFeaturesEnabled = 'beta_features_enabled',
  /** column name */
  CognitoIdentityId = 'cognito_identity_id',
  /** column name */
  CommunicationOptedOutEmailAt = 'communication_opted_out_email_at',
  /** column name */
  CommunicationOptedOutInAppAt = 'communication_opted_out_in_app_at',
  /** column name */
  CommunicationOptedOutSmsAt = 'communication_opted_out_sms_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExcludeFromIssues = 'exclude_from_issues',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FraudLastAdminReview = 'fraud_last_admin_review',
  /** column name */
  FraudLastReviewAt = 'fraud_last_review_at',
  /** column name */
  FraudReviewForceNext = 'fraud_review_force_next',
  /** column name */
  FraudReviewStatus = 'fraud_review_status',
  /** column name */
  FraudScore = 'fraud_score',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoreUntil = 'ignore_until',
  /** column name */
  IsLegacyMigration = 'is_legacy_migration',
  /** column name */
  LastActiveAt = 'last_active_at',
  /** column name */
  LastEtlAt = 'last_etl_at',
  /** column name */
  LastEtlTriggerAt = 'last_etl_trigger_at',
  /** column name */
  LastLoginAt = 'last_login_at',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastProactiveOutreachEmailAt = 'last_proactive_outreach_email_at',
  /** column name */
  LastProactiveOutreachInAppAt = 'last_proactive_outreach_in_app_at',
  /** column name */
  LastProactiveOutreachResponseEmailAt = 'last_proactive_outreach_response_email_at',
  /** column name */
  LastProactiveOutreachResponseInAppAt = 'last_proactive_outreach_response_in_app_at',
  /** column name */
  LastProactiveOutreachResponseSmsAt = 'last_proactive_outreach_response_sms_at',
  /** column name */
  LastProactiveOutreachSmsAt = 'last_proactive_outreach_sms_at',
  /** column name */
  LastReviewPromptAt = 'last_review_prompt_at',
  /** column name */
  LastReviewResponseAt = 'last_review_response_at',
  /** column name */
  LastSupportTicketAt = 'last_support_ticket_at',
  /** column name */
  LastSurveyPromptAt = 'last_survey_prompt_at',
  /** column name */
  LastSurveyResponseAt = 'last_survey_response_at',
  /** column name */
  LastUserListAnalysisAt = 'last_user_list_analysis_at',
  /** column name */
  LastWalletPromptAt = 'last_wallet_prompt_at',
  /** column name */
  LockedAt = 'locked_at',
  /** column name */
  MxmCustomerId = 'mxm_customer_id',
  /** column name */
  Note = 'note',
  /** column name */
  NumEtlFailures = 'num_etl_failures',
  /** column name */
  NumEtls = 'num_etls',
  /** column name */
  NumPaymentMethods = 'num_payment_methods',
  /** column name */
  NumVehicles = 'num_vehicles',
  /** column name */
  PendingDeletionAt = 'pending_deletion_at',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PhoneNumberVerified = 'phone_number_verified',
  /** column name */
  PrimaryParkingAuthorityId = 'primary_parking_authority_id',
  /** column name */
  SatisfactionRating = 'satisfaction_rating',
  /** column name */
  SetupPaymentMethodsLastNagAt = 'setup_payment_methods_last_nag_at',
  /** column name */
  SetupPrimaryParkingAuthorityLastNagAt = 'setup_primary_parking_authority_last_nag_at',
  /** column name */
  SetupVehiclesLastNagAt = 'setup_vehicles_last_nag_at',
  /** column name */
  SetupWalletLastNagAt = 'setup_wallet_last_nag_at',
  /** column name */
  TermsOfServiceLastAccepted = 'terms_of_service_last_accepted',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_vehicles?: Maybe<Scalars['Float']['output']>;
  primary_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  satisfaction_rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_vehicles?: Maybe<Scalars['Float']['output']>;
  primary_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  satisfaction_rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  mxm_customer_id?: Maybe<Scalars['Float']['output']>;
  num_etl_failures?: Maybe<Scalars['Float']['output']>;
  num_etls?: Maybe<Scalars['Float']['output']>;
  num_payment_methods?: Maybe<Scalars['Float']['output']>;
  num_vehicles?: Maybe<Scalars['Float']['output']>;
  primary_parking_authority_id?: Maybe<Scalars['Float']['output']>;
  satisfaction_rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "vehicles" */
export type Vehicles = {
  __typename?: 'vehicles';
  color?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  idempotent_key: Scalars['bigint']['output'];
  is_deleted: Scalars['Boolean']['output'];
  license_plate?: Maybe<Scalars['String']['output']>;
  manufacturer_make?: Maybe<Scalars['String']['output']>;
  manufacturer_model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  parkable_transactions: Array<Parkable_Transactions>;
  /** An aggregate relationship */
  parkable_transactions_aggregate: Parkable_Transactions_Aggregate;
  state_code?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "vehicles" */
export type VehiclesParkable_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};


/** columns and relationships of "vehicles" */
export type VehiclesParkable_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transactions_Order_By>>;
  where?: InputMaybe<Parkable_Transactions_Bool_Exp>;
};

/** aggregated selection of "vehicles" */
export type Vehicles_Aggregate = {
  __typename?: 'vehicles_aggregate';
  aggregate?: Maybe<Vehicles_Aggregate_Fields>;
  nodes: Array<Vehicles>;
};

export type Vehicles_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicles_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicles_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicles_Aggregate_Bool_Exp_Count>;
};

export type Vehicles_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicles_Select_Column_Vehicles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicles_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicles_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicles_Select_Column_Vehicles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicles_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicles" */
export type Vehicles_Aggregate_Fields = {
  __typename?: 'vehicles_aggregate_fields';
  avg?: Maybe<Vehicles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicles_Max_Fields>;
  min?: Maybe<Vehicles_Min_Fields>;
  stddev?: Maybe<Vehicles_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicles_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicles_Sum_Fields>;
  var_pop?: Maybe<Vehicles_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicles_Var_Samp_Fields>;
  variance?: Maybe<Vehicles_Variance_Fields>;
};


/** aggregate fields of "vehicles" */
export type Vehicles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicles" */
export type Vehicles_Aggregate_Order_By = {
  avg?: InputMaybe<Vehicles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicles_Max_Order_By>;
  min?: InputMaybe<Vehicles_Min_Order_By>;
  stddev?: InputMaybe<Vehicles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vehicles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vehicles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vehicles_Sum_Order_By>;
  var_pop?: InputMaybe<Vehicles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vehicles_Var_Samp_Order_By>;
  variance?: InputMaybe<Vehicles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicles" */
export type Vehicles_Arr_Rel_Insert_Input = {
  data: Array<Vehicles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicles_Avg_Fields = {
  __typename?: 'vehicles_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  idempotent_key?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vehicles" */
export type Vehicles_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicles". All fields are combined with a logical 'AND'. */
export type Vehicles_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicles_Bool_Exp>>;
  _not?: InputMaybe<Vehicles_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicles_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<Bigint_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  license_plate?: InputMaybe<String_Comparison_Exp>;
  manufacturer_make?: InputMaybe<String_Comparison_Exp>;
  manufacturer_model?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Bool_Exp>;
  parkable_transactions_aggregate?: InputMaybe<Parkable_Transactions_Aggregate_Bool_Exp>;
  state_code?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicles" */
export enum Vehicles_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehiclesPkey = 'vehicles_pkey',
  /** unique or primary key constraint on columns "idempotent_key", "user_id", "license_plate" */
  VehiclesUserIdLicensePlateIdempotentKeyUnique = 'vehicles_user_id_license_plate_idempotent_key_unique'
}

/** input type for incrementing numeric columns in table "vehicles" */
export type Vehicles_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "vehicles" */
export type Vehicles_Insert_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  manufacturer_make?: InputMaybe<Scalars['String']['input']>;
  manufacturer_model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parkable_transactions?: InputMaybe<Parkable_Transactions_Arr_Rel_Insert_Input>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Vehicles_Max_Fields = {
  __typename?: 'vehicles_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['bigint']['output']>;
  license_plate?: Maybe<Scalars['String']['output']>;
  manufacturer_make?: Maybe<Scalars['String']['output']>;
  manufacturer_model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "vehicles" */
export type Vehicles_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  license_plate?: InputMaybe<Order_By>;
  manufacturer_make?: InputMaybe<Order_By>;
  manufacturer_model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  state_code?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicles_Min_Fields = {
  __typename?: 'vehicles_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['bigint']['output']>;
  license_plate?: Maybe<Scalars['String']['output']>;
  manufacturer_make?: Maybe<Scalars['String']['output']>;
  manufacturer_model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state_code?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "vehicles" */
export type Vehicles_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  license_plate?: InputMaybe<Order_By>;
  manufacturer_make?: InputMaybe<Order_By>;
  manufacturer_model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  state_code?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicles" */
export type Vehicles_Mutation_Response = {
  __typename?: 'vehicles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicles>;
};

/** input type for inserting object relation for remote table "vehicles" */
export type Vehicles_Obj_Rel_Insert_Input = {
  data: Vehicles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};

/** on_conflict condition type for table "vehicles" */
export type Vehicles_On_Conflict = {
  constraint: Vehicles_Constraint;
  update_columns?: Array<Vehicles_Update_Column>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicles". */
export type Vehicles_Order_By = {
  color?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  license_plate?: InputMaybe<Order_By>;
  manufacturer_make?: InputMaybe<Order_By>;
  manufacturer_model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parkable_transactions_aggregate?: InputMaybe<Parkable_Transactions_Aggregate_Order_By>;
  state_code?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicles */
export type Vehicles_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "vehicles" */
export enum Vehicles_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LicensePlate = 'license_plate',
  /** column name */
  ManufacturerMake = 'manufacturer_make',
  /** column name */
  ManufacturerModel = 'manufacturer_model',
  /** column name */
  Name = 'name',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "vehicles_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicles" */
export enum Vehicles_Select_Column_Vehicles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "vehicles_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicles" */
export enum Vehicles_Select_Column_Vehicles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** input type for updating data in table "vehicles" */
export type Vehicles_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  manufacturer_make?: InputMaybe<Scalars['String']['input']>;
  manufacturer_model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Vehicles_Stddev_Fields = {
  __typename?: 'vehicles_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  idempotent_key?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vehicles" */
export type Vehicles_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicles_Stddev_Pop_Fields = {
  __typename?: 'vehicles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  idempotent_key?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vehicles" */
export type Vehicles_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicles_Stddev_Samp_Fields = {
  __typename?: 'vehicles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  idempotent_key?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vehicles" */
export type Vehicles_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vehicles" */
export type Vehicles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicles_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['bigint']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  manufacturer_make?: InputMaybe<Scalars['String']['input']>;
  manufacturer_model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state_code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vehicles_Sum_Fields = {
  __typename?: 'vehicles_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "vehicles" */
export type Vehicles_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "vehicles" */
export enum Vehicles_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LicensePlate = 'license_plate',
  /** column name */
  ManufacturerMake = 'manufacturer_make',
  /** column name */
  ManufacturerModel = 'manufacturer_model',
  /** column name */
  Name = 'name',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Vehicles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vehicles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vehicles_Var_Pop_Fields = {
  __typename?: 'vehicles_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  idempotent_key?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vehicles" */
export type Vehicles_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicles_Var_Samp_Fields = {
  __typename?: 'vehicles_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  idempotent_key?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vehicles" */
export type Vehicles_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicles_Variance_Fields = {
  __typename?: 'vehicles_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  idempotent_key?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vehicles" */
export type Vehicles_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "wallet_transactions" */
export type Wallet_Transactions = {
  __typename?: 'wallet_transactions';
  amount: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  invoice_wallet_transactions: Array<Invoice_Wallet_Transaction>;
  /** An aggregate relationship */
  invoice_wallet_transactions_aggregate: Invoice_Wallet_Transaction_Aggregate;
  is_opening_balance?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  line_item_wallet_transactions: Array<Line_Item_Wallet_Transaction>;
  /** An aggregate relationship */
  line_item_wallet_transactions_aggregate: Line_Item_Wallet_Transaction_Aggregate;
  /** An array relationship */
  parkable_transaction_wallet_transactions: Array<Parkable_Transaction_Wallet_Transaction>;
  /** An aggregate relationship */
  parkable_transaction_wallet_transactions_aggregate: Parkable_Transaction_Wallet_Transaction_Aggregate;
  /** An array relationship */
  payment_wallet_transactions: Array<Payment_Wallet_Transaction>;
  /** An aggregate relationship */
  payment_wallet_transactions_aggregate: Payment_Wallet_Transaction_Aggregate;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  wallet: Wallets;
  wallet_id: Scalars['bigint']['output'];
  /** An array relationship */
  wallets: Array<Wallets>;
  /** An array relationship */
  walletsByLastWalletTransactionId: Array<Wallets>;
  /** An aggregate relationship */
  walletsByLastWalletTransactionId_aggregate: Wallets_Aggregate;
  /** An aggregate relationship */
  wallets_aggregate: Wallets_Aggregate;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsInvoice_Wallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsInvoice_Wallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsLine_Item_Wallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsLine_Item_Wallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Item_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Item_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsParkable_Transaction_Wallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsParkable_Transaction_Wallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parkable_Transaction_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsPayment_Wallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsPayment_Wallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Wallet_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Wallet_Transaction_Order_By>>;
  where?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsWalletsArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsWalletsByLastWalletTransactionIdArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsWalletsByLastWalletTransactionId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsWallets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallets_Order_By>>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};

/** aggregated selection of "wallet_transactions" */
export type Wallet_Transactions_Aggregate = {
  __typename?: 'wallet_transactions_aggregate';
  aggregate?: Maybe<Wallet_Transactions_Aggregate_Fields>;
  nodes: Array<Wallet_Transactions>;
};

export type Wallet_Transactions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp_Count>;
};

export type Wallet_Transactions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Wallet_Transactions_Select_Column_Wallet_Transactions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallet_Transactions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Wallet_Transactions_Select_Column_Wallet_Transactions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallet_Transactions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "wallet_transactions" */
export type Wallet_Transactions_Aggregate_Fields = {
  __typename?: 'wallet_transactions_aggregate_fields';
  avg?: Maybe<Wallet_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Wallet_Transactions_Max_Fields>;
  min?: Maybe<Wallet_Transactions_Min_Fields>;
  stddev?: Maybe<Wallet_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Wallet_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Wallet_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Wallet_Transactions_Sum_Fields>;
  var_pop?: Maybe<Wallet_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Wallet_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Wallet_Transactions_Variance_Fields>;
};


/** aggregate fields of "wallet_transactions" */
export type Wallet_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "wallet_transactions" */
export type Wallet_Transactions_Aggregate_Order_By = {
  avg?: InputMaybe<Wallet_Transactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wallet_Transactions_Max_Order_By>;
  min?: InputMaybe<Wallet_Transactions_Min_Order_By>;
  stddev?: InputMaybe<Wallet_Transactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Wallet_Transactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Wallet_Transactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Wallet_Transactions_Sum_Order_By>;
  var_pop?: InputMaybe<Wallet_Transactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Wallet_Transactions_Var_Samp_Order_By>;
  variance?: InputMaybe<Wallet_Transactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "wallet_transactions" */
export type Wallet_Transactions_Arr_Rel_Insert_Input = {
  data: Array<Wallet_Transactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallet_Transactions_On_Conflict>;
};

/** aggregate avg on columns */
export type Wallet_Transactions_Avg_Fields = {
  __typename?: 'wallet_transactions_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "wallet_transactions". All fields are combined with a logical 'AND'. */
export type Wallet_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Wallet_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Wallet_Transactions_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  idempotent_key?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_wallet_transactions?: InputMaybe<Invoice_Wallet_Transaction_Bool_Exp>;
  invoice_wallet_transactions_aggregate?: InputMaybe<Invoice_Wallet_Transaction_Aggregate_Bool_Exp>;
  is_opening_balance?: InputMaybe<Boolean_Comparison_Exp>;
  line_item_wallet_transactions?: InputMaybe<Line_Item_Wallet_Transaction_Bool_Exp>;
  line_item_wallet_transactions_aggregate?: InputMaybe<Line_Item_Wallet_Transaction_Aggregate_Bool_Exp>;
  parkable_transaction_wallet_transactions?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Bool_Exp>;
  parkable_transaction_wallet_transactions_aggregate?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Aggregate_Bool_Exp>;
  payment_wallet_transactions?: InputMaybe<Payment_Wallet_Transaction_Bool_Exp>;
  payment_wallet_transactions_aggregate?: InputMaybe<Payment_Wallet_Transaction_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  wallet?: InputMaybe<Wallets_Bool_Exp>;
  wallet_id?: InputMaybe<Bigint_Comparison_Exp>;
  wallets?: InputMaybe<Wallets_Bool_Exp>;
  walletsByLastWalletTransactionId?: InputMaybe<Wallets_Bool_Exp>;
  walletsByLastWalletTransactionId_aggregate?: InputMaybe<Wallets_Aggregate_Bool_Exp>;
  wallets_aggregate?: InputMaybe<Wallets_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "wallet_transactions" */
export enum Wallet_Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  WalletTransactionsPkey = 'wallet_transactions_pkey',
  /** unique or primary key constraint on columns "is_opening_balance", "wallet_id" */
  WalletTransactionsWalletIdIsOpeningBalanceUnique = 'wallet_transactions_wallet_id_is_opening_balance_unique'
}

/** input type for incrementing numeric columns in table "wallet_transactions" */
export type Wallet_Transactions_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "wallet_transactions" */
export type Wallet_Transactions_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  invoice_wallet_transactions?: InputMaybe<Invoice_Wallet_Transaction_Arr_Rel_Insert_Input>;
  is_opening_balance?: InputMaybe<Scalars['Boolean']['input']>;
  line_item_wallet_transactions?: InputMaybe<Line_Item_Wallet_Transaction_Arr_Rel_Insert_Input>;
  parkable_transaction_wallet_transactions?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Arr_Rel_Insert_Input>;
  payment_wallet_transactions?: InputMaybe<Payment_Wallet_Transaction_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet?: InputMaybe<Wallets_Obj_Rel_Insert_Input>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
  wallets?: InputMaybe<Wallets_Arr_Rel_Insert_Input>;
  walletsByLastWalletTransactionId?: InputMaybe<Wallets_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Wallet_Transactions_Max_Fields = {
  __typename?: 'wallet_transactions_max_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wallet_Transactions_Min_Fields = {
  __typename?: 'wallet_transactions_min_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  idempotent_key?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  wallet_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "wallet_transactions" */
export type Wallet_Transactions_Mutation_Response = {
  __typename?: 'wallet_transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wallet_Transactions>;
};

/** input type for inserting object relation for remote table "wallet_transactions" */
export type Wallet_Transactions_Obj_Rel_Insert_Input = {
  data: Wallet_Transactions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallet_Transactions_On_Conflict>;
};

/** on_conflict condition type for table "wallet_transactions" */
export type Wallet_Transactions_On_Conflict = {
  constraint: Wallet_Transactions_Constraint;
  update_columns?: Array<Wallet_Transactions_Update_Column>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "wallet_transactions". */
export type Wallet_Transactions_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotent_key?: InputMaybe<Order_By>;
  invoice_wallet_transactions_aggregate?: InputMaybe<Invoice_Wallet_Transaction_Aggregate_Order_By>;
  is_opening_balance?: InputMaybe<Order_By>;
  line_item_wallet_transactions_aggregate?: InputMaybe<Line_Item_Wallet_Transaction_Aggregate_Order_By>;
  parkable_transaction_wallet_transactions_aggregate?: InputMaybe<Parkable_Transaction_Wallet_Transaction_Aggregate_Order_By>;
  payment_wallet_transactions_aggregate?: InputMaybe<Payment_Wallet_Transaction_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wallet?: InputMaybe<Wallets_Order_By>;
  wallet_id?: InputMaybe<Order_By>;
  walletsByLastWalletTransactionId_aggregate?: InputMaybe<Wallets_Aggregate_Order_By>;
  wallets_aggregate?: InputMaybe<Wallets_Aggregate_Order_By>;
};

/** primary key columns input for table: wallet_transactions */
export type Wallet_Transactions_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "wallet_transactions" */
export enum Wallet_Transactions_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  IsOpeningBalance = 'is_opening_balance',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WalletId = 'wallet_id'
}

/** select "wallet_transactions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "wallet_transactions" */
export enum Wallet_Transactions_Select_Column_Wallet_Transactions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsOpeningBalance = 'is_opening_balance'
}

/** select "wallet_transactions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "wallet_transactions" */
export enum Wallet_Transactions_Select_Column_Wallet_Transactions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsOpeningBalance = 'is_opening_balance'
}

/** input type for updating data in table "wallet_transactions" */
export type Wallet_Transactions_Set_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  is_opening_balance?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Wallet_Transactions_Stddev_Fields = {
  __typename?: 'wallet_transactions_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wallet_Transactions_Stddev_Pop_Fields = {
  __typename?: 'wallet_transactions_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wallet_Transactions_Stddev_Samp_Fields = {
  __typename?: 'wallet_transactions_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "wallet_transactions" */
export type Wallet_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wallet_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wallet_Transactions_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  idempotent_key?: InputMaybe<Scalars['uuid']['input']>;
  is_opening_balance?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Wallet_Transactions_Sum_Fields = {
  __typename?: 'wallet_transactions_sum_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  wallet_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** update columns of table "wallet_transactions" */
export enum Wallet_Transactions_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotentKey = 'idempotent_key',
  /** column name */
  IsOpeningBalance = 'is_opening_balance',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WalletId = 'wallet_id'
}

export type Wallet_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wallet_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wallet_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wallet_Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Wallet_Transactions_Var_Pop_Fields = {
  __typename?: 'wallet_transactions_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wallet_Transactions_Var_Samp_Fields = {
  __typename?: 'wallet_transactions_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wallet_Transactions_Variance_Fields = {
  __typename?: 'wallet_transactions_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  wallet_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "wallets" */
export type Wallets = {
  __typename?: 'wallets';
  auto_reload: Scalars['Boolean']['output'];
  auto_reload_amount?: Maybe<Scalars['Int']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['bigint']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Int']['output']>;
  balance: Scalars['Int']['output'];
  created_at: Scalars['timestamp']['output'];
  id: Scalars['bigint']['output'];
  last_processed_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  payment_method?: Maybe<Payment_Methods>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint']['output'];
  /** An object relationship */
  walletTransactionByLastWalletTransactionId?: Maybe<Wallet_Transactions>;
  /** An object relationship */
  wallet_transaction?: Maybe<Wallet_Transactions>;
  /** An array relationship */
  wallet_transactions: Array<Wallet_Transactions>;
  /** An aggregate relationship */
  wallet_transactions_aggregate: Wallet_Transactions_Aggregate;
};


/** columns and relationships of "wallets" */
export type WalletsWallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


/** columns and relationships of "wallets" */
export type WalletsWallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};

/** aggregated selection of "wallets" */
export type Wallets_Aggregate = {
  __typename?: 'wallets_aggregate';
  aggregate?: Maybe<Wallets_Aggregate_Fields>;
  nodes: Array<Wallets>;
};

export type Wallets_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Wallets_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Wallets_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Wallets_Aggregate_Bool_Exp_Count>;
};

export type Wallets_Aggregate_Bool_Exp_Bool_And = {
  arguments: Wallets_Select_Column_Wallets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallets_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Wallets_Select_Column_Wallets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wallets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "wallets" */
export type Wallets_Aggregate_Fields = {
  __typename?: 'wallets_aggregate_fields';
  avg?: Maybe<Wallets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Wallets_Max_Fields>;
  min?: Maybe<Wallets_Min_Fields>;
  stddev?: Maybe<Wallets_Stddev_Fields>;
  stddev_pop?: Maybe<Wallets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Wallets_Stddev_Samp_Fields>;
  sum?: Maybe<Wallets_Sum_Fields>;
  var_pop?: Maybe<Wallets_Var_Pop_Fields>;
  var_samp?: Maybe<Wallets_Var_Samp_Fields>;
  variance?: Maybe<Wallets_Variance_Fields>;
};


/** aggregate fields of "wallets" */
export type Wallets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wallets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "wallets" */
export type Wallets_Aggregate_Order_By = {
  avg?: InputMaybe<Wallets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wallets_Max_Order_By>;
  min?: InputMaybe<Wallets_Min_Order_By>;
  stddev?: InputMaybe<Wallets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Wallets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Wallets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Wallets_Sum_Order_By>;
  var_pop?: InputMaybe<Wallets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Wallets_Var_Samp_Order_By>;
  variance?: InputMaybe<Wallets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "wallets" */
export type Wallets_Arr_Rel_Insert_Input = {
  data: Array<Wallets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallets_On_Conflict>;
};

/** aggregate avg on columns */
export type Wallets_Avg_Fields = {
  __typename?: 'wallets_avg_fields';
  auto_reload_amount?: Maybe<Scalars['Float']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['Float']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_processed_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "wallets" */
export type Wallets_Avg_Order_By = {
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "wallets". All fields are combined with a logical 'AND'. */
export type Wallets_Bool_Exp = {
  _and?: InputMaybe<Array<Wallets_Bool_Exp>>;
  _not?: InputMaybe<Wallets_Bool_Exp>;
  _or?: InputMaybe<Array<Wallets_Bool_Exp>>;
  auto_reload?: InputMaybe<Boolean_Comparison_Exp>;
  auto_reload_amount?: InputMaybe<Int_Comparison_Exp>;
  auto_reload_payment_method_id?: InputMaybe<Bigint_Comparison_Exp>;
  auto_reload_threshold?: InputMaybe<Int_Comparison_Exp>;
  balance?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_processed_wallet_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  last_wallet_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_method?: InputMaybe<Payment_Methods_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  walletTransactionByLastWalletTransactionId?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transactions?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transactions_aggregate?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "wallets" */
export enum Wallets_Constraint {
  /** unique or primary key constraint on columns "id" */
  WalletsPkey = 'wallets_pkey',
  /** unique or primary key constraint on columns "user_id" */
  WalletsUserIdUnique = 'wallets_user_id_unique'
}

/** input type for incrementing numeric columns in table "wallets" */
export type Wallets_Inc_Input = {
  auto_reload_amount?: InputMaybe<Scalars['Int']['input']>;
  auto_reload_payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  auto_reload_threshold?: InputMaybe<Scalars['Int']['input']>;
  balance?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_processed_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  last_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "wallets" */
export type Wallets_Insert_Input = {
  auto_reload?: InputMaybe<Scalars['Boolean']['input']>;
  auto_reload_amount?: InputMaybe<Scalars['Int']['input']>;
  auto_reload_payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  auto_reload_threshold?: InputMaybe<Scalars['Int']['input']>;
  balance?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_processed_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  last_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  payment_method?: InputMaybe<Payment_Methods_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  walletTransactionByLastWalletTransactionId?: InputMaybe<Wallet_Transactions_Obj_Rel_Insert_Input>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Obj_Rel_Insert_Input>;
  wallet_transactions?: InputMaybe<Wallet_Transactions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Wallets_Max_Fields = {
  __typename?: 'wallets_max_fields';
  auto_reload_amount?: Maybe<Scalars['Int']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['bigint']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Int']['output']>;
  balance?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_processed_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "wallets" */
export type Wallets_Max_Order_By = {
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wallets_Min_Fields = {
  __typename?: 'wallets_min_fields';
  auto_reload_amount?: Maybe<Scalars['Int']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['bigint']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Int']['output']>;
  balance?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_processed_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "wallets" */
export type Wallets_Min_Order_By = {
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "wallets" */
export type Wallets_Mutation_Response = {
  __typename?: 'wallets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wallets>;
};

/** input type for inserting object relation for remote table "wallets" */
export type Wallets_Obj_Rel_Insert_Input = {
  data: Wallets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallets_On_Conflict>;
};

/** on_conflict condition type for table "wallets" */
export type Wallets_On_Conflict = {
  constraint: Wallets_Constraint;
  update_columns?: Array<Wallets_Update_Column>;
  where?: InputMaybe<Wallets_Bool_Exp>;
};

/** Ordering options when selecting data from "wallets". */
export type Wallets_Order_By = {
  auto_reload?: InputMaybe<Order_By>;
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Payment_Methods_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  walletTransactionByLastWalletTransactionId?: InputMaybe<Wallet_Transactions_Order_By>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Order_By>;
  wallet_transactions_aggregate?: InputMaybe<Wallet_Transactions_Aggregate_Order_By>;
};

/** primary key columns input for table: wallets */
export type Wallets_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "wallets" */
export enum Wallets_Select_Column {
  /** column name */
  AutoReload = 'auto_reload',
  /** column name */
  AutoReloadAmount = 'auto_reload_amount',
  /** column name */
  AutoReloadPaymentMethodId = 'auto_reload_payment_method_id',
  /** column name */
  AutoReloadThreshold = 'auto_reload_threshold',
  /** column name */
  Balance = 'balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastProcessedWalletTransactionId = 'last_processed_wallet_transaction_id',
  /** column name */
  LastWalletTransactionId = 'last_wallet_transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "wallets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "wallets" */
export enum Wallets_Select_Column_Wallets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AutoReload = 'auto_reload'
}

/** select "wallets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "wallets" */
export enum Wallets_Select_Column_Wallets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AutoReload = 'auto_reload'
}

/** input type for updating data in table "wallets" */
export type Wallets_Set_Input = {
  auto_reload?: InputMaybe<Scalars['Boolean']['input']>;
  auto_reload_amount?: InputMaybe<Scalars['Int']['input']>;
  auto_reload_payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  auto_reload_threshold?: InputMaybe<Scalars['Int']['input']>;
  balance?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_processed_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  last_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Wallets_Stddev_Fields = {
  __typename?: 'wallets_stddev_fields';
  auto_reload_amount?: Maybe<Scalars['Float']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['Float']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_processed_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "wallets" */
export type Wallets_Stddev_Order_By = {
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wallets_Stddev_Pop_Fields = {
  __typename?: 'wallets_stddev_pop_fields';
  auto_reload_amount?: Maybe<Scalars['Float']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['Float']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_processed_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "wallets" */
export type Wallets_Stddev_Pop_Order_By = {
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wallets_Stddev_Samp_Fields = {
  __typename?: 'wallets_stddev_samp_fields';
  auto_reload_amount?: Maybe<Scalars['Float']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['Float']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_processed_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "wallets" */
export type Wallets_Stddev_Samp_Order_By = {
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "wallets" */
export type Wallets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wallets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wallets_Stream_Cursor_Value_Input = {
  auto_reload?: InputMaybe<Scalars['Boolean']['input']>;
  auto_reload_amount?: InputMaybe<Scalars['Int']['input']>;
  auto_reload_payment_method_id?: InputMaybe<Scalars['bigint']['input']>;
  auto_reload_threshold?: InputMaybe<Scalars['Int']['input']>;
  balance?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_processed_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  last_wallet_transaction_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Wallets_Sum_Fields = {
  __typename?: 'wallets_sum_fields';
  auto_reload_amount?: Maybe<Scalars['Int']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['bigint']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Int']['output']>;
  balance?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  last_processed_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "wallets" */
export type Wallets_Sum_Order_By = {
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "wallets" */
export enum Wallets_Update_Column {
  /** column name */
  AutoReload = 'auto_reload',
  /** column name */
  AutoReloadAmount = 'auto_reload_amount',
  /** column name */
  AutoReloadPaymentMethodId = 'auto_reload_payment_method_id',
  /** column name */
  AutoReloadThreshold = 'auto_reload_threshold',
  /** column name */
  Balance = 'balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastProcessedWalletTransactionId = 'last_processed_wallet_transaction_id',
  /** column name */
  LastWalletTransactionId = 'last_wallet_transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Wallets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wallets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wallets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wallets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Wallets_Var_Pop_Fields = {
  __typename?: 'wallets_var_pop_fields';
  auto_reload_amount?: Maybe<Scalars['Float']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['Float']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_processed_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "wallets" */
export type Wallets_Var_Pop_Order_By = {
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wallets_Var_Samp_Fields = {
  __typename?: 'wallets_var_samp_fields';
  auto_reload_amount?: Maybe<Scalars['Float']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['Float']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_processed_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "wallets" */
export type Wallets_Var_Samp_Order_By = {
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wallets_Variance_Fields = {
  __typename?: 'wallets_variance_fields';
  auto_reload_amount?: Maybe<Scalars['Float']['output']>;
  auto_reload_payment_method_id?: Maybe<Scalars['Float']['output']>;
  auto_reload_threshold?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  last_processed_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  last_wallet_transaction_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "wallets" */
export type Wallets_Variance_Order_By = {
  auto_reload_amount?: InputMaybe<Order_By>;
  auto_reload_payment_method_id?: InputMaybe<Order_By>;
  auto_reload_threshold?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_processed_wallet_transaction_id?: InputMaybe<Order_By>;
  last_wallet_transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

export type ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigQuery = { __typename?: 'query_root', config?: { __typename?: 'ConfigOutput', serverNow: string } | null, configV2?: { __typename?: 'ConfigV2Output', config?: { __typename?: 'ConfigV2', auth?: { __typename?: 'AuthConfigItem', value?: { __typename?: 'AuthConfig', forceLogOut?: { __typename?: 'ForceLogOutConfig', reasons: { __typename?: 'ForceLogOutReasonConfigs', USER_MISSING: { __typename?: 'ForceLogOutReasonConfig', enabled: boolean }, IDENTITY_MISSING: { __typename?: 'ForceLogOutReasonConfig', enabled: boolean }, CREDENTIAL_MISMATCH: { __typename?: 'ForceLogOutReasonConfig', enabled: boolean }, USER_PENDING_DELETION: { __typename?: 'ForceLogOutReasonConfig', enabled: boolean }, USER_DELETED: { __typename?: 'ForceLogOutReasonConfig', enabled: boolean }, USER_LOCKED: { __typename?: 'ForceLogOutReasonConfig', enabled: boolean }, USER_FRAUDULENT: { __typename?: 'ForceLogOutReasonConfig', enabled: boolean } } } | null } | null, overrides?: { __typename?: 'ConfigOverrides', ids?: Array<any> | null, fromCache?: boolean | null } | null } | null } | null } | null };

export type SubmitEventsPrivateMutationVariables = Exact<{
  eventsBatches: Array<EventsBatch> | EventsBatch;
  device?: InputMaybe<ClientDevice>;
  now: Scalars['Int']['input'];
}>;


export type SubmitEventsPrivateMutation = { __typename?: 'mutation_root', submitEventsPrivate?: { __typename?: 'SubmitEventsOutput', result: Array<{ __typename?: 'EventsBatchResult', batchId: string, success: boolean, error?: string | null }> } | null };

export type SubmitEventsPublicMutationVariables = Exact<{
  eventsBatches: Array<EventsBatch> | EventsBatch;
  unauthenticatedCredentials?: InputMaybe<UnauthenticatedCredentials>;
  device?: InputMaybe<ClientDevice>;
  now: Scalars['Int']['input'];
}>;


export type SubmitEventsPublicMutation = { __typename?: 'mutation_root', submitEventsPublic?: { __typename?: 'SubmitEventsOutput', result: Array<{ __typename?: 'EventsBatchResult', batchId: string, success: boolean, error?: string | null }> } | null };

export type CancelParkableTransactionMutationVariables = Exact<{
  parkableTransactionId: Scalars['bigint']['input'];
}>;


export type CancelParkableTransactionMutation = { __typename?: 'mutation_root', cancelParkableTransaction?: { __typename?: 'CancelParkableTransactionOutput', parkableTransaction?: { __typename?: 'parkable_transactions', id: any, idempotent_key?: any | null, parkable_id: any, user_id: any, vehicle_id: any, payment_method_id?: any | null, time: number, snapshot_price_interval_unit: string, snapshot_price_interval: number, snapshot_price: number, snapshot_fee?: number | null, snapshot_time_limit: number, snapshot_time_limit_unit: string, snapshot_license_plate?: string | null, last_time_extended_at?: any | null, last_enforcement_notified_at?: any | null, last_acknowledged_at?: any | null, created_at?: any | null, expires_at?: any | null, cancelled_at?: any | null, expired_at?: any | null, updated_at?: any | null, payment_finalized_at?: any | null, finalized_at?: any | null, funds_transferred_at?: any | null, parkable: { __typename?: 'parkables', id: any, parking_authority_id: any, identifier: number, type: string, time_limit: number, time_limit_unit: string, price_interval_unit: string, price_interval: number, price: number, enabled: boolean, latitude?: string | null, longitude?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, data?: any | null, parking_authority: { __typename?: 'parking_authorities', city?: string | null, state?: string | null, wallet_fee: any, card_fee: any }, parkable_parkable_groups: Array<{ __typename?: 'parkable_parkable_group', parkable_group: { __typename?: 'parkable_groups', name: string } }> }, vehicle: { __typename?: 'vehicles', id: any, user_id: any, name?: string | null, manufacturer_make?: string | null, manufacturer_model?: string | null, type?: string | null, color?: string | null, license_plate?: string | null, country_code?: string | null, state_code?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null }, payment_method?: { __typename?: 'payment_methods', alias?: string | null, created_at: any, default: boolean, deleted_at?: any | null, id: any, type: string, updated_at?: any | null, user_id: any, mx_merchant_payment_method_metas: Array<{ __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null }> } | null } | null } | null };

export type CreateParkableTransactionMutationVariables = Exact<{
  idempotentKey: Scalars['uuid']['input'];
  parkableId: Scalars['bigint']['input'];
  time: Scalars['Int']['input'];
  vehicleId: Scalars['bigint']['input'];
  paymentMethodId?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateParkableTransactionMutation = { __typename?: 'mutation_root', createParkableTransaction?: { __typename?: 'CreateParkableTransactionOutput', parkableTransaction?: { __typename?: 'parkable_transactions', id: any, idempotent_key?: any | null, parkable_id: any, user_id: any, vehicle_id: any, payment_method_id?: any | null, time: number, snapshot_price_interval_unit: string, snapshot_price_interval: number, snapshot_price: number, snapshot_fee?: number | null, snapshot_time_limit: number, snapshot_time_limit_unit: string, snapshot_license_plate?: string | null, last_time_extended_at?: any | null, last_enforcement_notified_at?: any | null, last_acknowledged_at?: any | null, created_at?: any | null, expires_at?: any | null, cancelled_at?: any | null, expired_at?: any | null, updated_at?: any | null, payment_finalized_at?: any | null, finalized_at?: any | null, funds_transferred_at?: any | null, parkable: { __typename?: 'parkables', id: any, parking_authority_id: any, identifier: number, type: string, time_limit: number, time_limit_unit: string, price_interval_unit: string, price_interval: number, price: number, enabled: boolean, latitude?: string | null, longitude?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, data?: any | null, parking_authority: { __typename?: 'parking_authorities', city?: string | null, state?: string | null, wallet_fee: any, card_fee: any }, parkable_parkable_groups: Array<{ __typename?: 'parkable_parkable_group', parkable_group: { __typename?: 'parkable_groups', name: string } }> }, vehicle: { __typename?: 'vehicles', id: any, user_id: any, name?: string | null, manufacturer_make?: string | null, manufacturer_model?: string | null, type?: string | null, color?: string | null, license_plate?: string | null, country_code?: string | null, state_code?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null }, payment_method?: { __typename?: 'payment_methods', alias?: string | null, created_at: any, default: boolean, deleted_at?: any | null, id: any, type: string, updated_at?: any | null, user_id: any, mx_merchant_payment_method_metas: Array<{ __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null }> } | null } | null } | null };

export type ExtendTimeMutationVariables = Exact<{
  idempotentKey: Scalars['uuid']['input'];
  parkableTransactionId: Scalars['bigint']['input'];
  time: Scalars['Int']['input'];
}>;


export type ExtendTimeMutation = { __typename?: 'mutation_root', extendTime?: { __typename?: 'ExtendTimeOutput', parkableTransaction?: { __typename?: 'parkable_transactions', id: any, idempotent_key?: any | null, parkable_id: any, user_id: any, vehicle_id: any, payment_method_id?: any | null, time: number, snapshot_price_interval_unit: string, snapshot_price_interval: number, snapshot_price: number, snapshot_fee?: number | null, snapshot_time_limit: number, snapshot_time_limit_unit: string, snapshot_license_plate?: string | null, last_time_extended_at?: any | null, last_enforcement_notified_at?: any | null, last_acknowledged_at?: any | null, created_at?: any | null, expires_at?: any | null, cancelled_at?: any | null, expired_at?: any | null, updated_at?: any | null, payment_finalized_at?: any | null, finalized_at?: any | null, funds_transferred_at?: any | null, parkable: { __typename?: 'parkables', id: any, parking_authority_id: any, identifier: number, type: string, time_limit: number, time_limit_unit: string, price_interval_unit: string, price_interval: number, price: number, enabled: boolean, latitude?: string | null, longitude?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, data?: any | null, parking_authority: { __typename?: 'parking_authorities', city?: string | null, state?: string | null, wallet_fee: any, card_fee: any }, parkable_parkable_groups: Array<{ __typename?: 'parkable_parkable_group', parkable_group: { __typename?: 'parkable_groups', name: string } }> }, vehicle: { __typename?: 'vehicles', id: any, user_id: any, name?: string | null, manufacturer_make?: string | null, manufacturer_model?: string | null, type?: string | null, color?: string | null, license_plate?: string | null, country_code?: string | null, state_code?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null }, payment_method?: { __typename?: 'payment_methods', alias?: string | null, created_at: any, default: boolean, deleted_at?: any | null, id: any, type: string, updated_at?: any | null, user_id: any, mx_merchant_payment_method_metas: Array<{ __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null }> } | null } | null } | null };

export type ParkableTransactionQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type ParkableTransactionQuery = { __typename?: 'query_root', parkable_transactions_by_pk?: { __typename?: 'parkable_transactions', id: any, idempotent_key?: any | null, parkable_id: any, user_id: any, vehicle_id: any, payment_method_id?: any | null, time: number, snapshot_price_interval_unit: string, snapshot_price_interval: number, snapshot_price: number, snapshot_fee?: number | null, snapshot_time_limit: number, snapshot_time_limit_unit: string, snapshot_license_plate?: string | null, last_time_extended_at?: any | null, last_enforcement_notified_at?: any | null, last_acknowledged_at?: any | null, created_at?: any | null, expires_at?: any | null, cancelled_at?: any | null, expired_at?: any | null, updated_at?: any | null, payment_finalized_at?: any | null, finalized_at?: any | null, funds_transferred_at?: any | null, payment_method?: { __typename?: 'payment_methods', alias?: string | null, created_at: any, default: boolean, deleted_at?: any | null, id: any, type: string, updated_at?: any | null, user_id: any, mx_merchant_payment_method_metas: Array<{ __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null }> } | null, parkable: { __typename?: 'parkables', id: any, parking_authority_id: any, identifier: number, type: string, time_limit: number, time_limit_unit: string, price_interval_unit: string, price_interval: number, price: number, enabled: boolean, latitude?: string | null, longitude?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, data?: any | null, parking_authority: { __typename?: 'parking_authorities', city?: string | null, state?: string | null, wallet_fee: any, card_fee: any }, parkable_parkable_groups: Array<{ __typename?: 'parkable_parkable_group', parkable_group: { __typename?: 'parkable_groups', name: string } }> }, vehicle: { __typename?: 'vehicles', id: any, user_id: any, name?: string | null, manufacturer_make?: string | null, manufacturer_model?: string | null, type?: string | null, color?: string | null, license_plate?: string | null, country_code?: string | null, state_code?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null } } | null };

export type RecentParkableTransactionsQueryVariables = Exact<{
  dateFrom: Scalars['timestamp']['input'];
  limit?: Scalars['Int']['input'];
}>;


export type RecentParkableTransactionsQuery = { __typename?: 'query_root', parkable_transactions: Array<{ __typename?: 'parkable_transactions', id: any, idempotent_key?: any | null, parkable_id: any, user_id: any, vehicle_id: any, payment_method_id?: any | null, time: number, snapshot_price_interval_unit: string, snapshot_price_interval: number, snapshot_price: number, snapshot_fee?: number | null, snapshot_time_limit: number, snapshot_time_limit_unit: string, snapshot_license_plate?: string | null, last_time_extended_at?: any | null, last_enforcement_notified_at?: any | null, last_acknowledged_at?: any | null, created_at?: any | null, expires_at?: any | null, cancelled_at?: any | null, expired_at?: any | null, updated_at?: any | null, payment_finalized_at?: any | null, finalized_at?: any | null, funds_transferred_at?: any | null, payment_method?: { __typename?: 'payment_methods', alias?: string | null, created_at: any, default: boolean, deleted_at?: any | null, id: any, type: string, updated_at?: any | null, user_id: any, mx_merchant_payment_method_metas: Array<{ __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null }> } | null, parkable: { __typename?: 'parkables', id: any, parking_authority_id: any, identifier: number, type: string, time_limit: number, time_limit_unit: string, price_interval_unit: string, price_interval: number, price: number, enabled: boolean, latitude?: string | null, longitude?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, data?: any | null, parking_authority: { __typename?: 'parking_authorities', city?: string | null, state?: string | null, wallet_fee: any, card_fee: any }, parkable_parkable_groups: Array<{ __typename?: 'parkable_parkable_group', parkable_group: { __typename?: 'parkable_groups', name: string } }> }, vehicle: { __typename?: 'vehicles', id: any, user_id: any, name?: string | null, manufacturer_make?: string | null, manufacturer_model?: string | null, type?: string | null, color?: string | null, license_plate?: string | null, country_code?: string | null, state_code?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null } }> };

export type ParkableTransactionFieldsFragment = { __typename?: 'parkable_transactions', id: any, idempotent_key?: any | null, parkable_id: any, user_id: any, vehicle_id: any, payment_method_id?: any | null, time: number, snapshot_price_interval_unit: string, snapshot_price_interval: number, snapshot_price: number, snapshot_fee?: number | null, snapshot_time_limit: number, snapshot_time_limit_unit: string, snapshot_license_plate?: string | null, last_time_extended_at?: any | null, last_enforcement_notified_at?: any | null, last_acknowledged_at?: any | null, created_at?: any | null, expires_at?: any | null, cancelled_at?: any | null, expired_at?: any | null, updated_at?: any | null, payment_finalized_at?: any | null, finalized_at?: any | null, funds_transferred_at?: any | null, parkable: { __typename?: 'parkables', id: any, parking_authority_id: any, identifier: number, type: string, time_limit: number, time_limit_unit: string, price_interval_unit: string, price_interval: number, price: number, enabled: boolean, latitude?: string | null, longitude?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, data?: any | null, parking_authority: { __typename?: 'parking_authorities', city?: string | null, state?: string | null, wallet_fee: any, card_fee: any }, parkable_parkable_groups: Array<{ __typename?: 'parkable_parkable_group', parkable_group: { __typename?: 'parkable_groups', name: string } }> }, vehicle: { __typename?: 'vehicles', id: any, user_id: any, name?: string | null, manufacturer_make?: string | null, manufacturer_model?: string | null, type?: string | null, color?: string | null, license_plate?: string | null, country_code?: string | null, state_code?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null }, payment_method?: { __typename?: 'payment_methods', alias?: string | null, created_at: any, default: boolean, deleted_at?: any | null, id: any, type: string, updated_at?: any | null, user_id: any, mx_merchant_payment_method_metas: Array<{ __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null }> } | null };

export type ParkableQueryVariables = Exact<{
  parkableId: Scalars['bigint']['input'];
}>;


export type ParkableQuery = { __typename?: 'query_root', parkables_by_pk?: { __typename?: 'parkables', id: any, parking_authority_id: any, identifier: number, type: string, time_limit: number, time_limit_unit: string, price_interval_unit: string, price_interval: number, price: number, enabled: boolean, latitude?: string | null, longitude?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, data?: any | null, parking_authority: { __typename?: 'parking_authorities', city?: string | null, state?: string | null, wallet_fee: any, card_fee: any }, parkable_parkable_groups: Array<{ __typename?: 'parkable_parkable_group', parkable_group: { __typename?: 'parkable_groups', name: string } }> } | null };

export type SearchParkablesQueryVariables = Exact<{
  identifier: Scalars['Int']['input'];
}>;


export type SearchParkablesQuery = { __typename?: 'query_root', parkables: Array<{ __typename?: 'parkables', id: any, parking_authority_id: any, identifier: number, type: string, time_limit: number, time_limit_unit: string, price_interval_unit: string, price_interval: number, price: number, enabled: boolean, latitude?: string | null, longitude?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, data?: any | null, parking_authority: { __typename?: 'parking_authorities', city?: string | null, state?: string | null, wallet_fee: any, card_fee: any }, parkable_parkable_groups: Array<{ __typename?: 'parkable_parkable_group', parkable_group: { __typename?: 'parkable_groups', name: string } }> }> };

export type ParkableFieldsFragment = { __typename?: 'parkables', id: any, parking_authority_id: any, identifier: number, type: string, time_limit: number, time_limit_unit: string, price_interval_unit: string, price_interval: number, price: number, enabled: boolean, latitude?: string | null, longitude?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, data?: any | null, parking_authority: { __typename?: 'parking_authorities', city?: string | null, state?: string | null, wallet_fee: any, card_fee: any }, parkable_parkable_groups: Array<{ __typename?: 'parkable_parkable_group', parkable_group: { __typename?: 'parkable_groups', name: string } }> };

export type ParkingAuthoritiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ParkingAuthoritiesQuery = { __typename?: 'query_root', parking_authorities: Array<{ __typename?: 'parking_authorities', id: any, name: string, city?: string | null, state?: string | null, postal_code?: string | null }> };

export type CreateMxmCustomerMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateMxmCustomerMutation = { __typename?: 'mutation_root', createMxmCustomer?: { __typename?: 'CreateMxmCustomerOutput', user?: { __typename?: 'users', id: any, cognito_identity_id?: string | null, email?: string | null, phone_number?: string | null, first_name?: string | null, last_name?: string | null, terms_of_service_last_accepted?: any | null, mxm_customer_id?: any | null, pending_deletion_at?: any | null, last_login_at?: any | null, last_active_at?: any | null, is_legacy_migration: boolean, primary_parking_authority_id?: any | null, num_vehicles: any, num_payment_methods: any, setup_vehicles_last_nag_at?: any | null, setup_payment_methods_last_nag_at?: any | null, setup_wallet_last_nag_at?: any | null, setup_primary_parking_authority_last_nag_at?: any | null, beta_features_enabled?: boolean | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, last_wallet_prompt_at?: any | null, locked_at?: any | null, anonymized_at?: any | null, fraud_review_status?: string | null, wallet?: { __typename?: 'wallets', id: any, user_id: any, balance: number, auto_reload: boolean, last_wallet_transaction_id?: any | null } | null, legacyMigration?: { __typename?: 'legacy_migrations', id: any, last_general_error?: string | null, last_general_error_sentry_event_id?: string | null, user_id: any, started_at?: any | null, completed_at?: any | null, last_user_sync_at?: any | null, last_user_sync_error?: string | null, last_user_sync_error_sentry_event_id?: string | null, last_vehicles_sync_at?: any | null, last_vehicles_sync_error?: string | null, last_vehicles_sync_error_sentry_event_id?: string | null, last_payment_methods_sync_at?: any | null, last_payment_methods_sync_error?: string | null, last_payment_methods_sync_error_sentry_event_id?: string | null, last_wallet_sync_at?: any | null, last_wallet_sync_error?: string | null, last_wallet_sync_error_sentry_event_id?: string | null, last_active_parkable_transaction_sync_at?: any | null, last_active_parkable_transaction_sync_error?: string | null, last_active_parkable_transaction_sync_error_sentry_event_id?: string | null, legacy_active_parkable_transaction_id?: any | null, active_parkable_transaction_id?: any | null, created_at?: any | null, updated_at?: any | null } | null } | null } | null };

export type CreatePaymentMethodMutationVariables = Exact<{
  idempotentKey: Scalars['String']['input'];
  alias: Scalars['String']['input'];
  lastFour: Scalars['String']['input'];
  type: Scalars['String']['input'];
  cardAccountId?: InputMaybe<Scalars['bigint']['input']>;
  cardAccountCardType: Scalars['String']['input'];
  cardAccountCardId?: InputMaybe<Scalars['String']['input']>;
  cardAccountToken: Scalars['String']['input'];
  expiryMonth: Scalars['String']['input'];
  expiryYear: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
}>;


export type CreatePaymentMethodMutation = { __typename?: 'mutation_root', insert_payment_methods_one?: { __typename?: 'payment_methods', alias?: string | null, created_at: any, default: boolean, deleted_at?: any | null, id: any, type: string, updated_at?: any | null, user_id: any, mx_merchant_payment_method_metas: Array<{ __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null }> } | null };

export type DeletePaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['bigint']['input'];
}>;


export type DeletePaymentMethodMutation = { __typename?: 'mutation_root', deletePaymentMethod?: { __typename?: 'DeletePaymentMethodOutput', deletedPaymentMethodId: any } | null };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename?: 'query_root', payment_methods: Array<{ __typename?: 'payment_methods', alias?: string | null, created_at: any, default: boolean, deleted_at?: any | null, id: any, type: string, updated_at?: any | null, user_id: any, mx_merchant_payment_method_metas: Array<{ __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null }> }> };

export type RequestPaymentLimitedUseTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestPaymentLimitedUseTokenMutation = { __typename?: 'mutation_root', requestPaymentLimitedUseToken: { __typename?: 'RequestPaymentLimitedUseTokenOutput', token: string } };

export type StoreVaultedCardAccountMutationVariables = Exact<{
  alias: Scalars['String']['input'];
  lastFour: Scalars['String']['input'];
  type: Scalars['String']['input'];
  cardAccountId?: InputMaybe<Scalars['bigint']['input']>;
  cardAccountCardType: Scalars['String']['input'];
  cardAccountCardId?: InputMaybe<Scalars['String']['input']>;
  cardAccountToken: Scalars['String']['input'];
  expiryMonth: Scalars['String']['input'];
  expiryYear: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
}>;


export type StoreVaultedCardAccountMutation = { __typename?: 'mutation_root', storeVaultedCardAccount?: { __typename?: 'StoreVaultedCardAccountOutput', alreadyExists: boolean, paymentMethod?: { __typename?: 'payment_methods', alias?: string | null, created_at: any, default: boolean, deleted_at?: any | null, id: any, type: string, updated_at?: any | null, user_id: any, mx_merchant_payment_method_metas: Array<{ __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null }> } | null } | null };

export type PaymentMethodFieldsFragment = { __typename?: 'payment_methods', alias?: string | null, created_at: any, default: boolean, deleted_at?: any | null, id: any, type: string, updated_at?: any | null, user_id: any, mx_merchant_payment_method_metas: Array<{ __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null }> };

export type PaymentMethodMxmFieldsFragment = { __typename?: 'mx_merchant_payment_method_metas', id: any, meta_card_account_card_type: string, meta_card_account_last_4: string, meta_card_account_expiry_month: string, meta_card_account_expiry_year: string, meta_card_account_postal_code?: string | null };

export type CreateSupportTicketMutationVariables = Exact<{
  idempotentKey: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  message: Scalars['String']['input'];
  device?: InputMaybe<ClientDevice>;
  contextData?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSupportTicketMutation = { __typename?: 'mutation_root', createSupportTicket?: { __typename?: 'CreateSupportTicketOutput', id: any, supportTicket?: { __typename?: 'support_tickets', id: any, idempotent_key: any, user_id?: any | null, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, message?: string | null, external_ticket_id?: string | null, external_submitted: boolean } | null } | null };

export type CreateSupportTicketGuestMutationVariables = Exact<{
  idempotentKey: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  message: Scalars['String']['input'];
  device?: InputMaybe<ClientDevice>;
  contextData?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSupportTicketGuestMutation = { __typename?: 'mutation_root', createSupportTicketGuest?: { __typename?: 'CreateSupportTicketGuestOutput', id: any } | null };

export type SupportTicketFieldsFragment = { __typename?: 'support_tickets', id: any, idempotent_key: any, user_id?: any | null, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, message?: string | null, external_ticket_id?: string | null, external_submitted: boolean };

export type UpdateUserSettingsMutationVariables = Exact<{
  userSettings: Array<InputMaybe<UserSetting>> | InputMaybe<UserSetting>;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'mutation_root', updateUserSettings?: { __typename?: 'UpdateUserSettingOutput', updatedUserSettings: Array<{ __typename?: 'UpdatedUserSetting', key: string, value?: string | null } | null> } | null };

export type UserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSettingsQuery = { __typename?: 'query_root', user_settings_all: Array<{ __typename?: 'user_settings_all', key?: string | null, value?: string | null }> };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  values?: InputMaybe<Users_Set_Input>;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, cognito_identity_id?: string | null, email?: string | null, phone_number?: string | null, first_name?: string | null, last_name?: string | null, terms_of_service_last_accepted?: any | null, mxm_customer_id?: any | null, pending_deletion_at?: any | null, last_login_at?: any | null, last_active_at?: any | null, is_legacy_migration: boolean, primary_parking_authority_id?: any | null, num_vehicles: any, num_payment_methods: any, setup_vehicles_last_nag_at?: any | null, setup_payment_methods_last_nag_at?: any | null, setup_wallet_last_nag_at?: any | null, setup_primary_parking_authority_last_nag_at?: any | null, beta_features_enabled?: boolean | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, last_wallet_prompt_at?: any | null, locked_at?: any | null, anonymized_at?: any | null, fraud_review_status?: string | null, wallet?: { __typename?: 'wallets', id: any, user_id: any, balance: number, auto_reload: boolean, last_wallet_transaction_id?: any | null } | null, legacyMigration?: { __typename?: 'legacy_migrations', id: any, last_general_error?: string | null, last_general_error_sentry_event_id?: string | null, user_id: any, started_at?: any | null, completed_at?: any | null, last_user_sync_at?: any | null, last_user_sync_error?: string | null, last_user_sync_error_sentry_event_id?: string | null, last_vehicles_sync_at?: any | null, last_vehicles_sync_error?: string | null, last_vehicles_sync_error_sentry_event_id?: string | null, last_payment_methods_sync_at?: any | null, last_payment_methods_sync_error?: string | null, last_payment_methods_sync_error_sentry_event_id?: string | null, last_wallet_sync_at?: any | null, last_wallet_sync_error?: string | null, last_wallet_sync_error_sentry_event_id?: string | null, last_active_parkable_transaction_sync_at?: any | null, last_active_parkable_transaction_sync_error?: string | null, last_active_parkable_transaction_sync_error_sentry_event_id?: string | null, legacy_active_parkable_transaction_id?: any | null, active_parkable_transaction_id?: any | null, created_at?: any | null, updated_at?: any | null } | null } | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, cognito_identity_id?: string | null, email?: string | null, phone_number?: string | null, first_name?: string | null, last_name?: string | null, terms_of_service_last_accepted?: any | null, mxm_customer_id?: any | null, pending_deletion_at?: any | null, last_login_at?: any | null, last_active_at?: any | null, is_legacy_migration: boolean, primary_parking_authority_id?: any | null, num_vehicles: any, num_payment_methods: any, setup_vehicles_last_nag_at?: any | null, setup_payment_methods_last_nag_at?: any | null, setup_wallet_last_nag_at?: any | null, setup_primary_parking_authority_last_nag_at?: any | null, beta_features_enabled?: boolean | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, last_wallet_prompt_at?: any | null, locked_at?: any | null, anonymized_at?: any | null, fraud_review_status?: string | null, identities: Array<{ __typename?: 'identities', id: any, created_at?: any | null, updated_at?: any | null, last_login_at?: any | null, last_active_at?: any | null, locked_at?: any | null, provider: string, provider_id: string, id_token_expires_at?: any | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, nickname?: string | null, avatar?: string | null, email?: string | null, email_verified?: boolean | null, phone_number?: string | null, user_id?: any | null }>, r_user?: { __typename?: 'r_users', num_parkable_transactions?: number | null, percent_wallet_usage?: any | null } | null, wallet?: { __typename?: 'wallets', id: any, user_id: any, balance: number, auto_reload: boolean, last_wallet_transaction_id?: any | null } | null, legacyMigration?: { __typename?: 'legacy_migrations', id: any, last_general_error?: string | null, last_general_error_sentry_event_id?: string | null, user_id: any, started_at?: any | null, completed_at?: any | null, last_user_sync_at?: any | null, last_user_sync_error?: string | null, last_user_sync_error_sentry_event_id?: string | null, last_vehicles_sync_at?: any | null, last_vehicles_sync_error?: string | null, last_vehicles_sync_error_sentry_event_id?: string | null, last_payment_methods_sync_at?: any | null, last_payment_methods_sync_error?: string | null, last_payment_methods_sync_error_sentry_event_id?: string | null, last_wallet_sync_at?: any | null, last_wallet_sync_error?: string | null, last_wallet_sync_error_sentry_event_id?: string | null, last_active_parkable_transaction_sync_at?: any | null, last_active_parkable_transaction_sync_error?: string | null, last_active_parkable_transaction_sync_error_sentry_event_id?: string | null, legacy_active_parkable_transaction_id?: any | null, active_parkable_transaction_id?: any | null, created_at?: any | null, updated_at?: any | null } | null }> };

export type IdentityFieldsFragment = { __typename?: 'identities', id: any, created_at?: any | null, updated_at?: any | null, last_login_at?: any | null, last_active_at?: any | null, locked_at?: any | null, provider: string, provider_id: string, id_token_expires_at?: any | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, nickname?: string | null, avatar?: string | null, email?: string | null, email_verified?: boolean | null, phone_number?: string | null, user_id?: any | null };

export type LegacyMigrationFieldsFragment = { __typename?: 'legacy_migrations', id: any, last_general_error?: string | null, last_general_error_sentry_event_id?: string | null, user_id: any, started_at?: any | null, completed_at?: any | null, last_user_sync_at?: any | null, last_user_sync_error?: string | null, last_user_sync_error_sentry_event_id?: string | null, last_vehicles_sync_at?: any | null, last_vehicles_sync_error?: string | null, last_vehicles_sync_error_sentry_event_id?: string | null, last_payment_methods_sync_at?: any | null, last_payment_methods_sync_error?: string | null, last_payment_methods_sync_error_sentry_event_id?: string | null, last_wallet_sync_at?: any | null, last_wallet_sync_error?: string | null, last_wallet_sync_error_sentry_event_id?: string | null, last_active_parkable_transaction_sync_at?: any | null, last_active_parkable_transaction_sync_error?: string | null, last_active_parkable_transaction_sync_error_sentry_event_id?: string | null, legacy_active_parkable_transaction_id?: any | null, active_parkable_transaction_id?: any | null, created_at?: any | null, updated_at?: any | null };

export type UserFieldsFragment = { __typename?: 'users', id: any, cognito_identity_id?: string | null, email?: string | null, phone_number?: string | null, first_name?: string | null, last_name?: string | null, terms_of_service_last_accepted?: any | null, mxm_customer_id?: any | null, pending_deletion_at?: any | null, last_login_at?: any | null, last_active_at?: any | null, is_legacy_migration: boolean, primary_parking_authority_id?: any | null, num_vehicles: any, num_payment_methods: any, setup_vehicles_last_nag_at?: any | null, setup_payment_methods_last_nag_at?: any | null, setup_wallet_last_nag_at?: any | null, setup_primary_parking_authority_last_nag_at?: any | null, beta_features_enabled?: boolean | null, created_at: any, updated_at?: any | null, deleted_at?: any | null, last_wallet_prompt_at?: any | null, locked_at?: any | null, anonymized_at?: any | null, fraud_review_status?: string | null, wallet?: { __typename?: 'wallets', id: any, user_id: any, balance: number, auto_reload: boolean, last_wallet_transaction_id?: any | null } | null, legacyMigration?: { __typename?: 'legacy_migrations', id: any, last_general_error?: string | null, last_general_error_sentry_event_id?: string | null, user_id: any, started_at?: any | null, completed_at?: any | null, last_user_sync_at?: any | null, last_user_sync_error?: string | null, last_user_sync_error_sentry_event_id?: string | null, last_vehicles_sync_at?: any | null, last_vehicles_sync_error?: string | null, last_vehicles_sync_error_sentry_event_id?: string | null, last_payment_methods_sync_at?: any | null, last_payment_methods_sync_error?: string | null, last_payment_methods_sync_error_sentry_event_id?: string | null, last_wallet_sync_at?: any | null, last_wallet_sync_error?: string | null, last_wallet_sync_error_sentry_event_id?: string | null, last_active_parkable_transaction_sync_at?: any | null, last_active_parkable_transaction_sync_error?: string | null, last_active_parkable_transaction_sync_error_sentry_event_id?: string | null, legacy_active_parkable_transaction_id?: any | null, active_parkable_transaction_id?: any | null, created_at?: any | null, updated_at?: any | null } | null };

export type CreateVehicleMutationVariables = Exact<{
  values: Vehicles_Insert_Input;
}>;


export type CreateVehicleMutation = { __typename?: 'mutation_root', insert_vehicles_one?: { __typename?: 'vehicles', id: any, user_id: any, name?: string | null, manufacturer_make?: string | null, manufacturer_model?: string | null, type?: string | null, color?: string | null, license_plate?: string | null, country_code?: string | null, state_code?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null } | null };

export type DeleteVehicleMutationVariables = Exact<{
  vehicleId: Scalars['bigint']['input'];
}>;


export type DeleteVehicleMutation = { __typename?: 'mutation_root', deleteVehicle?: { __typename?: 'DeleteVehicleOutput', deletedVehicleId: any, vehicle?: { __typename?: 'vehicles', id: any, user_id: any, name?: string | null, manufacturer_make?: string | null, manufacturer_model?: string | null, type?: string | null, color?: string | null, license_plate?: string | null, country_code?: string | null, state_code?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null } | null } | null };

export type VehiclesQueryVariables = Exact<{ [key: string]: never; }>;


export type VehiclesQuery = { __typename?: 'query_root', vehicles: Array<{ __typename?: 'vehicles', id: any, user_id: any, name?: string | null, manufacturer_make?: string | null, manufacturer_model?: string | null, type?: string | null, color?: string | null, license_plate?: string | null, country_code?: string | null, state_code?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null }> };

export type VehicleFieldsFragment = { __typename?: 'vehicles', id: any, user_id: any, name?: string | null, manufacturer_make?: string | null, manufacturer_model?: string | null, type?: string | null, color?: string | null, license_plate?: string | null, country_code?: string | null, state_code?: string | null, created_at: any, updated_at?: any | null, deleted_at?: any | null };

export type WalletFieldsFragment = { __typename?: 'wallets', id: any, user_id: any, balance: number, auto_reload: boolean, last_wallet_transaction_id?: any | null };

export const ParkableFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkables"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_fee"}},{"kind":"Field","name":{"kind":"Name","value":"card_fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parkable_parkable_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GEOGRAPHICAL","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<ParkableFieldsFragment, unknown>;
export const VehicleFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vehicleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_make"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_model"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}}]} as unknown as DocumentNode<VehicleFieldsFragment, unknown>;
export const PaymentMethodMxmFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}}]} as unknown as DocumentNode<PaymentMethodMxmFieldsFragment, unknown>;
export const PaymentMethodFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"payment_methods"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodMxmFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}}]} as unknown as DocumentNode<PaymentMethodFieldsFragment, unknown>;
export const ParkableTransactionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableTransactionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkable_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent_key"}},{"kind":"Field","name":{"kind":"Name","value":"parkable_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method_id"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_fee"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"last_time_extended_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_enforcement_notified_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_acknowledged_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payment_finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"funds_transferred_at"}},{"kind":"Field","name":{"kind":"Name","value":"parkable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vehicleFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkables"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_fee"}},{"kind":"Field","name":{"kind":"Name","value":"card_fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parkable_parkable_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GEOGRAPHICAL","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vehicleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_make"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_model"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"payment_methods"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodMxmFields"}}]}}]}}]} as unknown as DocumentNode<ParkableTransactionFieldsFragment, unknown>;
export const SupportTicketFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"supportTicketFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"support_tickets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent_key"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"external_ticket_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_submitted"}}]}}]} as unknown as DocumentNode<SupportTicketFieldsFragment, unknown>;
export const IdentityFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"identityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"identities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_login_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_at"}},{"kind":"Field","name":{"kind":"Name","value":"locked_at"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"provider_id"}},{"kind":"Field","name":{"kind":"Name","value":"id_token_expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"email_verified"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]} as unknown as DocumentNode<IdentityFieldsFragment, unknown>;
export const WalletFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"walletFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"wallets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"auto_reload"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_transaction_id"}}]}}]} as unknown as DocumentNode<WalletFieldsFragment, unknown>;
export const LegacyMigrationFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"legacyMigrationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"legacy_migrations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_general_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_general_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"legacy_active_parkable_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"active_parkable_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<LegacyMigrationFieldsFragment, unknown>;
export const UserFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"userFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cognito_identity_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"terms_of_service_last_accepted"}},{"kind":"Field","name":{"kind":"Name","value":"mxm_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"pending_deletion_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_login_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_legacy_migration"}},{"kind":"Field","name":{"kind":"Name","value":"primary_parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"num_vehicles"}},{"kind":"Field","name":{"kind":"Name","value":"num_payment_methods"}},{"kind":"Field","name":{"kind":"Name","value":"setup_vehicles_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_payment_methods_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_wallet_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_primary_parking_authority_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"beta_features_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_prompt_at"}},{"kind":"Field","name":{"kind":"Name","value":"locked_at"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_at"}},{"kind":"Field","name":{"kind":"Name","value":"fraud_review_status"}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"walletFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legacyMigration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"legacyMigrationFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"walletFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"wallets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"auto_reload"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_transaction_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"legacyMigrationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"legacy_migrations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_general_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_general_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"legacy_active_parkable_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"active_parkable_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<UserFieldsFragment, unknown>;
export const ConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serverNow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forceLogOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"USER_MISSING"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"IDENTITY_MISSING"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CREDENTIAL_MISMATCH"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"USER_PENDING_DELETION"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"USER_DELETED"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"USER_LOCKED"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"USER_FRAUDULENT"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ids"}},{"kind":"Field","name":{"kind":"Name","value":"fromCache"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConfigQuery, ConfigQueryVariables>;
export const SubmitEventsPrivateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitEventsPrivate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventsBatches"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventsBatch"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientDevice"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"now"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitEventsPrivate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventsBatches"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventsBatches"}}},{"kind":"Argument","name":{"kind":"Name","value":"device"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device"}}},{"kind":"Argument","name":{"kind":"Name","value":"now"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitEventsPrivateMutation, SubmitEventsPrivateMutationVariables>;
export const SubmitEventsPublicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitEventsPublic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventsBatches"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventsBatch"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unauthenticatedCredentials"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UnauthenticatedCredentials"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientDevice"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"now"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitEventsPublic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventsBatches"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventsBatches"}}},{"kind":"Argument","name":{"kind":"Name","value":"unauthenticatedCredentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unauthenticatedCredentials"}}},{"kind":"Argument","name":{"kind":"Name","value":"device"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device"}}},{"kind":"Argument","name":{"kind":"Name","value":"now"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitEventsPublicMutation, SubmitEventsPublicMutationVariables>;
export const CancelParkableTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelParkableTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parkableTransactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelParkableTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parkableTransactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parkableTransactionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkableTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableTransactionFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkables"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_fee"}},{"kind":"Field","name":{"kind":"Name","value":"card_fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parkable_parkable_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GEOGRAPHICAL","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vehicleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_make"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_model"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"payment_methods"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodMxmFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableTransactionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkable_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent_key"}},{"kind":"Field","name":{"kind":"Name","value":"parkable_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method_id"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_fee"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"last_time_extended_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_enforcement_notified_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_acknowledged_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payment_finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"funds_transferred_at"}},{"kind":"Field","name":{"kind":"Name","value":"parkable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vehicleFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}}]}}]} as unknown as DocumentNode<CancelParkableTransactionMutation, CancelParkableTransactionMutationVariables>;
export const CreateParkableTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateParkableTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotentKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parkableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createParkableTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idempotentKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotentKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"parkableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parkableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}},{"kind":"Argument","name":{"kind":"Name","value":"vehicleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkableTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableTransactionFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkables"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_fee"}},{"kind":"Field","name":{"kind":"Name","value":"card_fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parkable_parkable_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GEOGRAPHICAL","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vehicleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_make"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_model"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"payment_methods"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodMxmFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableTransactionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkable_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent_key"}},{"kind":"Field","name":{"kind":"Name","value":"parkable_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method_id"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_fee"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"last_time_extended_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_enforcement_notified_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_acknowledged_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payment_finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"funds_transferred_at"}},{"kind":"Field","name":{"kind":"Name","value":"parkable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vehicleFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}}]}}]} as unknown as DocumentNode<CreateParkableTransactionMutation, CreateParkableTransactionMutationVariables>;
export const ExtendTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExtendTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotentKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parkableTransactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extendTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idempotentKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotentKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"parkableTransactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parkableTransactionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkableTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableTransactionFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkables"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_fee"}},{"kind":"Field","name":{"kind":"Name","value":"card_fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parkable_parkable_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GEOGRAPHICAL","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vehicleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_make"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_model"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"payment_methods"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodMxmFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableTransactionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkable_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent_key"}},{"kind":"Field","name":{"kind":"Name","value":"parkable_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method_id"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_fee"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"last_time_extended_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_enforcement_notified_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_acknowledged_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payment_finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"funds_transferred_at"}},{"kind":"Field","name":{"kind":"Name","value":"parkable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vehicleFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}}]}}]} as unknown as DocumentNode<ExtendTimeMutation, ExtendTimeMutationVariables>;
export const ParkableTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParkableTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableTransactionFields"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkables"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_fee"}},{"kind":"Field","name":{"kind":"Name","value":"card_fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parkable_parkable_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GEOGRAPHICAL","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vehicleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_make"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_model"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"payment_methods"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodMxmFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableTransactionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkable_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent_key"}},{"kind":"Field","name":{"kind":"Name","value":"parkable_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method_id"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_fee"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"last_time_extended_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_enforcement_notified_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_acknowledged_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payment_finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"funds_transferred_at"}},{"kind":"Field","name":{"kind":"Name","value":"parkable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vehicleFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}}]}}]} as unknown as DocumentNode<ParkableTransactionQuery, ParkableTransactionQueryVariables>;
export const RecentParkableTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecentParkableTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableTransactionFields"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkables"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_fee"}},{"kind":"Field","name":{"kind":"Name","value":"card_fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parkable_parkable_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GEOGRAPHICAL","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vehicleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_make"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_model"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"payment_methods"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodMxmFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableTransactionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkable_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent_key"}},{"kind":"Field","name":{"kind":"Name","value":"parkable_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method_id"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_price"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_fee"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"snapshot_license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"last_time_extended_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_enforcement_notified_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_acknowledged_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"expired_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payment_finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"finalized_at"}},{"kind":"Field","name":{"kind":"Name","value":"funds_transferred_at"}},{"kind":"Field","name":{"kind":"Name","value":"parkable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vehicleFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}}]}}]} as unknown as DocumentNode<RecentParkableTransactionsQuery, RecentParkableTransactionsQueryVariables>;
export const ParkableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Parkable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parkableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkables_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parkableId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkables"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_fee"}},{"kind":"Field","name":{"kind":"Name","value":"card_fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parkable_parkable_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GEOGRAPHICAL","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<ParkableQuery, ParkableQueryVariables>;
export const SearchParkablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchParkables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"identifier"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parkableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parkableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"parkables"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit"}},{"kind":"Field","name":{"kind":"Name","value":"time_limit_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval_unit"}},{"kind":"Field","name":{"kind":"Name","value":"price_interval"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"parking_authority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_fee"}},{"kind":"Field","name":{"kind":"Name","value":"card_fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parkable_parkable_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GEOGRAPHICAL","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parkable_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkable_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<SearchParkablesQuery, SearchParkablesQueryVariables>;
export const ParkingAuthoritiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParkingAuthorities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parking_authorities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}}]}}]}}]} as unknown as DocumentNode<ParkingAuthoritiesQuery, ParkingAuthoritiesQueryVariables>;
export const CreateMxmCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMxmCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMxmCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"userFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"walletFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"wallets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"auto_reload"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_transaction_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"legacyMigrationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"legacy_migrations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_general_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_general_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"legacy_active_parkable_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"active_parkable_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"userFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cognito_identity_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"terms_of_service_last_accepted"}},{"kind":"Field","name":{"kind":"Name","value":"mxm_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"pending_deletion_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_login_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_legacy_migration"}},{"kind":"Field","name":{"kind":"Name","value":"primary_parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"num_vehicles"}},{"kind":"Field","name":{"kind":"Name","value":"num_payment_methods"}},{"kind":"Field","name":{"kind":"Name","value":"setup_vehicles_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_payment_methods_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_wallet_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_primary_parking_authority_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"beta_features_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_prompt_at"}},{"kind":"Field","name":{"kind":"Name","value":"locked_at"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_at"}},{"kind":"Field","name":{"kind":"Name","value":"fraud_review_status"}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"walletFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legacyMigration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"legacyMigrationFields"}}]}}]}}]} as unknown as DocumentNode<CreateMxmCustomerMutation, CreateMxmCustomerMutationVariables>;
export const CreatePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotentKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastFour"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountCardType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountCardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiryMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiryYear"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_payment_methods_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idempotent_key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotentKey"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"meta_card_account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"meta_card_account_card_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountCardType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"meta_card_account_last_4"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastFour"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"meta_card_account_card_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountCardId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"meta_card_account_token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountToken"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"meta_card_account_expiry_month"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiryMonth"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"meta_card_account_expiry_year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiryYear"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"meta_card_account_postal_code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"mx_merchant_payment_method_metas_payment_method_id_unique"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"meta_card_account_token"}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"payment_methods_idempotent_key_unique"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"idempotent_key"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"payment_methods"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodMxmFields"}}]}}]}}]} as unknown as DocumentNode<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;
export const DeletePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedPaymentMethodId"}}]}}]}}]} as unknown as DocumentNode<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const PaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_methods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"payment_methods"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodMxmFields"}}]}}]}}]} as unknown as DocumentNode<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const RequestPaymentLimitedUseTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestPaymentLimitedUseToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestPaymentLimitedUseToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<RequestPaymentLimitedUseTokenMutation, RequestPaymentLimitedUseTokenMutationVariables>;
export const StoreVaultedCardAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StoreVaultedCardAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastFour"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountCardType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountCardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiryMonth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiryYear"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storeVaultedCardAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastFour"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastFour"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"cardAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cardAccountCardType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountCardType"}}},{"kind":"Argument","name":{"kind":"Name","value":"cardAccountCardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountCardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cardAccountToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardAccountToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"expiryMonth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiryMonth"}}},{"kind":"Argument","name":{"kind":"Name","value":"expiryYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiryYear"}}},{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alreadyExists"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodMxmFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_card_type"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_month"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_expiry_year"}},{"kind":"Field","name":{"kind":"Name","value":"meta_card_account_postal_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"payment_methods"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"mx_merchant_payment_method_metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentMethodMxmFields"}}]}}]}}]} as unknown as DocumentNode<StoreVaultedCardAccountMutation, StoreVaultedCardAccountMutationVariables>;
export const CreateSupportTicketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSupportTicket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotentKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientDevice"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contextData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSupportTicket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idempotentKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotentKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"Argument","name":{"kind":"Name","value":"device"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device"}}},{"kind":"Argument","name":{"kind":"Name","value":"contextData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contextData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supportTicket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"supportTicketFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"supportTicketFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"support_tickets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idempotent_key"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"external_ticket_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_submitted"}}]}}]} as unknown as DocumentNode<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>;
export const CreateSupportTicketGuestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSupportTicketGuest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idempotentKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"device"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientDevice"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contextData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSupportTicketGuest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idempotentKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idempotentKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"Argument","name":{"kind":"Name","value":"device"},"value":{"kind":"Variable","name":{"kind":"Name","value":"device"}}},{"kind":"Argument","name":{"kind":"Name","value":"contextData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contextData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSupportTicketGuestMutation, CreateSupportTicketGuestMutationVariables>;
export const UpdateUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSettings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSetting"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedUserSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const UserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_settings_all"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"notifications.sms_enabled","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UserSettingsQuery, UserSettingsQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_set_input"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"userFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"walletFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"wallets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"auto_reload"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_transaction_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"legacyMigrationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"legacy_migrations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_general_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_general_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"legacy_active_parkable_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"active_parkable_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"userFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cognito_identity_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"terms_of_service_last_accepted"}},{"kind":"Field","name":{"kind":"Name","value":"mxm_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"pending_deletion_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_login_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_legacy_migration"}},{"kind":"Field","name":{"kind":"Name","value":"primary_parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"num_vehicles"}},{"kind":"Field","name":{"kind":"Name","value":"num_payment_methods"}},{"kind":"Field","name":{"kind":"Name","value":"setup_vehicles_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_payment_methods_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_wallet_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_primary_parking_authority_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"beta_features_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_prompt_at"}},{"kind":"Field","name":{"kind":"Name","value":"locked_at"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_at"}},{"kind":"Field","name":{"kind":"Name","value":"fraud_review_status"}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"walletFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legacyMigration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"legacyMigrationFields"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"identityFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"userFields"}},{"kind":"Field","name":{"kind":"Name","value":"r_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"num_parkable_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"percent_wallet_usage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"walletFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"wallets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"auto_reload"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_transaction_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"legacyMigrationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"legacy_migrations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_general_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_general_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"started_at"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_vehicles_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_payment_methods_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_error"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_parkable_transaction_sync_error_sentry_event_id"}},{"kind":"Field","name":{"kind":"Name","value":"legacy_active_parkable_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"active_parkable_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"identityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"identities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_login_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_at"}},{"kind":"Field","name":{"kind":"Name","value":"locked_at"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"provider_id"}},{"kind":"Field","name":{"kind":"Name","value":"id_token_expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"email_verified"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"userFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cognito_identity_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"terms_of_service_last_accepted"}},{"kind":"Field","name":{"kind":"Name","value":"mxm_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"pending_deletion_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_login_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_active_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_legacy_migration"}},{"kind":"Field","name":{"kind":"Name","value":"primary_parking_authority_id"}},{"kind":"Field","name":{"kind":"Name","value":"num_vehicles"}},{"kind":"Field","name":{"kind":"Name","value":"num_payment_methods"}},{"kind":"Field","name":{"kind":"Name","value":"setup_vehicles_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_payment_methods_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_wallet_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"setup_primary_parking_authority_last_nag_at"}},{"kind":"Field","name":{"kind":"Name","value":"beta_features_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_wallet_prompt_at"}},{"kind":"Field","name":{"kind":"Name","value":"locked_at"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_at"}},{"kind":"Field","name":{"kind":"Name","value":"fraud_review_status"}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"walletFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legacyMigration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"legacyMigrationFields"}}]}}]}}]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const CreateVehicleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateVehicle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_vehicles_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"vehicles_user_id_license_plate_idempotent_key_unique"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"license_plate"},{"kind":"EnumValue","value":"country_code"},{"kind":"EnumValue","value":"state_code"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vehicleFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vehicleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_make"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_model"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}}]} as unknown as DocumentNode<CreateVehicleMutation, CreateVehicleMutationVariables>;
export const DeleteVehicleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteVehicle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteVehicle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"vehicleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedVehicleId"}},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vehicleFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vehicleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_make"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_model"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}}]} as unknown as DocumentNode<DeleteVehicleMutation, DeleteVehicleMutationVariables>;
export const VehiclesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Vehicles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vehicleFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vehicleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_make"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer_model"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"license_plate"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"state_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}}]}}]} as unknown as DocumentNode<VehiclesQuery, VehiclesQueryVariables>;